webpackJsonp([0],[
/* 0 */
/***/ (function(module, exports) {

/* globals __VUE_SSR_CONTEXT__ */

// this module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle

module.exports = function normalizeComponent (
  rawScriptExports,
  compiledTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */
) {
  var esModule
  var scriptExports = rawScriptExports = rawScriptExports || {}

  // ES6 modules interop
  var type = typeof rawScriptExports.default
  if (type === 'object' || type === 'function') {
    esModule = rawScriptExports
    scriptExports = rawScriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (compiledTemplate) {
    options.render = compiledTemplate.render
    options.staticRenderFns = compiledTemplate.staticRenderFns
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = injectStyles
  }

  if (hook) {
    var functional = options.functional
    var existing = functional
      ? options.render
      : options.beforeCreate
    if (!functional) {
      // inject component registration as beforeCreate hook
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    } else {
      // register for functioal component in vue file
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return existing(h, context)
      }
    }
  }

  return {
    esModule: esModule,
    exports: scriptExports,
    options: options
  }
}


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(8);

/*global toString:true*/

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return toString.call(val) === '[object Array]';
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is a Buffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Buffer, otherwise false
 */
function isBuffer(val) {
  return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor)
    && typeof val.constructor.isBuffer === 'function' && val.constructor.isBuffer(val);
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
function isArrayBuffer(val) {
  return toString.call(val) === '[object ArrayBuffer]';
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(val) {
  return (typeof FormData !== 'undefined') && (val instanceof FormData);
}

/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
function isDate(val) {
  return toString.call(val) === '[object Date]';
}

/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
function isFile(val) {
  return toString.call(val) === '[object File]';
}

/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
function isBlob(val) {
  return toString.call(val) === '[object Blob]';
}

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
function isURLSearchParams(val) {
  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.replace(/^\s*/, '').replace(/\s*$/, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && (navigator.product === 'ReactNative' ||
                                           navigator.product === 'NativeScript' ||
                                           navigator.product === 'NS')) {
    return false;
  }
  return (
    typeof window !== 'undefined' &&
    typeof document !== 'undefined'
  );
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (typeof result[key] === 'object' && typeof val === 'object') {
      result[key] = merge(result[key], val);
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Function equal to merge with the difference being that no reference
 * to original objects is kept.
 *
 * @see merge
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function deepMerge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (typeof result[key] === 'object' && typeof val === 'object') {
      result[key] = deepMerge(result[key], val);
    } else if (typeof val === 'object') {
      result[key] = deepMerge({}, val);
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

module.exports = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  deepMerge: deepMerge,
  extend: extend,
  trim: trim
};


/***/ }),
/* 2 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, setImmediate) {/*!
 * Vue.js v2.6.12
 * (c) 2014-2020 Evan You
 * Released under the MIT License.
 */
/*  */

var emptyObject = Object.freeze({});

// These helpers produce better VM code in JS engines due to their
// explicitness and function inlining.
function isUndef (v) {
  return v === undefined || v === null
}

function isDef (v) {
  return v !== undefined && v !== null
}

function isTrue (v) {
  return v === true
}

function isFalse (v) {
  return v === false
}

/**
 * Check if value is primitive.
 */
function isPrimitive (value) {
  return (
    typeof value === 'string' ||
    typeof value === 'number' ||
    // $flow-disable-line
    typeof value === 'symbol' ||
    typeof value === 'boolean'
  )
}

/**
 * Quick object check - this is primarily used to tell
 * Objects from primitive values when we know the value
 * is a JSON-compliant type.
 */
function isObject (obj) {
  return obj !== null && typeof obj === 'object'
}

/**
 * Get the raw type string of a value, e.g., [object Object].
 */
var _toString = Object.prototype.toString;

function toRawType (value) {
  return _toString.call(value).slice(8, -1)
}

/**
 * Strict object type check. Only returns true
 * for plain JavaScript objects.
 */
function isPlainObject (obj) {
  return _toString.call(obj) === '[object Object]'
}

function isRegExp (v) {
  return _toString.call(v) === '[object RegExp]'
}

/**
 * Check if val is a valid array index.
 */
function isValidArrayIndex (val) {
  var n = parseFloat(String(val));
  return n >= 0 && Math.floor(n) === n && isFinite(val)
}

function isPromise (val) {
  return (
    isDef(val) &&
    typeof val.then === 'function' &&
    typeof val.catch === 'function'
  )
}

/**
 * Convert a value to a string that is actually rendered.
 */
function toString (val) {
  return val == null
    ? ''
    : Array.isArray(val) || (isPlainObject(val) && val.toString === _toString)
      ? JSON.stringify(val, null, 2)
      : String(val)
}

/**
 * Convert an input value to a number for persistence.
 * If the conversion fails, return original string.
 */
function toNumber (val) {
  var n = parseFloat(val);
  return isNaN(n) ? val : n
}

/**
 * Make a map and return a function for checking if a key
 * is in that map.
 */
function makeMap (
  str,
  expectsLowerCase
) {
  var map = Object.create(null);
  var list = str.split(',');
  for (var i = 0; i < list.length; i++) {
    map[list[i]] = true;
  }
  return expectsLowerCase
    ? function (val) { return map[val.toLowerCase()]; }
    : function (val) { return map[val]; }
}

/**
 * Check if a tag is a built-in tag.
 */
var isBuiltInTag = makeMap('slot,component', true);

/**
 * Check if an attribute is a reserved attribute.
 */
var isReservedAttribute = makeMap('key,ref,slot,slot-scope,is');

/**
 * Remove an item from an array.
 */
function remove (arr, item) {
  if (arr.length) {
    var index = arr.indexOf(item);
    if (index > -1) {
      return arr.splice(index, 1)
    }
  }
}

/**
 * Check whether an object has the property.
 */
var hasOwnProperty = Object.prototype.hasOwnProperty;
function hasOwn (obj, key) {
  return hasOwnProperty.call(obj, key)
}

/**
 * Create a cached version of a pure function.
 */
function cached (fn) {
  var cache = Object.create(null);
  return (function cachedFn (str) {
    var hit = cache[str];
    return hit || (cache[str] = fn(str))
  })
}

/**
 * Camelize a hyphen-delimited string.
 */
var camelizeRE = /-(\w)/g;
var camelize = cached(function (str) {
  return str.replace(camelizeRE, function (_, c) { return c ? c.toUpperCase() : ''; })
});

/**
 * Capitalize a string.
 */
var capitalize = cached(function (str) {
  return str.charAt(0).toUpperCase() + str.slice(1)
});

/**
 * Hyphenate a camelCase string.
 */
var hyphenateRE = /\B([A-Z])/g;
var hyphenate = cached(function (str) {
  return str.replace(hyphenateRE, '-$1').toLowerCase()
});

/**
 * Simple bind polyfill for environments that do not support it,
 * e.g., PhantomJS 1.x. Technically, we don't need this anymore
 * since native bind is now performant enough in most browsers.
 * But removing it would mean breaking code that was able to run in
 * PhantomJS 1.x, so this must be kept for backward compatibility.
 */

/* istanbul ignore next */
function polyfillBind (fn, ctx) {
  function boundFn (a) {
    var l = arguments.length;
    return l
      ? l > 1
        ? fn.apply(ctx, arguments)
        : fn.call(ctx, a)
      : fn.call(ctx)
  }

  boundFn._length = fn.length;
  return boundFn
}

function nativeBind (fn, ctx) {
  return fn.bind(ctx)
}

var bind = Function.prototype.bind
  ? nativeBind
  : polyfillBind;

/**
 * Convert an Array-like object to a real Array.
 */
function toArray (list, start) {
  start = start || 0;
  var i = list.length - start;
  var ret = new Array(i);
  while (i--) {
    ret[i] = list[i + start];
  }
  return ret
}

/**
 * Mix properties into target object.
 */
function extend (to, _from) {
  for (var key in _from) {
    to[key] = _from[key];
  }
  return to
}

/**
 * Merge an Array of Objects into a single Object.
 */
function toObject (arr) {
  var res = {};
  for (var i = 0; i < arr.length; i++) {
    if (arr[i]) {
      extend(res, arr[i]);
    }
  }
  return res
}

/* eslint-disable no-unused-vars */

/**
 * Perform no operation.
 * Stubbing args to make Flow happy without leaving useless transpiled code
 * with ...rest (https://flow.org/blog/2017/05/07/Strict-Function-Call-Arity/).
 */
function noop (a, b, c) {}

/**
 * Always return false.
 */
var no = function (a, b, c) { return false; };

/* eslint-enable no-unused-vars */

/**
 * Return the same value.
 */
var identity = function (_) { return _; };

/**
 * Generate a string containing static keys from compiler modules.
 */
function genStaticKeys (modules) {
  return modules.reduce(function (keys, m) {
    return keys.concat(m.staticKeys || [])
  }, []).join(',')
}

/**
 * Check if two values are loosely equal - that is,
 * if they are plain objects, do they have the same shape?
 */
function looseEqual (a, b) {
  if (a === b) { return true }
  var isObjectA = isObject(a);
  var isObjectB = isObject(b);
  if (isObjectA && isObjectB) {
    try {
      var isArrayA = Array.isArray(a);
      var isArrayB = Array.isArray(b);
      if (isArrayA && isArrayB) {
        return a.length === b.length && a.every(function (e, i) {
          return looseEqual(e, b[i])
        })
      } else if (a instanceof Date && b instanceof Date) {
        return a.getTime() === b.getTime()
      } else if (!isArrayA && !isArrayB) {
        var keysA = Object.keys(a);
        var keysB = Object.keys(b);
        return keysA.length === keysB.length && keysA.every(function (key) {
          return looseEqual(a[key], b[key])
        })
      } else {
        /* istanbul ignore next */
        return false
      }
    } catch (e) {
      /* istanbul ignore next */
      return false
    }
  } else if (!isObjectA && !isObjectB) {
    return String(a) === String(b)
  } else {
    return false
  }
}

/**
 * Return the first index at which a loosely equal value can be
 * found in the array (if value is a plain object, the array must
 * contain an object of the same shape), or -1 if it is not present.
 */
function looseIndexOf (arr, val) {
  for (var i = 0; i < arr.length; i++) {
    if (looseEqual(arr[i], val)) { return i }
  }
  return -1
}

/**
 * Ensure a function is called only once.
 */
function once (fn) {
  var called = false;
  return function () {
    if (!called) {
      called = true;
      fn.apply(this, arguments);
    }
  }
}

var SSR_ATTR = 'data-server-rendered';

var ASSET_TYPES = [
  'component',
  'directive',
  'filter'
];

var LIFECYCLE_HOOKS = [
  'beforeCreate',
  'created',
  'beforeMount',
  'mounted',
  'beforeUpdate',
  'updated',
  'beforeDestroy',
  'destroyed',
  'activated',
  'deactivated',
  'errorCaptured',
  'serverPrefetch'
];

/*  */



var config = ({
  /**
   * Option merge strategies (used in core/util/options)
   */
  // $flow-disable-line
  optionMergeStrategies: Object.create(null),

  /**
   * Whether to suppress warnings.
   */
  silent: false,

  /**
   * Show production mode tip message on boot?
   */
  productionTip: "production" !== 'production',

  /**
   * Whether to enable devtools
   */
  devtools: "production" !== 'production',

  /**
   * Whether to record perf
   */
  performance: false,

  /**
   * Error handler for watcher errors
   */
  errorHandler: null,

  /**
   * Warn handler for watcher warns
   */
  warnHandler: null,

  /**
   * Ignore certain custom elements
   */
  ignoredElements: [],

  /**
   * Custom user key aliases for v-on
   */
  // $flow-disable-line
  keyCodes: Object.create(null),

  /**
   * Check if a tag is reserved so that it cannot be registered as a
   * component. This is platform-dependent and may be overwritten.
   */
  isReservedTag: no,

  /**
   * Check if an attribute is reserved so that it cannot be used as a component
   * prop. This is platform-dependent and may be overwritten.
   */
  isReservedAttr: no,

  /**
   * Check if a tag is an unknown element.
   * Platform-dependent.
   */
  isUnknownElement: no,

  /**
   * Get the namespace of an element
   */
  getTagNamespace: noop,

  /**
   * Parse the real tag name for the specific platform.
   */
  parsePlatformTagName: identity,

  /**
   * Check if an attribute must be bound using property, e.g. value
   * Platform-dependent.
   */
  mustUseProp: no,

  /**
   * Perform updates asynchronously. Intended to be used by Vue Test Utils
   * This will significantly reduce performance if set to false.
   */
  async: true,

  /**
   * Exposed for legacy reasons
   */
  _lifecycleHooks: LIFECYCLE_HOOKS
});

/*  */

/**
 * unicode letters used for parsing html tags, component names and property paths.
 * using https://www.w3.org/TR/html53/semantics-scripting.html#potentialcustomelementname
 * skipping \u10000-\uEFFFF due to it freezing up PhantomJS
 */
var unicodeRegExp = /a-zA-Z\u00B7\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u037D\u037F-\u1FFF\u200C-\u200D\u203F-\u2040\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD/;

/**
 * Check if a string starts with $ or _
 */
function isReserved (str) {
  var c = (str + '').charCodeAt(0);
  return c === 0x24 || c === 0x5F
}

/**
 * Define a property.
 */
function def (obj, key, val, enumerable) {
  Object.defineProperty(obj, key, {
    value: val,
    enumerable: !!enumerable,
    writable: true,
    configurable: true
  });
}

/**
 * Parse simple path.
 */
var bailRE = new RegExp(("[^" + (unicodeRegExp.source) + ".$_\\d]"));
function parsePath (path) {
  if (bailRE.test(path)) {
    return
  }
  var segments = path.split('.');
  return function (obj) {
    for (var i = 0; i < segments.length; i++) {
      if (!obj) { return }
      obj = obj[segments[i]];
    }
    return obj
  }
}

/*  */

// can we use __proto__?
var hasProto = '__proto__' in {};

// Browser environment sniffing
var inBrowser = typeof window !== 'undefined';
var inWeex = typeof WXEnvironment !== 'undefined' && !!WXEnvironment.platform;
var weexPlatform = inWeex && WXEnvironment.platform.toLowerCase();
var UA = inBrowser && window.navigator.userAgent.toLowerCase();
var isIE = UA && /msie|trident/.test(UA);
var isIE9 = UA && UA.indexOf('msie 9.0') > 0;
var isEdge = UA && UA.indexOf('edge/') > 0;
var isAndroid = (UA && UA.indexOf('android') > 0) || (weexPlatform === 'android');
var isIOS = (UA && /iphone|ipad|ipod|ios/.test(UA)) || (weexPlatform === 'ios');
var isChrome = UA && /chrome\/\d+/.test(UA) && !isEdge;
var isPhantomJS = UA && /phantomjs/.test(UA);
var isFF = UA && UA.match(/firefox\/(\d+)/);

// Firefox has a "watch" function on Object.prototype...
var nativeWatch = ({}).watch;

var supportsPassive = false;
if (inBrowser) {
  try {
    var opts = {};
    Object.defineProperty(opts, 'passive', ({
      get: function get () {
        /* istanbul ignore next */
        supportsPassive = true;
      }
    })); // https://github.com/facebook/flow/issues/285
    window.addEventListener('test-passive', null, opts);
  } catch (e) {}
}

// this needs to be lazy-evaled because vue may be required before
// vue-server-renderer can set VUE_ENV
var _isServer;
var isServerRendering = function () {
  if (_isServer === undefined) {
    /* istanbul ignore if */
    if (!inBrowser && !inWeex && typeof global !== 'undefined') {
      // detect presence of vue-server-renderer and avoid
      // Webpack shimming the process
      _isServer = global['process'] && global['process'].env.VUE_ENV === 'server';
    } else {
      _isServer = false;
    }
  }
  return _isServer
};

// detect devtools
var devtools = inBrowser && window.__VUE_DEVTOOLS_GLOBAL_HOOK__;

/* istanbul ignore next */
function isNative (Ctor) {
  return typeof Ctor === 'function' && /native code/.test(Ctor.toString())
}

var hasSymbol =
  typeof Symbol !== 'undefined' && isNative(Symbol) &&
  typeof Reflect !== 'undefined' && isNative(Reflect.ownKeys);

var _Set;
/* istanbul ignore if */ // $flow-disable-line
if (typeof Set !== 'undefined' && isNative(Set)) {
  // use native Set when available.
  _Set = Set;
} else {
  // a non-standard Set polyfill that only works with primitive keys.
  _Set = /*@__PURE__*/(function () {
    function Set () {
      this.set = Object.create(null);
    }
    Set.prototype.has = function has (key) {
      return this.set[key] === true
    };
    Set.prototype.add = function add (key) {
      this.set[key] = true;
    };
    Set.prototype.clear = function clear () {
      this.set = Object.create(null);
    };

    return Set;
  }());
}

/*  */

var warn = noop;
var tip = noop;
var generateComponentTrace = (noop); // work around flow check
var formatComponentName = (noop);

if (false) {
  var hasConsole = typeof console !== 'undefined';
  var classifyRE = /(?:^|[-_])(\w)/g;
  var classify = function (str) { return str
    .replace(classifyRE, function (c) { return c.toUpperCase(); })
    .replace(/[-_]/g, ''); };

  warn = function (msg, vm) {
    var trace = vm ? generateComponentTrace(vm) : '';

    if (config.warnHandler) {
      config.warnHandler.call(null, msg, vm, trace);
    } else if (hasConsole && (!config.silent)) {
      console.error(("[Vue warn]: " + msg + trace));
    }
  };

  tip = function (msg, vm) {
    if (hasConsole && (!config.silent)) {
      console.warn("[Vue tip]: " + msg + (
        vm ? generateComponentTrace(vm) : ''
      ));
    }
  };

  formatComponentName = function (vm, includeFile) {
    if (vm.$root === vm) {
      return '<Root>'
    }
    var options = typeof vm === 'function' && vm.cid != null
      ? vm.options
      : vm._isVue
        ? vm.$options || vm.constructor.options
        : vm;
    var name = options.name || options._componentTag;
    var file = options.__file;
    if (!name && file) {
      var match = file.match(/([^/\\]+)\.vue$/);
      name = match && match[1];
    }

    return (
      (name ? ("<" + (classify(name)) + ">") : "<Anonymous>") +
      (file && includeFile !== false ? (" at " + file) : '')
    )
  };

  var repeat = function (str, n) {
    var res = '';
    while (n) {
      if (n % 2 === 1) { res += str; }
      if (n > 1) { str += str; }
      n >>= 1;
    }
    return res
  };

  generateComponentTrace = function (vm) {
    if (vm._isVue && vm.$parent) {
      var tree = [];
      var currentRecursiveSequence = 0;
      while (vm) {
        if (tree.length > 0) {
          var last = tree[tree.length - 1];
          if (last.constructor === vm.constructor) {
            currentRecursiveSequence++;
            vm = vm.$parent;
            continue
          } else if (currentRecursiveSequence > 0) {
            tree[tree.length - 1] = [last, currentRecursiveSequence];
            currentRecursiveSequence = 0;
          }
        }
        tree.push(vm);
        vm = vm.$parent;
      }
      return '\n\nfound in\n\n' + tree
        .map(function (vm, i) { return ("" + (i === 0 ? '---> ' : repeat(' ', 5 + i * 2)) + (Array.isArray(vm)
            ? ((formatComponentName(vm[0])) + "... (" + (vm[1]) + " recursive calls)")
            : formatComponentName(vm))); })
        .join('\n')
    } else {
      return ("\n\n(found in " + (formatComponentName(vm)) + ")")
    }
  };
}

/*  */

var uid = 0;

/**
 * A dep is an observable that can have multiple
 * directives subscribing to it.
 */
var Dep = function Dep () {
  this.id = uid++;
  this.subs = [];
};

Dep.prototype.addSub = function addSub (sub) {
  this.subs.push(sub);
};

Dep.prototype.removeSub = function removeSub (sub) {
  remove(this.subs, sub);
};

Dep.prototype.depend = function depend () {
  if (Dep.target) {
    Dep.target.addDep(this);
  }
};

Dep.prototype.notify = function notify () {
  // stabilize the subscriber list first
  var subs = this.subs.slice();
  if (false) {
    // subs aren't sorted in scheduler if not running async
    // we need to sort them now to make sure they fire in correct
    // order
    subs.sort(function (a, b) { return a.id - b.id; });
  }
  for (var i = 0, l = subs.length; i < l; i++) {
    subs[i].update();
  }
};

// The current target watcher being evaluated.
// This is globally unique because only one watcher
// can be evaluated at a time.
Dep.target = null;
var targetStack = [];

function pushTarget (target) {
  targetStack.push(target);
  Dep.target = target;
}

function popTarget () {
  targetStack.pop();
  Dep.target = targetStack[targetStack.length - 1];
}

/*  */

var VNode = function VNode (
  tag,
  data,
  children,
  text,
  elm,
  context,
  componentOptions,
  asyncFactory
) {
  this.tag = tag;
  this.data = data;
  this.children = children;
  this.text = text;
  this.elm = elm;
  this.ns = undefined;
  this.context = context;
  this.fnContext = undefined;
  this.fnOptions = undefined;
  this.fnScopeId = undefined;
  this.key = data && data.key;
  this.componentOptions = componentOptions;
  this.componentInstance = undefined;
  this.parent = undefined;
  this.raw = false;
  this.isStatic = false;
  this.isRootInsert = true;
  this.isComment = false;
  this.isCloned = false;
  this.isOnce = false;
  this.asyncFactory = asyncFactory;
  this.asyncMeta = undefined;
  this.isAsyncPlaceholder = false;
};

var prototypeAccessors = { child: { configurable: true } };

// DEPRECATED: alias for componentInstance for backwards compat.
/* istanbul ignore next */
prototypeAccessors.child.get = function () {
  return this.componentInstance
};

Object.defineProperties( VNode.prototype, prototypeAccessors );

var createEmptyVNode = function (text) {
  if ( text === void 0 ) text = '';

  var node = new VNode();
  node.text = text;
  node.isComment = true;
  return node
};

function createTextVNode (val) {
  return new VNode(undefined, undefined, undefined, String(val))
}

// optimized shallow clone
// used for static nodes and slot nodes because they may be reused across
// multiple renders, cloning them avoids errors when DOM manipulations rely
// on their elm reference.
function cloneVNode (vnode) {
  var cloned = new VNode(
    vnode.tag,
    vnode.data,
    // #7975
    // clone children array to avoid mutating original in case of cloning
    // a child.
    vnode.children && vnode.children.slice(),
    vnode.text,
    vnode.elm,
    vnode.context,
    vnode.componentOptions,
    vnode.asyncFactory
  );
  cloned.ns = vnode.ns;
  cloned.isStatic = vnode.isStatic;
  cloned.key = vnode.key;
  cloned.isComment = vnode.isComment;
  cloned.fnContext = vnode.fnContext;
  cloned.fnOptions = vnode.fnOptions;
  cloned.fnScopeId = vnode.fnScopeId;
  cloned.asyncMeta = vnode.asyncMeta;
  cloned.isCloned = true;
  return cloned
}

/*
 * not type checking this file because flow doesn't play well with
 * dynamically accessing methods on Array prototype
 */

var arrayProto = Array.prototype;
var arrayMethods = Object.create(arrayProto);

var methodsToPatch = [
  'push',
  'pop',
  'shift',
  'unshift',
  'splice',
  'sort',
  'reverse'
];

/**
 * Intercept mutating methods and emit events
 */
methodsToPatch.forEach(function (method) {
  // cache original method
  var original = arrayProto[method];
  def(arrayMethods, method, function mutator () {
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];

    var result = original.apply(this, args);
    var ob = this.__ob__;
    var inserted;
    switch (method) {
      case 'push':
      case 'unshift':
        inserted = args;
        break
      case 'splice':
        inserted = args.slice(2);
        break
    }
    if (inserted) { ob.observeArray(inserted); }
    // notify change
    ob.dep.notify();
    return result
  });
});

/*  */

var arrayKeys = Object.getOwnPropertyNames(arrayMethods);

/**
 * In some cases we may want to disable observation inside a component's
 * update computation.
 */
var shouldObserve = true;

function toggleObserving (value) {
  shouldObserve = value;
}

/**
 * Observer class that is attached to each observed
 * object. Once attached, the observer converts the target
 * object's property keys into getter/setters that
 * collect dependencies and dispatch updates.
 */
var Observer = function Observer (value) {
  this.value = value;
  this.dep = new Dep();
  this.vmCount = 0;
  def(value, '__ob__', this);
  if (Array.isArray(value)) {
    if (hasProto) {
      protoAugment(value, arrayMethods);
    } else {
      copyAugment(value, arrayMethods, arrayKeys);
    }
    this.observeArray(value);
  } else {
    this.walk(value);
  }
};

/**
 * Walk through all properties and convert them into
 * getter/setters. This method should only be called when
 * value type is Object.
 */
Observer.prototype.walk = function walk (obj) {
  var keys = Object.keys(obj);
  for (var i = 0; i < keys.length; i++) {
    defineReactive$$1(obj, keys[i]);
  }
};

/**
 * Observe a list of Array items.
 */
Observer.prototype.observeArray = function observeArray (items) {
  for (var i = 0, l = items.length; i < l; i++) {
    observe(items[i]);
  }
};

// helpers

/**
 * Augment a target Object or Array by intercepting
 * the prototype chain using __proto__
 */
function protoAugment (target, src) {
  /* eslint-disable no-proto */
  target.__proto__ = src;
  /* eslint-enable no-proto */
}

/**
 * Augment a target Object or Array by defining
 * hidden properties.
 */
/* istanbul ignore next */
function copyAugment (target, src, keys) {
  for (var i = 0, l = keys.length; i < l; i++) {
    var key = keys[i];
    def(target, key, src[key]);
  }
}

/**
 * Attempt to create an observer instance for a value,
 * returns the new observer if successfully observed,
 * or the existing observer if the value already has one.
 */
function observe (value, asRootData) {
  if (!isObject(value) || value instanceof VNode) {
    return
  }
  var ob;
  if (hasOwn(value, '__ob__') && value.__ob__ instanceof Observer) {
    ob = value.__ob__;
  } else if (
    shouldObserve &&
    !isServerRendering() &&
    (Array.isArray(value) || isPlainObject(value)) &&
    Object.isExtensible(value) &&
    !value._isVue
  ) {
    ob = new Observer(value);
  }
  if (asRootData && ob) {
    ob.vmCount++;
  }
  return ob
}

/**
 * Define a reactive property on an Object.
 */
function defineReactive$$1 (
  obj,
  key,
  val,
  customSetter,
  shallow
) {
  var dep = new Dep();

  var property = Object.getOwnPropertyDescriptor(obj, key);
  if (property && property.configurable === false) {
    return
  }

  // cater for pre-defined getter/setters
  var getter = property && property.get;
  var setter = property && property.set;
  if ((!getter || setter) && arguments.length === 2) {
    val = obj[key];
  }

  var childOb = !shallow && observe(val);
  Object.defineProperty(obj, key, {
    enumerable: true,
    configurable: true,
    get: function reactiveGetter () {
      var value = getter ? getter.call(obj) : val;
      if (Dep.target) {
        dep.depend();
        if (childOb) {
          childOb.dep.depend();
          if (Array.isArray(value)) {
            dependArray(value);
          }
        }
      }
      return value
    },
    set: function reactiveSetter (newVal) {
      var value = getter ? getter.call(obj) : val;
      /* eslint-disable no-self-compare */
      if (newVal === value || (newVal !== newVal && value !== value)) {
        return
      }
      /* eslint-enable no-self-compare */
      if (false) {
        customSetter();
      }
      // #7981: for accessor properties without setter
      if (getter && !setter) { return }
      if (setter) {
        setter.call(obj, newVal);
      } else {
        val = newVal;
      }
      childOb = !shallow && observe(newVal);
      dep.notify();
    }
  });
}

/**
 * Set a property on an object. Adds the new property and
 * triggers change notification if the property doesn't
 * already exist.
 */
function set (target, key, val) {
  if (false
  ) {
    warn(("Cannot set reactive property on undefined, null, or primitive value: " + ((target))));
  }
  if (Array.isArray(target) && isValidArrayIndex(key)) {
    target.length = Math.max(target.length, key);
    target.splice(key, 1, val);
    return val
  }
  if (key in target && !(key in Object.prototype)) {
    target[key] = val;
    return val
  }
  var ob = (target).__ob__;
  if (target._isVue || (ob && ob.vmCount)) {
    "production" !== 'production' && warn(
      'Avoid adding reactive properties to a Vue instance or its root $data ' +
      'at runtime - declare it upfront in the data option.'
    );
    return val
  }
  if (!ob) {
    target[key] = val;
    return val
  }
  defineReactive$$1(ob.value, key, val);
  ob.dep.notify();
  return val
}

/**
 * Delete a property and trigger change if necessary.
 */
function del (target, key) {
  if (false
  ) {
    warn(("Cannot delete reactive property on undefined, null, or primitive value: " + ((target))));
  }
  if (Array.isArray(target) && isValidArrayIndex(key)) {
    target.splice(key, 1);
    return
  }
  var ob = (target).__ob__;
  if (target._isVue || (ob && ob.vmCount)) {
    "production" !== 'production' && warn(
      'Avoid deleting properties on a Vue instance or its root $data ' +
      '- just set it to null.'
    );
    return
  }
  if (!hasOwn(target, key)) {
    return
  }
  delete target[key];
  if (!ob) {
    return
  }
  ob.dep.notify();
}

/**
 * Collect dependencies on array elements when the array is touched, since
 * we cannot intercept array element access like property getters.
 */
function dependArray (value) {
  for (var e = (void 0), i = 0, l = value.length; i < l; i++) {
    e = value[i];
    e && e.__ob__ && e.__ob__.dep.depend();
    if (Array.isArray(e)) {
      dependArray(e);
    }
  }
}

/*  */

/**
 * Option overwriting strategies are functions that handle
 * how to merge a parent option value and a child option
 * value into the final value.
 */
var strats = config.optionMergeStrategies;

/**
 * Options with restrictions
 */
if (false) {
  strats.el = strats.propsData = function (parent, child, vm, key) {
    if (!vm) {
      warn(
        "option \"" + key + "\" can only be used during instance " +
        'creation with the `new` keyword.'
      );
    }
    return defaultStrat(parent, child)
  };
}

/**
 * Helper that recursively merges two data objects together.
 */
function mergeData (to, from) {
  if (!from) { return to }
  var key, toVal, fromVal;

  var keys = hasSymbol
    ? Reflect.ownKeys(from)
    : Object.keys(from);

  for (var i = 0; i < keys.length; i++) {
    key = keys[i];
    // in case the object is already observed...
    if (key === '__ob__') { continue }
    toVal = to[key];
    fromVal = from[key];
    if (!hasOwn(to, key)) {
      set(to, key, fromVal);
    } else if (
      toVal !== fromVal &&
      isPlainObject(toVal) &&
      isPlainObject(fromVal)
    ) {
      mergeData(toVal, fromVal);
    }
  }
  return to
}

/**
 * Data
 */
function mergeDataOrFn (
  parentVal,
  childVal,
  vm
) {
  if (!vm) {
    // in a Vue.extend merge, both should be functions
    if (!childVal) {
      return parentVal
    }
    if (!parentVal) {
      return childVal
    }
    // when parentVal & childVal are both present,
    // we need to return a function that returns the
    // merged result of both functions... no need to
    // check if parentVal is a function here because
    // it has to be a function to pass previous merges.
    return function mergedDataFn () {
      return mergeData(
        typeof childVal === 'function' ? childVal.call(this, this) : childVal,
        typeof parentVal === 'function' ? parentVal.call(this, this) : parentVal
      )
    }
  } else {
    return function mergedInstanceDataFn () {
      // instance merge
      var instanceData = typeof childVal === 'function'
        ? childVal.call(vm, vm)
        : childVal;
      var defaultData = typeof parentVal === 'function'
        ? parentVal.call(vm, vm)
        : parentVal;
      if (instanceData) {
        return mergeData(instanceData, defaultData)
      } else {
        return defaultData
      }
    }
  }
}

strats.data = function (
  parentVal,
  childVal,
  vm
) {
  if (!vm) {
    if (childVal && typeof childVal !== 'function') {
      "production" !== 'production' && warn(
        'The "data" option should be a function ' +
        'that returns a per-instance value in component ' +
        'definitions.',
        vm
      );

      return parentVal
    }
    return mergeDataOrFn(parentVal, childVal)
  }

  return mergeDataOrFn(parentVal, childVal, vm)
};

/**
 * Hooks and props are merged as arrays.
 */
function mergeHook (
  parentVal,
  childVal
) {
  var res = childVal
    ? parentVal
      ? parentVal.concat(childVal)
      : Array.isArray(childVal)
        ? childVal
        : [childVal]
    : parentVal;
  return res
    ? dedupeHooks(res)
    : res
}

function dedupeHooks (hooks) {
  var res = [];
  for (var i = 0; i < hooks.length; i++) {
    if (res.indexOf(hooks[i]) === -1) {
      res.push(hooks[i]);
    }
  }
  return res
}

LIFECYCLE_HOOKS.forEach(function (hook) {
  strats[hook] = mergeHook;
});

/**
 * Assets
 *
 * When a vm is present (instance creation), we need to do
 * a three-way merge between constructor options, instance
 * options and parent options.
 */
function mergeAssets (
  parentVal,
  childVal,
  vm,
  key
) {
  var res = Object.create(parentVal || null);
  if (childVal) {
    "production" !== 'production' && assertObjectType(key, childVal, vm);
    return extend(res, childVal)
  } else {
    return res
  }
}

ASSET_TYPES.forEach(function (type) {
  strats[type + 's'] = mergeAssets;
});

/**
 * Watchers.
 *
 * Watchers hashes should not overwrite one
 * another, so we merge them as arrays.
 */
strats.watch = function (
  parentVal,
  childVal,
  vm,
  key
) {
  // work around Firefox's Object.prototype.watch...
  if (parentVal === nativeWatch) { parentVal = undefined; }
  if (childVal === nativeWatch) { childVal = undefined; }
  /* istanbul ignore if */
  if (!childVal) { return Object.create(parentVal || null) }
  if (false) {
    assertObjectType(key, childVal, vm);
  }
  if (!parentVal) { return childVal }
  var ret = {};
  extend(ret, parentVal);
  for (var key$1 in childVal) {
    var parent = ret[key$1];
    var child = childVal[key$1];
    if (parent && !Array.isArray(parent)) {
      parent = [parent];
    }
    ret[key$1] = parent
      ? parent.concat(child)
      : Array.isArray(child) ? child : [child];
  }
  return ret
};

/**
 * Other object hashes.
 */
strats.props =
strats.methods =
strats.inject =
strats.computed = function (
  parentVal,
  childVal,
  vm,
  key
) {
  if (childVal && "production" !== 'production') {
    assertObjectType(key, childVal, vm);
  }
  if (!parentVal) { return childVal }
  var ret = Object.create(null);
  extend(ret, parentVal);
  if (childVal) { extend(ret, childVal); }
  return ret
};
strats.provide = mergeDataOrFn;

/**
 * Default strategy.
 */
var defaultStrat = function (parentVal, childVal) {
  return childVal === undefined
    ? parentVal
    : childVal
};

/**
 * Validate component names
 */
function checkComponents (options) {
  for (var key in options.components) {
    validateComponentName(key);
  }
}

function validateComponentName (name) {
  if (!new RegExp(("^[a-zA-Z][\\-\\.0-9_" + (unicodeRegExp.source) + "]*$")).test(name)) {
    warn(
      'Invalid component name: "' + name + '". Component names ' +
      'should conform to valid custom element name in html5 specification.'
    );
  }
  if (isBuiltInTag(name) || config.isReservedTag(name)) {
    warn(
      'Do not use built-in or reserved HTML elements as component ' +
      'id: ' + name
    );
  }
}

/**
 * Ensure all props option syntax are normalized into the
 * Object-based format.
 */
function normalizeProps (options, vm) {
  var props = options.props;
  if (!props) { return }
  var res = {};
  var i, val, name;
  if (Array.isArray(props)) {
    i = props.length;
    while (i--) {
      val = props[i];
      if (typeof val === 'string') {
        name = camelize(val);
        res[name] = { type: null };
      } else if (false) {
        warn('props must be strings when using array syntax.');
      }
    }
  } else if (isPlainObject(props)) {
    for (var key in props) {
      val = props[key];
      name = camelize(key);
      res[name] = isPlainObject(val)
        ? val
        : { type: val };
    }
  } else if (false) {
    warn(
      "Invalid value for option \"props\": expected an Array or an Object, " +
      "but got " + (toRawType(props)) + ".",
      vm
    );
  }
  options.props = res;
}

/**
 * Normalize all injections into Object-based format
 */
function normalizeInject (options, vm) {
  var inject = options.inject;
  if (!inject) { return }
  var normalized = options.inject = {};
  if (Array.isArray(inject)) {
    for (var i = 0; i < inject.length; i++) {
      normalized[inject[i]] = { from: inject[i] };
    }
  } else if (isPlainObject(inject)) {
    for (var key in inject) {
      var val = inject[key];
      normalized[key] = isPlainObject(val)
        ? extend({ from: key }, val)
        : { from: val };
    }
  } else if (false) {
    warn(
      "Invalid value for option \"inject\": expected an Array or an Object, " +
      "but got " + (toRawType(inject)) + ".",
      vm
    );
  }
}

/**
 * Normalize raw function directives into object format.
 */
function normalizeDirectives (options) {
  var dirs = options.directives;
  if (dirs) {
    for (var key in dirs) {
      var def$$1 = dirs[key];
      if (typeof def$$1 === 'function') {
        dirs[key] = { bind: def$$1, update: def$$1 };
      }
    }
  }
}

function assertObjectType (name, value, vm) {
  if (!isPlainObject(value)) {
    warn(
      "Invalid value for option \"" + name + "\": expected an Object, " +
      "but got " + (toRawType(value)) + ".",
      vm
    );
  }
}

/**
 * Merge two option objects into a new one.
 * Core utility used in both instantiation and inheritance.
 */
function mergeOptions (
  parent,
  child,
  vm
) {
  if (false) {
    checkComponents(child);
  }

  if (typeof child === 'function') {
    child = child.options;
  }

  normalizeProps(child, vm);
  normalizeInject(child, vm);
  normalizeDirectives(child);

  // Apply extends and mixins on the child options,
  // but only if it is a raw options object that isn't
  // the result of another mergeOptions call.
  // Only merged options has the _base property.
  if (!child._base) {
    if (child.extends) {
      parent = mergeOptions(parent, child.extends, vm);
    }
    if (child.mixins) {
      for (var i = 0, l = child.mixins.length; i < l; i++) {
        parent = mergeOptions(parent, child.mixins[i], vm);
      }
    }
  }

  var options = {};
  var key;
  for (key in parent) {
    mergeField(key);
  }
  for (key in child) {
    if (!hasOwn(parent, key)) {
      mergeField(key);
    }
  }
  function mergeField (key) {
    var strat = strats[key] || defaultStrat;
    options[key] = strat(parent[key], child[key], vm, key);
  }
  return options
}

/**
 * Resolve an asset.
 * This function is used because child instances need access
 * to assets defined in its ancestor chain.
 */
function resolveAsset (
  options,
  type,
  id,
  warnMissing
) {
  /* istanbul ignore if */
  if (typeof id !== 'string') {
    return
  }
  var assets = options[type];
  // check local registration variations first
  if (hasOwn(assets, id)) { return assets[id] }
  var camelizedId = camelize(id);
  if (hasOwn(assets, camelizedId)) { return assets[camelizedId] }
  var PascalCaseId = capitalize(camelizedId);
  if (hasOwn(assets, PascalCaseId)) { return assets[PascalCaseId] }
  // fallback to prototype chain
  var res = assets[id] || assets[camelizedId] || assets[PascalCaseId];
  if (false) {
    warn(
      'Failed to resolve ' + type.slice(0, -1) + ': ' + id,
      options
    );
  }
  return res
}

/*  */



function validateProp (
  key,
  propOptions,
  propsData,
  vm
) {
  var prop = propOptions[key];
  var absent = !hasOwn(propsData, key);
  var value = propsData[key];
  // boolean casting
  var booleanIndex = getTypeIndex(Boolean, prop.type);
  if (booleanIndex > -1) {
    if (absent && !hasOwn(prop, 'default')) {
      value = false;
    } else if (value === '' || value === hyphenate(key)) {
      // only cast empty string / same name to boolean if
      // boolean has higher priority
      var stringIndex = getTypeIndex(String, prop.type);
      if (stringIndex < 0 || booleanIndex < stringIndex) {
        value = true;
      }
    }
  }
  // check default value
  if (value === undefined) {
    value = getPropDefaultValue(vm, prop, key);
    // since the default value is a fresh copy,
    // make sure to observe it.
    var prevShouldObserve = shouldObserve;
    toggleObserving(true);
    observe(value);
    toggleObserving(prevShouldObserve);
  }
  if (
    false
  ) {
    assertProp(prop, key, value, vm, absent);
  }
  return value
}

/**
 * Get the default value of a prop.
 */
function getPropDefaultValue (vm, prop, key) {
  // no default, return undefined
  if (!hasOwn(prop, 'default')) {
    return undefined
  }
  var def = prop.default;
  // warn against non-factory defaults for Object & Array
  if (false) {
    warn(
      'Invalid default value for prop "' + key + '": ' +
      'Props with type Object/Array must use a factory function ' +
      'to return the default value.',
      vm
    );
  }
  // the raw prop value was also undefined from previous render,
  // return previous default value to avoid unnecessary watcher trigger
  if (vm && vm.$options.propsData &&
    vm.$options.propsData[key] === undefined &&
    vm._props[key] !== undefined
  ) {
    return vm._props[key]
  }
  // call factory function for non-Function types
  // a value is Function if its prototype is function even across different execution context
  return typeof def === 'function' && getType(prop.type) !== 'Function'
    ? def.call(vm)
    : def
}

/**
 * Assert whether a prop is valid.
 */
function assertProp (
  prop,
  name,
  value,
  vm,
  absent
) {
  if (prop.required && absent) {
    warn(
      'Missing required prop: "' + name + '"',
      vm
    );
    return
  }
  if (value == null && !prop.required) {
    return
  }
  var type = prop.type;
  var valid = !type || type === true;
  var expectedTypes = [];
  if (type) {
    if (!Array.isArray(type)) {
      type = [type];
    }
    for (var i = 0; i < type.length && !valid; i++) {
      var assertedType = assertType(value, type[i]);
      expectedTypes.push(assertedType.expectedType || '');
      valid = assertedType.valid;
    }
  }

  if (!valid) {
    warn(
      getInvalidTypeMessage(name, value, expectedTypes),
      vm
    );
    return
  }
  var validator = prop.validator;
  if (validator) {
    if (!validator(value)) {
      warn(
        'Invalid prop: custom validator check failed for prop "' + name + '".',
        vm
      );
    }
  }
}

var simpleCheckRE = /^(String|Number|Boolean|Function|Symbol)$/;

function assertType (value, type) {
  var valid;
  var expectedType = getType(type);
  if (simpleCheckRE.test(expectedType)) {
    var t = typeof value;
    valid = t === expectedType.toLowerCase();
    // for primitive wrapper objects
    if (!valid && t === 'object') {
      valid = value instanceof type;
    }
  } else if (expectedType === 'Object') {
    valid = isPlainObject(value);
  } else if (expectedType === 'Array') {
    valid = Array.isArray(value);
  } else {
    valid = value instanceof type;
  }
  return {
    valid: valid,
    expectedType: expectedType
  }
}

/**
 * Use function string name to check built-in types,
 * because a simple equality check will fail when running
 * across different vms / iframes.
 */
function getType (fn) {
  var match = fn && fn.toString().match(/^\s*function (\w+)/);
  return match ? match[1] : ''
}

function isSameType (a, b) {
  return getType(a) === getType(b)
}

function getTypeIndex (type, expectedTypes) {
  if (!Array.isArray(expectedTypes)) {
    return isSameType(expectedTypes, type) ? 0 : -1
  }
  for (var i = 0, len = expectedTypes.length; i < len; i++) {
    if (isSameType(expectedTypes[i], type)) {
      return i
    }
  }
  return -1
}

function getInvalidTypeMessage (name, value, expectedTypes) {
  var message = "Invalid prop: type check failed for prop \"" + name + "\"." +
    " Expected " + (expectedTypes.map(capitalize).join(', '));
  var expectedType = expectedTypes[0];
  var receivedType = toRawType(value);
  var expectedValue = styleValue(value, expectedType);
  var receivedValue = styleValue(value, receivedType);
  // check if we need to specify expected value
  if (expectedTypes.length === 1 &&
      isExplicable(expectedType) &&
      !isBoolean(expectedType, receivedType)) {
    message += " with value " + expectedValue;
  }
  message += ", got " + receivedType + " ";
  // check if we need to specify received value
  if (isExplicable(receivedType)) {
    message += "with value " + receivedValue + ".";
  }
  return message
}

function styleValue (value, type) {
  if (type === 'String') {
    return ("\"" + value + "\"")
  } else if (type === 'Number') {
    return ("" + (Number(value)))
  } else {
    return ("" + value)
  }
}

function isExplicable (value) {
  var explicitTypes = ['string', 'number', 'boolean'];
  return explicitTypes.some(function (elem) { return value.toLowerCase() === elem; })
}

function isBoolean () {
  var args = [], len = arguments.length;
  while ( len-- ) args[ len ] = arguments[ len ];

  return args.some(function (elem) { return elem.toLowerCase() === 'boolean'; })
}

/*  */

function handleError (err, vm, info) {
  // Deactivate deps tracking while processing error handler to avoid possible infinite rendering.
  // See: https://github.com/vuejs/vuex/issues/1505
  pushTarget();
  try {
    if (vm) {
      var cur = vm;
      while ((cur = cur.$parent)) {
        var hooks = cur.$options.errorCaptured;
        if (hooks) {
          for (var i = 0; i < hooks.length; i++) {
            try {
              var capture = hooks[i].call(cur, err, vm, info) === false;
              if (capture) { return }
            } catch (e) {
              globalHandleError(e, cur, 'errorCaptured hook');
            }
          }
        }
      }
    }
    globalHandleError(err, vm, info);
  } finally {
    popTarget();
  }
}

function invokeWithErrorHandling (
  handler,
  context,
  args,
  vm,
  info
) {
  var res;
  try {
    res = args ? handler.apply(context, args) : handler.call(context);
    if (res && !res._isVue && isPromise(res) && !res._handled) {
      res.catch(function (e) { return handleError(e, vm, info + " (Promise/async)"); });
      // issue #9511
      // avoid catch triggering multiple times when nested calls
      res._handled = true;
    }
  } catch (e) {
    handleError(e, vm, info);
  }
  return res
}

function globalHandleError (err, vm, info) {
  if (config.errorHandler) {
    try {
      return config.errorHandler.call(null, err, vm, info)
    } catch (e) {
      // if the user intentionally throws the original error in the handler,
      // do not log it twice
      if (e !== err) {
        logError(e, null, 'config.errorHandler');
      }
    }
  }
  logError(err, vm, info);
}

function logError (err, vm, info) {
  if (false) {
    warn(("Error in " + info + ": \"" + (err.toString()) + "\""), vm);
  }
  /* istanbul ignore else */
  if ((inBrowser || inWeex) && typeof console !== 'undefined') {
    console.error(err);
  } else {
    throw err
  }
}

/*  */

var isUsingMicroTask = false;

var callbacks = [];
var pending = false;

function flushCallbacks () {
  pending = false;
  var copies = callbacks.slice(0);
  callbacks.length = 0;
  for (var i = 0; i < copies.length; i++) {
    copies[i]();
  }
}

// Here we have async deferring wrappers using microtasks.
// In 2.5 we used (macro) tasks (in combination with microtasks).
// However, it has subtle problems when state is changed right before repaint
// (e.g. #6813, out-in transitions).
// Also, using (macro) tasks in event handler would cause some weird behaviors
// that cannot be circumvented (e.g. #7109, #7153, #7546, #7834, #8109).
// So we now use microtasks everywhere, again.
// A major drawback of this tradeoff is that there are some scenarios
// where microtasks have too high a priority and fire in between supposedly
// sequential events (e.g. #4521, #6690, which have workarounds)
// or even between bubbling of the same event (#6566).
var timerFunc;

// The nextTick behavior leverages the microtask queue, which can be accessed
// via either native Promise.then or MutationObserver.
// MutationObserver has wider support, however it is seriously bugged in
// UIWebView in iOS >= 9.3.3 when triggered in touch event handlers. It
// completely stops working after triggering a few times... so, if native
// Promise is available, we will use it:
/* istanbul ignore next, $flow-disable-line */
if (typeof Promise !== 'undefined' && isNative(Promise)) {
  var p = Promise.resolve();
  timerFunc = function () {
    p.then(flushCallbacks);
    // In problematic UIWebViews, Promise.then doesn't completely break, but
    // it can get stuck in a weird state where callbacks are pushed into the
    // microtask queue but the queue isn't being flushed, until the browser
    // needs to do some other work, e.g. handle a timer. Therefore we can
    // "force" the microtask queue to be flushed by adding an empty timer.
    if (isIOS) { setTimeout(noop); }
  };
  isUsingMicroTask = true;
} else if (!isIE && typeof MutationObserver !== 'undefined' && (
  isNative(MutationObserver) ||
  // PhantomJS and iOS 7.x
  MutationObserver.toString() === '[object MutationObserverConstructor]'
)) {
  // Use MutationObserver where native Promise is not available,
  // e.g. PhantomJS, iOS7, Android 4.4
  // (#6466 MutationObserver is unreliable in IE11)
  var counter = 1;
  var observer = new MutationObserver(flushCallbacks);
  var textNode = document.createTextNode(String(counter));
  observer.observe(textNode, {
    characterData: true
  });
  timerFunc = function () {
    counter = (counter + 1) % 2;
    textNode.data = String(counter);
  };
  isUsingMicroTask = true;
} else if (typeof setImmediate !== 'undefined' && isNative(setImmediate)) {
  // Fallback to setImmediate.
  // Technically it leverages the (macro) task queue,
  // but it is still a better choice than setTimeout.
  timerFunc = function () {
    setImmediate(flushCallbacks);
  };
} else {
  // Fallback to setTimeout.
  timerFunc = function () {
    setTimeout(flushCallbacks, 0);
  };
}

function nextTick (cb, ctx) {
  var _resolve;
  callbacks.push(function () {
    if (cb) {
      try {
        cb.call(ctx);
      } catch (e) {
        handleError(e, ctx, 'nextTick');
      }
    } else if (_resolve) {
      _resolve(ctx);
    }
  });
  if (!pending) {
    pending = true;
    timerFunc();
  }
  // $flow-disable-line
  if (!cb && typeof Promise !== 'undefined') {
    return new Promise(function (resolve) {
      _resolve = resolve;
    })
  }
}

/*  */

var mark;
var measure;

if (false) {
  var perf = inBrowser && window.performance;
  /* istanbul ignore if */
  if (
    perf &&
    perf.mark &&
    perf.measure &&
    perf.clearMarks &&
    perf.clearMeasures
  ) {
    mark = function (tag) { return perf.mark(tag); };
    measure = function (name, startTag, endTag) {
      perf.measure(name, startTag, endTag);
      perf.clearMarks(startTag);
      perf.clearMarks(endTag);
      // perf.clearMeasures(name)
    };
  }
}

/* not type checking this file because flow doesn't play well with Proxy */

var initProxy;

if (false) {
  var allowedGlobals = makeMap(
    'Infinity,undefined,NaN,isFinite,isNaN,' +
    'parseFloat,parseInt,decodeURI,decodeURIComponent,encodeURI,encodeURIComponent,' +
    'Math,Number,Date,Array,Object,Boolean,String,RegExp,Map,Set,JSON,Intl,' +
    'require' // for Webpack/Browserify
  );

  var warnNonPresent = function (target, key) {
    warn(
      "Property or method \"" + key + "\" is not defined on the instance but " +
      'referenced during render. Make sure that this property is reactive, ' +
      'either in the data option, or for class-based components, by ' +
      'initializing the property. ' +
      'See: https://vuejs.org/v2/guide/reactivity.html#Declaring-Reactive-Properties.',
      target
    );
  };

  var warnReservedPrefix = function (target, key) {
    warn(
      "Property \"" + key + "\" must be accessed with \"$data." + key + "\" because " +
      'properties starting with "$" or "_" are not proxied in the Vue instance to ' +
      'prevent conflicts with Vue internals. ' +
      'See: https://vuejs.org/v2/api/#data',
      target
    );
  };

  var hasProxy =
    typeof Proxy !== 'undefined' && isNative(Proxy);

  if (hasProxy) {
    var isBuiltInModifier = makeMap('stop,prevent,self,ctrl,shift,alt,meta,exact');
    config.keyCodes = new Proxy(config.keyCodes, {
      set: function set (target, key, value) {
        if (isBuiltInModifier(key)) {
          warn(("Avoid overwriting built-in modifier in config.keyCodes: ." + key));
          return false
        } else {
          target[key] = value;
          return true
        }
      }
    });
  }

  var hasHandler = {
    has: function has (target, key) {
      var has = key in target;
      var isAllowed = allowedGlobals(key) ||
        (typeof key === 'string' && key.charAt(0) === '_' && !(key in target.$data));
      if (!has && !isAllowed) {
        if (key in target.$data) { warnReservedPrefix(target, key); }
        else { warnNonPresent(target, key); }
      }
      return has || !isAllowed
    }
  };

  var getHandler = {
    get: function get (target, key) {
      if (typeof key === 'string' && !(key in target)) {
        if (key in target.$data) { warnReservedPrefix(target, key); }
        else { warnNonPresent(target, key); }
      }
      return target[key]
    }
  };

  initProxy = function initProxy (vm) {
    if (hasProxy) {
      // determine which proxy handler to use
      var options = vm.$options;
      var handlers = options.render && options.render._withStripped
        ? getHandler
        : hasHandler;
      vm._renderProxy = new Proxy(vm, handlers);
    } else {
      vm._renderProxy = vm;
    }
  };
}

/*  */

var seenObjects = new _Set();

/**
 * Recursively traverse an object to evoke all converted
 * getters, so that every nested property inside the object
 * is collected as a "deep" dependency.
 */
function traverse (val) {
  _traverse(val, seenObjects);
  seenObjects.clear();
}

function _traverse (val, seen) {
  var i, keys;
  var isA = Array.isArray(val);
  if ((!isA && !isObject(val)) || Object.isFrozen(val) || val instanceof VNode) {
    return
  }
  if (val.__ob__) {
    var depId = val.__ob__.dep.id;
    if (seen.has(depId)) {
      return
    }
    seen.add(depId);
  }
  if (isA) {
    i = val.length;
    while (i--) { _traverse(val[i], seen); }
  } else {
    keys = Object.keys(val);
    i = keys.length;
    while (i--) { _traverse(val[keys[i]], seen); }
  }
}

/*  */

var normalizeEvent = cached(function (name) {
  var passive = name.charAt(0) === '&';
  name = passive ? name.slice(1) : name;
  var once$$1 = name.charAt(0) === '~'; // Prefixed last, checked first
  name = once$$1 ? name.slice(1) : name;
  var capture = name.charAt(0) === '!';
  name = capture ? name.slice(1) : name;
  return {
    name: name,
    once: once$$1,
    capture: capture,
    passive: passive
  }
});

function createFnInvoker (fns, vm) {
  function invoker () {
    var arguments$1 = arguments;

    var fns = invoker.fns;
    if (Array.isArray(fns)) {
      var cloned = fns.slice();
      for (var i = 0; i < cloned.length; i++) {
        invokeWithErrorHandling(cloned[i], null, arguments$1, vm, "v-on handler");
      }
    } else {
      // return handler return value for single handlers
      return invokeWithErrorHandling(fns, null, arguments, vm, "v-on handler")
    }
  }
  invoker.fns = fns;
  return invoker
}

function updateListeners (
  on,
  oldOn,
  add,
  remove$$1,
  createOnceHandler,
  vm
) {
  var name, def$$1, cur, old, event;
  for (name in on) {
    def$$1 = cur = on[name];
    old = oldOn[name];
    event = normalizeEvent(name);
    if (isUndef(cur)) {
      "production" !== 'production' && warn(
        "Invalid handler for event \"" + (event.name) + "\": got " + String(cur),
        vm
      );
    } else if (isUndef(old)) {
      if (isUndef(cur.fns)) {
        cur = on[name] = createFnInvoker(cur, vm);
      }
      if (isTrue(event.once)) {
        cur = on[name] = createOnceHandler(event.name, cur, event.capture);
      }
      add(event.name, cur, event.capture, event.passive, event.params);
    } else if (cur !== old) {
      old.fns = cur;
      on[name] = old;
    }
  }
  for (name in oldOn) {
    if (isUndef(on[name])) {
      event = normalizeEvent(name);
      remove$$1(event.name, oldOn[name], event.capture);
    }
  }
}

/*  */

function mergeVNodeHook (def, hookKey, hook) {
  if (def instanceof VNode) {
    def = def.data.hook || (def.data.hook = {});
  }
  var invoker;
  var oldHook = def[hookKey];

  function wrappedHook () {
    hook.apply(this, arguments);
    // important: remove merged hook to ensure it's called only once
    // and prevent memory leak
    remove(invoker.fns, wrappedHook);
  }

  if (isUndef(oldHook)) {
    // no existing hook
    invoker = createFnInvoker([wrappedHook]);
  } else {
    /* istanbul ignore if */
    if (isDef(oldHook.fns) && isTrue(oldHook.merged)) {
      // already a merged invoker
      invoker = oldHook;
      invoker.fns.push(wrappedHook);
    } else {
      // existing plain hook
      invoker = createFnInvoker([oldHook, wrappedHook]);
    }
  }

  invoker.merged = true;
  def[hookKey] = invoker;
}

/*  */

function extractPropsFromVNodeData (
  data,
  Ctor,
  tag
) {
  // we are only extracting raw values here.
  // validation and default values are handled in the child
  // component itself.
  var propOptions = Ctor.options.props;
  if (isUndef(propOptions)) {
    return
  }
  var res = {};
  var attrs = data.attrs;
  var props = data.props;
  if (isDef(attrs) || isDef(props)) {
    for (var key in propOptions) {
      var altKey = hyphenate(key);
      if (false) {
        var keyInLowerCase = key.toLowerCase();
        if (
          key !== keyInLowerCase &&
          attrs && hasOwn(attrs, keyInLowerCase)
        ) {
          tip(
            "Prop \"" + keyInLowerCase + "\" is passed to component " +
            (formatComponentName(tag || Ctor)) + ", but the declared prop name is" +
            " \"" + key + "\". " +
            "Note that HTML attributes are case-insensitive and camelCased " +
            "props need to use their kebab-case equivalents when using in-DOM " +
            "templates. You should probably use \"" + altKey + "\" instead of \"" + key + "\"."
          );
        }
      }
      checkProp(res, props, key, altKey, true) ||
      checkProp(res, attrs, key, altKey, false);
    }
  }
  return res
}

function checkProp (
  res,
  hash,
  key,
  altKey,
  preserve
) {
  if (isDef(hash)) {
    if (hasOwn(hash, key)) {
      res[key] = hash[key];
      if (!preserve) {
        delete hash[key];
      }
      return true
    } else if (hasOwn(hash, altKey)) {
      res[key] = hash[altKey];
      if (!preserve) {
        delete hash[altKey];
      }
      return true
    }
  }
  return false
}

/*  */

// The template compiler attempts to minimize the need for normalization by
// statically analyzing the template at compile time.
//
// For plain HTML markup, normalization can be completely skipped because the
// generated render function is guaranteed to return Array<VNode>. There are
// two cases where extra normalization is needed:

// 1. When the children contains components - because a functional component
// may return an Array instead of a single root. In this case, just a simple
// normalization is needed - if any child is an Array, we flatten the whole
// thing with Array.prototype.concat. It is guaranteed to be only 1-level deep
// because functional components already normalize their own children.
function simpleNormalizeChildren (children) {
  for (var i = 0; i < children.length; i++) {
    if (Array.isArray(children[i])) {
      return Array.prototype.concat.apply([], children)
    }
  }
  return children
}

// 2. When the children contains constructs that always generated nested Arrays,
// e.g. <template>, <slot>, v-for, or when the children is provided by user
// with hand-written render functions / JSX. In such cases a full normalization
// is needed to cater to all possible types of children values.
function normalizeChildren (children) {
  return isPrimitive(children)
    ? [createTextVNode(children)]
    : Array.isArray(children)
      ? normalizeArrayChildren(children)
      : undefined
}

function isTextNode (node) {
  return isDef(node) && isDef(node.text) && isFalse(node.isComment)
}

function normalizeArrayChildren (children, nestedIndex) {
  var res = [];
  var i, c, lastIndex, last;
  for (i = 0; i < children.length; i++) {
    c = children[i];
    if (isUndef(c) || typeof c === 'boolean') { continue }
    lastIndex = res.length - 1;
    last = res[lastIndex];
    //  nested
    if (Array.isArray(c)) {
      if (c.length > 0) {
        c = normalizeArrayChildren(c, ((nestedIndex || '') + "_" + i));
        // merge adjacent text nodes
        if (isTextNode(c[0]) && isTextNode(last)) {
          res[lastIndex] = createTextVNode(last.text + (c[0]).text);
          c.shift();
        }
        res.push.apply(res, c);
      }
    } else if (isPrimitive(c)) {
      if (isTextNode(last)) {
        // merge adjacent text nodes
        // this is necessary for SSR hydration because text nodes are
        // essentially merged when rendered to HTML strings
        res[lastIndex] = createTextVNode(last.text + c);
      } else if (c !== '') {
        // convert primitive to vnode
        res.push(createTextVNode(c));
      }
    } else {
      if (isTextNode(c) && isTextNode(last)) {
        // merge adjacent text nodes
        res[lastIndex] = createTextVNode(last.text + c.text);
      } else {
        // default key for nested array children (likely generated by v-for)
        if (isTrue(children._isVList) &&
          isDef(c.tag) &&
          isUndef(c.key) &&
          isDef(nestedIndex)) {
          c.key = "__vlist" + nestedIndex + "_" + i + "__";
        }
        res.push(c);
      }
    }
  }
  return res
}

/*  */

function initProvide (vm) {
  var provide = vm.$options.provide;
  if (provide) {
    vm._provided = typeof provide === 'function'
      ? provide.call(vm)
      : provide;
  }
}

function initInjections (vm) {
  var result = resolveInject(vm.$options.inject, vm);
  if (result) {
    toggleObserving(false);
    Object.keys(result).forEach(function (key) {
      /* istanbul ignore else */
      if (false) {
        defineReactive$$1(vm, key, result[key], function () {
          warn(
            "Avoid mutating an injected value directly since the changes will be " +
            "overwritten whenever the provided component re-renders. " +
            "injection being mutated: \"" + key + "\"",
            vm
          );
        });
      } else {
        defineReactive$$1(vm, key, result[key]);
      }
    });
    toggleObserving(true);
  }
}

function resolveInject (inject, vm) {
  if (inject) {
    // inject is :any because flow is not smart enough to figure out cached
    var result = Object.create(null);
    var keys = hasSymbol
      ? Reflect.ownKeys(inject)
      : Object.keys(inject);

    for (var i = 0; i < keys.length; i++) {
      var key = keys[i];
      // #6574 in case the inject object is observed...
      if (key === '__ob__') { continue }
      var provideKey = inject[key].from;
      var source = vm;
      while (source) {
        if (source._provided && hasOwn(source._provided, provideKey)) {
          result[key] = source._provided[provideKey];
          break
        }
        source = source.$parent;
      }
      if (!source) {
        if ('default' in inject[key]) {
          var provideDefault = inject[key].default;
          result[key] = typeof provideDefault === 'function'
            ? provideDefault.call(vm)
            : provideDefault;
        } else if (false) {
          warn(("Injection \"" + key + "\" not found"), vm);
        }
      }
    }
    return result
  }
}

/*  */



/**
 * Runtime helper for resolving raw children VNodes into a slot object.
 */
function resolveSlots (
  children,
  context
) {
  if (!children || !children.length) {
    return {}
  }
  var slots = {};
  for (var i = 0, l = children.length; i < l; i++) {
    var child = children[i];
    var data = child.data;
    // remove slot attribute if the node is resolved as a Vue slot node
    if (data && data.attrs && data.attrs.slot) {
      delete data.attrs.slot;
    }
    // named slots should only be respected if the vnode was rendered in the
    // same context.
    if ((child.context === context || child.fnContext === context) &&
      data && data.slot != null
    ) {
      var name = data.slot;
      var slot = (slots[name] || (slots[name] = []));
      if (child.tag === 'template') {
        slot.push.apply(slot, child.children || []);
      } else {
        slot.push(child);
      }
    } else {
      (slots.default || (slots.default = [])).push(child);
    }
  }
  // ignore slots that contains only whitespace
  for (var name$1 in slots) {
    if (slots[name$1].every(isWhitespace)) {
      delete slots[name$1];
    }
  }
  return slots
}

function isWhitespace (node) {
  return (node.isComment && !node.asyncFactory) || node.text === ' '
}

/*  */

function normalizeScopedSlots (
  slots,
  normalSlots,
  prevSlots
) {
  var res;
  var hasNormalSlots = Object.keys(normalSlots).length > 0;
  var isStable = slots ? !!slots.$stable : !hasNormalSlots;
  var key = slots && slots.$key;
  if (!slots) {
    res = {};
  } else if (slots._normalized) {
    // fast path 1: child component re-render only, parent did not change
    return slots._normalized
  } else if (
    isStable &&
    prevSlots &&
    prevSlots !== emptyObject &&
    key === prevSlots.$key &&
    !hasNormalSlots &&
    !prevSlots.$hasNormal
  ) {
    // fast path 2: stable scoped slots w/ no normal slots to proxy,
    // only need to normalize once
    return prevSlots
  } else {
    res = {};
    for (var key$1 in slots) {
      if (slots[key$1] && key$1[0] !== '$') {
        res[key$1] = normalizeScopedSlot(normalSlots, key$1, slots[key$1]);
      }
    }
  }
  // expose normal slots on scopedSlots
  for (var key$2 in normalSlots) {
    if (!(key$2 in res)) {
      res[key$2] = proxyNormalSlot(normalSlots, key$2);
    }
  }
  // avoriaz seems to mock a non-extensible $scopedSlots object
  // and when that is passed down this would cause an error
  if (slots && Object.isExtensible(slots)) {
    (slots)._normalized = res;
  }
  def(res, '$stable', isStable);
  def(res, '$key', key);
  def(res, '$hasNormal', hasNormalSlots);
  return res
}

function normalizeScopedSlot(normalSlots, key, fn) {
  var normalized = function () {
    var res = arguments.length ? fn.apply(null, arguments) : fn({});
    res = res && typeof res === 'object' && !Array.isArray(res)
      ? [res] // single vnode
      : normalizeChildren(res);
    return res && (
      res.length === 0 ||
      (res.length === 1 && res[0].isComment) // #9658
    ) ? undefined
      : res
  };
  // this is a slot using the new v-slot syntax without scope. although it is
  // compiled as a scoped slot, render fn users would expect it to be present
  // on this.$slots because the usage is semantically a normal slot.
  if (fn.proxy) {
    Object.defineProperty(normalSlots, key, {
      get: normalized,
      enumerable: true,
      configurable: true
    });
  }
  return normalized
}

function proxyNormalSlot(slots, key) {
  return function () { return slots[key]; }
}

/*  */

/**
 * Runtime helper for rendering v-for lists.
 */
function renderList (
  val,
  render
) {
  var ret, i, l, keys, key;
  if (Array.isArray(val) || typeof val === 'string') {
    ret = new Array(val.length);
    for (i = 0, l = val.length; i < l; i++) {
      ret[i] = render(val[i], i);
    }
  } else if (typeof val === 'number') {
    ret = new Array(val);
    for (i = 0; i < val; i++) {
      ret[i] = render(i + 1, i);
    }
  } else if (isObject(val)) {
    if (hasSymbol && val[Symbol.iterator]) {
      ret = [];
      var iterator = val[Symbol.iterator]();
      var result = iterator.next();
      while (!result.done) {
        ret.push(render(result.value, ret.length));
        result = iterator.next();
      }
    } else {
      keys = Object.keys(val);
      ret = new Array(keys.length);
      for (i = 0, l = keys.length; i < l; i++) {
        key = keys[i];
        ret[i] = render(val[key], key, i);
      }
    }
  }
  if (!isDef(ret)) {
    ret = [];
  }
  (ret)._isVList = true;
  return ret
}

/*  */

/**
 * Runtime helper for rendering <slot>
 */
function renderSlot (
  name,
  fallback,
  props,
  bindObject
) {
  var scopedSlotFn = this.$scopedSlots[name];
  var nodes;
  if (scopedSlotFn) { // scoped slot
    props = props || {};
    if (bindObject) {
      if (false) {
        warn(
          'slot v-bind without argument expects an Object',
          this
        );
      }
      props = extend(extend({}, bindObject), props);
    }
    nodes = scopedSlotFn(props) || fallback;
  } else {
    nodes = this.$slots[name] || fallback;
  }

  var target = props && props.slot;
  if (target) {
    return this.$createElement('template', { slot: target }, nodes)
  } else {
    return nodes
  }
}

/*  */

/**
 * Runtime helper for resolving filters
 */
function resolveFilter (id) {
  return resolveAsset(this.$options, 'filters', id, true) || identity
}

/*  */

function isKeyNotMatch (expect, actual) {
  if (Array.isArray(expect)) {
    return expect.indexOf(actual) === -1
  } else {
    return expect !== actual
  }
}

/**
 * Runtime helper for checking keyCodes from config.
 * exposed as Vue.prototype._k
 * passing in eventKeyName as last argument separately for backwards compat
 */
function checkKeyCodes (
  eventKeyCode,
  key,
  builtInKeyCode,
  eventKeyName,
  builtInKeyName
) {
  var mappedKeyCode = config.keyCodes[key] || builtInKeyCode;
  if (builtInKeyName && eventKeyName && !config.keyCodes[key]) {
    return isKeyNotMatch(builtInKeyName, eventKeyName)
  } else if (mappedKeyCode) {
    return isKeyNotMatch(mappedKeyCode, eventKeyCode)
  } else if (eventKeyName) {
    return hyphenate(eventKeyName) !== key
  }
}

/*  */

/**
 * Runtime helper for merging v-bind="object" into a VNode's data.
 */
function bindObjectProps (
  data,
  tag,
  value,
  asProp,
  isSync
) {
  if (value) {
    if (!isObject(value)) {
      "production" !== 'production' && warn(
        'v-bind without argument expects an Object or Array value',
        this
      );
    } else {
      if (Array.isArray(value)) {
        value = toObject(value);
      }
      var hash;
      var loop = function ( key ) {
        if (
          key === 'class' ||
          key === 'style' ||
          isReservedAttribute(key)
        ) {
          hash = data;
        } else {
          var type = data.attrs && data.attrs.type;
          hash = asProp || config.mustUseProp(tag, type, key)
            ? data.domProps || (data.domProps = {})
            : data.attrs || (data.attrs = {});
        }
        var camelizedKey = camelize(key);
        var hyphenatedKey = hyphenate(key);
        if (!(camelizedKey in hash) && !(hyphenatedKey in hash)) {
          hash[key] = value[key];

          if (isSync) {
            var on = data.on || (data.on = {});
            on[("update:" + key)] = function ($event) {
              value[key] = $event;
            };
          }
        }
      };

      for (var key in value) loop( key );
    }
  }
  return data
}

/*  */

/**
 * Runtime helper for rendering static trees.
 */
function renderStatic (
  index,
  isInFor
) {
  var cached = this._staticTrees || (this._staticTrees = []);
  var tree = cached[index];
  // if has already-rendered static tree and not inside v-for,
  // we can reuse the same tree.
  if (tree && !isInFor) {
    return tree
  }
  // otherwise, render a fresh tree.
  tree = cached[index] = this.$options.staticRenderFns[index].call(
    this._renderProxy,
    null,
    this // for render fns generated for functional component templates
  );
  markStatic(tree, ("__static__" + index), false);
  return tree
}

/**
 * Runtime helper for v-once.
 * Effectively it means marking the node as static with a unique key.
 */
function markOnce (
  tree,
  index,
  key
) {
  markStatic(tree, ("__once__" + index + (key ? ("_" + key) : "")), true);
  return tree
}

function markStatic (
  tree,
  key,
  isOnce
) {
  if (Array.isArray(tree)) {
    for (var i = 0; i < tree.length; i++) {
      if (tree[i] && typeof tree[i] !== 'string') {
        markStaticNode(tree[i], (key + "_" + i), isOnce);
      }
    }
  } else {
    markStaticNode(tree, key, isOnce);
  }
}

function markStaticNode (node, key, isOnce) {
  node.isStatic = true;
  node.key = key;
  node.isOnce = isOnce;
}

/*  */

function bindObjectListeners (data, value) {
  if (value) {
    if (!isPlainObject(value)) {
      "production" !== 'production' && warn(
        'v-on without argument expects an Object value',
        this
      );
    } else {
      var on = data.on = data.on ? extend({}, data.on) : {};
      for (var key in value) {
        var existing = on[key];
        var ours = value[key];
        on[key] = existing ? [].concat(existing, ours) : ours;
      }
    }
  }
  return data
}

/*  */

function resolveScopedSlots (
  fns, // see flow/vnode
  res,
  // the following are added in 2.6
  hasDynamicKeys,
  contentHashKey
) {
  res = res || { $stable: !hasDynamicKeys };
  for (var i = 0; i < fns.length; i++) {
    var slot = fns[i];
    if (Array.isArray(slot)) {
      resolveScopedSlots(slot, res, hasDynamicKeys);
    } else if (slot) {
      // marker for reverse proxying v-slot without scope on this.$slots
      if (slot.proxy) {
        slot.fn.proxy = true;
      }
      res[slot.key] = slot.fn;
    }
  }
  if (contentHashKey) {
    (res).$key = contentHashKey;
  }
  return res
}

/*  */

function bindDynamicKeys (baseObj, values) {
  for (var i = 0; i < values.length; i += 2) {
    var key = values[i];
    if (typeof key === 'string' && key) {
      baseObj[values[i]] = values[i + 1];
    } else if (false) {
      // null is a special value for explicitly removing a binding
      warn(
        ("Invalid value for dynamic directive argument (expected string or null): " + key),
        this
      );
    }
  }
  return baseObj
}

// helper to dynamically append modifier runtime markers to event names.
// ensure only append when value is already string, otherwise it will be cast
// to string and cause the type check to miss.
function prependModifier (value, symbol) {
  return typeof value === 'string' ? symbol + value : value
}

/*  */

function installRenderHelpers (target) {
  target._o = markOnce;
  target._n = toNumber;
  target._s = toString;
  target._l = renderList;
  target._t = renderSlot;
  target._q = looseEqual;
  target._i = looseIndexOf;
  target._m = renderStatic;
  target._f = resolveFilter;
  target._k = checkKeyCodes;
  target._b = bindObjectProps;
  target._v = createTextVNode;
  target._e = createEmptyVNode;
  target._u = resolveScopedSlots;
  target._g = bindObjectListeners;
  target._d = bindDynamicKeys;
  target._p = prependModifier;
}

/*  */

function FunctionalRenderContext (
  data,
  props,
  children,
  parent,
  Ctor
) {
  var this$1 = this;

  var options = Ctor.options;
  // ensure the createElement function in functional components
  // gets a unique context - this is necessary for correct named slot check
  var contextVm;
  if (hasOwn(parent, '_uid')) {
    contextVm = Object.create(parent);
    // $flow-disable-line
    contextVm._original = parent;
  } else {
    // the context vm passed in is a functional context as well.
    // in this case we want to make sure we are able to get a hold to the
    // real context instance.
    contextVm = parent;
    // $flow-disable-line
    parent = parent._original;
  }
  var isCompiled = isTrue(options._compiled);
  var needNormalization = !isCompiled;

  this.data = data;
  this.props = props;
  this.children = children;
  this.parent = parent;
  this.listeners = data.on || emptyObject;
  this.injections = resolveInject(options.inject, parent);
  this.slots = function () {
    if (!this$1.$slots) {
      normalizeScopedSlots(
        data.scopedSlots,
        this$1.$slots = resolveSlots(children, parent)
      );
    }
    return this$1.$slots
  };

  Object.defineProperty(this, 'scopedSlots', ({
    enumerable: true,
    get: function get () {
      return normalizeScopedSlots(data.scopedSlots, this.slots())
    }
  }));

  // support for compiled functional template
  if (isCompiled) {
    // exposing $options for renderStatic()
    this.$options = options;
    // pre-resolve slots for renderSlot()
    this.$slots = this.slots();
    this.$scopedSlots = normalizeScopedSlots(data.scopedSlots, this.$slots);
  }

  if (options._scopeId) {
    this._c = function (a, b, c, d) {
      var vnode = createElement(contextVm, a, b, c, d, needNormalization);
      if (vnode && !Array.isArray(vnode)) {
        vnode.fnScopeId = options._scopeId;
        vnode.fnContext = parent;
      }
      return vnode
    };
  } else {
    this._c = function (a, b, c, d) { return createElement(contextVm, a, b, c, d, needNormalization); };
  }
}

installRenderHelpers(FunctionalRenderContext.prototype);

function createFunctionalComponent (
  Ctor,
  propsData,
  data,
  contextVm,
  children
) {
  var options = Ctor.options;
  var props = {};
  var propOptions = options.props;
  if (isDef(propOptions)) {
    for (var key in propOptions) {
      props[key] = validateProp(key, propOptions, propsData || emptyObject);
    }
  } else {
    if (isDef(data.attrs)) { mergeProps(props, data.attrs); }
    if (isDef(data.props)) { mergeProps(props, data.props); }
  }

  var renderContext = new FunctionalRenderContext(
    data,
    props,
    children,
    contextVm,
    Ctor
  );

  var vnode = options.render.call(null, renderContext._c, renderContext);

  if (vnode instanceof VNode) {
    return cloneAndMarkFunctionalResult(vnode, data, renderContext.parent, options, renderContext)
  } else if (Array.isArray(vnode)) {
    var vnodes = normalizeChildren(vnode) || [];
    var res = new Array(vnodes.length);
    for (var i = 0; i < vnodes.length; i++) {
      res[i] = cloneAndMarkFunctionalResult(vnodes[i], data, renderContext.parent, options, renderContext);
    }
    return res
  }
}

function cloneAndMarkFunctionalResult (vnode, data, contextVm, options, renderContext) {
  // #7817 clone node before setting fnContext, otherwise if the node is reused
  // (e.g. it was from a cached normal slot) the fnContext causes named slots
  // that should not be matched to match.
  var clone = cloneVNode(vnode);
  clone.fnContext = contextVm;
  clone.fnOptions = options;
  if (false) {
    (clone.devtoolsMeta = clone.devtoolsMeta || {}).renderContext = renderContext;
  }
  if (data.slot) {
    (clone.data || (clone.data = {})).slot = data.slot;
  }
  return clone
}

function mergeProps (to, from) {
  for (var key in from) {
    to[camelize(key)] = from[key];
  }
}

/*  */

/*  */

/*  */

/*  */

// inline hooks to be invoked on component VNodes during patch
var componentVNodeHooks = {
  init: function init (vnode, hydrating) {
    if (
      vnode.componentInstance &&
      !vnode.componentInstance._isDestroyed &&
      vnode.data.keepAlive
    ) {
      // kept-alive components, treat as a patch
      var mountedNode = vnode; // work around flow
      componentVNodeHooks.prepatch(mountedNode, mountedNode);
    } else {
      var child = vnode.componentInstance = createComponentInstanceForVnode(
        vnode,
        activeInstance
      );
      child.$mount(hydrating ? vnode.elm : undefined, hydrating);
    }
  },

  prepatch: function prepatch (oldVnode, vnode) {
    var options = vnode.componentOptions;
    var child = vnode.componentInstance = oldVnode.componentInstance;
    updateChildComponent(
      child,
      options.propsData, // updated props
      options.listeners, // updated listeners
      vnode, // new parent vnode
      options.children // new children
    );
  },

  insert: function insert (vnode) {
    var context = vnode.context;
    var componentInstance = vnode.componentInstance;
    if (!componentInstance._isMounted) {
      componentInstance._isMounted = true;
      callHook(componentInstance, 'mounted');
    }
    if (vnode.data.keepAlive) {
      if (context._isMounted) {
        // vue-router#1212
        // During updates, a kept-alive component's child components may
        // change, so directly walking the tree here may call activated hooks
        // on incorrect children. Instead we push them into a queue which will
        // be processed after the whole patch process ended.
        queueActivatedComponent(componentInstance);
      } else {
        activateChildComponent(componentInstance, true /* direct */);
      }
    }
  },

  destroy: function destroy (vnode) {
    var componentInstance = vnode.componentInstance;
    if (!componentInstance._isDestroyed) {
      if (!vnode.data.keepAlive) {
        componentInstance.$destroy();
      } else {
        deactivateChildComponent(componentInstance, true /* direct */);
      }
    }
  }
};

var hooksToMerge = Object.keys(componentVNodeHooks);

function createComponent (
  Ctor,
  data,
  context,
  children,
  tag
) {
  if (isUndef(Ctor)) {
    return
  }

  var baseCtor = context.$options._base;

  // plain options object: turn it into a constructor
  if (isObject(Ctor)) {
    Ctor = baseCtor.extend(Ctor);
  }

  // if at this stage it's not a constructor or an async component factory,
  // reject.
  if (typeof Ctor !== 'function') {
    if (false) {
      warn(("Invalid Component definition: " + (String(Ctor))), context);
    }
    return
  }

  // async component
  var asyncFactory;
  if (isUndef(Ctor.cid)) {
    asyncFactory = Ctor;
    Ctor = resolveAsyncComponent(asyncFactory, baseCtor);
    if (Ctor === undefined) {
      // return a placeholder node for async component, which is rendered
      // as a comment node but preserves all the raw information for the node.
      // the information will be used for async server-rendering and hydration.
      return createAsyncPlaceholder(
        asyncFactory,
        data,
        context,
        children,
        tag
      )
    }
  }

  data = data || {};

  // resolve constructor options in case global mixins are applied after
  // component constructor creation
  resolveConstructorOptions(Ctor);

  // transform component v-model data into props & events
  if (isDef(data.model)) {
    transformModel(Ctor.options, data);
  }

  // extract props
  var propsData = extractPropsFromVNodeData(data, Ctor, tag);

  // functional component
  if (isTrue(Ctor.options.functional)) {
    return createFunctionalComponent(Ctor, propsData, data, context, children)
  }

  // extract listeners, since these needs to be treated as
  // child component listeners instead of DOM listeners
  var listeners = data.on;
  // replace with listeners with .native modifier
  // so it gets processed during parent component patch.
  data.on = data.nativeOn;

  if (isTrue(Ctor.options.abstract)) {
    // abstract components do not keep anything
    // other than props & listeners & slot

    // work around flow
    var slot = data.slot;
    data = {};
    if (slot) {
      data.slot = slot;
    }
  }

  // install component management hooks onto the placeholder node
  installComponentHooks(data);

  // return a placeholder vnode
  var name = Ctor.options.name || tag;
  var vnode = new VNode(
    ("vue-component-" + (Ctor.cid) + (name ? ("-" + name) : '')),
    data, undefined, undefined, undefined, context,
    { Ctor: Ctor, propsData: propsData, listeners: listeners, tag: tag, children: children },
    asyncFactory
  );

  return vnode
}

function createComponentInstanceForVnode (
  vnode, // we know it's MountedComponentVNode but flow doesn't
  parent // activeInstance in lifecycle state
) {
  var options = {
    _isComponent: true,
    _parentVnode: vnode,
    parent: parent
  };
  // check inline-template render functions
  var inlineTemplate = vnode.data.inlineTemplate;
  if (isDef(inlineTemplate)) {
    options.render = inlineTemplate.render;
    options.staticRenderFns = inlineTemplate.staticRenderFns;
  }
  return new vnode.componentOptions.Ctor(options)
}

function installComponentHooks (data) {
  var hooks = data.hook || (data.hook = {});
  for (var i = 0; i < hooksToMerge.length; i++) {
    var key = hooksToMerge[i];
    var existing = hooks[key];
    var toMerge = componentVNodeHooks[key];
    if (existing !== toMerge && !(existing && existing._merged)) {
      hooks[key] = existing ? mergeHook$1(toMerge, existing) : toMerge;
    }
  }
}

function mergeHook$1 (f1, f2) {
  var merged = function (a, b) {
    // flow complains about extra args which is why we use any
    f1(a, b);
    f2(a, b);
  };
  merged._merged = true;
  return merged
}

// transform component v-model info (value and callback) into
// prop and event handler respectively.
function transformModel (options, data) {
  var prop = (options.model && options.model.prop) || 'value';
  var event = (options.model && options.model.event) || 'input'
  ;(data.attrs || (data.attrs = {}))[prop] = data.model.value;
  var on = data.on || (data.on = {});
  var existing = on[event];
  var callback = data.model.callback;
  if (isDef(existing)) {
    if (
      Array.isArray(existing)
        ? existing.indexOf(callback) === -1
        : existing !== callback
    ) {
      on[event] = [callback].concat(existing);
    }
  } else {
    on[event] = callback;
  }
}

/*  */

var SIMPLE_NORMALIZE = 1;
var ALWAYS_NORMALIZE = 2;

// wrapper function for providing a more flexible interface
// without getting yelled at by flow
function createElement (
  context,
  tag,
  data,
  children,
  normalizationType,
  alwaysNormalize
) {
  if (Array.isArray(data) || isPrimitive(data)) {
    normalizationType = children;
    children = data;
    data = undefined;
  }
  if (isTrue(alwaysNormalize)) {
    normalizationType = ALWAYS_NORMALIZE;
  }
  return _createElement(context, tag, data, children, normalizationType)
}

function _createElement (
  context,
  tag,
  data,
  children,
  normalizationType
) {
  if (isDef(data) && isDef((data).__ob__)) {
    "production" !== 'production' && warn(
      "Avoid using observed data object as vnode data: " + (JSON.stringify(data)) + "\n" +
      'Always create fresh vnode data objects in each render!',
      context
    );
    return createEmptyVNode()
  }
  // object syntax in v-bind
  if (isDef(data) && isDef(data.is)) {
    tag = data.is;
  }
  if (!tag) {
    // in case of component :is set to falsy value
    return createEmptyVNode()
  }
  // warn against non-primitive key
  if (false
  ) {
    {
      warn(
        'Avoid using non-primitive value as key, ' +
        'use string/number value instead.',
        context
      );
    }
  }
  // support single function children as default scoped slot
  if (Array.isArray(children) &&
    typeof children[0] === 'function'
  ) {
    data = data || {};
    data.scopedSlots = { default: children[0] };
    children.length = 0;
  }
  if (normalizationType === ALWAYS_NORMALIZE) {
    children = normalizeChildren(children);
  } else if (normalizationType === SIMPLE_NORMALIZE) {
    children = simpleNormalizeChildren(children);
  }
  var vnode, ns;
  if (typeof tag === 'string') {
    var Ctor;
    ns = (context.$vnode && context.$vnode.ns) || config.getTagNamespace(tag);
    if (config.isReservedTag(tag)) {
      // platform built-in elements
      if (false) {
        warn(
          ("The .native modifier for v-on is only valid on components but it was used on <" + tag + ">."),
          context
        );
      }
      vnode = new VNode(
        config.parsePlatformTagName(tag), data, children,
        undefined, undefined, context
      );
    } else if ((!data || !data.pre) && isDef(Ctor = resolveAsset(context.$options, 'components', tag))) {
      // component
      vnode = createComponent(Ctor, data, context, children, tag);
    } else {
      // unknown or unlisted namespaced elements
      // check at runtime because it may get assigned a namespace when its
      // parent normalizes children
      vnode = new VNode(
        tag, data, children,
        undefined, undefined, context
      );
    }
  } else {
    // direct component options / constructor
    vnode = createComponent(tag, data, context, children);
  }
  if (Array.isArray(vnode)) {
    return vnode
  } else if (isDef(vnode)) {
    if (isDef(ns)) { applyNS(vnode, ns); }
    if (isDef(data)) { registerDeepBindings(data); }
    return vnode
  } else {
    return createEmptyVNode()
  }
}

function applyNS (vnode, ns, force) {
  vnode.ns = ns;
  if (vnode.tag === 'foreignObject') {
    // use default namespace inside foreignObject
    ns = undefined;
    force = true;
  }
  if (isDef(vnode.children)) {
    for (var i = 0, l = vnode.children.length; i < l; i++) {
      var child = vnode.children[i];
      if (isDef(child.tag) && (
        isUndef(child.ns) || (isTrue(force) && child.tag !== 'svg'))) {
        applyNS(child, ns, force);
      }
    }
  }
}

// ref #5318
// necessary to ensure parent re-render when deep bindings like :style and
// :class are used on slot nodes
function registerDeepBindings (data) {
  if (isObject(data.style)) {
    traverse(data.style);
  }
  if (isObject(data.class)) {
    traverse(data.class);
  }
}

/*  */

function initRender (vm) {
  vm._vnode = null; // the root of the child tree
  vm._staticTrees = null; // v-once cached trees
  var options = vm.$options;
  var parentVnode = vm.$vnode = options._parentVnode; // the placeholder node in parent tree
  var renderContext = parentVnode && parentVnode.context;
  vm.$slots = resolveSlots(options._renderChildren, renderContext);
  vm.$scopedSlots = emptyObject;
  // bind the createElement fn to this instance
  // so that we get proper render context inside it.
  // args order: tag, data, children, normalizationType, alwaysNormalize
  // internal version is used by render functions compiled from templates
  vm._c = function (a, b, c, d) { return createElement(vm, a, b, c, d, false); };
  // normalization is always applied for the public version, used in
  // user-written render functions.
  vm.$createElement = function (a, b, c, d) { return createElement(vm, a, b, c, d, true); };

  // $attrs & $listeners are exposed for easier HOC creation.
  // they need to be reactive so that HOCs using them are always updated
  var parentData = parentVnode && parentVnode.data;

  /* istanbul ignore else */
  if (false) {
    defineReactive$$1(vm, '$attrs', parentData && parentData.attrs || emptyObject, function () {
      !isUpdatingChildComponent && warn("$attrs is readonly.", vm);
    }, true);
    defineReactive$$1(vm, '$listeners', options._parentListeners || emptyObject, function () {
      !isUpdatingChildComponent && warn("$listeners is readonly.", vm);
    }, true);
  } else {
    defineReactive$$1(vm, '$attrs', parentData && parentData.attrs || emptyObject, null, true);
    defineReactive$$1(vm, '$listeners', options._parentListeners || emptyObject, null, true);
  }
}

var currentRenderingInstance = null;

function renderMixin (Vue) {
  // install runtime convenience helpers
  installRenderHelpers(Vue.prototype);

  Vue.prototype.$nextTick = function (fn) {
    return nextTick(fn, this)
  };

  Vue.prototype._render = function () {
    var vm = this;
    var ref = vm.$options;
    var render = ref.render;
    var _parentVnode = ref._parentVnode;

    if (_parentVnode) {
      vm.$scopedSlots = normalizeScopedSlots(
        _parentVnode.data.scopedSlots,
        vm.$slots,
        vm.$scopedSlots
      );
    }

    // set parent vnode. this allows render functions to have access
    // to the data on the placeholder node.
    vm.$vnode = _parentVnode;
    // render self
    var vnode;
    try {
      // There's no need to maintain a stack because all render fns are called
      // separately from one another. Nested component's render fns are called
      // when parent component is patched.
      currentRenderingInstance = vm;
      vnode = render.call(vm._renderProxy, vm.$createElement);
    } catch (e) {
      handleError(e, vm, "render");
      // return error render result,
      // or previous vnode to prevent render error causing blank component
      /* istanbul ignore else */
      if (false) {
        try {
          vnode = vm.$options.renderError.call(vm._renderProxy, vm.$createElement, e);
        } catch (e) {
          handleError(e, vm, "renderError");
          vnode = vm._vnode;
        }
      } else {
        vnode = vm._vnode;
      }
    } finally {
      currentRenderingInstance = null;
    }
    // if the returned array contains only a single node, allow it
    if (Array.isArray(vnode) && vnode.length === 1) {
      vnode = vnode[0];
    }
    // return empty vnode in case the render function errored out
    if (!(vnode instanceof VNode)) {
      if (false) {
        warn(
          'Multiple root nodes returned from render function. Render function ' +
          'should return a single root node.',
          vm
        );
      }
      vnode = createEmptyVNode();
    }
    // set parent
    vnode.parent = _parentVnode;
    return vnode
  };
}

/*  */

function ensureCtor (comp, base) {
  if (
    comp.__esModule ||
    (hasSymbol && comp[Symbol.toStringTag] === 'Module')
  ) {
    comp = comp.default;
  }
  return isObject(comp)
    ? base.extend(comp)
    : comp
}

function createAsyncPlaceholder (
  factory,
  data,
  context,
  children,
  tag
) {
  var node = createEmptyVNode();
  node.asyncFactory = factory;
  node.asyncMeta = { data: data, context: context, children: children, tag: tag };
  return node
}

function resolveAsyncComponent (
  factory,
  baseCtor
) {
  if (isTrue(factory.error) && isDef(factory.errorComp)) {
    return factory.errorComp
  }

  if (isDef(factory.resolved)) {
    return factory.resolved
  }

  var owner = currentRenderingInstance;
  if (owner && isDef(factory.owners) && factory.owners.indexOf(owner) === -1) {
    // already pending
    factory.owners.push(owner);
  }

  if (isTrue(factory.loading) && isDef(factory.loadingComp)) {
    return factory.loadingComp
  }

  if (owner && !isDef(factory.owners)) {
    var owners = factory.owners = [owner];
    var sync = true;
    var timerLoading = null;
    var timerTimeout = null

    ;(owner).$on('hook:destroyed', function () { return remove(owners, owner); });

    var forceRender = function (renderCompleted) {
      for (var i = 0, l = owners.length; i < l; i++) {
        (owners[i]).$forceUpdate();
      }

      if (renderCompleted) {
        owners.length = 0;
        if (timerLoading !== null) {
          clearTimeout(timerLoading);
          timerLoading = null;
        }
        if (timerTimeout !== null) {
          clearTimeout(timerTimeout);
          timerTimeout = null;
        }
      }
    };

    var resolve = once(function (res) {
      // cache resolved
      factory.resolved = ensureCtor(res, baseCtor);
      // invoke callbacks only if this is not a synchronous resolve
      // (async resolves are shimmed as synchronous during SSR)
      if (!sync) {
        forceRender(true);
      } else {
        owners.length = 0;
      }
    });

    var reject = once(function (reason) {
      "production" !== 'production' && warn(
        "Failed to resolve async component: " + (String(factory)) +
        (reason ? ("\nReason: " + reason) : '')
      );
      if (isDef(factory.errorComp)) {
        factory.error = true;
        forceRender(true);
      }
    });

    var res = factory(resolve, reject);

    if (isObject(res)) {
      if (isPromise(res)) {
        // () => Promise
        if (isUndef(factory.resolved)) {
          res.then(resolve, reject);
        }
      } else if (isPromise(res.component)) {
        res.component.then(resolve, reject);

        if (isDef(res.error)) {
          factory.errorComp = ensureCtor(res.error, baseCtor);
        }

        if (isDef(res.loading)) {
          factory.loadingComp = ensureCtor(res.loading, baseCtor);
          if (res.delay === 0) {
            factory.loading = true;
          } else {
            timerLoading = setTimeout(function () {
              timerLoading = null;
              if (isUndef(factory.resolved) && isUndef(factory.error)) {
                factory.loading = true;
                forceRender(false);
              }
            }, res.delay || 200);
          }
        }

        if (isDef(res.timeout)) {
          timerTimeout = setTimeout(function () {
            timerTimeout = null;
            if (isUndef(factory.resolved)) {
              reject(
                 false
                  ? ("timeout (" + (res.timeout) + "ms)")
                  : null
              );
            }
          }, res.timeout);
        }
      }
    }

    sync = false;
    // return in case resolved synchronously
    return factory.loading
      ? factory.loadingComp
      : factory.resolved
  }
}

/*  */

function isAsyncPlaceholder (node) {
  return node.isComment && node.asyncFactory
}

/*  */

function getFirstComponentChild (children) {
  if (Array.isArray(children)) {
    for (var i = 0; i < children.length; i++) {
      var c = children[i];
      if (isDef(c) && (isDef(c.componentOptions) || isAsyncPlaceholder(c))) {
        return c
      }
    }
  }
}

/*  */

/*  */

function initEvents (vm) {
  vm._events = Object.create(null);
  vm._hasHookEvent = false;
  // init parent attached events
  var listeners = vm.$options._parentListeners;
  if (listeners) {
    updateComponentListeners(vm, listeners);
  }
}

var target;

function add (event, fn) {
  target.$on(event, fn);
}

function remove$1 (event, fn) {
  target.$off(event, fn);
}

function createOnceHandler (event, fn) {
  var _target = target;
  return function onceHandler () {
    var res = fn.apply(null, arguments);
    if (res !== null) {
      _target.$off(event, onceHandler);
    }
  }
}

function updateComponentListeners (
  vm,
  listeners,
  oldListeners
) {
  target = vm;
  updateListeners(listeners, oldListeners || {}, add, remove$1, createOnceHandler, vm);
  target = undefined;
}

function eventsMixin (Vue) {
  var hookRE = /^hook:/;
  Vue.prototype.$on = function (event, fn) {
    var vm = this;
    if (Array.isArray(event)) {
      for (var i = 0, l = event.length; i < l; i++) {
        vm.$on(event[i], fn);
      }
    } else {
      (vm._events[event] || (vm._events[event] = [])).push(fn);
      // optimize hook:event cost by using a boolean flag marked at registration
      // instead of a hash lookup
      if (hookRE.test(event)) {
        vm._hasHookEvent = true;
      }
    }
    return vm
  };

  Vue.prototype.$once = function (event, fn) {
    var vm = this;
    function on () {
      vm.$off(event, on);
      fn.apply(vm, arguments);
    }
    on.fn = fn;
    vm.$on(event, on);
    return vm
  };

  Vue.prototype.$off = function (event, fn) {
    var vm = this;
    // all
    if (!arguments.length) {
      vm._events = Object.create(null);
      return vm
    }
    // array of events
    if (Array.isArray(event)) {
      for (var i$1 = 0, l = event.length; i$1 < l; i$1++) {
        vm.$off(event[i$1], fn);
      }
      return vm
    }
    // specific event
    var cbs = vm._events[event];
    if (!cbs) {
      return vm
    }
    if (!fn) {
      vm._events[event] = null;
      return vm
    }
    // specific handler
    var cb;
    var i = cbs.length;
    while (i--) {
      cb = cbs[i];
      if (cb === fn || cb.fn === fn) {
        cbs.splice(i, 1);
        break
      }
    }
    return vm
  };

  Vue.prototype.$emit = function (event) {
    var vm = this;
    if (false) {
      var lowerCaseEvent = event.toLowerCase();
      if (lowerCaseEvent !== event && vm._events[lowerCaseEvent]) {
        tip(
          "Event \"" + lowerCaseEvent + "\" is emitted in component " +
          (formatComponentName(vm)) + " but the handler is registered for \"" + event + "\". " +
          "Note that HTML attributes are case-insensitive and you cannot use " +
          "v-on to listen to camelCase events when using in-DOM templates. " +
          "You should probably use \"" + (hyphenate(event)) + "\" instead of \"" + event + "\"."
        );
      }
    }
    var cbs = vm._events[event];
    if (cbs) {
      cbs = cbs.length > 1 ? toArray(cbs) : cbs;
      var args = toArray(arguments, 1);
      var info = "event handler for \"" + event + "\"";
      for (var i = 0, l = cbs.length; i < l; i++) {
        invokeWithErrorHandling(cbs[i], vm, args, vm, info);
      }
    }
    return vm
  };
}

/*  */

var activeInstance = null;
var isUpdatingChildComponent = false;

function setActiveInstance(vm) {
  var prevActiveInstance = activeInstance;
  activeInstance = vm;
  return function () {
    activeInstance = prevActiveInstance;
  }
}

function initLifecycle (vm) {
  var options = vm.$options;

  // locate first non-abstract parent
  var parent = options.parent;
  if (parent && !options.abstract) {
    while (parent.$options.abstract && parent.$parent) {
      parent = parent.$parent;
    }
    parent.$children.push(vm);
  }

  vm.$parent = parent;
  vm.$root = parent ? parent.$root : vm;

  vm.$children = [];
  vm.$refs = {};

  vm._watcher = null;
  vm._inactive = null;
  vm._directInactive = false;
  vm._isMounted = false;
  vm._isDestroyed = false;
  vm._isBeingDestroyed = false;
}

function lifecycleMixin (Vue) {
  Vue.prototype._update = function (vnode, hydrating) {
    var vm = this;
    var prevEl = vm.$el;
    var prevVnode = vm._vnode;
    var restoreActiveInstance = setActiveInstance(vm);
    vm._vnode = vnode;
    // Vue.prototype.__patch__ is injected in entry points
    // based on the rendering backend used.
    if (!prevVnode) {
      // initial render
      vm.$el = vm.__patch__(vm.$el, vnode, hydrating, false /* removeOnly */);
    } else {
      // updates
      vm.$el = vm.__patch__(prevVnode, vnode);
    }
    restoreActiveInstance();
    // update __vue__ reference
    if (prevEl) {
      prevEl.__vue__ = null;
    }
    if (vm.$el) {
      vm.$el.__vue__ = vm;
    }
    // if parent is an HOC, update its $el as well
    if (vm.$vnode && vm.$parent && vm.$vnode === vm.$parent._vnode) {
      vm.$parent.$el = vm.$el;
    }
    // updated hook is called by the scheduler to ensure that children are
    // updated in a parent's updated hook.
  };

  Vue.prototype.$forceUpdate = function () {
    var vm = this;
    if (vm._watcher) {
      vm._watcher.update();
    }
  };

  Vue.prototype.$destroy = function () {
    var vm = this;
    if (vm._isBeingDestroyed) {
      return
    }
    callHook(vm, 'beforeDestroy');
    vm._isBeingDestroyed = true;
    // remove self from parent
    var parent = vm.$parent;
    if (parent && !parent._isBeingDestroyed && !vm.$options.abstract) {
      remove(parent.$children, vm);
    }
    // teardown watchers
    if (vm._watcher) {
      vm._watcher.teardown();
    }
    var i = vm._watchers.length;
    while (i--) {
      vm._watchers[i].teardown();
    }
    // remove reference from data ob
    // frozen object may not have observer.
    if (vm._data.__ob__) {
      vm._data.__ob__.vmCount--;
    }
    // call the last hook...
    vm._isDestroyed = true;
    // invoke destroy hooks on current rendered tree
    vm.__patch__(vm._vnode, null);
    // fire destroyed hook
    callHook(vm, 'destroyed');
    // turn off all instance listeners.
    vm.$off();
    // remove __vue__ reference
    if (vm.$el) {
      vm.$el.__vue__ = null;
    }
    // release circular reference (#6759)
    if (vm.$vnode) {
      vm.$vnode.parent = null;
    }
  };
}

function mountComponent (
  vm,
  el,
  hydrating
) {
  vm.$el = el;
  if (!vm.$options.render) {
    vm.$options.render = createEmptyVNode;
    if (false) {
      /* istanbul ignore if */
      if ((vm.$options.template && vm.$options.template.charAt(0) !== '#') ||
        vm.$options.el || el) {
        warn(
          'You are using the runtime-only build of Vue where the template ' +
          'compiler is not available. Either pre-compile the templates into ' +
          'render functions, or use the compiler-included build.',
          vm
        );
      } else {
        warn(
          'Failed to mount component: template or render function not defined.',
          vm
        );
      }
    }
  }
  callHook(vm, 'beforeMount');

  var updateComponent;
  /* istanbul ignore if */
  if (false) {
    updateComponent = function () {
      var name = vm._name;
      var id = vm._uid;
      var startTag = "vue-perf-start:" + id;
      var endTag = "vue-perf-end:" + id;

      mark(startTag);
      var vnode = vm._render();
      mark(endTag);
      measure(("vue " + name + " render"), startTag, endTag);

      mark(startTag);
      vm._update(vnode, hydrating);
      mark(endTag);
      measure(("vue " + name + " patch"), startTag, endTag);
    };
  } else {
    updateComponent = function () {
      vm._update(vm._render(), hydrating);
    };
  }

  // we set this to vm._watcher inside the watcher's constructor
  // since the watcher's initial patch may call $forceUpdate (e.g. inside child
  // component's mounted hook), which relies on vm._watcher being already defined
  new Watcher(vm, updateComponent, noop, {
    before: function before () {
      if (vm._isMounted && !vm._isDestroyed) {
        callHook(vm, 'beforeUpdate');
      }
    }
  }, true /* isRenderWatcher */);
  hydrating = false;

  // manually mounted instance, call mounted on self
  // mounted is called for render-created child components in its inserted hook
  if (vm.$vnode == null) {
    vm._isMounted = true;
    callHook(vm, 'mounted');
  }
  return vm
}

function updateChildComponent (
  vm,
  propsData,
  listeners,
  parentVnode,
  renderChildren
) {
  if (false) {
    isUpdatingChildComponent = true;
  }

  // determine whether component has slot children
  // we need to do this before overwriting $options._renderChildren.

  // check if there are dynamic scopedSlots (hand-written or compiled but with
  // dynamic slot names). Static scoped slots compiled from template has the
  // "$stable" marker.
  var newScopedSlots = parentVnode.data.scopedSlots;
  var oldScopedSlots = vm.$scopedSlots;
  var hasDynamicScopedSlot = !!(
    (newScopedSlots && !newScopedSlots.$stable) ||
    (oldScopedSlots !== emptyObject && !oldScopedSlots.$stable) ||
    (newScopedSlots && vm.$scopedSlots.$key !== newScopedSlots.$key)
  );

  // Any static slot children from the parent may have changed during parent's
  // update. Dynamic scoped slots may also have changed. In such cases, a forced
  // update is necessary to ensure correctness.
  var needsForceUpdate = !!(
    renderChildren ||               // has new static slots
    vm.$options._renderChildren ||  // has old static slots
    hasDynamicScopedSlot
  );

  vm.$options._parentVnode = parentVnode;
  vm.$vnode = parentVnode; // update vm's placeholder node without re-render

  if (vm._vnode) { // update child tree's parent
    vm._vnode.parent = parentVnode;
  }
  vm.$options._renderChildren = renderChildren;

  // update $attrs and $listeners hash
  // these are also reactive so they may trigger child update if the child
  // used them during render
  vm.$attrs = parentVnode.data.attrs || emptyObject;
  vm.$listeners = listeners || emptyObject;

  // update props
  if (propsData && vm.$options.props) {
    toggleObserving(false);
    var props = vm._props;
    var propKeys = vm.$options._propKeys || [];
    for (var i = 0; i < propKeys.length; i++) {
      var key = propKeys[i];
      var propOptions = vm.$options.props; // wtf flow?
      props[key] = validateProp(key, propOptions, propsData, vm);
    }
    toggleObserving(true);
    // keep a copy of raw propsData
    vm.$options.propsData = propsData;
  }

  // update listeners
  listeners = listeners || emptyObject;
  var oldListeners = vm.$options._parentListeners;
  vm.$options._parentListeners = listeners;
  updateComponentListeners(vm, listeners, oldListeners);

  // resolve slots + force update if has children
  if (needsForceUpdate) {
    vm.$slots = resolveSlots(renderChildren, parentVnode.context);
    vm.$forceUpdate();
  }

  if (false) {
    isUpdatingChildComponent = false;
  }
}

function isInInactiveTree (vm) {
  while (vm && (vm = vm.$parent)) {
    if (vm._inactive) { return true }
  }
  return false
}

function activateChildComponent (vm, direct) {
  if (direct) {
    vm._directInactive = false;
    if (isInInactiveTree(vm)) {
      return
    }
  } else if (vm._directInactive) {
    return
  }
  if (vm._inactive || vm._inactive === null) {
    vm._inactive = false;
    for (var i = 0; i < vm.$children.length; i++) {
      activateChildComponent(vm.$children[i]);
    }
    callHook(vm, 'activated');
  }
}

function deactivateChildComponent (vm, direct) {
  if (direct) {
    vm._directInactive = true;
    if (isInInactiveTree(vm)) {
      return
    }
  }
  if (!vm._inactive) {
    vm._inactive = true;
    for (var i = 0; i < vm.$children.length; i++) {
      deactivateChildComponent(vm.$children[i]);
    }
    callHook(vm, 'deactivated');
  }
}

function callHook (vm, hook) {
  // #7573 disable dep collection when invoking lifecycle hooks
  pushTarget();
  var handlers = vm.$options[hook];
  var info = hook + " hook";
  if (handlers) {
    for (var i = 0, j = handlers.length; i < j; i++) {
      invokeWithErrorHandling(handlers[i], vm, null, vm, info);
    }
  }
  if (vm._hasHookEvent) {
    vm.$emit('hook:' + hook);
  }
  popTarget();
}

/*  */

var MAX_UPDATE_COUNT = 100;

var queue = [];
var activatedChildren = [];
var has = {};
var circular = {};
var waiting = false;
var flushing = false;
var index = 0;

/**
 * Reset the scheduler's state.
 */
function resetSchedulerState () {
  index = queue.length = activatedChildren.length = 0;
  has = {};
  if (false) {
    circular = {};
  }
  waiting = flushing = false;
}

// Async edge case #6566 requires saving the timestamp when event listeners are
// attached. However, calling performance.now() has a perf overhead especially
// if the page has thousands of event listeners. Instead, we take a timestamp
// every time the scheduler flushes and use that for all event listeners
// attached during that flush.
var currentFlushTimestamp = 0;

// Async edge case fix requires storing an event listener's attach timestamp.
var getNow = Date.now;

// Determine what event timestamp the browser is using. Annoyingly, the
// timestamp can either be hi-res (relative to page load) or low-res
// (relative to UNIX epoch), so in order to compare time we have to use the
// same timestamp type when saving the flush timestamp.
// All IE versions use low-res event timestamps, and have problematic clock
// implementations (#9632)
if (inBrowser && !isIE) {
  var performance = window.performance;
  if (
    performance &&
    typeof performance.now === 'function' &&
    getNow() > document.createEvent('Event').timeStamp
  ) {
    // if the event timestamp, although evaluated AFTER the Date.now(), is
    // smaller than it, it means the event is using a hi-res timestamp,
    // and we need to use the hi-res version for event listener timestamps as
    // well.
    getNow = function () { return performance.now(); };
  }
}

/**
 * Flush both queues and run the watchers.
 */
function flushSchedulerQueue () {
  currentFlushTimestamp = getNow();
  flushing = true;
  var watcher, id;

  // Sort queue before flush.
  // This ensures that:
  // 1. Components are updated from parent to child. (because parent is always
  //    created before the child)
  // 2. A component's user watchers are run before its render watcher (because
  //    user watchers are created before the render watcher)
  // 3. If a component is destroyed during a parent component's watcher run,
  //    its watchers can be skipped.
  queue.sort(function (a, b) { return a.id - b.id; });

  // do not cache length because more watchers might be pushed
  // as we run existing watchers
  for (index = 0; index < queue.length; index++) {
    watcher = queue[index];
    if (watcher.before) {
      watcher.before();
    }
    id = watcher.id;
    has[id] = null;
    watcher.run();
    // in dev build, check and stop circular updates.
    if (false) {
      circular[id] = (circular[id] || 0) + 1;
      if (circular[id] > MAX_UPDATE_COUNT) {
        warn(
          'You may have an infinite update loop ' + (
            watcher.user
              ? ("in watcher with expression \"" + (watcher.expression) + "\"")
              : "in a component render function."
          ),
          watcher.vm
        );
        break
      }
    }
  }

  // keep copies of post queues before resetting state
  var activatedQueue = activatedChildren.slice();
  var updatedQueue = queue.slice();

  resetSchedulerState();

  // call component updated and activated hooks
  callActivatedHooks(activatedQueue);
  callUpdatedHooks(updatedQueue);

  // devtool hook
  /* istanbul ignore if */
  if (devtools && config.devtools) {
    devtools.emit('flush');
  }
}

function callUpdatedHooks (queue) {
  var i = queue.length;
  while (i--) {
    var watcher = queue[i];
    var vm = watcher.vm;
    if (vm._watcher === watcher && vm._isMounted && !vm._isDestroyed) {
      callHook(vm, 'updated');
    }
  }
}

/**
 * Queue a kept-alive component that was activated during patch.
 * The queue will be processed after the entire tree has been patched.
 */
function queueActivatedComponent (vm) {
  // setting _inactive to false here so that a render function can
  // rely on checking whether it's in an inactive tree (e.g. router-view)
  vm._inactive = false;
  activatedChildren.push(vm);
}

function callActivatedHooks (queue) {
  for (var i = 0; i < queue.length; i++) {
    queue[i]._inactive = true;
    activateChildComponent(queue[i], true /* true */);
  }
}

/**
 * Push a watcher into the watcher queue.
 * Jobs with duplicate IDs will be skipped unless it's
 * pushed when the queue is being flushed.
 */
function queueWatcher (watcher) {
  var id = watcher.id;
  if (has[id] == null) {
    has[id] = true;
    if (!flushing) {
      queue.push(watcher);
    } else {
      // if already flushing, splice the watcher based on its id
      // if already past its id, it will be run next immediately.
      var i = queue.length - 1;
      while (i > index && queue[i].id > watcher.id) {
        i--;
      }
      queue.splice(i + 1, 0, watcher);
    }
    // queue the flush
    if (!waiting) {
      waiting = true;

      if (false) {
        flushSchedulerQueue();
        return
      }
      nextTick(flushSchedulerQueue);
    }
  }
}

/*  */



var uid$2 = 0;

/**
 * A watcher parses an expression, collects dependencies,
 * and fires callback when the expression value changes.
 * This is used for both the $watch() api and directives.
 */
var Watcher = function Watcher (
  vm,
  expOrFn,
  cb,
  options,
  isRenderWatcher
) {
  this.vm = vm;
  if (isRenderWatcher) {
    vm._watcher = this;
  }
  vm._watchers.push(this);
  // options
  if (options) {
    this.deep = !!options.deep;
    this.user = !!options.user;
    this.lazy = !!options.lazy;
    this.sync = !!options.sync;
    this.before = options.before;
  } else {
    this.deep = this.user = this.lazy = this.sync = false;
  }
  this.cb = cb;
  this.id = ++uid$2; // uid for batching
  this.active = true;
  this.dirty = this.lazy; // for lazy watchers
  this.deps = [];
  this.newDeps = [];
  this.depIds = new _Set();
  this.newDepIds = new _Set();
  this.expression =  false
    ? expOrFn.toString()
    : '';
  // parse expression for getter
  if (typeof expOrFn === 'function') {
    this.getter = expOrFn;
  } else {
    this.getter = parsePath(expOrFn);
    if (!this.getter) {
      this.getter = noop;
      "production" !== 'production' && warn(
        "Failed watching path: \"" + expOrFn + "\" " +
        'Watcher only accepts simple dot-delimited paths. ' +
        'For full control, use a function instead.',
        vm
      );
    }
  }
  this.value = this.lazy
    ? undefined
    : this.get();
};

/**
 * Evaluate the getter, and re-collect dependencies.
 */
Watcher.prototype.get = function get () {
  pushTarget(this);
  var value;
  var vm = this.vm;
  try {
    value = this.getter.call(vm, vm);
  } catch (e) {
    if (this.user) {
      handleError(e, vm, ("getter for watcher \"" + (this.expression) + "\""));
    } else {
      throw e
    }
  } finally {
    // "touch" every property so they are all tracked as
    // dependencies for deep watching
    if (this.deep) {
      traverse(value);
    }
    popTarget();
    this.cleanupDeps();
  }
  return value
};

/**
 * Add a dependency to this directive.
 */
Watcher.prototype.addDep = function addDep (dep) {
  var id = dep.id;
  if (!this.newDepIds.has(id)) {
    this.newDepIds.add(id);
    this.newDeps.push(dep);
    if (!this.depIds.has(id)) {
      dep.addSub(this);
    }
  }
};

/**
 * Clean up for dependency collection.
 */
Watcher.prototype.cleanupDeps = function cleanupDeps () {
  var i = this.deps.length;
  while (i--) {
    var dep = this.deps[i];
    if (!this.newDepIds.has(dep.id)) {
      dep.removeSub(this);
    }
  }
  var tmp = this.depIds;
  this.depIds = this.newDepIds;
  this.newDepIds = tmp;
  this.newDepIds.clear();
  tmp = this.deps;
  this.deps = this.newDeps;
  this.newDeps = tmp;
  this.newDeps.length = 0;
};

/**
 * Subscriber interface.
 * Will be called when a dependency changes.
 */
Watcher.prototype.update = function update () {
  /* istanbul ignore else */
  if (this.lazy) {
    this.dirty = true;
  } else if (this.sync) {
    this.run();
  } else {
    queueWatcher(this);
  }
};

/**
 * Scheduler job interface.
 * Will be called by the scheduler.
 */
Watcher.prototype.run = function run () {
  if (this.active) {
    var value = this.get();
    if (
      value !== this.value ||
      // Deep watchers and watchers on Object/Arrays should fire even
      // when the value is the same, because the value may
      // have mutated.
      isObject(value) ||
      this.deep
    ) {
      // set new value
      var oldValue = this.value;
      this.value = value;
      if (this.user) {
        try {
          this.cb.call(this.vm, value, oldValue);
        } catch (e) {
          handleError(e, this.vm, ("callback for watcher \"" + (this.expression) + "\""));
        }
      } else {
        this.cb.call(this.vm, value, oldValue);
      }
    }
  }
};

/**
 * Evaluate the value of the watcher.
 * This only gets called for lazy watchers.
 */
Watcher.prototype.evaluate = function evaluate () {
  this.value = this.get();
  this.dirty = false;
};

/**
 * Depend on all deps collected by this watcher.
 */
Watcher.prototype.depend = function depend () {
  var i = this.deps.length;
  while (i--) {
    this.deps[i].depend();
  }
};

/**
 * Remove self from all dependencies' subscriber list.
 */
Watcher.prototype.teardown = function teardown () {
  if (this.active) {
    // remove self from vm's watcher list
    // this is a somewhat expensive operation so we skip it
    // if the vm is being destroyed.
    if (!this.vm._isBeingDestroyed) {
      remove(this.vm._watchers, this);
    }
    var i = this.deps.length;
    while (i--) {
      this.deps[i].removeSub(this);
    }
    this.active = false;
  }
};

/*  */

var sharedPropertyDefinition = {
  enumerable: true,
  configurable: true,
  get: noop,
  set: noop
};

function proxy (target, sourceKey, key) {
  sharedPropertyDefinition.get = function proxyGetter () {
    return this[sourceKey][key]
  };
  sharedPropertyDefinition.set = function proxySetter (val) {
    this[sourceKey][key] = val;
  };
  Object.defineProperty(target, key, sharedPropertyDefinition);
}

function initState (vm) {
  vm._watchers = [];
  var opts = vm.$options;
  if (opts.props) { initProps(vm, opts.props); }
  if (opts.methods) { initMethods(vm, opts.methods); }
  if (opts.data) {
    initData(vm);
  } else {
    observe(vm._data = {}, true /* asRootData */);
  }
  if (opts.computed) { initComputed(vm, opts.computed); }
  if (opts.watch && opts.watch !== nativeWatch) {
    initWatch(vm, opts.watch);
  }
}

function initProps (vm, propsOptions) {
  var propsData = vm.$options.propsData || {};
  var props = vm._props = {};
  // cache prop keys so that future props updates can iterate using Array
  // instead of dynamic object key enumeration.
  var keys = vm.$options._propKeys = [];
  var isRoot = !vm.$parent;
  // root instance props should be converted
  if (!isRoot) {
    toggleObserving(false);
  }
  var loop = function ( key ) {
    keys.push(key);
    var value = validateProp(key, propsOptions, propsData, vm);
    /* istanbul ignore else */
    if (false) {
      var hyphenatedKey = hyphenate(key);
      if (isReservedAttribute(hyphenatedKey) ||
          config.isReservedAttr(hyphenatedKey)) {
        warn(
          ("\"" + hyphenatedKey + "\" is a reserved attribute and cannot be used as component prop."),
          vm
        );
      }
      defineReactive$$1(props, key, value, function () {
        if (!isRoot && !isUpdatingChildComponent) {
          warn(
            "Avoid mutating a prop directly since the value will be " +
            "overwritten whenever the parent component re-renders. " +
            "Instead, use a data or computed property based on the prop's " +
            "value. Prop being mutated: \"" + key + "\"",
            vm
          );
        }
      });
    } else {
      defineReactive$$1(props, key, value);
    }
    // static props are already proxied on the component's prototype
    // during Vue.extend(). We only need to proxy props defined at
    // instantiation here.
    if (!(key in vm)) {
      proxy(vm, "_props", key);
    }
  };

  for (var key in propsOptions) loop( key );
  toggleObserving(true);
}

function initData (vm) {
  var data = vm.$options.data;
  data = vm._data = typeof data === 'function'
    ? getData(data, vm)
    : data || {};
  if (!isPlainObject(data)) {
    data = {};
    "production" !== 'production' && warn(
      'data functions should return an object:\n' +
      'https://vuejs.org/v2/guide/components.html#data-Must-Be-a-Function',
      vm
    );
  }
  // proxy data on instance
  var keys = Object.keys(data);
  var props = vm.$options.props;
  var methods = vm.$options.methods;
  var i = keys.length;
  while (i--) {
    var key = keys[i];
    if (false) {
      if (methods && hasOwn(methods, key)) {
        warn(
          ("Method \"" + key + "\" has already been defined as a data property."),
          vm
        );
      }
    }
    if (props && hasOwn(props, key)) {
      "production" !== 'production' && warn(
        "The data property \"" + key + "\" is already declared as a prop. " +
        "Use prop default value instead.",
        vm
      );
    } else if (!isReserved(key)) {
      proxy(vm, "_data", key);
    }
  }
  // observe data
  observe(data, true /* asRootData */);
}

function getData (data, vm) {
  // #7573 disable dep collection when invoking data getters
  pushTarget();
  try {
    return data.call(vm, vm)
  } catch (e) {
    handleError(e, vm, "data()");
    return {}
  } finally {
    popTarget();
  }
}

var computedWatcherOptions = { lazy: true };

function initComputed (vm, computed) {
  // $flow-disable-line
  var watchers = vm._computedWatchers = Object.create(null);
  // computed properties are just getters during SSR
  var isSSR = isServerRendering();

  for (var key in computed) {
    var userDef = computed[key];
    var getter = typeof userDef === 'function' ? userDef : userDef.get;
    if (false) {
      warn(
        ("Getter is missing for computed property \"" + key + "\"."),
        vm
      );
    }

    if (!isSSR) {
      // create internal watcher for the computed property.
      watchers[key] = new Watcher(
        vm,
        getter || noop,
        noop,
        computedWatcherOptions
      );
    }

    // component-defined computed properties are already defined on the
    // component prototype. We only need to define computed properties defined
    // at instantiation here.
    if (!(key in vm)) {
      defineComputed(vm, key, userDef);
    } else if (false) {
      if (key in vm.$data) {
        warn(("The computed property \"" + key + "\" is already defined in data."), vm);
      } else if (vm.$options.props && key in vm.$options.props) {
        warn(("The computed property \"" + key + "\" is already defined as a prop."), vm);
      }
    }
  }
}

function defineComputed (
  target,
  key,
  userDef
) {
  var shouldCache = !isServerRendering();
  if (typeof userDef === 'function') {
    sharedPropertyDefinition.get = shouldCache
      ? createComputedGetter(key)
      : createGetterInvoker(userDef);
    sharedPropertyDefinition.set = noop;
  } else {
    sharedPropertyDefinition.get = userDef.get
      ? shouldCache && userDef.cache !== false
        ? createComputedGetter(key)
        : createGetterInvoker(userDef.get)
      : noop;
    sharedPropertyDefinition.set = userDef.set || noop;
  }
  if (false) {
    sharedPropertyDefinition.set = function () {
      warn(
        ("Computed property \"" + key + "\" was assigned to but it has no setter."),
        this
      );
    };
  }
  Object.defineProperty(target, key, sharedPropertyDefinition);
}

function createComputedGetter (key) {
  return function computedGetter () {
    var watcher = this._computedWatchers && this._computedWatchers[key];
    if (watcher) {
      if (watcher.dirty) {
        watcher.evaluate();
      }
      if (Dep.target) {
        watcher.depend();
      }
      return watcher.value
    }
  }
}

function createGetterInvoker(fn) {
  return function computedGetter () {
    return fn.call(this, this)
  }
}

function initMethods (vm, methods) {
  var props = vm.$options.props;
  for (var key in methods) {
    if (false) {
      if (typeof methods[key] !== 'function') {
        warn(
          "Method \"" + key + "\" has type \"" + (typeof methods[key]) + "\" in the component definition. " +
          "Did you reference the function correctly?",
          vm
        );
      }
      if (props && hasOwn(props, key)) {
        warn(
          ("Method \"" + key + "\" has already been defined as a prop."),
          vm
        );
      }
      if ((key in vm) && isReserved(key)) {
        warn(
          "Method \"" + key + "\" conflicts with an existing Vue instance method. " +
          "Avoid defining component methods that start with _ or $."
        );
      }
    }
    vm[key] = typeof methods[key] !== 'function' ? noop : bind(methods[key], vm);
  }
}

function initWatch (vm, watch) {
  for (var key in watch) {
    var handler = watch[key];
    if (Array.isArray(handler)) {
      for (var i = 0; i < handler.length; i++) {
        createWatcher(vm, key, handler[i]);
      }
    } else {
      createWatcher(vm, key, handler);
    }
  }
}

function createWatcher (
  vm,
  expOrFn,
  handler,
  options
) {
  if (isPlainObject(handler)) {
    options = handler;
    handler = handler.handler;
  }
  if (typeof handler === 'string') {
    handler = vm[handler];
  }
  return vm.$watch(expOrFn, handler, options)
}

function stateMixin (Vue) {
  // flow somehow has problems with directly declared definition object
  // when using Object.defineProperty, so we have to procedurally build up
  // the object here.
  var dataDef = {};
  dataDef.get = function () { return this._data };
  var propsDef = {};
  propsDef.get = function () { return this._props };
  if (false) {
    dataDef.set = function () {
      warn(
        'Avoid replacing instance root $data. ' +
        'Use nested data properties instead.',
        this
      );
    };
    propsDef.set = function () {
      warn("$props is readonly.", this);
    };
  }
  Object.defineProperty(Vue.prototype, '$data', dataDef);
  Object.defineProperty(Vue.prototype, '$props', propsDef);

  Vue.prototype.$set = set;
  Vue.prototype.$delete = del;

  Vue.prototype.$watch = function (
    expOrFn,
    cb,
    options
  ) {
    var vm = this;
    if (isPlainObject(cb)) {
      return createWatcher(vm, expOrFn, cb, options)
    }
    options = options || {};
    options.user = true;
    var watcher = new Watcher(vm, expOrFn, cb, options);
    if (options.immediate) {
      try {
        cb.call(vm, watcher.value);
      } catch (error) {
        handleError(error, vm, ("callback for immediate watcher \"" + (watcher.expression) + "\""));
      }
    }
    return function unwatchFn () {
      watcher.teardown();
    }
  };
}

/*  */

var uid$3 = 0;

function initMixin (Vue) {
  Vue.prototype._init = function (options) {
    var vm = this;
    // a uid
    vm._uid = uid$3++;

    var startTag, endTag;
    /* istanbul ignore if */
    if (false) {
      startTag = "vue-perf-start:" + (vm._uid);
      endTag = "vue-perf-end:" + (vm._uid);
      mark(startTag);
    }

    // a flag to avoid this being observed
    vm._isVue = true;
    // merge options
    if (options && options._isComponent) {
      // optimize internal component instantiation
      // since dynamic options merging is pretty slow, and none of the
      // internal component options needs special treatment.
      initInternalComponent(vm, options);
    } else {
      vm.$options = mergeOptions(
        resolveConstructorOptions(vm.constructor),
        options || {},
        vm
      );
    }
    /* istanbul ignore else */
    if (false) {
      initProxy(vm);
    } else {
      vm._renderProxy = vm;
    }
    // expose real self
    vm._self = vm;
    initLifecycle(vm);
    initEvents(vm);
    initRender(vm);
    callHook(vm, 'beforeCreate');
    initInjections(vm); // resolve injections before data/props
    initState(vm);
    initProvide(vm); // resolve provide after data/props
    callHook(vm, 'created');

    /* istanbul ignore if */
    if (false) {
      vm._name = formatComponentName(vm, false);
      mark(endTag);
      measure(("vue " + (vm._name) + " init"), startTag, endTag);
    }

    if (vm.$options.el) {
      vm.$mount(vm.$options.el);
    }
  };
}

function initInternalComponent (vm, options) {
  var opts = vm.$options = Object.create(vm.constructor.options);
  // doing this because it's faster than dynamic enumeration.
  var parentVnode = options._parentVnode;
  opts.parent = options.parent;
  opts._parentVnode = parentVnode;

  var vnodeComponentOptions = parentVnode.componentOptions;
  opts.propsData = vnodeComponentOptions.propsData;
  opts._parentListeners = vnodeComponentOptions.listeners;
  opts._renderChildren = vnodeComponentOptions.children;
  opts._componentTag = vnodeComponentOptions.tag;

  if (options.render) {
    opts.render = options.render;
    opts.staticRenderFns = options.staticRenderFns;
  }
}

function resolveConstructorOptions (Ctor) {
  var options = Ctor.options;
  if (Ctor.super) {
    var superOptions = resolveConstructorOptions(Ctor.super);
    var cachedSuperOptions = Ctor.superOptions;
    if (superOptions !== cachedSuperOptions) {
      // super option changed,
      // need to resolve new options.
      Ctor.superOptions = superOptions;
      // check if there are any late-modified/attached options (#4976)
      var modifiedOptions = resolveModifiedOptions(Ctor);
      // update base extend options
      if (modifiedOptions) {
        extend(Ctor.extendOptions, modifiedOptions);
      }
      options = Ctor.options = mergeOptions(superOptions, Ctor.extendOptions);
      if (options.name) {
        options.components[options.name] = Ctor;
      }
    }
  }
  return options
}

function resolveModifiedOptions (Ctor) {
  var modified;
  var latest = Ctor.options;
  var sealed = Ctor.sealedOptions;
  for (var key in latest) {
    if (latest[key] !== sealed[key]) {
      if (!modified) { modified = {}; }
      modified[key] = latest[key];
    }
  }
  return modified
}

function Vue (options) {
  if (false
  ) {
    warn('Vue is a constructor and should be called with the `new` keyword');
  }
  this._init(options);
}

initMixin(Vue);
stateMixin(Vue);
eventsMixin(Vue);
lifecycleMixin(Vue);
renderMixin(Vue);

/*  */

function initUse (Vue) {
  Vue.use = function (plugin) {
    var installedPlugins = (this._installedPlugins || (this._installedPlugins = []));
    if (installedPlugins.indexOf(plugin) > -1) {
      return this
    }

    // additional parameters
    var args = toArray(arguments, 1);
    args.unshift(this);
    if (typeof plugin.install === 'function') {
      plugin.install.apply(plugin, args);
    } else if (typeof plugin === 'function') {
      plugin.apply(null, args);
    }
    installedPlugins.push(plugin);
    return this
  };
}

/*  */

function initMixin$1 (Vue) {
  Vue.mixin = function (mixin) {
    this.options = mergeOptions(this.options, mixin);
    return this
  };
}

/*  */

function initExtend (Vue) {
  /**
   * Each instance constructor, including Vue, has a unique
   * cid. This enables us to create wrapped "child
   * constructors" for prototypal inheritance and cache them.
   */
  Vue.cid = 0;
  var cid = 1;

  /**
   * Class inheritance
   */
  Vue.extend = function (extendOptions) {
    extendOptions = extendOptions || {};
    var Super = this;
    var SuperId = Super.cid;
    var cachedCtors = extendOptions._Ctor || (extendOptions._Ctor = {});
    if (cachedCtors[SuperId]) {
      return cachedCtors[SuperId]
    }

    var name = extendOptions.name || Super.options.name;
    if (false) {
      validateComponentName(name);
    }

    var Sub = function VueComponent (options) {
      this._init(options);
    };
    Sub.prototype = Object.create(Super.prototype);
    Sub.prototype.constructor = Sub;
    Sub.cid = cid++;
    Sub.options = mergeOptions(
      Super.options,
      extendOptions
    );
    Sub['super'] = Super;

    // For props and computed properties, we define the proxy getters on
    // the Vue instances at extension time, on the extended prototype. This
    // avoids Object.defineProperty calls for each instance created.
    if (Sub.options.props) {
      initProps$1(Sub);
    }
    if (Sub.options.computed) {
      initComputed$1(Sub);
    }

    // allow further extension/mixin/plugin usage
    Sub.extend = Super.extend;
    Sub.mixin = Super.mixin;
    Sub.use = Super.use;

    // create asset registers, so extended classes
    // can have their private assets too.
    ASSET_TYPES.forEach(function (type) {
      Sub[type] = Super[type];
    });
    // enable recursive self-lookup
    if (name) {
      Sub.options.components[name] = Sub;
    }

    // keep a reference to the super options at extension time.
    // later at instantiation we can check if Super's options have
    // been updated.
    Sub.superOptions = Super.options;
    Sub.extendOptions = extendOptions;
    Sub.sealedOptions = extend({}, Sub.options);

    // cache constructor
    cachedCtors[SuperId] = Sub;
    return Sub
  };
}

function initProps$1 (Comp) {
  var props = Comp.options.props;
  for (var key in props) {
    proxy(Comp.prototype, "_props", key);
  }
}

function initComputed$1 (Comp) {
  var computed = Comp.options.computed;
  for (var key in computed) {
    defineComputed(Comp.prototype, key, computed[key]);
  }
}

/*  */

function initAssetRegisters (Vue) {
  /**
   * Create asset registration methods.
   */
  ASSET_TYPES.forEach(function (type) {
    Vue[type] = function (
      id,
      definition
    ) {
      if (!definition) {
        return this.options[type + 's'][id]
      } else {
        /* istanbul ignore if */
        if (false) {
          validateComponentName(id);
        }
        if (type === 'component' && isPlainObject(definition)) {
          definition.name = definition.name || id;
          definition = this.options._base.extend(definition);
        }
        if (type === 'directive' && typeof definition === 'function') {
          definition = { bind: definition, update: definition };
        }
        this.options[type + 's'][id] = definition;
        return definition
      }
    };
  });
}

/*  */



function getComponentName (opts) {
  return opts && (opts.Ctor.options.name || opts.tag)
}

function matches (pattern, name) {
  if (Array.isArray(pattern)) {
    return pattern.indexOf(name) > -1
  } else if (typeof pattern === 'string') {
    return pattern.split(',').indexOf(name) > -1
  } else if (isRegExp(pattern)) {
    return pattern.test(name)
  }
  /* istanbul ignore next */
  return false
}

function pruneCache (keepAliveInstance, filter) {
  var cache = keepAliveInstance.cache;
  var keys = keepAliveInstance.keys;
  var _vnode = keepAliveInstance._vnode;
  for (var key in cache) {
    var cachedNode = cache[key];
    if (cachedNode) {
      var name = getComponentName(cachedNode.componentOptions);
      if (name && !filter(name)) {
        pruneCacheEntry(cache, key, keys, _vnode);
      }
    }
  }
}

function pruneCacheEntry (
  cache,
  key,
  keys,
  current
) {
  var cached$$1 = cache[key];
  if (cached$$1 && (!current || cached$$1.tag !== current.tag)) {
    cached$$1.componentInstance.$destroy();
  }
  cache[key] = null;
  remove(keys, key);
}

var patternTypes = [String, RegExp, Array];

var KeepAlive = {
  name: 'keep-alive',
  abstract: true,

  props: {
    include: patternTypes,
    exclude: patternTypes,
    max: [String, Number]
  },

  created: function created () {
    this.cache = Object.create(null);
    this.keys = [];
  },

  destroyed: function destroyed () {
    for (var key in this.cache) {
      pruneCacheEntry(this.cache, key, this.keys);
    }
  },

  mounted: function mounted () {
    var this$1 = this;

    this.$watch('include', function (val) {
      pruneCache(this$1, function (name) { return matches(val, name); });
    });
    this.$watch('exclude', function (val) {
      pruneCache(this$1, function (name) { return !matches(val, name); });
    });
  },

  render: function render () {
    var slot = this.$slots.default;
    var vnode = getFirstComponentChild(slot);
    var componentOptions = vnode && vnode.componentOptions;
    if (componentOptions) {
      // check pattern
      var name = getComponentName(componentOptions);
      var ref = this;
      var include = ref.include;
      var exclude = ref.exclude;
      if (
        // not included
        (include && (!name || !matches(include, name))) ||
        // excluded
        (exclude && name && matches(exclude, name))
      ) {
        return vnode
      }

      var ref$1 = this;
      var cache = ref$1.cache;
      var keys = ref$1.keys;
      var key = vnode.key == null
        // same constructor may get registered as different local components
        // so cid alone is not enough (#3269)
        ? componentOptions.Ctor.cid + (componentOptions.tag ? ("::" + (componentOptions.tag)) : '')
        : vnode.key;
      if (cache[key]) {
        vnode.componentInstance = cache[key].componentInstance;
        // make current key freshest
        remove(keys, key);
        keys.push(key);
      } else {
        cache[key] = vnode;
        keys.push(key);
        // prune oldest entry
        if (this.max && keys.length > parseInt(this.max)) {
          pruneCacheEntry(cache, keys[0], keys, this._vnode);
        }
      }

      vnode.data.keepAlive = true;
    }
    return vnode || (slot && slot[0])
  }
};

var builtInComponents = {
  KeepAlive: KeepAlive
};

/*  */

function initGlobalAPI (Vue) {
  // config
  var configDef = {};
  configDef.get = function () { return config; };
  if (false) {
    configDef.set = function () {
      warn(
        'Do not replace the Vue.config object, set individual fields instead.'
      );
    };
  }
  Object.defineProperty(Vue, 'config', configDef);

  // exposed util methods.
  // NOTE: these are not considered part of the public API - avoid relying on
  // them unless you are aware of the risk.
  Vue.util = {
    warn: warn,
    extend: extend,
    mergeOptions: mergeOptions,
    defineReactive: defineReactive$$1
  };

  Vue.set = set;
  Vue.delete = del;
  Vue.nextTick = nextTick;

  // 2.6 explicit observable API
  Vue.observable = function (obj) {
    observe(obj);
    return obj
  };

  Vue.options = Object.create(null);
  ASSET_TYPES.forEach(function (type) {
    Vue.options[type + 's'] = Object.create(null);
  });

  // this is used to identify the "base" constructor to extend all plain-object
  // components with in Weex's multi-instance scenarios.
  Vue.options._base = Vue;

  extend(Vue.options.components, builtInComponents);

  initUse(Vue);
  initMixin$1(Vue);
  initExtend(Vue);
  initAssetRegisters(Vue);
}

initGlobalAPI(Vue);

Object.defineProperty(Vue.prototype, '$isServer', {
  get: isServerRendering
});

Object.defineProperty(Vue.prototype, '$ssrContext', {
  get: function get () {
    /* istanbul ignore next */
    return this.$vnode && this.$vnode.ssrContext
  }
});

// expose FunctionalRenderContext for ssr runtime helper installation
Object.defineProperty(Vue, 'FunctionalRenderContext', {
  value: FunctionalRenderContext
});

Vue.version = '2.6.12';

/*  */

// these are reserved for web because they are directly compiled away
// during template compilation
var isReservedAttr = makeMap('style,class');

// attributes that should be using props for binding
var acceptValue = makeMap('input,textarea,option,select,progress');
var mustUseProp = function (tag, type, attr) {
  return (
    (attr === 'value' && acceptValue(tag)) && type !== 'button' ||
    (attr === 'selected' && tag === 'option') ||
    (attr === 'checked' && tag === 'input') ||
    (attr === 'muted' && tag === 'video')
  )
};

var isEnumeratedAttr = makeMap('contenteditable,draggable,spellcheck');

var isValidContentEditableValue = makeMap('events,caret,typing,plaintext-only');

var convertEnumeratedValue = function (key, value) {
  return isFalsyAttrValue(value) || value === 'false'
    ? 'false'
    // allow arbitrary string value for contenteditable
    : key === 'contenteditable' && isValidContentEditableValue(value)
      ? value
      : 'true'
};

var isBooleanAttr = makeMap(
  'allowfullscreen,async,autofocus,autoplay,checked,compact,controls,declare,' +
  'default,defaultchecked,defaultmuted,defaultselected,defer,disabled,' +
  'enabled,formnovalidate,hidden,indeterminate,inert,ismap,itemscope,loop,multiple,' +
  'muted,nohref,noresize,noshade,novalidate,nowrap,open,pauseonexit,readonly,' +
  'required,reversed,scoped,seamless,selected,sortable,translate,' +
  'truespeed,typemustmatch,visible'
);

var xlinkNS = 'http://www.w3.org/1999/xlink';

var isXlink = function (name) {
  return name.charAt(5) === ':' && name.slice(0, 5) === 'xlink'
};

var getXlinkProp = function (name) {
  return isXlink(name) ? name.slice(6, name.length) : ''
};

var isFalsyAttrValue = function (val) {
  return val == null || val === false
};

/*  */

function genClassForVnode (vnode) {
  var data = vnode.data;
  var parentNode = vnode;
  var childNode = vnode;
  while (isDef(childNode.componentInstance)) {
    childNode = childNode.componentInstance._vnode;
    if (childNode && childNode.data) {
      data = mergeClassData(childNode.data, data);
    }
  }
  while (isDef(parentNode = parentNode.parent)) {
    if (parentNode && parentNode.data) {
      data = mergeClassData(data, parentNode.data);
    }
  }
  return renderClass(data.staticClass, data.class)
}

function mergeClassData (child, parent) {
  return {
    staticClass: concat(child.staticClass, parent.staticClass),
    class: isDef(child.class)
      ? [child.class, parent.class]
      : parent.class
  }
}

function renderClass (
  staticClass,
  dynamicClass
) {
  if (isDef(staticClass) || isDef(dynamicClass)) {
    return concat(staticClass, stringifyClass(dynamicClass))
  }
  /* istanbul ignore next */
  return ''
}

function concat (a, b) {
  return a ? b ? (a + ' ' + b) : a : (b || '')
}

function stringifyClass (value) {
  if (Array.isArray(value)) {
    return stringifyArray(value)
  }
  if (isObject(value)) {
    return stringifyObject(value)
  }
  if (typeof value === 'string') {
    return value
  }
  /* istanbul ignore next */
  return ''
}

function stringifyArray (value) {
  var res = '';
  var stringified;
  for (var i = 0, l = value.length; i < l; i++) {
    if (isDef(stringified = stringifyClass(value[i])) && stringified !== '') {
      if (res) { res += ' '; }
      res += stringified;
    }
  }
  return res
}

function stringifyObject (value) {
  var res = '';
  for (var key in value) {
    if (value[key]) {
      if (res) { res += ' '; }
      res += key;
    }
  }
  return res
}

/*  */

var namespaceMap = {
  svg: 'http://www.w3.org/2000/svg',
  math: 'http://www.w3.org/1998/Math/MathML'
};

var isHTMLTag = makeMap(
  'html,body,base,head,link,meta,style,title,' +
  'address,article,aside,footer,header,h1,h2,h3,h4,h5,h6,hgroup,nav,section,' +
  'div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,' +
  'a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,rtc,ruby,' +
  's,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,' +
  'embed,object,param,source,canvas,script,noscript,del,ins,' +
  'caption,col,colgroup,table,thead,tbody,td,th,tr,' +
  'button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,' +
  'output,progress,select,textarea,' +
  'details,dialog,menu,menuitem,summary,' +
  'content,element,shadow,template,blockquote,iframe,tfoot'
);

// this map is intentionally selective, only covering SVG elements that may
// contain child elements.
var isSVG = makeMap(
  'svg,animate,circle,clippath,cursor,defs,desc,ellipse,filter,font-face,' +
  'foreignObject,g,glyph,image,line,marker,mask,missing-glyph,path,pattern,' +
  'polygon,polyline,rect,switch,symbol,text,textpath,tspan,use,view',
  true
);

var isPreTag = function (tag) { return tag === 'pre'; };

var isReservedTag = function (tag) {
  return isHTMLTag(tag) || isSVG(tag)
};

function getTagNamespace (tag) {
  if (isSVG(tag)) {
    return 'svg'
  }
  // basic support for MathML
  // note it doesn't support other MathML elements being component roots
  if (tag === 'math') {
    return 'math'
  }
}

var unknownElementCache = Object.create(null);
function isUnknownElement (tag) {
  /* istanbul ignore if */
  if (!inBrowser) {
    return true
  }
  if (isReservedTag(tag)) {
    return false
  }
  tag = tag.toLowerCase();
  /* istanbul ignore if */
  if (unknownElementCache[tag] != null) {
    return unknownElementCache[tag]
  }
  var el = document.createElement(tag);
  if (tag.indexOf('-') > -1) {
    // http://stackoverflow.com/a/28210364/1070244
    return (unknownElementCache[tag] = (
      el.constructor === window.HTMLUnknownElement ||
      el.constructor === window.HTMLElement
    ))
  } else {
    return (unknownElementCache[tag] = /HTMLUnknownElement/.test(el.toString()))
  }
}

var isTextInputType = makeMap('text,number,password,search,email,tel,url');

/*  */

/**
 * Query an element selector if it's not an element already.
 */
function query (el) {
  if (typeof el === 'string') {
    var selected = document.querySelector(el);
    if (!selected) {
      "production" !== 'production' && warn(
        'Cannot find element: ' + el
      );
      return document.createElement('div')
    }
    return selected
  } else {
    return el
  }
}

/*  */

function createElement$1 (tagName, vnode) {
  var elm = document.createElement(tagName);
  if (tagName !== 'select') {
    return elm
  }
  // false or null will remove the attribute but undefined will not
  if (vnode.data && vnode.data.attrs && vnode.data.attrs.multiple !== undefined) {
    elm.setAttribute('multiple', 'multiple');
  }
  return elm
}

function createElementNS (namespace, tagName) {
  return document.createElementNS(namespaceMap[namespace], tagName)
}

function createTextNode (text) {
  return document.createTextNode(text)
}

function createComment (text) {
  return document.createComment(text)
}

function insertBefore (parentNode, newNode, referenceNode) {
  parentNode.insertBefore(newNode, referenceNode);
}

function removeChild (node, child) {
  node.removeChild(child);
}

function appendChild (node, child) {
  node.appendChild(child);
}

function parentNode (node) {
  return node.parentNode
}

function nextSibling (node) {
  return node.nextSibling
}

function tagName (node) {
  return node.tagName
}

function setTextContent (node, text) {
  node.textContent = text;
}

function setStyleScope (node, scopeId) {
  node.setAttribute(scopeId, '');
}

var nodeOps = /*#__PURE__*/Object.freeze({
  createElement: createElement$1,
  createElementNS: createElementNS,
  createTextNode: createTextNode,
  createComment: createComment,
  insertBefore: insertBefore,
  removeChild: removeChild,
  appendChild: appendChild,
  parentNode: parentNode,
  nextSibling: nextSibling,
  tagName: tagName,
  setTextContent: setTextContent,
  setStyleScope: setStyleScope
});

/*  */

var ref = {
  create: function create (_, vnode) {
    registerRef(vnode);
  },
  update: function update (oldVnode, vnode) {
    if (oldVnode.data.ref !== vnode.data.ref) {
      registerRef(oldVnode, true);
      registerRef(vnode);
    }
  },
  destroy: function destroy (vnode) {
    registerRef(vnode, true);
  }
};

function registerRef (vnode, isRemoval) {
  var key = vnode.data.ref;
  if (!isDef(key)) { return }

  var vm = vnode.context;
  var ref = vnode.componentInstance || vnode.elm;
  var refs = vm.$refs;
  if (isRemoval) {
    if (Array.isArray(refs[key])) {
      remove(refs[key], ref);
    } else if (refs[key] === ref) {
      refs[key] = undefined;
    }
  } else {
    if (vnode.data.refInFor) {
      if (!Array.isArray(refs[key])) {
        refs[key] = [ref];
      } else if (refs[key].indexOf(ref) < 0) {
        // $flow-disable-line
        refs[key].push(ref);
      }
    } else {
      refs[key] = ref;
    }
  }
}

/**
 * Virtual DOM patching algorithm based on Snabbdom by
 * Simon Friis Vindum (@paldepind)
 * Licensed under the MIT License
 * https://github.com/paldepind/snabbdom/blob/master/LICENSE
 *
 * modified by Evan You (@yyx990803)
 *
 * Not type-checking this because this file is perf-critical and the cost
 * of making flow understand it is not worth it.
 */

var emptyNode = new VNode('', {}, []);

var hooks = ['create', 'activate', 'update', 'remove', 'destroy'];

function sameVnode (a, b) {
  return (
    a.key === b.key && (
      (
        a.tag === b.tag &&
        a.isComment === b.isComment &&
        isDef(a.data) === isDef(b.data) &&
        sameInputType(a, b)
      ) || (
        isTrue(a.isAsyncPlaceholder) &&
        a.asyncFactory === b.asyncFactory &&
        isUndef(b.asyncFactory.error)
      )
    )
  )
}

function sameInputType (a, b) {
  if (a.tag !== 'input') { return true }
  var i;
  var typeA = isDef(i = a.data) && isDef(i = i.attrs) && i.type;
  var typeB = isDef(i = b.data) && isDef(i = i.attrs) && i.type;
  return typeA === typeB || isTextInputType(typeA) && isTextInputType(typeB)
}

function createKeyToOldIdx (children, beginIdx, endIdx) {
  var i, key;
  var map = {};
  for (i = beginIdx; i <= endIdx; ++i) {
    key = children[i].key;
    if (isDef(key)) { map[key] = i; }
  }
  return map
}

function createPatchFunction (backend) {
  var i, j;
  var cbs = {};

  var modules = backend.modules;
  var nodeOps = backend.nodeOps;

  for (i = 0; i < hooks.length; ++i) {
    cbs[hooks[i]] = [];
    for (j = 0; j < modules.length; ++j) {
      if (isDef(modules[j][hooks[i]])) {
        cbs[hooks[i]].push(modules[j][hooks[i]]);
      }
    }
  }

  function emptyNodeAt (elm) {
    return new VNode(nodeOps.tagName(elm).toLowerCase(), {}, [], undefined, elm)
  }

  function createRmCb (childElm, listeners) {
    function remove$$1 () {
      if (--remove$$1.listeners === 0) {
        removeNode(childElm);
      }
    }
    remove$$1.listeners = listeners;
    return remove$$1
  }

  function removeNode (el) {
    var parent = nodeOps.parentNode(el);
    // element may have already been removed due to v-html / v-text
    if (isDef(parent)) {
      nodeOps.removeChild(parent, el);
    }
  }

  function isUnknownElement$$1 (vnode, inVPre) {
    return (
      !inVPre &&
      !vnode.ns &&
      !(
        config.ignoredElements.length &&
        config.ignoredElements.some(function (ignore) {
          return isRegExp(ignore)
            ? ignore.test(vnode.tag)
            : ignore === vnode.tag
        })
      ) &&
      config.isUnknownElement(vnode.tag)
    )
  }

  var creatingElmInVPre = 0;

  function createElm (
    vnode,
    insertedVnodeQueue,
    parentElm,
    refElm,
    nested,
    ownerArray,
    index
  ) {
    if (isDef(vnode.elm) && isDef(ownerArray)) {
      // This vnode was used in a previous render!
      // now it's used as a new node, overwriting its elm would cause
      // potential patch errors down the road when it's used as an insertion
      // reference node. Instead, we clone the node on-demand before creating
      // associated DOM element for it.
      vnode = ownerArray[index] = cloneVNode(vnode);
    }

    vnode.isRootInsert = !nested; // for transition enter check
    if (createComponent(vnode, insertedVnodeQueue, parentElm, refElm)) {
      return
    }

    var data = vnode.data;
    var children = vnode.children;
    var tag = vnode.tag;
    if (isDef(tag)) {
      if (false) {
        if (data && data.pre) {
          creatingElmInVPre++;
        }
        if (isUnknownElement$$1(vnode, creatingElmInVPre)) {
          warn(
            'Unknown custom element: <' + tag + '> - did you ' +
            'register the component correctly? For recursive components, ' +
            'make sure to provide the "name" option.',
            vnode.context
          );
        }
      }

      vnode.elm = vnode.ns
        ? nodeOps.createElementNS(vnode.ns, tag)
        : nodeOps.createElement(tag, vnode);
      setScope(vnode);

      /* istanbul ignore if */
      {
        createChildren(vnode, children, insertedVnodeQueue);
        if (isDef(data)) {
          invokeCreateHooks(vnode, insertedVnodeQueue);
        }
        insert(parentElm, vnode.elm, refElm);
      }

      if (false) {
        creatingElmInVPre--;
      }
    } else if (isTrue(vnode.isComment)) {
      vnode.elm = nodeOps.createComment(vnode.text);
      insert(parentElm, vnode.elm, refElm);
    } else {
      vnode.elm = nodeOps.createTextNode(vnode.text);
      insert(parentElm, vnode.elm, refElm);
    }
  }

  function createComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
    var i = vnode.data;
    if (isDef(i)) {
      var isReactivated = isDef(vnode.componentInstance) && i.keepAlive;
      if (isDef(i = i.hook) && isDef(i = i.init)) {
        i(vnode, false /* hydrating */);
      }
      // after calling the init hook, if the vnode is a child component
      // it should've created a child instance and mounted it. the child
      // component also has set the placeholder vnode's elm.
      // in that case we can just return the element and be done.
      if (isDef(vnode.componentInstance)) {
        initComponent(vnode, insertedVnodeQueue);
        insert(parentElm, vnode.elm, refElm);
        if (isTrue(isReactivated)) {
          reactivateComponent(vnode, insertedVnodeQueue, parentElm, refElm);
        }
        return true
      }
    }
  }

  function initComponent (vnode, insertedVnodeQueue) {
    if (isDef(vnode.data.pendingInsert)) {
      insertedVnodeQueue.push.apply(insertedVnodeQueue, vnode.data.pendingInsert);
      vnode.data.pendingInsert = null;
    }
    vnode.elm = vnode.componentInstance.$el;
    if (isPatchable(vnode)) {
      invokeCreateHooks(vnode, insertedVnodeQueue);
      setScope(vnode);
    } else {
      // empty component root.
      // skip all element-related modules except for ref (#3455)
      registerRef(vnode);
      // make sure to invoke the insert hook
      insertedVnodeQueue.push(vnode);
    }
  }

  function reactivateComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
    var i;
    // hack for #4339: a reactivated component with inner transition
    // does not trigger because the inner node's created hooks are not called
    // again. It's not ideal to involve module-specific logic in here but
    // there doesn't seem to be a better way to do it.
    var innerNode = vnode;
    while (innerNode.componentInstance) {
      innerNode = innerNode.componentInstance._vnode;
      if (isDef(i = innerNode.data) && isDef(i = i.transition)) {
        for (i = 0; i < cbs.activate.length; ++i) {
          cbs.activate[i](emptyNode, innerNode);
        }
        insertedVnodeQueue.push(innerNode);
        break
      }
    }
    // unlike a newly created component,
    // a reactivated keep-alive component doesn't insert itself
    insert(parentElm, vnode.elm, refElm);
  }

  function insert (parent, elm, ref$$1) {
    if (isDef(parent)) {
      if (isDef(ref$$1)) {
        if (nodeOps.parentNode(ref$$1) === parent) {
          nodeOps.insertBefore(parent, elm, ref$$1);
        }
      } else {
        nodeOps.appendChild(parent, elm);
      }
    }
  }

  function createChildren (vnode, children, insertedVnodeQueue) {
    if (Array.isArray(children)) {
      if (false) {
        checkDuplicateKeys(children);
      }
      for (var i = 0; i < children.length; ++i) {
        createElm(children[i], insertedVnodeQueue, vnode.elm, null, true, children, i);
      }
    } else if (isPrimitive(vnode.text)) {
      nodeOps.appendChild(vnode.elm, nodeOps.createTextNode(String(vnode.text)));
    }
  }

  function isPatchable (vnode) {
    while (vnode.componentInstance) {
      vnode = vnode.componentInstance._vnode;
    }
    return isDef(vnode.tag)
  }

  function invokeCreateHooks (vnode, insertedVnodeQueue) {
    for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
      cbs.create[i$1](emptyNode, vnode);
    }
    i = vnode.data.hook; // Reuse variable
    if (isDef(i)) {
      if (isDef(i.create)) { i.create(emptyNode, vnode); }
      if (isDef(i.insert)) { insertedVnodeQueue.push(vnode); }
    }
  }

  // set scope id attribute for scoped CSS.
  // this is implemented as a special case to avoid the overhead
  // of going through the normal attribute patching process.
  function setScope (vnode) {
    var i;
    if (isDef(i = vnode.fnScopeId)) {
      nodeOps.setStyleScope(vnode.elm, i);
    } else {
      var ancestor = vnode;
      while (ancestor) {
        if (isDef(i = ancestor.context) && isDef(i = i.$options._scopeId)) {
          nodeOps.setStyleScope(vnode.elm, i);
        }
        ancestor = ancestor.parent;
      }
    }
    // for slot content they should also get the scopeId from the host instance.
    if (isDef(i = activeInstance) &&
      i !== vnode.context &&
      i !== vnode.fnContext &&
      isDef(i = i.$options._scopeId)
    ) {
      nodeOps.setStyleScope(vnode.elm, i);
    }
  }

  function addVnodes (parentElm, refElm, vnodes, startIdx, endIdx, insertedVnodeQueue) {
    for (; startIdx <= endIdx; ++startIdx) {
      createElm(vnodes[startIdx], insertedVnodeQueue, parentElm, refElm, false, vnodes, startIdx);
    }
  }

  function invokeDestroyHook (vnode) {
    var i, j;
    var data = vnode.data;
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.destroy)) { i(vnode); }
      for (i = 0; i < cbs.destroy.length; ++i) { cbs.destroy[i](vnode); }
    }
    if (isDef(i = vnode.children)) {
      for (j = 0; j < vnode.children.length; ++j) {
        invokeDestroyHook(vnode.children[j]);
      }
    }
  }

  function removeVnodes (vnodes, startIdx, endIdx) {
    for (; startIdx <= endIdx; ++startIdx) {
      var ch = vnodes[startIdx];
      if (isDef(ch)) {
        if (isDef(ch.tag)) {
          removeAndInvokeRemoveHook(ch);
          invokeDestroyHook(ch);
        } else { // Text node
          removeNode(ch.elm);
        }
      }
    }
  }

  function removeAndInvokeRemoveHook (vnode, rm) {
    if (isDef(rm) || isDef(vnode.data)) {
      var i;
      var listeners = cbs.remove.length + 1;
      if (isDef(rm)) {
        // we have a recursively passed down rm callback
        // increase the listeners count
        rm.listeners += listeners;
      } else {
        // directly removing
        rm = createRmCb(vnode.elm, listeners);
      }
      // recursively invoke hooks on child component root node
      if (isDef(i = vnode.componentInstance) && isDef(i = i._vnode) && isDef(i.data)) {
        removeAndInvokeRemoveHook(i, rm);
      }
      for (i = 0; i < cbs.remove.length; ++i) {
        cbs.remove[i](vnode, rm);
      }
      if (isDef(i = vnode.data.hook) && isDef(i = i.remove)) {
        i(vnode, rm);
      } else {
        rm();
      }
    } else {
      removeNode(vnode.elm);
    }
  }

  function updateChildren (parentElm, oldCh, newCh, insertedVnodeQueue, removeOnly) {
    var oldStartIdx = 0;
    var newStartIdx = 0;
    var oldEndIdx = oldCh.length - 1;
    var oldStartVnode = oldCh[0];
    var oldEndVnode = oldCh[oldEndIdx];
    var newEndIdx = newCh.length - 1;
    var newStartVnode = newCh[0];
    var newEndVnode = newCh[newEndIdx];
    var oldKeyToIdx, idxInOld, vnodeToMove, refElm;

    // removeOnly is a special flag used only by <transition-group>
    // to ensure removed elements stay in correct relative positions
    // during leaving transitions
    var canMove = !removeOnly;

    if (false) {
      checkDuplicateKeys(newCh);
    }

    while (oldStartIdx <= oldEndIdx && newStartIdx <= newEndIdx) {
      if (isUndef(oldStartVnode)) {
        oldStartVnode = oldCh[++oldStartIdx]; // Vnode has been moved left
      } else if (isUndef(oldEndVnode)) {
        oldEndVnode = oldCh[--oldEndIdx];
      } else if (sameVnode(oldStartVnode, newStartVnode)) {
        patchVnode(oldStartVnode, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
        oldStartVnode = oldCh[++oldStartIdx];
        newStartVnode = newCh[++newStartIdx];
      } else if (sameVnode(oldEndVnode, newEndVnode)) {
        patchVnode(oldEndVnode, newEndVnode, insertedVnodeQueue, newCh, newEndIdx);
        oldEndVnode = oldCh[--oldEndIdx];
        newEndVnode = newCh[--newEndIdx];
      } else if (sameVnode(oldStartVnode, newEndVnode)) { // Vnode moved right
        patchVnode(oldStartVnode, newEndVnode, insertedVnodeQueue, newCh, newEndIdx);
        canMove && nodeOps.insertBefore(parentElm, oldStartVnode.elm, nodeOps.nextSibling(oldEndVnode.elm));
        oldStartVnode = oldCh[++oldStartIdx];
        newEndVnode = newCh[--newEndIdx];
      } else if (sameVnode(oldEndVnode, newStartVnode)) { // Vnode moved left
        patchVnode(oldEndVnode, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
        canMove && nodeOps.insertBefore(parentElm, oldEndVnode.elm, oldStartVnode.elm);
        oldEndVnode = oldCh[--oldEndIdx];
        newStartVnode = newCh[++newStartIdx];
      } else {
        if (isUndef(oldKeyToIdx)) { oldKeyToIdx = createKeyToOldIdx(oldCh, oldStartIdx, oldEndIdx); }
        idxInOld = isDef(newStartVnode.key)
          ? oldKeyToIdx[newStartVnode.key]
          : findIdxInOld(newStartVnode, oldCh, oldStartIdx, oldEndIdx);
        if (isUndef(idxInOld)) { // New element
          createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
        } else {
          vnodeToMove = oldCh[idxInOld];
          if (sameVnode(vnodeToMove, newStartVnode)) {
            patchVnode(vnodeToMove, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
            oldCh[idxInOld] = undefined;
            canMove && nodeOps.insertBefore(parentElm, vnodeToMove.elm, oldStartVnode.elm);
          } else {
            // same key but different element. treat as new element
            createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
          }
        }
        newStartVnode = newCh[++newStartIdx];
      }
    }
    if (oldStartIdx > oldEndIdx) {
      refElm = isUndef(newCh[newEndIdx + 1]) ? null : newCh[newEndIdx + 1].elm;
      addVnodes(parentElm, refElm, newCh, newStartIdx, newEndIdx, insertedVnodeQueue);
    } else if (newStartIdx > newEndIdx) {
      removeVnodes(oldCh, oldStartIdx, oldEndIdx);
    }
  }

  function checkDuplicateKeys (children) {
    var seenKeys = {};
    for (var i = 0; i < children.length; i++) {
      var vnode = children[i];
      var key = vnode.key;
      if (isDef(key)) {
        if (seenKeys[key]) {
          warn(
            ("Duplicate keys detected: '" + key + "'. This may cause an update error."),
            vnode.context
          );
        } else {
          seenKeys[key] = true;
        }
      }
    }
  }

  function findIdxInOld (node, oldCh, start, end) {
    for (var i = start; i < end; i++) {
      var c = oldCh[i];
      if (isDef(c) && sameVnode(node, c)) { return i }
    }
  }

  function patchVnode (
    oldVnode,
    vnode,
    insertedVnodeQueue,
    ownerArray,
    index,
    removeOnly
  ) {
    if (oldVnode === vnode) {
      return
    }

    if (isDef(vnode.elm) && isDef(ownerArray)) {
      // clone reused vnode
      vnode = ownerArray[index] = cloneVNode(vnode);
    }

    var elm = vnode.elm = oldVnode.elm;

    if (isTrue(oldVnode.isAsyncPlaceholder)) {
      if (isDef(vnode.asyncFactory.resolved)) {
        hydrate(oldVnode.elm, vnode, insertedVnodeQueue);
      } else {
        vnode.isAsyncPlaceholder = true;
      }
      return
    }

    // reuse element for static trees.
    // note we only do this if the vnode is cloned -
    // if the new node is not cloned it means the render functions have been
    // reset by the hot-reload-api and we need to do a proper re-render.
    if (isTrue(vnode.isStatic) &&
      isTrue(oldVnode.isStatic) &&
      vnode.key === oldVnode.key &&
      (isTrue(vnode.isCloned) || isTrue(vnode.isOnce))
    ) {
      vnode.componentInstance = oldVnode.componentInstance;
      return
    }

    var i;
    var data = vnode.data;
    if (isDef(data) && isDef(i = data.hook) && isDef(i = i.prepatch)) {
      i(oldVnode, vnode);
    }

    var oldCh = oldVnode.children;
    var ch = vnode.children;
    if (isDef(data) && isPatchable(vnode)) {
      for (i = 0; i < cbs.update.length; ++i) { cbs.update[i](oldVnode, vnode); }
      if (isDef(i = data.hook) && isDef(i = i.update)) { i(oldVnode, vnode); }
    }
    if (isUndef(vnode.text)) {
      if (isDef(oldCh) && isDef(ch)) {
        if (oldCh !== ch) { updateChildren(elm, oldCh, ch, insertedVnodeQueue, removeOnly); }
      } else if (isDef(ch)) {
        if (false) {
          checkDuplicateKeys(ch);
        }
        if (isDef(oldVnode.text)) { nodeOps.setTextContent(elm, ''); }
        addVnodes(elm, null, ch, 0, ch.length - 1, insertedVnodeQueue);
      } else if (isDef(oldCh)) {
        removeVnodes(oldCh, 0, oldCh.length - 1);
      } else if (isDef(oldVnode.text)) {
        nodeOps.setTextContent(elm, '');
      }
    } else if (oldVnode.text !== vnode.text) {
      nodeOps.setTextContent(elm, vnode.text);
    }
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.postpatch)) { i(oldVnode, vnode); }
    }
  }

  function invokeInsertHook (vnode, queue, initial) {
    // delay insert hooks for component root nodes, invoke them after the
    // element is really inserted
    if (isTrue(initial) && isDef(vnode.parent)) {
      vnode.parent.data.pendingInsert = queue;
    } else {
      for (var i = 0; i < queue.length; ++i) {
        queue[i].data.hook.insert(queue[i]);
      }
    }
  }

  var hydrationBailed = false;
  // list of modules that can skip create hook during hydration because they
  // are already rendered on the client or has no need for initialization
  // Note: style is excluded because it relies on initial clone for future
  // deep updates (#7063).
  var isRenderedModule = makeMap('attrs,class,staticClass,staticStyle,key');

  // Note: this is a browser-only function so we can assume elms are DOM nodes.
  function hydrate (elm, vnode, insertedVnodeQueue, inVPre) {
    var i;
    var tag = vnode.tag;
    var data = vnode.data;
    var children = vnode.children;
    inVPre = inVPre || (data && data.pre);
    vnode.elm = elm;

    if (isTrue(vnode.isComment) && isDef(vnode.asyncFactory)) {
      vnode.isAsyncPlaceholder = true;
      return true
    }
    // assert node match
    if (false) {
      if (!assertNodeMatch(elm, vnode, inVPre)) {
        return false
      }
    }
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.init)) { i(vnode, true /* hydrating */); }
      if (isDef(i = vnode.componentInstance)) {
        // child component. it should have hydrated its own tree.
        initComponent(vnode, insertedVnodeQueue);
        return true
      }
    }
    if (isDef(tag)) {
      if (isDef(children)) {
        // empty element, allow client to pick up and populate children
        if (!elm.hasChildNodes()) {
          createChildren(vnode, children, insertedVnodeQueue);
        } else {
          // v-html and domProps: innerHTML
          if (isDef(i = data) && isDef(i = i.domProps) && isDef(i = i.innerHTML)) {
            if (i !== elm.innerHTML) {
              /* istanbul ignore if */
              if (false
              ) {
                hydrationBailed = true;
                console.warn('Parent: ', elm);
                console.warn('server innerHTML: ', i);
                console.warn('client innerHTML: ', elm.innerHTML);
              }
              return false
            }
          } else {
            // iterate and compare children lists
            var childrenMatch = true;
            var childNode = elm.firstChild;
            for (var i$1 = 0; i$1 < children.length; i$1++) {
              if (!childNode || !hydrate(childNode, children[i$1], insertedVnodeQueue, inVPre)) {
                childrenMatch = false;
                break
              }
              childNode = childNode.nextSibling;
            }
            // if childNode is not null, it means the actual childNodes list is
            // longer than the virtual children list.
            if (!childrenMatch || childNode) {
              /* istanbul ignore if */
              if (false
              ) {
                hydrationBailed = true;
                console.warn('Parent: ', elm);
                console.warn('Mismatching childNodes vs. VNodes: ', elm.childNodes, children);
              }
              return false
            }
          }
        }
      }
      if (isDef(data)) {
        var fullInvoke = false;
        for (var key in data) {
          if (!isRenderedModule(key)) {
            fullInvoke = true;
            invokeCreateHooks(vnode, insertedVnodeQueue);
            break
          }
        }
        if (!fullInvoke && data['class']) {
          // ensure collecting deps for deep class bindings for future updates
          traverse(data['class']);
        }
      }
    } else if (elm.data !== vnode.text) {
      elm.data = vnode.text;
    }
    return true
  }

  function assertNodeMatch (node, vnode, inVPre) {
    if (isDef(vnode.tag)) {
      return vnode.tag.indexOf('vue-component') === 0 || (
        !isUnknownElement$$1(vnode, inVPre) &&
        vnode.tag.toLowerCase() === (node.tagName && node.tagName.toLowerCase())
      )
    } else {
      return node.nodeType === (vnode.isComment ? 8 : 3)
    }
  }

  return function patch (oldVnode, vnode, hydrating, removeOnly) {
    if (isUndef(vnode)) {
      if (isDef(oldVnode)) { invokeDestroyHook(oldVnode); }
      return
    }

    var isInitialPatch = false;
    var insertedVnodeQueue = [];

    if (isUndef(oldVnode)) {
      // empty mount (likely as component), create new root element
      isInitialPatch = true;
      createElm(vnode, insertedVnodeQueue);
    } else {
      var isRealElement = isDef(oldVnode.nodeType);
      if (!isRealElement && sameVnode(oldVnode, vnode)) {
        // patch existing root node
        patchVnode(oldVnode, vnode, insertedVnodeQueue, null, null, removeOnly);
      } else {
        if (isRealElement) {
          // mounting to a real element
          // check if this is server-rendered content and if we can perform
          // a successful hydration.
          if (oldVnode.nodeType === 1 && oldVnode.hasAttribute(SSR_ATTR)) {
            oldVnode.removeAttribute(SSR_ATTR);
            hydrating = true;
          }
          if (isTrue(hydrating)) {
            if (hydrate(oldVnode, vnode, insertedVnodeQueue)) {
              invokeInsertHook(vnode, insertedVnodeQueue, true);
              return oldVnode
            } else if (false) {
              warn(
                'The client-side rendered virtual DOM tree is not matching ' +
                'server-rendered content. This is likely caused by incorrect ' +
                'HTML markup, for example nesting block-level elements inside ' +
                '<p>, or missing <tbody>. Bailing hydration and performing ' +
                'full client-side render.'
              );
            }
          }
          // either not server-rendered, or hydration failed.
          // create an empty node and replace it
          oldVnode = emptyNodeAt(oldVnode);
        }

        // replacing existing element
        var oldElm = oldVnode.elm;
        var parentElm = nodeOps.parentNode(oldElm);

        // create new node
        createElm(
          vnode,
          insertedVnodeQueue,
          // extremely rare edge case: do not insert if old element is in a
          // leaving transition. Only happens when combining transition +
          // keep-alive + HOCs. (#4590)
          oldElm._leaveCb ? null : parentElm,
          nodeOps.nextSibling(oldElm)
        );

        // update parent placeholder node element, recursively
        if (isDef(vnode.parent)) {
          var ancestor = vnode.parent;
          var patchable = isPatchable(vnode);
          while (ancestor) {
            for (var i = 0; i < cbs.destroy.length; ++i) {
              cbs.destroy[i](ancestor);
            }
            ancestor.elm = vnode.elm;
            if (patchable) {
              for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
                cbs.create[i$1](emptyNode, ancestor);
              }
              // #6513
              // invoke insert hooks that may have been merged by create hooks.
              // e.g. for directives that uses the "inserted" hook.
              var insert = ancestor.data.hook.insert;
              if (insert.merged) {
                // start at index 1 to avoid re-invoking component mounted hook
                for (var i$2 = 1; i$2 < insert.fns.length; i$2++) {
                  insert.fns[i$2]();
                }
              }
            } else {
              registerRef(ancestor);
            }
            ancestor = ancestor.parent;
          }
        }

        // destroy old node
        if (isDef(parentElm)) {
          removeVnodes([oldVnode], 0, 0);
        } else if (isDef(oldVnode.tag)) {
          invokeDestroyHook(oldVnode);
        }
      }
    }

    invokeInsertHook(vnode, insertedVnodeQueue, isInitialPatch);
    return vnode.elm
  }
}

/*  */

var directives = {
  create: updateDirectives,
  update: updateDirectives,
  destroy: function unbindDirectives (vnode) {
    updateDirectives(vnode, emptyNode);
  }
};

function updateDirectives (oldVnode, vnode) {
  if (oldVnode.data.directives || vnode.data.directives) {
    _update(oldVnode, vnode);
  }
}

function _update (oldVnode, vnode) {
  var isCreate = oldVnode === emptyNode;
  var isDestroy = vnode === emptyNode;
  var oldDirs = normalizeDirectives$1(oldVnode.data.directives, oldVnode.context);
  var newDirs = normalizeDirectives$1(vnode.data.directives, vnode.context);

  var dirsWithInsert = [];
  var dirsWithPostpatch = [];

  var key, oldDir, dir;
  for (key in newDirs) {
    oldDir = oldDirs[key];
    dir = newDirs[key];
    if (!oldDir) {
      // new directive, bind
      callHook$1(dir, 'bind', vnode, oldVnode);
      if (dir.def && dir.def.inserted) {
        dirsWithInsert.push(dir);
      }
    } else {
      // existing directive, update
      dir.oldValue = oldDir.value;
      dir.oldArg = oldDir.arg;
      callHook$1(dir, 'update', vnode, oldVnode);
      if (dir.def && dir.def.componentUpdated) {
        dirsWithPostpatch.push(dir);
      }
    }
  }

  if (dirsWithInsert.length) {
    var callInsert = function () {
      for (var i = 0; i < dirsWithInsert.length; i++) {
        callHook$1(dirsWithInsert[i], 'inserted', vnode, oldVnode);
      }
    };
    if (isCreate) {
      mergeVNodeHook(vnode, 'insert', callInsert);
    } else {
      callInsert();
    }
  }

  if (dirsWithPostpatch.length) {
    mergeVNodeHook(vnode, 'postpatch', function () {
      for (var i = 0; i < dirsWithPostpatch.length; i++) {
        callHook$1(dirsWithPostpatch[i], 'componentUpdated', vnode, oldVnode);
      }
    });
  }

  if (!isCreate) {
    for (key in oldDirs) {
      if (!newDirs[key]) {
        // no longer present, unbind
        callHook$1(oldDirs[key], 'unbind', oldVnode, oldVnode, isDestroy);
      }
    }
  }
}

var emptyModifiers = Object.create(null);

function normalizeDirectives$1 (
  dirs,
  vm
) {
  var res = Object.create(null);
  if (!dirs) {
    // $flow-disable-line
    return res
  }
  var i, dir;
  for (i = 0; i < dirs.length; i++) {
    dir = dirs[i];
    if (!dir.modifiers) {
      // $flow-disable-line
      dir.modifiers = emptyModifiers;
    }
    res[getRawDirName(dir)] = dir;
    dir.def = resolveAsset(vm.$options, 'directives', dir.name, true);
  }
  // $flow-disable-line
  return res
}

function getRawDirName (dir) {
  return dir.rawName || ((dir.name) + "." + (Object.keys(dir.modifiers || {}).join('.')))
}

function callHook$1 (dir, hook, vnode, oldVnode, isDestroy) {
  var fn = dir.def && dir.def[hook];
  if (fn) {
    try {
      fn(vnode.elm, dir, vnode, oldVnode, isDestroy);
    } catch (e) {
      handleError(e, vnode.context, ("directive " + (dir.name) + " " + hook + " hook"));
    }
  }
}

var baseModules = [
  ref,
  directives
];

/*  */

function updateAttrs (oldVnode, vnode) {
  var opts = vnode.componentOptions;
  if (isDef(opts) && opts.Ctor.options.inheritAttrs === false) {
    return
  }
  if (isUndef(oldVnode.data.attrs) && isUndef(vnode.data.attrs)) {
    return
  }
  var key, cur, old;
  var elm = vnode.elm;
  var oldAttrs = oldVnode.data.attrs || {};
  var attrs = vnode.data.attrs || {};
  // clone observed objects, as the user probably wants to mutate it
  if (isDef(attrs.__ob__)) {
    attrs = vnode.data.attrs = extend({}, attrs);
  }

  for (key in attrs) {
    cur = attrs[key];
    old = oldAttrs[key];
    if (old !== cur) {
      setAttr(elm, key, cur);
    }
  }
  // #4391: in IE9, setting type can reset value for input[type=radio]
  // #6666: IE/Edge forces progress value down to 1 before setting a max
  /* istanbul ignore if */
  if ((isIE || isEdge) && attrs.value !== oldAttrs.value) {
    setAttr(elm, 'value', attrs.value);
  }
  for (key in oldAttrs) {
    if (isUndef(attrs[key])) {
      if (isXlink(key)) {
        elm.removeAttributeNS(xlinkNS, getXlinkProp(key));
      } else if (!isEnumeratedAttr(key)) {
        elm.removeAttribute(key);
      }
    }
  }
}

function setAttr (el, key, value) {
  if (el.tagName.indexOf('-') > -1) {
    baseSetAttr(el, key, value);
  } else if (isBooleanAttr(key)) {
    // set attribute for blank value
    // e.g. <option disabled>Select one</option>
    if (isFalsyAttrValue(value)) {
      el.removeAttribute(key);
    } else {
      // technically allowfullscreen is a boolean attribute for <iframe>,
      // but Flash expects a value of "true" when used on <embed> tag
      value = key === 'allowfullscreen' && el.tagName === 'EMBED'
        ? 'true'
        : key;
      el.setAttribute(key, value);
    }
  } else if (isEnumeratedAttr(key)) {
    el.setAttribute(key, convertEnumeratedValue(key, value));
  } else if (isXlink(key)) {
    if (isFalsyAttrValue(value)) {
      el.removeAttributeNS(xlinkNS, getXlinkProp(key));
    } else {
      el.setAttributeNS(xlinkNS, key, value);
    }
  } else {
    baseSetAttr(el, key, value);
  }
}

function baseSetAttr (el, key, value) {
  if (isFalsyAttrValue(value)) {
    el.removeAttribute(key);
  } else {
    // #7138: IE10 & 11 fires input event when setting placeholder on
    // <textarea>... block the first input event and remove the blocker
    // immediately.
    /* istanbul ignore if */
    if (
      isIE && !isIE9 &&
      el.tagName === 'TEXTAREA' &&
      key === 'placeholder' && value !== '' && !el.__ieph
    ) {
      var blocker = function (e) {
        e.stopImmediatePropagation();
        el.removeEventListener('input', blocker);
      };
      el.addEventListener('input', blocker);
      // $flow-disable-line
      el.__ieph = true; /* IE placeholder patched */
    }
    el.setAttribute(key, value);
  }
}

var attrs = {
  create: updateAttrs,
  update: updateAttrs
};

/*  */

function updateClass (oldVnode, vnode) {
  var el = vnode.elm;
  var data = vnode.data;
  var oldData = oldVnode.data;
  if (
    isUndef(data.staticClass) &&
    isUndef(data.class) && (
      isUndef(oldData) || (
        isUndef(oldData.staticClass) &&
        isUndef(oldData.class)
      )
    )
  ) {
    return
  }

  var cls = genClassForVnode(vnode);

  // handle transition classes
  var transitionClass = el._transitionClasses;
  if (isDef(transitionClass)) {
    cls = concat(cls, stringifyClass(transitionClass));
  }

  // set the class
  if (cls !== el._prevClass) {
    el.setAttribute('class', cls);
    el._prevClass = cls;
  }
}

var klass = {
  create: updateClass,
  update: updateClass
};

/*  */

var validDivisionCharRE = /[\w).+\-_$\]]/;

function parseFilters (exp) {
  var inSingle = false;
  var inDouble = false;
  var inTemplateString = false;
  var inRegex = false;
  var curly = 0;
  var square = 0;
  var paren = 0;
  var lastFilterIndex = 0;
  var c, prev, i, expression, filters;

  for (i = 0; i < exp.length; i++) {
    prev = c;
    c = exp.charCodeAt(i);
    if (inSingle) {
      if (c === 0x27 && prev !== 0x5C) { inSingle = false; }
    } else if (inDouble) {
      if (c === 0x22 && prev !== 0x5C) { inDouble = false; }
    } else if (inTemplateString) {
      if (c === 0x60 && prev !== 0x5C) { inTemplateString = false; }
    } else if (inRegex) {
      if (c === 0x2f && prev !== 0x5C) { inRegex = false; }
    } else if (
      c === 0x7C && // pipe
      exp.charCodeAt(i + 1) !== 0x7C &&
      exp.charCodeAt(i - 1) !== 0x7C &&
      !curly && !square && !paren
    ) {
      if (expression === undefined) {
        // first filter, end of expression
        lastFilterIndex = i + 1;
        expression = exp.slice(0, i).trim();
      } else {
        pushFilter();
      }
    } else {
      switch (c) {
        case 0x22: inDouble = true; break         // "
        case 0x27: inSingle = true; break         // '
        case 0x60: inTemplateString = true; break // `
        case 0x28: paren++; break                 // (
        case 0x29: paren--; break                 // )
        case 0x5B: square++; break                // [
        case 0x5D: square--; break                // ]
        case 0x7B: curly++; break                 // {
        case 0x7D: curly--; break                 // }
      }
      if (c === 0x2f) { // /
        var j = i - 1;
        var p = (void 0);
        // find first non-whitespace prev char
        for (; j >= 0; j--) {
          p = exp.charAt(j);
          if (p !== ' ') { break }
        }
        if (!p || !validDivisionCharRE.test(p)) {
          inRegex = true;
        }
      }
    }
  }

  if (expression === undefined) {
    expression = exp.slice(0, i).trim();
  } else if (lastFilterIndex !== 0) {
    pushFilter();
  }

  function pushFilter () {
    (filters || (filters = [])).push(exp.slice(lastFilterIndex, i).trim());
    lastFilterIndex = i + 1;
  }

  if (filters) {
    for (i = 0; i < filters.length; i++) {
      expression = wrapFilter(expression, filters[i]);
    }
  }

  return expression
}

function wrapFilter (exp, filter) {
  var i = filter.indexOf('(');
  if (i < 0) {
    // _f: resolveFilter
    return ("_f(\"" + filter + "\")(" + exp + ")")
  } else {
    var name = filter.slice(0, i);
    var args = filter.slice(i + 1);
    return ("_f(\"" + name + "\")(" + exp + (args !== ')' ? ',' + args : args))
  }
}

/*  */



/* eslint-disable no-unused-vars */
function baseWarn (msg, range) {
  console.error(("[Vue compiler]: " + msg));
}
/* eslint-enable no-unused-vars */

function pluckModuleFunction (
  modules,
  key
) {
  return modules
    ? modules.map(function (m) { return m[key]; }).filter(function (_) { return _; })
    : []
}

function addProp (el, name, value, range, dynamic) {
  (el.props || (el.props = [])).push(rangeSetItem({ name: name, value: value, dynamic: dynamic }, range));
  el.plain = false;
}

function addAttr (el, name, value, range, dynamic) {
  var attrs = dynamic
    ? (el.dynamicAttrs || (el.dynamicAttrs = []))
    : (el.attrs || (el.attrs = []));
  attrs.push(rangeSetItem({ name: name, value: value, dynamic: dynamic }, range));
  el.plain = false;
}

// add a raw attr (use this in preTransforms)
function addRawAttr (el, name, value, range) {
  el.attrsMap[name] = value;
  el.attrsList.push(rangeSetItem({ name: name, value: value }, range));
}

function addDirective (
  el,
  name,
  rawName,
  value,
  arg,
  isDynamicArg,
  modifiers,
  range
) {
  (el.directives || (el.directives = [])).push(rangeSetItem({
    name: name,
    rawName: rawName,
    value: value,
    arg: arg,
    isDynamicArg: isDynamicArg,
    modifiers: modifiers
  }, range));
  el.plain = false;
}

function prependModifierMarker (symbol, name, dynamic) {
  return dynamic
    ? ("_p(" + name + ",\"" + symbol + "\")")
    : symbol + name // mark the event as captured
}

function addHandler (
  el,
  name,
  value,
  modifiers,
  important,
  warn,
  range,
  dynamic
) {
  modifiers = modifiers || emptyObject;
  // warn prevent and passive modifier
  /* istanbul ignore if */
  if (
    false
  ) {
    warn(
      'passive and prevent can\'t be used together. ' +
      'Passive handler can\'t prevent default event.',
      range
    );
  }

  // normalize click.right and click.middle since they don't actually fire
  // this is technically browser-specific, but at least for now browsers are
  // the only target envs that have right/middle clicks.
  if (modifiers.right) {
    if (dynamic) {
      name = "(" + name + ")==='click'?'contextmenu':(" + name + ")";
    } else if (name === 'click') {
      name = 'contextmenu';
      delete modifiers.right;
    }
  } else if (modifiers.middle) {
    if (dynamic) {
      name = "(" + name + ")==='click'?'mouseup':(" + name + ")";
    } else if (name === 'click') {
      name = 'mouseup';
    }
  }

  // check capture modifier
  if (modifiers.capture) {
    delete modifiers.capture;
    name = prependModifierMarker('!', name, dynamic);
  }
  if (modifiers.once) {
    delete modifiers.once;
    name = prependModifierMarker('~', name, dynamic);
  }
  /* istanbul ignore if */
  if (modifiers.passive) {
    delete modifiers.passive;
    name = prependModifierMarker('&', name, dynamic);
  }

  var events;
  if (modifiers.native) {
    delete modifiers.native;
    events = el.nativeEvents || (el.nativeEvents = {});
  } else {
    events = el.events || (el.events = {});
  }

  var newHandler = rangeSetItem({ value: value.trim(), dynamic: dynamic }, range);
  if (modifiers !== emptyObject) {
    newHandler.modifiers = modifiers;
  }

  var handlers = events[name];
  /* istanbul ignore if */
  if (Array.isArray(handlers)) {
    important ? handlers.unshift(newHandler) : handlers.push(newHandler);
  } else if (handlers) {
    events[name] = important ? [newHandler, handlers] : [handlers, newHandler];
  } else {
    events[name] = newHandler;
  }

  el.plain = false;
}

function getRawBindingAttr (
  el,
  name
) {
  return el.rawAttrsMap[':' + name] ||
    el.rawAttrsMap['v-bind:' + name] ||
    el.rawAttrsMap[name]
}

function getBindingAttr (
  el,
  name,
  getStatic
) {
  var dynamicValue =
    getAndRemoveAttr(el, ':' + name) ||
    getAndRemoveAttr(el, 'v-bind:' + name);
  if (dynamicValue != null) {
    return parseFilters(dynamicValue)
  } else if (getStatic !== false) {
    var staticValue = getAndRemoveAttr(el, name);
    if (staticValue != null) {
      return JSON.stringify(staticValue)
    }
  }
}

// note: this only removes the attr from the Array (attrsList) so that it
// doesn't get processed by processAttrs.
// By default it does NOT remove it from the map (attrsMap) because the map is
// needed during codegen.
function getAndRemoveAttr (
  el,
  name,
  removeFromMap
) {
  var val;
  if ((val = el.attrsMap[name]) != null) {
    var list = el.attrsList;
    for (var i = 0, l = list.length; i < l; i++) {
      if (list[i].name === name) {
        list.splice(i, 1);
        break
      }
    }
  }
  if (removeFromMap) {
    delete el.attrsMap[name];
  }
  return val
}

function getAndRemoveAttrByRegex (
  el,
  name
) {
  var list = el.attrsList;
  for (var i = 0, l = list.length; i < l; i++) {
    var attr = list[i];
    if (name.test(attr.name)) {
      list.splice(i, 1);
      return attr
    }
  }
}

function rangeSetItem (
  item,
  range
) {
  if (range) {
    if (range.start != null) {
      item.start = range.start;
    }
    if (range.end != null) {
      item.end = range.end;
    }
  }
  return item
}

/*  */

/**
 * Cross-platform code generation for component v-model
 */
function genComponentModel (
  el,
  value,
  modifiers
) {
  var ref = modifiers || {};
  var number = ref.number;
  var trim = ref.trim;

  var baseValueExpression = '$$v';
  var valueExpression = baseValueExpression;
  if (trim) {
    valueExpression =
      "(typeof " + baseValueExpression + " === 'string'" +
      "? " + baseValueExpression + ".trim()" +
      ": " + baseValueExpression + ")";
  }
  if (number) {
    valueExpression = "_n(" + valueExpression + ")";
  }
  var assignment = genAssignmentCode(value, valueExpression);

  el.model = {
    value: ("(" + value + ")"),
    expression: JSON.stringify(value),
    callback: ("function (" + baseValueExpression + ") {" + assignment + "}")
  };
}

/**
 * Cross-platform codegen helper for generating v-model value assignment code.
 */
function genAssignmentCode (
  value,
  assignment
) {
  var res = parseModel(value);
  if (res.key === null) {
    return (value + "=" + assignment)
  } else {
    return ("$set(" + (res.exp) + ", " + (res.key) + ", " + assignment + ")")
  }
}

/**
 * Parse a v-model expression into a base path and a final key segment.
 * Handles both dot-path and possible square brackets.
 *
 * Possible cases:
 *
 * - test
 * - test[key]
 * - test[test1[key]]
 * - test["a"][key]
 * - xxx.test[a[a].test1[key]]
 * - test.xxx.a["asa"][test1[key]]
 *
 */

var len, str, chr, index$1, expressionPos, expressionEndPos;



function parseModel (val) {
  // Fix https://github.com/vuejs/vue/pull/7730
  // allow v-model="obj.val " (trailing whitespace)
  val = val.trim();
  len = val.length;

  if (val.indexOf('[') < 0 || val.lastIndexOf(']') < len - 1) {
    index$1 = val.lastIndexOf('.');
    if (index$1 > -1) {
      return {
        exp: val.slice(0, index$1),
        key: '"' + val.slice(index$1 + 1) + '"'
      }
    } else {
      return {
        exp: val,
        key: null
      }
    }
  }

  str = val;
  index$1 = expressionPos = expressionEndPos = 0;

  while (!eof()) {
    chr = next();
    /* istanbul ignore if */
    if (isStringStart(chr)) {
      parseString(chr);
    } else if (chr === 0x5B) {
      parseBracket(chr);
    }
  }

  return {
    exp: val.slice(0, expressionPos),
    key: val.slice(expressionPos + 1, expressionEndPos)
  }
}

function next () {
  return str.charCodeAt(++index$1)
}

function eof () {
  return index$1 >= len
}

function isStringStart (chr) {
  return chr === 0x22 || chr === 0x27
}

function parseBracket (chr) {
  var inBracket = 1;
  expressionPos = index$1;
  while (!eof()) {
    chr = next();
    if (isStringStart(chr)) {
      parseString(chr);
      continue
    }
    if (chr === 0x5B) { inBracket++; }
    if (chr === 0x5D) { inBracket--; }
    if (inBracket === 0) {
      expressionEndPos = index$1;
      break
    }
  }
}

function parseString (chr) {
  var stringQuote = chr;
  while (!eof()) {
    chr = next();
    if (chr === stringQuote) {
      break
    }
  }
}

/*  */

var warn$1;

// in some cases, the event used has to be determined at runtime
// so we used some reserved tokens during compile.
var RANGE_TOKEN = '__r';
var CHECKBOX_RADIO_TOKEN = '__c';

function model (
  el,
  dir,
  _warn
) {
  warn$1 = _warn;
  var value = dir.value;
  var modifiers = dir.modifiers;
  var tag = el.tag;
  var type = el.attrsMap.type;

  if (false) {
    // inputs with type="file" are read only and setting the input's
    // value will throw an error.
    if (tag === 'input' && type === 'file') {
      warn$1(
        "<" + (el.tag) + " v-model=\"" + value + "\" type=\"file\">:\n" +
        "File inputs are read only. Use a v-on:change listener instead.",
        el.rawAttrsMap['v-model']
      );
    }
  }

  if (el.component) {
    genComponentModel(el, value, modifiers);
    // component v-model doesn't need extra runtime
    return false
  } else if (tag === 'select') {
    genSelect(el, value, modifiers);
  } else if (tag === 'input' && type === 'checkbox') {
    genCheckboxModel(el, value, modifiers);
  } else if (tag === 'input' && type === 'radio') {
    genRadioModel(el, value, modifiers);
  } else if (tag === 'input' || tag === 'textarea') {
    genDefaultModel(el, value, modifiers);
  } else if (!config.isReservedTag(tag)) {
    genComponentModel(el, value, modifiers);
    // component v-model doesn't need extra runtime
    return false
  } else if (false) {
    warn$1(
      "<" + (el.tag) + " v-model=\"" + value + "\">: " +
      "v-model is not supported on this element type. " +
      'If you are working with contenteditable, it\'s recommended to ' +
      'wrap a library dedicated for that purpose inside a custom component.',
      el.rawAttrsMap['v-model']
    );
  }

  // ensure runtime directive metadata
  return true
}

function genCheckboxModel (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var valueBinding = getBindingAttr(el, 'value') || 'null';
  var trueValueBinding = getBindingAttr(el, 'true-value') || 'true';
  var falseValueBinding = getBindingAttr(el, 'false-value') || 'false';
  addProp(el, 'checked',
    "Array.isArray(" + value + ")" +
    "?_i(" + value + "," + valueBinding + ")>-1" + (
      trueValueBinding === 'true'
        ? (":(" + value + ")")
        : (":_q(" + value + "," + trueValueBinding + ")")
    )
  );
  addHandler(el, 'change',
    "var $$a=" + value + "," +
        '$$el=$event.target,' +
        "$$c=$$el.checked?(" + trueValueBinding + "):(" + falseValueBinding + ");" +
    'if(Array.isArray($$a)){' +
      "var $$v=" + (number ? '_n(' + valueBinding + ')' : valueBinding) + "," +
          '$$i=_i($$a,$$v);' +
      "if($$el.checked){$$i<0&&(" + (genAssignmentCode(value, '$$a.concat([$$v])')) + ")}" +
      "else{$$i>-1&&(" + (genAssignmentCode(value, '$$a.slice(0,$$i).concat($$a.slice($$i+1))')) + ")}" +
    "}else{" + (genAssignmentCode(value, '$$c')) + "}",
    null, true
  );
}

function genRadioModel (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var valueBinding = getBindingAttr(el, 'value') || 'null';
  valueBinding = number ? ("_n(" + valueBinding + ")") : valueBinding;
  addProp(el, 'checked', ("_q(" + value + "," + valueBinding + ")"));
  addHandler(el, 'change', genAssignmentCode(value, valueBinding), null, true);
}

function genSelect (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var selectedVal = "Array.prototype.filter" +
    ".call($event.target.options,function(o){return o.selected})" +
    ".map(function(o){var val = \"_value\" in o ? o._value : o.value;" +
    "return " + (number ? '_n(val)' : 'val') + "})";

  var assignment = '$event.target.multiple ? $$selectedVal : $$selectedVal[0]';
  var code = "var $$selectedVal = " + selectedVal + ";";
  code = code + " " + (genAssignmentCode(value, assignment));
  addHandler(el, 'change', code, null, true);
}

function genDefaultModel (
  el,
  value,
  modifiers
) {
  var type = el.attrsMap.type;

  // warn if v-bind:value conflicts with v-model
  // except for inputs with v-bind:type
  if (false) {
    var value$1 = el.attrsMap['v-bind:value'] || el.attrsMap[':value'];
    var typeBinding = el.attrsMap['v-bind:type'] || el.attrsMap[':type'];
    if (value$1 && !typeBinding) {
      var binding = el.attrsMap['v-bind:value'] ? 'v-bind:value' : ':value';
      warn$1(
        binding + "=\"" + value$1 + "\" conflicts with v-model on the same element " +
        'because the latter already expands to a value binding internally',
        el.rawAttrsMap[binding]
      );
    }
  }

  var ref = modifiers || {};
  var lazy = ref.lazy;
  var number = ref.number;
  var trim = ref.trim;
  var needCompositionGuard = !lazy && type !== 'range';
  var event = lazy
    ? 'change'
    : type === 'range'
      ? RANGE_TOKEN
      : 'input';

  var valueExpression = '$event.target.value';
  if (trim) {
    valueExpression = "$event.target.value.trim()";
  }
  if (number) {
    valueExpression = "_n(" + valueExpression + ")";
  }

  var code = genAssignmentCode(value, valueExpression);
  if (needCompositionGuard) {
    code = "if($event.target.composing)return;" + code;
  }

  addProp(el, 'value', ("(" + value + ")"));
  addHandler(el, event, code, null, true);
  if (trim || number) {
    addHandler(el, 'blur', '$forceUpdate()');
  }
}

/*  */

// normalize v-model event tokens that can only be determined at runtime.
// it's important to place the event as the first in the array because
// the whole point is ensuring the v-model callback gets called before
// user-attached handlers.
function normalizeEvents (on) {
  /* istanbul ignore if */
  if (isDef(on[RANGE_TOKEN])) {
    // IE input[type=range] only supports `change` event
    var event = isIE ? 'change' : 'input';
    on[event] = [].concat(on[RANGE_TOKEN], on[event] || []);
    delete on[RANGE_TOKEN];
  }
  // This was originally intended to fix #4521 but no longer necessary
  // after 2.5. Keeping it for backwards compat with generated code from < 2.4
  /* istanbul ignore if */
  if (isDef(on[CHECKBOX_RADIO_TOKEN])) {
    on.change = [].concat(on[CHECKBOX_RADIO_TOKEN], on.change || []);
    delete on[CHECKBOX_RADIO_TOKEN];
  }
}

var target$1;

function createOnceHandler$1 (event, handler, capture) {
  var _target = target$1; // save current target element in closure
  return function onceHandler () {
    var res = handler.apply(null, arguments);
    if (res !== null) {
      remove$2(event, onceHandler, capture, _target);
    }
  }
}

// #9446: Firefox <= 53 (in particular, ESR 52) has incorrect Event.timeStamp
// implementation and does not fire microtasks in between event propagation, so
// safe to exclude.
var useMicrotaskFix = isUsingMicroTask && !(isFF && Number(isFF[1]) <= 53);

function add$1 (
  name,
  handler,
  capture,
  passive
) {
  // async edge case #6566: inner click event triggers patch, event handler
  // attached to outer element during patch, and triggered again. This
  // happens because browsers fire microtask ticks between event propagation.
  // the solution is simple: we save the timestamp when a handler is attached,
  // and the handler would only fire if the event passed to it was fired
  // AFTER it was attached.
  if (useMicrotaskFix) {
    var attachedTimestamp = currentFlushTimestamp;
    var original = handler;
    handler = original._wrapper = function (e) {
      if (
        // no bubbling, should always fire.
        // this is just a safety net in case event.timeStamp is unreliable in
        // certain weird environments...
        e.target === e.currentTarget ||
        // event is fired after handler attachment
        e.timeStamp >= attachedTimestamp ||
        // bail for environments that have buggy event.timeStamp implementations
        // #9462 iOS 9 bug: event.timeStamp is 0 after history.pushState
        // #9681 QtWebEngine event.timeStamp is negative value
        e.timeStamp <= 0 ||
        // #9448 bail if event is fired in another document in a multi-page
        // electron/nw.js app, since event.timeStamp will be using a different
        // starting reference
        e.target.ownerDocument !== document
      ) {
        return original.apply(this, arguments)
      }
    };
  }
  target$1.addEventListener(
    name,
    handler,
    supportsPassive
      ? { capture: capture, passive: passive }
      : capture
  );
}

function remove$2 (
  name,
  handler,
  capture,
  _target
) {
  (_target || target$1).removeEventListener(
    name,
    handler._wrapper || handler,
    capture
  );
}

function updateDOMListeners (oldVnode, vnode) {
  if (isUndef(oldVnode.data.on) && isUndef(vnode.data.on)) {
    return
  }
  var on = vnode.data.on || {};
  var oldOn = oldVnode.data.on || {};
  target$1 = vnode.elm;
  normalizeEvents(on);
  updateListeners(on, oldOn, add$1, remove$2, createOnceHandler$1, vnode.context);
  target$1 = undefined;
}

var events = {
  create: updateDOMListeners,
  update: updateDOMListeners
};

/*  */

var svgContainer;

function updateDOMProps (oldVnode, vnode) {
  if (isUndef(oldVnode.data.domProps) && isUndef(vnode.data.domProps)) {
    return
  }
  var key, cur;
  var elm = vnode.elm;
  var oldProps = oldVnode.data.domProps || {};
  var props = vnode.data.domProps || {};
  // clone observed objects, as the user probably wants to mutate it
  if (isDef(props.__ob__)) {
    props = vnode.data.domProps = extend({}, props);
  }

  for (key in oldProps) {
    if (!(key in props)) {
      elm[key] = '';
    }
  }

  for (key in props) {
    cur = props[key];
    // ignore children if the node has textContent or innerHTML,
    // as these will throw away existing DOM nodes and cause removal errors
    // on subsequent patches (#3360)
    if (key === 'textContent' || key === 'innerHTML') {
      if (vnode.children) { vnode.children.length = 0; }
      if (cur === oldProps[key]) { continue }
      // #6601 work around Chrome version <= 55 bug where single textNode
      // replaced by innerHTML/textContent retains its parentNode property
      if (elm.childNodes.length === 1) {
        elm.removeChild(elm.childNodes[0]);
      }
    }

    if (key === 'value' && elm.tagName !== 'PROGRESS') {
      // store value as _value as well since
      // non-string values will be stringified
      elm._value = cur;
      // avoid resetting cursor position when value is the same
      var strCur = isUndef(cur) ? '' : String(cur);
      if (shouldUpdateValue(elm, strCur)) {
        elm.value = strCur;
      }
    } else if (key === 'innerHTML' && isSVG(elm.tagName) && isUndef(elm.innerHTML)) {
      // IE doesn't support innerHTML for SVG elements
      svgContainer = svgContainer || document.createElement('div');
      svgContainer.innerHTML = "<svg>" + cur + "</svg>";
      var svg = svgContainer.firstChild;
      while (elm.firstChild) {
        elm.removeChild(elm.firstChild);
      }
      while (svg.firstChild) {
        elm.appendChild(svg.firstChild);
      }
    } else if (
      // skip the update if old and new VDOM state is the same.
      // `value` is handled separately because the DOM value may be temporarily
      // out of sync with VDOM state due to focus, composition and modifiers.
      // This  #4521 by skipping the unnecessary `checked` update.
      cur !== oldProps[key]
    ) {
      // some property updates can throw
      // e.g. `value` on <progress> w/ non-finite value
      try {
        elm[key] = cur;
      } catch (e) {}
    }
  }
}

// check platforms/web/util/attrs.js acceptValue


function shouldUpdateValue (elm, checkVal) {
  return (!elm.composing && (
    elm.tagName === 'OPTION' ||
    isNotInFocusAndDirty(elm, checkVal) ||
    isDirtyWithModifiers(elm, checkVal)
  ))
}

function isNotInFocusAndDirty (elm, checkVal) {
  // return true when textbox (.number and .trim) loses focus and its value is
  // not equal to the updated value
  var notInFocus = true;
  // #6157
  // work around IE bug when accessing document.activeElement in an iframe
  try { notInFocus = document.activeElement !== elm; } catch (e) {}
  return notInFocus && elm.value !== checkVal
}

function isDirtyWithModifiers (elm, newVal) {
  var value = elm.value;
  var modifiers = elm._vModifiers; // injected by v-model runtime
  if (isDef(modifiers)) {
    if (modifiers.number) {
      return toNumber(value) !== toNumber(newVal)
    }
    if (modifiers.trim) {
      return value.trim() !== newVal.trim()
    }
  }
  return value !== newVal
}

var domProps = {
  create: updateDOMProps,
  update: updateDOMProps
};

/*  */

var parseStyleText = cached(function (cssText) {
  var res = {};
  var listDelimiter = /;(?![^(]*\))/g;
  var propertyDelimiter = /:(.+)/;
  cssText.split(listDelimiter).forEach(function (item) {
    if (item) {
      var tmp = item.split(propertyDelimiter);
      tmp.length > 1 && (res[tmp[0].trim()] = tmp[1].trim());
    }
  });
  return res
});

// merge static and dynamic style data on the same vnode
function normalizeStyleData (data) {
  var style = normalizeStyleBinding(data.style);
  // static style is pre-processed into an object during compilation
  // and is always a fresh object, so it's safe to merge into it
  return data.staticStyle
    ? extend(data.staticStyle, style)
    : style
}

// normalize possible array / string values into Object
function normalizeStyleBinding (bindingStyle) {
  if (Array.isArray(bindingStyle)) {
    return toObject(bindingStyle)
  }
  if (typeof bindingStyle === 'string') {
    return parseStyleText(bindingStyle)
  }
  return bindingStyle
}

/**
 * parent component style should be after child's
 * so that parent component's style could override it
 */
function getStyle (vnode, checkChild) {
  var res = {};
  var styleData;

  if (checkChild) {
    var childNode = vnode;
    while (childNode.componentInstance) {
      childNode = childNode.componentInstance._vnode;
      if (
        childNode && childNode.data &&
        (styleData = normalizeStyleData(childNode.data))
      ) {
        extend(res, styleData);
      }
    }
  }

  if ((styleData = normalizeStyleData(vnode.data))) {
    extend(res, styleData);
  }

  var parentNode = vnode;
  while ((parentNode = parentNode.parent)) {
    if (parentNode.data && (styleData = normalizeStyleData(parentNode.data))) {
      extend(res, styleData);
    }
  }
  return res
}

/*  */

var cssVarRE = /^--/;
var importantRE = /\s*!important$/;
var setProp = function (el, name, val) {
  /* istanbul ignore if */
  if (cssVarRE.test(name)) {
    el.style.setProperty(name, val);
  } else if (importantRE.test(val)) {
    el.style.setProperty(hyphenate(name), val.replace(importantRE, ''), 'important');
  } else {
    var normalizedName = normalize(name);
    if (Array.isArray(val)) {
      // Support values array created by autoprefixer, e.g.
      // {display: ["-webkit-box", "-ms-flexbox", "flex"]}
      // Set them one by one, and the browser will only set those it can recognize
      for (var i = 0, len = val.length; i < len; i++) {
        el.style[normalizedName] = val[i];
      }
    } else {
      el.style[normalizedName] = val;
    }
  }
};

var vendorNames = ['Webkit', 'Moz', 'ms'];

var emptyStyle;
var normalize = cached(function (prop) {
  emptyStyle = emptyStyle || document.createElement('div').style;
  prop = camelize(prop);
  if (prop !== 'filter' && (prop in emptyStyle)) {
    return prop
  }
  var capName = prop.charAt(0).toUpperCase() + prop.slice(1);
  for (var i = 0; i < vendorNames.length; i++) {
    var name = vendorNames[i] + capName;
    if (name in emptyStyle) {
      return name
    }
  }
});

function updateStyle (oldVnode, vnode) {
  var data = vnode.data;
  var oldData = oldVnode.data;

  if (isUndef(data.staticStyle) && isUndef(data.style) &&
    isUndef(oldData.staticStyle) && isUndef(oldData.style)
  ) {
    return
  }

  var cur, name;
  var el = vnode.elm;
  var oldStaticStyle = oldData.staticStyle;
  var oldStyleBinding = oldData.normalizedStyle || oldData.style || {};

  // if static style exists, stylebinding already merged into it when doing normalizeStyleData
  var oldStyle = oldStaticStyle || oldStyleBinding;

  var style = normalizeStyleBinding(vnode.data.style) || {};

  // store normalized style under a different key for next diff
  // make sure to clone it if it's reactive, since the user likely wants
  // to mutate it.
  vnode.data.normalizedStyle = isDef(style.__ob__)
    ? extend({}, style)
    : style;

  var newStyle = getStyle(vnode, true);

  for (name in oldStyle) {
    if (isUndef(newStyle[name])) {
      setProp(el, name, '');
    }
  }
  for (name in newStyle) {
    cur = newStyle[name];
    if (cur !== oldStyle[name]) {
      // ie9 setting to null has no effect, must use empty string
      setProp(el, name, cur == null ? '' : cur);
    }
  }
}

var style = {
  create: updateStyle,
  update: updateStyle
};

/*  */

var whitespaceRE = /\s+/;

/**
 * Add class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function addClass (el, cls) {
  /* istanbul ignore if */
  if (!cls || !(cls = cls.trim())) {
    return
  }

  /* istanbul ignore else */
  if (el.classList) {
    if (cls.indexOf(' ') > -1) {
      cls.split(whitespaceRE).forEach(function (c) { return el.classList.add(c); });
    } else {
      el.classList.add(cls);
    }
  } else {
    var cur = " " + (el.getAttribute('class') || '') + " ";
    if (cur.indexOf(' ' + cls + ' ') < 0) {
      el.setAttribute('class', (cur + cls).trim());
    }
  }
}

/**
 * Remove class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function removeClass (el, cls) {
  /* istanbul ignore if */
  if (!cls || !(cls = cls.trim())) {
    return
  }

  /* istanbul ignore else */
  if (el.classList) {
    if (cls.indexOf(' ') > -1) {
      cls.split(whitespaceRE).forEach(function (c) { return el.classList.remove(c); });
    } else {
      el.classList.remove(cls);
    }
    if (!el.classList.length) {
      el.removeAttribute('class');
    }
  } else {
    var cur = " " + (el.getAttribute('class') || '') + " ";
    var tar = ' ' + cls + ' ';
    while (cur.indexOf(tar) >= 0) {
      cur = cur.replace(tar, ' ');
    }
    cur = cur.trim();
    if (cur) {
      el.setAttribute('class', cur);
    } else {
      el.removeAttribute('class');
    }
  }
}

/*  */

function resolveTransition (def$$1) {
  if (!def$$1) {
    return
  }
  /* istanbul ignore else */
  if (typeof def$$1 === 'object') {
    var res = {};
    if (def$$1.css !== false) {
      extend(res, autoCssTransition(def$$1.name || 'v'));
    }
    extend(res, def$$1);
    return res
  } else if (typeof def$$1 === 'string') {
    return autoCssTransition(def$$1)
  }
}

var autoCssTransition = cached(function (name) {
  return {
    enterClass: (name + "-enter"),
    enterToClass: (name + "-enter-to"),
    enterActiveClass: (name + "-enter-active"),
    leaveClass: (name + "-leave"),
    leaveToClass: (name + "-leave-to"),
    leaveActiveClass: (name + "-leave-active")
  }
});

var hasTransition = inBrowser && !isIE9;
var TRANSITION = 'transition';
var ANIMATION = 'animation';

// Transition property/event sniffing
var transitionProp = 'transition';
var transitionEndEvent = 'transitionend';
var animationProp = 'animation';
var animationEndEvent = 'animationend';
if (hasTransition) {
  /* istanbul ignore if */
  if (window.ontransitionend === undefined &&
    window.onwebkittransitionend !== undefined
  ) {
    transitionProp = 'WebkitTransition';
    transitionEndEvent = 'webkitTransitionEnd';
  }
  if (window.onanimationend === undefined &&
    window.onwebkitanimationend !== undefined
  ) {
    animationProp = 'WebkitAnimation';
    animationEndEvent = 'webkitAnimationEnd';
  }
}

// binding to window is necessary to make hot reload work in IE in strict mode
var raf = inBrowser
  ? window.requestAnimationFrame
    ? window.requestAnimationFrame.bind(window)
    : setTimeout
  : /* istanbul ignore next */ function (fn) { return fn(); };

function nextFrame (fn) {
  raf(function () {
    raf(fn);
  });
}

function addTransitionClass (el, cls) {
  var transitionClasses = el._transitionClasses || (el._transitionClasses = []);
  if (transitionClasses.indexOf(cls) < 0) {
    transitionClasses.push(cls);
    addClass(el, cls);
  }
}

function removeTransitionClass (el, cls) {
  if (el._transitionClasses) {
    remove(el._transitionClasses, cls);
  }
  removeClass(el, cls);
}

function whenTransitionEnds (
  el,
  expectedType,
  cb
) {
  var ref = getTransitionInfo(el, expectedType);
  var type = ref.type;
  var timeout = ref.timeout;
  var propCount = ref.propCount;
  if (!type) { return cb() }
  var event = type === TRANSITION ? transitionEndEvent : animationEndEvent;
  var ended = 0;
  var end = function () {
    el.removeEventListener(event, onEnd);
    cb();
  };
  var onEnd = function (e) {
    if (e.target === el) {
      if (++ended >= propCount) {
        end();
      }
    }
  };
  setTimeout(function () {
    if (ended < propCount) {
      end();
    }
  }, timeout + 1);
  el.addEventListener(event, onEnd);
}

var transformRE = /\b(transform|all)(,|$)/;

function getTransitionInfo (el, expectedType) {
  var styles = window.getComputedStyle(el);
  // JSDOM may return undefined for transition properties
  var transitionDelays = (styles[transitionProp + 'Delay'] || '').split(', ');
  var transitionDurations = (styles[transitionProp + 'Duration'] || '').split(', ');
  var transitionTimeout = getTimeout(transitionDelays, transitionDurations);
  var animationDelays = (styles[animationProp + 'Delay'] || '').split(', ');
  var animationDurations = (styles[animationProp + 'Duration'] || '').split(', ');
  var animationTimeout = getTimeout(animationDelays, animationDurations);

  var type;
  var timeout = 0;
  var propCount = 0;
  /* istanbul ignore if */
  if (expectedType === TRANSITION) {
    if (transitionTimeout > 0) {
      type = TRANSITION;
      timeout = transitionTimeout;
      propCount = transitionDurations.length;
    }
  } else if (expectedType === ANIMATION) {
    if (animationTimeout > 0) {
      type = ANIMATION;
      timeout = animationTimeout;
      propCount = animationDurations.length;
    }
  } else {
    timeout = Math.max(transitionTimeout, animationTimeout);
    type = timeout > 0
      ? transitionTimeout > animationTimeout
        ? TRANSITION
        : ANIMATION
      : null;
    propCount = type
      ? type === TRANSITION
        ? transitionDurations.length
        : animationDurations.length
      : 0;
  }
  var hasTransform =
    type === TRANSITION &&
    transformRE.test(styles[transitionProp + 'Property']);
  return {
    type: type,
    timeout: timeout,
    propCount: propCount,
    hasTransform: hasTransform
  }
}

function getTimeout (delays, durations) {
  /* istanbul ignore next */
  while (delays.length < durations.length) {
    delays = delays.concat(delays);
  }

  return Math.max.apply(null, durations.map(function (d, i) {
    return toMs(d) + toMs(delays[i])
  }))
}

// Old versions of Chromium (below 61.0.3163.100) formats floating pointer numbers
// in a locale-dependent way, using a comma instead of a dot.
// If comma is not replaced with a dot, the input will be rounded down (i.e. acting
// as a floor function) causing unexpected behaviors
function toMs (s) {
  return Number(s.slice(0, -1).replace(',', '.')) * 1000
}

/*  */

function enter (vnode, toggleDisplay) {
  var el = vnode.elm;

  // call leave callback now
  if (isDef(el._leaveCb)) {
    el._leaveCb.cancelled = true;
    el._leaveCb();
  }

  var data = resolveTransition(vnode.data.transition);
  if (isUndef(data)) {
    return
  }

  /* istanbul ignore if */
  if (isDef(el._enterCb) || el.nodeType !== 1) {
    return
  }

  var css = data.css;
  var type = data.type;
  var enterClass = data.enterClass;
  var enterToClass = data.enterToClass;
  var enterActiveClass = data.enterActiveClass;
  var appearClass = data.appearClass;
  var appearToClass = data.appearToClass;
  var appearActiveClass = data.appearActiveClass;
  var beforeEnter = data.beforeEnter;
  var enter = data.enter;
  var afterEnter = data.afterEnter;
  var enterCancelled = data.enterCancelled;
  var beforeAppear = data.beforeAppear;
  var appear = data.appear;
  var afterAppear = data.afterAppear;
  var appearCancelled = data.appearCancelled;
  var duration = data.duration;

  // activeInstance will always be the <transition> component managing this
  // transition. One edge case to check is when the <transition> is placed
  // as the root node of a child component. In that case we need to check
  // <transition>'s parent for appear check.
  var context = activeInstance;
  var transitionNode = activeInstance.$vnode;
  while (transitionNode && transitionNode.parent) {
    context = transitionNode.context;
    transitionNode = transitionNode.parent;
  }

  var isAppear = !context._isMounted || !vnode.isRootInsert;

  if (isAppear && !appear && appear !== '') {
    return
  }

  var startClass = isAppear && appearClass
    ? appearClass
    : enterClass;
  var activeClass = isAppear && appearActiveClass
    ? appearActiveClass
    : enterActiveClass;
  var toClass = isAppear && appearToClass
    ? appearToClass
    : enterToClass;

  var beforeEnterHook = isAppear
    ? (beforeAppear || beforeEnter)
    : beforeEnter;
  var enterHook = isAppear
    ? (typeof appear === 'function' ? appear : enter)
    : enter;
  var afterEnterHook = isAppear
    ? (afterAppear || afterEnter)
    : afterEnter;
  var enterCancelledHook = isAppear
    ? (appearCancelled || enterCancelled)
    : enterCancelled;

  var explicitEnterDuration = toNumber(
    isObject(duration)
      ? duration.enter
      : duration
  );

  if (false) {
    checkDuration(explicitEnterDuration, 'enter', vnode);
  }

  var expectsCSS = css !== false && !isIE9;
  var userWantsControl = getHookArgumentsLength(enterHook);

  var cb = el._enterCb = once(function () {
    if (expectsCSS) {
      removeTransitionClass(el, toClass);
      removeTransitionClass(el, activeClass);
    }
    if (cb.cancelled) {
      if (expectsCSS) {
        removeTransitionClass(el, startClass);
      }
      enterCancelledHook && enterCancelledHook(el);
    } else {
      afterEnterHook && afterEnterHook(el);
    }
    el._enterCb = null;
  });

  if (!vnode.data.show) {
    // remove pending leave element on enter by injecting an insert hook
    mergeVNodeHook(vnode, 'insert', function () {
      var parent = el.parentNode;
      var pendingNode = parent && parent._pending && parent._pending[vnode.key];
      if (pendingNode &&
        pendingNode.tag === vnode.tag &&
        pendingNode.elm._leaveCb
      ) {
        pendingNode.elm._leaveCb();
      }
      enterHook && enterHook(el, cb);
    });
  }

  // start enter transition
  beforeEnterHook && beforeEnterHook(el);
  if (expectsCSS) {
    addTransitionClass(el, startClass);
    addTransitionClass(el, activeClass);
    nextFrame(function () {
      removeTransitionClass(el, startClass);
      if (!cb.cancelled) {
        addTransitionClass(el, toClass);
        if (!userWantsControl) {
          if (isValidDuration(explicitEnterDuration)) {
            setTimeout(cb, explicitEnterDuration);
          } else {
            whenTransitionEnds(el, type, cb);
          }
        }
      }
    });
  }

  if (vnode.data.show) {
    toggleDisplay && toggleDisplay();
    enterHook && enterHook(el, cb);
  }

  if (!expectsCSS && !userWantsControl) {
    cb();
  }
}

function leave (vnode, rm) {
  var el = vnode.elm;

  // call enter callback now
  if (isDef(el._enterCb)) {
    el._enterCb.cancelled = true;
    el._enterCb();
  }

  var data = resolveTransition(vnode.data.transition);
  if (isUndef(data) || el.nodeType !== 1) {
    return rm()
  }

  /* istanbul ignore if */
  if (isDef(el._leaveCb)) {
    return
  }

  var css = data.css;
  var type = data.type;
  var leaveClass = data.leaveClass;
  var leaveToClass = data.leaveToClass;
  var leaveActiveClass = data.leaveActiveClass;
  var beforeLeave = data.beforeLeave;
  var leave = data.leave;
  var afterLeave = data.afterLeave;
  var leaveCancelled = data.leaveCancelled;
  var delayLeave = data.delayLeave;
  var duration = data.duration;

  var expectsCSS = css !== false && !isIE9;
  var userWantsControl = getHookArgumentsLength(leave);

  var explicitLeaveDuration = toNumber(
    isObject(duration)
      ? duration.leave
      : duration
  );

  if (false) {
    checkDuration(explicitLeaveDuration, 'leave', vnode);
  }

  var cb = el._leaveCb = once(function () {
    if (el.parentNode && el.parentNode._pending) {
      el.parentNode._pending[vnode.key] = null;
    }
    if (expectsCSS) {
      removeTransitionClass(el, leaveToClass);
      removeTransitionClass(el, leaveActiveClass);
    }
    if (cb.cancelled) {
      if (expectsCSS) {
        removeTransitionClass(el, leaveClass);
      }
      leaveCancelled && leaveCancelled(el);
    } else {
      rm();
      afterLeave && afterLeave(el);
    }
    el._leaveCb = null;
  });

  if (delayLeave) {
    delayLeave(performLeave);
  } else {
    performLeave();
  }

  function performLeave () {
    // the delayed leave may have already been cancelled
    if (cb.cancelled) {
      return
    }
    // record leaving element
    if (!vnode.data.show && el.parentNode) {
      (el.parentNode._pending || (el.parentNode._pending = {}))[(vnode.key)] = vnode;
    }
    beforeLeave && beforeLeave(el);
    if (expectsCSS) {
      addTransitionClass(el, leaveClass);
      addTransitionClass(el, leaveActiveClass);
      nextFrame(function () {
        removeTransitionClass(el, leaveClass);
        if (!cb.cancelled) {
          addTransitionClass(el, leaveToClass);
          if (!userWantsControl) {
            if (isValidDuration(explicitLeaveDuration)) {
              setTimeout(cb, explicitLeaveDuration);
            } else {
              whenTransitionEnds(el, type, cb);
            }
          }
        }
      });
    }
    leave && leave(el, cb);
    if (!expectsCSS && !userWantsControl) {
      cb();
    }
  }
}

// only used in dev mode
function checkDuration (val, name, vnode) {
  if (typeof val !== 'number') {
    warn(
      "<transition> explicit " + name + " duration is not a valid number - " +
      "got " + (JSON.stringify(val)) + ".",
      vnode.context
    );
  } else if (isNaN(val)) {
    warn(
      "<transition> explicit " + name + " duration is NaN - " +
      'the duration expression might be incorrect.',
      vnode.context
    );
  }
}

function isValidDuration (val) {
  return typeof val === 'number' && !isNaN(val)
}

/**
 * Normalize a transition hook's argument length. The hook may be:
 * - a merged hook (invoker) with the original in .fns
 * - a wrapped component method (check ._length)
 * - a plain function (.length)
 */
function getHookArgumentsLength (fn) {
  if (isUndef(fn)) {
    return false
  }
  var invokerFns = fn.fns;
  if (isDef(invokerFns)) {
    // invoker
    return getHookArgumentsLength(
      Array.isArray(invokerFns)
        ? invokerFns[0]
        : invokerFns
    )
  } else {
    return (fn._length || fn.length) > 1
  }
}

function _enter (_, vnode) {
  if (vnode.data.show !== true) {
    enter(vnode);
  }
}

var transition = inBrowser ? {
  create: _enter,
  activate: _enter,
  remove: function remove$$1 (vnode, rm) {
    /* istanbul ignore else */
    if (vnode.data.show !== true) {
      leave(vnode, rm);
    } else {
      rm();
    }
  }
} : {};

var platformModules = [
  attrs,
  klass,
  events,
  domProps,
  style,
  transition
];

/*  */

// the directive module should be applied last, after all
// built-in modules have been applied.
var modules = platformModules.concat(baseModules);

var patch = createPatchFunction({ nodeOps: nodeOps, modules: modules });

/**
 * Not type checking this file because flow doesn't like attaching
 * properties to Elements.
 */

/* istanbul ignore if */
if (isIE9) {
  // http://www.matts411.com/post/internet-explorer-9-oninput/
  document.addEventListener('selectionchange', function () {
    var el = document.activeElement;
    if (el && el.vmodel) {
      trigger(el, 'input');
    }
  });
}

var directive = {
  inserted: function inserted (el, binding, vnode, oldVnode) {
    if (vnode.tag === 'select') {
      // #6903
      if (oldVnode.elm && !oldVnode.elm._vOptions) {
        mergeVNodeHook(vnode, 'postpatch', function () {
          directive.componentUpdated(el, binding, vnode);
        });
      } else {
        setSelected(el, binding, vnode.context);
      }
      el._vOptions = [].map.call(el.options, getValue);
    } else if (vnode.tag === 'textarea' || isTextInputType(el.type)) {
      el._vModifiers = binding.modifiers;
      if (!binding.modifiers.lazy) {
        el.addEventListener('compositionstart', onCompositionStart);
        el.addEventListener('compositionend', onCompositionEnd);
        // Safari < 10.2 & UIWebView doesn't fire compositionend when
        // switching focus before confirming composition choice
        // this also fixes the issue where some browsers e.g. iOS Chrome
        // fires "change" instead of "input" on autocomplete.
        el.addEventListener('change', onCompositionEnd);
        /* istanbul ignore if */
        if (isIE9) {
          el.vmodel = true;
        }
      }
    }
  },

  componentUpdated: function componentUpdated (el, binding, vnode) {
    if (vnode.tag === 'select') {
      setSelected(el, binding, vnode.context);
      // in case the options rendered by v-for have changed,
      // it's possible that the value is out-of-sync with the rendered options.
      // detect such cases and filter out values that no longer has a matching
      // option in the DOM.
      var prevOptions = el._vOptions;
      var curOptions = el._vOptions = [].map.call(el.options, getValue);
      if (curOptions.some(function (o, i) { return !looseEqual(o, prevOptions[i]); })) {
        // trigger change event if
        // no matching option found for at least one value
        var needReset = el.multiple
          ? binding.value.some(function (v) { return hasNoMatchingOption(v, curOptions); })
          : binding.value !== binding.oldValue && hasNoMatchingOption(binding.value, curOptions);
        if (needReset) {
          trigger(el, 'change');
        }
      }
    }
  }
};

function setSelected (el, binding, vm) {
  actuallySetSelected(el, binding, vm);
  /* istanbul ignore if */
  if (isIE || isEdge) {
    setTimeout(function () {
      actuallySetSelected(el, binding, vm);
    }, 0);
  }
}

function actuallySetSelected (el, binding, vm) {
  var value = binding.value;
  var isMultiple = el.multiple;
  if (isMultiple && !Array.isArray(value)) {
    "production" !== 'production' && warn(
      "<select multiple v-model=\"" + (binding.expression) + "\"> " +
      "expects an Array value for its binding, but got " + (Object.prototype.toString.call(value).slice(8, -1)),
      vm
    );
    return
  }
  var selected, option;
  for (var i = 0, l = el.options.length; i < l; i++) {
    option = el.options[i];
    if (isMultiple) {
      selected = looseIndexOf(value, getValue(option)) > -1;
      if (option.selected !== selected) {
        option.selected = selected;
      }
    } else {
      if (looseEqual(getValue(option), value)) {
        if (el.selectedIndex !== i) {
          el.selectedIndex = i;
        }
        return
      }
    }
  }
  if (!isMultiple) {
    el.selectedIndex = -1;
  }
}

function hasNoMatchingOption (value, options) {
  return options.every(function (o) { return !looseEqual(o, value); })
}

function getValue (option) {
  return '_value' in option
    ? option._value
    : option.value
}

function onCompositionStart (e) {
  e.target.composing = true;
}

function onCompositionEnd (e) {
  // prevent triggering an input event for no reason
  if (!e.target.composing) { return }
  e.target.composing = false;
  trigger(e.target, 'input');
}

function trigger (el, type) {
  var e = document.createEvent('HTMLEvents');
  e.initEvent(type, true, true);
  el.dispatchEvent(e);
}

/*  */

// recursively search for possible transition defined inside the component root
function locateNode (vnode) {
  return vnode.componentInstance && (!vnode.data || !vnode.data.transition)
    ? locateNode(vnode.componentInstance._vnode)
    : vnode
}

var show = {
  bind: function bind (el, ref, vnode) {
    var value = ref.value;

    vnode = locateNode(vnode);
    var transition$$1 = vnode.data && vnode.data.transition;
    var originalDisplay = el.__vOriginalDisplay =
      el.style.display === 'none' ? '' : el.style.display;
    if (value && transition$$1) {
      vnode.data.show = true;
      enter(vnode, function () {
        el.style.display = originalDisplay;
      });
    } else {
      el.style.display = value ? originalDisplay : 'none';
    }
  },

  update: function update (el, ref, vnode) {
    var value = ref.value;
    var oldValue = ref.oldValue;

    /* istanbul ignore if */
    if (!value === !oldValue) { return }
    vnode = locateNode(vnode);
    var transition$$1 = vnode.data && vnode.data.transition;
    if (transition$$1) {
      vnode.data.show = true;
      if (value) {
        enter(vnode, function () {
          el.style.display = el.__vOriginalDisplay;
        });
      } else {
        leave(vnode, function () {
          el.style.display = 'none';
        });
      }
    } else {
      el.style.display = value ? el.__vOriginalDisplay : 'none';
    }
  },

  unbind: function unbind (
    el,
    binding,
    vnode,
    oldVnode,
    isDestroy
  ) {
    if (!isDestroy) {
      el.style.display = el.__vOriginalDisplay;
    }
  }
};

var platformDirectives = {
  model: directive,
  show: show
};

/*  */

var transitionProps = {
  name: String,
  appear: Boolean,
  css: Boolean,
  mode: String,
  type: String,
  enterClass: String,
  leaveClass: String,
  enterToClass: String,
  leaveToClass: String,
  enterActiveClass: String,
  leaveActiveClass: String,
  appearClass: String,
  appearActiveClass: String,
  appearToClass: String,
  duration: [Number, String, Object]
};

// in case the child is also an abstract component, e.g. <keep-alive>
// we want to recursively retrieve the real component to be rendered
function getRealChild (vnode) {
  var compOptions = vnode && vnode.componentOptions;
  if (compOptions && compOptions.Ctor.options.abstract) {
    return getRealChild(getFirstComponentChild(compOptions.children))
  } else {
    return vnode
  }
}

function extractTransitionData (comp) {
  var data = {};
  var options = comp.$options;
  // props
  for (var key in options.propsData) {
    data[key] = comp[key];
  }
  // events.
  // extract listeners and pass them directly to the transition methods
  var listeners = options._parentListeners;
  for (var key$1 in listeners) {
    data[camelize(key$1)] = listeners[key$1];
  }
  return data
}

function placeholder (h, rawChild) {
  if (/\d-keep-alive$/.test(rawChild.tag)) {
    return h('keep-alive', {
      props: rawChild.componentOptions.propsData
    })
  }
}

function hasParentTransition (vnode) {
  while ((vnode = vnode.parent)) {
    if (vnode.data.transition) {
      return true
    }
  }
}

function isSameChild (child, oldChild) {
  return oldChild.key === child.key && oldChild.tag === child.tag
}

var isNotTextNode = function (c) { return c.tag || isAsyncPlaceholder(c); };

var isVShowDirective = function (d) { return d.name === 'show'; };

var Transition = {
  name: 'transition',
  props: transitionProps,
  abstract: true,

  render: function render (h) {
    var this$1 = this;

    var children = this.$slots.default;
    if (!children) {
      return
    }

    // filter out text nodes (possible whitespaces)
    children = children.filter(isNotTextNode);
    /* istanbul ignore if */
    if (!children.length) {
      return
    }

    // warn multiple elements
    if (false) {
      warn(
        '<transition> can only be used on a single element. Use ' +
        '<transition-group> for lists.',
        this.$parent
      );
    }

    var mode = this.mode;

    // warn invalid mode
    if (false
    ) {
      warn(
        'invalid <transition> mode: ' + mode,
        this.$parent
      );
    }

    var rawChild = children[0];

    // if this is a component root node and the component's
    // parent container node also has transition, skip.
    if (hasParentTransition(this.$vnode)) {
      return rawChild
    }

    // apply transition data to child
    // use getRealChild() to ignore abstract components e.g. keep-alive
    var child = getRealChild(rawChild);
    /* istanbul ignore if */
    if (!child) {
      return rawChild
    }

    if (this._leaving) {
      return placeholder(h, rawChild)
    }

    // ensure a key that is unique to the vnode type and to this transition
    // component instance. This key will be used to remove pending leaving nodes
    // during entering.
    var id = "__transition-" + (this._uid) + "-";
    child.key = child.key == null
      ? child.isComment
        ? id + 'comment'
        : id + child.tag
      : isPrimitive(child.key)
        ? (String(child.key).indexOf(id) === 0 ? child.key : id + child.key)
        : child.key;

    var data = (child.data || (child.data = {})).transition = extractTransitionData(this);
    var oldRawChild = this._vnode;
    var oldChild = getRealChild(oldRawChild);

    // mark v-show
    // so that the transition module can hand over the control to the directive
    if (child.data.directives && child.data.directives.some(isVShowDirective)) {
      child.data.show = true;
    }

    if (
      oldChild &&
      oldChild.data &&
      !isSameChild(child, oldChild) &&
      !isAsyncPlaceholder(oldChild) &&
      // #6687 component root is a comment node
      !(oldChild.componentInstance && oldChild.componentInstance._vnode.isComment)
    ) {
      // replace old child transition data with fresh one
      // important for dynamic transitions!
      var oldData = oldChild.data.transition = extend({}, data);
      // handle transition mode
      if (mode === 'out-in') {
        // return placeholder node and queue update when leave finishes
        this._leaving = true;
        mergeVNodeHook(oldData, 'afterLeave', function () {
          this$1._leaving = false;
          this$1.$forceUpdate();
        });
        return placeholder(h, rawChild)
      } else if (mode === 'in-out') {
        if (isAsyncPlaceholder(child)) {
          return oldRawChild
        }
        var delayedLeave;
        var performLeave = function () { delayedLeave(); };
        mergeVNodeHook(data, 'afterEnter', performLeave);
        mergeVNodeHook(data, 'enterCancelled', performLeave);
        mergeVNodeHook(oldData, 'delayLeave', function (leave) { delayedLeave = leave; });
      }
    }

    return rawChild
  }
};

/*  */

var props = extend({
  tag: String,
  moveClass: String
}, transitionProps);

delete props.mode;

var TransitionGroup = {
  props: props,

  beforeMount: function beforeMount () {
    var this$1 = this;

    var update = this._update;
    this._update = function (vnode, hydrating) {
      var restoreActiveInstance = setActiveInstance(this$1);
      // force removing pass
      this$1.__patch__(
        this$1._vnode,
        this$1.kept,
        false, // hydrating
        true // removeOnly (!important, avoids unnecessary moves)
      );
      this$1._vnode = this$1.kept;
      restoreActiveInstance();
      update.call(this$1, vnode, hydrating);
    };
  },

  render: function render (h) {
    var tag = this.tag || this.$vnode.data.tag || 'span';
    var map = Object.create(null);
    var prevChildren = this.prevChildren = this.children;
    var rawChildren = this.$slots.default || [];
    var children = this.children = [];
    var transitionData = extractTransitionData(this);

    for (var i = 0; i < rawChildren.length; i++) {
      var c = rawChildren[i];
      if (c.tag) {
        if (c.key != null && String(c.key).indexOf('__vlist') !== 0) {
          children.push(c);
          map[c.key] = c
          ;(c.data || (c.data = {})).transition = transitionData;
        } else if (false) {
          var opts = c.componentOptions;
          var name = opts ? (opts.Ctor.options.name || opts.tag || '') : c.tag;
          warn(("<transition-group> children must be keyed: <" + name + ">"));
        }
      }
    }

    if (prevChildren) {
      var kept = [];
      var removed = [];
      for (var i$1 = 0; i$1 < prevChildren.length; i$1++) {
        var c$1 = prevChildren[i$1];
        c$1.data.transition = transitionData;
        c$1.data.pos = c$1.elm.getBoundingClientRect();
        if (map[c$1.key]) {
          kept.push(c$1);
        } else {
          removed.push(c$1);
        }
      }
      this.kept = h(tag, null, kept);
      this.removed = removed;
    }

    return h(tag, null, children)
  },

  updated: function updated () {
    var children = this.prevChildren;
    var moveClass = this.moveClass || ((this.name || 'v') + '-move');
    if (!children.length || !this.hasMove(children[0].elm, moveClass)) {
      return
    }

    // we divide the work into three loops to avoid mixing DOM reads and writes
    // in each iteration - which helps prevent layout thrashing.
    children.forEach(callPendingCbs);
    children.forEach(recordPosition);
    children.forEach(applyTranslation);

    // force reflow to put everything in position
    // assign to this to avoid being removed in tree-shaking
    // $flow-disable-line
    this._reflow = document.body.offsetHeight;

    children.forEach(function (c) {
      if (c.data.moved) {
        var el = c.elm;
        var s = el.style;
        addTransitionClass(el, moveClass);
        s.transform = s.WebkitTransform = s.transitionDuration = '';
        el.addEventListener(transitionEndEvent, el._moveCb = function cb (e) {
          if (e && e.target !== el) {
            return
          }
          if (!e || /transform$/.test(e.propertyName)) {
            el.removeEventListener(transitionEndEvent, cb);
            el._moveCb = null;
            removeTransitionClass(el, moveClass);
          }
        });
      }
    });
  },

  methods: {
    hasMove: function hasMove (el, moveClass) {
      /* istanbul ignore if */
      if (!hasTransition) {
        return false
      }
      /* istanbul ignore if */
      if (this._hasMove) {
        return this._hasMove
      }
      // Detect whether an element with the move class applied has
      // CSS transitions. Since the element may be inside an entering
      // transition at this very moment, we make a clone of it and remove
      // all other transition classes applied to ensure only the move class
      // is applied.
      var clone = el.cloneNode();
      if (el._transitionClasses) {
        el._transitionClasses.forEach(function (cls) { removeClass(clone, cls); });
      }
      addClass(clone, moveClass);
      clone.style.display = 'none';
      this.$el.appendChild(clone);
      var info = getTransitionInfo(clone);
      this.$el.removeChild(clone);
      return (this._hasMove = info.hasTransform)
    }
  }
};

function callPendingCbs (c) {
  /* istanbul ignore if */
  if (c.elm._moveCb) {
    c.elm._moveCb();
  }
  /* istanbul ignore if */
  if (c.elm._enterCb) {
    c.elm._enterCb();
  }
}

function recordPosition (c) {
  c.data.newPos = c.elm.getBoundingClientRect();
}

function applyTranslation (c) {
  var oldPos = c.data.pos;
  var newPos = c.data.newPos;
  var dx = oldPos.left - newPos.left;
  var dy = oldPos.top - newPos.top;
  if (dx || dy) {
    c.data.moved = true;
    var s = c.elm.style;
    s.transform = s.WebkitTransform = "translate(" + dx + "px," + dy + "px)";
    s.transitionDuration = '0s';
  }
}

var platformComponents = {
  Transition: Transition,
  TransitionGroup: TransitionGroup
};

/*  */

// install platform specific utils
Vue.config.mustUseProp = mustUseProp;
Vue.config.isReservedTag = isReservedTag;
Vue.config.isReservedAttr = isReservedAttr;
Vue.config.getTagNamespace = getTagNamespace;
Vue.config.isUnknownElement = isUnknownElement;

// install platform runtime directives & components
extend(Vue.options.directives, platformDirectives);
extend(Vue.options.components, platformComponents);

// install platform patch function
Vue.prototype.__patch__ = inBrowser ? patch : noop;

// public mount method
Vue.prototype.$mount = function (
  el,
  hydrating
) {
  el = el && inBrowser ? query(el) : undefined;
  return mountComponent(this, el, hydrating)
};

// devtools global hook
/* istanbul ignore next */
if (inBrowser) {
  setTimeout(function () {
    if (config.devtools) {
      if (devtools) {
        devtools.emit('init', Vue);
      } else if (
        false
      ) {
        console[console.info ? 'info' : 'log'](
          'Download the Vue Devtools extension for a better development experience:\n' +
          'https://github.com/vuejs/vue-devtools'
        );
      }
    }
    if (false
    ) {
      console[console.info ? 'info' : 'log'](
        "You are running Vue in development mode.\n" +
        "Make sure to turn on production mode when deploying for production.\n" +
        "See more tips at https://vuejs.org/guide/deployment.html"
      );
    }
  }, 0);
}

/*  */

var defaultTagRE = /\{\{((?:.|\r?\n)+?)\}\}/g;
var regexEscapeRE = /[-.*+?^${}()|[\]\/\\]/g;

var buildRegex = cached(function (delimiters) {
  var open = delimiters[0].replace(regexEscapeRE, '\\$&');
  var close = delimiters[1].replace(regexEscapeRE, '\\$&');
  return new RegExp(open + '((?:.|\\n)+?)' + close, 'g')
});



function parseText (
  text,
  delimiters
) {
  var tagRE = delimiters ? buildRegex(delimiters) : defaultTagRE;
  if (!tagRE.test(text)) {
    return
  }
  var tokens = [];
  var rawTokens = [];
  var lastIndex = tagRE.lastIndex = 0;
  var match, index, tokenValue;
  while ((match = tagRE.exec(text))) {
    index = match.index;
    // push text token
    if (index > lastIndex) {
      rawTokens.push(tokenValue = text.slice(lastIndex, index));
      tokens.push(JSON.stringify(tokenValue));
    }
    // tag token
    var exp = parseFilters(match[1].trim());
    tokens.push(("_s(" + exp + ")"));
    rawTokens.push({ '@binding': exp });
    lastIndex = index + match[0].length;
  }
  if (lastIndex < text.length) {
    rawTokens.push(tokenValue = text.slice(lastIndex));
    tokens.push(JSON.stringify(tokenValue));
  }
  return {
    expression: tokens.join('+'),
    tokens: rawTokens
  }
}

/*  */

function transformNode (el, options) {
  var warn = options.warn || baseWarn;
  var staticClass = getAndRemoveAttr(el, 'class');
  if (false) {
    var res = parseText(staticClass, options.delimiters);
    if (res) {
      warn(
        "class=\"" + staticClass + "\": " +
        'Interpolation inside attributes has been removed. ' +
        'Use v-bind or the colon shorthand instead. For example, ' +
        'instead of <div class="{{ val }}">, use <div :class="val">.',
        el.rawAttrsMap['class']
      );
    }
  }
  if (staticClass) {
    el.staticClass = JSON.stringify(staticClass);
  }
  var classBinding = getBindingAttr(el, 'class', false /* getStatic */);
  if (classBinding) {
    el.classBinding = classBinding;
  }
}

function genData (el) {
  var data = '';
  if (el.staticClass) {
    data += "staticClass:" + (el.staticClass) + ",";
  }
  if (el.classBinding) {
    data += "class:" + (el.classBinding) + ",";
  }
  return data
}

var klass$1 = {
  staticKeys: ['staticClass'],
  transformNode: transformNode,
  genData: genData
};

/*  */

function transformNode$1 (el, options) {
  var warn = options.warn || baseWarn;
  var staticStyle = getAndRemoveAttr(el, 'style');
  if (staticStyle) {
    /* istanbul ignore if */
    if (false) {
      var res = parseText(staticStyle, options.delimiters);
      if (res) {
        warn(
          "style=\"" + staticStyle + "\": " +
          'Interpolation inside attributes has been removed. ' +
          'Use v-bind or the colon shorthand instead. For example, ' +
          'instead of <div style="{{ val }}">, use <div :style="val">.',
          el.rawAttrsMap['style']
        );
      }
    }
    el.staticStyle = JSON.stringify(parseStyleText(staticStyle));
  }

  var styleBinding = getBindingAttr(el, 'style', false /* getStatic */);
  if (styleBinding) {
    el.styleBinding = styleBinding;
  }
}

function genData$1 (el) {
  var data = '';
  if (el.staticStyle) {
    data += "staticStyle:" + (el.staticStyle) + ",";
  }
  if (el.styleBinding) {
    data += "style:(" + (el.styleBinding) + "),";
  }
  return data
}

var style$1 = {
  staticKeys: ['staticStyle'],
  transformNode: transformNode$1,
  genData: genData$1
};

/*  */

var decoder;

var he = {
  decode: function decode (html) {
    decoder = decoder || document.createElement('div');
    decoder.innerHTML = html;
    return decoder.textContent
  }
};

/*  */

var isUnaryTag = makeMap(
  'area,base,br,col,embed,frame,hr,img,input,isindex,keygen,' +
  'link,meta,param,source,track,wbr'
);

// Elements that you can, intentionally, leave open
// (and which close themselves)
var canBeLeftOpenTag = makeMap(
  'colgroup,dd,dt,li,options,p,td,tfoot,th,thead,tr,source'
);

// HTML5 tags https://html.spec.whatwg.org/multipage/indices.html#elements-3
// Phrasing Content https://html.spec.whatwg.org/multipage/dom.html#phrasing-content
var isNonPhrasingTag = makeMap(
  'address,article,aside,base,blockquote,body,caption,col,colgroup,dd,' +
  'details,dialog,div,dl,dt,fieldset,figcaption,figure,footer,form,' +
  'h1,h2,h3,h4,h5,h6,head,header,hgroup,hr,html,legend,li,menuitem,meta,' +
  'optgroup,option,param,rp,rt,source,style,summary,tbody,td,tfoot,th,thead,' +
  'title,tr,track'
);

/**
 * Not type-checking this file because it's mostly vendor code.
 */

// Regular Expressions for parsing tags and attributes
var attribute = /^\s*([^\s"'<>\/=]+)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/;
var dynamicArgAttribute = /^\s*((?:v-[\w-]+:|@|:|#)\[[^=]+\][^\s"'<>\/=]*)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/;
var ncname = "[a-zA-Z_][\\-\\.0-9_a-zA-Z" + (unicodeRegExp.source) + "]*";
var qnameCapture = "((?:" + ncname + "\\:)?" + ncname + ")";
var startTagOpen = new RegExp(("^<" + qnameCapture));
var startTagClose = /^\s*(\/?)>/;
var endTag = new RegExp(("^<\\/" + qnameCapture + "[^>]*>"));
var doctype = /^<!DOCTYPE [^>]+>/i;
// #7298: escape - to avoid being passed as HTML comment when inlined in page
var comment = /^<!\--/;
var conditionalComment = /^<!\[/;

// Special Elements (can contain anything)
var isPlainTextElement = makeMap('script,style,textarea', true);
var reCache = {};

var decodingMap = {
  '&lt;': '<',
  '&gt;': '>',
  '&quot;': '"',
  '&amp;': '&',
  '&#10;': '\n',
  '&#9;': '\t',
  '&#39;': "'"
};
var encodedAttr = /&(?:lt|gt|quot|amp|#39);/g;
var encodedAttrWithNewLines = /&(?:lt|gt|quot|amp|#39|#10|#9);/g;

// #5992
var isIgnoreNewlineTag = makeMap('pre,textarea', true);
var shouldIgnoreFirstNewline = function (tag, html) { return tag && isIgnoreNewlineTag(tag) && html[0] === '\n'; };

function decodeAttr (value, shouldDecodeNewlines) {
  var re = shouldDecodeNewlines ? encodedAttrWithNewLines : encodedAttr;
  return value.replace(re, function (match) { return decodingMap[match]; })
}

function parseHTML (html, options) {
  var stack = [];
  var expectHTML = options.expectHTML;
  var isUnaryTag$$1 = options.isUnaryTag || no;
  var canBeLeftOpenTag$$1 = options.canBeLeftOpenTag || no;
  var index = 0;
  var last, lastTag;
  while (html) {
    last = html;
    // Make sure we're not in a plaintext content element like script/style
    if (!lastTag || !isPlainTextElement(lastTag)) {
      var textEnd = html.indexOf('<');
      if (textEnd === 0) {
        // Comment:
        if (comment.test(html)) {
          var commentEnd = html.indexOf('-->');

          if (commentEnd >= 0) {
            if (options.shouldKeepComment) {
              options.comment(html.substring(4, commentEnd), index, index + commentEnd + 3);
            }
            advance(commentEnd + 3);
            continue
          }
        }

        // http://en.wikipedia.org/wiki/Conditional_comment#Downlevel-revealed_conditional_comment
        if (conditionalComment.test(html)) {
          var conditionalEnd = html.indexOf(']>');

          if (conditionalEnd >= 0) {
            advance(conditionalEnd + 2);
            continue
          }
        }

        // Doctype:
        var doctypeMatch = html.match(doctype);
        if (doctypeMatch) {
          advance(doctypeMatch[0].length);
          continue
        }

        // End tag:
        var endTagMatch = html.match(endTag);
        if (endTagMatch) {
          var curIndex = index;
          advance(endTagMatch[0].length);
          parseEndTag(endTagMatch[1], curIndex, index);
          continue
        }

        // Start tag:
        var startTagMatch = parseStartTag();
        if (startTagMatch) {
          handleStartTag(startTagMatch);
          if (shouldIgnoreFirstNewline(startTagMatch.tagName, html)) {
            advance(1);
          }
          continue
        }
      }

      var text = (void 0), rest = (void 0), next = (void 0);
      if (textEnd >= 0) {
        rest = html.slice(textEnd);
        while (
          !endTag.test(rest) &&
          !startTagOpen.test(rest) &&
          !comment.test(rest) &&
          !conditionalComment.test(rest)
        ) {
          // < in plain text, be forgiving and treat it as text
          next = rest.indexOf('<', 1);
          if (next < 0) { break }
          textEnd += next;
          rest = html.slice(textEnd);
        }
        text = html.substring(0, textEnd);
      }

      if (textEnd < 0) {
        text = html;
      }

      if (text) {
        advance(text.length);
      }

      if (options.chars && text) {
        options.chars(text, index - text.length, index);
      }
    } else {
      var endTagLength = 0;
      var stackedTag = lastTag.toLowerCase();
      var reStackedTag = reCache[stackedTag] || (reCache[stackedTag] = new RegExp('([\\s\\S]*?)(</' + stackedTag + '[^>]*>)', 'i'));
      var rest$1 = html.replace(reStackedTag, function (all, text, endTag) {
        endTagLength = endTag.length;
        if (!isPlainTextElement(stackedTag) && stackedTag !== 'noscript') {
          text = text
            .replace(/<!\--([\s\S]*?)-->/g, '$1') // #7298
            .replace(/<!\[CDATA\[([\s\S]*?)]]>/g, '$1');
        }
        if (shouldIgnoreFirstNewline(stackedTag, text)) {
          text = text.slice(1);
        }
        if (options.chars) {
          options.chars(text);
        }
        return ''
      });
      index += html.length - rest$1.length;
      html = rest$1;
      parseEndTag(stackedTag, index - endTagLength, index);
    }

    if (html === last) {
      options.chars && options.chars(html);
      if (false) {
        options.warn(("Mal-formatted tag at end of template: \"" + html + "\""), { start: index + html.length });
      }
      break
    }
  }

  // Clean up any remaining tags
  parseEndTag();

  function advance (n) {
    index += n;
    html = html.substring(n);
  }

  function parseStartTag () {
    var start = html.match(startTagOpen);
    if (start) {
      var match = {
        tagName: start[1],
        attrs: [],
        start: index
      };
      advance(start[0].length);
      var end, attr;
      while (!(end = html.match(startTagClose)) && (attr = html.match(dynamicArgAttribute) || html.match(attribute))) {
        attr.start = index;
        advance(attr[0].length);
        attr.end = index;
        match.attrs.push(attr);
      }
      if (end) {
        match.unarySlash = end[1];
        advance(end[0].length);
        match.end = index;
        return match
      }
    }
  }

  function handleStartTag (match) {
    var tagName = match.tagName;
    var unarySlash = match.unarySlash;

    if (expectHTML) {
      if (lastTag === 'p' && isNonPhrasingTag(tagName)) {
        parseEndTag(lastTag);
      }
      if (canBeLeftOpenTag$$1(tagName) && lastTag === tagName) {
        parseEndTag(tagName);
      }
    }

    var unary = isUnaryTag$$1(tagName) || !!unarySlash;

    var l = match.attrs.length;
    var attrs = new Array(l);
    for (var i = 0; i < l; i++) {
      var args = match.attrs[i];
      var value = args[3] || args[4] || args[5] || '';
      var shouldDecodeNewlines = tagName === 'a' && args[1] === 'href'
        ? options.shouldDecodeNewlinesForHref
        : options.shouldDecodeNewlines;
      attrs[i] = {
        name: args[1],
        value: decodeAttr(value, shouldDecodeNewlines)
      };
      if (false) {
        attrs[i].start = args.start + args[0].match(/^\s*/).length;
        attrs[i].end = args.end;
      }
    }

    if (!unary) {
      stack.push({ tag: tagName, lowerCasedTag: tagName.toLowerCase(), attrs: attrs, start: match.start, end: match.end });
      lastTag = tagName;
    }

    if (options.start) {
      options.start(tagName, attrs, unary, match.start, match.end);
    }
  }

  function parseEndTag (tagName, start, end) {
    var pos, lowerCasedTagName;
    if (start == null) { start = index; }
    if (end == null) { end = index; }

    // Find the closest opened tag of the same type
    if (tagName) {
      lowerCasedTagName = tagName.toLowerCase();
      for (pos = stack.length - 1; pos >= 0; pos--) {
        if (stack[pos].lowerCasedTag === lowerCasedTagName) {
          break
        }
      }
    } else {
      // If no tag name is provided, clean shop
      pos = 0;
    }

    if (pos >= 0) {
      // Close all the open elements, up the stack
      for (var i = stack.length - 1; i >= pos; i--) {
        if (false
        ) {
          options.warn(
            ("tag <" + (stack[i].tag) + "> has no matching end tag."),
            { start: stack[i].start, end: stack[i].end }
          );
        }
        if (options.end) {
          options.end(stack[i].tag, start, end);
        }
      }

      // Remove the open elements from the stack
      stack.length = pos;
      lastTag = pos && stack[pos - 1].tag;
    } else if (lowerCasedTagName === 'br') {
      if (options.start) {
        options.start(tagName, [], true, start, end);
      }
    } else if (lowerCasedTagName === 'p') {
      if (options.start) {
        options.start(tagName, [], false, start, end);
      }
      if (options.end) {
        options.end(tagName, start, end);
      }
    }
  }
}

/*  */

var onRE = /^@|^v-on:/;
var dirRE = /^v-|^@|^:|^#/;
var forAliasRE = /([\s\S]*?)\s+(?:in|of)\s+([\s\S]*)/;
var forIteratorRE = /,([^,\}\]]*)(?:,([^,\}\]]*))?$/;
var stripParensRE = /^\(|\)$/g;
var dynamicArgRE = /^\[.*\]$/;

var argRE = /:(.*)$/;
var bindRE = /^:|^\.|^v-bind:/;
var modifierRE = /\.[^.\]]+(?=[^\]]*$)/g;

var slotRE = /^v-slot(:|$)|^#/;

var lineBreakRE = /[\r\n]/;
var whitespaceRE$1 = /\s+/g;

var invalidAttributeRE = /[\s"'<>\/=]/;

var decodeHTMLCached = cached(he.decode);

var emptySlotScopeToken = "_empty_";

// configurable state
var warn$2;
var delimiters;
var transforms;
var preTransforms;
var postTransforms;
var platformIsPreTag;
var platformMustUseProp;
var platformGetTagNamespace;
var maybeComponent;

function createASTElement (
  tag,
  attrs,
  parent
) {
  return {
    type: 1,
    tag: tag,
    attrsList: attrs,
    attrsMap: makeAttrsMap(attrs),
    rawAttrsMap: {},
    parent: parent,
    children: []
  }
}

/**
 * Convert HTML string to AST.
 */
function parse (
  template,
  options
) {
  warn$2 = options.warn || baseWarn;

  platformIsPreTag = options.isPreTag || no;
  platformMustUseProp = options.mustUseProp || no;
  platformGetTagNamespace = options.getTagNamespace || no;
  var isReservedTag = options.isReservedTag || no;
  maybeComponent = function (el) { return !!el.component || !isReservedTag(el.tag); };

  transforms = pluckModuleFunction(options.modules, 'transformNode');
  preTransforms = pluckModuleFunction(options.modules, 'preTransformNode');
  postTransforms = pluckModuleFunction(options.modules, 'postTransformNode');

  delimiters = options.delimiters;

  var stack = [];
  var preserveWhitespace = options.preserveWhitespace !== false;
  var whitespaceOption = options.whitespace;
  var root;
  var currentParent;
  var inVPre = false;
  var inPre = false;
  var warned = false;

  function warnOnce (msg, range) {
    if (!warned) {
      warned = true;
      warn$2(msg, range);
    }
  }

  function closeElement (element) {
    trimEndingWhitespace(element);
    if (!inVPre && !element.processed) {
      element = processElement(element, options);
    }
    // tree management
    if (!stack.length && element !== root) {
      // allow root elements with v-if, v-else-if and v-else
      if (root.if && (element.elseif || element.else)) {
        if (false) {
          checkRootConstraints(element);
        }
        addIfCondition(root, {
          exp: element.elseif,
          block: element
        });
      } else if (false) {
        warnOnce(
          "Component template should contain exactly one root element. " +
          "If you are using v-if on multiple elements, " +
          "use v-else-if to chain them instead.",
          { start: element.start }
        );
      }
    }
    if (currentParent && !element.forbidden) {
      if (element.elseif || element.else) {
        processIfConditions(element, currentParent);
      } else {
        if (element.slotScope) {
          // scoped slot
          // keep it in the children list so that v-else(-if) conditions can
          // find it as the prev node.
          var name = element.slotTarget || '"default"'
          ;(currentParent.scopedSlots || (currentParent.scopedSlots = {}))[name] = element;
        }
        currentParent.children.push(element);
        element.parent = currentParent;
      }
    }

    // final children cleanup
    // filter out scoped slots
    element.children = element.children.filter(function (c) { return !(c).slotScope; });
    // remove trailing whitespace node again
    trimEndingWhitespace(element);

    // check pre state
    if (element.pre) {
      inVPre = false;
    }
    if (platformIsPreTag(element.tag)) {
      inPre = false;
    }
    // apply post-transforms
    for (var i = 0; i < postTransforms.length; i++) {
      postTransforms[i](element, options);
    }
  }

  function trimEndingWhitespace (el) {
    // remove trailing whitespace node
    if (!inPre) {
      var lastNode;
      while (
        (lastNode = el.children[el.children.length - 1]) &&
        lastNode.type === 3 &&
        lastNode.text === ' '
      ) {
        el.children.pop();
      }
    }
  }

  function checkRootConstraints (el) {
    if (el.tag === 'slot' || el.tag === 'template') {
      warnOnce(
        "Cannot use <" + (el.tag) + "> as component root element because it may " +
        'contain multiple nodes.',
        { start: el.start }
      );
    }
    if (el.attrsMap.hasOwnProperty('v-for')) {
      warnOnce(
        'Cannot use v-for on stateful component root element because ' +
        'it renders multiple elements.',
        el.rawAttrsMap['v-for']
      );
    }
  }

  parseHTML(template, {
    warn: warn$2,
    expectHTML: options.expectHTML,
    isUnaryTag: options.isUnaryTag,
    canBeLeftOpenTag: options.canBeLeftOpenTag,
    shouldDecodeNewlines: options.shouldDecodeNewlines,
    shouldDecodeNewlinesForHref: options.shouldDecodeNewlinesForHref,
    shouldKeepComment: options.comments,
    outputSourceRange: options.outputSourceRange,
    start: function start (tag, attrs, unary, start$1, end) {
      // check namespace.
      // inherit parent ns if there is one
      var ns = (currentParent && currentParent.ns) || platformGetTagNamespace(tag);

      // handle IE svg bug
      /* istanbul ignore if */
      if (isIE && ns === 'svg') {
        attrs = guardIESVGBug(attrs);
      }

      var element = createASTElement(tag, attrs, currentParent);
      if (ns) {
        element.ns = ns;
      }

      if (false) {
        if (options.outputSourceRange) {
          element.start = start$1;
          element.end = end;
          element.rawAttrsMap = element.attrsList.reduce(function (cumulated, attr) {
            cumulated[attr.name] = attr;
            return cumulated
          }, {});
        }
        attrs.forEach(function (attr) {
          if (invalidAttributeRE.test(attr.name)) {
            warn$2(
              "Invalid dynamic argument expression: attribute names cannot contain " +
              "spaces, quotes, <, >, / or =.",
              {
                start: attr.start + attr.name.indexOf("["),
                end: attr.start + attr.name.length
              }
            );
          }
        });
      }

      if (isForbiddenTag(element) && !isServerRendering()) {
        element.forbidden = true;
        "production" !== 'production' && warn$2(
          'Templates should only be responsible for mapping the state to the ' +
          'UI. Avoid placing tags with side-effects in your templates, such as ' +
          "<" + tag + ">" + ', as they will not be parsed.',
          { start: element.start }
        );
      }

      // apply pre-transforms
      for (var i = 0; i < preTransforms.length; i++) {
        element = preTransforms[i](element, options) || element;
      }

      if (!inVPre) {
        processPre(element);
        if (element.pre) {
          inVPre = true;
        }
      }
      if (platformIsPreTag(element.tag)) {
        inPre = true;
      }
      if (inVPre) {
        processRawAttrs(element);
      } else if (!element.processed) {
        // structural directives
        processFor(element);
        processIf(element);
        processOnce(element);
      }

      if (!root) {
        root = element;
        if (false) {
          checkRootConstraints(root);
        }
      }

      if (!unary) {
        currentParent = element;
        stack.push(element);
      } else {
        closeElement(element);
      }
    },

    end: function end (tag, start, end$1) {
      var element = stack[stack.length - 1];
      // pop stack
      stack.length -= 1;
      currentParent = stack[stack.length - 1];
      if (false) {
        element.end = end$1;
      }
      closeElement(element);
    },

    chars: function chars (text, start, end) {
      if (!currentParent) {
        if (false) {
          if (text === template) {
            warnOnce(
              'Component template requires a root element, rather than just text.',
              { start: start }
            );
          } else if ((text = text.trim())) {
            warnOnce(
              ("text \"" + text + "\" outside root element will be ignored."),
              { start: start }
            );
          }
        }
        return
      }
      // IE textarea placeholder bug
      /* istanbul ignore if */
      if (isIE &&
        currentParent.tag === 'textarea' &&
        currentParent.attrsMap.placeholder === text
      ) {
        return
      }
      var children = currentParent.children;
      if (inPre || text.trim()) {
        text = isTextTag(currentParent) ? text : decodeHTMLCached(text);
      } else if (!children.length) {
        // remove the whitespace-only node right after an opening tag
        text = '';
      } else if (whitespaceOption) {
        if (whitespaceOption === 'condense') {
          // in condense mode, remove the whitespace node if it contains
          // line break, otherwise condense to a single space
          text = lineBreakRE.test(text) ? '' : ' ';
        } else {
          text = ' ';
        }
      } else {
        text = preserveWhitespace ? ' ' : '';
      }
      if (text) {
        if (!inPre && whitespaceOption === 'condense') {
          // condense consecutive whitespaces into single space
          text = text.replace(whitespaceRE$1, ' ');
        }
        var res;
        var child;
        if (!inVPre && text !== ' ' && (res = parseText(text, delimiters))) {
          child = {
            type: 2,
            expression: res.expression,
            tokens: res.tokens,
            text: text
          };
        } else if (text !== ' ' || !children.length || children[children.length - 1].text !== ' ') {
          child = {
            type: 3,
            text: text
          };
        }
        if (child) {
          if (false) {
            child.start = start;
            child.end = end;
          }
          children.push(child);
        }
      }
    },
    comment: function comment (text, start, end) {
      // adding anything as a sibling to the root node is forbidden
      // comments should still be allowed, but ignored
      if (currentParent) {
        var child = {
          type: 3,
          text: text,
          isComment: true
        };
        if (false) {
          child.start = start;
          child.end = end;
        }
        currentParent.children.push(child);
      }
    }
  });
  return root
}

function processPre (el) {
  if (getAndRemoveAttr(el, 'v-pre') != null) {
    el.pre = true;
  }
}

function processRawAttrs (el) {
  var list = el.attrsList;
  var len = list.length;
  if (len) {
    var attrs = el.attrs = new Array(len);
    for (var i = 0; i < len; i++) {
      attrs[i] = {
        name: list[i].name,
        value: JSON.stringify(list[i].value)
      };
      if (list[i].start != null) {
        attrs[i].start = list[i].start;
        attrs[i].end = list[i].end;
      }
    }
  } else if (!el.pre) {
    // non root node in pre blocks with no attributes
    el.plain = true;
  }
}

function processElement (
  element,
  options
) {
  processKey(element);

  // determine whether this is a plain element after
  // removing structural attributes
  element.plain = (
    !element.key &&
    !element.scopedSlots &&
    !element.attrsList.length
  );

  processRef(element);
  processSlotContent(element);
  processSlotOutlet(element);
  processComponent(element);
  for (var i = 0; i < transforms.length; i++) {
    element = transforms[i](element, options) || element;
  }
  processAttrs(element);
  return element
}

function processKey (el) {
  var exp = getBindingAttr(el, 'key');
  if (exp) {
    if (false) {
      if (el.tag === 'template') {
        warn$2(
          "<template> cannot be keyed. Place the key on real elements instead.",
          getRawBindingAttr(el, 'key')
        );
      }
      if (el.for) {
        var iterator = el.iterator2 || el.iterator1;
        var parent = el.parent;
        if (iterator && iterator === exp && parent && parent.tag === 'transition-group') {
          warn$2(
            "Do not use v-for index as key on <transition-group> children, " +
            "this is the same as not using keys.",
            getRawBindingAttr(el, 'key'),
            true /* tip */
          );
        }
      }
    }
    el.key = exp;
  }
}

function processRef (el) {
  var ref = getBindingAttr(el, 'ref');
  if (ref) {
    el.ref = ref;
    el.refInFor = checkInFor(el);
  }
}

function processFor (el) {
  var exp;
  if ((exp = getAndRemoveAttr(el, 'v-for'))) {
    var res = parseFor(exp);
    if (res) {
      extend(el, res);
    } else if (false) {
      warn$2(
        ("Invalid v-for expression: " + exp),
        el.rawAttrsMap['v-for']
      );
    }
  }
}



function parseFor (exp) {
  var inMatch = exp.match(forAliasRE);
  if (!inMatch) { return }
  var res = {};
  res.for = inMatch[2].trim();
  var alias = inMatch[1].trim().replace(stripParensRE, '');
  var iteratorMatch = alias.match(forIteratorRE);
  if (iteratorMatch) {
    res.alias = alias.replace(forIteratorRE, '').trim();
    res.iterator1 = iteratorMatch[1].trim();
    if (iteratorMatch[2]) {
      res.iterator2 = iteratorMatch[2].trim();
    }
  } else {
    res.alias = alias;
  }
  return res
}

function processIf (el) {
  var exp = getAndRemoveAttr(el, 'v-if');
  if (exp) {
    el.if = exp;
    addIfCondition(el, {
      exp: exp,
      block: el
    });
  } else {
    if (getAndRemoveAttr(el, 'v-else') != null) {
      el.else = true;
    }
    var elseif = getAndRemoveAttr(el, 'v-else-if');
    if (elseif) {
      el.elseif = elseif;
    }
  }
}

function processIfConditions (el, parent) {
  var prev = findPrevElement(parent.children);
  if (prev && prev.if) {
    addIfCondition(prev, {
      exp: el.elseif,
      block: el
    });
  } else if (false) {
    warn$2(
      "v-" + (el.elseif ? ('else-if="' + el.elseif + '"') : 'else') + " " +
      "used on element <" + (el.tag) + "> without corresponding v-if.",
      el.rawAttrsMap[el.elseif ? 'v-else-if' : 'v-else']
    );
  }
}

function findPrevElement (children) {
  var i = children.length;
  while (i--) {
    if (children[i].type === 1) {
      return children[i]
    } else {
      if (false) {
        warn$2(
          "text \"" + (children[i].text.trim()) + "\" between v-if and v-else(-if) " +
          "will be ignored.",
          children[i]
        );
      }
      children.pop();
    }
  }
}

function addIfCondition (el, condition) {
  if (!el.ifConditions) {
    el.ifConditions = [];
  }
  el.ifConditions.push(condition);
}

function processOnce (el) {
  var once$$1 = getAndRemoveAttr(el, 'v-once');
  if (once$$1 != null) {
    el.once = true;
  }
}

// handle content being passed to a component as slot,
// e.g. <template slot="xxx">, <div slot-scope="xxx">
function processSlotContent (el) {
  var slotScope;
  if (el.tag === 'template') {
    slotScope = getAndRemoveAttr(el, 'scope');
    /* istanbul ignore if */
    if (false) {
      warn$2(
        "the \"scope\" attribute for scoped slots have been deprecated and " +
        "replaced by \"slot-scope\" since 2.5. The new \"slot-scope\" attribute " +
        "can also be used on plain elements in addition to <template> to " +
        "denote scoped slots.",
        el.rawAttrsMap['scope'],
        true
      );
    }
    el.slotScope = slotScope || getAndRemoveAttr(el, 'slot-scope');
  } else if ((slotScope = getAndRemoveAttr(el, 'slot-scope'))) {
    /* istanbul ignore if */
    if (false) {
      warn$2(
        "Ambiguous combined usage of slot-scope and v-for on <" + (el.tag) + "> " +
        "(v-for takes higher priority). Use a wrapper <template> for the " +
        "scoped slot to make it clearer.",
        el.rawAttrsMap['slot-scope'],
        true
      );
    }
    el.slotScope = slotScope;
  }

  // slot="xxx"
  var slotTarget = getBindingAttr(el, 'slot');
  if (slotTarget) {
    el.slotTarget = slotTarget === '""' ? '"default"' : slotTarget;
    el.slotTargetDynamic = !!(el.attrsMap[':slot'] || el.attrsMap['v-bind:slot']);
    // preserve slot as an attribute for native shadow DOM compat
    // only for non-scoped slots.
    if (el.tag !== 'template' && !el.slotScope) {
      addAttr(el, 'slot', slotTarget, getRawBindingAttr(el, 'slot'));
    }
  }

  // 2.6 v-slot syntax
  {
    if (el.tag === 'template') {
      // v-slot on <template>
      var slotBinding = getAndRemoveAttrByRegex(el, slotRE);
      if (slotBinding) {
        if (false) {
          if (el.slotTarget || el.slotScope) {
            warn$2(
              "Unexpected mixed usage of different slot syntaxes.",
              el
            );
          }
          if (el.parent && !maybeComponent(el.parent)) {
            warn$2(
              "<template v-slot> can only appear at the root level inside " +
              "the receiving component",
              el
            );
          }
        }
        var ref = getSlotName(slotBinding);
        var name = ref.name;
        var dynamic = ref.dynamic;
        el.slotTarget = name;
        el.slotTargetDynamic = dynamic;
        el.slotScope = slotBinding.value || emptySlotScopeToken; // force it into a scoped slot for perf
      }
    } else {
      // v-slot on component, denotes default slot
      var slotBinding$1 = getAndRemoveAttrByRegex(el, slotRE);
      if (slotBinding$1) {
        if (false) {
          if (!maybeComponent(el)) {
            warn$2(
              "v-slot can only be used on components or <template>.",
              slotBinding$1
            );
          }
          if (el.slotScope || el.slotTarget) {
            warn$2(
              "Unexpected mixed usage of different slot syntaxes.",
              el
            );
          }
          if (el.scopedSlots) {
            warn$2(
              "To avoid scope ambiguity, the default slot should also use " +
              "<template> syntax when there are other named slots.",
              slotBinding$1
            );
          }
        }
        // add the component's children to its default slot
        var slots = el.scopedSlots || (el.scopedSlots = {});
        var ref$1 = getSlotName(slotBinding$1);
        var name$1 = ref$1.name;
        var dynamic$1 = ref$1.dynamic;
        var slotContainer = slots[name$1] = createASTElement('template', [], el);
        slotContainer.slotTarget = name$1;
        slotContainer.slotTargetDynamic = dynamic$1;
        slotContainer.children = el.children.filter(function (c) {
          if (!c.slotScope) {
            c.parent = slotContainer;
            return true
          }
        });
        slotContainer.slotScope = slotBinding$1.value || emptySlotScopeToken;
        // remove children as they are returned from scopedSlots now
        el.children = [];
        // mark el non-plain so data gets generated
        el.plain = false;
      }
    }
  }
}

function getSlotName (binding) {
  var name = binding.name.replace(slotRE, '');
  if (!name) {
    if (binding.name[0] !== '#') {
      name = 'default';
    } else if (false) {
      warn$2(
        "v-slot shorthand syntax requires a slot name.",
        binding
      );
    }
  }
  return dynamicArgRE.test(name)
    // dynamic [name]
    ? { name: name.slice(1, -1), dynamic: true }
    // static name
    : { name: ("\"" + name + "\""), dynamic: false }
}

// handle <slot/> outlets
function processSlotOutlet (el) {
  if (el.tag === 'slot') {
    el.slotName = getBindingAttr(el, 'name');
    if (false) {
      warn$2(
        "`key` does not work on <slot> because slots are abstract outlets " +
        "and can possibly expand into multiple elements. " +
        "Use the key on a wrapping element instead.",
        getRawBindingAttr(el, 'key')
      );
    }
  }
}

function processComponent (el) {
  var binding;
  if ((binding = getBindingAttr(el, 'is'))) {
    el.component = binding;
  }
  if (getAndRemoveAttr(el, 'inline-template') != null) {
    el.inlineTemplate = true;
  }
}

function processAttrs (el) {
  var list = el.attrsList;
  var i, l, name, rawName, value, modifiers, syncGen, isDynamic;
  for (i = 0, l = list.length; i < l; i++) {
    name = rawName = list[i].name;
    value = list[i].value;
    if (dirRE.test(name)) {
      // mark element as dynamic
      el.hasBindings = true;
      // modifiers
      modifiers = parseModifiers(name.replace(dirRE, ''));
      // support .foo shorthand syntax for the .prop modifier
      if (modifiers) {
        name = name.replace(modifierRE, '');
      }
      if (bindRE.test(name)) { // v-bind
        name = name.replace(bindRE, '');
        value = parseFilters(value);
        isDynamic = dynamicArgRE.test(name);
        if (isDynamic) {
          name = name.slice(1, -1);
        }
        if (
          false
        ) {
          warn$2(
            ("The value for a v-bind expression cannot be empty. Found in \"v-bind:" + name + "\"")
          );
        }
        if (modifiers) {
          if (modifiers.prop && !isDynamic) {
            name = camelize(name);
            if (name === 'innerHtml') { name = 'innerHTML'; }
          }
          if (modifiers.camel && !isDynamic) {
            name = camelize(name);
          }
          if (modifiers.sync) {
            syncGen = genAssignmentCode(value, "$event");
            if (!isDynamic) {
              addHandler(
                el,
                ("update:" + (camelize(name))),
                syncGen,
                null,
                false,
                warn$2,
                list[i]
              );
              if (hyphenate(name) !== camelize(name)) {
                addHandler(
                  el,
                  ("update:" + (hyphenate(name))),
                  syncGen,
                  null,
                  false,
                  warn$2,
                  list[i]
                );
              }
            } else {
              // handler w/ dynamic event name
              addHandler(
                el,
                ("\"update:\"+(" + name + ")"),
                syncGen,
                null,
                false,
                warn$2,
                list[i],
                true // dynamic
              );
            }
          }
        }
        if ((modifiers && modifiers.prop) || (
          !el.component && platformMustUseProp(el.tag, el.attrsMap.type, name)
        )) {
          addProp(el, name, value, list[i], isDynamic);
        } else {
          addAttr(el, name, value, list[i], isDynamic);
        }
      } else if (onRE.test(name)) { // v-on
        name = name.replace(onRE, '');
        isDynamic = dynamicArgRE.test(name);
        if (isDynamic) {
          name = name.slice(1, -1);
        }
        addHandler(el, name, value, modifiers, false, warn$2, list[i], isDynamic);
      } else { // normal directives
        name = name.replace(dirRE, '');
        // parse arg
        var argMatch = name.match(argRE);
        var arg = argMatch && argMatch[1];
        isDynamic = false;
        if (arg) {
          name = name.slice(0, -(arg.length + 1));
          if (dynamicArgRE.test(arg)) {
            arg = arg.slice(1, -1);
            isDynamic = true;
          }
        }
        addDirective(el, name, rawName, value, arg, isDynamic, modifiers, list[i]);
        if (false) {
          checkForAliasModel(el, value);
        }
      }
    } else {
      // literal attribute
      if (false) {
        var res = parseText(value, delimiters);
        if (res) {
          warn$2(
            name + "=\"" + value + "\": " +
            'Interpolation inside attributes has been removed. ' +
            'Use v-bind or the colon shorthand instead. For example, ' +
            'instead of <div id="{{ val }}">, use <div :id="val">.',
            list[i]
          );
        }
      }
      addAttr(el, name, JSON.stringify(value), list[i]);
      // #6887 firefox doesn't update muted state if set via attribute
      // even immediately after element creation
      if (!el.component &&
          name === 'muted' &&
          platformMustUseProp(el.tag, el.attrsMap.type, name)) {
        addProp(el, name, 'true', list[i]);
      }
    }
  }
}

function checkInFor (el) {
  var parent = el;
  while (parent) {
    if (parent.for !== undefined) {
      return true
    }
    parent = parent.parent;
  }
  return false
}

function parseModifiers (name) {
  var match = name.match(modifierRE);
  if (match) {
    var ret = {};
    match.forEach(function (m) { ret[m.slice(1)] = true; });
    return ret
  }
}

function makeAttrsMap (attrs) {
  var map = {};
  for (var i = 0, l = attrs.length; i < l; i++) {
    if (
      false
    ) {
      warn$2('duplicate attribute: ' + attrs[i].name, attrs[i]);
    }
    map[attrs[i].name] = attrs[i].value;
  }
  return map
}

// for script (e.g. type="x/template") or style, do not decode content
function isTextTag (el) {
  return el.tag === 'script' || el.tag === 'style'
}

function isForbiddenTag (el) {
  return (
    el.tag === 'style' ||
    (el.tag === 'script' && (
      !el.attrsMap.type ||
      el.attrsMap.type === 'text/javascript'
    ))
  )
}

var ieNSBug = /^xmlns:NS\d+/;
var ieNSPrefix = /^NS\d+:/;

/* istanbul ignore next */
function guardIESVGBug (attrs) {
  var res = [];
  for (var i = 0; i < attrs.length; i++) {
    var attr = attrs[i];
    if (!ieNSBug.test(attr.name)) {
      attr.name = attr.name.replace(ieNSPrefix, '');
      res.push(attr);
    }
  }
  return res
}

function checkForAliasModel (el, value) {
  var _el = el;
  while (_el) {
    if (_el.for && _el.alias === value) {
      warn$2(
        "<" + (el.tag) + " v-model=\"" + value + "\">: " +
        "You are binding v-model directly to a v-for iteration alias. " +
        "This will not be able to modify the v-for source array because " +
        "writing to the alias is like modifying a function local variable. " +
        "Consider using an array of objects and use v-model on an object property instead.",
        el.rawAttrsMap['v-model']
      );
    }
    _el = _el.parent;
  }
}

/*  */

function preTransformNode (el, options) {
  if (el.tag === 'input') {
    var map = el.attrsMap;
    if (!map['v-model']) {
      return
    }

    var typeBinding;
    if (map[':type'] || map['v-bind:type']) {
      typeBinding = getBindingAttr(el, 'type');
    }
    if (!map.type && !typeBinding && map['v-bind']) {
      typeBinding = "(" + (map['v-bind']) + ").type";
    }

    if (typeBinding) {
      var ifCondition = getAndRemoveAttr(el, 'v-if', true);
      var ifConditionExtra = ifCondition ? ("&&(" + ifCondition + ")") : "";
      var hasElse = getAndRemoveAttr(el, 'v-else', true) != null;
      var elseIfCondition = getAndRemoveAttr(el, 'v-else-if', true);
      // 1. checkbox
      var branch0 = cloneASTElement(el);
      // process for on the main node
      processFor(branch0);
      addRawAttr(branch0, 'type', 'checkbox');
      processElement(branch0, options);
      branch0.processed = true; // prevent it from double-processed
      branch0.if = "(" + typeBinding + ")==='checkbox'" + ifConditionExtra;
      addIfCondition(branch0, {
        exp: branch0.if,
        block: branch0
      });
      // 2. add radio else-if condition
      var branch1 = cloneASTElement(el);
      getAndRemoveAttr(branch1, 'v-for', true);
      addRawAttr(branch1, 'type', 'radio');
      processElement(branch1, options);
      addIfCondition(branch0, {
        exp: "(" + typeBinding + ")==='radio'" + ifConditionExtra,
        block: branch1
      });
      // 3. other
      var branch2 = cloneASTElement(el);
      getAndRemoveAttr(branch2, 'v-for', true);
      addRawAttr(branch2, ':type', typeBinding);
      processElement(branch2, options);
      addIfCondition(branch0, {
        exp: ifCondition,
        block: branch2
      });

      if (hasElse) {
        branch0.else = true;
      } else if (elseIfCondition) {
        branch0.elseif = elseIfCondition;
      }

      return branch0
    }
  }
}

function cloneASTElement (el) {
  return createASTElement(el.tag, el.attrsList.slice(), el.parent)
}

var model$1 = {
  preTransformNode: preTransformNode
};

var modules$1 = [
  klass$1,
  style$1,
  model$1
];

/*  */

function text (el, dir) {
  if (dir.value) {
    addProp(el, 'textContent', ("_s(" + (dir.value) + ")"), dir);
  }
}

/*  */

function html (el, dir) {
  if (dir.value) {
    addProp(el, 'innerHTML', ("_s(" + (dir.value) + ")"), dir);
  }
}

var directives$1 = {
  model: model,
  text: text,
  html: html
};

/*  */

var baseOptions = {
  expectHTML: true,
  modules: modules$1,
  directives: directives$1,
  isPreTag: isPreTag,
  isUnaryTag: isUnaryTag,
  mustUseProp: mustUseProp,
  canBeLeftOpenTag: canBeLeftOpenTag,
  isReservedTag: isReservedTag,
  getTagNamespace: getTagNamespace,
  staticKeys: genStaticKeys(modules$1)
};

/*  */

var isStaticKey;
var isPlatformReservedTag;

var genStaticKeysCached = cached(genStaticKeys$1);

/**
 * Goal of the optimizer: walk the generated template AST tree
 * and detect sub-trees that are purely static, i.e. parts of
 * the DOM that never needs to change.
 *
 * Once we detect these sub-trees, we can:
 *
 * 1. Hoist them into constants, so that we no longer need to
 *    create fresh nodes for them on each re-render;
 * 2. Completely skip them in the patching process.
 */
function optimize (root, options) {
  if (!root) { return }
  isStaticKey = genStaticKeysCached(options.staticKeys || '');
  isPlatformReservedTag = options.isReservedTag || no;
  // first pass: mark all non-static nodes.
  markStatic$1(root);
  // second pass: mark static roots.
  markStaticRoots(root, false);
}

function genStaticKeys$1 (keys) {
  return makeMap(
    'type,tag,attrsList,attrsMap,plain,parent,children,attrs,start,end,rawAttrsMap' +
    (keys ? ',' + keys : '')
  )
}

function markStatic$1 (node) {
  node.static = isStatic(node);
  if (node.type === 1) {
    // do not make component slot content static. this avoids
    // 1. components not able to mutate slot nodes
    // 2. static slot content fails for hot-reloading
    if (
      !isPlatformReservedTag(node.tag) &&
      node.tag !== 'slot' &&
      node.attrsMap['inline-template'] == null
    ) {
      return
    }
    for (var i = 0, l = node.children.length; i < l; i++) {
      var child = node.children[i];
      markStatic$1(child);
      if (!child.static) {
        node.static = false;
      }
    }
    if (node.ifConditions) {
      for (var i$1 = 1, l$1 = node.ifConditions.length; i$1 < l$1; i$1++) {
        var block = node.ifConditions[i$1].block;
        markStatic$1(block);
        if (!block.static) {
          node.static = false;
        }
      }
    }
  }
}

function markStaticRoots (node, isInFor) {
  if (node.type === 1) {
    if (node.static || node.once) {
      node.staticInFor = isInFor;
    }
    // For a node to qualify as a static root, it should have children that
    // are not just static text. Otherwise the cost of hoisting out will
    // outweigh the benefits and it's better off to just always render it fresh.
    if (node.static && node.children.length && !(
      node.children.length === 1 &&
      node.children[0].type === 3
    )) {
      node.staticRoot = true;
      return
    } else {
      node.staticRoot = false;
    }
    if (node.children) {
      for (var i = 0, l = node.children.length; i < l; i++) {
        markStaticRoots(node.children[i], isInFor || !!node.for);
      }
    }
    if (node.ifConditions) {
      for (var i$1 = 1, l$1 = node.ifConditions.length; i$1 < l$1; i$1++) {
        markStaticRoots(node.ifConditions[i$1].block, isInFor);
      }
    }
  }
}

function isStatic (node) {
  if (node.type === 2) { // expression
    return false
  }
  if (node.type === 3) { // text
    return true
  }
  return !!(node.pre || (
    !node.hasBindings && // no dynamic bindings
    !node.if && !node.for && // not v-if or v-for or v-else
    !isBuiltInTag(node.tag) && // not a built-in
    isPlatformReservedTag(node.tag) && // not a component
    !isDirectChildOfTemplateFor(node) &&
    Object.keys(node).every(isStaticKey)
  ))
}

function isDirectChildOfTemplateFor (node) {
  while (node.parent) {
    node = node.parent;
    if (node.tag !== 'template') {
      return false
    }
    if (node.for) {
      return true
    }
  }
  return false
}

/*  */

var fnExpRE = /^([\w$_]+|\([^)]*?\))\s*=>|^function(?:\s+[\w$]+)?\s*\(/;
var fnInvokeRE = /\([^)]*?\);*$/;
var simplePathRE = /^[A-Za-z_$][\w$]*(?:\.[A-Za-z_$][\w$]*|\['[^']*?']|\["[^"]*?"]|\[\d+]|\[[A-Za-z_$][\w$]*])*$/;

// KeyboardEvent.keyCode aliases
var keyCodes = {
  esc: 27,
  tab: 9,
  enter: 13,
  space: 32,
  up: 38,
  left: 37,
  right: 39,
  down: 40,
  'delete': [8, 46]
};

// KeyboardEvent.key aliases
var keyNames = {
  // #7880: IE11 and Edge use `Esc` for Escape key name.
  esc: ['Esc', 'Escape'],
  tab: 'Tab',
  enter: 'Enter',
  // #9112: IE11 uses `Spacebar` for Space key name.
  space: [' ', 'Spacebar'],
  // #7806: IE11 uses key names without `Arrow` prefix for arrow keys.
  up: ['Up', 'ArrowUp'],
  left: ['Left', 'ArrowLeft'],
  right: ['Right', 'ArrowRight'],
  down: ['Down', 'ArrowDown'],
  // #9112: IE11 uses `Del` for Delete key name.
  'delete': ['Backspace', 'Delete', 'Del']
};

// #4868: modifiers that prevent the execution of the listener
// need to explicitly return null so that we can determine whether to remove
// the listener for .once
var genGuard = function (condition) { return ("if(" + condition + ")return null;"); };

var modifierCode = {
  stop: '$event.stopPropagation();',
  prevent: '$event.preventDefault();',
  self: genGuard("$event.target !== $event.currentTarget"),
  ctrl: genGuard("!$event.ctrlKey"),
  shift: genGuard("!$event.shiftKey"),
  alt: genGuard("!$event.altKey"),
  meta: genGuard("!$event.metaKey"),
  left: genGuard("'button' in $event && $event.button !== 0"),
  middle: genGuard("'button' in $event && $event.button !== 1"),
  right: genGuard("'button' in $event && $event.button !== 2")
};

function genHandlers (
  events,
  isNative
) {
  var prefix = isNative ? 'nativeOn:' : 'on:';
  var staticHandlers = "";
  var dynamicHandlers = "";
  for (var name in events) {
    var handlerCode = genHandler(events[name]);
    if (events[name] && events[name].dynamic) {
      dynamicHandlers += name + "," + handlerCode + ",";
    } else {
      staticHandlers += "\"" + name + "\":" + handlerCode + ",";
    }
  }
  staticHandlers = "{" + (staticHandlers.slice(0, -1)) + "}";
  if (dynamicHandlers) {
    return prefix + "_d(" + staticHandlers + ",[" + (dynamicHandlers.slice(0, -1)) + "])"
  } else {
    return prefix + staticHandlers
  }
}

function genHandler (handler) {
  if (!handler) {
    return 'function(){}'
  }

  if (Array.isArray(handler)) {
    return ("[" + (handler.map(function (handler) { return genHandler(handler); }).join(',')) + "]")
  }

  var isMethodPath = simplePathRE.test(handler.value);
  var isFunctionExpression = fnExpRE.test(handler.value);
  var isFunctionInvocation = simplePathRE.test(handler.value.replace(fnInvokeRE, ''));

  if (!handler.modifiers) {
    if (isMethodPath || isFunctionExpression) {
      return handler.value
    }
    return ("function($event){" + (isFunctionInvocation ? ("return " + (handler.value)) : handler.value) + "}") // inline statement
  } else {
    var code = '';
    var genModifierCode = '';
    var keys = [];
    for (var key in handler.modifiers) {
      if (modifierCode[key]) {
        genModifierCode += modifierCode[key];
        // left/right
        if (keyCodes[key]) {
          keys.push(key);
        }
      } else if (key === 'exact') {
        var modifiers = (handler.modifiers);
        genModifierCode += genGuard(
          ['ctrl', 'shift', 'alt', 'meta']
            .filter(function (keyModifier) { return !modifiers[keyModifier]; })
            .map(function (keyModifier) { return ("$event." + keyModifier + "Key"); })
            .join('||')
        );
      } else {
        keys.push(key);
      }
    }
    if (keys.length) {
      code += genKeyFilter(keys);
    }
    // Make sure modifiers like prevent and stop get executed after key filtering
    if (genModifierCode) {
      code += genModifierCode;
    }
    var handlerCode = isMethodPath
      ? ("return " + (handler.value) + "($event)")
      : isFunctionExpression
        ? ("return (" + (handler.value) + ")($event)")
        : isFunctionInvocation
          ? ("return " + (handler.value))
          : handler.value;
    return ("function($event){" + code + handlerCode + "}")
  }
}

function genKeyFilter (keys) {
  return (
    // make sure the key filters only apply to KeyboardEvents
    // #9441: can't use 'keyCode' in $event because Chrome autofill fires fake
    // key events that do not have keyCode property...
    "if(!$event.type.indexOf('key')&&" +
    (keys.map(genFilterCode).join('&&')) + ")return null;"
  )
}

function genFilterCode (key) {
  var keyVal = parseInt(key, 10);
  if (keyVal) {
    return ("$event.keyCode!==" + keyVal)
  }
  var keyCode = keyCodes[key];
  var keyName = keyNames[key];
  return (
    "_k($event.keyCode," +
    (JSON.stringify(key)) + "," +
    (JSON.stringify(keyCode)) + "," +
    "$event.key," +
    "" + (JSON.stringify(keyName)) +
    ")"
  )
}

/*  */

function on (el, dir) {
  if (false) {
    warn("v-on without argument does not support modifiers.");
  }
  el.wrapListeners = function (code) { return ("_g(" + code + "," + (dir.value) + ")"); };
}

/*  */

function bind$1 (el, dir) {
  el.wrapData = function (code) {
    return ("_b(" + code + ",'" + (el.tag) + "'," + (dir.value) + "," + (dir.modifiers && dir.modifiers.prop ? 'true' : 'false') + (dir.modifiers && dir.modifiers.sync ? ',true' : '') + ")")
  };
}

/*  */

var baseDirectives = {
  on: on,
  bind: bind$1,
  cloak: noop
};

/*  */





var CodegenState = function CodegenState (options) {
  this.options = options;
  this.warn = options.warn || baseWarn;
  this.transforms = pluckModuleFunction(options.modules, 'transformCode');
  this.dataGenFns = pluckModuleFunction(options.modules, 'genData');
  this.directives = extend(extend({}, baseDirectives), options.directives);
  var isReservedTag = options.isReservedTag || no;
  this.maybeComponent = function (el) { return !!el.component || !isReservedTag(el.tag); };
  this.onceId = 0;
  this.staticRenderFns = [];
  this.pre = false;
};



function generate (
  ast,
  options
) {
  var state = new CodegenState(options);
  var code = ast ? genElement(ast, state) : '_c("div")';
  return {
    render: ("with(this){return " + code + "}"),
    staticRenderFns: state.staticRenderFns
  }
}

function genElement (el, state) {
  if (el.parent) {
    el.pre = el.pre || el.parent.pre;
  }

  if (el.staticRoot && !el.staticProcessed) {
    return genStatic(el, state)
  } else if (el.once && !el.onceProcessed) {
    return genOnce(el, state)
  } else if (el.for && !el.forProcessed) {
    return genFor(el, state)
  } else if (el.if && !el.ifProcessed) {
    return genIf(el, state)
  } else if (el.tag === 'template' && !el.slotTarget && !state.pre) {
    return genChildren(el, state) || 'void 0'
  } else if (el.tag === 'slot') {
    return genSlot(el, state)
  } else {
    // component or element
    var code;
    if (el.component) {
      code = genComponent(el.component, el, state);
    } else {
      var data;
      if (!el.plain || (el.pre && state.maybeComponent(el))) {
        data = genData$2(el, state);
      }

      var children = el.inlineTemplate ? null : genChildren(el, state, true);
      code = "_c('" + (el.tag) + "'" + (data ? ("," + data) : '') + (children ? ("," + children) : '') + ")";
    }
    // module transforms
    for (var i = 0; i < state.transforms.length; i++) {
      code = state.transforms[i](el, code);
    }
    return code
  }
}

// hoist static sub-trees out
function genStatic (el, state) {
  el.staticProcessed = true;
  // Some elements (templates) need to behave differently inside of a v-pre
  // node.  All pre nodes are static roots, so we can use this as a location to
  // wrap a state change and reset it upon exiting the pre node.
  var originalPreState = state.pre;
  if (el.pre) {
    state.pre = el.pre;
  }
  state.staticRenderFns.push(("with(this){return " + (genElement(el, state)) + "}"));
  state.pre = originalPreState;
  return ("_m(" + (state.staticRenderFns.length - 1) + (el.staticInFor ? ',true' : '') + ")")
}

// v-once
function genOnce (el, state) {
  el.onceProcessed = true;
  if (el.if && !el.ifProcessed) {
    return genIf(el, state)
  } else if (el.staticInFor) {
    var key = '';
    var parent = el.parent;
    while (parent) {
      if (parent.for) {
        key = parent.key;
        break
      }
      parent = parent.parent;
    }
    if (!key) {
      "production" !== 'production' && state.warn(
        "v-once can only be used inside v-for that is keyed. ",
        el.rawAttrsMap['v-once']
      );
      return genElement(el, state)
    }
    return ("_o(" + (genElement(el, state)) + "," + (state.onceId++) + "," + key + ")")
  } else {
    return genStatic(el, state)
  }
}

function genIf (
  el,
  state,
  altGen,
  altEmpty
) {
  el.ifProcessed = true; // avoid recursion
  return genIfConditions(el.ifConditions.slice(), state, altGen, altEmpty)
}

function genIfConditions (
  conditions,
  state,
  altGen,
  altEmpty
) {
  if (!conditions.length) {
    return altEmpty || '_e()'
  }

  var condition = conditions.shift();
  if (condition.exp) {
    return ("(" + (condition.exp) + ")?" + (genTernaryExp(condition.block)) + ":" + (genIfConditions(conditions, state, altGen, altEmpty)))
  } else {
    return ("" + (genTernaryExp(condition.block)))
  }

  // v-if with v-once should generate code like (a)?_m(0):_m(1)
  function genTernaryExp (el) {
    return altGen
      ? altGen(el, state)
      : el.once
        ? genOnce(el, state)
        : genElement(el, state)
  }
}

function genFor (
  el,
  state,
  altGen,
  altHelper
) {
  var exp = el.for;
  var alias = el.alias;
  var iterator1 = el.iterator1 ? ("," + (el.iterator1)) : '';
  var iterator2 = el.iterator2 ? ("," + (el.iterator2)) : '';

  if (false
  ) {
    state.warn(
      "<" + (el.tag) + " v-for=\"" + alias + " in " + exp + "\">: component lists rendered with " +
      "v-for should have explicit keys. " +
      "See https://vuejs.org/guide/list.html#key for more info.",
      el.rawAttrsMap['v-for'],
      true /* tip */
    );
  }

  el.forProcessed = true; // avoid recursion
  return (altHelper || '_l') + "((" + exp + ")," +
    "function(" + alias + iterator1 + iterator2 + "){" +
      "return " + ((altGen || genElement)(el, state)) +
    '})'
}

function genData$2 (el, state) {
  var data = '{';

  // directives first.
  // directives may mutate the el's other properties before they are generated.
  var dirs = genDirectives(el, state);
  if (dirs) { data += dirs + ','; }

  // key
  if (el.key) {
    data += "key:" + (el.key) + ",";
  }
  // ref
  if (el.ref) {
    data += "ref:" + (el.ref) + ",";
  }
  if (el.refInFor) {
    data += "refInFor:true,";
  }
  // pre
  if (el.pre) {
    data += "pre:true,";
  }
  // record original tag name for components using "is" attribute
  if (el.component) {
    data += "tag:\"" + (el.tag) + "\",";
  }
  // module data generation functions
  for (var i = 0; i < state.dataGenFns.length; i++) {
    data += state.dataGenFns[i](el);
  }
  // attributes
  if (el.attrs) {
    data += "attrs:" + (genProps(el.attrs)) + ",";
  }
  // DOM props
  if (el.props) {
    data += "domProps:" + (genProps(el.props)) + ",";
  }
  // event handlers
  if (el.events) {
    data += (genHandlers(el.events, false)) + ",";
  }
  if (el.nativeEvents) {
    data += (genHandlers(el.nativeEvents, true)) + ",";
  }
  // slot target
  // only for non-scoped slots
  if (el.slotTarget && !el.slotScope) {
    data += "slot:" + (el.slotTarget) + ",";
  }
  // scoped slots
  if (el.scopedSlots) {
    data += (genScopedSlots(el, el.scopedSlots, state)) + ",";
  }
  // component v-model
  if (el.model) {
    data += "model:{value:" + (el.model.value) + ",callback:" + (el.model.callback) + ",expression:" + (el.model.expression) + "},";
  }
  // inline-template
  if (el.inlineTemplate) {
    var inlineTemplate = genInlineTemplate(el, state);
    if (inlineTemplate) {
      data += inlineTemplate + ",";
    }
  }
  data = data.replace(/,$/, '') + '}';
  // v-bind dynamic argument wrap
  // v-bind with dynamic arguments must be applied using the same v-bind object
  // merge helper so that class/style/mustUseProp attrs are handled correctly.
  if (el.dynamicAttrs) {
    data = "_b(" + data + ",\"" + (el.tag) + "\"," + (genProps(el.dynamicAttrs)) + ")";
  }
  // v-bind data wrap
  if (el.wrapData) {
    data = el.wrapData(data);
  }
  // v-on data wrap
  if (el.wrapListeners) {
    data = el.wrapListeners(data);
  }
  return data
}

function genDirectives (el, state) {
  var dirs = el.directives;
  if (!dirs) { return }
  var res = 'directives:[';
  var hasRuntime = false;
  var i, l, dir, needRuntime;
  for (i = 0, l = dirs.length; i < l; i++) {
    dir = dirs[i];
    needRuntime = true;
    var gen = state.directives[dir.name];
    if (gen) {
      // compile-time directive that manipulates AST.
      // returns true if it also needs a runtime counterpart.
      needRuntime = !!gen(el, dir, state.warn);
    }
    if (needRuntime) {
      hasRuntime = true;
      res += "{name:\"" + (dir.name) + "\",rawName:\"" + (dir.rawName) + "\"" + (dir.value ? (",value:(" + (dir.value) + "),expression:" + (JSON.stringify(dir.value))) : '') + (dir.arg ? (",arg:" + (dir.isDynamicArg ? dir.arg : ("\"" + (dir.arg) + "\""))) : '') + (dir.modifiers ? (",modifiers:" + (JSON.stringify(dir.modifiers))) : '') + "},";
    }
  }
  if (hasRuntime) {
    return res.slice(0, -1) + ']'
  }
}

function genInlineTemplate (el, state) {
  var ast = el.children[0];
  if (false) {
    state.warn(
      'Inline-template components must have exactly one child element.',
      { start: el.start }
    );
  }
  if (ast && ast.type === 1) {
    var inlineRenderFns = generate(ast, state.options);
    return ("inlineTemplate:{render:function(){" + (inlineRenderFns.render) + "},staticRenderFns:[" + (inlineRenderFns.staticRenderFns.map(function (code) { return ("function(){" + code + "}"); }).join(',')) + "]}")
  }
}

function genScopedSlots (
  el,
  slots,
  state
) {
  // by default scoped slots are considered "stable", this allows child
  // components with only scoped slots to skip forced updates from parent.
  // but in some cases we have to bail-out of this optimization
  // for example if the slot contains dynamic names, has v-if or v-for on them...
  var needsForceUpdate = el.for || Object.keys(slots).some(function (key) {
    var slot = slots[key];
    return (
      slot.slotTargetDynamic ||
      slot.if ||
      slot.for ||
      containsSlotChild(slot) // is passing down slot from parent which may be dynamic
    )
  });

  // #9534: if a component with scoped slots is inside a conditional branch,
  // it's possible for the same component to be reused but with different
  // compiled slot content. To avoid that, we generate a unique key based on
  // the generated code of all the slot contents.
  var needsKey = !!el.if;

  // OR when it is inside another scoped slot or v-for (the reactivity may be
  // disconnected due to the intermediate scope variable)
  // #9438, #9506
  // TODO: this can be further optimized by properly analyzing in-scope bindings
  // and skip force updating ones that do not actually use scope variables.
  if (!needsForceUpdate) {
    var parent = el.parent;
    while (parent) {
      if (
        (parent.slotScope && parent.slotScope !== emptySlotScopeToken) ||
        parent.for
      ) {
        needsForceUpdate = true;
        break
      }
      if (parent.if) {
        needsKey = true;
      }
      parent = parent.parent;
    }
  }

  var generatedSlots = Object.keys(slots)
    .map(function (key) { return genScopedSlot(slots[key], state); })
    .join(',');

  return ("scopedSlots:_u([" + generatedSlots + "]" + (needsForceUpdate ? ",null,true" : "") + (!needsForceUpdate && needsKey ? (",null,false," + (hash(generatedSlots))) : "") + ")")
}

function hash(str) {
  var hash = 5381;
  var i = str.length;
  while(i) {
    hash = (hash * 33) ^ str.charCodeAt(--i);
  }
  return hash >>> 0
}

function containsSlotChild (el) {
  if (el.type === 1) {
    if (el.tag === 'slot') {
      return true
    }
    return el.children.some(containsSlotChild)
  }
  return false
}

function genScopedSlot (
  el,
  state
) {
  var isLegacySyntax = el.attrsMap['slot-scope'];
  if (el.if && !el.ifProcessed && !isLegacySyntax) {
    return genIf(el, state, genScopedSlot, "null")
  }
  if (el.for && !el.forProcessed) {
    return genFor(el, state, genScopedSlot)
  }
  var slotScope = el.slotScope === emptySlotScopeToken
    ? ""
    : String(el.slotScope);
  var fn = "function(" + slotScope + "){" +
    "return " + (el.tag === 'template'
      ? el.if && isLegacySyntax
        ? ("(" + (el.if) + ")?" + (genChildren(el, state) || 'undefined') + ":undefined")
        : genChildren(el, state) || 'undefined'
      : genElement(el, state)) + "}";
  // reverse proxy v-slot without scope on this.$slots
  var reverseProxy = slotScope ? "" : ",proxy:true";
  return ("{key:" + (el.slotTarget || "\"default\"") + ",fn:" + fn + reverseProxy + "}")
}

function genChildren (
  el,
  state,
  checkSkip,
  altGenElement,
  altGenNode
) {
  var children = el.children;
  if (children.length) {
    var el$1 = children[0];
    // optimize single v-for
    if (children.length === 1 &&
      el$1.for &&
      el$1.tag !== 'template' &&
      el$1.tag !== 'slot'
    ) {
      var normalizationType = checkSkip
        ? state.maybeComponent(el$1) ? ",1" : ",0"
        : "";
      return ("" + ((altGenElement || genElement)(el$1, state)) + normalizationType)
    }
    var normalizationType$1 = checkSkip
      ? getNormalizationType(children, state.maybeComponent)
      : 0;
    var gen = altGenNode || genNode;
    return ("[" + (children.map(function (c) { return gen(c, state); }).join(',')) + "]" + (normalizationType$1 ? ("," + normalizationType$1) : ''))
  }
}

// determine the normalization needed for the children array.
// 0: no normalization needed
// 1: simple normalization needed (possible 1-level deep nested array)
// 2: full normalization needed
function getNormalizationType (
  children,
  maybeComponent
) {
  var res = 0;
  for (var i = 0; i < children.length; i++) {
    var el = children[i];
    if (el.type !== 1) {
      continue
    }
    if (needsNormalization(el) ||
        (el.ifConditions && el.ifConditions.some(function (c) { return needsNormalization(c.block); }))) {
      res = 2;
      break
    }
    if (maybeComponent(el) ||
        (el.ifConditions && el.ifConditions.some(function (c) { return maybeComponent(c.block); }))) {
      res = 1;
    }
  }
  return res
}

function needsNormalization (el) {
  return el.for !== undefined || el.tag === 'template' || el.tag === 'slot'
}

function genNode (node, state) {
  if (node.type === 1) {
    return genElement(node, state)
  } else if (node.type === 3 && node.isComment) {
    return genComment(node)
  } else {
    return genText(node)
  }
}

function genText (text) {
  return ("_v(" + (text.type === 2
    ? text.expression // no need for () because already wrapped in _s()
    : transformSpecialNewlines(JSON.stringify(text.text))) + ")")
}

function genComment (comment) {
  return ("_e(" + (JSON.stringify(comment.text)) + ")")
}

function genSlot (el, state) {
  var slotName = el.slotName || '"default"';
  var children = genChildren(el, state);
  var res = "_t(" + slotName + (children ? ("," + children) : '');
  var attrs = el.attrs || el.dynamicAttrs
    ? genProps((el.attrs || []).concat(el.dynamicAttrs || []).map(function (attr) { return ({
        // slot props are camelized
        name: camelize(attr.name),
        value: attr.value,
        dynamic: attr.dynamic
      }); }))
    : null;
  var bind$$1 = el.attrsMap['v-bind'];
  if ((attrs || bind$$1) && !children) {
    res += ",null";
  }
  if (attrs) {
    res += "," + attrs;
  }
  if (bind$$1) {
    res += (attrs ? '' : ',null') + "," + bind$$1;
  }
  return res + ')'
}

// componentName is el.component, take it as argument to shun flow's pessimistic refinement
function genComponent (
  componentName,
  el,
  state
) {
  var children = el.inlineTemplate ? null : genChildren(el, state, true);
  return ("_c(" + componentName + "," + (genData$2(el, state)) + (children ? ("," + children) : '') + ")")
}

function genProps (props) {
  var staticProps = "";
  var dynamicProps = "";
  for (var i = 0; i < props.length; i++) {
    var prop = props[i];
    var value = transformSpecialNewlines(prop.value);
    if (prop.dynamic) {
      dynamicProps += (prop.name) + "," + value + ",";
    } else {
      staticProps += "\"" + (prop.name) + "\":" + value + ",";
    }
  }
  staticProps = "{" + (staticProps.slice(0, -1)) + "}";
  if (dynamicProps) {
    return ("_d(" + staticProps + ",[" + (dynamicProps.slice(0, -1)) + "])")
  } else {
    return staticProps
  }
}

// #3895, #4268
function transformSpecialNewlines (text) {
  return text
    .replace(/\u2028/g, '\\u2028')
    .replace(/\u2029/g, '\\u2029')
}

/*  */



// these keywords should not appear inside expressions, but operators like
// typeof, instanceof and in are allowed
var prohibitedKeywordRE = new RegExp('\\b' + (
  'do,if,for,let,new,try,var,case,else,with,await,break,catch,class,const,' +
  'super,throw,while,yield,delete,export,import,return,switch,default,' +
  'extends,finally,continue,debugger,function,arguments'
).split(',').join('\\b|\\b') + '\\b');

// these unary operators should not be used as property/method names
var unaryOperatorsRE = new RegExp('\\b' + (
  'delete,typeof,void'
).split(',').join('\\s*\\([^\\)]*\\)|\\b') + '\\s*\\([^\\)]*\\)');

// strip strings in expressions
var stripStringRE = /'(?:[^'\\]|\\.)*'|"(?:[^"\\]|\\.)*"|`(?:[^`\\]|\\.)*\$\{|\}(?:[^`\\]|\\.)*`|`(?:[^`\\]|\\.)*`/g;

// detect problematic expressions in a template
function detectErrors (ast, warn) {
  if (ast) {
    checkNode(ast, warn);
  }
}

function checkNode (node, warn) {
  if (node.type === 1) {
    for (var name in node.attrsMap) {
      if (dirRE.test(name)) {
        var value = node.attrsMap[name];
        if (value) {
          var range = node.rawAttrsMap[name];
          if (name === 'v-for') {
            checkFor(node, ("v-for=\"" + value + "\""), warn, range);
          } else if (name === 'v-slot' || name[0] === '#') {
            checkFunctionParameterExpression(value, (name + "=\"" + value + "\""), warn, range);
          } else if (onRE.test(name)) {
            checkEvent(value, (name + "=\"" + value + "\""), warn, range);
          } else {
            checkExpression(value, (name + "=\"" + value + "\""), warn, range);
          }
        }
      }
    }
    if (node.children) {
      for (var i = 0; i < node.children.length; i++) {
        checkNode(node.children[i], warn);
      }
    }
  } else if (node.type === 2) {
    checkExpression(node.expression, node.text, warn, node);
  }
}

function checkEvent (exp, text, warn, range) {
  var stripped = exp.replace(stripStringRE, '');
  var keywordMatch = stripped.match(unaryOperatorsRE);
  if (keywordMatch && stripped.charAt(keywordMatch.index - 1) !== '$') {
    warn(
      "avoid using JavaScript unary operator as property name: " +
      "\"" + (keywordMatch[0]) + "\" in expression " + (text.trim()),
      range
    );
  }
  checkExpression(exp, text, warn, range);
}

function checkFor (node, text, warn, range) {
  checkExpression(node.for || '', text, warn, range);
  checkIdentifier(node.alias, 'v-for alias', text, warn, range);
  checkIdentifier(node.iterator1, 'v-for iterator', text, warn, range);
  checkIdentifier(node.iterator2, 'v-for iterator', text, warn, range);
}

function checkIdentifier (
  ident,
  type,
  text,
  warn,
  range
) {
  if (typeof ident === 'string') {
    try {
      new Function(("var " + ident + "=_"));
    } catch (e) {
      warn(("invalid " + type + " \"" + ident + "\" in expression: " + (text.trim())), range);
    }
  }
}

function checkExpression (exp, text, warn, range) {
  try {
    new Function(("return " + exp));
  } catch (e) {
    var keywordMatch = exp.replace(stripStringRE, '').match(prohibitedKeywordRE);
    if (keywordMatch) {
      warn(
        "avoid using JavaScript keyword as property name: " +
        "\"" + (keywordMatch[0]) + "\"\n  Raw expression: " + (text.trim()),
        range
      );
    } else {
      warn(
        "invalid expression: " + (e.message) + " in\n\n" +
        "    " + exp + "\n\n" +
        "  Raw expression: " + (text.trim()) + "\n",
        range
      );
    }
  }
}

function checkFunctionParameterExpression (exp, text, warn, range) {
  try {
    new Function(exp, '');
  } catch (e) {
    warn(
      "invalid function parameter expression: " + (e.message) + " in\n\n" +
      "    " + exp + "\n\n" +
      "  Raw expression: " + (text.trim()) + "\n",
      range
    );
  }
}

/*  */

var range = 2;

function generateCodeFrame (
  source,
  start,
  end
) {
  if ( start === void 0 ) start = 0;
  if ( end === void 0 ) end = source.length;

  var lines = source.split(/\r?\n/);
  var count = 0;
  var res = [];
  for (var i = 0; i < lines.length; i++) {
    count += lines[i].length + 1;
    if (count >= start) {
      for (var j = i - range; j <= i + range || end > count; j++) {
        if (j < 0 || j >= lines.length) { continue }
        res.push(("" + (j + 1) + (repeat$1(" ", 3 - String(j + 1).length)) + "|  " + (lines[j])));
        var lineLength = lines[j].length;
        if (j === i) {
          // push underline
          var pad = start - (count - lineLength) + 1;
          var length = end > count ? lineLength - pad : end - start;
          res.push("   |  " + repeat$1(" ", pad) + repeat$1("^", length));
        } else if (j > i) {
          if (end > count) {
            var length$1 = Math.min(end - count, lineLength);
            res.push("   |  " + repeat$1("^", length$1));
          }
          count += lineLength + 1;
        }
      }
      break
    }
  }
  return res.join('\n')
}

function repeat$1 (str, n) {
  var result = '';
  if (n > 0) {
    while (true) { // eslint-disable-line
      if (n & 1) { result += str; }
      n >>>= 1;
      if (n <= 0) { break }
      str += str;
    }
  }
  return result
}

/*  */



function createFunction (code, errors) {
  try {
    return new Function(code)
  } catch (err) {
    errors.push({ err: err, code: code });
    return noop
  }
}

function createCompileToFunctionFn (compile) {
  var cache = Object.create(null);

  return function compileToFunctions (
    template,
    options,
    vm
  ) {
    options = extend({}, options);
    var warn$$1 = options.warn || warn;
    delete options.warn;

    /* istanbul ignore if */
    if (false) {
      // detect possible CSP restriction
      try {
        new Function('return 1');
      } catch (e) {
        if (e.toString().match(/unsafe-eval|CSP/)) {
          warn$$1(
            'It seems you are using the standalone build of Vue.js in an ' +
            'environment with Content Security Policy that prohibits unsafe-eval. ' +
            'The template compiler cannot work in this environment. Consider ' +
            'relaxing the policy to allow unsafe-eval or pre-compiling your ' +
            'templates into render functions.'
          );
        }
      }
    }

    // check cache
    var key = options.delimiters
      ? String(options.delimiters) + template
      : template;
    if (cache[key]) {
      return cache[key]
    }

    // compile
    var compiled = compile(template, options);

    // check compilation errors/tips
    if (false) {
      if (compiled.errors && compiled.errors.length) {
        if (options.outputSourceRange) {
          compiled.errors.forEach(function (e) {
            warn$$1(
              "Error compiling template:\n\n" + (e.msg) + "\n\n" +
              generateCodeFrame(template, e.start, e.end),
              vm
            );
          });
        } else {
          warn$$1(
            "Error compiling template:\n\n" + template + "\n\n" +
            compiled.errors.map(function (e) { return ("- " + e); }).join('\n') + '\n',
            vm
          );
        }
      }
      if (compiled.tips && compiled.tips.length) {
        if (options.outputSourceRange) {
          compiled.tips.forEach(function (e) { return tip(e.msg, vm); });
        } else {
          compiled.tips.forEach(function (msg) { return tip(msg, vm); });
        }
      }
    }

    // turn code into functions
    var res = {};
    var fnGenErrors = [];
    res.render = createFunction(compiled.render, fnGenErrors);
    res.staticRenderFns = compiled.staticRenderFns.map(function (code) {
      return createFunction(code, fnGenErrors)
    });

    // check function generation errors.
    // this should only happen if there is a bug in the compiler itself.
    // mostly for codegen development use
    /* istanbul ignore if */
    if (false) {
      if ((!compiled.errors || !compiled.errors.length) && fnGenErrors.length) {
        warn$$1(
          "Failed to generate render function:\n\n" +
          fnGenErrors.map(function (ref) {
            var err = ref.err;
            var code = ref.code;

            return ((err.toString()) + " in\n\n" + code + "\n");
        }).join('\n'),
          vm
        );
      }
    }

    return (cache[key] = res)
  }
}

/*  */

function createCompilerCreator (baseCompile) {
  return function createCompiler (baseOptions) {
    function compile (
      template,
      options
    ) {
      var finalOptions = Object.create(baseOptions);
      var errors = [];
      var tips = [];

      var warn = function (msg, range, tip) {
        (tip ? tips : errors).push(msg);
      };

      if (options) {
        if (false) {
          // $flow-disable-line
          var leadingSpaceLength = template.match(/^\s*/)[0].length;

          warn = function (msg, range, tip) {
            var data = { msg: msg };
            if (range) {
              if (range.start != null) {
                data.start = range.start + leadingSpaceLength;
              }
              if (range.end != null) {
                data.end = range.end + leadingSpaceLength;
              }
            }
            (tip ? tips : errors).push(data);
          };
        }
        // merge custom modules
        if (options.modules) {
          finalOptions.modules =
            (baseOptions.modules || []).concat(options.modules);
        }
        // merge custom directives
        if (options.directives) {
          finalOptions.directives = extend(
            Object.create(baseOptions.directives || null),
            options.directives
          );
        }
        // copy other options
        for (var key in options) {
          if (key !== 'modules' && key !== 'directives') {
            finalOptions[key] = options[key];
          }
        }
      }

      finalOptions.warn = warn;

      var compiled = baseCompile(template.trim(), finalOptions);
      if (false) {
        detectErrors(compiled.ast, warn);
      }
      compiled.errors = errors;
      compiled.tips = tips;
      return compiled
    }

    return {
      compile: compile,
      compileToFunctions: createCompileToFunctionFn(compile)
    }
  }
}

/*  */

// `createCompilerCreator` allows creating compilers that use alternative
// parser/optimizer/codegen, e.g the SSR optimizing compiler.
// Here we just export a default compiler using the default parts.
var createCompiler = createCompilerCreator(function baseCompile (
  template,
  options
) {
  var ast = parse(template.trim(), options);
  if (options.optimize !== false) {
    optimize(ast, options);
  }
  var code = generate(ast, options);
  return {
    ast: ast,
    render: code.render,
    staticRenderFns: code.staticRenderFns
  }
});

/*  */

var ref$1 = createCompiler(baseOptions);
var compile = ref$1.compile;
var compileToFunctions = ref$1.compileToFunctions;

/*  */

// check whether current browser encodes a char inside attribute values
var div;
function getShouldDecode (href) {
  div = div || document.createElement('div');
  div.innerHTML = href ? "<a href=\"\n\"/>" : "<div a=\"\n\"/>";
  return div.innerHTML.indexOf('&#10;') > 0
}

// #3663: IE encodes newlines inside attribute values while other browsers don't
var shouldDecodeNewlines = inBrowser ? getShouldDecode(false) : false;
// #6828: chrome encodes content in a[href]
var shouldDecodeNewlinesForHref = inBrowser ? getShouldDecode(true) : false;

/*  */

var idToTemplate = cached(function (id) {
  var el = query(id);
  return el && el.innerHTML
});

var mount = Vue.prototype.$mount;
Vue.prototype.$mount = function (
  el,
  hydrating
) {
  el = el && query(el);

  /* istanbul ignore if */
  if (el === document.body || el === document.documentElement) {
    "production" !== 'production' && warn(
      "Do not mount Vue to <html> or <body> - mount to normal elements instead."
    );
    return this
  }

  var options = this.$options;
  // resolve template/el and convert to render function
  if (!options.render) {
    var template = options.template;
    if (template) {
      if (typeof template === 'string') {
        if (template.charAt(0) === '#') {
          template = idToTemplate(template);
          /* istanbul ignore if */
          if (false) {
            warn(
              ("Template element not found or is empty: " + (options.template)),
              this
            );
          }
        }
      } else if (template.nodeType) {
        template = template.innerHTML;
      } else {
        if (false) {
          warn('invalid template option:' + template, this);
        }
        return this
      }
    } else if (el) {
      template = getOuterHTML(el);
    }
    if (template) {
      /* istanbul ignore if */
      if (false) {
        mark('compile');
      }

      var ref = compileToFunctions(template, {
        outputSourceRange: "production" !== 'production',
        shouldDecodeNewlines: shouldDecodeNewlines,
        shouldDecodeNewlinesForHref: shouldDecodeNewlinesForHref,
        delimiters: options.delimiters,
        comments: options.comments
      }, this);
      var render = ref.render;
      var staticRenderFns = ref.staticRenderFns;
      options.render = render;
      options.staticRenderFns = staticRenderFns;

      /* istanbul ignore if */
      if (false) {
        mark('compile end');
        measure(("vue " + (this._name) + " compile"), 'compile', 'compile end');
      }
    }
  }
  return mount.call(this, el, hydrating)
};

/**
 * Get outerHTML of elements, taking care
 * of SVG elements in IE as well.
 */
function getOuterHTML (el) {
  if (el.outerHTML) {
    return el.outerHTML
  } else {
    var container = document.createElement('div');
    container.appendChild(el.cloneNode(true));
    return container.innerHTML
  }
}

Vue.compile = compileToFunctions;

/* harmony default export */ __webpack_exports__["a"] = (Vue);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4), __webpack_require__(18).setImmediate))

/***/ }),
/* 4 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]());

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(25),
  /* template */
  __webpack_require__(28),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(26),
  /* template */
  __webpack_require__(27),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

function encode(val) {
  return encodeURIComponent(val).
    replace(/%40/gi, '@').
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
module.exports = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils.isArray(val)) {
        key = key + '[]';
      } else {
        val = [val];
      }

      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    var hashmarkIndex = url.indexOf('#');
    if (hashmarkIndex !== -1) {
      url = url.slice(0, hashmarkIndex);
    }

    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

var utils = __webpack_require__(1);
var normalizeHeaderName = __webpack_require__(35);

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = __webpack_require__(12);
  } else if (typeof process !== 'undefined' && Object.prototype.toString.call(process) === '[object process]') {
    // For node use HTTP adapter
    adapter = __webpack_require__(12);
  }
  return adapter;
}

var defaults = {
  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Accept');
    normalizeHeaderName(headers, 'Content-Type');
    if (utils.isFormData(data) ||
      utils.isArrayBuffer(data) ||
      utils.isBuffer(data) ||
      utils.isStream(data) ||
      utils.isFile(data) ||
      utils.isBlob(data)
    ) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }
    if (utils.isObject(data)) {
      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
      return JSON.stringify(data);
    }
    return data;
  }],

  transformResponse: [function transformResponse(data) {
    /*eslint no-param-reassign:0*/
    if (typeof data === 'string') {
      try {
        data = JSON.parse(data);
      } catch (e) { /* Ignore */ }
    }
    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  }
};

defaults.headers = {
  common: {
    'Accept': 'application/json, text/plain, */*'
  }
};

utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});

module.exports = defaults;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);
var settle = __webpack_require__(36);
var buildURL = __webpack_require__(9);
var buildFullPath = __webpack_require__(38);
var parseHeaders = __webpack_require__(41);
var isURLSameOrigin = __webpack_require__(42);
var createError = __webpack_require__(13);

module.exports = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;

    if (utils.isFormData(requestData)) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password || '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    var fullPath = buildFullPath(config.baseURL, config.url);
    request.open(config.method.toUpperCase(), buildURL(fullPath, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    // Listen for ready state
    request.onreadystatechange = function handleLoad() {
      if (!request || request.readyState !== 4) {
        return;
      }

      // The request errored out and we didn't get a response, this will be
      // handled by onerror instead
      // With one exception: request that using file: protocol, most browsers
      // will return status as 0 even though it's a successful request
      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
        return;
      }

      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
      var response = {
        data: responseData,
        status: request.status,
        statusText: request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(resolve, reject, response);

      // Clean up request
      request = null;
    };

    // Handle browser request cancellation (as opposed to a manual cancellation)
    request.onabort = function handleAbort() {
      if (!request) {
        return;
      }

      reject(createError('Request aborted', config, 'ECONNABORTED', request));

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(createError('Network Error', config, null, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      var timeoutErrorMessage = 'timeout of ' + config.timeout + 'ms exceeded';
      if (config.timeoutErrorMessage) {
        timeoutErrorMessage = config.timeoutErrorMessage;
      }
      reject(createError(timeoutErrorMessage, config, 'ECONNABORTED',
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils.isStandardBrowserEnv()) {
      var cookies = __webpack_require__(43);

      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(fullPath)) && config.xsrfCookieName ?
        cookies.read(config.xsrfCookieName) :
        undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (!utils.isUndefined(config.withCredentials)) {
      request.withCredentials = !!config.withCredentials;
    }

    // Add responseType to request if needed
    if (config.responseType) {
      try {
        request.responseType = config.responseType;
      } catch (e) {
        // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
        // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
        if (config.responseType !== 'json') {
          throw e;
        }
      }
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken) {
      // Handle cancellation
      config.cancelToken.promise.then(function onCanceled(cancel) {
        if (!request) {
          return;
        }

        request.abort();
        reject(cancel);
        // Clean up request
        request = null;
      });
    }

    if (requestData === undefined) {
      requestData = null;
    }

    // Send the request
    request.send(requestData);
  });
};


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var enhanceError = __webpack_require__(37);

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
module.exports = function createError(message, config, code, request, response) {
  var error = new Error(message);
  return enhanceError(error, config, code, request, response);
};


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 * @returns {Object} New object resulting from merging config2 to config1
 */
module.exports = function mergeConfig(config1, config2) {
  // eslint-disable-next-line no-param-reassign
  config2 = config2 || {};
  var config = {};

  var valueFromConfig2Keys = ['url', 'method', 'params', 'data'];
  var mergeDeepPropertiesKeys = ['headers', 'auth', 'proxy'];
  var defaultToConfig2Keys = [
    'baseURL', 'url', 'transformRequest', 'transformResponse', 'paramsSerializer',
    'timeout', 'withCredentials', 'adapter', 'responseType', 'xsrfCookieName',
    'xsrfHeaderName', 'onUploadProgress', 'onDownloadProgress',
    'maxContentLength', 'validateStatus', 'maxRedirects', 'httpAgent',
    'httpsAgent', 'cancelToken', 'socketPath'
  ];

  utils.forEach(valueFromConfig2Keys, function valueFromConfig2(prop) {
    if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    }
  });

  utils.forEach(mergeDeepPropertiesKeys, function mergeDeepProperties(prop) {
    if (utils.isObject(config2[prop])) {
      config[prop] = utils.deepMerge(config1[prop], config2[prop]);
    } else if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    } else if (utils.isObject(config1[prop])) {
      config[prop] = utils.deepMerge(config1[prop]);
    } else if (typeof config1[prop] !== 'undefined') {
      config[prop] = config1[prop];
    }
  });

  utils.forEach(defaultToConfig2Keys, function defaultToConfig2(prop) {
    if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    } else if (typeof config1[prop] !== 'undefined') {
      config[prop] = config1[prop];
    }
  });

  var axiosKeys = valueFromConfig2Keys
    .concat(mergeDeepPropertiesKeys)
    .concat(defaultToConfig2Keys);

  var otherKeys = Object
    .keys(config2)
    .filter(function filterAxiosKeys(key) {
      return axiosKeys.indexOf(key) === -1;
    });

  utils.forEach(otherKeys, function otherKeysDefaultToConfig2(prop) {
    if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    } else if (typeof config1[prop] !== 'undefined') {
      config[prop] = config1[prop];
    }
  });

  return config;
};


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */
function Cancel(message) {
  this.message = message;
}

Cancel.prototype.toString = function toString() {
  return 'Cancel' + (this.message ? ': ' + this.message : '');
};

Cancel.prototype.__CANCEL__ = true;

module.exports = Cancel;


/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuetify__ = __webpack_require__(676);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuetify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuetify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_shortkey__ = __webpack_require__(677);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_shortkey___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_shortkey__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_touch__ = __webpack_require__(678);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_touch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_touch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_resource__ = __webpack_require__(680);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_analytics__ = __webpack_require__(682);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_analytics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_analytics__);
/*jshint esversion: 6 */
/* The Vue build version to load with the `import` command
(runtime-only or standalone) has been set in webpack.base.conf with an alias. */

var path = __webpack_require__(17);










__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vuetify___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_4_vue_shortkey___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_6_vue_resource__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_5_vue_touch___default.a.config.swipe = {
  direction: 'horizontal',
  threshold: 10,
  velocity: 0.3,
  pointers: 1
};

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_5_vue_touch___default.a, { name: 'v-touch' });

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_7_vue_analytics___default.a, {
  id: ['UA-137347938-1', 'UA-64435914-1'],
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  autoTracking: {
    pageviewTemplate: function pageviewTemplate(route) {
      return {
        page: path.join(window.location.pathname, route.path),
        title: document.title,
        location: window.location.href
      };
    }
  },
  debug: {
    enabled: false
  }
});

var app = new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  data: {},
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_1__App___default.a);
  }
}).$mount('#app');

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {// .dirname, .basename, and .extname methods are extracted from Node.js v8.11.1,
// backported and transplited with Babel, with backwards-compat fixes

// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// resolves . and .. elements in a path array with directory names there
// must be no slashes, empty elements, or device names (c:\) in the array
// (so also no leading and trailing slashes - it does not distinguish
// relative and absolute paths)
function normalizeArray(parts, allowAboveRoot) {
  // if the path tries to go above the root, `up` ends up > 0
  var up = 0;
  for (var i = parts.length - 1; i >= 0; i--) {
    var last = parts[i];
    if (last === '.') {
      parts.splice(i, 1);
    } else if (last === '..') {
      parts.splice(i, 1);
      up++;
    } else if (up) {
      parts.splice(i, 1);
      up--;
    }
  }

  // if the path is allowed to go above the root, restore leading ..s
  if (allowAboveRoot) {
    for (; up--; up) {
      parts.unshift('..');
    }
  }

  return parts;
}

// path.resolve([from ...], to)
// posix version
exports.resolve = function() {
  var resolvedPath = '',
      resolvedAbsolute = false;

  for (var i = arguments.length - 1; i >= -1 && !resolvedAbsolute; i--) {
    var path = (i >= 0) ? arguments[i] : process.cwd();

    // Skip empty and invalid entries
    if (typeof path !== 'string') {
      throw new TypeError('Arguments to path.resolve must be strings');
    } else if (!path) {
      continue;
    }

    resolvedPath = path + '/' + resolvedPath;
    resolvedAbsolute = path.charAt(0) === '/';
  }

  // At this point the path should be resolved to a full absolute path, but
  // handle relative paths to be safe (might happen when process.cwd() fails)

  // Normalize the path
  resolvedPath = normalizeArray(filter(resolvedPath.split('/'), function(p) {
    return !!p;
  }), !resolvedAbsolute).join('/');

  return ((resolvedAbsolute ? '/' : '') + resolvedPath) || '.';
};

// path.normalize(path)
// posix version
exports.normalize = function(path) {
  var isAbsolute = exports.isAbsolute(path),
      trailingSlash = substr(path, -1) === '/';

  // Normalize the path
  path = normalizeArray(filter(path.split('/'), function(p) {
    return !!p;
  }), !isAbsolute).join('/');

  if (!path && !isAbsolute) {
    path = '.';
  }
  if (path && trailingSlash) {
    path += '/';
  }

  return (isAbsolute ? '/' : '') + path;
};

// posix version
exports.isAbsolute = function(path) {
  return path.charAt(0) === '/';
};

// posix version
exports.join = function() {
  var paths = Array.prototype.slice.call(arguments, 0);
  return exports.normalize(filter(paths, function(p, index) {
    if (typeof p !== 'string') {
      throw new TypeError('Arguments to path.join must be strings');
    }
    return p;
  }).join('/'));
};


// path.relative(from, to)
// posix version
exports.relative = function(from, to) {
  from = exports.resolve(from).substr(1);
  to = exports.resolve(to).substr(1);

  function trim(arr) {
    var start = 0;
    for (; start < arr.length; start++) {
      if (arr[start] !== '') break;
    }

    var end = arr.length - 1;
    for (; end >= 0; end--) {
      if (arr[end] !== '') break;
    }

    if (start > end) return [];
    return arr.slice(start, end - start + 1);
  }

  var fromParts = trim(from.split('/'));
  var toParts = trim(to.split('/'));

  var length = Math.min(fromParts.length, toParts.length);
  var samePartsLength = length;
  for (var i = 0; i < length; i++) {
    if (fromParts[i] !== toParts[i]) {
      samePartsLength = i;
      break;
    }
  }

  var outputParts = [];
  for (var i = samePartsLength; i < fromParts.length; i++) {
    outputParts.push('..');
  }

  outputParts = outputParts.concat(toParts.slice(samePartsLength));

  return outputParts.join('/');
};

exports.sep = '/';
exports.delimiter = ':';

exports.dirname = function (path) {
  if (typeof path !== 'string') path = path + '';
  if (path.length === 0) return '.';
  var code = path.charCodeAt(0);
  var hasRoot = code === 47 /*/*/;
  var end = -1;
  var matchedSlash = true;
  for (var i = path.length - 1; i >= 1; --i) {
    code = path.charCodeAt(i);
    if (code === 47 /*/*/) {
        if (!matchedSlash) {
          end = i;
          break;
        }
      } else {
      // We saw the first non-path separator
      matchedSlash = false;
    }
  }

  if (end === -1) return hasRoot ? '/' : '.';
  if (hasRoot && end === 1) {
    // return '//';
    // Backwards-compat fix:
    return '/';
  }
  return path.slice(0, end);
};

function basename(path) {
  if (typeof path !== 'string') path = path + '';

  var start = 0;
  var end = -1;
  var matchedSlash = true;
  var i;

  for (i = path.length - 1; i >= 0; --i) {
    if (path.charCodeAt(i) === 47 /*/*/) {
        // If we reached a path separator that was not part of a set of path
        // separators at the end of the string, stop now
        if (!matchedSlash) {
          start = i + 1;
          break;
        }
      } else if (end === -1) {
      // We saw the first non-path separator, mark this as the end of our
      // path component
      matchedSlash = false;
      end = i + 1;
    }
  }

  if (end === -1) return '';
  return path.slice(start, end);
}

// Uses a mixed approach for backwards-compatibility, as ext behavior changed
// in new Node.js versions, so only basename() above is backported here
exports.basename = function (path, ext) {
  var f = basename(path);
  if (ext && f.substr(-1 * ext.length) === ext) {
    f = f.substr(0, f.length - ext.length);
  }
  return f;
};

exports.extname = function (path) {
  if (typeof path !== 'string') path = path + '';
  var startDot = -1;
  var startPart = 0;
  var end = -1;
  var matchedSlash = true;
  // Track the state of characters (if any) we see before our first dot and
  // after any path separator we find
  var preDotState = 0;
  for (var i = path.length - 1; i >= 0; --i) {
    var code = path.charCodeAt(i);
    if (code === 47 /*/*/) {
        // If we reached a path separator that was not part of a set of path
        // separators at the end of the string, stop now
        if (!matchedSlash) {
          startPart = i + 1;
          break;
        }
        continue;
      }
    if (end === -1) {
      // We saw the first non-path separator, mark this as the end of our
      // extension
      matchedSlash = false;
      end = i + 1;
    }
    if (code === 46 /*.*/) {
        // If this is our first dot, mark it as the start of our extension
        if (startDot === -1)
          startDot = i;
        else if (preDotState !== 1)
          preDotState = 1;
    } else if (startDot !== -1) {
      // We saw a non-dot and non-path separator before our dot, so we should
      // have a good chance at having a non-empty extension
      preDotState = -1;
    }
  }

  if (startDot === -1 || end === -1 ||
      // We saw a non-dot character immediately before the dot
      preDotState === 0 ||
      // The (right-most) trimmed path component is exactly '..'
      preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) {
    return '';
  }
  return path.slice(startDot, end);
};

function filter (xs, f) {
    if (xs.filter) return xs.filter(f);
    var res = [];
    for (var i = 0; i < xs.length; i++) {
        if (f(xs[i], i, xs)) res.push(xs[i]);
    }
    return res;
}

// String.prototype.substr - negative index don't work in IE8
var substr = 'ab'.substr(-1) === 'b'
    ? function (str, start, len) { return str.substr(start, len) }
    : function (str, start, len) {
        if (start < 0) start = str.length + start;
        return str.substr(start, len);
    }
;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var scope = (typeof global !== "undefined" && global) ||
            (typeof self !== "undefined" && self) ||
            window;
var apply = Function.prototype.apply;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) {
  if (timeout) {
    timeout.close();
  }
};

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(scope, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// setimmediate attaches itself to the global object
__webpack_require__(19);
// On some exotic environments, it's not clear which object `setimmediate` was
// able to install onto.  Search each possibility in the same order as the
// `setimmediate` library.
exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
                       (typeof global !== "undefined" && global.setImmediate) ||
                       (this && this.setImmediate);
exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
                         (typeof global !== "undefined" && global.clearImmediate) ||
                         (this && this.clearImmediate);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
      // Callback can either be a function or a string
      if (typeof callback !== "function") {
        callback = new Function("" + callback);
      }
      // Copy function arguments
      var args = new Array(arguments.length - 1);
      for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i + 1];
      }
      // Store and register the task
      var task = { callback: callback, args: args };
      tasksByHandle[nextHandle] = task;
      registerImmediate(nextHandle);
      return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
        case 0:
            callback();
            break;
        case 1:
            callback(args[0]);
            break;
        case 2:
            callback(args[0], args[1]);
            break;
        case 3:
            callback(args[0], args[1], args[2]);
            break;
        default:
            callback.apply(undefined, args);
            break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            process.nextTick(function () { runIfPresent(handle); });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global &&
                typeof event.data === "string" &&
                event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();

    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();

    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();

    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();

    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4), __webpack_require__(2)))

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(21)
  __webpack_require__(22)
  __webpack_require__(23)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(24),
  /* template */
  __webpack_require__(46),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 21 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 22 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 23 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Reader_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Reader_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Reader_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Settings_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Settings_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Settings_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__event_hub_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    pageNum: {
      type: Number,
      default: 0
    },
    ttlPages: {
      type: Number,
      default: 0
    }
  },
  data: function data() {
    return {
      pageNumber: this.pageNum,
      totalPages: this.ttlPages,
      info: false,
      buyBar: true,
      buyMenu: false,
      socialMenu: false,
      otherBooks: false,
      focused: false,
      dialogBuy: false,
      dialogShare: false,
      notifications: false,
      sound: true,
      widgets: false,
      show: false,
      iSize: 50,
      selectBook: "Books",
      home: this.$route.path,
      drawer: false,
      drawerRight: false,
      items: [],
      books: [],
      booksChanged: '',
      socials: [{
        title: "LinkedIn",
        img: "static/img/linkedin-logo.svg",
        url: "https://www.linkedin.com/shareArticle?mini=true&url=https://textcafe.co/books/11fRC9u/%3F1737121986411&title=Chronicles%20of%20Barsetshire%20Volume%20Two%2C%20The%20Chronicles%20of%20Barsetshire&summary=Three%20wise%2C%20witty%20novels%20in%20the%20saga%20following%20the%20residents%20of%20a%20rural%20English%20town%20in%20the%20Victorian%20era.%20In%20the%20nineteenth%20century%2C%20Anthony%20Trollope%20created%20the%20fictional%20world%20of%20Barsetshire%2C%20the%20setting%20for%20a%20series%20of%20classic%20novel&source=LinkedIn",
        icon: "ion-social-linkedin"
      }, {
        title: "Facebook",
        img: "static/img/facebook-logo.svg",
        url: "https://www.facebook.com/sharer/sharer.php?u=https://textcafe.co/books/11fRC9u/%3F1737121986411",
        icon: "ion-social-facebook"
      }, {
        title: "Twitter",
        img: "static/img/twitter-logo-silhouette.svg",
        url: "https://twitter.com/intent/tweet?text=Three%20wise%2C%20witty%20novels%20in%20the%20saga%20following%20the%20residents%20of%20a%20rural%20English%20town%20in%20the%20Victorian%20era.%20In%20the%20nineteenth%20%0Dhttps://textcafe.co/books/11fRC9u/%3F1737121986411&amp;via=textcafecom",
        icon: "ion-social-twitter"
      }, {
        title: "Tumblr",
        img: "static/img/tumblr-letter-logo.svg",
        url: "https://www.tumblr.com/widgets/share/tool?canonicalUrl=https://textcafe.co/books/11fRC9u/%3F1737121986411&posttype=link&caption=Three%20wise%2C%20witty%20novels%20in%20the%20saga%20following%20the%20residents%20of%20a%20rural%20English%20town%20in%20the%20Victorian%20era.%20In%20the%20nineteenth%20century%2C%20Anthony%20Trollope%20created%20the%20fictional%20world%20of%20Barsetshire%2C%20the%20setting%20for%20a%20series%20of%20classic%20novel",
        icon: "ion-social-tumblr"
      }, {
        title: "Pinterest",
        img: "static/img/pinterest-logo.svg",
        url: "http://www.pinterest.com/pin/create/button/?url=https://textcafe.co/books/11fRC9u/%3F1737121986411&description=Three%20wise%2C%20witty%20novels%20in%20the%20saga%20following%20the%20residents%20of%20a%20rural%20English%20town%20in%20the%20Victorian%20era.%20In%20the%20nineteenth%20century%2C%20Anthony%20Trollope%20created%20the%20fictional%20world%20of%20Barsetshire%2C%20the%20setting%20for%20a%20series%20of%20classic%20novel&media=https://textcafe.co/books/11fRC9u/tc-custom/9781504065214.jpg",
        icon: "ion-social-pinterest"
      }],
      buys: [{
        title: 'Amazon US',
        img: 'https://textcafe.co/domain-icons/Amazon.com_A_Smile.svg',
        url: 'https://www.amazon.com/s?k=9781504065214&i=stripbooks&linkCode=qs&tag=mobilebookcom-20',
        alt: 'None'
      }, {
        title: 'Google Play',
        img: 'https://textcafe.co/global-css/img/Google_Play_symbol.svg',
        url: 'https://play.google.com/store/books/details?id=xOMKEAAAQBAJ&amp;rdid=book-xOMKEAAAQBAJ&amp;rdot=1&amp;source=gbs_atb&amp;pcampaignid=books_booksearch_atb&gl=us',
        alt: 'None'
      }],
      right: null,
      left: null
    };
  },
  mounted: function mounted() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('https://www.textcafe.com/widget/get-samples.json?related=9781504065214').then(function (response) {
      return _this.books = response.data.map(function (item) {
        return {
          title: item.title,
          img: item.coverImagePath,
          url: item.socialUrl,
          alt: "This image is the cover for the book " + item.title
        };
      });
    }).catch(function (error) {
      return (
        // handle error
        console.log(error)
      );
    });
  },

  created: function created() {
    var _this2 = this;

    this.$router.options.routes.forEach(function (route) {
      _this2.items.push({
        path: route.path,
        name: route.name,
        component: route.component,
        //image: "static/img/ilG6Mf.jpg"
        image: '/books/11fRC9u/tc-custom/9781504065214.jpg?1737121986411',
        alt: 'Chronicles of Barsetshire Volume Two, The Chronicles of Barsetshire'
      });
    });
    __WEBPACK_IMPORTED_MODULE_2__event_hub_js__["a" /* default */].$on("pageNum", function (newValue) {
      _this2.pageNum = newValue;
    });
    __WEBPACK_IMPORTED_MODULE_2__event_hub_js__["a" /* default */].$on("ttlPages", function (newValue) {
      _this2.ttlPages = newValue;
    });
  },
  watch: {
    $route: function $route(to, from) {
      if (to.path === "/") {
        this.home = this.$route.path;
      } else {
        this.home = null;
      }
    },

    iSize: function iSize(newValue) {
      __WEBPACK_IMPORTED_MODULE_2__event_hub_js__["a" /* default */].$emit("iSizeChanged", newValue);
    },
    books: function books(newValue) {
      __WEBPACK_IMPORTED_MODULE_2__event_hub_js__["a" /* default */].$emit("booksChanged", Date.now());
    }
  },
  methods: {
    resetScroll: function resetScroll() {
      var page = this.$el.querySelector(".book-page");
      page.scrollLeft = 0;
    },
    onBlur: function onBlur() {
      if (this.show === true) {
        this.show = false;
        this.$emit("blur");
      }
    },
    onFocus: function onFocus() {
      if (this.show === false) {
        this.show = true;
        this.$el.querySelector(".book-page").$emit("focus");
      }
    },
    buyClick: function buyClick(url) {
      //const url = '/foo/bar'
      // this.$ga.query('send', 'event', 'outbound', 'click', url, {
      //     transport: 'beacon',
      //     hitCallback () {
      //        //document.location = url
      //     }
      // })
      this.$ga.event({
        eventCategory: 'purchase',
        eventAction: 'click',
        eventLabel: url
        // eventValue: 123
      });
    },
    shareClick: function shareClick(network) {
      this.$ga.event({
        eventCategory: 'share',
        eventAction: 'click',
        eventLabel: network
        // eventValue: 123
      });
    }
  },
  components: {
    settings: __WEBPACK_IMPORTED_MODULE_1__components_Settings_vue___default.a,
    reader: __WEBPACK_IMPORTED_MODULE_0__components_Reader_vue___default.a
  }
});

/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__event_hub_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Settings__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Settings___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Settings__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var SLIDE_TIME = document.documentElement.clientWidth > 480 ? 500 : 300;

/* harmony default export */ __webpack_exports__["default"] = ({
  name: "reader",
  props: {
    value1: {
      type: Number,
      default: 22
    },
    selected: {
      type: String
    },
    ex8: {
      type: String,
      default: "Auto"
    },
    value2: {
      type: Number
    },
    value3: {
      type: Number,
      default: 100
    }
  },
  data: function data() {
    return {
      pageNum: 0,
      pageNumber: 1,
      ttlPages: 0,
      totalPages: 0,
      home: false,
      div: 0,
      prevX: null,
      xDownEnd: null,
      fontSize: this.value1,
      fontFamily: this.selected,
      columns: this.ex8,
      widthSize: this.value2,
      brightness: this.value3,
      currentColor: "#f3f3f3",
      cols: "2 220px",
      position: { scrollTop: 0, scrollLeft: 0 },
      offset: null,
      height: 0,
      isOver: false,
      routeNames: ["home", "bundle_content", "Book1/cover", "Book1/Untitled-1", "Book1/Untitled-1-1", "Book1/Untitled-1-2", "Book1/Untitled-1-3", "Book1/Untitled-1-4", "Book1/Untitled-1-5", "Book1/Untitled-1-6", "Book1/Untitled-1-7", "Book1/Untitled-1-8", "Book1/Untitled-1-9", "Book1/Untitled-1-10", "Book1/Untitled-1-11", "Book1/Untitled-1-12", "Book1/Untitled-1-13", "Book1/Untitled-1-14", "Book1/Untitled-1-15", "Book1/Untitled-1-16", "Book1/Untitled-1-17", "Book1/Untitled-1-18", "last"],
      routeTransition: "slide-left",
      rest: true,
      selectedView: "Book1",
      progress: 0,
      hiddenEl: false,
      brandReaderUrl: "",
      brandLogoUrl: "",
      currentUrl: "https://textcafe.co/books/11fRC9u/",
      waiting: false
    };
  },

  created: function created() {
    var _this = this;

    document.addEventListener("mousewheel", this.onScroll, false);
    window.addEventListener('resize', this.resize);
    this.resize();
    this.getTtlPages();

    if (document.documentElement.offsetWidth >= 768) {
      this.hiddenEl = true;
    } else {
      this.hiddenEl = false;
    }

    this.$router.options.routes.forEach(function (route) {
      _this.routeNames.push(route.name);
    });
    __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$on("fontSizeChanged", function (newValue) {
      _this.fontSize = newValue;
    });
    __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$on("fontFamilyChanged", function (newValue) {
      _this.fontFamily = newValue;
    });
    __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$on("columnsCountChanged", function (newValue) {
      _this.columns = newValue;
      if (_this.columns === "Single") {
        _this.cols = "1 auto";
      } else if (_this.columns === "Auto") {
        _this.cols = "2 220px";
      }
    });
    __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$on("widthChanged", function (newValue) {
      _this.widthSize = newValue;
    });
    __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$on("brightnessChanged", function (newValue) {
      _this.brightness = newValue;
    });
  },

  destroyed: function destroyed() {
    document.removeEventListener("mousewheel", this.onScroll, false);
    document.removeEventListener("resize", this.resize, false);
  },
  updated: function updated() {
    this.getTtlPages();
    this.resize();
    var links = document.getElementsByTagName("a");
    for (var i = 0; i < links.length; i++) {
      var that = this;
      var url = "/" + document.location.hash.split("#/")[1];
      if (links[i].href.split("#")[1] === url) {
        links[i].style.textDecoration = "underline";
        links[i].style.textDecorationStyle = "dotted";
        links[i].onclick = function (e) {
          e.preventDefault();
          var refr = this.href.split("#")[2];
          that.linkTo(refr);
        };
      };
    };
  },
  mounted: function mounted() {
    this.resize();

    var links = document.getElementsByTagName("a");
    for (var i = 0; i < links.length; i++) {
      var that = this;
      var url = "/" + document.location.hash.split("#/")[1];
      if (links[i].href.split("#")[1] === url) {
        links[i].style.textDecoration = "underline";
        links[i].style.textDecorationStyle = "dotted";
        links[i].onclick = function (e) {
          e.preventDefault();
          var refr = this.href.split("#")[2];
          that.linkTo(refr);
        };
      };
    };

    this.getTtlPages();

    var bgColor = document.getElementsByClassName("book-content")[0].style.backgroundColor,
        hexDigits = new Array("0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "a", "b", "c", "d", "e", "f");
    function rgb2hex(rgb) {
      rgb = rgb.match(/^rgb\((\d+),\s*(\d+),\s*(\d+)\)$/);
      return "#" + hex(rgb[1]) + hex(rgb[2]) + hex(rgb[3]);
    }
    function hex(x) {
      return isNaN(x) ? "00" : hexDigits[(x - x % 16) / 16] + hexDigits[x % 16];
    }
    this.currentColor = rgb2hex(bgColor);
  },

  watch: {
    $route: function $route(to, from, next) {
      var toDepth = this.routeNames.indexOf(to.name);
      var fromDepth = this.routeNames.indexOf(from.name);
      this.routeTransition = toDepth < fromDepth ? "slide-right" : "slide-left";

      this.progress = 0;
      this.pageNumber = 1;
    },

    pageNum: function pageNum(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("pageNum", newValue);
    },
    ttlPages: function ttlPages(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("ttlPages", newValue);
    }
  },
  methods: {
    resize: function resize() {
      this.height = document.documentElement.clientHeight;
    },
    linkTo: function linkTo(refName) {
      var element = document.getElementById(refName);
      var elementOffset = Math.ceil(element.offsetLeft);
      var page = this.$el.querySelector(".book-page");
      var gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10);
      var onStart = Math.ceil(page.scrollLeft);
      var destinationOffset = Math.floor(elementOffset / (page.offsetWidth + gap));
      var target = destinationOffset * (page.offsetWidth + gap) - onStart;
      if (destinationOffset + 1 !== this.pageNumber) {
        this.scrollIt(target, 300, "easeOutQuad", false);
        var scrollArea = page.scrollWidth - page.offsetWidth;
        var pctScrolled = Math.floor(destinationOffset * (page.offsetWidth + gap) / scrollArea * 100);
        this.progress = pctScrolled;
        this.pageNumber = destinationOffset + 1;
      }
    },
    getTtlPages: function getTtlPages() {
      this.$nextTick(function () {
        var page = this.$el.querySelector(".book-page");

        var gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10);

        var scrollArea = page.scrollWidth - page.offsetWidth;
        var ttlPages = Math.round(scrollArea / (page.offsetWidth + gap));
        this.ttlPages = ttlPages;
        this.totalPages = this.ttlPages + 1;
      });
    },
    tapped: function tapped() {
      var el = this.$el.querySelector(".touch-swipe");
      this.hiddenEl = !this.hiddenEl;
    },
    tappedIn: function tappedIn() {
      var el = this.$el.querySelector(".touch-swipe");
      this.hiddenEl = !this.hiddenEl;
    },
    scrollIt: function scrollIt(destination) {
      var duration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 200;

      var _this2 = this;

      var easing = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "easeInOutQuart";
      var callback = arguments[3];

      var easings = {
        linear: function linear(t) {
          return t;
        },
        easeInQuad: function easeInQuad(t) {
          return t * t;
        },
        easeOutQuad: function easeOutQuad(t) {
          return t * (2 - t);
        },
        easeInOutQuad: function easeInOutQuad(t) {
          return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
        },
        easeInCubic: function easeInCubic(t) {
          return t * t * t;
        },
        easeOutCubic: function easeOutCubic(t) {
          return --t * t * t + 1;
        },
        easeInOutCubic: function easeInOutCubic(t) {
          return t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;
        },
        easeInQuart: function easeInQuart(t) {
          return t * t * t * t;
        },
        easeOutQuart: function easeOutQuart(t) {
          return 1 - --t * t * t * t;
        },
        easeInOutQuart: function easeInOutQuart(t) {
          return t < 0.5 ? 8 * t * t * t * t : 1 - 8 * --t * t * t * t;
        },
        easeInQuint: function easeInQuint(t) {
          return t * t * t * t * t;
        },
        easeOutQuint: function easeOutQuint(t) {
          return 1 + --t * t * t * t * t;
        },
        easeInOutQuint: function easeInOutQuint(t) {
          return t < 0.5 ? 16 * t * t * t * t * t : 1 + 16 * --t * t * t * t * t;
        }
      };

      var page = this.$el.querySelector(".book-page");
      var gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10),
          offset = page.offsetWidth + gap;

      var start = Math.ceil(page.scrollLeft);

      var startTime = "now" in window.performance ? performance.now() : new Date().getTime();

      var documentWidth = Math.max(page.scrollWidth || page.offsetWidth || page.clientWidth);

      var windowWidth = window.innerWidth || window.clientWidth;

      var destinationOffsetToScroll = start + destination;

      function scroll() {
        var now = "now" in window.performance ? performance.now() : new Date().getTime();
        var time = Math.min(1, (now - startTime) / duration);
        var timeFunction = easings[easing](time);
        page.scroll(Math.ceil(timeFunction * (destinationOffsetToScroll - start) + start), 0);
        if (timeFunction === 1 || start === destinationOffsetToScroll) {
          if (callback) {
            callback();
          }
          return;
        }
        requestAnimationFrame(scroll);
      }
      scroll();
      setTimeout(function () {
        _this2.waiting = false;
      }, 250);
    },


    next: function next(e) {
      var el = this.$el.querySelector(".touch-swipe");
      if (el) el.style.pointerEvents = "auto";
      var book = this.$el.querySelector(".book-content");
      var page = this.$el.querySelector(".book-page"),
          gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10),
          offset = page.offsetWidth + gap,
          index = this.routeNames.indexOf(this.$route.name);

      var scrollArea = page.scrollWidth - page.offsetWidth;
      var windowWidth = window.innerWidth || window.clientWidth;
      var trackLength = scrollArea - (page.offsetWidth + gap);

      // var pageNum = Math.floor(page.scrollLeft / (page.offsetWidth + gap));
      var scrollLeft = Math.ceil(page.scrollLeft);
      var pageNum = Math.floor(scrollLeft / (page.offsetWidth + gap));

      this.pageNum = pageNum;

      pageNum += 1;

      this.pageNumber += 1;

      if (page.scrollWidth - (scrollLeft + page.offsetWidth) !== 0 && pctScrolled !== 100) {
        var currentPage = Math.floor(pageNum * (page.offsetWidth + gap));

        var nextPage = Math.floor(pageNum * (page.offsetWidth + gap));

        var destination = nextPage - scrollLeft;

        this.scrollIt(destination, 300, "easeOutQuad", false);
      } else {
        this.$router.push({ name: this.routeNames[index + 1] });

        this.pageNumber = 1;
        pageNum = 0;
        var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
        this.progress = pctScrolled;
      }
      var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
      this.progress = pctScrolled;
    },
    prev: function prev(e) {
      var el = this.$el.querySelector(".touch-swipe");
      if (el) el.style.pointerEvents = "auto";

      var page = this.$el.querySelector(".book-page"),
          gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10),
          offset = page.offsetWidth + gap,
          index = this.routeNames.indexOf(this.$route.name);

      var scrollArea = page.scrollWidth - page.offsetWidth;

      var scrollLeft = Math.ceil(page.scrollLeft);
      var pageNum = Math.round(scrollLeft / (page.offsetWidth + gap));
      var ttlPages = Math.round(scrollArea / (page.offsetWidth + gap));

      this.pageNum = pageNum;

      this.pageNumber -= 1;

      var currentPage = Math.floor(pageNum * (page.offsetWidth + gap));

      if (scrollLeft !== 0 && pageNum !== 0) {
        var pageNum = Math.round(scrollLeft / (page.offsetWidth + gap));
        var pageNumber = Math.floor(scrollLeft / (page.offsetWidth + gap));

        pageNum -= 1;
        var prevPage = Math.floor(pageNum * (page.offsetWidth + gap));

        var destination = -1 * (scrollLeft - prevPage);

        this.scrollIt(destination, 300, "easeOutQuad", false);
      } else {
        this.$router.push({ name: this.routeNames[index - 1] });

        this.pageNumber = 1;

        pageNum = 0;
        var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
        this.progress = pctScrolled;
      }
      var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
      this.progress = pctScrolled;
    },
    over: function over() {
      this.isOver = true;
    },
    out: function out() {
      this.isOver = false;
    },
    onScroll: function onScroll(e, position) {
      this.position = position;
      if (this.isOver === true) {
        var page = this.$el.querySelector(".book-page"),
            gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10),
            deltaX = Math.max(-1, Math.min(1, e.wheelDelta || -e.detail)),
            end = page.scrollWidth - (page.scrollLeft + page.offsetWidth),
            offset = page.offsetWidth + gap;

        var scrollArea = page.scrollWidth - page.offsetWidth;
        var pageNum = Math.round(page.scrollLeft / (page.offsetWidth + gap));

        var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
        this.progress = pctScrolled;

        if (deltaX === 1) {
          if (page.scrollLeft !== 0) {
            if (this.waiting) {
              return;
            }
            this.waiting = true;

            pageNum -= 1;

            this.pageNumber -= 1;
            var prevPage = Math.floor(pageNum * (page.offsetWidth + gap));

            var destination = -1 * (page.scrollLeft - prevPage);

            this.scrollIt(destination, 300, "easeOutQuad", false);

            var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
            this.progress = pctScrolled;
          }
        } else if (deltaX === -1) {
          if (page.scrollWidth - (page.scrollLeft + page.offsetWidth) !== 0) {
            if (this.waiting) {
              return;
            }
            this.waiting = true;

            pageNum += 1;

            this.pageNumber += 1;
            var nextPage = Math.floor(pageNum * (page.offsetWidth + gap));

            var destination = nextPage - page.scrollLeft;

            this.scrollIt(destination, 300, "easeOutQuad", false);

            var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
            this.progress = pctScrolled;
          }
        }
      } else {
        return;
      }
    },
    fadeIn: function fadeIn() {
      var page = this.$el.querySelector(".book-page");
      page.style.opacity = 0;
      var last = +new Date();
      var tick = function tick() {
        page.style.opacity = +page.style.opacity + (new Date() - last) / 400;
        last = +new Date();
        if (+page.style.opacity < 1) {
          window.requestAnimationFrame && requestAnimationFrame(tick) || setTimeout(tick, 16);
        }
      };
      tick();
    },

    resetScroll: function resetScroll() {
      var page = this.$el.querySelector(".book-page");
      page.scrollLeft = 0;
    }
  },
  computed: {
    isMobile: function isMobile() {
      var check = false;
      (function (a) {
        if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true;
      })(navigator.userAgent || navigator.vendor || window.opera);
      return check;
    }
  },
  components: {
    Settings: __WEBPACK_IMPORTED_MODULE_1__components_Settings___default.a
  }
});

/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__event_hub_js__ = __webpack_require__(5);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: "settings",
  data: function data() {
    return {
      events: [],
      value1: 22,
      value2: 70,
      value3: 100,
      ex8: "Auto",
      selected: "Old-Cabin",
      fonts: ["Old-Cabin", "Raleway-Bitter", "Ubuntu-Abel", "Droid-Abril", "Garamond-Clicker", "Alice-Playfair", "Judson-Quando"],
      classes: ["white", "black", "sepia"]
    };
  },

  watch: {
    value1: function value1(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("fontSizeChanged", newValue);
    },
    selected: function selected(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("fontFamilyChanged", newValue);
    },
    ex8: function ex8(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("columnsCountChanged", newValue);
    },
    value2: function value2(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("widthChanged", newValue);
    },
    value3: function value3(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("brightnessChanged", newValue);
    }
  },
  methods: {
    reloadBook: function reloadBook() {
      window.location.reload(true);
    },
    changeClassWhite: function changeClassWhite() {
      var el = document.getElementsByClassName("book-content")[0];
      var el2 = document.getElementsByClassName("nav-btn")[0];
      var el3 = document.getElementsByClassName("nav-btn")[1];
      var el4 = document.getElementsByTagName("footer")[0];
      console.log(document.getElementsByTagName("footer")[0]);
      if (el.classList && el2.classList && el3.classList && el4.classList) {
        el.classList.remove("black");
        el2.classList.remove("black");
        el3.classList.remove("black");
        el4.classList.remove("black");
        el.classList.remove("sepia");
        el2.classList.remove("sepia");
        el3.classList.remove("sepia");
        el4.classList.remove("sepia");
        el.classList.add("white");
        el2.classList.add("white");
        el3.classList.add("white");
        el4.classList.add("white");
      } else {
        el.className += " white";
        el2.className += " white";
        el3.className += " white";
        el4.className += " white";
      }
    },
    changeClassBlack: function changeClassBlack() {
      var el = document.getElementsByClassName("book-content")[0];
      var el2 = document.getElementsByClassName("nav-btn")[0];
      var el3 = document.getElementsByClassName("nav-btn")[1];
      var el4 = document.getElementsByTagName("footer")[0];
      if (el.classList && el2.classList && el3.classList && el4.classList) {
        el.classList.remove("white");
        el2.classList.remove("white");
        el3.classList.remove("white");
        el4.classList.remove("white");
        el.classList.remove("sepia");
        el2.classList.remove("sepia");
        el3.classList.remove("sepia");
        el4.classList.remove("sepia");
        el.classList.add("black");
        el2.classList.add("black");
        el3.classList.add("black");
        el4.classList.add("black");
      } else {
        el.className += " black";
        el2.className += " black";
        el3.className += " black";
        el4.className += " black";
      }
    },
    changeClassSepia: function changeClassSepia() {
      var el = document.getElementsByClassName("book-content")[0];
      var el2 = document.getElementsByClassName("nav-btn")[0];
      var el3 = document.getElementsByClassName("nav-btn")[1];
      var el4 = document.getElementsByTagName("footer")[0];
      if (el.classList && el2.classList && el3.classList && el4.classList) {
        el.classList.remove("black");
        el2.classList.remove("black");
        el3.classList.remove("black");
        el4.classList.remove("black");
        el.classList.remove("white");
        el2.classList.remove("white");
        el3.classList.remove("white");
        el4.classList.remove("white");
        el.classList.add("sepia");
        el2.classList.add("sepia");
        el3.classList.add("sepia");
        el4.classList.add("sepia");
      } else {
        el.className += " sepia";
        el2.className += " sepia";
        el3.className += " sepia";
        el4.className += " sepia";
      }
    }
  }
});

/***/ }),
/* 27 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "settings"
  }, [_c('ul', {
    staticClass: "settings-list"
  }, [_c('li', [_c('span', [_vm._v("Reload book: ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "id": "reloadBookBtn",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.reloadBook()
      }
    }
  }, [_c('v-icon', [_vm._v("ion-ios-loop-strong")])], 1)], 1), _vm._v(" "), _c('li', [_c('span', [_vm._v("Font:")]), _vm._v(" "), _c('v-select', {
    attrs: {
      "items": _vm.fonts,
      "overflow": "",
      "single-line": "",
      "return-objectauto": "",
      "append-icon": "ion-ios-arrow-down",
      "hide-details": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawerRight = true
      }
    },
    model: {
      value: (_vm.selected),
      callback: function($$v) {
        _vm.selected = $$v
      },
      expression: "selected"
    }
  })], 1), _vm._v(" "), _c('li', [_c('span', [_vm._v("Font size:")]), _vm._v(" "), _c('p', {
    staticClass: "bold-font",
    domProps: {
      "innerHTML": _vm._s(_vm.value1 + 'px' || null)
    }
  }), _vm._v(" "), _c('v-slider', {
    attrs: {
      "min": 17,
      "max": 27,
      "step": 1
    },
    model: {
      value: (_vm.value1),
      callback: function($$v) {
        _vm.value1 = $$v
      },
      expression: "value1"
    }
  })], 1), _vm._v(" "), _c('li', {
    staticClass: "columns-setting"
  }, [_c('span', [_vm._v("Page columns:")]), _c('br'), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": "Auto",
      "value": "Auto",
      "flat": "",
      "ripple": false,
      "prepend-icon": ""
    },
    model: {
      value: (_vm.ex8),
      callback: function($$v) {
        _vm.ex8 = $$v
      },
      expression: "ex8"
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": "Single",
      "value": "Single",
      "flat": "",
      "ripple": false,
      "prepend-icon": ""
    },
    model: {
      value: (_vm.ex8),
      callback: function($$v) {
        _vm.ex8 = $$v
      },
      expression: "ex8"
    }
  })], 1), _vm._v(" "), _c('li', {
    staticClass: "width-setting"
  }, [_c('span', [_vm._v("Page width:")]), _vm._v(" "), _c('p', {
    staticClass: "bold-font",
    domProps: {
      "innerHTML": _vm._s(_vm.value2 + '%' || null)
    }
  }), _vm._v(" "), _c('v-slider', {
    attrs: {
      "min": 50,
      "max": 90
    },
    model: {
      value: (_vm.value2),
      callback: function($$v) {
        _vm.value2 = $$v
      },
      expression: "value2"
    }
  })], 1), _vm._v(" "), _c('li', [_c('span', [_vm._v("Brightness:")]), _vm._v(" "), _c('p', {
    staticClass: "bold-font",
    domProps: {
      "innerHTML": _vm._s((_vm.value3 - 100) + '%' || null)
    }
  }), _vm._v(" "), _c('v-slider', {
    attrs: {
      "step": 1,
      "min": 0,
      "max": 200
    },
    model: {
      value: (_vm.value3),
      callback: function($$v) {
        _vm.value3 = $$v
      },
      expression: "value3"
    }
  })], 1), _vm._v(" "), _c('li', [_c('span', [_vm._v("Color mode:")]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    attrs: {
      "id": "colors"
    }
  }, [_c('v-btn', {
    attrs: {
      "flat": "",
      "id": "white",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.changeClassWhite()
      }
    }
  }, [_vm._v("\n          White\n        ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "id": "black",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.changeClassBlack()
      }
    }
  }, [_vm._v("\n          Black\n        ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "id": "sepia",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.changeClassSepia()
      }
    }
  }, [_vm._v("\n          Sepia\n        ")])], 1)])])])
},staticRenderFns: []}

/***/ }),
/* 28 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrap",
    style: ({
      'filter': 'brightness(' + _vm.brightness + '%)',
      'height': _vm.height - 49 + 'px'
    })
  }, [_c('v-progress-linear', {
    model: {
      value: (_vm.progress),
      callback: function($$v) {
        _vm.progress = $$v
      },
      expression: "progress"
    }
  }), _vm._v(" "), _c('v-btn', {
    directives: [{
      name: "shortkey",
      rawName: "v-shortkey",
      value: (['arrowleft']),
      expression: "['arrowleft']"
    }],
    staticClass: "nav-btn left",
    style: ({
      width: (100 - _vm.widthSize) + '%'
    }),
    attrs: {
      "ripple": false
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.prev($event)
      },
      "shortkey": _vm.prev
    }
  }, [_c('v-icon', {
    style: ({
      'left': (_vm.widthSize / 3.5) + '%'
    })
  }, [_vm._v("ion-ios-arrow-left")])], 1), _vm._v(" "), _c('v-btn', {
    directives: [{
      name: "shortkey",
      rawName: "v-shortkey",
      value: (['arrowright']),
      expression: "['arrowright']"
    }],
    staticClass: "nav-btn right",
    style: ({
      width: (100 - _vm.widthSize) + '%'
    }),
    attrs: {
      "ripple": false
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.next($event)
      },
      "shortkey": _vm.next
    }
  }, [_c('v-icon', {
    style: ({
      'right': (_vm.widthSize / 3.5) + '%'
    })
  }, [_vm._v("ion-ios-arrow-right")])], 1), _vm._v(" "), _c('div', {
    staticClass: "book-content",
    style: ({
      'width': _vm.widthSize + '%',
      'background-color': _vm.currentColor,
      'height': _vm.height - 78 + 'px'
    }),
    on: {
      "mouseenter": _vm.over,
      "mouseleave": _vm.out
    }
  }, [(_vm.isMobile) ? _c('v-touch', {
    staticClass: "touch-swipe",
    class: {
      active: _vm.hiddenEl
    },
    on: {
      "swipeleft": _vm.next,
      "swiperight": _vm.prev,
      "tap": _vm.tapped
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    key: _vm.div,
    staticClass: "book-page",
    class: _vm.fontFamily,
    style: ({
      'font-size': _vm.fontSize + 'px',
      'columns': _vm.cols
    }),
    attrs: {
      "enable-resize-watcher": ""
    },
    on: {
      "tap": _vm.tappedIn,
      "swipe": _vm.tappedIn,
      "click": _vm.tappedIn
    }
  }, [_c('transition', {
    attrs: {
      "name": _vm.routeTransition,
      "mode": "out-in"
    }
  }, [_c('router-view', {
    key: _vm.$route.name,
    staticClass: "view"
  })], 1)], 1)], 1), _vm._v(" "), _c('footer', {
    class: _vm.fontFamily,
    style: ({
      'font-size': (_vm.fontSize - 5) + 'px'
    })
  }, [(_vm.brandReaderUrl) ? _c('div', [_c('v-btn', {
    staticClass: "HC-footer-button",
    attrs: {
      "flat": "",
      "ripple": false,
      "tag": "a",
      "href": _vm.brandReaderUrl,
      "target": "_blank"
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawer = false, _vm.info = false, _vm.buyMenu = false, _vm.socialMenu = false, _vm.drawerRight = false, _vm.otherBooks = false
      }
    }
  }, [_c('i', [_c('img', {
    attrs: {
      "src": _vm.brandLogoUrl
    }
  })])])], 1) : _vm._e(), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('div', {
    staticClass: "foots"
  }, [_c('span', [_c('em', [_vm._v(_vm._s(this.$route.name))])]), _vm._v(" - page "), _c('span', [_c('em', [_vm._v(_vm._s(this.pageNumber))])]), _vm._v(" "), (this.totalPages > 1) ? _c('span', [_c('em', [_vm._v(_vm._s("/ " + this.totalPages))])]) : _vm._e()]), _vm._v(" "), _c('v-spacer')], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(30);

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);
var bind = __webpack_require__(8);
var Axios = __webpack_require__(31);
var mergeConfig = __webpack_require__(14);
var defaults = __webpack_require__(11);

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  return instance;
}

// Create the default instance to be exported
var axios = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios.Axios = Axios;

// Factory for creating new instances
axios.create = function create(instanceConfig) {
  return createInstance(mergeConfig(axios.defaults, instanceConfig));
};

// Expose Cancel & CancelToken
axios.Cancel = __webpack_require__(15);
axios.CancelToken = __webpack_require__(44);
axios.isCancel = __webpack_require__(10);

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = __webpack_require__(45);

module.exports = axios;

// Allow use of default import syntax in TypeScript
module.exports.default = axios;


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);
var buildURL = __webpack_require__(9);
var InterceptorManager = __webpack_require__(32);
var dispatchRequest = __webpack_require__(33);
var mergeConfig = __webpack_require__(14);

/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios.prototype.request = function request(config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof config === 'string') {
    config = arguments[1] || {};
    config.url = arguments[0];
  } else {
    config = config || {};
  }

  config = mergeConfig(this.defaults, config);

  // Set config.method
  if (config.method) {
    config.method = config.method.toLowerCase();
  } else if (this.defaults.method) {
    config.method = this.defaults.method.toLowerCase();
  } else {
    config.method = 'get';
  }

  // Hook up interceptors middleware
  var chain = [dispatchRequest, undefined];
  var promise = Promise.resolve(config);

  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    chain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    chain.push(interceptor.fulfilled, interceptor.rejected);
  });

  while (chain.length) {
    promise = promise.then(chain.shift(), chain.shift());
  }

  return promise;
};

Axios.prototype.getUri = function getUri(config) {
  config = mergeConfig(this.defaults, config);
  return buildURL(config.url, config.params, config.paramsSerializer).replace(/^\?/, '');
};

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, data, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url,
      data: data
    }));
  };
});

module.exports = Axios;


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

module.exports = InterceptorManager;


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);
var transformData = __webpack_require__(34);
var isCancel = __webpack_require__(10);
var defaults = __webpack_require__(11);

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
module.exports = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData(
    config.data,
    config.headers,
    config.transformRequest
  );

  // Flatten headers
  config.headers = utils.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers
  );

  utils.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  var adapter = config.adapter || defaults.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData(
      response.data,
      response.headers,
      config.transformResponse
    );

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData(
          reason.response.data,
          reason.response.headers,
          config.transformResponse
        );
      }
    }

    return Promise.reject(reason);
  });
};


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
module.exports = function transformData(data, headers, fns) {
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn(data, headers);
  });

  return data;
};


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

module.exports = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var createError = __webpack_require__(13);

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
module.exports = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  if (!validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(createError(
      'Request failed with status code ' + response.status,
      response.config,
      null,
      response.request,
      response
    ));
  }
};


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */
module.exports = function enhanceError(error, config, code, request, response) {
  error.config = config;
  if (code) {
    error.code = code;
  }

  error.request = request;
  error.response = response;
  error.isAxiosError = true;

  error.toJSON = function() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: this.config,
      code: this.code
    };
  };
  return error;
};


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isAbsoluteURL = __webpack_require__(39);
var combineURLs = __webpack_require__(40);

/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 * @returns {string} The combined full path
 */
module.exports = function buildFullPath(baseURL, requestedURL) {
  if (baseURL && !isAbsoluteURL(requestedURL)) {
    return combineURLs(baseURL, requestedURL);
  }
  return requestedURL;
};


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
module.exports = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */
module.exports = function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
};


/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var ignoreDuplicateOf = [
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
];

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
module.exports = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) { return parsed; }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));

    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === 'set-cookie') {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
  });

  return parsed;
};


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
    (function standardBrowserEnv() {
      var msie = /(msie|trident)/i.test(navigator.userAgent);
      var urlParsingNode = document.createElement('a');
      var originURL;

      /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
      function resolveURL(url) {
        var href = url;

        if (msie) {
        // IE needs attribute set twice to normalize properties
          urlParsingNode.setAttribute('href', href);
          href = urlParsingNode.href;
        }

        urlParsingNode.setAttribute('href', href);

        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
          href: urlParsingNode.href,
          protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
          host: urlParsingNode.host,
          search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
          hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
          hostname: urlParsingNode.hostname,
          port: urlParsingNode.port,
          pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
            urlParsingNode.pathname :
            '/' + urlParsingNode.pathname
        };
      }

      originURL = resolveURL(window.location.href);

      /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
      return function isURLSameOrigin(requestURL) {
        var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
        return (parsed.protocol === originURL.protocol &&
            parsed.host === originURL.host);
      };
    })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return function isURLSameOrigin() {
        return true;
      };
    })()
);


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs support document.cookie
    (function standardBrowserEnv() {
      return {
        write: function write(name, value, expires, path, domain, secure) {
          var cookie = [];
          cookie.push(name + '=' + encodeURIComponent(value));

          if (utils.isNumber(expires)) {
            cookie.push('expires=' + new Date(expires).toGMTString());
          }

          if (utils.isString(path)) {
            cookie.push('path=' + path);
          }

          if (utils.isString(domain)) {
            cookie.push('domain=' + domain);
          }

          if (secure === true) {
            cookie.push('secure');
          }

          document.cookie = cookie.join('; ');
        },

        read: function read(name) {
          var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
          return (match ? decodeURIComponent(match[3]) : null);
        },

        remove: function remove(name) {
          this.write(name, '', Date.now() - 86400000);
        }
      };
    })() :

  // Non standard browser env (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return {
        write: function write() {},
        read: function read() { return null; },
        remove: function remove() {}
      };
    })()
);


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Cancel = __webpack_require__(15);

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;
  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;
  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new Cancel(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

module.exports = CancelToken;


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */
module.exports = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};


/***/ }),
/* 46 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', {
    attrs: {
      "toolbar": ""
    }
  }, [_c('v-dialog', {
    attrs: {
      "fullscreen": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.info = !_vm.info
      }
    },
    model: {
      value: (_vm.info),
      callback: function($$v) {
        _vm.info = $$v
      },
      expression: "info"
    }
  }, [_c('v-card', {
    staticClass: "infoDialog"
  }, [_c('div', {
    staticClass: "menuIns"
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-navicon")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-ios-browsers-outline")])], 1), _vm._v(" "), _c('div', {
    staticClass: "menuInsTip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Contents")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Navigate to book chapters")])]), _vm._v(" "), _c('div', {
    staticClass: "menuInsTip2"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Related Books")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Other books you might like")])]), _vm._v(" "), _c('div', {
    staticClass: "socMenu"
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-social-linkedin")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-social-facebook")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-social-twitter")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-social-tumblr")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-social-pinterest")])], 1), _vm._v(" "), _c('div', {
    staticClass: "socMenuMob"
  }, [_c('v-icon', [_vm._v("ion-android-share-alt")])], 1), _vm._v(" "), _c('div', {
    staticClass: "socMenuTip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Share Book")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Share book to your social network")])]), _vm._v(" "), _c('div', {
    staticClass: "resize-settings"
  }, [_c('v-icon', [_vm._v("ion-ios-gear-outline")])], 1), _vm._v(" "), _c('div', {
    staticClass: "resize-settings-tip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Settings button")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Change colors and fonts")])]), _vm._v(" "), _c('div', {
    staticClass: "left-button"
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-ios-arrow-left")])], 1), _vm._v(" "), _c('div', {
    staticClass: "left-button-tip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Left/Previous")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Go to previous page or chapter in book view."), _c('br'), _vm._v("On touch screen swipe right.")])]), _vm._v(" "), _c('div', {
    staticClass: "right-button"
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-ios-arrow-right")])], 1), _vm._v(" "), _c('div', {
    staticClass: "right-button-tip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Right/Next")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Go to next page or chapter in book view."), _c('br'), _vm._v("On touch screen swipe left.")])]), _vm._v(" "), _c('div', {
    staticClass: "buy-buttons"
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-bag")])], 1), _vm._v(" "), _c('div', {
    staticClass: "buy-buttons-mob"
  }, [_c('v-icon', [_vm._v("ion-bag")])], 1), _vm._v(" "), _c('div', {
    staticClass: "buy-buttons-tip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Buy Book")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Click to stores where you can buy this book")])]), _vm._v(" "), _c('div', {
    staticClass: "headline"
  }, [_vm._v("Instructions")]), _vm._v(" "), _c('v-btn', {
    staticClass: "closeDialog",
    attrs: {
      "flat": "",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.info = false
      }
    }
  }, [_vm._v("Close")])], 1)], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "menu",
    attrs: {
      "temporary": "",
      "hide-overlay": "",
      "clipped": "",
      "enable-resize-watcher": "",
      "disable-route-watcher": "",
      "touchless": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawer = !_vm.drawer
      }
    },
    model: {
      value: (_vm.drawer),
      callback: function($$v) {
        _vm.drawer = $$v
      },
      expression: "drawer"
    }
  }, [_c('v-list', _vm._l((_vm.items), function(item) {
    return _c('v-list-tile', {
      key: item.name,
      attrs: {
        "href": item.path,
        "to": item.path,
        "exact": "",
        "ripple": false,
        "width": "100%"
      }
    }, [_c('v-list-tile-action', [_c('img', {
      attrs: {
        "height": "55px",
        "alt": item.alt,
        "src": item.image
      }
    })]), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
      attrs: {
        "active": ""
      }
    }, [_vm._v(_vm._s(item.name))])], 1)], 1)
  }), 1)], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "otherBooks",
    attrs: {
      "temporary": "",
      "hide-overlay": "",
      "clipped": "",
      "enable-resize-watcher": "",
      "disable-route-watcher": "",
      "touchless": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.otherBooks = !_vm.otherBooks
      }
    },
    model: {
      value: (_vm.otherBooks),
      callback: function($$v) {
        _vm.otherBooks = $$v
      },
      expression: "otherBooks"
    }
  }, [_c('v-list', [_c('h6', [_vm._v("Other books you might like:")]), _vm._v(" "), _vm._l((_vm.books), function(book) {
    return _c('v-list-tile', {
      key: book.title,
      attrs: {
        "href": book.url,
        "target": "_blank",
        "ripple": false,
        "width": "100%"
      }
    }, [_c('v-list-tile-action', [_c('img', {
      attrs: {
        "alt": book.alt,
        "src": book.img
      }
    })]), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
      attrs: {
        "active": ""
      }
    }, [_vm._v(_vm._s(book.title))])], 1)], 1)
  })], 2)], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "settings-drawer",
    attrs: {
      "temporary": "",
      "hide-overlay": "",
      "clipped": "",
      "right": "",
      "enable-resize-watcher": "",
      "touchless": ""
    },
    model: {
      value: (_vm.drawerRight),
      callback: function($$v) {
        _vm.drawerRight = $$v
      },
      expression: "drawerRight"
    }
  }, [_c('v-list', [_c('settings')], 1)], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "mini-bar",
    attrs: {
      "mini-variant": "",
      "enable-resize-watcher": "",
      "touchless": ""
    },
    model: {
      value: (_vm.buyBar),
      callback: function($$v) {
        _vm.buyBar = $$v
      },
      expression: "buyBar"
    }
  }, [_c('v-list', {
    attrs: {
      "ripple": false
    }
  }, [_vm._v("Shop:\n      "), _vm._l((_vm.buys), function(buy) {
    return _c('v-list-tile', {
      key: buy.title,
      attrs: {
        "href": buy.url,
        "target": "_blank"
      },
      on: {
        "click": function($event) {
          return _vm.buyClick(buy.url)
        }
      }
    }, [_c('img', {
      attrs: {
        "alt": buy.alt,
        "src": buy.img
      }
    })])
  })], 2)], 1), _vm._v(" "), _c('v-toolbar', {
    staticClass: "main-menu",
    attrs: {
      "fixed": "",
      "persistent": ""
    }
  }, [_c('v-btn', {
    staticClass: "main-menu-button",
    attrs: {
      "flat": "",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawer = !_vm.drawer, _vm.info = false, _vm.buyMenu = false, _vm.socialMenu = false, _vm.drawerRight = false, _vm.otherBooks = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-navicon")])], 1), _vm._v(" "), (_vm.books.length > 0) ? _c('v-btn', {
    key: _vm.booksChanged,
    staticClass: "otherBooks-button",
    attrs: {
      "flat": "",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.otherBooks = !_vm.otherBooks, _vm.info = false, _vm.buyMenu = false, _vm.socialMenu = false, _vm.drawerRight = false, _vm.drawer = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-ios-browsers-outline")])], 1) : _vm._e(), _vm._v(" "), _c('v-toolbar', {
    staticClass: "desktop-social-btn",
    staticStyle: {
      "margin-left": "5%"
    }
  }, _vm._l((_vm.socials), function(social) {
    return _c('v-btn', {
      key: social.title,
      attrs: {
        "flat": "",
        "href": social.url,
        "target": "_blank",
        "ripple": false
      },
      on: {
        "click": function($event) {
          return _vm.shareClick(social.title)
        }
      }
    }, [_c('v-icon', [_vm._v(_vm._s(social.icon))])], 1)
  }), 1), _vm._v(" "), _c('v-btn', {
    staticClass: "mobile-buy-btn",
    attrs: {
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.buyMenu = !_vm.buyMenu, _vm.info = false, _vm.drawer = false, _vm.socialMenu = false, _vm.drawerRight = false, _vm.otherBooks = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-bag")])], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "buy-menu",
    attrs: {
      "width": "100vw",
      "height": "auto",
      "hide-overlay": "",
      "temporary": "",
      "clipped": "",
      "disable-route-watcher": "",
      "touchless": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.buyMenu = !_vm.buyMenu
      }
    },
    model: {
      value: (_vm.buyMenu),
      callback: function($$v) {
        _vm.buyMenu = $$v
      },
      expression: "buyMenu"
    }
  }, [_c('v-list', [_c('span', [_vm._v("Purchase this book: ")]), _vm._v(" "), _vm._l((_vm.buys), function(buy) {
    return _c('v-list-tile', {
      key: buy.title,
      attrs: {
        "href": buy.url,
        "target": "_blank"
      },
      on: {
        "click": function($event) {
          return _vm.buyClick(buy.url)
        }
      }
    }, [_c('v-list-tile-action', [_c('img', {
      attrs: {
        "alt": buy.alt,
        "src": buy.img
      }
    })]), _vm._v(" "), _c('v-list-tile-title', {
      domProps: {
        "innerHTML": _vm._s(buy.title)
      }
    })], 1)
  })], 2)], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "mobile-social-btn",
    attrs: {
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.socialMenu = !_vm.socialMenu, _vm.info = false, _vm.buyMenu = false, _vm.drawer = false, _vm.drawerRight = false, _vm.otherBooks = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-android-share-alt")])], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "social-menu",
    attrs: {
      "width": "100vw",
      "height": "auto",
      "hide-overlay": "",
      "temporary": "",
      "clipped": "",
      "disable-route-watcher": "",
      "persistent": "",
      "touchless": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.socialMenu = !_vm.socialMenu
      }
    },
    model: {
      value: (_vm.socialMenu),
      callback: function($$v) {
        _vm.socialMenu = $$v
      },
      expression: "socialMenu"
    }
  }, [_c('v-list', [_c('span', [_vm._v("Share this book: ")]), _vm._v(" "), _vm._l((_vm.socials), function(social) {
    return _c('v-list-tile', {
      key: social.title,
      attrs: {
        "href": social.url,
        "target": "_blank"
      },
      on: {
        "click": function($event) {
          return _vm.shareClick(social.title)
        }
      }
    }, [_c('v-list-tile-action', [_c('v-icon', [_vm._v(_vm._s(social.icon))])], 1), _vm._v(" "), _c('v-list-tile-title', {
      domProps: {
        "innerHTML": _vm._s(social.title)
      }
    })], 1)
  })], 2)], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "info-btn",
    attrs: {
      "flat": "",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.info = !_vm.info, _vm.drawer = false, _vm.buyMenu = false, _vm.socialMenu = false, _vm.drawerRight = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-ios-information-outline")])], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "settings-button",
    attrs: {
      "flat": "",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawerRight = !_vm.drawerRight, _vm.info = false, _vm.buyMenu = false, _vm.socialMenu = false, _vm.drawer = false, _vm.otherBooks = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-ios-gear-outline")])], 1)], 1), _vm._v(" "), _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('reader')], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Reader__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Reader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Reader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_home__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_home___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_home__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_bundle_cover__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_bundle_cover___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_bundle_cover__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_ebb__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_ebb___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_ebb__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_love_1__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_love_1___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_love_1__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_bundle_title__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_bundle_title___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_bundle_title__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_bundle_content__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_bundle_content___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_bundle_content__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Book1_cover__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Book1_cover___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_Book1_cover__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Book1_Untitled_1__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Book1_Untitled_1___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_Book1_Untitled_1__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Book1_Untitled_1_1__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Book1_Untitled_1_1___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_Book1_Untitled_1_1__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_Book1_Untitled_1_2__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_Book1_Untitled_1_2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_Book1_Untitled_1_2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_Book1_Untitled_1_3__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_Book1_Untitled_1_3___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_Book1_Untitled_1_3__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_Book1_Untitled_1_4__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_Book1_Untitled_1_4___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_Book1_Untitled_1_4__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_Book1_Untitled_1_5__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_Book1_Untitled_1_5___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__components_Book1_Untitled_1_5__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_Book1_Untitled_1_6__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_Book1_Untitled_1_6___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__components_Book1_Untitled_1_6__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_Book1_Untitled_1_7__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_Book1_Untitled_1_7___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__components_Book1_Untitled_1_7__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_Book1_Untitled_1_8__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_Book1_Untitled_1_8___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__components_Book1_Untitled_1_8__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_Book1_Untitled_1_9__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_Book1_Untitled_1_9___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__components_Book1_Untitled_1_9__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_Book1_Untitled_1_10__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_Book1_Untitled_1_10___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__components_Book1_Untitled_1_10__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_Book1_Untitled_1_11__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_Book1_Untitled_1_11___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__components_Book1_Untitled_1_11__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_Book1_Untitled_1_12__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_Book1_Untitled_1_12___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__components_Book1_Untitled_1_12__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_Book1_Untitled_1_13__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_Book1_Untitled_1_13___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__components_Book1_Untitled_1_13__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_Book1_Untitled_1_14__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_Book1_Untitled_1_14___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__components_Book1_Untitled_1_14__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_Book1_Untitled_1_15__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_Book1_Untitled_1_15___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__components_Book1_Untitled_1_15__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_Book1_Untitled_1_16__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_Book1_Untitled_1_16___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26__components_Book1_Untitled_1_16__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_Book1_Untitled_1_17__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_Book1_Untitled_1_17___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27__components_Book1_Untitled_1_17__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__components_Book1_Untitled_1_18__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__components_Book1_Untitled_1_18___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28__components_Book1_Untitled_1_18__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__components_Book1_Untitled_1_19__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__components_Book1_Untitled_1_19___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29__components_Book1_Untitled_1_19__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__components_Book1_Untitled_1_20__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__components_Book1_Untitled_1_20___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30__components_Book1_Untitled_1_20__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__components_Book1_Untitled_1_21__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__components_Book1_Untitled_1_21___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31__components_Book1_Untitled_1_21__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__components_Book1_Untitled_1_22__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__components_Book1_Untitled_1_22___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32__components_Book1_Untitled_1_22__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__components_Book1_Untitled_1_23__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__components_Book1_Untitled_1_23___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_33__components_Book1_Untitled_1_23__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__components_Book1_Untitled_1_24__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__components_Book1_Untitled_1_24___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_34__components_Book1_Untitled_1_24__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__components_Book1_Untitled_1_25__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__components_Book1_Untitled_1_25___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_35__components_Book1_Untitled_1_25__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__components_Book1_Untitled_1_26__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__components_Book1_Untitled_1_26___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_36__components_Book1_Untitled_1_26__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__components_Book1_Untitled_1_27__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__components_Book1_Untitled_1_27___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_37__components_Book1_Untitled_1_27__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__components_Book1_Untitled_1_28__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__components_Book1_Untitled_1_28___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_38__components_Book1_Untitled_1_28__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__components_Book1_Untitled_1_29__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__components_Book1_Untitled_1_29___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_39__components_Book1_Untitled_1_29__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__components_Book1_Untitled_1_30__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__components_Book1_Untitled_1_30___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_40__components_Book1_Untitled_1_30__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__components_Book1_Untitled_1_31__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__components_Book1_Untitled_1_31___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_41__components_Book1_Untitled_1_31__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__components_Book1_Untitled_1_32__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__components_Book1_Untitled_1_32___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_42__components_Book1_Untitled_1_32__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__components_Book1_Untitled_1_33__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__components_Book1_Untitled_1_33___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_43__components_Book1_Untitled_1_33__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__components_Book1_Untitled_1_34__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__components_Book1_Untitled_1_34___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_44__components_Book1_Untitled_1_34__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__components_Book1_Untitled_1_35__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__components_Book1_Untitled_1_35___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_45__components_Book1_Untitled_1_35__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__components_Book1_Untitled_1_36__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__components_Book1_Untitled_1_36___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_46__components_Book1_Untitled_1_36__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__components_Book1_Untitled_1_37__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__components_Book1_Untitled_1_37___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_47__components_Book1_Untitled_1_37__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__components_Book1_Untitled_1_38__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__components_Book1_Untitled_1_38___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_48__components_Book1_Untitled_1_38__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__components_Book1_Untitled_1_39__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__components_Book1_Untitled_1_39___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_49__components_Book1_Untitled_1_39__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__components_Book1_Untitled_1_40__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__components_Book1_Untitled_1_40___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_50__components_Book1_Untitled_1_40__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__components_Book1_Untitled_1_41__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__components_Book1_Untitled_1_41___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_51__components_Book1_Untitled_1_41__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__components_Book1_Untitled_1_42__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__components_Book1_Untitled_1_42___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_52__components_Book1_Untitled_1_42__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53__components_Book1_Untitled_1_43__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53__components_Book1_Untitled_1_43___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_53__components_Book1_Untitled_1_43__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54__components_Book1_Untitled_1_44__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54__components_Book1_Untitled_1_44___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_54__components_Book1_Untitled_1_44__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55__components_Book1_Untitled_1_45__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55__components_Book1_Untitled_1_45___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_55__components_Book1_Untitled_1_45__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56__components_Book1_Untitled_1_46__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56__components_Book1_Untitled_1_46___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_56__components_Book1_Untitled_1_46__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57__components_Book1_Untitled_1_47__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57__components_Book1_Untitled_1_47___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_57__components_Book1_Untitled_1_47__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58__components_Book1_Untitled_1_48__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58__components_Book1_Untitled_1_48___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_58__components_Book1_Untitled_1_48__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59__components_Book2_cover__ = __webpack_require__(217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59__components_Book2_cover___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_59__components_Book2_cover__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_60__components_Book2_Untitled_1__ = __webpack_require__(220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_60__components_Book2_Untitled_1___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_60__components_Book2_Untitled_1__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_61__components_Book2_Untitled_1_1__ = __webpack_require__(223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_61__components_Book2_Untitled_1_1___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_61__components_Book2_Untitled_1_1__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_62__components_Book2_Untitled_1_2__ = __webpack_require__(226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_62__components_Book2_Untitled_1_2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_62__components_Book2_Untitled_1_2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_63__components_Book2_Untitled_1_3__ = __webpack_require__(229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_63__components_Book2_Untitled_1_3___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_63__components_Book2_Untitled_1_3__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_64__components_Book2_Untitled_1_4__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_64__components_Book2_Untitled_1_4___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_64__components_Book2_Untitled_1_4__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_65__components_Book2_Untitled_1_5__ = __webpack_require__(235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_65__components_Book2_Untitled_1_5___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_65__components_Book2_Untitled_1_5__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_66__components_Book2_Untitled_1_6__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_66__components_Book2_Untitled_1_6___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_66__components_Book2_Untitled_1_6__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_67__components_Book2_Untitled_1_7__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_67__components_Book2_Untitled_1_7___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_67__components_Book2_Untitled_1_7__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_68__components_Book2_Untitled_1_8__ = __webpack_require__(244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_68__components_Book2_Untitled_1_8___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_68__components_Book2_Untitled_1_8__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_69__components_Book2_Untitled_1_9__ = __webpack_require__(247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_69__components_Book2_Untitled_1_9___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_69__components_Book2_Untitled_1_9__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_70__components_Book2_Untitled_1_10__ = __webpack_require__(250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_70__components_Book2_Untitled_1_10___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_70__components_Book2_Untitled_1_10__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_71__components_Book2_Untitled_1_11__ = __webpack_require__(253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_71__components_Book2_Untitled_1_11___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_71__components_Book2_Untitled_1_11__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_72__components_Book2_Untitled_1_12__ = __webpack_require__(256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_72__components_Book2_Untitled_1_12___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_72__components_Book2_Untitled_1_12__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_73__components_Book2_Untitled_1_13__ = __webpack_require__(259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_73__components_Book2_Untitled_1_13___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_73__components_Book2_Untitled_1_13__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_74__components_Book2_Untitled_1_14__ = __webpack_require__(262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_74__components_Book2_Untitled_1_14___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_74__components_Book2_Untitled_1_14__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_75__components_Book2_Untitled_1_15__ = __webpack_require__(265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_75__components_Book2_Untitled_1_15___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_75__components_Book2_Untitled_1_15__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_76__components_Book2_Untitled_1_16__ = __webpack_require__(268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_76__components_Book2_Untitled_1_16___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_76__components_Book2_Untitled_1_16__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_77__components_Book2_Untitled_1_17__ = __webpack_require__(271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_77__components_Book2_Untitled_1_17___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_77__components_Book2_Untitled_1_17__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_78__components_Book2_Untitled_1_18__ = __webpack_require__(274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_78__components_Book2_Untitled_1_18___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_78__components_Book2_Untitled_1_18__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_79__components_Book2_Untitled_1_19__ = __webpack_require__(277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_79__components_Book2_Untitled_1_19___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_79__components_Book2_Untitled_1_19__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_80__components_Book2_Untitled_1_20__ = __webpack_require__(280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_80__components_Book2_Untitled_1_20___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_80__components_Book2_Untitled_1_20__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_81__components_Book2_Untitled_1_21__ = __webpack_require__(283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_81__components_Book2_Untitled_1_21___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_81__components_Book2_Untitled_1_21__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_82__components_Book2_Untitled_1_22__ = __webpack_require__(286);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_82__components_Book2_Untitled_1_22___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_82__components_Book2_Untitled_1_22__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_83__components_Book2_Untitled_1_23__ = __webpack_require__(289);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_83__components_Book2_Untitled_1_23___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_83__components_Book2_Untitled_1_23__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_84__components_Book2_Untitled_1_24__ = __webpack_require__(292);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_84__components_Book2_Untitled_1_24___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_84__components_Book2_Untitled_1_24__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_85__components_Book2_Untitled_1_25__ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_85__components_Book2_Untitled_1_25___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_85__components_Book2_Untitled_1_25__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_86__components_Book2_Untitled_1_26__ = __webpack_require__(298);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_86__components_Book2_Untitled_1_26___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_86__components_Book2_Untitled_1_26__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_87__components_Book2_Untitled_1_27__ = __webpack_require__(301);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_87__components_Book2_Untitled_1_27___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_87__components_Book2_Untitled_1_27__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_88__components_Book2_Untitled_1_28__ = __webpack_require__(304);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_88__components_Book2_Untitled_1_28___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_88__components_Book2_Untitled_1_28__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_89__components_Book2_Untitled_1_29__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_89__components_Book2_Untitled_1_29___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_89__components_Book2_Untitled_1_29__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_90__components_Book2_Untitled_1_30__ = __webpack_require__(310);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_90__components_Book2_Untitled_1_30___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_90__components_Book2_Untitled_1_30__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_91__components_Book2_Untitled_1_31__ = __webpack_require__(313);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_91__components_Book2_Untitled_1_31___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_91__components_Book2_Untitled_1_31__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_92__components_Book2_Untitled_1_32__ = __webpack_require__(316);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_92__components_Book2_Untitled_1_32___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_92__components_Book2_Untitled_1_32__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_93__components_Book2_Untitled_1_33__ = __webpack_require__(319);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_93__components_Book2_Untitled_1_33___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_93__components_Book2_Untitled_1_33__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_94__components_Book2_Untitled_1_34__ = __webpack_require__(322);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_94__components_Book2_Untitled_1_34___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_94__components_Book2_Untitled_1_34__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_95__components_Book2_Untitled_1_35__ = __webpack_require__(325);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_95__components_Book2_Untitled_1_35___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_95__components_Book2_Untitled_1_35__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_96__components_Book2_Untitled_1_36__ = __webpack_require__(328);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_96__components_Book2_Untitled_1_36___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_96__components_Book2_Untitled_1_36__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_97__components_Book2_Untitled_1_37__ = __webpack_require__(331);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_97__components_Book2_Untitled_1_37___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_97__components_Book2_Untitled_1_37__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_98__components_Book2_Untitled_1_38__ = __webpack_require__(334);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_98__components_Book2_Untitled_1_38___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_98__components_Book2_Untitled_1_38__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_99__components_Book2_Untitled_1_39__ = __webpack_require__(337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_99__components_Book2_Untitled_1_39___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_99__components_Book2_Untitled_1_39__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_100__components_Book2_Untitled_1_40__ = __webpack_require__(340);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_100__components_Book2_Untitled_1_40___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_100__components_Book2_Untitled_1_40__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_101__components_Book2_Untitled_1_41__ = __webpack_require__(343);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_101__components_Book2_Untitled_1_41___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_101__components_Book2_Untitled_1_41__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_102__components_Book2_Untitled_1_42__ = __webpack_require__(346);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_102__components_Book2_Untitled_1_42___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_102__components_Book2_Untitled_1_42__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_103__components_Book2_Untitled_1_43__ = __webpack_require__(349);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_103__components_Book2_Untitled_1_43___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_103__components_Book2_Untitled_1_43__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_104__components_Book2_Untitled_1_44__ = __webpack_require__(352);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_104__components_Book2_Untitled_1_44___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_104__components_Book2_Untitled_1_44__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_105__components_Book2_Untitled_1_45__ = __webpack_require__(355);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_105__components_Book2_Untitled_1_45___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_105__components_Book2_Untitled_1_45__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_106__components_Book2_Untitled_1_46__ = __webpack_require__(358);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_106__components_Book2_Untitled_1_46___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_106__components_Book2_Untitled_1_46__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_107__components_Book2_Untitled_1_47__ = __webpack_require__(361);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_107__components_Book2_Untitled_1_47___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_107__components_Book2_Untitled_1_47__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_108__components_Book2_Untitled_1_48__ = __webpack_require__(364);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_108__components_Book2_Untitled_1_48___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_108__components_Book2_Untitled_1_48__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_109__components_Book2_Untitled_1_49__ = __webpack_require__(367);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_109__components_Book2_Untitled_1_49___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_109__components_Book2_Untitled_1_49__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_110__components_Book2_Untitled_1_50__ = __webpack_require__(370);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_110__components_Book2_Untitled_1_50___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_110__components_Book2_Untitled_1_50__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_111__components_Book2_Untitled_1_51__ = __webpack_require__(373);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_111__components_Book2_Untitled_1_51___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_111__components_Book2_Untitled_1_51__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_112__components_Book2_Untitled_1_52__ = __webpack_require__(376);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_112__components_Book2_Untitled_1_52___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_112__components_Book2_Untitled_1_52__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_113__components_Book2_Untitled_1_53__ = __webpack_require__(379);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_113__components_Book2_Untitled_1_53___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_113__components_Book2_Untitled_1_53__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_114__components_Book2_Untitled_1_54__ = __webpack_require__(382);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_114__components_Book2_Untitled_1_54___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_114__components_Book2_Untitled_1_54__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_115__components_Book2_Untitled_1_55__ = __webpack_require__(385);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_115__components_Book2_Untitled_1_55___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_115__components_Book2_Untitled_1_55__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_116__components_Book2_Untitled_1_56__ = __webpack_require__(388);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_116__components_Book2_Untitled_1_56___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_116__components_Book2_Untitled_1_56__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_117__components_Book2_Untitled_1_57__ = __webpack_require__(391);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_117__components_Book2_Untitled_1_57___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_117__components_Book2_Untitled_1_57__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_118__components_Book2_Untitled_1_58__ = __webpack_require__(394);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_118__components_Book2_Untitled_1_58___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_118__components_Book2_Untitled_1_58__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_119__components_Book2_Untitled_1_59__ = __webpack_require__(397);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_119__components_Book2_Untitled_1_59___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_119__components_Book2_Untitled_1_59__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_120__components_Book2_Untitled_1_60__ = __webpack_require__(400);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_120__components_Book2_Untitled_1_60___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_120__components_Book2_Untitled_1_60__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_121__components_Book3_cover__ = __webpack_require__(403);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_121__components_Book3_cover___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_121__components_Book3_cover__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_122__components_Book3_Untitled_1__ = __webpack_require__(406);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_122__components_Book3_Untitled_1___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_122__components_Book3_Untitled_1__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_123__components_Book3_Untitled_1_1__ = __webpack_require__(409);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_123__components_Book3_Untitled_1_1___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_123__components_Book3_Untitled_1_1__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_124__components_Book3_Untitled_1_2__ = __webpack_require__(412);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_124__components_Book3_Untitled_1_2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_124__components_Book3_Untitled_1_2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_125__components_Book3_Untitled_1_3__ = __webpack_require__(415);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_125__components_Book3_Untitled_1_3___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_125__components_Book3_Untitled_1_3__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_126__components_Book3_Untitled_1_4__ = __webpack_require__(418);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_126__components_Book3_Untitled_1_4___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_126__components_Book3_Untitled_1_4__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_127__components_Book3_Untitled_1_5__ = __webpack_require__(421);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_127__components_Book3_Untitled_1_5___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_127__components_Book3_Untitled_1_5__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_128__components_Book3_Untitled_1_6__ = __webpack_require__(424);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_128__components_Book3_Untitled_1_6___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_128__components_Book3_Untitled_1_6__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_129__components_Book3_Untitled_1_7__ = __webpack_require__(427);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_129__components_Book3_Untitled_1_7___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_129__components_Book3_Untitled_1_7__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_130__components_Book3_Untitled_1_8__ = __webpack_require__(430);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_130__components_Book3_Untitled_1_8___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_130__components_Book3_Untitled_1_8__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_131__components_Book3_Untitled_1_9__ = __webpack_require__(433);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_131__components_Book3_Untitled_1_9___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_131__components_Book3_Untitled_1_9__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_132__components_Book3_Untitled_1_10__ = __webpack_require__(436);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_132__components_Book3_Untitled_1_10___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_132__components_Book3_Untitled_1_10__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_133__components_Book3_Untitled_1_11__ = __webpack_require__(439);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_133__components_Book3_Untitled_1_11___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_133__components_Book3_Untitled_1_11__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_134__components_Book3_Untitled_1_12__ = __webpack_require__(442);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_134__components_Book3_Untitled_1_12___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_134__components_Book3_Untitled_1_12__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_135__components_Book3_Untitled_1_13__ = __webpack_require__(445);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_135__components_Book3_Untitled_1_13___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_135__components_Book3_Untitled_1_13__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_136__components_Book3_Untitled_1_14__ = __webpack_require__(448);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_136__components_Book3_Untitled_1_14___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_136__components_Book3_Untitled_1_14__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_137__components_Book3_Untitled_1_15__ = __webpack_require__(451);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_137__components_Book3_Untitled_1_15___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_137__components_Book3_Untitled_1_15__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_138__components_Book3_Untitled_1_16__ = __webpack_require__(454);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_138__components_Book3_Untitled_1_16___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_138__components_Book3_Untitled_1_16__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_139__components_Book3_Untitled_1_17__ = __webpack_require__(457);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_139__components_Book3_Untitled_1_17___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_139__components_Book3_Untitled_1_17__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_140__components_Book3_Untitled_1_18__ = __webpack_require__(460);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_140__components_Book3_Untitled_1_18___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_140__components_Book3_Untitled_1_18__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_141__components_Book3_Untitled_1_19__ = __webpack_require__(463);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_141__components_Book3_Untitled_1_19___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_141__components_Book3_Untitled_1_19__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_142__components_Book3_Untitled_1_20__ = __webpack_require__(466);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_142__components_Book3_Untitled_1_20___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_142__components_Book3_Untitled_1_20__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_143__components_Book3_Untitled_1_21__ = __webpack_require__(469);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_143__components_Book3_Untitled_1_21___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_143__components_Book3_Untitled_1_21__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_144__components_Book3_Untitled_1_22__ = __webpack_require__(472);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_144__components_Book3_Untitled_1_22___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_144__components_Book3_Untitled_1_22__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_145__components_Book3_Untitled_1_23__ = __webpack_require__(475);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_145__components_Book3_Untitled_1_23___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_145__components_Book3_Untitled_1_23__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_146__components_Book3_Untitled_1_24__ = __webpack_require__(478);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_146__components_Book3_Untitled_1_24___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_146__components_Book3_Untitled_1_24__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_147__components_Book3_Untitled_1_25__ = __webpack_require__(481);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_147__components_Book3_Untitled_1_25___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_147__components_Book3_Untitled_1_25__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_148__components_Book3_Untitled_1_26__ = __webpack_require__(484);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_148__components_Book3_Untitled_1_26___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_148__components_Book3_Untitled_1_26__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_149__components_Book3_Untitled_1_27__ = __webpack_require__(487);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_149__components_Book3_Untitled_1_27___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_149__components_Book3_Untitled_1_27__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_150__components_Book3_Untitled_1_28__ = __webpack_require__(490);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_150__components_Book3_Untitled_1_28___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_150__components_Book3_Untitled_1_28__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_151__components_Book3_Untitled_1_29__ = __webpack_require__(493);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_151__components_Book3_Untitled_1_29___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_151__components_Book3_Untitled_1_29__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_152__components_Book3_Untitled_1_30__ = __webpack_require__(496);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_152__components_Book3_Untitled_1_30___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_152__components_Book3_Untitled_1_30__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_153__components_Book3_Untitled_1_31__ = __webpack_require__(499);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_153__components_Book3_Untitled_1_31___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_153__components_Book3_Untitled_1_31__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_154__components_Book3_Untitled_1_32__ = __webpack_require__(502);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_154__components_Book3_Untitled_1_32___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_154__components_Book3_Untitled_1_32__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_155__components_Book3_Untitled_1_33__ = __webpack_require__(505);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_155__components_Book3_Untitled_1_33___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_155__components_Book3_Untitled_1_33__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_156__components_Book3_Untitled_1_34__ = __webpack_require__(508);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_156__components_Book3_Untitled_1_34___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_156__components_Book3_Untitled_1_34__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_157__components_Book3_Untitled_1_35__ = __webpack_require__(511);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_157__components_Book3_Untitled_1_35___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_157__components_Book3_Untitled_1_35__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_158__components_Book3_Untitled_1_36__ = __webpack_require__(514);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_158__components_Book3_Untitled_1_36___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_158__components_Book3_Untitled_1_36__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_159__components_Book3_Untitled_1_37__ = __webpack_require__(517);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_159__components_Book3_Untitled_1_37___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_159__components_Book3_Untitled_1_37__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_160__components_Book3_Untitled_1_38__ = __webpack_require__(520);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_160__components_Book3_Untitled_1_38___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_160__components_Book3_Untitled_1_38__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_161__components_Book3_Untitled_1_39__ = __webpack_require__(523);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_161__components_Book3_Untitled_1_39___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_161__components_Book3_Untitled_1_39__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_162__components_Book3_Untitled_1_40__ = __webpack_require__(526);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_162__components_Book3_Untitled_1_40___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_162__components_Book3_Untitled_1_40__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_163__components_Book3_Untitled_1_41__ = __webpack_require__(529);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_163__components_Book3_Untitled_1_41___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_163__components_Book3_Untitled_1_41__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_164__components_Book3_Untitled_1_42__ = __webpack_require__(532);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_164__components_Book3_Untitled_1_42___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_164__components_Book3_Untitled_1_42__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_165__components_Book3_Untitled_1_43__ = __webpack_require__(535);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_165__components_Book3_Untitled_1_43___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_165__components_Book3_Untitled_1_43__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_166__components_Book3_Untitled_1_44__ = __webpack_require__(538);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_166__components_Book3_Untitled_1_44___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_166__components_Book3_Untitled_1_44__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_167__components_Book3_Untitled_1_45__ = __webpack_require__(541);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_167__components_Book3_Untitled_1_45___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_167__components_Book3_Untitled_1_45__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_168__components_Book3_Untitled_1_46__ = __webpack_require__(544);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_168__components_Book3_Untitled_1_46___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_168__components_Book3_Untitled_1_46__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_169__components_Book3_Untitled_1_47__ = __webpack_require__(547);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_169__components_Book3_Untitled_1_47___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_169__components_Book3_Untitled_1_47__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_170__components_Book3_Untitled_1_48__ = __webpack_require__(550);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_170__components_Book3_Untitled_1_48___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_170__components_Book3_Untitled_1_48__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_171__components_Book3_Untitled_1_49__ = __webpack_require__(553);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_171__components_Book3_Untitled_1_49___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_171__components_Book3_Untitled_1_49__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_172__components_Book3_Untitled_1_50__ = __webpack_require__(556);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_172__components_Book3_Untitled_1_50___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_172__components_Book3_Untitled_1_50__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_173__components_Book3_Untitled_1_51__ = __webpack_require__(559);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_173__components_Book3_Untitled_1_51___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_173__components_Book3_Untitled_1_51__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_174__components_Book3_Untitled_1_52__ = __webpack_require__(562);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_174__components_Book3_Untitled_1_52___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_174__components_Book3_Untitled_1_52__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_175__components_Book3_Untitled_1_53__ = __webpack_require__(565);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_175__components_Book3_Untitled_1_53___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_175__components_Book3_Untitled_1_53__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_176__components_Book3_Untitled_1_54__ = __webpack_require__(568);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_176__components_Book3_Untitled_1_54___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_176__components_Book3_Untitled_1_54__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_177__components_Book3_Untitled_1_55__ = __webpack_require__(571);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_177__components_Book3_Untitled_1_55___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_177__components_Book3_Untitled_1_55__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_178__components_Book3_Untitled_1_56__ = __webpack_require__(574);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_178__components_Book3_Untitled_1_56___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_178__components_Book3_Untitled_1_56__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_179__components_Book3_Untitled_1_57__ = __webpack_require__(577);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_179__components_Book3_Untitled_1_57___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_179__components_Book3_Untitled_1_57__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_180__components_Book3_Untitled_1_58__ = __webpack_require__(580);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_180__components_Book3_Untitled_1_58___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_180__components_Book3_Untitled_1_58__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_181__components_Book3_Untitled_1_59__ = __webpack_require__(583);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_181__components_Book3_Untitled_1_59___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_181__components_Book3_Untitled_1_59__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_182__components_Book3_Untitled_1_60__ = __webpack_require__(586);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_182__components_Book3_Untitled_1_60___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_182__components_Book3_Untitled_1_60__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_183__components_Book3_Untitled_1_61__ = __webpack_require__(589);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_183__components_Book3_Untitled_1_61___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_183__components_Book3_Untitled_1_61__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_184__components_Book3_Untitled_1_62__ = __webpack_require__(592);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_184__components_Book3_Untitled_1_62___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_184__components_Book3_Untitled_1_62__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_185__components_Book3_Untitled_1_63__ = __webpack_require__(595);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_185__components_Book3_Untitled_1_63___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_185__components_Book3_Untitled_1_63__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_186__components_Book3_Untitled_1_64__ = __webpack_require__(598);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_186__components_Book3_Untitled_1_64___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_186__components_Book3_Untitled_1_64__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_187__components_Book3_Untitled_1_65__ = __webpack_require__(601);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_187__components_Book3_Untitled_1_65___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_187__components_Book3_Untitled_1_65__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_188__components_Book3_Untitled_1_66__ = __webpack_require__(604);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_188__components_Book3_Untitled_1_66___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_188__components_Book3_Untitled_1_66__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_189__components_Book3_Untitled_1_67__ = __webpack_require__(607);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_189__components_Book3_Untitled_1_67___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_189__components_Book3_Untitled_1_67__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_190__components_Book3_Untitled_1_68__ = __webpack_require__(610);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_190__components_Book3_Untitled_1_68___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_190__components_Book3_Untitled_1_68__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_191__components_Book3_Untitled_1_69__ = __webpack_require__(613);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_191__components_Book3_Untitled_1_69___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_191__components_Book3_Untitled_1_69__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_192__components_Book3_Untitled_1_70__ = __webpack_require__(616);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_192__components_Book3_Untitled_1_70___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_192__components_Book3_Untitled_1_70__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_193__components_Book3_Untitled_1_71__ = __webpack_require__(619);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_193__components_Book3_Untitled_1_71___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_193__components_Book3_Untitled_1_71__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_194__components_Book3_Untitled_1_72__ = __webpack_require__(622);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_194__components_Book3_Untitled_1_72___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_194__components_Book3_Untitled_1_72__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_195__components_Book3_Untitled_1_73__ = __webpack_require__(625);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_195__components_Book3_Untitled_1_73___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_195__components_Book3_Untitled_1_73__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_196__components_Book3_Untitled_1_74__ = __webpack_require__(628);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_196__components_Book3_Untitled_1_74___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_196__components_Book3_Untitled_1_74__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_197__components_Book3_Untitled_1_75__ = __webpack_require__(631);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_197__components_Book3_Untitled_1_75___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_197__components_Book3_Untitled_1_75__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_198__components_Book3_Untitled_1_76__ = __webpack_require__(634);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_198__components_Book3_Untitled_1_76___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_198__components_Book3_Untitled_1_76__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_199__components_Book3_Untitled_1_77__ = __webpack_require__(637);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_199__components_Book3_Untitled_1_77___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_199__components_Book3_Untitled_1_77__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_200__components_Book3_Untitled_1_78__ = __webpack_require__(640);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_200__components_Book3_Untitled_1_78___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_200__components_Book3_Untitled_1_78__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_201__components_Book3_Untitled_1_79__ = __webpack_require__(643);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_201__components_Book3_Untitled_1_79___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_201__components_Book3_Untitled_1_79__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_202__components_Book3_Untitled_1_80__ = __webpack_require__(646);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_202__components_Book3_Untitled_1_80___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_202__components_Book3_Untitled_1_80__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_203__components_Book3_Untitled_1_81__ = __webpack_require__(649);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_203__components_Book3_Untitled_1_81___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_203__components_Book3_Untitled_1_81__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_204__components_Book3_Untitled_1_82__ = __webpack_require__(652);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_204__components_Book3_Untitled_1_82___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_204__components_Book3_Untitled_1_82__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_205__components_Book3_Untitled_1_83__ = __webpack_require__(655);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_205__components_Book3_Untitled_1_83___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_205__components_Book3_Untitled_1_83__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_206__components_Book3_Untitled_1_84__ = __webpack_require__(658);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_206__components_Book3_Untitled_1_84___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_206__components_Book3_Untitled_1_84__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_207__components_love_2__ = __webpack_require__(661);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_207__components_love_2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_207__components_love_2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_208__components_Comon_copyright__ = __webpack_require__(664);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_208__components_Comon_copyright___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_208__components_Comon_copyright__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_209__components_Book1_auba__ = __webpack_require__(667);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_209__components_Book1_auba___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_209__components_Book1_auba__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_210__components_ORIMad__ = __webpack_require__(670);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_210__components_ORIMad___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_210__components_ORIMad__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_211__components_last__ = __webpack_require__(673);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_211__components_last___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_211__components_last__);
/*jshint esversion: 6 */






















































































































































































































__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    "path": "/",
    "name": "home",
    "component": __WEBPACK_IMPORTED_MODULE_3__components_home___default.a
  }, {
    "path": "/bundle_content",
    "name": "bundle_content",
    "component": __WEBPACK_IMPORTED_MODULE_8__components_bundle_content___default.a
  }, {
    "path": "/Book1/cover",
    "name": "Book1/cover",
    "component": __WEBPACK_IMPORTED_MODULE_9__components_Book1_cover___default.a
  }, {
    "path": "/Book1/Untitled-1",
    "name": "Book1/Untitled-1",
    "component": __WEBPACK_IMPORTED_MODULE_10__components_Book1_Untitled_1___default.a
  }, {
    "path": "/Book1/Untitled-1-1",
    "name": "Book1/Untitled-1-1",
    "component": __WEBPACK_IMPORTED_MODULE_11__components_Book1_Untitled_1_1___default.a
  }, {
    "path": "/Book1/Untitled-1-2",
    "name": "Book1/Untitled-1-2",
    "component": __WEBPACK_IMPORTED_MODULE_12__components_Book1_Untitled_1_2___default.a
  }, {
    "path": "/Book1/Untitled-1-3",
    "name": "Book1/Untitled-1-3",
    "component": __WEBPACK_IMPORTED_MODULE_13__components_Book1_Untitled_1_3___default.a
  }, {
    "path": "/Book1/Untitled-1-4",
    "name": "Book1/Untitled-1-4",
    "component": __WEBPACK_IMPORTED_MODULE_14__components_Book1_Untitled_1_4___default.a
  }, {
    "path": "/Book1/Untitled-1-5",
    "name": "Book1/Untitled-1-5",
    "component": __WEBPACK_IMPORTED_MODULE_15__components_Book1_Untitled_1_5___default.a
  }, {
    "path": "/Book1/Untitled-1-6",
    "name": "Book1/Untitled-1-6",
    "component": __WEBPACK_IMPORTED_MODULE_16__components_Book1_Untitled_1_6___default.a
  }, {
    "path": "/Book1/Untitled-1-7",
    "name": "Book1/Untitled-1-7",
    "component": __WEBPACK_IMPORTED_MODULE_17__components_Book1_Untitled_1_7___default.a
  }, {
    "path": "/Book1/Untitled-1-8",
    "name": "Book1/Untitled-1-8",
    "component": __WEBPACK_IMPORTED_MODULE_18__components_Book1_Untitled_1_8___default.a
  }, {
    "path": "/Book1/Untitled-1-9",
    "name": "Book1/Untitled-1-9",
    "component": __WEBPACK_IMPORTED_MODULE_19__components_Book1_Untitled_1_9___default.a
  }, {
    "path": "/Book1/Untitled-1-10",
    "name": "Book1/Untitled-1-10",
    "component": __WEBPACK_IMPORTED_MODULE_20__components_Book1_Untitled_1_10___default.a
  }, {
    "path": "/Book1/Untitled-1-11",
    "name": "Book1/Untitled-1-11",
    "component": __WEBPACK_IMPORTED_MODULE_21__components_Book1_Untitled_1_11___default.a
  }, {
    "path": "/Book1/Untitled-1-12",
    "name": "Book1/Untitled-1-12",
    "component": __WEBPACK_IMPORTED_MODULE_22__components_Book1_Untitled_1_12___default.a
  }, {
    "path": "/Book1/Untitled-1-13",
    "name": "Book1/Untitled-1-13",
    "component": __WEBPACK_IMPORTED_MODULE_23__components_Book1_Untitled_1_13___default.a
  }, {
    "path": "/Book1/Untitled-1-14",
    "name": "Book1/Untitled-1-14",
    "component": __WEBPACK_IMPORTED_MODULE_24__components_Book1_Untitled_1_14___default.a
  }, {
    "path": "/Book1/Untitled-1-15",
    "name": "Book1/Untitled-1-15",
    "component": __WEBPACK_IMPORTED_MODULE_25__components_Book1_Untitled_1_15___default.a
  }, {
    "path": "/Book1/Untitled-1-16",
    "name": "Book1/Untitled-1-16",
    "component": __WEBPACK_IMPORTED_MODULE_26__components_Book1_Untitled_1_16___default.a
  }, {
    "path": "/Book1/Untitled-1-17",
    "name": "Book1/Untitled-1-17",
    "component": __WEBPACK_IMPORTED_MODULE_27__components_Book1_Untitled_1_17___default.a
  }, {
    "path": "/Book1/Untitled-1-18",
    "name": "Book1/Untitled-1-18",
    "component": __WEBPACK_IMPORTED_MODULE_28__components_Book1_Untitled_1_18___default.a
  }, {
    "path": "/last",
    "name": "last",
    "component": __WEBPACK_IMPORTED_MODULE_211__components_last___default.a
  }]
}));

/***/ }),
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
  * vue-router v2.8.1
  * (c) 2017 Evan You
  * @license MIT
  */
/*  */

function assert (condition, message) {
  if (!condition) {
    throw new Error(("[vue-router] " + message))
  }
}

function warn (condition, message) {
  if (false) {
    typeof console !== 'undefined' && console.warn(("[vue-router] " + message));
  }
}

function isError (err) {
  return Object.prototype.toString.call(err).indexOf('Error') > -1
}

var View = {
  name: 'router-view',
  functional: true,
  props: {
    name: {
      type: String,
      default: 'default'
    }
  },
  render: function render (_, ref) {
    var props = ref.props;
    var children = ref.children;
    var parent = ref.parent;
    var data = ref.data;

    data.routerView = true;

    // directly use parent context's createElement() function
    // so that components rendered by router-view can resolve named slots
    var h = parent.$createElement;
    var name = props.name;
    var route = parent.$route;
    var cache = parent._routerViewCache || (parent._routerViewCache = {});

    // determine current view depth, also check to see if the tree
    // has been toggled inactive but kept-alive.
    var depth = 0;
    var inactive = false;
    while (parent && parent._routerRoot !== parent) {
      if (parent.$vnode && parent.$vnode.data.routerView) {
        depth++;
      }
      if (parent._inactive) {
        inactive = true;
      }
      parent = parent.$parent;
    }
    data.routerViewDepth = depth;

    // render previous view if the tree is inactive and kept-alive
    if (inactive) {
      return h(cache[name], data, children)
    }

    var matched = route.matched[depth];
    // render empty node if no matched route
    if (!matched) {
      cache[name] = null;
      return h()
    }

    var component = cache[name] = matched.components[name];

    // attach instance registration hook
    // this will be called in the instance's injected lifecycle hooks
    data.registerRouteInstance = function (vm, val) {
      // val could be undefined for unregistration
      var current = matched.instances[name];
      if (
        (val && current !== vm) ||
        (!val && current === vm)
      ) {
        matched.instances[name] = val;
      }
    }

    // also register instance in prepatch hook
    // in case the same component instance is reused across different routes
    ;(data.hook || (data.hook = {})).prepatch = function (_, vnode) {
      matched.instances[name] = vnode.componentInstance;
    };

    // resolve props
    var propsToPass = data.props = resolveProps(route, matched.props && matched.props[name]);
    if (propsToPass) {
      // clone to prevent mutation
      propsToPass = data.props = extend({}, propsToPass);
      // pass non-declared props as attrs
      var attrs = data.attrs = data.attrs || {};
      for (var key in propsToPass) {
        if (!component.props || !(key in component.props)) {
          attrs[key] = propsToPass[key];
          delete propsToPass[key];
        }
      }
    }

    return h(component, data, children)
  }
};

function resolveProps (route, config) {
  switch (typeof config) {
    case 'undefined':
      return
    case 'object':
      return config
    case 'function':
      return config(route)
    case 'boolean':
      return config ? route.params : undefined
    default:
      if (false) {
        warn(
          false,
          "props in \"" + (route.path) + "\" is a " + (typeof config) + ", " +
          "expecting an object, function or boolean."
        );
      }
  }
}

function extend (to, from) {
  for (var key in from) {
    to[key] = from[key];
  }
  return to
}

/*  */

var encodeReserveRE = /[!'()*]/g;
var encodeReserveReplacer = function (c) { return '%' + c.charCodeAt(0).toString(16); };
var commaRE = /%2C/g;

// fixed encodeURIComponent which is more conformant to RFC3986:
// - escapes [!'()*]
// - preserve commas
var encode = function (str) { return encodeURIComponent(str)
  .replace(encodeReserveRE, encodeReserveReplacer)
  .replace(commaRE, ','); };

var decode = decodeURIComponent;

function resolveQuery (
  query,
  extraQuery,
  _parseQuery
) {
  if ( extraQuery === void 0 ) extraQuery = {};

  var parse = _parseQuery || parseQuery;
  var parsedQuery;
  try {
    parsedQuery = parse(query || '');
  } catch (e) {
    "production" !== 'production' && warn(false, e.message);
    parsedQuery = {};
  }
  for (var key in extraQuery) {
    parsedQuery[key] = extraQuery[key];
  }
  return parsedQuery
}

function parseQuery (query) {
  var res = {};

  query = query.trim().replace(/^(\?|#|&)/, '');

  if (!query) {
    return res
  }

  query.split('&').forEach(function (param) {
    var parts = param.replace(/\+/g, ' ').split('=');
    var key = decode(parts.shift());
    var val = parts.length > 0
      ? decode(parts.join('='))
      : null;

    if (res[key] === undefined) {
      res[key] = val;
    } else if (Array.isArray(res[key])) {
      res[key].push(val);
    } else {
      res[key] = [res[key], val];
    }
  });

  return res
}

function stringifyQuery (obj) {
  var res = obj ? Object.keys(obj).map(function (key) {
    var val = obj[key];

    if (val === undefined) {
      return ''
    }

    if (val === null) {
      return encode(key)
    }

    if (Array.isArray(val)) {
      var result = [];
      val.forEach(function (val2) {
        if (val2 === undefined) {
          return
        }
        if (val2 === null) {
          result.push(encode(key));
        } else {
          result.push(encode(key) + '=' + encode(val2));
        }
      });
      return result.join('&')
    }

    return encode(key) + '=' + encode(val)
  }).filter(function (x) { return x.length > 0; }).join('&') : null;
  return res ? ("?" + res) : ''
}

/*  */


var trailingSlashRE = /\/?$/;

function createRoute (
  record,
  location,
  redirectedFrom,
  router
) {
  var stringifyQuery$$1 = router && router.options.stringifyQuery;

  var query = location.query || {};
  try {
    query = clone(query);
  } catch (e) {}

  var route = {
    name: location.name || (record && record.name),
    meta: (record && record.meta) || {},
    path: location.path || '/',
    hash: location.hash || '',
    query: query,
    params: location.params || {},
    fullPath: getFullPath(location, stringifyQuery$$1),
    matched: record ? formatMatch(record) : []
  };
  if (redirectedFrom) {
    route.redirectedFrom = getFullPath(redirectedFrom, stringifyQuery$$1);
  }
  return Object.freeze(route)
}

function clone (value) {
  if (Array.isArray(value)) {
    return value.map(clone)
  } else if (value && typeof value === 'object') {
    var res = {};
    for (var key in value) {
      res[key] = clone(value[key]);
    }
    return res
  } else {
    return value
  }
}

// the starting route that represents the initial state
var START = createRoute(null, {
  path: '/'
});

function formatMatch (record) {
  var res = [];
  while (record) {
    res.unshift(record);
    record = record.parent;
  }
  return res
}

function getFullPath (
  ref,
  _stringifyQuery
) {
  var path = ref.path;
  var query = ref.query; if ( query === void 0 ) query = {};
  var hash = ref.hash; if ( hash === void 0 ) hash = '';

  var stringify = _stringifyQuery || stringifyQuery;
  return (path || '/') + stringify(query) + hash
}

function isSameRoute (a, b) {
  if (b === START) {
    return a === b
  } else if (!b) {
    return false
  } else if (a.path && b.path) {
    return (
      a.path.replace(trailingSlashRE, '') === b.path.replace(trailingSlashRE, '') &&
      a.hash === b.hash &&
      isObjectEqual(a.query, b.query)
    )
  } else if (a.name && b.name) {
    return (
      a.name === b.name &&
      a.hash === b.hash &&
      isObjectEqual(a.query, b.query) &&
      isObjectEqual(a.params, b.params)
    )
  } else {
    return false
  }
}

function isObjectEqual (a, b) {
  if ( a === void 0 ) a = {};
  if ( b === void 0 ) b = {};

  // handle null value #1566
  if (!a || !b) { return a === b }
  var aKeys = Object.keys(a);
  var bKeys = Object.keys(b);
  if (aKeys.length !== bKeys.length) {
    return false
  }
  return aKeys.every(function (key) {
    var aVal = a[key];
    var bVal = b[key];
    // check nested equality
    if (typeof aVal === 'object' && typeof bVal === 'object') {
      return isObjectEqual(aVal, bVal)
    }
    return String(aVal) === String(bVal)
  })
}

function isIncludedRoute (current, target) {
  return (
    current.path.replace(trailingSlashRE, '/').indexOf(
      target.path.replace(trailingSlashRE, '/')
    ) === 0 &&
    (!target.hash || current.hash === target.hash) &&
    queryIncludes(current.query, target.query)
  )
}

function queryIncludes (current, target) {
  for (var key in target) {
    if (!(key in current)) {
      return false
    }
  }
  return true
}

/*  */

// work around weird flow bug
var toTypes = [String, Object];
var eventTypes = [String, Array];

var Link = {
  name: 'router-link',
  props: {
    to: {
      type: toTypes,
      required: true
    },
    tag: {
      type: String,
      default: 'a'
    },
    exact: Boolean,
    append: Boolean,
    replace: Boolean,
    activeClass: String,
    exactActiveClass: String,
    event: {
      type: eventTypes,
      default: 'click'
    }
  },
  render: function render (h) {
    var this$1 = this;

    var router = this.$router;
    var current = this.$route;
    var ref = router.resolve(this.to, current, this.append);
    var location = ref.location;
    var route = ref.route;
    var href = ref.href;

    var classes = {};
    var globalActiveClass = router.options.linkActiveClass;
    var globalExactActiveClass = router.options.linkExactActiveClass;
    // Support global empty active class
    var activeClassFallback = globalActiveClass == null
            ? 'router-link-active'
            : globalActiveClass;
    var exactActiveClassFallback = globalExactActiveClass == null
            ? 'router-link-exact-active'
            : globalExactActiveClass;
    var activeClass = this.activeClass == null
            ? activeClassFallback
            : this.activeClass;
    var exactActiveClass = this.exactActiveClass == null
            ? exactActiveClassFallback
            : this.exactActiveClass;
    var compareTarget = location.path
      ? createRoute(null, location, null, router)
      : route;

    classes[exactActiveClass] = isSameRoute(current, compareTarget);
    classes[activeClass] = this.exact
      ? classes[exactActiveClass]
      : isIncludedRoute(current, compareTarget);

    var handler = function (e) {
      if (guardEvent(e)) {
        if (this$1.replace) {
          router.replace(location);
        } else {
          router.push(location);
        }
      }
    };

    var on = { click: guardEvent };
    if (Array.isArray(this.event)) {
      this.event.forEach(function (e) { on[e] = handler; });
    } else {
      on[this.event] = handler;
    }

    var data = {
      class: classes
    };

    if (this.tag === 'a') {
      data.on = on;
      data.attrs = { href: href };
    } else {
      // find the first <a> child and apply listener and href
      var a = findAnchor(this.$slots.default);
      if (a) {
        // in case the <a> is a static node
        a.isStatic = false;
        var extend = _Vue.util.extend;
        var aData = a.data = extend({}, a.data);
        aData.on = on;
        var aAttrs = a.data.attrs = extend({}, a.data.attrs);
        aAttrs.href = href;
      } else {
        // doesn't have <a> child, apply listener to self
        data.on = on;
      }
    }

    return h(this.tag, data, this.$slots.default)
  }
};

function guardEvent (e) {
  // don't redirect with control keys
  if (e.metaKey || e.altKey || e.ctrlKey || e.shiftKey) { return }
  // don't redirect when preventDefault called
  if (e.defaultPrevented) { return }
  // don't redirect on right click
  if (e.button !== undefined && e.button !== 0) { return }
  // don't redirect if `target="_blank"`
  if (e.currentTarget && e.currentTarget.getAttribute) {
    var target = e.currentTarget.getAttribute('target');
    if (/\b_blank\b/i.test(target)) { return }
  }
  // this may be a Weex event which doesn't have this method
  if (e.preventDefault) {
    e.preventDefault();
  }
  return true
}

function findAnchor (children) {
  if (children) {
    var child;
    for (var i = 0; i < children.length; i++) {
      child = children[i];
      if (child.tag === 'a') {
        return child
      }
      if (child.children && (child = findAnchor(child.children))) {
        return child
      }
    }
  }
}

var _Vue;

function install (Vue) {
  if (install.installed && _Vue === Vue) { return }
  install.installed = true;

  _Vue = Vue;

  var isDef = function (v) { return v !== undefined; };

  var registerInstance = function (vm, callVal) {
    var i = vm.$options._parentVnode;
    if (isDef(i) && isDef(i = i.data) && isDef(i = i.registerRouteInstance)) {
      i(vm, callVal);
    }
  };

  Vue.mixin({
    beforeCreate: function beforeCreate () {
      if (isDef(this.$options.router)) {
        this._routerRoot = this;
        this._router = this.$options.router;
        this._router.init(this);
        Vue.util.defineReactive(this, '_route', this._router.history.current);
      } else {
        this._routerRoot = (this.$parent && this.$parent._routerRoot) || this;
      }
      registerInstance(this, this);
    },
    destroyed: function destroyed () {
      registerInstance(this);
    }
  });

  Object.defineProperty(Vue.prototype, '$router', {
    get: function get () { return this._routerRoot._router }
  });

  Object.defineProperty(Vue.prototype, '$route', {
    get: function get () { return this._routerRoot._route }
  });

  Vue.component('router-view', View);
  Vue.component('router-link', Link);

  var strats = Vue.config.optionMergeStrategies;
  // use the same hook merging strategy for route hooks
  strats.beforeRouteEnter = strats.beforeRouteLeave = strats.beforeRouteUpdate = strats.created;
}

/*  */

var inBrowser = typeof window !== 'undefined';

/*  */

function resolvePath (
  relative,
  base,
  append
) {
  var firstChar = relative.charAt(0);
  if (firstChar === '/') {
    return relative
  }

  if (firstChar === '?' || firstChar === '#') {
    return base + relative
  }

  var stack = base.split('/');

  // remove trailing segment if:
  // - not appending
  // - appending to trailing slash (last segment is empty)
  if (!append || !stack[stack.length - 1]) {
    stack.pop();
  }

  // resolve relative path
  var segments = relative.replace(/^\//, '').split('/');
  for (var i = 0; i < segments.length; i++) {
    var segment = segments[i];
    if (segment === '..') {
      stack.pop();
    } else if (segment !== '.') {
      stack.push(segment);
    }
  }

  // ensure leading slash
  if (stack[0] !== '') {
    stack.unshift('');
  }

  return stack.join('/')
}

function parsePath (path) {
  var hash = '';
  var query = '';

  var hashIndex = path.indexOf('#');
  if (hashIndex >= 0) {
    hash = path.slice(hashIndex);
    path = path.slice(0, hashIndex);
  }

  var queryIndex = path.indexOf('?');
  if (queryIndex >= 0) {
    query = path.slice(queryIndex + 1);
    path = path.slice(0, queryIndex);
  }

  return {
    path: path,
    query: query,
    hash: hash
  }
}

function cleanPath (path) {
  return path.replace(/\/\//g, '/')
}

var isarray = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};

/**
 * Expose `pathToRegexp`.
 */
var pathToRegexp_1 = pathToRegexp;
var parse_1 = parse;
var compile_1 = compile;
var tokensToFunction_1 = tokensToFunction;
var tokensToRegExp_1 = tokensToRegExp;

/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */
var PATH_REGEXP = new RegExp([
  // Match escaped characters that would otherwise appear in future matches.
  // This allows the user to escape special characters that won't transform.
  '(\\\\.)',
  // Match Express-style parameters and un-named parameters with a prefix
  // and optional suffixes. Matches appear as:
  //
  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
].join('|'), 'g');

/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */
function parse (str, options) {
  var tokens = [];
  var key = 0;
  var index = 0;
  var path = '';
  var defaultDelimiter = options && options.delimiter || '/';
  var res;

  while ((res = PATH_REGEXP.exec(str)) != null) {
    var m = res[0];
    var escaped = res[1];
    var offset = res.index;
    path += str.slice(index, offset);
    index = offset + m.length;

    // Ignore already escaped sequences.
    if (escaped) {
      path += escaped[1];
      continue
    }

    var next = str[index];
    var prefix = res[2];
    var name = res[3];
    var capture = res[4];
    var group = res[5];
    var modifier = res[6];
    var asterisk = res[7];

    // Push the current path onto the tokens.
    if (path) {
      tokens.push(path);
      path = '';
    }

    var partial = prefix != null && next != null && next !== prefix;
    var repeat = modifier === '+' || modifier === '*';
    var optional = modifier === '?' || modifier === '*';
    var delimiter = res[2] || defaultDelimiter;
    var pattern = capture || group;

    tokens.push({
      name: name || key++,
      prefix: prefix || '',
      delimiter: delimiter,
      optional: optional,
      repeat: repeat,
      partial: partial,
      asterisk: !!asterisk,
      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?')
    });
  }

  // Match any characters still remaining.
  if (index < str.length) {
    path += str.substr(index);
  }

  // If the path exists, push it onto the end.
  if (path) {
    tokens.push(path);
  }

  return tokens
}

/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */
function compile (str, options) {
  return tokensToFunction(parse(str, options))
}

/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */
function encodeURIComponentPretty (str) {
  return encodeURI(str).replace(/[\/?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */
function encodeAsterisk (str) {
  return encodeURI(str).replace(/[?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Expose a method for transforming tokens into the path function.
 */
function tokensToFunction (tokens) {
  // Compile all the tokens into regexps.
  var matches = new Array(tokens.length);

  // Compile all the patterns before compilation.
  for (var i = 0; i < tokens.length; i++) {
    if (typeof tokens[i] === 'object') {
      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$');
    }
  }

  return function (obj, opts) {
    var path = '';
    var data = obj || {};
    var options = opts || {};
    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent;

    for (var i = 0; i < tokens.length; i++) {
      var token = tokens[i];

      if (typeof token === 'string') {
        path += token;

        continue
      }

      var value = data[token.name];
      var segment;

      if (value == null) {
        if (token.optional) {
          // Prepend partial segment prefixes.
          if (token.partial) {
            path += token.prefix;
          }

          continue
        } else {
          throw new TypeError('Expected "' + token.name + '" to be defined')
        }
      }

      if (isarray(value)) {
        if (!token.repeat) {
          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
        }

        if (value.length === 0) {
          if (token.optional) {
            continue
          } else {
            throw new TypeError('Expected "' + token.name + '" to not be empty')
          }
        }

        for (var j = 0; j < value.length; j++) {
          segment = encode(value[j]);

          if (!matches[i].test(segment)) {
            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
          }

          path += (j === 0 ? token.prefix : token.delimiter) + segment;
        }

        continue
      }

      segment = token.asterisk ? encodeAsterisk(value) : encode(value);

      if (!matches[i].test(segment)) {
        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
      }

      path += token.prefix + segment;
    }

    return path
  }
}

/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */
function escapeString (str) {
  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
}

/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */
function escapeGroup (group) {
  return group.replace(/([=!:$\/()])/g, '\\$1')
}

/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */
function attachKeys (re, keys) {
  re.keys = keys;
  return re
}

/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */
function flags (options) {
  return options.sensitive ? '' : 'i'
}

/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */
function regexpToRegexp (path, keys) {
  // Use a negative lookahead to match only capturing groups.
  var groups = path.source.match(/\((?!\?)/g);

  if (groups) {
    for (var i = 0; i < groups.length; i++) {
      keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
      });
    }
  }

  return attachKeys(path, keys)
}

/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function arrayToRegexp (path, keys, options) {
  var parts = [];

  for (var i = 0; i < path.length; i++) {
    parts.push(pathToRegexp(path[i], keys, options).source);
  }

  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options));

  return attachKeys(regexp, keys)
}

/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function stringToRegexp (path, keys, options) {
  return tokensToRegExp(parse(path, options), keys, options)
}

/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */
function tokensToRegExp (tokens, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options);
    keys = [];
  }

  options = options || {};

  var strict = options.strict;
  var end = options.end !== false;
  var route = '';

  // Iterate over the tokens and create our regexp string.
  for (var i = 0; i < tokens.length; i++) {
    var token = tokens[i];

    if (typeof token === 'string') {
      route += escapeString(token);
    } else {
      var prefix = escapeString(token.prefix);
      var capture = '(?:' + token.pattern + ')';

      keys.push(token);

      if (token.repeat) {
        capture += '(?:' + prefix + capture + ')*';
      }

      if (token.optional) {
        if (!token.partial) {
          capture = '(?:' + prefix + '(' + capture + '))?';
        } else {
          capture = prefix + '(' + capture + ')?';
        }
      } else {
        capture = prefix + '(' + capture + ')';
      }

      route += capture;
    }
  }

  var delimiter = escapeString(options.delimiter || '/');
  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter;

  // In non-strict mode we allow a slash at the end of match. If the path to
  // match already ends with a slash, we remove it for consistency. The slash
  // is valid at the end of a path match, not in the middle. This is important
  // in non-ending mode, where "/test/" shouldn't match "/test//route".
  if (!strict) {
    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?';
  }

  if (end) {
    route += '$';
  } else {
    // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)';
  }

  return attachKeys(new RegExp('^' + route, flags(options)), keys)
}

/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */
function pathToRegexp (path, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options);
    keys = [];
  }

  options = options || {};

  if (path instanceof RegExp) {
    return regexpToRegexp(path, /** @type {!Array} */ (keys))
  }

  if (isarray(path)) {
    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
  }

  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
}

pathToRegexp_1.parse = parse_1;
pathToRegexp_1.compile = compile_1;
pathToRegexp_1.tokensToFunction = tokensToFunction_1;
pathToRegexp_1.tokensToRegExp = tokensToRegExp_1;

/*  */

// $flow-disable-line
var regexpCompileCache = Object.create(null);

function fillParams (
  path,
  params,
  routeMsg
) {
  try {
    var filler =
      regexpCompileCache[path] ||
      (regexpCompileCache[path] = pathToRegexp_1.compile(path));
    return filler(params || {}, { pretty: true })
  } catch (e) {
    if (false) {
      warn(false, ("missing param for " + routeMsg + ": " + (e.message)));
    }
    return ''
  }
}

/*  */

function createRouteMap (
  routes,
  oldPathList,
  oldPathMap,
  oldNameMap
) {
  // the path list is used to control path matching priority
  var pathList = oldPathList || [];
  // $flow-disable-line
  var pathMap = oldPathMap || Object.create(null);
  // $flow-disable-line
  var nameMap = oldNameMap || Object.create(null);

  routes.forEach(function (route) {
    addRouteRecord(pathList, pathMap, nameMap, route);
  });

  // ensure wildcard routes are always at the end
  for (var i = 0, l = pathList.length; i < l; i++) {
    if (pathList[i] === '*') {
      pathList.push(pathList.splice(i, 1)[0]);
      l--;
      i--;
    }
  }

  return {
    pathList: pathList,
    pathMap: pathMap,
    nameMap: nameMap
  }
}

function addRouteRecord (
  pathList,
  pathMap,
  nameMap,
  route,
  parent,
  matchAs
) {
  var path = route.path;
  var name = route.name;
  if (false) {
    assert(path != null, "\"path\" is required in a route configuration.");
    assert(
      typeof route.component !== 'string',
      "route config \"component\" for path: " + (String(path || name)) + " cannot be a " +
      "string id. Use an actual component instead."
    );
  }

  var pathToRegexpOptions = route.pathToRegexpOptions || {};
  var normalizedPath = normalizePath(
    path,
    parent,
    pathToRegexpOptions.strict
  );

  if (typeof route.caseSensitive === 'boolean') {
    pathToRegexpOptions.sensitive = route.caseSensitive;
  }

  var record = {
    path: normalizedPath,
    regex: compileRouteRegex(normalizedPath, pathToRegexpOptions),
    components: route.components || { default: route.component },
    instances: {},
    name: name,
    parent: parent,
    matchAs: matchAs,
    redirect: route.redirect,
    beforeEnter: route.beforeEnter,
    meta: route.meta || {},
    props: route.props == null
      ? {}
      : route.components
        ? route.props
        : { default: route.props }
  };

  if (route.children) {
    // Warn if route is named, does not redirect and has a default child route.
    // If users navigate to this route by name, the default child will
    // not be rendered (GH Issue #629)
    if (false) {
      if (route.name && !route.redirect && route.children.some(function (child) { return /^\/?$/.test(child.path); })) {
        warn(
          false,
          "Named Route '" + (route.name) + "' has a default child route. " +
          "When navigating to this named route (:to=\"{name: '" + (route.name) + "'\"), " +
          "the default child route will not be rendered. Remove the name from " +
          "this route and use the name of the default child route for named " +
          "links instead."
        );
      }
    }
    route.children.forEach(function (child) {
      var childMatchAs = matchAs
        ? cleanPath((matchAs + "/" + (child.path)))
        : undefined;
      addRouteRecord(pathList, pathMap, nameMap, child, record, childMatchAs);
    });
  }

  if (route.alias !== undefined) {
    var aliases = Array.isArray(route.alias)
      ? route.alias
      : [route.alias];

    aliases.forEach(function (alias) {
      var aliasRoute = {
        path: alias,
        children: route.children
      };
      addRouteRecord(
        pathList,
        pathMap,
        nameMap,
        aliasRoute,
        parent,
        record.path || '/' // matchAs
      );
    });
  }

  if (!pathMap[record.path]) {
    pathList.push(record.path);
    pathMap[record.path] = record;
  }

  if (name) {
    if (!nameMap[name]) {
      nameMap[name] = record;
    } else if (false) {
      warn(
        false,
        "Duplicate named routes definition: " +
        "{ name: \"" + name + "\", path: \"" + (record.path) + "\" }"
      );
    }
  }
}

function compileRouteRegex (path, pathToRegexpOptions) {
  var regex = pathToRegexp_1(path, [], pathToRegexpOptions);
  if (false) {
    var keys = Object.create(null);
    regex.keys.forEach(function (key) {
      warn(!keys[key.name], ("Duplicate param keys in route with path: \"" + path + "\""));
      keys[key.name] = true;
    });
  }
  return regex
}

function normalizePath (path, parent, strict) {
  if (!strict) { path = path.replace(/\/$/, ''); }
  if (path[0] === '/') { return path }
  if (parent == null) { return path }
  return cleanPath(((parent.path) + "/" + path))
}

/*  */


function normalizeLocation (
  raw,
  current,
  append,
  router
) {
  var next = typeof raw === 'string' ? { path: raw } : raw;
  // named target
  if (next.name || next._normalized) {
    return next
  }

  // relative params
  if (!next.path && next.params && current) {
    next = assign({}, next);
    next._normalized = true;
    var params = assign(assign({}, current.params), next.params);
    if (current.name) {
      next.name = current.name;
      next.params = params;
    } else if (current.matched.length) {
      var rawPath = current.matched[current.matched.length - 1].path;
      next.path = fillParams(rawPath, params, ("path " + (current.path)));
    } else if (false) {
      warn(false, "relative params navigation requires a current route.");
    }
    return next
  }

  var parsedPath = parsePath(next.path || '');
  var basePath = (current && current.path) || '/';
  var path = parsedPath.path
    ? resolvePath(parsedPath.path, basePath, append || next.append)
    : basePath;

  var query = resolveQuery(
    parsedPath.query,
    next.query,
    router && router.options.parseQuery
  );

  var hash = next.hash || parsedPath.hash;
  if (hash && hash.charAt(0) !== '#') {
    hash = "#" + hash;
  }

  return {
    _normalized: true,
    path: path,
    query: query,
    hash: hash
  }
}

function assign (a, b) {
  for (var key in b) {
    a[key] = b[key];
  }
  return a
}

/*  */


function createMatcher (
  routes,
  router
) {
  var ref = createRouteMap(routes);
  var pathList = ref.pathList;
  var pathMap = ref.pathMap;
  var nameMap = ref.nameMap;

  function addRoutes (routes) {
    createRouteMap(routes, pathList, pathMap, nameMap);
  }

  function match (
    raw,
    currentRoute,
    redirectedFrom
  ) {
    var location = normalizeLocation(raw, currentRoute, false, router);
    var name = location.name;

    if (name) {
      var record = nameMap[name];
      if (false) {
        warn(record, ("Route with name '" + name + "' does not exist"));
      }
      if (!record) { return _createRoute(null, location) }
      var paramNames = record.regex.keys
        .filter(function (key) { return !key.optional; })
        .map(function (key) { return key.name; });

      if (typeof location.params !== 'object') {
        location.params = {};
      }

      if (currentRoute && typeof currentRoute.params === 'object') {
        for (var key in currentRoute.params) {
          if (!(key in location.params) && paramNames.indexOf(key) > -1) {
            location.params[key] = currentRoute.params[key];
          }
        }
      }

      if (record) {
        location.path = fillParams(record.path, location.params, ("named route \"" + name + "\""));
        return _createRoute(record, location, redirectedFrom)
      }
    } else if (location.path) {
      location.params = {};
      for (var i = 0; i < pathList.length; i++) {
        var path = pathList[i];
        var record$1 = pathMap[path];
        if (matchRoute(record$1.regex, location.path, location.params)) {
          return _createRoute(record$1, location, redirectedFrom)
        }
      }
    }
    // no match
    return _createRoute(null, location)
  }

  function redirect (
    record,
    location
  ) {
    var originalRedirect = record.redirect;
    var redirect = typeof originalRedirect === 'function'
        ? originalRedirect(createRoute(record, location, null, router))
        : originalRedirect;

    if (typeof redirect === 'string') {
      redirect = { path: redirect };
    }

    if (!redirect || typeof redirect !== 'object') {
      if (false) {
        warn(
          false, ("invalid redirect option: " + (JSON.stringify(redirect)))
        );
      }
      return _createRoute(null, location)
    }

    var re = redirect;
    var name = re.name;
    var path = re.path;
    var query = location.query;
    var hash = location.hash;
    var params = location.params;
    query = re.hasOwnProperty('query') ? re.query : query;
    hash = re.hasOwnProperty('hash') ? re.hash : hash;
    params = re.hasOwnProperty('params') ? re.params : params;

    if (name) {
      // resolved named direct
      var targetRecord = nameMap[name];
      if (false) {
        assert(targetRecord, ("redirect failed: named route \"" + name + "\" not found."));
      }
      return match({
        _normalized: true,
        name: name,
        query: query,
        hash: hash,
        params: params
      }, undefined, location)
    } else if (path) {
      // 1. resolve relative redirect
      var rawPath = resolveRecordPath(path, record);
      // 2. resolve params
      var resolvedPath = fillParams(rawPath, params, ("redirect route with path \"" + rawPath + "\""));
      // 3. rematch with existing query and hash
      return match({
        _normalized: true,
        path: resolvedPath,
        query: query,
        hash: hash
      }, undefined, location)
    } else {
      if (false) {
        warn(false, ("invalid redirect option: " + (JSON.stringify(redirect))));
      }
      return _createRoute(null, location)
    }
  }

  function alias (
    record,
    location,
    matchAs
  ) {
    var aliasedPath = fillParams(matchAs, location.params, ("aliased route with path \"" + matchAs + "\""));
    var aliasedMatch = match({
      _normalized: true,
      path: aliasedPath
    });
    if (aliasedMatch) {
      var matched = aliasedMatch.matched;
      var aliasedRecord = matched[matched.length - 1];
      location.params = aliasedMatch.params;
      return _createRoute(aliasedRecord, location)
    }
    return _createRoute(null, location)
  }

  function _createRoute (
    record,
    location,
    redirectedFrom
  ) {
    if (record && record.redirect) {
      return redirect(record, redirectedFrom || location)
    }
    if (record && record.matchAs) {
      return alias(record, location, record.matchAs)
    }
    return createRoute(record, location, redirectedFrom, router)
  }

  return {
    match: match,
    addRoutes: addRoutes
  }
}

function matchRoute (
  regex,
  path,
  params
) {
  var m = path.match(regex);

  if (!m) {
    return false
  } else if (!params) {
    return true
  }

  for (var i = 1, len = m.length; i < len; ++i) {
    var key = regex.keys[i - 1];
    var val = typeof m[i] === 'string' ? decodeURIComponent(m[i]) : m[i];
    if (key) {
      params[key.name] = val;
    }
  }

  return true
}

function resolveRecordPath (path, record) {
  return resolvePath(path, record.parent ? record.parent.path : '/', true)
}

/*  */


var positionStore = Object.create(null);

function setupScroll () {
  // Fix for #1585 for Firefox
  window.history.replaceState({ key: getStateKey() }, '');
  window.addEventListener('popstate', function (e) {
    saveScrollPosition();
    if (e.state && e.state.key) {
      setStateKey(e.state.key);
    }
  });
}

function handleScroll (
  router,
  to,
  from,
  isPop
) {
  if (!router.app) {
    return
  }

  var behavior = router.options.scrollBehavior;
  if (!behavior) {
    return
  }

  if (false) {
    assert(typeof behavior === 'function', "scrollBehavior must be a function");
  }

  // wait until re-render finishes before scrolling
  router.app.$nextTick(function () {
    var position = getScrollPosition();
    var shouldScroll = behavior(to, from, isPop ? position : null);

    if (!shouldScroll) {
      return
    }

    if (typeof shouldScroll.then === 'function') {
      shouldScroll.then(function (shouldScroll) {
        scrollToPosition((shouldScroll), position);
      }).catch(function (err) {
        if (false) {
          assert(false, err.toString());
        }
      });
    } else {
      scrollToPosition(shouldScroll, position);
    }
  });
}

function saveScrollPosition () {
  var key = getStateKey();
  if (key) {
    positionStore[key] = {
      x: window.pageXOffset,
      y: window.pageYOffset
    };
  }
}

function getScrollPosition () {
  var key = getStateKey();
  if (key) {
    return positionStore[key]
  }
}

function getElementPosition (el, offset) {
  var docEl = document.documentElement;
  var docRect = docEl.getBoundingClientRect();
  var elRect = el.getBoundingClientRect();
  return {
    x: elRect.left - docRect.left - offset.x,
    y: elRect.top - docRect.top - offset.y
  }
}

function isValidPosition (obj) {
  return isNumber(obj.x) || isNumber(obj.y)
}

function normalizePosition (obj) {
  return {
    x: isNumber(obj.x) ? obj.x : window.pageXOffset,
    y: isNumber(obj.y) ? obj.y : window.pageYOffset
  }
}

function normalizeOffset (obj) {
  return {
    x: isNumber(obj.x) ? obj.x : 0,
    y: isNumber(obj.y) ? obj.y : 0
  }
}

function isNumber (v) {
  return typeof v === 'number'
}

function scrollToPosition (shouldScroll, position) {
  var isObject = typeof shouldScroll === 'object';
  if (isObject && typeof shouldScroll.selector === 'string') {
    var el = document.querySelector(shouldScroll.selector);
    if (el) {
      var offset = shouldScroll.offset && typeof shouldScroll.offset === 'object' ? shouldScroll.offset : {};
      offset = normalizeOffset(offset);
      position = getElementPosition(el, offset);
    } else if (isValidPosition(shouldScroll)) {
      position = normalizePosition(shouldScroll);
    }
  } else if (isObject && isValidPosition(shouldScroll)) {
    position = normalizePosition(shouldScroll);
  }

  if (position) {
    window.scrollTo(position.x, position.y);
  }
}

/*  */

var supportsPushState = inBrowser && (function () {
  var ua = window.navigator.userAgent;

  if (
    (ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) &&
    ua.indexOf('Mobile Safari') !== -1 &&
    ua.indexOf('Chrome') === -1 &&
    ua.indexOf('Windows Phone') === -1
  ) {
    return false
  }

  return window.history && 'pushState' in window.history
})();

// use User Timing api (if present) for more accurate key precision
var Time = inBrowser && window.performance && window.performance.now
  ? window.performance
  : Date;

var _key = genKey();

function genKey () {
  return Time.now().toFixed(3)
}

function getStateKey () {
  return _key
}

function setStateKey (key) {
  _key = key;
}

function pushState (url, replace) {
  saveScrollPosition();
  // try...catch the pushState call to get around Safari
  // DOM Exception 18 where it limits to 100 pushState calls
  var history = window.history;
  try {
    if (replace) {
      history.replaceState({ key: _key }, '', url);
    } else {
      _key = genKey();
      history.pushState({ key: _key }, '', url);
    }
  } catch (e) {
    window.location[replace ? 'replace' : 'assign'](url);
  }
}

function replaceState (url) {
  pushState(url, true);
}

/*  */

function runQueue (queue, fn, cb) {
  var step = function (index) {
    if (index >= queue.length) {
      cb();
    } else {
      if (queue[index]) {
        fn(queue[index], function () {
          step(index + 1);
        });
      } else {
        step(index + 1);
      }
    }
  };
  step(0);
}

/*  */

function resolveAsyncComponents (matched) {
  return function (to, from, next) {
    var hasAsync = false;
    var pending = 0;
    var error = null;

    flatMapComponents(matched, function (def, _, match, key) {
      // if it's a function and doesn't have cid attached,
      // assume it's an async component resolve function.
      // we are not using Vue's default async resolving mechanism because
      // we want to halt the navigation until the incoming component has been
      // resolved.
      if (typeof def === 'function' && def.cid === undefined) {
        hasAsync = true;
        pending++;

        var resolve = once(function (resolvedDef) {
          if (isESModule(resolvedDef)) {
            resolvedDef = resolvedDef.default;
          }
          // save resolved on async factory in case it's used elsewhere
          def.resolved = typeof resolvedDef === 'function'
            ? resolvedDef
            : _Vue.extend(resolvedDef);
          match.components[key] = resolvedDef;
          pending--;
          if (pending <= 0) {
            next();
          }
        });

        var reject = once(function (reason) {
          var msg = "Failed to resolve async component " + key + ": " + reason;
          "production" !== 'production' && warn(false, msg);
          if (!error) {
            error = isError(reason)
              ? reason
              : new Error(msg);
            next(error);
          }
        });

        var res;
        try {
          res = def(resolve, reject);
        } catch (e) {
          reject(e);
        }
        if (res) {
          if (typeof res.then === 'function') {
            res.then(resolve, reject);
          } else {
            // new syntax in Vue 2.3
            var comp = res.component;
            if (comp && typeof comp.then === 'function') {
              comp.then(resolve, reject);
            }
          }
        }
      }
    });

    if (!hasAsync) { next(); }
  }
}

function flatMapComponents (
  matched,
  fn
) {
  return flatten(matched.map(function (m) {
    return Object.keys(m.components).map(function (key) { return fn(
      m.components[key],
      m.instances[key],
      m, key
    ); })
  }))
}

function flatten (arr) {
  return Array.prototype.concat.apply([], arr)
}

var hasSymbol =
  typeof Symbol === 'function' &&
  typeof Symbol.toStringTag === 'symbol';

function isESModule (obj) {
  return obj.__esModule || (hasSymbol && obj[Symbol.toStringTag] === 'Module')
}

// in Webpack 2, require.ensure now also returns a Promise
// so the resolve/reject functions may get called an extra time
// if the user uses an arrow function shorthand that happens to
// return that Promise.
function once (fn) {
  var called = false;
  return function () {
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];

    if (called) { return }
    called = true;
    return fn.apply(this, args)
  }
}

/*  */

var History = function History (router, base) {
  this.router = router;
  this.base = normalizeBase(base);
  // start with a route object that stands for "nowhere"
  this.current = START;
  this.pending = null;
  this.ready = false;
  this.readyCbs = [];
  this.readyErrorCbs = [];
  this.errorCbs = [];
};

History.prototype.listen = function listen (cb) {
  this.cb = cb;
};

History.prototype.onReady = function onReady (cb, errorCb) {
  if (this.ready) {
    cb();
  } else {
    this.readyCbs.push(cb);
    if (errorCb) {
      this.readyErrorCbs.push(errorCb);
    }
  }
};

History.prototype.onError = function onError (errorCb) {
  this.errorCbs.push(errorCb);
};

History.prototype.transitionTo = function transitionTo (location, onComplete, onAbort) {
    var this$1 = this;

  var route = this.router.match(location, this.current);
  this.confirmTransition(route, function () {
    this$1.updateRoute(route);
    onComplete && onComplete(route);
    this$1.ensureURL();

    // fire ready cbs once
    if (!this$1.ready) {
      this$1.ready = true;
      this$1.readyCbs.forEach(function (cb) { cb(route); });
    }
  }, function (err) {
    if (onAbort) {
      onAbort(err);
    }
    if (err && !this$1.ready) {
      this$1.ready = true;
      this$1.readyErrorCbs.forEach(function (cb) { cb(err); });
    }
  });
};

History.prototype.confirmTransition = function confirmTransition (route, onComplete, onAbort) {
    var this$1 = this;

  var current = this.current;
  var abort = function (err) {
    if (isError(err)) {
      if (this$1.errorCbs.length) {
        this$1.errorCbs.forEach(function (cb) { cb(err); });
      } else {
        warn(false, 'uncaught error during route navigation:');
        console.error(err);
      }
    }
    onAbort && onAbort(err);
  };
  if (
    isSameRoute(route, current) &&
    // in the case the route map has been dynamically appended to
    route.matched.length === current.matched.length
  ) {
    this.ensureURL();
    return abort()
  }

  var ref = resolveQueue(this.current.matched, route.matched);
    var updated = ref.updated;
    var deactivated = ref.deactivated;
    var activated = ref.activated;

  var queue = [].concat(
    // in-component leave guards
    extractLeaveGuards(deactivated),
    // global before hooks
    this.router.beforeHooks,
    // in-component update hooks
    extractUpdateHooks(updated),
    // in-config enter guards
    activated.map(function (m) { return m.beforeEnter; }),
    // async components
    resolveAsyncComponents(activated)
  );

  this.pending = route;
  var iterator = function (hook, next) {
    if (this$1.pending !== route) {
      return abort()
    }
    try {
      hook(route, current, function (to) {
        if (to === false || isError(to)) {
          // next(false) -> abort navigation, ensure current URL
          this$1.ensureURL(true);
          abort(to);
        } else if (
          typeof to === 'string' ||
          (typeof to === 'object' && (
            typeof to.path === 'string' ||
            typeof to.name === 'string'
          ))
        ) {
          // next('/') or next({ path: '/' }) -> redirect
          abort();
          if (typeof to === 'object' && to.replace) {
            this$1.replace(to);
          } else {
            this$1.push(to);
          }
        } else {
          // confirm transition and pass on the value
          next(to);
        }
      });
    } catch (e) {
      abort(e);
    }
  };

  runQueue(queue, iterator, function () {
    var postEnterCbs = [];
    var isValid = function () { return this$1.current === route; };
    // wait until async components are resolved before
    // extracting in-component enter guards
    var enterGuards = extractEnterGuards(activated, postEnterCbs, isValid);
    var queue = enterGuards.concat(this$1.router.resolveHooks);
    runQueue(queue, iterator, function () {
      if (this$1.pending !== route) {
        return abort()
      }
      this$1.pending = null;
      onComplete(route);
      if (this$1.router.app) {
        this$1.router.app.$nextTick(function () {
          postEnterCbs.forEach(function (cb) { cb(); });
        });
      }
    });
  });
};

History.prototype.updateRoute = function updateRoute (route) {
  var prev = this.current;
  this.current = route;
  this.cb && this.cb(route);
  this.router.afterHooks.forEach(function (hook) {
    hook && hook(route, prev);
  });
};

function normalizeBase (base) {
  if (!base) {
    if (inBrowser) {
      // respect <base> tag
      var baseEl = document.querySelector('base');
      base = (baseEl && baseEl.getAttribute('href')) || '/';
      // strip full URL origin
      base = base.replace(/^https?:\/\/[^\/]+/, '');
    } else {
      base = '/';
    }
  }
  // make sure there's the starting slash
  if (base.charAt(0) !== '/') {
    base = '/' + base;
  }
  // remove trailing slash
  return base.replace(/\/$/, '')
}

function resolveQueue (
  current,
  next
) {
  var i;
  var max = Math.max(current.length, next.length);
  for (i = 0; i < max; i++) {
    if (current[i] !== next[i]) {
      break
    }
  }
  return {
    updated: next.slice(0, i),
    activated: next.slice(i),
    deactivated: current.slice(i)
  }
}

function extractGuards (
  records,
  name,
  bind,
  reverse
) {
  var guards = flatMapComponents(records, function (def, instance, match, key) {
    var guard = extractGuard(def, name);
    if (guard) {
      return Array.isArray(guard)
        ? guard.map(function (guard) { return bind(guard, instance, match, key); })
        : bind(guard, instance, match, key)
    }
  });
  return flatten(reverse ? guards.reverse() : guards)
}

function extractGuard (
  def,
  key
) {
  if (typeof def !== 'function') {
    // extend now so that global mixins are applied.
    def = _Vue.extend(def);
  }
  return def.options[key]
}

function extractLeaveGuards (deactivated) {
  return extractGuards(deactivated, 'beforeRouteLeave', bindGuard, true)
}

function extractUpdateHooks (updated) {
  return extractGuards(updated, 'beforeRouteUpdate', bindGuard)
}

function bindGuard (guard, instance) {
  if (instance) {
    return function boundRouteGuard () {
      return guard.apply(instance, arguments)
    }
  }
}

function extractEnterGuards (
  activated,
  cbs,
  isValid
) {
  return extractGuards(activated, 'beforeRouteEnter', function (guard, _, match, key) {
    return bindEnterGuard(guard, match, key, cbs, isValid)
  })
}

function bindEnterGuard (
  guard,
  match,
  key,
  cbs,
  isValid
) {
  return function routeEnterGuard (to, from, next) {
    return guard(to, from, function (cb) {
      next(cb);
      if (typeof cb === 'function') {
        cbs.push(function () {
          // #750
          // if a router-view is wrapped with an out-in transition,
          // the instance may not have been registered at this time.
          // we will need to poll for registration until current route
          // is no longer valid.
          poll(cb, match.instances, key, isValid);
        });
      }
    })
  }
}

function poll (
  cb, // somehow flow cannot infer this is a function
  instances,
  key,
  isValid
) {
  if (instances[key]) {
    cb(instances[key]);
  } else if (isValid()) {
    setTimeout(function () {
      poll(cb, instances, key, isValid);
    }, 16);
  }
}

/*  */


var HTML5History = (function (History$$1) {
  function HTML5History (router, base) {
    var this$1 = this;

    History$$1.call(this, router, base);

    var expectScroll = router.options.scrollBehavior;

    if (expectScroll) {
      setupScroll();
    }

    var initLocation = getLocation(this.base);
    window.addEventListener('popstate', function (e) {
      var current = this$1.current;

      // Avoiding first `popstate` event dispatched in some browsers but first
      // history route not updated since async guard at the same time.
      var location = getLocation(this$1.base);
      if (this$1.current === START && location === initLocation) {
        return
      }

      this$1.transitionTo(location, function (route) {
        if (expectScroll) {
          handleScroll(router, route, current, true);
        }
      });
    });
  }

  if ( History$$1 ) HTML5History.__proto__ = History$$1;
  HTML5History.prototype = Object.create( History$$1 && History$$1.prototype );
  HTML5History.prototype.constructor = HTML5History;

  HTML5History.prototype.go = function go (n) {
    window.history.go(n);
  };

  HTML5History.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      pushState(cleanPath(this$1.base + route.fullPath));
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HTML5History.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      replaceState(cleanPath(this$1.base + route.fullPath));
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HTML5History.prototype.ensureURL = function ensureURL (push) {
    if (getLocation(this.base) !== this.current.fullPath) {
      var current = cleanPath(this.base + this.current.fullPath);
      push ? pushState(current) : replaceState(current);
    }
  };

  HTML5History.prototype.getCurrentLocation = function getCurrentLocation () {
    return getLocation(this.base)
  };

  return HTML5History;
}(History));

function getLocation (base) {
  var path = window.location.pathname;
  if (base && path.indexOf(base) === 0) {
    path = path.slice(base.length);
  }
  return (path || '/') + window.location.search + window.location.hash
}

/*  */


var HashHistory = (function (History$$1) {
  function HashHistory (router, base, fallback) {
    History$$1.call(this, router, base);
    // check history fallback deeplinking
    if (fallback && checkFallback(this.base)) {
      return
    }
    ensureSlash();
  }

  if ( History$$1 ) HashHistory.__proto__ = History$$1;
  HashHistory.prototype = Object.create( History$$1 && History$$1.prototype );
  HashHistory.prototype.constructor = HashHistory;

  // this is delayed until the app mounts
  // to avoid the hashchange listener being fired too early
  HashHistory.prototype.setupListeners = function setupListeners () {
    var this$1 = this;

    var router = this.router;
    var expectScroll = router.options.scrollBehavior;
    var supportsScroll = supportsPushState && expectScroll;

    if (supportsScroll) {
      setupScroll();
    }

    window.addEventListener(supportsPushState ? 'popstate' : 'hashchange', function () {
      var current = this$1.current;
      if (!ensureSlash()) {
        return
      }
      this$1.transitionTo(getHash(), function (route) {
        if (supportsScroll) {
          handleScroll(this$1.router, route, current, true);
        }
        if (!supportsPushState) {
          replaceHash(route.fullPath);
        }
      });
    });
  };

  HashHistory.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      pushHash(route.fullPath);
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HashHistory.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      replaceHash(route.fullPath);
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HashHistory.prototype.go = function go (n) {
    window.history.go(n);
  };

  HashHistory.prototype.ensureURL = function ensureURL (push) {
    var current = this.current.fullPath;
    if (getHash() !== current) {
      push ? pushHash(current) : replaceHash(current);
    }
  };

  HashHistory.prototype.getCurrentLocation = function getCurrentLocation () {
    return getHash()
  };

  return HashHistory;
}(History));

function checkFallback (base) {
  var location = getLocation(base);
  if (!/^\/#/.test(location)) {
    window.location.replace(
      cleanPath(base + '/#' + location)
    );
    return true
  }
}

function ensureSlash () {
  var path = getHash();
  if (path.charAt(0) === '/') {
    return true
  }
  replaceHash('/' + path);
  return false
}

function getHash () {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var index = href.indexOf('#');
  return index === -1 ? '' : href.slice(index + 1)
}

function getUrl (path) {
  var href = window.location.href;
  var i = href.indexOf('#');
  var base = i >= 0 ? href.slice(0, i) : href;
  return (base + "#" + path)
}

function pushHash (path) {
  if (supportsPushState) {
    pushState(getUrl(path));
  } else {
    window.location.hash = path;
  }
}

function replaceHash (path) {
  if (supportsPushState) {
    replaceState(getUrl(path));
  } else {
    window.location.replace(getUrl(path));
  }
}

/*  */


var AbstractHistory = (function (History$$1) {
  function AbstractHistory (router, base) {
    History$$1.call(this, router, base);
    this.stack = [];
    this.index = -1;
  }

  if ( History$$1 ) AbstractHistory.__proto__ = History$$1;
  AbstractHistory.prototype = Object.create( History$$1 && History$$1.prototype );
  AbstractHistory.prototype.constructor = AbstractHistory;

  AbstractHistory.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    this.transitionTo(location, function (route) {
      this$1.stack = this$1.stack.slice(0, this$1.index + 1).concat(route);
      this$1.index++;
      onComplete && onComplete(route);
    }, onAbort);
  };

  AbstractHistory.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    this.transitionTo(location, function (route) {
      this$1.stack = this$1.stack.slice(0, this$1.index).concat(route);
      onComplete && onComplete(route);
    }, onAbort);
  };

  AbstractHistory.prototype.go = function go (n) {
    var this$1 = this;

    var targetIndex = this.index + n;
    if (targetIndex < 0 || targetIndex >= this.stack.length) {
      return
    }
    var route = this.stack[targetIndex];
    this.confirmTransition(route, function () {
      this$1.index = targetIndex;
      this$1.updateRoute(route);
    });
  };

  AbstractHistory.prototype.getCurrentLocation = function getCurrentLocation () {
    var current = this.stack[this.stack.length - 1];
    return current ? current.fullPath : '/'
  };

  AbstractHistory.prototype.ensureURL = function ensureURL () {
    // noop
  };

  return AbstractHistory;
}(History));

/*  */

var VueRouter = function VueRouter (options) {
  if ( options === void 0 ) options = {};

  this.app = null;
  this.apps = [];
  this.options = options;
  this.beforeHooks = [];
  this.resolveHooks = [];
  this.afterHooks = [];
  this.matcher = createMatcher(options.routes || [], this);

  var mode = options.mode || 'hash';
  this.fallback = mode === 'history' && !supportsPushState && options.fallback !== false;
  if (this.fallback) {
    mode = 'hash';
  }
  if (!inBrowser) {
    mode = 'abstract';
  }
  this.mode = mode;

  switch (mode) {
    case 'history':
      this.history = new HTML5History(this, options.base);
      break
    case 'hash':
      this.history = new HashHistory(this, options.base, this.fallback);
      break
    case 'abstract':
      this.history = new AbstractHistory(this, options.base);
      break
    default:
      if (false) {
        assert(false, ("invalid mode: " + mode));
      }
  }
};

var prototypeAccessors = { currentRoute: { configurable: true } };

VueRouter.prototype.match = function match (
  raw,
  current,
  redirectedFrom
) {
  return this.matcher.match(raw, current, redirectedFrom)
};

prototypeAccessors.currentRoute.get = function () {
  return this.history && this.history.current
};

VueRouter.prototype.init = function init (app /* Vue component instance */) {
    var this$1 = this;

  "production" !== 'production' && assert(
    install.installed,
    "not installed. Make sure to call `Vue.use(VueRouter)` " +
    "before creating root instance."
  );

  this.apps.push(app);

  // main app already initialized.
  if (this.app) {
    return
  }

  this.app = app;

  var history = this.history;

  if (history instanceof HTML5History) {
    history.transitionTo(history.getCurrentLocation());
  } else if (history instanceof HashHistory) {
    var setupHashListener = function () {
      history.setupListeners();
    };
    history.transitionTo(
      history.getCurrentLocation(),
      setupHashListener,
      setupHashListener
    );
  }

  history.listen(function (route) {
    this$1.apps.forEach(function (app) {
      app._route = route;
    });
  });
};

VueRouter.prototype.beforeEach = function beforeEach (fn) {
  return registerHook(this.beforeHooks, fn)
};

VueRouter.prototype.beforeResolve = function beforeResolve (fn) {
  return registerHook(this.resolveHooks, fn)
};

VueRouter.prototype.afterEach = function afterEach (fn) {
  return registerHook(this.afterHooks, fn)
};

VueRouter.prototype.onReady = function onReady (cb, errorCb) {
  this.history.onReady(cb, errorCb);
};

VueRouter.prototype.onError = function onError (errorCb) {
  this.history.onError(errorCb);
};

VueRouter.prototype.push = function push (location, onComplete, onAbort) {
  this.history.push(location, onComplete, onAbort);
};

VueRouter.prototype.replace = function replace (location, onComplete, onAbort) {
  this.history.replace(location, onComplete, onAbort);
};

VueRouter.prototype.go = function go (n) {
  this.history.go(n);
};

VueRouter.prototype.back = function back () {
  this.go(-1);
};

VueRouter.prototype.forward = function forward () {
  this.go(1);
};

VueRouter.prototype.getMatchedComponents = function getMatchedComponents (to) {
  var route = to
    ? to.matched
      ? to
      : this.resolve(to).route
    : this.currentRoute;
  if (!route) {
    return []
  }
  return [].concat.apply([], route.matched.map(function (m) {
    return Object.keys(m.components).map(function (key) {
      return m.components[key]
    })
  }))
};

VueRouter.prototype.resolve = function resolve (
  to,
  current,
  append
) {
  var location = normalizeLocation(
    to,
    current || this.history.current,
    append,
    this
  );
  var route = this.match(location, current);
  var fullPath = route.redirectedFrom || route.fullPath;
  var base = this.history.base;
  var href = createHref(base, fullPath, this.mode);
  return {
    location: location,
    route: route,
    href: href,
    // for backwards compat
    normalizedTo: location,
    resolved: route
  }
};

VueRouter.prototype.addRoutes = function addRoutes (routes) {
  this.matcher.addRoutes(routes);
  if (this.history.current !== START) {
    this.history.transitionTo(this.history.getCurrentLocation());
  }
};

Object.defineProperties( VueRouter.prototype, prototypeAccessors );

function registerHook (list, fn) {
  list.push(fn);
  return function () {
    var i = list.indexOf(fn);
    if (i > -1) { list.splice(i, 1); }
  }
}

function createHref (base, fullPath, mode) {
  var path = mode === 'hash' ? '#' + fullPath : fullPath;
  return base ? cleanPath(base + '/' + path) : path
}

VueRouter.install = install;
VueRouter.version = '2.8.1';

if (inBrowser && window.Vue) {
  window.Vue.use(VueRouter);
}

/* harmony default export */ __webpack_exports__["a"] = (VueRouter);


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(50),
  /* template */
  __webpack_require__(51),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import Navigation from '@/components/Navigation'
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'home',
  data: function data() {
    return {};
  },

  components: {
    // 'navigation': Navigation
  }
});

/***/ }),
/* 51 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Anthony Trollope\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Anthony Trollope (1815–1882) was the author of over fifty books of fiction and nonfiction and is widely regarded as one of the preeminent English novelists of the Victorian era. Uncommon in his ability to capture both a wide readership and the highest respect of his most influential critics and peers—including luminaries such as Nathaniel Hawthorne, William Thackeray, Henry James, and George Eliot—Trollope is best remembered for two great sextets, the Chronicles of Barsetshire and the Pallisers, as well as his late-career satirical masterpiece "), _c('I', [_vm._v("The Way We Live Now")]), _vm._v(".")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/11fRC9u/tc-custom/9781504065214.jpg?1737121986411",
      "alt": "This image is the cover for the book Chronicles of Barsetshire Volume Two, The Chronicles of Barsetshire"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Chronicles of Barsetshire Volume Two, The Chronicles of Barsetshire\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("Three wise, witty novels in the saga following the residents of a rural English town in the Victorian era.")]), _c('br'), _c('br'), _vm._v(" In the nineteenth century, Anthony Trollope created the fictional world of Barsetshire, the setting for a series of classic novels that addressed love, murder, religion, politics, and the ordinary lives of locals both rich and poor."), _c('br'), _c('br'), _c('i', [_vm._v("Framley Parsonage")]), _vm._v(": A young vicar’s ambition drives him into a costly bargain in this comedic love story that brilliantly examines the intersection of romance and social class."), _c('br'), _c('br'), _c('i', [_vm._v("The Small House at Allington")]), _vm._v(": This witty novel follows the amorous misadventures of a pair of sisters."), _c('br'), _c('br'), _c('i', [_vm._v("The Last Chronicle of Barset")]), _vm._v(": A clergyman’s daughter falls in love with a member of high society, while her father stands accused of a terrible crime.\n    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Open Road Media\n   ")])])
}]}

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(53),
  /* template */
  __webpack_require__(54),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 54 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [
    [_c('div', {
      staticClass: "chapter"
    }, [_c('div', {
      staticClass: "inner_page"
    }, [
      [_vm._m(0)]
    ], 2)])]
  ], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(56),
  /* template */
  __webpack_require__(57),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 57 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [
    [_c('div', {
      staticClass: "chapter"
    }, [_c('div', {
      staticClass: "inner_page"
    }, [
      [_vm._m(0)]
    ], 2)])]
  ], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(59),
  /* template */
  __webpack_require__(60),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 60 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [
    [_c('div', {
      staticClass: "chapter"
    }, [_c('div', {
      staticClass: "inner_page"
    }, [
      [_vm._m(0)]
    ], 2)])]
  ], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(62),
  /* template */
  __webpack_require__(63),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 63 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [
    [_c('div', {
      staticClass: "chapter"
    }, [_c('div', {
      staticClass: "inner_page"
    }, [
      [_vm._m(0)]
    ], 2)])]
  ], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(65),
  /* template */
  __webpack_require__(66),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 66 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "toc2"
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('b', [_vm._v("CONTENTS")])])]), _vm._v(" "), _c('div', {
    staticClass: "toc1"
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/cover"
    }
  }, [_vm._v("Framley Parsonage")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/Untitled1"
    }
  }, [_vm._v("Title Page")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/Untitled11"
    }
  }, [_vm._v("CHAPTER I “Omnes Omnia Bona Dicere”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/Untitled12"
    }
  }, [_vm._v("CHAPTER II The Framley Set, and the Chaldicotes Set")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/Untitled13"
    }
  }, [_vm._v("CHAPTER III Chaldicotes")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/Untitled14"
    }
  }, [_vm._v("CHAPTER IV A Matter of Conscience")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/Untitled15"
    }
  }, [_vm._v("CHAPTER V Amantium Iræ Amoris Integratio")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/Untitled16"
    }
  }, [_vm._v("CHAPTER VI Mr. Harold Smith’s Lecture")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/Untitled17"
    }
  }, [_vm._v("CHAPTER VII Sunday Morning")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/Untitled18"
    }
  }, [_vm._v("CHAPTER VIII Gatherum Castle")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/Untitled19"
    }
  }, [_vm._v("CHAPTER IX The Vicar’s Return")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/Untitled110"
    }
  }, [_vm._v("CHAPTER X Lucy Robarts")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/Untitled111"
    }
  }, [_vm._v("CHAPTER XI Griselda Grantly")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/Untitled112"
    }
  }, [_vm._v("CHAPTER XII The Little Bill")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/Untitled113"
    }
  }, [_vm._v("CHAPTER XIII Delicate Hints")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/Untitled114"
    }
  }, [_vm._v("CHAPTER XIV Mr. Crawley of Hogglestock")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/Untitled115"
    }
  }, [_vm._v("CHAPTER XV Lady Lufton’s Ambassador")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/Untitled116"
    }
  }, [_vm._v("CHAPTER XVI Mrs. Podgens’s Baby")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/Untitled117"
    }
  }, [_vm._v("CHAPTER XVII Mrs. Proudie’s Conversazione")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/Untitled118"
    }
  }, [_vm._v("CHAPTER XVIII The New Minister’s Patronage")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/Untitled119"
    }
  }, [_vm._v("CHAPTER XIX Money Dealings")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/Untitled120"
    }
  }, [_vm._v("CHAPTER XX Harold Smith in the Cabinet")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/Untitled121"
    }
  }, [_vm._v("CHAPTER XXI Why Puck, the Pony, Was Beaten")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/Untitled122"
    }
  }, [_vm._v("CHAPTER XXII Hogglestock Parsonage")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/Untitled123"
    }
  }, [_vm._v("CHAPTER XXIII The Triumph of the Giants")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/Untitled124"
    }
  }, [_vm._v("CHAPTER XXIV Magna Est Veritas")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/Untitled125"
    }
  }, [_vm._v("CHAPTER XXV Non-Impulsive")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/Untitled126"
    }
  }, [_vm._v("CHAPTER XXVI Impulsive")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/Untitled127"
    }
  }, [_vm._v("CHAPTER XXVII South Audley Street")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/Untitled128"
    }
  }, [_vm._v("CHAPTER XXVIII Dr. Thorne")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/Untitled129"
    }
  }, [_vm._v("CHAPTER XXIX Miss Dunstable at Home")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/Untitled130"
    }
  }, [_vm._v("CHAPTER XXX The Grantly Triumph")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/Untitled131"
    }
  }, [_vm._v("CHAPTER XXXI Salmon Fishing in Norway")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/Untitled132"
    }
  }, [_vm._v("CHAPTER XXXII The Goat and Compasses")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/Untitled133"
    }
  }, [_vm._v("CHAPTER XXXIII Consolation")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/Untitled134"
    }
  }, [_vm._v("CHAPTER XXXIV Lady Lufton Is Taken by Surprise")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/Untitled135"
    }
  }, [_vm._v("CHAPTER XXXV The Story of King Cophetua")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/Untitled136"
    }
  }, [_vm._v("CHAPTER XXXVI Kidnapping at Hogglestock")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/Untitled137"
    }
  }, [_vm._v("CHAPTER XXXVII Mr. Sowerby Without Company")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/Untitled138"
    }
  }, [_vm._v("CHAPTER XXXVIII Is There Cause or Just Impediment")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/Untitled139"
    }
  }, [_vm._v("CHAPTER XXIX How to Write a Love Letter")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/Untitled140"
    }
  }, [_vm._v("CHAPTER XL Internecine")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/Untitled141"
    }
  }, [_vm._v("CHAPTER XLI Don Quixote")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/Untitled142"
    }
  }, [_vm._v("CHAPTER XLII Touching Pitch")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/Untitled143"
    }
  }, [_vm._v("CHAPTER XLIII Is She Not Insignificant?")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/Untitled144"
    }
  }, [_vm._v("CHAPTER XLIV The Philistines at the Parsonage")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/Untitled145"
    }
  }, [_vm._v("CHAPTER XLV Palace Blessings")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/Untitled146"
    }
  }, [_vm._v("CHAPTER XLVI Lady Lufton’s Request")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/Untitled147"
    }
  }, [_vm._v("CHAPTER XLVII Nemesis")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/Untitled148"
    }
  }, [_vm._v("CHAPTER XLVIII How They Were All Married, Had Two Children, and Lived Happy Ever After.")])]), _vm._v(" "), _c('div', {
    staticClass: "toc1"
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/cover",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Small House at Allington")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Book2/Untitled1"
    }
  }, [_vm._v("Title Page")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Book2/Untitled11"
    }
  }, [_vm._v("CHAPTER I THE SQUIRE OF ALLINGTON")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Book2/Untitled12"
    }
  }, [_vm._v("CHAPTER II THE TWO PEARLS OF ALLINGTON")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Book2/Untitled13"
    }
  }, [_vm._v("CHAPTER III THE WIDOW DALE OF ALLINGTON")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Book2/Untitled14"
    }
  }, [_vm._v("CHAPTER IV MRS. ROPER’S BOARDING-HOUSE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Book2/Untitled15"
    }
  }, [_vm._v("CHAPTER V ABOUT L. D.")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Book2/Untitled16"
    }
  }, [_vm._v("CHAPTER VI BEAUTIFUL DAYS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Book2/Untitled17"
    }
  }, [_vm._v("CHAPTER VII THE BEGINNING OF TROUBLES")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Book2/Untitled18"
    }
  }, [_vm._v("CHAPTER VIII IT CANNOT BE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Book2/Untitled19"
    }
  }, [_vm._v("CHAPTER IX MRS. DALE’S LITTLE PARTY")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Book2/Untitled110"
    }
  }, [_vm._v("CHAPTER X MRS. LUPEX AND AMELIA ROPER")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Book2/Untitled111"
    }
  }, [_vm._v("CHAPTER XI SOCIAL LIFE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Book2/Untitled112"
    }
  }, [_vm._v("CHAPTER XII LILIAN DALE BECOMES A BUTTERFLY")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Book2/Untitled113"
    }
  }, [_vm._v("CHAPTER XIII A VISIT TO GUESTWICK")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Book2/Untitled114"
    }
  }, [_vm._v("CHAPTER XIV JOHN EAMES TAKES A WALK")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Book2/Untitled115"
    }
  }, [_vm._v("CHAPTER XV THE LAST DAY")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Book2/Untitled116"
    }
  }, [_vm._v("CHAPTER XVI MR. CROSBIE MEETS AN OLD CLERGYMAN ON HIS WAY TO COURCY CASTLE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Book2/Untitled117"
    }
  }, [_vm._v("CHAPTER XVII COURCY CASTLE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Book2/Untitled118"
    }
  }, [_vm._v("CHAPTER XVIII LILY DALE’S FIRST LOVE-LETTER")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Book2/Untitled119"
    }
  }, [_vm._v("CHAPTER XIX THE SQUIRE MAKES A VISIT TO THE SMALL HOUSE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Book2/Untitled120"
    }
  }, [_vm._v("CHAPTER XX DR. CROFTS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Book2/Untitled121"
    }
  }, [_vm._v("CHAPTER XXI JOHN EAMES ENCOUNTERS TWO ADVENTURES, AND DISPLAYS GREAT COURAGE IN BOTH")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Book2/Untitled122"
    }
  }, [_vm._v("CHAPTER XXII LORD DE GUEST AT HOME")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Book2/Untitled123"
    }
  }, [_vm._v("CHAPTER XXIII MR. PLANTAGENET PALLISER")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Book2/Untitled124"
    }
  }, [_vm._v("CHAPTER XXIV A MOTHER-IN-LAW AND A FATHER-IN-LAW")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Book2/Untitled125"
    }
  }, [_vm._v("CHAPTER XXV ADOLPHUS CROSBIE SPENDS AN EVENING AT HIS CLUB")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Book2/Untitled126"
    }
  }, [_vm._v("CHAPTER XXVI LORD DE COURCY IN THE BOSOM OF HIS FAMILY")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Book2/Untitled127"
    }
  }, [_vm._v("CHAPTER XXVII “ON MY HONOUR, I DO NOT UNDERSTAND IT”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Book2/Untitled128"
    }
  }, [_vm._v("CHAPTER XXVIII THE BOARD")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Book2/Untitled129"
    }
  }, [_vm._v("CHAPTER XXIX JOHN EAMES RETURNS TO BURTON CRESCENT")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Book2/Untitled130"
    }
  }, [_vm._v("CHAPTER XXX IS IT FROM HIM?")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Book2/Untitled131"
    }
  }, [_vm._v("CHAPTER XXXI THE WOUNDED FAWN")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Book2/Untitled132"
    }
  }, [_vm._v("CHAPTER XXXII PAWKINS’S IN JERMYN STREET")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Book2/Untitled133"
    }
  }, [_vm._v("CHAPTER XXXIII “THE TIME WILL COME”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Book2/Untitled134"
    }
  }, [_vm._v("CHAPTER XXXIV THE COMBAT")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Book2/Untitled135"
    }
  }, [_vm._v("CHAPTER XXXV VÆ VICTIS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Book2/Untitled136"
    }
  }, [_vm._v("CHAPTER XXXVI “SEE, THE CONQUERING HERO COMES”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Book2/Untitled137"
    }
  }, [_vm._v("CHAPTER XXXVII AN OLD MAN’S COMPLAINT")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Book2/Untitled138"
    }
  }, [_vm._v("CHAPTER XXXVIII DOCTOR CROFTS IS CALLED IN")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Book2/Untitled139"
    }
  }, [_vm._v("CHAPTER XXXIX DR. CROFTS IS TURNED OUT")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Book2/Untitled140"
    }
  }, [_vm._v("CHAPTER XL PREPARATIONS FOR THE WEDDING")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Book2/Untitled141"
    }
  }, [_vm._v("CHAPTER XLI DOMESTIC TROUBLES")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Book2/Untitled142"
    }
  }, [_vm._v("CHAPTER XLII LILY’S BEDSIDE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Book2/Untitled143"
    }
  }, [_vm._v("CHAPTER XLIII FIE, FIE!")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Book2/Untitled144"
    }
  }, [_vm._v("CHAPTER XLIV VALENTINE’S DAY AT ALLINGTON")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Book2/Untitled145"
    }
  }, [_vm._v("CHAPTER XLV VALENTINE’S DAY IN LONDON")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Book2/Untitled146"
    }
  }, [_vm._v("CHAPTER XLVI JOHN EAMES AT HIS OFFICE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Book2/Untitled147"
    }
  }, [_vm._v("CHAPTER XLVII THE NEW PRIVATE SECRETARY")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Book2/Untitled148"
    }
  }, [_vm._v("CHAPTER XLVIII NEMESIS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Book2/Untitled149"
    }
  }, [_vm._v("CHAPTER XLIX PREPARATIONS FOR GOING")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Book2/Untitled150"
    }
  }, [_vm._v("CHAPTER L MRS. DALE IS THANKFUL FOR A GOOD THING")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Book2/Untitled151"
    }
  }, [_vm._v("CHAPTER LI JOHN EAMES DOES THINGS WHICH HE OUGHT NOT TO HAVE DONE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Book2/Untitled152"
    }
  }, [_vm._v("CHAPTER LII THE FIRST VISIT TO THE GUESTWICK BRIDGE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Book2/Untitled153"
    }
  }, [_vm._v("CHAPTER LIII LOQUITUR HOPKINS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Book2/Untitled154"
    }
  }, [_vm._v("CHAPTER LIV THE SECOND VISIT TO THE GUESTWICK BRIDGE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Book2/Untitled155"
    }
  }, [_vm._v("CHAPTER LV NOT VERY FIE FIE AFTER ALL")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Book2/Untitled156"
    }
  }, [_vm._v("CHAPTER LVI SHOWING HOW MR. CROSBIE BECAME AGAIN A HAPPY MAN")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Book2/Untitled157"
    }
  }, [_vm._v("CHAPTER LVII LILIAN DALE VANQUISHES HER MOTHER")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Book2/Untitled158"
    }
  }, [_vm._v("CHAPTER LVIII THE FATE OF THE SMALL HOUSE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Book2/Untitled159"
    }
  }, [_vm._v("CHAPTER LIX JOHN EAMES BECOMES A MAN")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Book2/Untitled160"
    }
  }, [_vm._v("CHAPTER LX CONCLUSION")])]), _vm._v(" "), _c('div', {
    staticClass: "toc1"
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/cover",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Last Chronicle of Barset")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Book3/Untitled1"
    }
  }, [_vm._v("Title Page")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Book3/Untitled11"
    }
  }, [_vm._v("CHAPTER I How Did He Get It?")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Book3/Untitled12"
    }
  }, [_vm._v("CHAPTER II By Heavens He Had Better Not!")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Book3/Untitled13"
    }
  }, [_vm._v("CHAPTER III The Archdeacon’s Threat")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Book3/Untitled14"
    }
  }, [_vm._v("CHAPTER IV The Clergyman’s House at Hogglestock")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Book3/Untitled15"
    }
  }, [_vm._v("CHAPTER V What the World Thought About It")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Book3/Untitled16"
    }
  }, [_vm._v("CHAPTER VI Grace Crawley")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Book3/Untitled17"
    }
  }, [_vm._v("CHAPTER VII Miss Prettyman’s Private Room")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Book3/Untitled18"
    }
  }, [_vm._v("CHAPTER VIII Mr. Crawley Is Taken to Silverbridge")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Book3/Untitled19"
    }
  }, [_vm._v("CHAPTER IX Grace Crawley Goes to Allington")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Book3/Untitled110"
    }
  }, [_vm._v("CHAPTER X Dinner at Framley Court")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Book3/Untitled111"
    }
  }, [_vm._v("CHAPTER XI The Bishop Sends His Inhibition")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Book3/Untitled112"
    }
  }, [_vm._v("CHAPTER XII Mr. Crawley Seeks for Sympathy")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Book3/Untitled113"
    }
  }, [_vm._v("CHAPTER XIII The Bishop’s Angel")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Book3/Untitled114"
    }
  }, [_vm._v("CHAPTER XIV Major Grantly Consults a Friend")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Book3/Untitled115"
    }
  }, [_vm._v("CHAPTER XV Up in London")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Book3/Untitled116"
    }
  }, [_vm._v("CHAPTER XVI Down at Allington")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Book3/Untitled117"
    }
  }, [_vm._v("CHAPTER XVII Mr. Crawley Is Summoned to Barchester")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Book3/Untitled118"
    }
  }, [_vm._v("CHAPTER XVIII The Bishop of Barchester Is Crushed")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Book3/Untitled119"
    }
  }, [_vm._v("CHAPTER XIX Where Did It Come From?")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Book3/Untitled120"
    }
  }, [_vm._v("CHAPTER XX What Mr. Walker Thought About It")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Book3/Untitled121"
    }
  }, [_vm._v("CHAPTER XXI Mr. Robarts on His Embassy")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Book3/Untitled122"
    }
  }, [_vm._v("CHAPTER XXII Major Grantly at Home")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Book3/Untitled123"
    }
  }, [_vm._v("CHAPTER XXIII Miss Lily Dale’s Resolution")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Book3/Untitled124"
    }
  }, [_vm._v("CHAPTER XXIV Mrs. Dobbs Broughton’s Dinner-Party")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Book3/Untitled125"
    }
  }, [_vm._v("CHAPTER XXV Miss Madalina Demolines")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Book3/Untitled126"
    }
  }, [_vm._v("CHAPTER XXVI The Picture")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Book3/Untitled127"
    }
  }, [_vm._v("CHAPTER XXVII A Hero at Home")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Book3/Untitled128"
    }
  }, [_vm._v("CHAPTER XXVIII Showing How Major Grantly Took a Walk")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Book3/Untitled129"
    }
  }, [_vm._v("CHAPTER XXIX Miss Lily Dale’s Logic")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Book3/Untitled130"
    }
  }, [_vm._v("CHAPTER XXX Showing What Major Grantly Did After His Walk")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Book3/Untitled131"
    }
  }, [_vm._v("CHAPTER XXXI Showing How Major Grantly Returned to Guestwick")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Book3/Untitled132"
    }
  }, [_vm._v("CHAPTER XXXII Mr. Toogood")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Book3/Untitled133"
    }
  }, [_vm._v("CHAPTER XXXIII The Plumstead Foxes")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Book3/Untitled134"
    }
  }, [_vm._v("CHAPTER XXXIV Mrs. Proudie Sends for Her Lawyer")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Book3/Untitled135"
    }
  }, [_vm._v("CHAPTER XXXV Lily Dale Writes Two Words in Her Book")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Book3/Untitled136"
    }
  }, [_vm._v("CHAPTER XXXVI Grace Crawley Returns Home")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Book3/Untitled137"
    }
  }, [_vm._v("CHAPTER XXXVII Hook Court")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Book3/Untitled138"
    }
  }, [_vm._v("CHAPTER XXXVIII Jael")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Book3/Untitled139"
    }
  }, [_vm._v("CHAPTER XXXIX A New Flirtation")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Book3/Untitled140"
    }
  }, [_vm._v("CHAPTER XL Mr. Toogood’s Ideas About Society")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Book3/Untitled141"
    }
  }, [_vm._v("CHAPTER XLI Grace Crawley at Home")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Book3/Untitled142"
    }
  }, [_vm._v("CHAPTER XLII Mr. Toogood Travels Professionally")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Book3/Untitled143"
    }
  }, [_vm._v("CHAPTER XLIII Mr. Crosbie Goes Into the City")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Book3/Untitled144"
    }
  }, [_vm._v("CHAPTER XLIV “I Suppose I Must Let You Have It”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Book3/Untitled145"
    }
  }, [_vm._v("CHAPTER XLV Lily Dale Goes to London")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Book3/Untitled146"
    }
  }, [_vm._v("CHAPTER XLVI The Bayswater Romance")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Book3/Untitled147"
    }
  }, [_vm._v("CHAPTER XLVII Dr. Tempest at the Palace")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Book3/Untitled148"
    }
  }, [_vm._v("CHAPTER XLVIII The Softness of Sir Raffle Buffle")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Book3/Untitled149"
    }
  }, [_vm._v("CHAPTER XLIX Near the Close")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Book3/Untitled150"
    }
  }, [_vm._v("CHAPTER L Lady Lufton’s Proposition")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Book3/Untitled151"
    }
  }, [_vm._v("CHAPTER LI Mrs. Dobbs Broughton Piles Her Fagots")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Book3/Untitled152"
    }
  }, [_vm._v("CHAPTER LII Why Don’t You Have an “It” for Yourself?")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Book3/Untitled153"
    }
  }, [_vm._v("CHAPTER LIII Rotten Row")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Book3/Untitled154"
    }
  }, [_vm._v("CHAPTER LIV The Clerical Commission")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Book3/Untitled155"
    }
  }, [_vm._v("CHAPTER LV Framley Parsonage")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Book3/Untitled156"
    }
  }, [_vm._v("CHAPTER LVI The Archdeacon Goes to Framley")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Book3/Untitled157"
    }
  }, [_vm._v("CHAPTER LVII A Double Pledge")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Book3/Untitled158"
    }
  }, [_vm._v("CHAPTER LVIII The Cross-Grainedness of Men")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Book3/Untitled159"
    }
  }, [_vm._v("CHAPTER LIX A Lady Presents Her Compliments to Miss L. D.")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Book3/Untitled160"
    }
  }, [_vm._v("CHAPTER LX The End of Jael and Sisera")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Book3/Untitled161"
    }
  }, [_vm._v("CHAPTER LXI “It’s Dogged as Does It”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Book3/Untitled162"
    }
  }, [_vm._v("CHAPTER LXII Mr. Crawley’s Letter to the Dean")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Book3/Untitled163"
    }
  }, [_vm._v("CHAPTER LXIII Two Visitors to Hogglestock")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Book3/Untitled164"
    }
  }, [_vm._v("CHAPTER LXIV The Tragedy in Hook Court")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Book3/Untitled165"
    }
  }, [_vm._v("CHAPTER LXV Miss Van Siever Makes Her Choice")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Book3/Untitled166"
    }
  }, [_vm._v("CHAPTER LXVI Requiescat in Pace")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Book3/Untitled167"
    }
  }, [_vm._v("CHAPTER LXVII In Memoriam")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Book3/Untitled168"
    }
  }, [_vm._v("CHAPTER LXVIII The Obstinacy of Mr. Crawley")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Book3/Untitled169"
    }
  }, [_vm._v("CHAPTER LXIX Mr. Crawley’s Last Appearance in His Own Pulpit")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Book3/Untitled170"
    }
  }, [_vm._v("CHAPTER LXX Mrs. Arabin Is Caught")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Book3/Untitled171"
    }
  }, [_vm._v("CHAPTER LXXI Mr. Toogood at Silverbridge")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Book3/Untitled172"
    }
  }, [_vm._v("CHAPTER LXXII Mr. Toogood at “The Dragon of Wantly”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Book3/Untitled173"
    }
  }, [_vm._v("CHAPTER LXXIII There Is Comfort at Plumstead")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Book3/Untitled174"
    }
  }, [_vm._v("CHAPTER LXXIV The Crawleys Are Informed")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Book3/Untitled175"
    }
  }, [_vm._v("CHAPTER LXXV Madalina’s Heart Is Bleeding")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Book3/Untitled176"
    }
  }, [_vm._v("CHAPTER LXXVI I Think He Is Light of Heart")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Book3/Untitled177"
    }
  }, [_vm._v("CHAPTER LXXVII The Shattered Tree")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Book3/Untitled178"
    }
  }, [_vm._v("CHAPTER LXXVIII The Arabins Return to Barchester")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Book3/Untitled179"
    }
  }, [_vm._v("CHAPTER LXXIX Mr. Crawley Speaks of His Coat")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Book3/Untitled180"
    }
  }, [_vm._v("CHAPTER LXXX Miss Demolines Desires to Become a Finger-Post")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Book3/Untitled181"
    }
  }, [_vm._v("CHAPTER LXXXI Barchester Cloisters")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Book3/Untitled182"
    }
  }, [_vm._v("CHAPTER LXXXII The Last Scene at Hogglestock")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Book3/Untitled183"
    }
  }, [_vm._v("CHAPTER LXXXIII Mr. Crawley Is Conquered")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Book3/Untitled184"
    }
  }, [_vm._v("CHAPTER LXXXIV Conclusion")])])])])
}]}

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(68),
  /* template */
  __webpack_require__(69),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 69 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "epub:type": "cover"
    }
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "Trollope_FramleyParsonagecover.jpg",
      "src": "Book1/image/Trollope_FramleyParsonagecover.jpg"
    }
  })])])])
}]}

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(71),
  /* template */
  __webpack_require__(72),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 71 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 72 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer000"
    }
  }, [_c('p', {
    staticClass: "bk-title"
  }, [_vm._v("Framley Parsonage")]), _vm._v(" "), _c('p', {
    staticClass: "authorname"
  }, [_vm._v("Anthony Trollope")]), _vm._v(" "), _c('p', {
    staticClass: "publisher"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "Book1/image/logo.jpg"
    }
  })])])])])
}]}

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(74),
  /* template */
  __webpack_require__(75),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 74 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 75 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('p', {
    staticClass: "ORIM-Chapter-Title-Page-Break"
  }, [_vm._v("CHAPTER I")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Chapter-Subtitle"
  }, [_vm._v("“Omnes Omnia Bona Dicere”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Chapter-Opener-Paragraph"
  }, [_vm._v("When young Mark Robarts was leaving college, his father might well declare that all men began to say all good things to him, and to extol his fortune in that he had a son blessed with so excellent a disposition.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("This father was a physician living at Exeter. He was a gentleman possessed of no private means, but enjoying a lucrative practice, which had enabled him to maintain and educate a family with all the advantages which money can give in this country. Mark was his eldest son and second child; and the first page or two of this narrative must be consumed in giving a catalogue of the good things which chance and conduct together had heaped upon this young man’s head.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("His first step forward in life had arisen from his having been sent, while still very young, as a private pupil to the house of a clergyman, who was an old friend and intimate friend of his father’s. This clergyman had one other, and only one other, pupil—the young Lord Lufton; and between the two boys, there had sprung up a close alliance.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("While they were both so placed, Lady Lufton had visited her son, and then invited young Robarts to pass his next holidays at Framley Court. This visit was made; and it ended in Mark going back to Exeter with a letter full of praise from the widowed peeress. She had been delighted, she said, in having such a companion for her son, and expressed a hope that the boys might remain together during the course of their education. Dr. Robarts was a man who thought much of the breath of peers and peeresses, and was by no means inclined to throw away any advantage which might arise to his child from such a friendship. When, therefore, the young lord was sent to Harrow, Mark Robarts went there also.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("That the lord and his friend often quarrelled, and occasionally fought,—the fact even that for one period of three months they never spoke to each other—by no means interfered with the doctor’s hopes. Mark again and again stayed a fortnight at Framley Court, and Lady Lufton always wrote about him in the highest terms.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("And then the lads went together to Oxford, and here Mark’s good fortune followed him, consisting rather in the highly respectable manner in which he lived, than in any wonderful career of collegiate success. His family was proud of him, and the doctor was always ready to talk of him to his patients; not because he was a prizeman, and had gotten medals and scholarships, but on account of the excellence of his general conduct. He lived with the best set—he incurred no debts—he was fond of society, but able to avoid low society—liked his glass of wine, but was never known to be drunk; and, above all things, was one of the most popular men in the university.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("Then came the question of a profession for this young Hyperion, and on this subject, Dr. Robarts was invited himself to go over to Framley Court to discuss the matter with Lady Lufton. Dr. Robarts returned with a very strong conception that the Church was the profession best suited to his son.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("Lady Lufton had not sent for Dr. Robarts all the way from Exeter for nothing. The living of Framley was in the gift of the Lufton family, and the next presentation would be in Lady Lufton’s hands, if it should fall vacant before the young lord was twenty-five years of age, and in the young lord’s hands if it should fall afterwards. But the mother and the heir consented to give a joint promise to Dr. Robarts. Now, as the present incumbent was over seventy, and as the living was worth £900 a year, there could be no doubt as to the eligibility of the clerical profession.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("And I must further say, that the dowager and the doctor were justified in their choice by the life and principles of the young man—as far as any father can be justified in choosing such a profession for his son, and as far as any lay impropriator can be justified in making such a promise. Had Lady Lufton had a second son, that second son would probably have had the living, and no one would have thought it wrong;—certainly not if that second son had been such a one as Mark Robarts.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("Lady Lufton herself was a woman who thought much on religious matters, and would by no means have been disposed to place any one in a living, merely because such a one had been her son’s friend. Her tendencies were High Church, and she was enabled to perceive that those of young Mark Robarts ran in the same direction. She was very desirous that her son should make an associate of his clergyman, and by this step she would insure, at any rate, that. She was anxious that the parish vicar should be one with whom she could herself fully co-operate, and was perhaps unconsciously wishful that he might in some measure be subject to her influence. Should she appoint an elder man, this might probably not be the case to the same extent; and should her son have the gift, it might probably not be the case at all. And therefore it was resolved that the living should be given to young Robarts.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("He took his degree—not with any brilliancy, but quite in the manner that his father desired; he then travelled for eight or ten months with Lord Lufton and a college don, and almost immediately after his return home was ordained.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("The living of Framley is in the diocese of Barchester; and, seeing what were Mark’s hopes with reference to that diocese, it was by no means difficult to get him a curacy within it. But this curacy he was not allowed long to fill. He had not been in it above a twelvemonth, when poor old Dr. Stopford, the then vicar of Framley, was gathered to his fathers, and the full fruition of his rich hopes fell upon his shoulders.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("But even yet more must be told of his good fortune before we can come to the actual incidents of our story. Lady Lufton, who, as I have said, thought much of clerical matters, did not carry her High Church principles so far as to advocate celibacy for the clergy. On the contrary, she had an idea that a man could not be a good parish parson without a wife. So, having given to her favourite a position in the world, and an income sufficient for a gentleman’s wants, she set herself to work to find him a partner in those blessings.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("And here also, as in other matters, he fell in with the views of his patroness—not, however, that they were declared to him in that marked manner in which the affair of the living had been broached. Lady Lufton was much too highly gifted with woman’s craft for that. She never told the young vicar that Miss Monsell accompanied her ladyship’s married daughter to Framley Court expressly that he, Mark, might fall in love with her; but such was in truth the case.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("Lady Lufton had but two children. The eldest, a daughter, had been married some four or five years to Sir George Meredith, and this Miss Monsell was a dear friend of hers. And now looms before me the novelist’s great difficulty. Miss Monsell,—or, rather, Mrs. Mark Robarts,—must be described. As Miss Monsell, our tale will have to take no prolonged note of her. And yet we will call her Fanny Monsell, when we declare that she was one of the pleasantest companions that could be brought near to a man, as the future partner of his home, and owner of his heart. And if high principles without asperity, female gentleness without weakness, a love of laughter without malice, and a true loving heart, can qualify a woman to be a parson’s wife, then was Fanny Monsell qualified to fill that station.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("In person she was somewhat larger than common. Her face would have been beautiful but that her mouth was large. Her hair, which was copious, was of a bright brown; her eyes also were brown, and, being so, were the distinctive feature of her face, for brown eyes are not common. They were liquid, large, and full either of tenderness or of mirth. Mark Robarts still had his accustomed luck, when such a girl as this was brought to Framley for his wooing.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("And he did woo her—and won her. For Mark himself was a handsome fellow. At this time the vicar was about twenty-five years of age, and the future Mrs. Robarts was two or three years younger. Nor did she come quite empty-handed to the vicarage. It cannot be said that Fanny Monsell was an heiress, but she had been left with a provision of some few thousand pounds. This was so settled, that the interest of his wife’s money paid the heavy insurance on his life which young Robarts effected, and there was left to him, over and above, sufficient to furnish his parsonage in the very best style of clerical comfort,—and to start him on the road of life rejoicing.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("So much did Lady Lufton do for her "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("protégé")]), _vm._v(", and it may well be imagined that the Devonshire physician, sitting meditative over his parlour fire, looking back, as men will look back on the upshot of their life, was well contented with that upshot, as regarded his eldest offshoot, the Rev. Mark Robarts, the vicar of Framley.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("But little has as yet been said, personally, as to our hero himself, and perhaps it may not be necessary to say much. Let us hope that by degrees he may come forth upon the canvas, showing to the beholder the nature of the man inwardly and outwardly. Here it may suffice to say that he was no born heaven’s cherub, neither was he a born fallen devil’s spirit. Such as his training made him, such he was. He had large capabilities for good—and aptitudes also for evil, quite enough: quite enough to make it needful that he should repel temptation as temptation only can be repelled. Much had been done to spoil him, but in the ordinary acceptation of the word he was not spoiled. He had too much tact, too much common sense, to believe himself to be the paragon which his mother thought him. Self-conceit was not, perhaps, his greatest danger. Had he possessed more of it, he might have been a less agreeable man, but his course before him might on that account have been the safer.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("In person he was manly, tall, and fair-haired, with a square forehead, denoting intelligence rather than thought, with clear white hands, filbert nails, and a power of dressing himself in such a manner that no one should ever observe of him that his clothes were either good or bad, shabby or smart.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("Such was Mark Robarts when at the age of twenty-five, or a little more, he married Fanny Monsell. The marriage was celebrated in his own church, for Miss Monsell had no home of her own, and had been staying for the last three months at Framley Court. She was given away by Sir George Meredith, and Lady Lufton herself saw that the wedding was what it should be, with almost as much care as she had bestowed on that of her own daughter. The deed of marrying, the absolute tying of the knot, was performed by the Very Reverend the Dean of Barchester, an esteemed friend of Lady Lufton’s. And Mrs. Arabin, the dean’s wife, was of the party, though the distance from Barchester to Framley is long, and the roads deep, and no railway lends its assistance. And Lord Lufton was there of course; and people protested that he would surely fall in love with one of the four beautiful bridesmaids, of whom Blanche Robarts, the vicar’s second sister, was by common acknowledgment by far the most beautiful.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("And there was there another and a younger sister of Mark’s—who did not officiate at the ceremony, though she was present—and of whom no prediction was made, seeing that she was then only sixteen, but of whom mention is made here, as it will come to pass that my readers will know her hereafter. Her name was Lucy Robarts.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("And then the vicar and his wife went off on their wedding tour, the old curate taking care of the Framley souls the while.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("And in due time they returned; and after a further interval, in due course, a child was born to them; and then another; and after that came the period at which we will begin our story. But before doing so, may I not assert that all men were right in saying all manner of good things to the Devonshire physician, and in praising his luck in having such a son?")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“You were up at the house to-day, I suppose?” said Mark to his wife, as he sat stretching himself in an easy-chair in the drawing-room, before the fire, previously to his dressing for dinner. It was a November evening, and he had been out all day, and on such occasions the aptitude for delay in dressing is very powerful. A strong-minded man goes direct from the hall-door to his chamber without encountering the temptation of the drawing-room fire.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“No; but Lady Lufton was down here.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Full of arguments in favour of Sarah Thompson?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Exactly so, Mark.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“And what did you say about Sarah Thompson?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Very little as coming from myself; but I did hint that you thought, or that I thought that you thought, that one of the regular trained schoolmistresses would be better.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“But her ladyship did not agree?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Well, I won’t exactly say that;—though I think that perhaps she did not.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“I am sure she did not. When she has a point to carry, she is very fond of carrying it.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“But then, Mark, her points are generally so good.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“But, you see, in this affair of the school she is thinking more of her "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("protégée")]), _vm._v(" than she does of the children.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Tell her that, and I am sure she will give way.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("And then again they were both silent. And the vicar having thoroughly warmed himself, as far as this might be done by facing the fire, turned round and began the operation "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("à tergo")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Come, Mark, it is twenty minutes past six. Will you go and dress?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“I’ll tell you what, Fanny: she must have her way about Sarah Thompson. You can see her to-morrow and tell her so.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“I am sure, Mark, I would not give way, if I thought it wrong. Nor would she expect it.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“If I persist this time, I shall certainly have to yield the next; and then the next may probably be more important.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“But if it’s wrong, Mark?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“I didn’t say it was wrong. Besides, if it is wrong, wrong in some infinitesimal degree, one must put up with it. Sarah Thompson is very respectable; the only question is whether she can teach.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("The young wife, though she did not say so, had some idea that her husband was in error. It is true that one must put up with wrong, with a great deal of wrong. But no one need put up with wrong that he can remedy. Why should he, the vicar, consent to receive an incompetent teacher for the parish children, when he was able to procure one that was competent? In such a case,—so thought Mrs. Robarts to herself,—she would have fought the matter out with Lady Lufton.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("On the next morning, however, she did as she was bid, and signified to the dowager that all objection to Sarah Thompson would be withdrawn.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Ah! I was sure he would agree with me,” said her ladyship, “when he learned what sort of person she is. I know I had only to explain;”—and then she plumed her feathers, and was very gracious; for, to tell the truth, Lady Lufton did not like to be opposed in things which concerned the parish nearly.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“And, Fanny,” said Lady Lufton, in her kindest manner, “you are not going anywhere on Saturday, are you?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“No, I think not.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Then you must come to us. Justinia is to be here, you know”—Lady Meredith was named Justinia—“and you and Mr. Robarts had better stay with us till Monday. He can have the little book-room all to himself on Sunday. The Merediths go on Monday; and Justinia won’t be happy if you are not with her.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("It would be unjust to say that Lady Lufton had determined not to invite the Robartses if she were not allowed to have her own way about Sarah Thompson. But such would have been the result. As it was, however, she was all kindness; and when Mrs. Robarts made some little excuse, saying that she was afraid she must return home in the evening, because of the children, Lady Lufton declared that there was room enough at Framley Court for baby and nurse, and so settled the matter in her own way, with a couple of nods and three taps of her umbrella.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("This was on a Tuesday morning, and on the same evening, before dinner, the vicar again seated himself in the same chair before the drawing-room fire, as soon as he had seen his horse led into the stable.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Mark,” said his wife, “the Merediths are to be at Framley on Saturday and Sunday; and I have promised that we will go up and stay over till Monday.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“You don’t mean it! Goodness gracious, how provoking!”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Why? I thought you wouldn’t mind it. And Justinia would think it unkind if I were not there.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“You can go, my dear, and of course will go. But as for me, it is impossible.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“But why, love?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Why? Just now, at the school-house, I answered a letter that was brought to me from Chaldicotes. Sowerby insists on my going over there for a week or so; and I have said that I would.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Go to Chaldicotes for a week, Mark?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“I believe I have even consented to ten days.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“And be away two Sundays?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“No, Fanny, only one. Don’t be so censorious.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Don’t call me censorious, Mark; you know I am not so. But I am so sorry. It is just what Lady Lufton won’t like. Besides, you were away in Scotland two Sundays last month.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“In September, Fanny. And that is being censorious.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Oh, but, Mark, dear Mark; don’t say so. You know I don’t mean it. But Lady Lufton does not like those Chaldicotes people. You know Lord Lufton was with you the last time you were there; and how annoyed she was!”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Lord Lufton won’t be with me now, for he is still in Scotland. And the reason why I am going is this: Harold Smith and his wife will be there, and I am very anxious to know more of them. I have no doubt that Harold Smith will be in the government some day, and I cannot afford to neglect such a man’s acquaintance.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“But, Mark, what do you want of any government?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Well, Fanny, of course I am bound to say that I want nothing; neither in one sense do I; but nevertheless, I shall go and meet the Harold Smiths.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Could you not be back before Sunday?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“I have promised to preach at Chaldicotes. Harold Smith is going to lecture at Barchester, about the Australasian archipelago, and I am to preach a charity sermon on the same subject. They want to send out more missionaries.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“A charity sermon at Chaldicotes!”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“And why not? The house will be quite full, you know; and I daresay the Arabins will be there.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“I think not; Mrs. Arabin may get on with Mrs. Harold Smith, though I doubt that; but I’m sure she’s not fond of Mrs. Smith’s brother. I don’t think she would stay at Chaldicotes.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“And the bishop will probably be there for a day or two.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“That is much more likely, Mark. If the pleasure of meeting Mrs. Proudie is taking you to Chaldicotes, I have not a word more to say.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“I am not a bit more fond of Mrs. Proudie than you are, Fanny,” said the vicar, with something like vexation in the tone of his voice, for he thought that his wife was hard upon him. “But it is generally thought that a parish clergyman does well to meet his bishop now and then. And as I was invited there, especially to preach while all these people are staying at the place, I could not well refuse.” And then he got up, and taking his candlestick, escaped to his dressing-room.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“But what am I to say to Lady Lufton?” his wife said to him, in the course of the evening.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Just write her a note, and tell her that you find I had promised to preach at Chaldicotes next Sunday. You’ll go, of course?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Yes, but I know she’ll be annoyed. You were away the last time she had people there.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“It can’t be helped. She must put it down against Sarah Thompson. She ought not to expect to win always.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“I should not have minded it, if she had lost, as you call it, about Sarah Thompson. That was a case in which you ought to have had your own way.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“And this other is a case in which I shall have it. It’s a pity that there should be such a difference; isn’t it?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("Then the wife perceived that, vexed as she was, it would be better that she should say nothing further; and before she went to bed, she wrote the note to Lady Lufton, as her husband recommended.")])])])])
}]}

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(77),
  /* template */
  __webpack_require__(78),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 77 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 78 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('p', {
    staticClass: "ORIM-Chapter-Title-Page-Break"
  }, [_vm._v("CHAPTER II")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Chapter-Subtitle"
  }, [_vm._v("The Framley Set, and the Chaldicotes Set")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Chapter-Opener-Paragraph"
  }, [_vm._v("It will be necessary that I should say a word or two of some of the people named in the few preceding pages, and also of the localities in which they lived.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("Of Lady Lufton herself enough, perhaps, has been written to introduce her to my readers. The Framley property belonged to her son; but as Lufton Park—an ancient ramshackle place in another county—had heretofore been the family residence of the Lufton family, Framley Court had been apportioned to her for her residence for life. Lord Lufton himself was still unmarried; and as he had no establishment at Lufton Park—which indeed had not been inhabited since his grandfather died—he lived with his mother when it suited him to live anywhere in that neighbourhood. The widow would fain have seen more of him than he allowed her to do. He had a shooting-lodge in Scotland, and apartments in London, and a string of horses in Leicestershire—much to the disgust of the county gentry around him, who held that their own hunting was as good as any that England could afford. His lordship, however, paid his subscription to the East Barsetshire pack, and then thought himself at liberty to follow his own pleasure as to his own amusement.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("Framley itself was a pleasant country place, having about it nothing of seignorial dignity or grandeur, but possessing everything necessary for the comfort of country life. The house was a low building of two stories, built at different periods, and devoid of all pretensions to any style of architecture; but the rooms, though not lofty, were warm and comfortable, and the gardens were trim and neat beyond all others in the county. Indeed, it was for its gardens only that Framley Court was celebrated.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("Village there was none, properly speaking. The high road went winding about through the Framley paddocks, shrubberies, and wood-skirted home fields, for a mile and a half, not two hundred yards of which ran in a straight line; and there was a cross-road which passed down through the domain, whereby there came to be a locality called Framley Cross. Here stood the “Lufton Arms,” and here, at Framley Cross, the hounds occasionally would meet; for the Framley woods were drawn in spite of the young lord’s truant disposition; and then, at the Cross also, lived the shoemaker, who kept the post-office.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("Framley church was distant from this just a quarter of a mile, and stood immediately opposite to the chief entrance to Framley Court. It was but a mean, ugly building, having been erected about a hundred years since, when all churches then built were made to be mean and ugly; nor was it large enough for the congregation, some of whom were thus driven to the dissenting chapels, the Sions and Ebenezers, which had got themselves established on each side of the parish, in putting down which Lady Lufton thought that her pet parson was hardly as energetic as he might be. It was, therefore, a matter near to Lady Lufton’s heart to see a new church built, and she was urgent in her eloquence, both with her son and with the vicar, to have this good work commenced.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("Beyond the church, but close to it, were the boys’ school and girls’ school, two distinct buildings, which owed their erection to Lady Lufton’s energy; then came a neat little grocer’s shop, the neat grocer being the clerk and sexton, and the neat grocer’s wife, the pew-opener in the church. Podgens was their name, and they were great favourites with her ladyship, both having been servants up at the house.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("And here the road took a sudden turn to the left, turning, as it were, away from Framley Court; and just beyond the turn was the vicarage, so that there was a little garden path running from the back of the vicarage grounds into the churchyard, cutting the Podgenses off into an isolated corner of their own;—from whence, to tell the truth, the vicar would have been glad to banish them and their cabbages, could he have had the power to do so. For has not the small vineyard of Naboth been always an eyesore to neighbouring potentates?")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("The potentate in this case had as little excuse as Ahab, for nothing in the parsonage way could be more perfect than his parsonage. It had all the details requisite for the house of a moderate gentleman with moderate means, and none of those expensive superfluities which immoderate gentlemen demand, or which themselves demand—immoderate means. And then the gardens and paddocks were exactly suited to it; and everything was in good order;—not exactly new, so as to be raw and uncovered, and redolent of workmen; but just at that era of their existence in which newness gives way to comfortable homeliness.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("Other village at Framley there was none. At the back of the Court, up one of those cross-roads, there was another small shop or two, and there was a very neat cottage residence, in which lived the widow of a former curate, another "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("protégé")]), _vm._v(" of Lady Lufton’s; and there was a big, staring brick house, in which the present curate lived; but this was a full mile distant from the church, and farther from Framley Court, standing on that cross-road which runs from Framley Cross in a direction away from the mansion. This gentleman, the Rev. Evan Jones, might, from his age, have been the vicar’s father; but he had been for many years curate of Framley; and though he was personally disliked by Lady Lufton, as being Low Church in his principles, and unsightly in his appearance, nevertheless, she would not urge his removal. He had two or three pupils in that large brick house, and if turned out from these and from his curacy, might find it difficult to establish himself elsewhere. On this account mercy was extended to the Rev. E. Jones, and, in spite of his red face and awkward big feet, he was invited to dine at Framley Court, with his plain daughter, once in every three months.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("Over and above these, there was hardly a house in the parish of Framley, outside the bounds of Framley Court, except those of farmers and farm labourers; and yet the parish was of large extent.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("Framley is in the eastern division of the county of Barsetshire, which, as all the world knows, is, politically speaking, as true blue a county as any in England. There have been backslidings even here, it is true; but then, in what county have there not been such backslidings? Where, in these pinchbeck days, can we hope to find the old agricultural virtue in all its purity? But, among those backsliders, I regret to say, that men now reckon Lord Lufton. Not that he is a violent Whig, or perhaps that he is a Whig at all. But he jeers and sneers at the old county doings; declares, when solicited on the subject, that, as far as he is concerned, Mr. Bright may sit for the county, if he pleases; and alleges, that being unfortunately a peer, he has no right even to interest himself in the question. All this is deeply regretted, for, in the old days, there was no portion of the county more decidedly true blue than that Framley district; and, indeed, up to the present day, the dowager is able to give an occasional helping hand.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("Chaldicotes is the seat of Nathaniel Sowerby, Esq., who, at the moment supposed to be now present, is one of the members for the Western Division of Barsetshire. But this Western Division can boast none of the fine political attributes which grace its twin brother. It is decidedly Whig, and is almost governed in its politics by one or two great Whig families.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("It has been said that Mark Robarts was about to pay a visit to Chaldicotes, and it has been hinted that his wife would have been as well pleased had this not been the case. Such was certainly the fact; for she, dear, prudent, excellent wife as she was, knew that Mr. Sowerby was not the most eligible friend in the world for a young clergyman, and knew, also, that there was but one other house in the whole county the name of which was so distasteful to Lady Lufton. The reasons for this were, I may say, manifold. In the first place, Mr. Sowerby was a Whig, and was seated in Parliament mainly by the interest of that great Whig autocrat the Duke of Omnium, whose residence was more dangerous even than that of Mr. Sowerby, and whom Lady Lufton regarded as an impersonation of Lucifer upon earth. Mr. Sowerby, too, was unmarried—as indeed, also, was Lord Lufton, much to his mother’s grief. Mr. Sowerby, it is true, was fifty, whereas the young lord was as yet only twenty-six, but, nevertheless, her ladyship was becoming anxious on the subject. In her mind, every man was bound to marry as soon as he could maintain a wife; and she held an idea—a quite private tenet, of which she was herself but imperfectly conscious—that men in general were inclined to neglect this duty for their own selfish gratifications, that the wicked ones encouraged the more innocent in this neglect, and that many would not marry at all, were not an unseen coercion exercised against them by the other sex. The Duke of Omnium was the very head of all such sinners, and Lady Lufton greatly feared that her son might be made subject to the baneful Omnium influence, by means of Mr. Sowerby and Chaldicotes.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("And then Mr. Sowerby was known to be a very poor man, with a very large estate. He had wasted, men said, much on electioneering, and more in gambling. A considerable portion of his property had already gone into the hands of the duke, who, as a rule, bought up everything around him that was to be purchased. Indeed it was said of him by his enemies, that so covetous was he of Barsetshire property, that he would lead a young neighbour on to his ruin, in order that he might get his land. What—oh! what if he should come to be possessed in this way of any of the fair acres of Framley Court? What if he should become possessed of them all? It can hardly be wondered at that Lady Lufton should not like Chaldicotes.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("The Chaldicotes set, as Lady Lufton called them, were in every way opposed to what a set should be according to her ideas. She liked cheerful, quiet, well-to-do people, who loved their Church, their country, and their Queen, and who were not too anxious to make a noise in the world. She desired that all the farmers round her should be able to pay their rents without trouble, that all the old women should have warm flannel petticoats, that the working men should be saved from rheumatism by healthy food and dry houses, that they should all be obedient to their pastors and masters—temporal as well as spiritual. That was her idea of loving her country. She desired also that the copses should be full of pheasants, the stubble-field of partridges, and the gorse covers of foxes;—in that way, also, she loved her country. She had ardently longed, during that Crimean war, that the Russians might be beaten—but not by the French, to the exclusion of the English, as had seemed to her to be too much the case; and hardly by the English under the dictatorship of Lord Palmerston. Indeed, she had had but little faith in that war after Lord Aberdeen had been expelled. If, indeed, Lord Derby could have come in!")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("But now as to this Chaldicotes set. After all, there was nothing so very dangerous about them; for it was in London, not in the country, that Mr. Sowerby indulged, if he did indulge, his bachelor mal-practices. Speaking of them as a set, the chief offender was Mr. Harold Smith, or perhaps his wife. He also was a member of Parliament, and, as many thought, a rising man. His father had been for many years a debater in the House, and had held high office. Harold, in early life, had intended himself for the cabinet; and if working hard at his trade could ensure success, he ought to obtain it sooner or later. He had already filled more than one subordinate station, had been at the Treasury, and for a month or two at the Admiralty, astonishing official mankind by his diligence. Those last-named few months had been under Lord Aberdeen, with whom he had been forced to retire. He was a younger son, and not possessed of any large fortune. Politics as a profession was therefore of importance to him. He had in early life married a sister of Mr. Sowerby; and as the lady was some six or seven years older than himself, and had brought with her but a scanty dowry, people thought that in this matter Mr. Harold Smith had not been perspicacious. Mr. Harold Smith was not personally a popular man with any party, though some judged him to be eminently useful. He was laborious, well-informed, and, on the whole, honest; but he was conceited, long-winded, and pompous.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("Mrs. Harold Smith was the very opposite of her lord. She was a clever, bright woman, good-looking for her time of life—and she was now over forty—with a keen sense of the value of all worldly things, and a keen relish for all the world’s pleasures. She was neither laborious, nor well-informed, nor perhaps altogether honest—what woman ever understood the necessity or recognized the advantage of political honesty?—but then she was neither dull nor pompous, and if she was conceited, she did not show it. She was a disappointed woman, as regards her husband; seeing that she had married him on the speculation that he would at once become politically important; and as yet Mr. Smith had not quite fulfilled the prophecies of his early life.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("And Lady Lufton, when she spoke of the Chaldicotes set, distinctly included, in her own mind, the Bishop of Barchester, and his wife and daughter. Seeing that Bishop Proudie was, of course, a man much addicted to religion and to religious thinking, and that Mr. Sowerby himself had no peculiar religious sentiments whatever, there would not at first sight appear to be ground for much intercourse, and perhaps there was not much of such intercourse; but Mrs. Proudie and Mrs. Harold Smith were firm friends of four or five years’ standing—ever since the Proudies came into the diocese; and therefore the bishop was usually taken to Chaldicotes whenever Mrs. Smith paid her brother a visit. Now Bishop Proudie was by no means a High Church dignitary, and Lady Lufton had never forgiven him for coming into that diocese. She had, instinctively, a high respect for the episcopal office; but of Bishop Proudie himself she hardly thought better than she did of Mr. Sowerby, or of that fabricator of evil, the Duke of Omnium. Whenever Mr. Robarts would plead that in going anywhere he would have the benefit of meeting the bishop, Lady Lufton would slightly curl her upper lip. She could not say in words, that Bishop Proudie—bishop as he certainly must be called—was no better than he ought to be; but by that curl of her lip she did explain to those who knew her that such was the inner feeling of her heart.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("And then it was understood—Mark Robarts, at least, had so heard, and the information soon reached Framley Court—that Mr. Supplehouse was to make one of the Chaldicotes party. Now Mr. Supplehouse was a worse companion for a gentlemanlike, young, High Church, conservative county parson than even Harold Smith. He also was in Parliament, and had been extolled during the early days of that Russian war by some portion of the metropolitan daily press, as the only man who could save the country. Let him be in the ministry, the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Jupiter")]), _vm._v(" had said, and there would be some hope of reform, some chance that England’s ancient glory would not be allowed in these perilous times to go headlong to oblivion. And upon this the ministry, not anticipating much salvation from Mr. Supplehouse, but willing, as they usually are, to have the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Jupiter")]), _vm._v(" at their back, did send for that gentleman, and gave him some footing among them. But how can a man born to save a nation, and to lead a people, be content to fill the chair of an under-secretary? Supplehouse was not content, and soon gave it to be understood that his place was much higher than any yet tendered to him. The seals of high office, or war to the knife, was the alternative which he offered to a much-belaboured Head of Affairs—nothing doubting that the Head of Affairs would recognize the claimant’s value, and would have before his eyes a wholesome fear of the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Jupiter")]), _vm._v(". But the Head of Affairs, much belaboured as he was, knew that he might pay too high even for Mr. Supplehouse and the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Jupiter")]), _vm._v("; and the saviour of the nation was told that he might swing his tomahawk. Since that time he had been swinging his tomahawk, but not with so much effect as had been anticipated. He also was very intimate with Mr. Sowerby, and was decidedly one of the Chaldicotes set.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("And there were many others included in the stigma whose sins were political or religious rather than moral. But they were gall and wormwood to Lady Lufton, who regarded them as children of the Lost One, and who grieved with a mother’s grief when she knew that her son was among them, and felt all a patron’s anger when she heard that her clerical "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("protégé")]), _vm._v(" was about to seek such society. Mrs. Robarts might well say that Lady Lufton would be annoyed.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“You won’t call at the house before you go, will you?” the wife asked on the following morning. He was to start after lunch on that day, driving himself in his own gig, so as to reach Chaldicotes, some twenty-four miles distant, before dinner.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“No, I think not. What good should I do?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Well, I can’t explain; but I think I should call: partly, perhaps, to show her that as I had determined to go, I was not afraid of telling her so.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Afraid! That’s nonsense, Fanny. I’m not afraid of her. But I don’t see why I should bring down upon myself the disagreeable things she will say. Besides, I have not time. I must walk up and see Jones about the duties; and then, what with getting ready, I shall have enough to do to get off in time.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("He paid his visit to Mr. Jones, the curate, feeling no qualms of conscience there, as he rather boasted of all the members of Parliament he was going to meet, and of the bishop who would be with them. Mr. Evan Jones was only his curate, and in speaking to him on the matter he could talk as though it were quite the proper thing for a vicar to meet his bishop at the house of a county member. And one would be inclined to say that it was proper;—only why could he not talk of it in the same tone to Lady Lufton? And then, having kissed his wife and children, he drove off, well pleased with his prospect for the coming ten days, but already anticipating some discomfort on his return.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("On the three following days, Mrs. Robarts did not meet her ladyship. She did not exactly take any steps to avoid such a meeting, but she did not purposely go up to the big house. She went to her school as usual, and made one or two calls among the farmers’ wives, but put no foot within the Framley Court grounds. She was braver than her husband, but even she did not wish to anticipate the evil day.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("On the Saturday, just before it began to get dusk, when she was thinking of preparing for the fatal plunge, her friend, Lady Meredith, came to her.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“So, Fanny, we shall again be so unfortunate as to miss Mr. Robarts,” said her ladyship.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Yes. Did you ever know anything so unlucky? But he had promised Mr. Sowerby before he heard that you were coming. Pray do not think that he would have gone away had he known it.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“We should have been sorry to keep him from so much more amusing a party.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Now, Justinia, you are unfair. You intend to imply that he has gone to Chaldicotes, because he likes it better than Framley Court; but that is not the case. I hope Lady Lufton does not think that it is.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("Lady Meredith laughed as she put her arm round her friend’s waist. “Don’t lose your eloquence in defending him to me,” she said. “You’ll want all that for my mother.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“But is your mother angry?” asked Mrs. Robarts, showing by her countenance, how eager she was for true tidings on the subject.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Well, Fanny, you know her ladyship as well as I do. She thinks so very highly of the vicar of Framley, that she does begrudge him to those politicians at Chaldicotes.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“But, Justinia, the bishop is to be there, you know.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“I don’t think that that consideration will at all reconcile my mother to the gentleman’s absence. He ought to be very proud, I know, to find that he is so much thought of. But come, Fanny, I want you to walk back with me, and you can dress at the house. And now we’ll go and look at the children.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("After that, as they walked together to Framley Court, Mrs. Robarts made her friend promise that she would stand by her if any serious attack were made on the absent clergyman.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Are you going up to your room at once?” said the vicar’s wife, as soon as they were inside the porch leading into the hall. Lady Meredith immediately knew what her friend meant, and decided that the evil day should not be postponed. “We had better go in and have it over,” she said, “and then we shall be comfortable for the evening.” So the drawing-room door was opened, and there was Lady Lufton alone upon the sofa.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Now, mamma,” said the daughter, “you mustn’t scold Fanny much about Mr. Robarts. He has gone to preach a charity sermon before the bishop, and under those circumstances, perhaps, he could not refuse.” This was a stretch on the part of Lady Meredith—put in with much good nature, no doubt; but still a stretch; for no one had supposed that the bishop would remain at Chaldicotes for the Sunday.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“How do you do, Fanny?” said Lady Lufton, getting up. “I am not going to scold her; and I don’t know how you can talk such nonsense, Justinia. Of course, we are very sorry not to have Mr. Robarts; more especially as he was not here the last Sunday that Sir George was with us. I do like to see Mr. Robarts in his own church, certainly; and I don’t like any other clergyman there as well. If Fanny takes that for scolding, why—”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Oh! no, Lady Lufton; and it’s so kind of you to say so. But Mr. Robarts was so sorry that he had accepted this invitation to Chaldicotes, before he heard that Sir George was coming, and—”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Oh, I know that Chaldicotes has great attractions which we cannot offer,” said Lady Lufton.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Indeed, it was not that. But he was asked to preach, you know; and Mr. Harold Smith—” Poor Fanny was only making it worse. Had she been worldly wise, she would have accepted the little compliment implied in Lady Lufton’s first rebuke, and then have held her peace.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Oh, yes; the Harold Smiths! They are irresistible, I know. How could any man refuse to join a party, graced both by Mrs. Harold Smith and Mrs. Proudie—even though his duty should require him to stay away?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Now, mamma—” said Justinia.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Well, my dear, what am I to say? You would not wish me to tell a fib. I don’t like Mrs. Harold Smith—at least, what I hear of her; for it has not been my fortune to meet her since her marriage. It may be conceited; but to own the truth, I think that Mr. Robarts would be better off with us at Framley than with the Harold Smiths at Chaldicotes,—even though Mrs. Proudie be thrown into the bargain.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("It was nearly dark, and therefore the rising colour in the face of Mrs. Robarts could not be seen. She, however, was too good a wife to hear these things said without some anger within her bosom. She could blame her husband in her own mind; but it was intolerable to her that others should blame him in her hearing.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“He would undoubtedly be better off,” she said; “but then, Lady Lufton, people can’t always go exactly where they will be best off. Gentlemen sometimes must—”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Well—well, my dear, that will do. He has not taken you, at any rate; and so we will forgive him.” And Lady Lufton kissed her. “As it is,”—and she affected a low whisper between the two young wives—“as it is, we must e’en put up with poor old Evan Jones. He is to be here to-night, and we must go and dress to receive him.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("And so they went off. Lady Lufton was quite good enough at heart to like Mrs. Robarts all the better for standing up for her absent lord.")])])])])
}]}

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(80),
  /* template */
  __webpack_require__(81),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 80 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 81 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('p', {
    staticClass: "ORIM-Chapter-Title-Page-Break"
  }, [_vm._v("CHAPTER III")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Chapter-Subtitle"
  }, [_vm._v("Chaldicotes")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Chapter-Opener-Paragraph"
  }, [_vm._v("Chaldicotes is a house of much more pretension than Framley Court. Indeed, if one looks at the ancient marks about it, rather than at those of the present day, it is a place of very considerable pretension. There is an old forest, not altogether belonging to the property, but attached to it, called the Chace of Chaldicotes. A portion of this forest comes up close behind the mansion, and of itself gives a character and celebrity to the place. The Chace of Chaldicotes—the greater part of it, at least—is, as all the world knows, Crown property, and now, in these utilitarian days, is to be disforested. In former times it was a great forest, stretching half across the country, almost as far as Silverbridge; and there are bits of it, here and there, still to be seen at intervals throughout the whole distance; but the larger remaining portion, consisting of aged hollow oaks, centuries old, and wide-spreading withered beeches, stands in the two parishes of Chaldicotes and Uffley. People still come from afar to see the oaks of Chaldicotes, and to hear their feet rustle among the thick autumn leaves. But they will soon come no longer. The giants of past ages are to give way to wheat and turnips; a ruthless Chancellor of the Exchequer, disregarding old associations and rural beauty, requires money returns from the lands; and the Chace of Chaldicotes is to vanish from the earth’s surface.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("Some part of it, however, is the private property of Mr. Sowerby, who hitherto, through all his pecuniary distresses, has managed to save from the axe and the auction-mart that portion of his paternal heritage. The house of Chaldicotes is a large stone building, probably of the time of Charles the Second. It is approached on both fronts by a heavy double flight of stone steps. In the front of the house a long, solemn, straight avenue through a double row of lime-trees leads away to lodge-gates, which stand in the centre of the village of Chaldicotes; but to the rear the windows open upon four different vistas, which run down through the forest; four open green rides, which all converge together at a large iron gateway, the barrier which divides the private grounds from the Chace. The Sowerbys, for many generations, have been rangers of the Chace of Chaldicotes, thus having almost as wide an authority over the Crown forest as over their own. But now all this is to cease, for the forest will be disforested.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("It was nearly dark as Mark Robarts drove up through the avenue of lime-trees to the hall-door; but it was easy to see that the house, which was dead and silent as the grave through nine months of the year, was now alive in all its parts. There were lights in many of the windows, and a noise of voices came from the stables, and servants were moving about, and dogs barked, and the dark gravel before the front steps was cut up with many a coach-wheel.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Oh, be that you, sir, Mr. Robarts?” said a groom, taking the parson’s horse by the head, and touching his own hat. “I hope I see your reverence well?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Quite well, Bob, thank you. All well at Chaldicotes?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Pretty bobbish, Mr. Robarts. Deal of life going on here now, sir. The bishop and his lady came this morning.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Oh—ah—yes! I understood they were to be here. Any of the young ladies?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“One young lady. Miss Olivia, I think they call her, your reverence.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“And how’s Mr. Sowerby?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Very well, your reverence. He, and Mr. Harold Smith, and Mr. Fothergill—that’s the duke’s man of business, you know—is getting off their horses now in the stable-yard there.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Home from hunting—eh, Bob?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Yes, sir, just home, this minute.” And then Mr. Robarts walked into the house, his portmanteau following on a footboy’s shoulder.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("It will be seen that our young vicar was very intimate at Chaldicotes; so much so that the groom knew him, and talked to him about the people in the house. Yes; he was intimate there; much more than he had given the Framley people to understand. Not that he had wilfully and overtly deceived any one; not that he had ever spoken a false word about Chaldicotes. But he had never boasted at home that he and Sowerby were near allies. Neither had he told them there how often Mr. Sowerby and Lord Lufton were together in London. Why trouble women with such matters? Why annoy so excellent a woman as Lady Lufton?")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("And then Mr. Sowerby was one whose intimacy few young men would wish to reject. He was fifty, and had lived, perhaps, not the most salutary life; but he dressed young, and usually looked well. He was bald, with a good forehead, and sparkling moist eyes. He was a clever man, and a pleasant companion, and always good-humoured when it so suited him. He was a gentleman, too, of high breeding and good birth, whose ancestors had been known in that county—longer, the farmers around would boast, than those of any other landowner in it, unless it be the Thornes of Ullathorne, or perhaps the Greshams of Greshamsbury—much longer than the De Courcys at Courcy Castle. As for the Duke of Omnium, he, comparatively speaking, was a new man.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("And then he was a member of Parliament, a friend of some men in power, and of others who might be there; a man who could talk about the world as one knowing the matter of which he talked. And moreover, whatever might be his ways of life at other times, when in the presence of a clergyman he rarely made himself offensive to clerical tastes. He neither swore, nor brought his vices on the carpet, nor sneered at the faith of the Church. If he was no churchman himself, he at least knew how to live with those who were.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("How was it possible that such a one as our vicar should not relish the intimacy of Mr. Sowerby? It might be very well, he would say to himself, for a woman like Lady Lufton to turn up her nose at him—for Lady Lufton, who spent ten months of the year at Framley Court, and who during those ten months, and for the matter of that, during the two months also which she spent in London, saw no one out of her own set. Women did not understand such things, the vicar said to himself; even his own wife—good, and nice, and sensible, and intelligent as she was—even she did not understand that a man in the world must meet all sorts of men; and that in these days it did not do for a clergyman to be a hermit.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("’Twas thus that Mark Robarts argued when he found himself called upon to defend himself before the bar of his own conscience for going to Chaldicotes and increasing his intimacy with Mr. Sowerby. He did know that Mr. Sowerby was a dangerous man; he was aware that he was over head and ears in debt, and that he had already entangled young Lord Lufton in some pecuniary embarrassment; his conscience did tell him that it would be well for him, as one of Christ’s soldiers, to look out for companions of a different stamp. But nevertheless he went to Chaldicotes, not satisfied with himself indeed, but repeating to himself a great many arguments why he should be so satisfied.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("He was shown into the drawing-room at once, and there he found Mrs. Harold Smith, with Mrs. and Miss Proudie, and a lady whom he had never before seen, and whose name he did not at first hear mentioned.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Is that Mr. Robarts?” said Mrs. Harold Smith, getting up to greet him, and screening her pretended ignorance under the veil of the darkness. “And have you really driven over four-and-twenty miles of Barsetshire roads on such a day as this to assist us in our little difficulties? Well, we can promise you gratitude at any rate.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("And then the vicar shook hands with Mrs. Proudie, in that deferential manner which is due from a vicar to his bishop’s wife; and Mrs. Proudie returned the greeting with all that smiling condescension which a bishop’s wife should show to a vicar. Miss Proudie was not quite so civil. Had Mr. Robarts been still unmarried, she also could have smiled sweetly; but she had been exercising smiles on clergymen too long to waste them now on a married parish parson.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“And what are the difficulties, Mrs. Smith, in which I am to assist you?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“We have six or seven gentlemen here, Mr. Robarts, and they always go out hunting before breakfast, and they never come back—I was going to say—till after dinner. I wish it were so, for then we should not have to wait for them.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Excepting Mr. Supplehouse, you know,” said the unknown lady, in a loud voice.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“And he is generally shut up in the library, writing articles.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“He’d be better employed if he were trying to break his neck like the others,” said the unknown lady.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Only he would never succeed,” said Mrs. Harold Smith. “But perhaps, Mr. Robarts, you are as bad as the rest; perhaps you, too, will be hunting to-morrow.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“My dear Mrs. Smith!” said Mrs. Proudie, in a tone denoting slight reproach, and modified horror.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Oh! I forgot. No, of course, you won’t be hunting, Mr. Robarts; you’ll only be wishing that you could.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Why can’t he?” said the lady with the loud voice.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“My dear Miss Dunstable! a clergyman hunt, while he is staying in the same house with the bishop? Think of the proprieties!”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Oh—ah! The bishop wouldn’t like it—wouldn’t he? Now, do tell me, sir, what would the bishop do to you if you did hunt?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“It would depend upon his mood at the time, madam,” said Mr. Robarts. “If that were very stern, he might perhaps have me beheaded before the palace gates.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("Mrs. Proudie drew herself up in her chair, showing that she did not like the tone of the conversation; and Miss Proudie fixed her eyes vehemently on her book, showing that Miss Dunstable and her conversation were both beneath her notice.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“If these gentlemen do not mean to break their necks to-night,” said Mrs. Harold Smith, “I wish they’d let us know it. It’s half-past six already.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("And then Mr. Robarts gave them to understand that no such catastrophe could be looked for that day, as Mr. Sowerby and the other sportsmen were within the stable-yard when he entered the door.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Then, ladies, we may as well dress,” said Mrs. Harold Smith. But as she moved towards the door, it opened, and a short gentleman, with a slow, quiet step, entered the room; but was not yet to be distinguished through the dusk by the eyes of Mr. Robarts. “Oh! bishop, is that you?” said Mrs. Smith. “Here is one of the luminaries of your diocese.” And then the bishop, feeling through the dark, made his way up to the vicar and shook him cordially by the hand. “He was delighted to meet Mr. Robarts at Chaldicotes,” he said—“quite delighted. Was he not going to preach on behalf of the Papuan Mission next Sunday? Ah! so he, the bishop, had heard. It was a good work, an excellent work.” And then Dr. Proudie expressed himself as much grieved that he could not remain at Chaldicotes, and hear the sermon. It was plain that his bishop thought no ill of him on account of his intimacy with Mr. Sowerby. But then he felt in his own heart that he did not much regard his bishop’s opinion.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Ah, Robarts, I’m delighted to see you,” said Mr. Sowerby, when they met on the drawing-room rug before dinner. “You know Harold Smith? Yes, of course you do. Well, who else is there? Oh! Supplehouse. Mr. Supplehouse, allow me to introduce to you my friend Mr. Robarts. It is he who will extract the five-pound note out of your pocket next Sunday for these poor Papuans whom we are going to Christianize. That is, if Harold Smith does not finish the work out of hand at his Saturday lecture. And, Robarts, you have seen the bishop, of course:” this he said in a whisper. “A fine thing to be a bishop, isn’t it? I wish I had half your chance. But, my dear fellow, I’ve made such a mistake; I haven’t got a bachelor parson for Miss Proudie. You must help me out, and take her in to dinner.” And then the great gong sounded, and off they went in pairs.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("At dinner Mark found himself seated between Miss Proudie and the lady whom he had heard named as Miss Dunstable. Of the former he was not very fond, and, in spite of his host’s petition, was not inclined to play bachelor parson for her benefit. With the other lady he would willingly have chatted during the dinner, only that everybody else at table seemed to be intent on doing the same thing. She was neither young, nor beautiful, nor peculiarly ladylike; yet she seemed to enjoy a popularity which must have excited the envy of Mr. Supplehouse, and which certainly was not altogether to the taste of Mrs. Proudie—who, however, fêted her as much as did the others. So that our clergyman found himself unable to obtain more than an inconsiderable share of the lady’s attention.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Bishop,” said she, speaking across the table, “we have missed you so all day! we have had no one on earth to say a word to us.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“My dear Miss Dunstable, had I known that— But I really was engaged on business of some importance.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“I don’t believe in business of importance; do you, Mrs. Smith?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Do I not?” said Mrs. Smith. “If you were married to Mr. Harold Smith for one week, you’d believe in it.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Should I, now? What a pity that I can’t have that chance of improving my faith! But you are a man of business, also, Mr. Supplehouse; so they tell me.” And she turned to her neighbour on her right hand.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“I cannot compare myself to Harold Smith,” said he. “But perhaps I may equal the bishop.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“What does a man do, now, when he sits himself down to business? How does he set about it? What are his tools? A quire of blotting paper, I suppose, to begin with?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“That depends, I should say, on his trade. A shoemaker begins by waxing his thread.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“And Mr. Harold Smith—?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“By counting up his yesterday’s figures, generally, I should say; or else by unrolling a ball of red tape. Well-docketed papers and statistical facts are his forte.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“And what does a bishop do? Can you tell me that?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“He sends forth to his clergy either blessings or blowings-up, according to the state of his digestive organs. But Mrs. Proudie can explain all that to you with the greatest accuracy.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Can she, now? I understand what you mean, but I don’t believe a word of it. The bishop manages his own affairs himself, quite as much as you do, or Mr. Harold Smith.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“I, Miss Dunstable?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Yes, you.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“But I, unluckily, have not a wife to manage them for me.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Then you should not laugh at those who have, for you don’t know what you may come to yourself, when you’re married.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("Mr. Supplehouse began to make a pretty speech, saying that he would be delighted to incur any danger in that respect to which he might be subjected by the companionship of Miss Dunstable. But before he was half through it, she had turned her back upon him, and begun a conversation with Mark Robarts.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Have you much work in your parish, Mr. Robarts?” she asked. Now, Mark was not aware that she knew his name, or the fact of his having a parish, and was rather surprised by the question. And he had not quite liked the tone in which she had seemed to speak of the bishop and his work. His desire for her further acquaintance was therefore somewhat moderated, and he was not prepared to answer her question with much zeal.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“All parish clergymen have plenty of work, if they choose to do it.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Ah, that is it; is it not, Mr. Robarts? If they choose to do it? A great many do—many that I know, do; and see what a result they have. But many neglect it—and see what a result "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("they")]), _vm._v(" have. I think it ought to be the happiest life that a man can lead, that of a parish clergyman, with a wife and family, and a sufficient income.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“I think it is,” said Mark Robarts, asking himself whether the contentment accruing to him from such blessings had made him satisfied at all points. He had all these things of which Miss Dunstable spoke, and yet he had told his wife, the other day, that he could not afford to neglect the acquaintance of a rising politician like Harold Smith.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“What I find fault with is this,” continued Miss Dunstable, “that we expect clergymen to do their duty, and don’t give them a sufficient income—give them hardly any income at all. Is it not a scandal, that an educated gentleman with a family should be made to work half his life, and perhaps the whole, for a pittance of seventy pounds a year?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("Mark said that it was a scandal, and thought of Mr. Evan Jones and his daughter;—and thought also of his own worth, and his own house, and his own nine hundred a year.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“And yet you clergymen are so proud—aristocratic would be the genteel word, I know—that you won’t take the money of common, ordinary poor people. You must be paid from land and endowments, from tithe and church property. You can’t bring yourself to work for what you earn, as lawyers and doctors do. It is better that curates should starve than undergo such ignominy as that.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“It is a long subject, Miss Dunstable.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“A very long one; and that means that I am not to say any more about it.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“I did not mean that exactly.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Oh! but you did though, Mr. Robarts. And I can take a hint of that kind when I get it. You clergymen like to keep those long subjects for your sermons, when no one can answer you. Now if I have a longing heart’s desire for anything at all in this world, it is to be able to get up into a pulpit, and preach a sermon.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“You can’t conceive how soon that appetite would pall upon you, after its first indulgence.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“That would depend upon whether I could get people to listen to me. It does not pall upon Mr. Spurgeon, I suppose.” Then her attention was called away by some question from Mr. Sowerby, and Mark Robarts found himself bound to address his conversation to Miss Proudie. Miss Proudie, however, was not thankful, and gave him little but monosyllables for his pains.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Of course you know Harold Smith is going to give us a lecture about these islanders,” Mr. Sowerby said to him, as they sat round the fire over their wine after dinner. Mark said that he had been so informed, and should be delighted to be one of the listeners.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“You are bound to do that, as he is going to listen to you the day afterwards—or, at any rate, to pretend to do so, which is as much as you will do for him. It’ll be a terrible bore—the lecture, I mean, not the sermon.” And he spoke very low into his friend’s ear. “Fancy having to drive ten miles after dusk, and ten miles back, to hear Harold Smith talk for two hours about Borneo! One must do it, you know.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“I daresay it will be very interesting.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“My dear fellow, you haven’t undergone so many of these things as I have. But he’s right to do it. It’s his line of life; and when a man begins a thing he ought to go on with it. Where’s Lufton all this time?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“In Scotland, when I last heard from him; but he’s probably at Melton now.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“It’s deuced shabby of him, not hunting here in his own county. He escapes all the bore of going to lectures, and giving feeds to the neighbours; that’s why he treats us so. He has no idea of his duty, has he?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Lady Lufton does all that, you know.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“I wish I’d a Mrs. Sowerby "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("mère")]), _vm._v(" to do it for me. But then Lufton has no constituents to look after—lucky dog! By-the-by, has he spoken to you about selling that outlying bit of land of his in Oxfordshire? It belongs to the Lufton property, and yet it doesn’t. In my mind it gives more trouble than it’s worth.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("Lord Lufton had spoken to Mark about this sale, and had explained to him that such a sacrifice was absolutely necessary, in consequence of certain pecuniary transactions between him, Lord Lufton, and Mr. Sowerby. But it was found impracticable to complete the business without Lady Lufton’s knowledge, and her son had commissioned Mr. Robarts not only to inform her ladyship, but to talk her over, and to appease her wrath. This commission he had not yet attempted to execute, and it was probable that this visit to Chaldicotes would not do much to facilitate the business.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“They are the most magnificent islands under the sun,” said Harold Smith to the bishop.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Are they, indeed!” said the bishop, opening his eyes wide, and assuming a look of intense interest.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“And the most intelligent people.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Dear me!” said the bishop.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“All they want is guidance, encouragement, instruction—”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“And Christianity,” suggested the bishop.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“And Christianity, of course,” said Mr. Smith, remembering that he was speaking to a dignitary of the Church. It was well to humour such people, Mr. Smith thought. But the Christianity was to be done in the Sunday sermon, and was not part of his work.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“And how do you intend to begin with them?” asked Mr. Supplehouse, the business of whose life it had been to suggest difficulties.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Begin with them—oh—why—it’s very easy to begin with them. The difficulty is to go on with them, after the money is all spent. We’ll begin by explaining to them the benefits of civilization.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Capital plan!” said Mr. Supplehouse. “But how do you set about it, Smith?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“How do we set about it? How did we set about it with Australia and America? It is very easy to criticize; but in such matters the great thing is to put one’s shoulder to the wheel.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“We sent our felons to Australia,” said Supplehouse, “and they began the work for us. And as to America, we exterminated the people instead of civilizing them.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“We did not exterminate the inhabitants of India,” said Harold Smith, angrily.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Nor have we attempted to Christianize them, as the bishop so properly wishes to do with your islanders.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Supplehouse, you are not fair,” said Mr. Sowerby, “neither to Harold Smith nor to us;—you are making him rehearse his lecture, which is bad for him; and making us hear the rehearsal, which is bad for us.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Supplehouse belongs to a clique which monopolizes the wisdom of England,” said Harold Smith; “or, at any rate, thinks that it does. But the worst of them is that they are given to talk leading articles.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Better that, than talk articles which are not leading,” said Mr. Supplehouse. “Some first-class official men do that.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Shall I meet you at the duke’s next week, Mr. Robarts?” said the bishop to him, soon after they had gone into the drawing-room.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("Meet him at the duke’s!—the established enemy of Barsetshire mankind, as Lady Lufton regarded his grace! No idea of going to the duke’s had ever entered our hero’s mind; nor had he been aware that the duke was about to entertain any one.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“No, my lord; I think not. Indeed, I have no acquaintance with his grace.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Oh—ah! I did not know. Because Mr. Sowerby is going; and so are the Harold Smiths, and, I think, Mr. Supplehouse. An excellent man is the duke;—that is, as regards all the county interests,” added the bishop, remembering that the moral character of his bachelor grace was not the very best in the world.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("And then his lordship began to ask some questions about the church affairs of Framley, in which a little interest as to Framley Court was also mixed up, when he was interrupted by a rather sharp voice, to which he instantly attended.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Bishop,” said the rather sharp voice; and the bishop trotted across the room to the back of the sofa, on which his wife was sitting. “Miss Dunstable thinks that she will be able to come to us for a couple of days, after we leave the duke’s.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“I shall be delighted above all things,” said the bishop, bowing low to the dominant lady of the day. For be it known to all men, that Miss Dunstable was the great heiress of that name.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Mrs. Proudie is so very kind as to say that she will take me in, with my poodle, parrot, and pet old woman.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“I tell Miss Dunstable that we shall have quite room for any of her suite,” said Mrs. Proudie. “And that it will give us no trouble.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“‘The labour we delight in physics pain,’” said the gallant bishop, bowing low, and putting his hand upon his heart.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("In the meantime, Mr. Fothergill had got hold of Mark Robarts. Mr. Fothergill was a gentleman, and a magistrate of the county, but he occupied the position of managing man on the Duke of Omnium’s estates. He was not exactly his agent; that is to say, he did not receive his rents; but he “managed” for him, saw people, went about the county, wrote letters, supported the electioneering interest, did popularity when it was too much trouble for the duke to do it himself, and was, in fact, invaluable. People in West Barsetshire would often say that they did not know what "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("on earth")]), _vm._v(" the duke would do, if it were not for Mr. Fothergill. Indeed, Mr. Fothergill was useful to the duke.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Mr. Robarts,” he said, “I am very happy to have the pleasure of meeting you—very happy, indeed. I have often heard of you from our friend Sowerby.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("Mark bowed, and said that he was delighted to have the honour of making Mr. Fothergill’s acquaintance.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“I am commissioned by the Duke of Omnium,” continued Mr. Fothergill, “to say how glad he will be if you will join his grace’s party at Gatherum Castle, next week. The bishop will be there, and indeed nearly the whole set who are here now. The duke would have written when he heard that you were to be at Chaldicotes; but things were hardly quite arranged then, so his grace has left it for me to tell you how happy he will be to make your acquaintance in his own house. I have spoken to Sowerby,” continued Mr. Fothergill, “and he very much hopes that you will be able to join us.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("Mark felt that his face became red when this proposition was made to him. The party in the county to which he properly belonged—he and his wife, and all that made him happy and respectable—looked upon the Duke of Omnium with horror and amazement; and now he had absolutely received an invitation to the duke’s house! A proposition was made to him that he should be numbered among the duke’s friends!")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("And though in one sense he was sorry that the proposition was made to him, yet in another he was proud of it. It is not every young man, let his profession be what it may, who can receive overtures of friendship from dukes without some elation. Mark, too, had risen in the world, as far as he had yet risen, by knowing great people; and he certainly had an ambition to rise higher. I will not degrade him by calling him a tuft-hunter; but he undoubtedly had a feeling that the paths most pleasant for a clergyman’s feet were those which were trodden by the great ones of the earth.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("Nevertheless, at the moment he declined the duke’s invitation. He was very much flattered, he said, but the duties of his parish would require him to return direct from Chaldicotes to Framley.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“You need not give me an answer to-night, you know,” said Mr. Fothergill. “Before the week is past, we will talk it over with Sowerby and the bishop. It will be a thousand pities, Mr. Robarts, if you will allow me to say so, that you should neglect such an opportunity of knowing his grace.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("When Mark went to bed, his mind was still set against going to the duke’s; but, nevertheless, he did feel that it was a pity that he should not do so. After all, was it necessary that he should obey Lady Lufton in all things?")])])])])
}]}

/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(83),
  /* template */
  __webpack_require__(84),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 84 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('p', {
    staticClass: "ORIM-Chapter-Title-Page-Break"
  }, [_vm._v("CHAPTER IV")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Chapter-Subtitle"
  }, [_vm._v("A Matter of Conscience")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Chapter-Opener-Paragraph"
  }, [_vm._v("It is no doubt very wrong to long after a naughty thing. But nevertheless we all do so. One may say that hankering after naughty things is the very essence of the evil into which we have been precipitated by Adam’s fall. When we confess that we are all sinners, we confess that we all long after naughty things.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("And ambition is a great vice—as Mark Antony told us a long time ago—a great vice, no doubt, if the ambition of the man be with reference to his own advancement, and not to the advancement of others. But then, how many of us are there who are not ambitious in this vicious manner?")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("And there is nothing viler than the desire to know great people—people of great rank, I should say; nothing worse than the hunting of titles and worshipping of wealth. We all know this, and say it every day of our lives. But presuming that a way into the society of Park Lane was open to us, and a way also into that of Bedford Row, how many of us are there who would prefer Bedford Row because it is so vile to worship wealth and title?")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("I am led into these rather trite remarks by the necessity of putting forward some sort of excuse for that frame of mind in which the Rev. Mark Robarts awoke on the morning after his arrival at Chaldicotes. And I trust that the fact of his being a clergyman will not be allowed to press against him unfairly. Clergymen are subject to the same passions as other men; and, as far as I can see, give way to them, in one line or in another, almost as frequently. Every clergyman should, by canonical rule, feel a personal disinclination to a bishopric; but yet we do not believe that such personal disinclination is generally very strong.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("Mark’s first thoughts when he woke on that morning flew back to Mr. Fothergill’s invitation. The duke had sent a special message to say how peculiarly glad he, the duke, would be to make acquaintance with him, the parson! How much of this message had been of Mr. Fothergill’s own manufacture, that Mark Robarts did not consider.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("He had obtained a living at an age when other young clergymen are beginning to think of a curacy, and he had obtained such a living as middle-aged parsons in their dreams regard as a possible Paradise for their old years. Of course he thought that all these good things had been the results of his own peculiar merits. Of course he felt that he was different from other parsons,—more fitted by nature for intimacy with great persons, more urbane, more polished, and more richly endowed with modern clerical well-to-do aptitudes. He was grateful to Lady Lufton for what she had done for him; but perhaps not so grateful as he should have been.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("At any rate he was not Lady Lufton’s servant, nor even her dependant. So much he had repeated to himself on many occasions, and had gone so far as to hint the same idea to his wife. In his career as parish priest he must in most things be the judge of his own actions—and in many also it was his duty to be the judge of those of his patroness. The fact of Lady Lufton having placed him in the living, could by no means make her the proper judge of his actions. This he often said to himself; and he said as often that Lady Lufton certainly had a hankering after such a judgment-seat.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("Of whom generally did prime ministers and official bigwigs think it expedient to make bishops and deans? Was it not, as a rule, of those clergymen who had shown themselves able to perform their clerical duties efficiently, and able also to take their place with ease in high society? He was very well off certainly at Framley; but he could never hope for anything beyond Framley, if he allowed himself to regard Lady Lufton as a bugbear. Putting Lady Lufton and her prejudices out of the question, was there any reason why he ought not to accept the duke’s invitation? He could not see that there was any such reason. If any one could be a better judge on such a subject than himself, it must be his bishop. And it was clear that the bishop wished him to go to Gatherum Castle.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("The matter was still left open to him. Mr. Fothergill had especially explained that; and therefore his ultimate decision was as yet within his own power. Such a visit would cost him some money, for he knew that a man does not stay at great houses without expense; and then, in spite of his good income, he was not very flush of money. He had been down this year with Lord Lufton in Scotland. Perhaps it might be more prudent for him to return home.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("But then an idea came to him that it behoved him as a man and a priest to break through that Framley thraldom under which he felt that he did to a certain extent exist. Was it not the fact that he was about to decline this invitation from fear of Lady Lufton? and if so, was that a motive by which he ought to be actuated? It was incumbent on him to rid himself of that feeling. And in this spirit he got up and dressed.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("There was hunting again on that day; and as the hounds were to meet near Chaldicotes, and to draw some coverts lying on the verge of the Chace, the ladies were to go in carriages through the drives of the forest, and Mr. Robarts was to escort them on horseback. Indeed it was one of those hunting-days got up rather for the ladies than for the sport. Great nuisances they are to steady, middle-aged hunting men; but the young fellows like them because they have thereby an opportunity of showing off their sporting finery, and of doing a little flirtation on horseback. The bishop, also, had been minded to be of the party; so, at least, he had said on the previous evening; and a place in one of the carriages had been set apart for him: but since that, he and Mrs. Proudie had discussed the matter in private, and at breakfast his lordship declared that he had changed his mind.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("Mr. Sowerby was one of those men who are known to be very poor—as poor as debt can make a man—but who, nevertheless, enjoy all the luxuries which money can give. It was believed that he could not live in England out of jail but for his protection as a member of Parliament; and yet it seemed that there was no end to his horses and carriages, his servants and retinue. He had been at this work for a great many years, and practice, they say, makes perfect. Such companions are very dangerous. There is no cholera, no yellow-fever, no small-pox more contagious than debt. If one lives habitually among embarrassed men, one catches it to a certainty. No one had injured the community in this way more fatally than Mr. Sowerby. But still he carried on the game himself; and now on this morning carriages and horses thronged at his gate, as though he were as substantially rich as his friend the Duke of Omnium.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Robarts, my dear fellow,” said Mr. Sowerby, when they were well under way down one of the glades of the forest,—for the place where the hounds met was some four or five miles from the house of Chaldicotes,—“ride on with me a moment. I want to speak to you; and if I stay behind we shall never get to the hounds.” So Mark, who had come expressly to escort the ladies, rode on alongside of Mr. Sowerby in his pink coat.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“My dear fellow, Fothergill tells me that you have some hesitation about going to Gatherum Castle.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Well, I did decline, certainly. You know I am not a man of pleasure, as you are. I have some duties to attend to.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Gammon!” said Mr. Sowerby; and as he said it he looked with a kind of derisive smile into the clergyman’s face.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“It is easy enough to say that, Sowerby; and perhaps I have no right to expect that you should understand me.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Ah, but I do understand you; and I say it is gammon. I would be the last man in the world to ridicule your scruples about duty, if this hesitation on your part arose from any such scruple. But answer me honestly, do you not know that such is not the case?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“I know nothing of the kind.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Ah, but I think you do. If you persist in refusing this invitation will it not be because you are afraid of making Lady Lufton angry? I do not know what there can be in that woman that she is able to hold both you and Lufton in leading-strings.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("Robarts, of course, denied the charge and protested that he was not to be taken back to his own parsonage by any fear of Lady Lufton. But though he made such protest with warmth, he knew that he did so ineffectually. Sowerby only smiled and said that the proof of the pudding was in the eating.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“What is the good of a man keeping a curate if it be not to save him from that sort of drudgery?” he asked.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Drudgery! If I were a drudge how could I be here to-day?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Well, Robarts, look here. I am speaking now, perhaps, with more of the energy of an old friend than circumstances fully warrant; but I am an older man than you, and as I have a regard for you I do not like to see you throw up a good game when it is in your hands.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Oh, as far as that goes, Sowerby, I need hardly tell you that I appreciate your kindness.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“If you are content,” continued the man of the world, “to live at Framley all your life, and to warm yourself in the sunshine of the dowager there, why, in such case, it may perhaps be useless for you to extend the circle of your friends; but if you have higher ideas than these, I think you will be very wrong to omit the present opportunity of going to the duke’s. I never knew the duke go so much out of his way to be civil to a clergyman as he has done in this instance.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“I am sure I am very much obliged to him.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“The fact is, that you may, if you please, make yourself popular in the county; but you cannot do it by obeying all Lady Lufton’s behests. She is a dear old woman, I am sure.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“She is, Sowerby; and you would say so, if you knew her.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“I don’t doubt it; but it would not do for you or me to live exactly according to her ideas. Now, here, in this case, the bishop of the diocese is to be one of the party, and he has, I believe, already expressed a wish that you should be another.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“He asked me if I were going.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Exactly; and Archdeacon Grantly will be there.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Will he?” asked Mark. Now, that would be a great point gained, for Archdeacon Grantly was a close friend of Lady Lufton.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“So I understand from Fothergill. Indeed, it will be very wrong of you not to go, and I tell you so plainly; and what is more, when you talk about your duty—you having a curate as you have—why, it is gammon.” These last words he spoke looking back over his shoulder as he stood up in his stirrups, for he had caught the eye of the huntsman, who was surrounded by his hounds, and was now trotting on to join him.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("During a great portion of the day, Mark found himself riding by the side of Mrs. Proudie, as that lady leaned back in her carriage. And Mrs. Proudie smiled on him graciously, though her daughter would not do so. Mrs. Proudie was fond of having an attendant clergyman; and as it was evident that Mr. Robarts lived among nice people—titled dowagers, members of Parliament, and people of that sort—she was quite willing to instal him as a sort of honorary chaplain "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("pro tem")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“I’ll tell you what we have settled, Mrs. Harold Smith and I,” said Mrs. Proudie to him. “This lecture at Barchester will be so late on Saturday evening, that you had all better come and dine with us.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("Mark bowed and thanked her, and declared that he should be very happy to make one of such a party. Even Lady Lufton could not object to this, although she was not especially fond of Mrs. Proudie.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“And then they are to sleep at the hotel. It will really be too late for ladies to think of going back so far at this time of the year. I told Mrs. Harold Smith, and Miss Dunstable, too, that we could manage to make room at any rate for them. But they will not leave the other ladies; so they go to the hotel for that night. But, Mr. Robarts, the bishop will never allow you to stay at the inn, so of course you will take a bed at the palace.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("It immediately occurred to Mark that as the lecture was to be given on Saturday evening, the next morning would be Sunday; and, on that Sunday, he would have to preach at Chaldicotes. “I thought they were all going to return the same night,” said he.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Well, they did intend it; but you see Mrs. Smith is afraid.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“I should have to get back here on the Sunday morning, Mrs. Proudie.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Ah, yes, that is bad—very bad, indeed. No one dislikes any interference with the Sabbath more than I do. Indeed, if I am particular about anything it is about that. But some works are works of necessity, Mr. Robarts; are they not? Now you must necessarily be back at Chaldicotes on Sunday morning!” And so the matter was settled. Mrs. Proudie was very firm in general in the matter of Sabbath-day observances; but when she had to deal with such persons as Mrs. Harold Smith, it was expedient that she should give way a little. “You can start as soon as it’s daylight, you know, if you like it, Mr. Robarts,” said Mrs. Proudie.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("There was not much to boast of as to the hunting, but it was a very pleasant day for the ladies. The men rode up and down the grass roads through the Chace, sometimes in the greatest possible hurry as though they never could go quick enough; and then the coachmen would drive very fast also, though they did not know why, for a fast pace of movement is another of those contagious diseases. And then again the sportsmen would move at an undertaker’s pace, when the fox had traversed and the hounds would be at a loss to know which was the hunt and which was the heel; and then the carriage also would go slowly, and the ladies would stand up and talk. And then the time for lunch came; and altogether the day went by pleasantly enough.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“And so that’s hunting, is it?” said Miss Dunstable.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Yes, that’s hunting,” said Mr. Sowerby.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“I did not see any gentleman do anything that I could not do myself, except there was one young man slipped off into the mud; and I shouldn’t like that.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“But there was no breaking of bones, was there, my dear?” said Mrs. Harold Smith.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“And nobody caught any foxes,” said Miss Dunstable. “The fact is, Mrs. Smith, that I don’t think much more of their sport than I do of their business. I shall take to hunting a pack of hounds myself after this.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Do, my dear, and I’ll be your whipper-in. I wonder whether Mrs. Proudie would join us.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“I shall be writing to the duke to-night,” said Mr. Fothergill to Mark, as they were all riding up to the stable-yard together. “You will let me tell his grace that you will accept his invitation—will you not?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Upon my word, the duke is very kind,” said Mark.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“He is very anxious to know you, I can assure you,” said Fothergill.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("What could a young flattered fool of a parson do, but say that he would go? Mark did say that he would go; and in the course of the evening his friend Mr. Sowerby congratulated him, and the bishop joked with him and said that he knew that he would not give up good company so soon; and Miss Dunstable said she would make him her chaplain as soon as Parliament would allow quack doctors to have such articles—an allusion which Mark did not understand, till he learned that Miss Dunstable was herself the proprietress of the celebrated Oil of Lebanon, invented by her late respected father, and patented by him with such wonderful results in the way of accumulated fortune; and Mrs. Proudie made him quite one of their party, talking to him about all manner of church subjects; and then at last, even Miss Proudie smiled on him, when she learned that he had been thought worthy of a bed at a duke’s castle. And all the world seemed to be open to him.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("But he could not make himself happy that evening. On the next morning he must write to his wife; and he could already see the look of painful sorrow which would fall upon his Fanny’s brow when she learned that her husband was going to be a guest at the Duke of Omnium’s. And he must tell her to send him money, and money was scarce. And then, as to Lady Lufton, should he send her some message, or should he not? In either case he must declare war against her. And then did he not owe everything to Lady Lufton? And thus in spite of all his triumphs he could not get himself to bed in a happy frame of mind.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("On the next day, which was Friday, he postponed the disagreeable task of writing. Saturday would do as well; and on Saturday morning, before they all started for Barchester, he did write. And his letter ran as follows:—")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Ext-First"
  }, [_vm._v("Chaldicotes, — November, 185—.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Ext-Body"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("DEAREST LOVE")]), _vm._v(",— You will be astonished when I tell you how gay we all are here, and what further dissipations are in store for us. The Arabins, as you supposed, are not of our party; but the Proudies are,—as you supposed also. Your suppositions are always right. And what will you think when I tell you that I am to sleep at the palace on Saturday? You know that there is to be a lecture in Barchester on that day. Well; we must all go, of course, as Harold Smith, one of our set here, is to give it. And now it turns out that we cannot get back the same night because there is no moon; and Mrs. Bishop would not allow that my cloth should be contaminated by an hotel;—very kind and considerate, is it not?")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Ext-Body"
  }, [_vm._v("But I have a more astounding piece of news for you than this. There is to be a great party at Gatherum Castle next week, and they have talked me over into accepting an invitation which the duke sent expressly to me. I refused at first; but everybody here said that my doing so would be so strange; and then they all wanted to know my reason. When I came to render it, I did not know what reason I had to give. The bishop is going, and he thought it very odd that I should not go also, seeing that I was asked.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Ext-Body"
  }, [_vm._v("I know what my own darling will think, and I know that she will not be pleased, and I must put off my defence till I return to her from this ogre-land,—if ever I do get back alive. But joking apart, Fanny, I think that I should have been wrong to stand out, when so much was said about it. I should have been seeming to take upon myself to sit in judgment upon the duke. I doubt if there be a single clergyman in the diocese, under fifty years of age, who would have refused the invitation under such circumstances,—unless it be Crawley, who is so mad on the subject that he thinks it almost wrong to take a walk out of his own parish.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Ext-Body"
  }, [_vm._v("I must stay at Gatherum Castle over Sunday week—indeed, we only go there on Friday. I have written to Jones about the duties. I can make it up to him, as I know he wishes to go into Wales at Christmas. My wanderings will all be over then, and he may go for a couple of months if he pleases. I suppose you will take my classes in the school on Sunday, as well as your own; but pray make them have a good fire. If this is too much for you, make Mrs. Podgens take the boys. Indeed I think that will be better.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Ext-Body"
  }, [_vm._v("Of course you will tell her ladyship of my whereabouts. Tell her from me, that as regards the bishop, as well as regarding another great personage, the colour has been laid on perhaps a little too thickly. Not that Lady Lufton would ever like him. Make her understand that my going to the duke’s has almost become a matter of conscience with me. I have not known how to make it appear that it would be right for me to refuse, without absolutely making a party matter of it. I saw that it would be said, that I, coming from Lady Lufton’s parish, could not go to the Duke of Omnium’s. This I did not choose.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Ext-Body"
  }, [_vm._v("I find that I shall want a little more money before I leave here, five or ten pounds—say ten pounds. If you cannot spare it, get it from Davis. He owes me more than that, a good deal.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Ext-Body"
  }, [_vm._v("And now, God bless and preserve you, my own love. Kiss my darling bairns for papa, and give them my blessing.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Letclos"
  }, [_vm._v("Always and ever your own,")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Letclos-Last"
  }, [_vm._v("M. R.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("And then there was written, on an outside scrap which was folded round the full-written sheet of paper, “Make it as smooth at Framley Court as possible.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("However strong, and reasonable, and unanswerable the body of Mark’s letter may have been, all his hesitation, weakness, doubt, and fear were expressed in this short postscript.")])])])])
}]}

/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(86),
  /* template */
  __webpack_require__(87),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 86 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 87 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('p', {
    staticClass: "ORIM-Chapter-Title-Page-Break"
  }, [_vm._v("CHAPTER V")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Chapter-Subtitle"
  }, [_vm._v("Amantium Iræ Amoris Integratio")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Chapter-Opener-Paragraph"
  }, [_vm._v("And now, with my reader’s consent, I will follow the postman with that letter to Framley; not by its own circuitous route indeed, or by the same mode of conveyance; for that letter went into Barchester by the Courcy night mail-cart, which, on its road, passes through the villages of Uffley and Chaldicotes, reaching Barchester in time for the up mail-train to London. By that train, the letter was sent towards the metropolis as far as the junction of the Barset branch line, but there it was turned in its course, and came down again by the main line as far as Silverbridge; at which place, between six and seven in the morning, it was shouldered by the Framley footpost messenger, and in due course delivered at the Framley Parsonage exactly as Mrs. Robarts had finished reading prayers to the four servants. Or, I should say rather, that such would in its usual course have been that letter’s destiny. As it was, however, it reached Silverbridge on Sunday, and lay there till the Monday, as the Framley people have declined their Sunday post. And then again, when the letter was delivered at the parsonage, on that wet Monday morning, Mrs. Robarts was not at home. As we are all aware, she was staying with her ladyship at Framley Court.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Oh, but it’s mortial wet,” said the shivering postman as he handed in that and the vicar’s newspaper. The vicar was a man of the world, and took the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Jupiter")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Come in, Robin postman, and warm theeself awhile,” said Jemima the cook, pushing a stool a little to one side, but still well in front of the big kitchen fire.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Well, I dudna jist know how it’ll be. The wery ’edges ’as eyes and tells on me in Silverbridge, if I so much as stops to pick a blackberry.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“There bain’t no hedges here, mon, nor yet no blackberries; so sit thee down and warm theeself. That’s better nor blackberries I’m thinking,” and she handed him a bowl of tea with a slice of buttered toast.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("Robin postman took the proffered tea, put his dripping hat on the ground, and thanked Jemima cook. “But I dudna jist know how it’ll be,” said he; “only it do pour so tarnation heavy.” Which among us, O my readers, could have withstood that temptation?")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("Such was the circuitous course of Mark’s letter; but as it left Chaldicotes on Saturday evening, and reached Mrs. Robarts on the following morning, or would have done, but for that intervening Sunday, doing all its peregrinations during the night, it may be held that its course of transport was not inconveniently arranged. We, however, will travel by a much shorter route.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("Robin, in the course of his daily travels, passed, first the post-office at Framley, then the Framley Court back entrance, and then the vicar’s house, so that on this wet morning Jemima cook was not able to make use of his services in transporting this letter back to her mistress; for Robin had got another village before him, expectant of its letters.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Why didn’t thee leave it, mon, with Mr. Applejohn at the Court?” Mr. Applejohn was the butler who took the letter-bag. “Thee know’st as how missus was there.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("And then Robin, mindful of the tea and toast, explained to her courteously how the law made it imperative on him to bring the letter to the very house that was indicated, let the owner of the letter be where she might; and he laid down the law very satisfactorily with sundry long-worded quotations. Not to much effect, however, for the housemaid called him an oaf; and Robin would decidedly have had the worst of it had not the gardener come in and taken his part. “They women knows nothin’, and understands nothin’,” said the gardener. “Give us hold of the letter. I’ll take it up to the house. It’s the master’s fist.” And then Robin postman went on one way, and the gardener, he went the other. The gardener never disliked an excuse for going up to the Court gardens, even on so wet a day as this.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("Mrs. Robarts was sitting over the drawing-room fire with Lady Meredith, when her husband’s letter was brought to her. The Framley Court letter-bag had been discussed at breakfast; but that was now nearly an hour since, and Lady Lufton, as was her wont, was away in her own room writing her own letters, and looking after her own matters; for Lady Lufton was a person who dealt in figures herself, and understood business almost as well as Harold Smith. And on that morning she also had received a letter which had displeased her not a little. Whence arose this displeasure neither Mrs. Robarts nor Lady Meredith knew; but her ladyship’s brow had grown black at breakfast time; she had bundled up an ominous-looking epistle into her bag without speaking of it, and had left the room immediately that breakfast was over.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“There’s something wrong,” said Sir George.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Mamma does fret herself so much about Ludovic’s money matters,” said Lady Meredith. Ludovic was Lord Lufton,—Ludovic Lufton, Baron Lufton of Lufton, in the county of Oxfordshire.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“And yet I don’t think Lufton gets much astray,” said Sir George, as he sauntered out of the room. “Well, Justy; we’ll put off going then till to-morrow; but remember, it must be the first train.” Lady Meredith said she would remember, and then they went into the drawing-room, and there Mrs. Robarts received her letter.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("Fanny, when she read it, hardly at first realized to herself the idea that her husband, the clergyman of Framley, the family clerical friend of Lady Lufton’s establishment, was going to stay with the Duke of Omnium. It was so thoroughly understood at Framley Court that the duke and all belonging to him was noxious and damnable. He was a Whig, he was a bachelor, he was a gambler, he was immoral in every way, he was a man of no church principle, a corrupter of youth, a sworn foe of young wives, a swallower up of small men’s patrimonies; a man whom mothers feared for their sons, and sisters for their brothers; and worse again, whom fathers had cause to fear for their daughters, and brothers for their sisters;—a man who, with his belongings, dwelt, and must dwell, poles asunder from Lady Lufton and her belongings!")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("And it must be remembered that all these evil things were fully believed by Mrs. Robarts. Could it really be that her husband was going to dwell in the halls of Apollyon, to shelter himself beneath the wings of this very Lucifer? A cloud of sorrow settled upon her face, and then she read the letter again very slowly, not omitting the tell-tale postscript.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Oh, Justinia!” at last she said.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“What, have you got bad news, too?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“I hardly know how to tell you what has occurred. There; I suppose you had better read it;” and she handed her husband’s epistle to Lady Meredith,—keeping back, however, the postscript.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“What on earth will her ladyship say now?” said Lady Meredith, as she folded the paper, and replaced it in the envelope.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“What had I better do, Justinia? how had I better tell her?” And then the two ladies put their heads together, bethinking themselves how they might best deprecate the wrath of Lady Lufton. It had been arranged that Mrs. Robarts should go back to the parsonage after lunch, and she had persisted in her intention after it had been settled that the Merediths were to stay over that evening. Lady Meredith now advised her friend to carry out this determination without saying anything about her husband’s terrible iniquities, and then to send the letter up to Lady Lufton as soon as she reached the parsonage. “Mamma will never know that you received it here,” said Lady Meredith.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("But Mrs. Robarts would not consent to this. Such a course seemed to her to be cowardly. She knew that her husband was doing wrong; she felt that he knew it himself; but still it was necessary that she should defend him. However terrible might be the storm, it must break upon her own head. So she at once went up and tapped at Lady Lufton’s private door; and as she did so Lady Meredith followed her.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Come in,” said Lady Lufton, and the voice did not sound soft and pleasant. When they entered, they found her sitting at her little writing table, with her head resting on her arm, and that letter which she had received that morning was lying open on the table before her. Indeed there were two letters now there, one from a London lawyer to herself, and the other from her son to that London lawyer. It needs only be explained that the subject of those letters was the immediate sale of that outlying portion of the Lufton property in Oxfordshire, as to which Mr. Sowerby once spoke. Lord Lufton had told the lawyer that the thing must be done at once, adding that his friend Robarts would have explained the whole affair to his mother. And then the lawyer had written to Lady Lufton, as indeed was necessary; but unfortunately Lady Lufton had not hitherto heard a word of the matter.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("In her eyes the sale of family property was horrible; the fact that a young man with some fifteen or twenty thousand a year should require subsidiary money was horrible; that her own son should have not written to her himself was horrible; and it was also horrible that her own pet, the clergyman whom she had brought there to be her son’s friend, should be mixed up in the matter,—should be cognizant of it while she was not cognizant,—should be employed in it as a go-between and agent in her son’s bad courses. It was all horrible, and Lady Lufton was sitting there with a black brow and an uneasy heart. As regarded our poor parson, we may say that in this matter he was blameless, except that he had hitherto lacked the courage to execute his friend’s commission.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“What is it, Fanny?” said Lady Lufton as soon as the door was opened; “I should have been down in half-an-hour, if you wanted me, Justinia.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Fanny has received a letter which makes her wish to speak to you at once,” said Lady Meredith. ")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“What letter, Fanny?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("Poor Fanny’s heart was in her mouth; she held it in her hand, but had not yet quite made up her mind whether she would show it bodily to Lady Lufton.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“From Mr. Robarts,” she said.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Well; I suppose he is going to stay another week at Chaldicotes. For my part I should be as well pleased;” and Lady Lufton’s voice was not friendly, for she was thinking of that farm in Oxfordshire. The imprudence of the young is very sore to the prudence of their elders. No woman could be less covetous, less grasping than Lady Lufton; but the sale of a portion of the old family property was to her as the loss of her own heart’s blood.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Here is the letter, Lady Lufton; perhaps you had better read it;” and Fanny handed it to her, again keeping back the postscript. She had read and re-read the letter downstairs, but could not make out whether her husband had intended her to show it. From the line of the argument she thought that he must have done so. At any rate he said for himself more than she could say for him, and so, probably, it was best that her ladyship should see it.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("Lady Lufton took it, and read it, and her face grew blacker and blacker. Her mind was set against the writer before she began it, and every word in it tended to make her feel more estranged from him. “Oh, he is going to the palace, is he?—well; he must choose his own friends. Harold Smith one of his party! It’s a pity, my dear, he did not see Miss Proudie before he met you, he might have lived to be the bishop’s chaplain. Gatherum Castle! You don’t mean to tell me that he is going there? Then I tell you fairly, Fanny, that I have done with him.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Oh, Lady Lufton, don’t say that,” said Mrs. Robarts, with tears in her eyes.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Mamma, mamma, don’t speak in that way,” said Lady Meredith.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“But my dear, what am I to say? I must speak in that way. You would not wish me to speak falsehoods, would you? A man must choose for himself, but he can’t live with two different sets of people; at least, not if I belong to one and the Duke of Omnium to the other. The bishop going indeed! If there be anything that I hate it is hypocrisy.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“There is no hypocrisy in that, Lady Lufton.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“But I say there is, Fanny. Very strange, indeed! ‘Put off his defence!’ Why should a man need any defence to his wife if he acts in a straightforward way? His own language condemns him: ‘Wrong to stand out!’ Now, will either of you tell me that Mr. Robarts would really have thought it wrong to refuse that invitation? I say that that is hypocrisy. There is no other word for it.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("By this time the poor wife, who had been in tears, was wiping them away and preparing for action. Lady Lufton’s extreme severity gave her courage. She knew that it behoved her to fight for her husband when he was thus attacked. Had Lady Lufton been moderate in her remarks Mrs. Robarts would not have had a word to say.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“My husband may have been ill-judged,” she said, “but he is no hypocrite.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Very well, my dear, I daresay you know better than I; but to me it looks extremely like hypocrisy; eh, Justinia?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Oh, mamma, do be moderate.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Moderate! That’s all very well. How is one to moderate one’s feelings when one has been betrayed?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“You do not mean that Mr. Robarts has betrayed you?” said the wife.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Oh, no; of course not.” And then she went on reading the letter: “‘Seem to have been standing in judgment upon the duke.’ Might he not use the same argument as to going into any house in the kingdom, however infamous? We must all stand in judgment one upon another in that sense. ‘Crawley!’ Yes; if he were a little more like Mr. Crawley it would be a good thing for me, and for the parish, and for you too, my dear. God forgive me for bringing him here; that’s all.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Lady Lufton, I must say that you are very hard upon him—very hard. I did not expect it from such a friend.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“My dear, you ought to know me well enough to be sure that I shall speak my mind. ‘Written to Jones’—yes; it is easy enough to write to poor Jones. He had better write to Jones, and bid him do the whole duty. Then he can go and be the duke’s domestic chaplain.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“I believe my husband does as much of his own duty as any clergyman in the whole diocese,” said Mrs. Robarts, now again in tears.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“And you are to take his work in the school; you and Mrs. Podgens. What with his curate and his wife and Mrs. Podgens, I don’t see why he should come back at all.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Oh, mamma,” said Justinia, “pray, pray don’t be so harsh to her.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Let me finish it, my dear;—oh, here I come. ‘Tell her ladyship my whereabouts.’ He little thought you’d show me this letter.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Didn’t he?” said Mrs. Robarts, putting out her hand to get it back, but in vain. “I thought it was for the best; I did indeed.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“I had better finish it now, if you please. What is this? How does he dare send his ribald jokes to me in such a matter? No, I do not suppose I ever shall like Dr. Proudie; I have never expected it. A matter of conscience with him! Well—well, well. Had I not read it myself, I could not have believed it of him. I would not positively have believed it. ‘Coming from my parish he could not go to the Duke of Omnium!’ And it is what I would wish to have said. People fit for this parish should not be fit for the Duke of Omnium’s house. And I had trusted that he would have this feeling more strongly than any one else in it. I have been deceived—that’s all.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“He has done nothing to deceive you, Lady Lufton.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“I hope he will not have deceived you, my dear. ‘More money;’ yes, it is probable that he will want more money. There is your letter, Fanny. I am very sorry for it. I can say nothing more.” And she folded up the letter and gave it back to Mrs. Robarts.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“I thought it right to show it you,” said Mrs. Robarts.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“It did not much matter whether you did or no; of course I must have been told.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“He especially begs me to tell you.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Why, yes; he could not very well have kept me in the dark in such a matter. He could not neglect his own work, and go and live with gamblers and adulterers at the Duke of Omnium’s without my knowing it.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("And now Fanny Robarts’s cup was full, full to the overflowing. When she heard these words she forgot all about Lady Lufton, all about Lady Meredith, and remembered only her husband,—that he was her husband, and, in spite of his faults, a good and loving husband;—and that other fact also she remembered, that she was his wife.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Lady Lufton,” she said, “you forget yourself in speaking in that way of my husband.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“What!” said her ladyship; “you are to show me such a letter as that, and I am not to tell you what I think?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Not if you think such hard things as that. Even you are not justified in speaking to me in that way, and I will not hear it.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Heighty-tighty!” said her ladyship.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Whether or no he is right in going to the Duke of Omnium’s, I will not pretend to judge. He is the judge of his own actions, and neither you nor I.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“And when he leaves you with the butcher’s bill unpaid and no money to buy shoes for the children, who will be the judge then?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Not you, Lady Lufton. If such bad days should ever come—and neither you nor I have a right to expect them—I will not come to you in my troubles; not after this.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Very well, my dear. You may go to the Duke of Omnium if that suits you better.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Fanny, come away,” said Lady Meredith. “Why should you try to anger my mother?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“I don’t want to anger her; but I won’t hear him abused in that way without speaking up for him. If I don’t defend him, who will? Lady Lufton has said terrible things about him; and they are not true.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Oh, Fanny!” said Justinia.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Very well, very well!” said Lady Lufton. “This is the sort of return that one gets.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“I don’t know what you mean by return, Lady Lufton; but would you wish me to stand by quietly and hear such things said of my husband? He does not live with such people as you have named. He does not neglect his duties. If every clergyman were as much in his parish, it would be well for some of them. And in going to such a house as the Duke of Omnium’s it does make a difference that he goes there in company with the bishop. I can’t explain why, but I know that it does.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Especially when the bishop is coupled up with the devil, as Mr. Robarts has done,” said Lady Lufton; “he can join the duke with them and then they’ll stand for the three Graces, won’t they, Justinia?” And Lady Lufton laughed a bitter little laugh at her own wit.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“I suppose I may go now, Lady Lufton.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Oh, yes, certainly, my dear.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“I am sorry if I have made you angry with me; but I will not allow any one to speak against Mr. Robarts without answering them. You have been very unjust to him; and even though I do anger you, I must say so.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Come, Fanny; this is too bad,” said Lady Lufton. “You have been scolding me for the last half-hour because I would not congratulate you on this new friend that your husband has made, and now you are going to begin it all over again. That is more than I can stand. If you have nothing else particular to say, you might as well leave me.” And Lady Lufton’s face as she spoke was unbending, severe, and harsh.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("Mrs. Robarts had never before been so spoken to by her old friend; indeed she had never been so spoken to by any one, and she hardly knew how to bear herself.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Very well, Lady Lufton,” she said; “then I will go. Good-bye.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Good-bye,” said Lady Lufton, and turning herself to her table she began to arrange her papers. Fanny had never before left Framley Court to go back to her own parsonage without a warm embrace. Now she was to do so without even having her hand taken. Had it come to this, that there was absolutely to be a quarrel between them,—a quarrel for ever?")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Fanny is going, you know, mamma,” said Lady Meredith. “She will be home before you are down again.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“I cannot help it, my dear. Fanny must do as she pleases. I am not to be the judge of her actions. She has just told me so.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("Mrs. Robarts had said nothing of the kind, but she was far too proud to point this out. So with a gentle step she retreated through the door, and then Lady Meredith, having tried what a conciliatory whisper with her mother would do, followed her. Alas, the conciliatory whisper was altogether ineffectual!")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("The two ladies said nothing as they descended the stairs, but when they had regained the drawing-room they looked with blank horror into each other’s faces. What were they to do now? Of such a tragedy as this they had had no remotest preconception. Was it absolutely the case that Fanny Robarts was to walk out of Lady Lufton’s house as a declared enemy,—she who, before her marriage as well as since, had been almost treated as an adopted daughter of the family?")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Oh, Fanny, why did you answer my mother in that way?” said Lady Meredith. “You saw that she was vexed. She had other things to vex her besides this about Mr. Robarts.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“And would not you answer any one who attacked Sir George?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“No, not my own mother. I would let her say what she pleased, and leave Sir George to fight his own battles.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Ah, but it is different with you. You are her daughter, and Sir George—she would not dare to speak in that way as to Sir George’s doings.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Indeed she would, if it pleased her. I am sorry I let you go up to her.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“It is as well that it should be over, Justinia. As those are her thoughts about Mr. Robarts, it is quite as well that we should know them. Even for all that I owe to her, and all the love I bear to you, I will not come to this house if I am to hear my husband abused;—not into any house.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“My dearest Fanny, we all know what happens when two angry people get together.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“I was not angry when I went up to her; not in the least.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“It is no good looking back. What are we to do now, Fanny?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“I suppose I had better go home,” said Mrs. Robarts. “I will go and put my things up, and then I will send James for them.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Wait till after lunch, and then you will be able to kiss my mother before you leave us.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“No, Justinia; I cannot wait. I must answer Mr. Robarts by this post, and I must think what I have to say to him. I could not write that letter here, and the post goes at four.” And Mrs. Robarts got up from her chair, preparatory to her final departure.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“I shall come to you before dinner,” said Lady Meredith; “and if I can bring you good tidings, I shall expect you to come back here with me. It is out of the question that I should go away from Framley leaving you and my mother at enmity with each other.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("To this Mrs. Robarts made no answer; and in a very few minutes afterwards she was in her own nursery, kissing her children, and teaching the elder one to say something about papa. But, even as she taught him, the tears stood in her eyes, and the little fellow knew that everything was not right.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("And there she sat till about two, doing little odds and ends of things for the children, and allowing that occupation to stand as an excuse to her for not commencing her letter. But then there remained only two hours to her, and it might be that the letter would be difficult in the writing—would require thought and changes, and must needs be copied, perhaps more than once. As to the money, that she had in the house—as much, at least, as Mark now wanted, though the sending of it would leave her nearly penniless. She could, however, in case of personal need, resort to Davis as desired by him.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("So she got out her desk in the drawing-room and sat down and wrote her letter. It was difficult, though she found that it hardly took so long as she expected. It was difficult, for she felt bound to tell him the truth; and yet she was anxious not to spoil all his pleasure among his friends. She told him, however, that Lady Lufton was very angry, “unreasonably angry, I must say,” she put in, in order to show that she had not sided against him. “And indeed we have quite quarrelled, and this has made me unhappy, as it will you, dearest; I know that. But we both know how good she is at heart, and Justinia thinks that she had other things to trouble her; and I hope it will all be made up before you come home; only, dearest Mark, pray do not be longer than you said in your last letter.” And then there were three or four paragraphs about the babies and two about the schools, which I may as well omit.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("She had just finished her letter, and was carefully folding it for its envelope, with the two whole five-pound notes imprudently placed within it, when she heard a footstep on the gravel path which led up from a small wicket to the front-door. The path ran near the drawing-room window, and she was just in time to catch a glimpse of the last fold of a passing cloak. “It is Justinia,” she said to herself; and her heart became disturbed at the idea of again discussing the morning’s adventure. “What am I to do,” she had said to herself before, “if she wants me to beg her pardon? I will not own before her that he is in the wrong.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("And then the door opened—for the visitor made her entrance without the aid of any servant—and Lady Lufton herself stood before her. “Fanny,” she said at once, “I have come to beg your pardon.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Oh, Lady Lufton!”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“I was very much harassed when you came to me just now;—by more things than one, my dear. But, nevertheless, I should not have spoken to you of your husband as I did, and so I have come to beg your pardon.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("Mrs. Robarts was past answering by the time that this was said,—past answering at least in words; so she jumped up and, with her eyes full of tears, threw herself into her old friend’s arms. “Oh, Lady Lufton!” she sobbed forth again.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“You will forgive me, won’t you?” said her ladyship, as she returned her young friend’s caress. “Well, that’s right. I have not been at all happy since you left my den this morning, and I don’t suppose you have. But, Fanny, dearest, we love each other too well and know each other too thoroughly, to have a long quarrel, don’t we?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Oh, yes, Lady Lufton.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Of course we do. Friends are not to be picked up on the road-side every day; nor are they to be thrown away lightly. And now sit down, my love, and let us have a little talk. There, I must take my bonnet off. You have pulled the strings so that you have almost choked me.” And Lady Lufton deposited her bonnet on the table and seated herself comfortably in the corner of the sofa.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“My dear,” she said, “there is no duty which any woman owes to any other human being at all equal to that which she owes to her husband, and, therefore, you were quite right to stand up for Mr. Robarts this morning.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("Upon this Mrs. Robarts said nothing, but she got her hand within that of her ladyship and gave it a slight squeeze.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“And I loved you for what you were doing all the time. I did, my dear; though you were a little fierce, you know. Even Justinia admits that, and she has been at me ever since you went away. And indeed, I did not know that it was in you to look in that way out of those pretty eyes of yours.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Oh, Lady Lufton!”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“But I looked fierce enough too myself, I daresay; so we’ll say nothing more about that; will we? But now, about this good man of yours?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Dear Lady Lufton, you must forgive him.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Well, as you ask me, I will. We’ll have nothing more said about the duke, either now or when he comes back; not a word. Let me see—he’s to be back;—when is it?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Wednesday week, I think.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Ah, Wednesday. Well, tell him to come and dine up at the house on Wednesday. He’ll be in time, I suppose, and there shan’t be a word said about this horrid duke.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“I am so much obliged to you, Lady Lufton.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“But look here, my dear; believe me, he’s better off without such friends.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Oh, I know he is; much better off.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Well, I’m glad you admit that, for I thought you seemed to be in favour of the duke.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Oh, no, Lady Lufton.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“That’s right, then. And now, if you’ll take my advice, you’ll use your influence, as a good, dear sweet wife as you are, to prevent his going there any more. I’m an old woman and he is a young man, and it’s very natural that he should think me behind the times. I’m not angry at that. But he’ll find that it’s better for him, better for him in every way, to stick to his old friends. It will be better for his peace of mind, better for his character as a clergyman, better for his pocket, better for his children and for you,—and better for his eternal welfare. The duke is not such a companion as he should seek;—nor if he is sought, should he allow himself to be led away.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("And then Lady Lufton ceased, and Fanny Robarts kneeling at her feet sobbed, with her face hidden on her friend’s knees. She had not a word now to say as to her husband’s capability of judging for himself.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“And now I must be going again; but Justinia has made me promise,—promise, mind you, most solemnly, that I would have you back to dinner to-night,—by force if necessary. It was the only way I could make my peace with her; so you must not leave me in the lurch.” Of course, Fanny said that she would go and dine at Framley Court.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“And you must not send that letter, by any means,” said her ladyship as she was leaving the room, poking with her umbrella at the epistle, which lay directed on Mrs. Robarts’s desk. “I can understand very well what it contains. You must alter it altogether, my dear.” And then Lady Lufton went.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("Mrs. Robarts instantly rushed to her desk and tore open her letter. She looked at her watch and it was past four. She had hardly begun another when the postman came. “Oh, Mary,” she said, “do make him wait. If he’ll wait a quarter of an hour I’ll give him a shilling.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“There’s no need of that, ma’am. Let him have a glass of beer.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Very well, Mary; but don’t give him too much, for fear he should drop the letters about. I’ll be ready in ten minutes.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("And in five minutes she had scrawled a very different sort of a letter. But he might want the money immediately, so she would not delay it for a day.")])])])])
}]}

/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(89),
  /* template */
  __webpack_require__(90),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 89 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 90 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('p', {
    staticClass: "ORIM-Chapter-Title-Page-Break"
  }, [_vm._v("CHAPTER VI")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Chapter-Subtitle"
  }, [_vm._v("Mr. Harold Smith’s Lecture")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Chapter-Opener-Paragraph"
  }, [_vm._v("On the whole the party at Chaldicotes was very pleasant, and the time passed away quickly enough. Mr. Robarts’s chief friend there, independently of Mr. Sowerby, was Miss Dunstable, who seemed to take a great fancy to him, whereas she was not very accessible to the blandishments of Mr. Supplehouse, nor more specially courteous even to her host than good manners required of her. But then Mr. Supplehouse and Mr. Sowerby were both bachelors, while Mark Robarts was a married man.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("With Mr. Sowerby Robarts had more than one communication respecting Lord Lufton and his affairs, which he would willingly have avoided had it been possible. Sowerby was one of those men who are always mixing up business with pleasure, and who have usually some scheme in their mind which requires forwarding. Men of this class have, as a rule, no daily work, no regular routine of labour; but it may be doubted whether they do not toil much more incessantly than those who have.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Lufton is so dilatory,” Mr. Sowerby said. “Why did he not arrange this at once, when he promised it? And then he is so afraid of that old woman at Framley Court. Well, my dear fellow, say what you will; she is an old woman and she’ll never be younger. But do write to Lufton and tell him that this delay is inconvenient to me; he’ll do anything for you, I know.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("Mark said that he would write, and, indeed, did do so; but he did not at first like the tone of the conversation into which he was dragged. It was very painful to him to hear Lady Lufton called an old woman, and hardly less so to discuss the propriety of Lord Lufton’s parting with his property. This was irksome to him, till habit made it easy. But by degrees his feelings became less acute, and he accustomed himself to his friend Sowerby’s mode of talking.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("And then on the Saturday afternoon they all went over to Barchester. Harold Smith during the last forty-eight hours had become crammed to overflowing with Sarawak, Labuan, New Guinea, and the Salomon Islands. As is the case with all men labouring under temporary specialities, he for the time had faith in nothing else, and was not content that any one near him should have any other faith. They called him Viscount Papua and Baron Borneo; and his wife, who headed the joke against him, insisted on having her title. Miss Dunstable swore that she would wed none but a South Sea islander; and to Mark was offered the income and duties of Bishop of Spices. Nor did the Proudie family set themselves against these little sarcastic quips with any overwhelming severity. It is sweet to unbend oneself at the proper opportunity, and this was the proper opportunity for Mrs. Proudie’s unbending. No mortal can be seriously wise at all hours; and in these happy hours did that usually wise mortal, the bishop, lay aside for awhile his serious wisdom.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“We think of dining at five to-morrow, my Lady Papua,” said the facetious bishop; “will that suit his lordship and the affairs of State? he! he! he!” And the good prelate laughed at the fun.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("How pleasantly young men and women of fifty or thereabouts can joke and flirt and poke their fun about, laughing and holding their sides, dealing in little innuendoes and rejoicing in nicknames when they have no Mentors of twenty-five or thirty near them to keep them in order. The vicar of Framley might perhaps have been regarded as such a Mentor, were it not for that capability of adapting himself to the company immediately around him on which he so much piqued himself. He therefore also talked to my Lady Papua, and was jocose about the Baron,—not altogether to the satisfaction of Mr. Harold Smith himself.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("For Mr. Harold Smith was in earnest and did not quite relish these jocundities. He had an idea that he could in about three months talk the British world into civilizing New Guinea, and that the world of Barsetshire would be made to go with him by one night’s efforts. He did not understand why others should be less serious, and was inclined to resent somewhat stiffly the amenities of our friend Mark.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“We must not keep the Baron waiting,” said Mark, as they were preparing to start for Barchester.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“I don’t know what you mean by the Baron, sir,” said Harold Smith. “But perhaps the joke will be against you, when you are getting up into your pulpit to-morrow and sending the hat round among the clodhoppers of Chaldicotes.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Those who live in glass houses shouldn’t throw stones; eh, Baron?” said Miss Dunstable. “Mr. Robarts’s sermon will be too near akin to your lecture to allow of his laughing.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“If we can do nothing towards instructing the outer world till it’s done by the parsons,” said Harold Smith, “the outer world will have to wait a long time, I fear.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Nobody can do anything of that kind short of a member of Parliament and a would-be minister,” whispered Mrs. Harold. And so they were all very pleasant together, in spite of a little fencing with edge-tools; and at three o’clock the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("cortège")]), _vm._v(" of carriages started for Barchester, that of the bishop, of course, leading the way. His lordship, however, was not in it.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Mrs. Proudie, I’m sure you’ll let me go with you,” said Miss Dunstable, at the last moment, as she came down the big stone steps. “I want to hear the rest of that story about Mr. Slope.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("Now this upset everything. The bishop was to have gone with his wife, Mrs. Smith, and Mark Robarts; and Mr. Sowerby had so arranged matters that he could have accompanied Miss Dunstable in his phaeton. But no one ever dreamed of denying Miss Dunstable anything. Of course Mark gave way; but it ended in the bishop declaring that he had no special predilection for his own carriage, which he did in compliance with a glance from his wife’s eye. Then other changes of course followed, and, at last, Mr. Sowerby and Harold Smith were the joint occupants of the phaeton.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("The poor lecturer, as he seated himself, made some remark such as those he had been making for the last two days—for out of a full heart the mouth speaketh. But he spoke to an impatient listener. “D—— the South Sea islanders,” said Mr. Sowerby. “You’ll have it all your own way in a few minutes, like a bull in a china-shop; but for Heaven’s sake let us have a little peace till that time comes.” It appeared that Mr. Sowerby’s little plan of having Miss Dunstable for his companion was not quite insignificant; and, indeed, it may be said that but few of his little plans were so. At the present moment he flung himself back in the carriage and prepared for sleep. He could further no plan of his by a "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("tête-à-tête")]), _vm._v(" conversation with his brother-in-law.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("And then Mrs. Proudie began her story about Mr. Slope, or rather recommenced it. She was very fond of talking about this gentleman, who had once been her pet chaplain but was now her bitterest foe; and in telling the story, she had sometimes to whisper to Miss Dunstable, for there were one or two fie-fie little anecdotes about a married lady, not altogether fit for young Mr. Robarts’s ears. But Mrs. Harold Smith insisted on having them out loud, and Miss Dunstable would gratify that lady in spite of Mrs. Proudie’s winks.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“What, kissing her hand, and he a clergyman!” said Miss Dunstable. “I did not think they ever did such things, Mr. Robarts.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Still waters run deepest,” said Mrs. Harold Smith.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Hush-h-h,” looked, rather than spoke, Mrs. Proudie. “The grief of spirit which that bad man caused me nearly broke my heart, and all the while, you know, he was courting—” and then Mrs. Proudie whispered a name.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“What, the dean’s wife!” shouted Miss Dunstable, in a voice which made the coachman of the next carriage give a chuck to his horses as he overheard her.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“The archdeacon’s sister-in-law!” screamed Mrs. Harold Smith.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“What might he not have attempted next?” said Miss Dunstable.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“She wasn’t the dean’s wife then, you know,” said Mrs. Proudie, explaining.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Well, you’ve a gay set in the chapter, I must say,” said Miss Dunstable. “You ought to make one of them in Barchester, Mr. Robarts.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Only perhaps Mrs. Robarts might not like it,” said Mrs. Harold Smith.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“And then the schemes which he tried on with the bishop!” said Mrs. Proudie.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“It’s all fair in love and war, you know,” said Miss Dunstable.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“But he little knew whom he had to deal with when he began that,” said Mrs. Proudie.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“The bishop was too many for him,” suggested Mrs. Harold Smith, very maliciously.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“If the bishop was not, somebody else was; and he was obliged to leave Barchester in utter disgrace. He has since married the wife of some tallow-chandler.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“The wife!” said Miss Dunstable. “What a man!”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Widow, I mean; but it’s all one to him.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“The gentleman was clearly born when Venus was in the ascendant,” said Mrs. Smith. “You clergymen usually are, I believe, Mr. Robarts.” So that Mrs. Proudie’s carriage was by no means the dullest as they drove into Barchester that day; and by degrees our friend Mark became accustomed to his companions, and before they reached the palace he acknowledged to himself that Miss Dunstable was very good fun.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("We cannot linger over the bishop’s dinner, though it was very good of its kind; and as Mr. Sowerby contrived to sit next to Miss Dunstable, thereby overturning a little scheme made by Mr. Supplehouse, he again shone forth in unclouded good humour. But Mr. Harold Smith became impatient immediately on the withdrawal of the cloth. The lecture was to begin at seven, and according to his watch that hour had already come. He declared that Sowerby and Supplehouse were endeavouring to delay matters in order that the Barchesterians might become vexed and impatient; and so the bishop was not allowed to exercise his hospitality in true episcopal fashion.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“You forget, Sowerby,” said Supplehouse, “that the world here for the last fortnight has been looking forward to nothing else.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“The world shall be gratified at once,” said Mrs. Harold, obeying a little nod from Mrs. Proudie. “Come, my dear,” and she took hold of Miss Dunstable’s arm, “don’t let us keep Barchester waiting. We shall be ready in a quarter-of-an-hour, shall we not, Mrs. Proudie?” and so they sailed off.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“And we shall have time for one glass of claret,” said the bishop.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“There; that’s seven by the cathedral,” said Harold Smith, jumping up from his chair as he heard the clock. “If the people have come it would not be right in me to keep them waiting, and I shall go.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Just one glass of claret, Mr. Smith, and we’ll be off,” said the bishop.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Those women will keep me an hour,” said Harold, filling his glass, and drinking it standing. “They do it on purpose.” He was thinking of his wife, but it seemed to the bishop as though his guest were actually speaking of Mrs. Proudie.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("It was rather late when they all found themselves in the big room of the Mechanics’ Institute; but I do not know whether this on the whole did them any harm. Most of Mr. Smith’s hearers, excepting the party from the palace, were Barchester tradesmen with their wives and families; and they waited, not impatiently, for the big people. And then the lecture was gratis, a fact which is always borne in mind by an Englishman when he comes to reckon up and calculate the way in which he is treated. When he pays his money, then he takes his choice; he may be impatient or not as he likes. His sense of justice teaches him so much, and in accordance with that sense he usually acts.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("So the people on the benches rose graciously when the palace party entered the room. Seats for them had been kept in the front. There were three arm-chairs, which were filled, after some little hesitation, by the bishop, Mrs. Proudie, and Miss Dunstable—Mrs. Smith positively declining to take one of them; though, as she admitted, her rank as Lady Papua of the islands did give her some claim. And this remark, as it was made quite out loud, reached Mr. Smith’s ears as he stood behind a little table on a small raised dais, holding his white kid gloves; and it annoyed him and rather put him out. He did not like that joke about Lady Papua.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("And then the others of the party sat upon a front bench covered with red cloth. “We shall find this very hard and very narrow about the second hour,” said Mr. Sowerby, and Mr. Smith on his dais again overheard the words, and dashed his gloves down to the table. He felt that all the room would hear it.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("And there were one or two gentlemen on the second seat who shook hands with some of our party. There was Mr. Thorne of Ullathorne, a good-natured old bachelor, whose residence was near enough to Barchester to allow of his coming in without much personal inconvenience; and next to him was Mr. Harding, an old clergyman of the chapter, with whom Mrs. Proudie shook hands very graciously, making way for him to seat himself close behind her if he would so please. But Mr. Harding did not so please. Having paid his respects to the bishop he returned quietly to the side of his old friend Mr. Thorne, thereby angering Mrs. Proudie, as might easily be seen by her face. And Mr. Chadwick also was there, the episcopal man of business for the diocese; but he also adhered to the two gentlemen above named.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("And now that the bishop and the ladies had taken their places, Mr. Harold Smith relifted his gloves and again laid them down, hummed three times distinctly, and then began.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“It was,” he said, “the most peculiar characteristic of the present era in the British islands that those who were high placed before the world in rank, wealth, and education were willing to come forward and give their time and knowledge without fee or reward, for the advantage and amelioration of those who did not stand so high in the social scale.” And then he paused for a moment, during which Mrs. Smith remarked to Miss Dunstable that that was pretty well for a beginning; and Miss Dunstable replied, “that as for herself she felt very grateful to rank, wealth, and education.” Mr. Sowerby winked to Mr. Supplehouse, who opened his eyes very wide and shrugged his shoulders. But the Barchesterians took it all in good part and gave the lecturer the applause of their hands and feet.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("And then, well pleased, he recommenced—“I do not make these remarks with reference to myself—”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“I hope he’s not going to be modest,” said Miss Dunstable.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“It will be quite new if he is,” replied Mrs. Smith.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“—so much as to many noble and talented lords and members of the Lower House who have lately from time to time devoted themselves to this good work.” And then he went through a long list of peers and members of Parliament, beginning, of course, with Lord Boanerges, and ending with Mr. Green Walker, a young gentleman who had lately been returned by his uncle’s interest for the borough of Crewe Junction, and had immediately made his entrance into public life by giving a lecture on the grammarians of the Latin language as exemplified at Eton school.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“On the present occasion,” Mr. Smith continued, “our object is to learn something as to those grand and magnificent islands which lie far away, beyond the Indies, in the Southern Ocean; the lands of which produce rich spices and glorious fruits, and whose seas are imbedded with pearls and corals,—Papua and the Philippines, Borneo and the Moluccas. My friends, you are familiar with your maps, and you know the track which the equator makes for itself through those distant oceans.” And then many heads were turned down, and there was a rustle of leaves; for not a few of those “who stood not so high in the social scale” had brought their maps with them, and refreshed their memories as to the whereabouts of these wondrous islands.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("And then Mr. Smith also, with a map in his hand, and pointing occasionally to another large map which hung against the wall, went into the geography of the matter. “We might have found that out from our atlases, I think, without coming all the way to Barchester,” said that unsympathizing helpmate, Mrs. Harold, very cruelly—most illogically too, for there be so many things which we could find out ourselves by search, but which we never do find out unless they be specially told us; and why should not the latitude and longitude of Labuan be one—or rather two of these things?")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("And then, when he had duly marked the path of the line through Borneo, Celebes, and Gilolo, through the Macassar Strait and the Molucca Passage, Mr. Harold Smith rose to a higher flight. “But what,” said he, “avails all that God can give to man, unless man will open his hand to receive the gift? And what is this opening of the hand but the process of civilization—yes, my friends, the process of civilization? These South Sea islanders have all that a kind Providence can bestow on them; but that all is as nothing without education. That education and that civilization it is for you to bestow upon them—yes, my friends, for you; for you, citizens of Barchester as you are.” And then he paused again, in order that the feet and hands might go to work. The feet and hands did go to work, during which Mr. Smith took a slight drink of water.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("He was now quite in his element and had got into the proper way of punching the table with his fists. A few words dropping from Mr. Sowerby did now and again find their way to his ears, but the sound of his own voice had brought with it the accustomed charm, and he ran on from platitude to truism, and from truism back to platitude, with an eloquence that was charming to himself.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Civilization,” he exclaimed, lifting up his eyes and hands to the ceiling. “Oh, civilization—”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“There will not be a chance for us now for the next hour and a half,” said Mr. Supplehouse, groaning.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("Harold Smith cast one eye down at him, but it immediately flew back to the ceiling.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Oh, civilization! thou that ennoblest mankind and makest him equal to the gods, what is like unto thee?” Here Mrs. Proudie showed evident signs of disapprobation, which no doubt would have been shared by the bishop, had not that worthy prelate been asleep. But Mr. Smith continued unobservant; or, at any rate, regardless.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“What is like unto thee? Thou art the irrigating stream which makest fertile the barren plain. Till thou comest all is dark and dreary; but at thy advent the noontide sun shines out, the earth gives forth her increase; the deep bowels of the rocks render up their tribute. Forms which were dull and hideous become endowed with grace and beauty, and vegetable existence rises to the scale of celestial life. Then, too, Genius appears clad in a panoply of translucent armour, grasping in his hand the whole terrestrial surface, and making every rood of earth subservient to his purposes;—Genius, the child of civilization, the mother of the Arts!”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("The last little bit, taken from the Pedigree of Progress, had a great success, and all Barchester went to work with its hands and feet;—all Barchester, except that ill-natured aristocratic front-row together with the three arm-chairs at the corner of it. The aristocratic front-row felt itself to be too intimate with civilization to care much about it; and the three arm-chairs, or rather that special one which contained Mrs. Proudie, considered that there was a certain heathenness, a pagan sentimentality almost amounting to infidelity, contained in the lecturer’s remarks, with which she, a pillar of the Church, could not put up, seated as she was now in public conclave.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“It is to civilization that we must look,” continued Mr. Harold Smith, descending from poetry to prose as a lecturer well knows how, and thereby showing the value of both—“for any material progress in these islands; and—”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“And to Christianity,” shouted Mrs. Proudie, to the great amazement of the assembled people and to the thorough wakening of the bishop, who, jumping up in his chair at the sound of the well-known voice, exclaimed, “Certainly, certainly.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Hear, hear, hear,” said those on the benches who particularly belonged to Mrs. Proudie’s school of divinity in the city, and among the voices was distinctly heard that of a new verger in whose behalf she had greatly interested herself.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Oh, yes, Christianity of course,” said Harold Smith, upon whom the interruption did not seem to operate favourably.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Christianity and Sabbath-day observance,” exclaimed Mrs. Proudie, who, now that she had obtained the ear of the public, seemed well inclined to keep it. “Let us never forget that these islanders can never prosper unless they keep the Sabbath holy.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("Poor Mr. Smith, having been so rudely dragged from his high horse, was never able to mount it again, and completed the lecture in a manner not at all comfortable to himself. He had there, on the table before him, a huge bundle of statistics with which he had meant to convince the reason of his hearers after he had taken full possession of their feelings. But they fell very dull and flat. And at the moment when he was interrupted he was about to explain that that material progress to which he had alluded could not be attained without money; and that it behoved them, the people of Barchester before him, to come forward with their purses like men and brothers. He did also attempt this; but from the moment of that fatal onslaught from the arm-chair, it was clear to him and to every one else, that Mrs. Proudie was now the hero of the hour. His time had gone by, and the people of Barchester did not care a straw for his appeal.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("From these causes the lecture was over full twenty minutes earlier than any one had expected, to the great delight of Messrs. Sowerby and Supplehouse, who, on that evening, moved and carried a vote of thanks to Mrs. Proudie. For they had gay doings yet before they went to their beds.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Robarts, here one moment,” Mr. Sowerby said, as they were standing at the door of the Mechanics’ Institute. “Don’t you go off with Mr. and Mrs. Bishop. We are going to have a little supper at the Dragon of Wantly, and after what we have gone through upon my word we want it. You can tell one of the palace servants to let you in.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("Mark considered the proposal wistfully. He would fain have joined the supper-party had he dared; but he, like many others of his cloth, had the fear of Mrs. Proudie before his eyes.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("And a very merry supper they had; but poor Mr. Harold Smith was not the merriest of the party.")])])])])
}]}

/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(92),
  /* template */
  __webpack_require__(93),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 93 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('p', {
    staticClass: "ORIM-Chapter-Title-Page-Break"
  }, [_vm._v("CHAPTER VII")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Chapter-Subtitle"
  }, [_vm._v("Sunday Morning")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Chapter-Opener-Paragraph"
  }, [_vm._v("It was, perhaps, quite as well on the whole for Mark Robarts, that he did not go to that supper party. It was eleven o’clock before they sat down, and nearly two before the gentlemen were in bed. It must be remembered that he had to preach, on the coming Sunday morning, a charity sermon on behalf of a mission to Mr. Harold Smith’s islanders; and, to tell the truth, it was a task for which he had now very little inclination.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("When first invited to do this, he had regarded the task seriously enough, as he always did regard such work, and he completed his sermon for the occasion before he left Framley; but, since that, an air of ridicule had been thrown over the whole affair, in which he had joined without much thinking of his own sermon, and this made him now heartily wish that he could choose a discourse upon any other subject.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("He knew well that the very points on which he had most insisted, were those which had drawn most mirth from Miss Dunstable and Mrs. Smith, and had oftenest provoked his own laughter; and how was he now to preach on those matters in a fitting mood, knowing, as he would know, that those two ladies would be looking at him, would endeavour to catch his eye, and would turn him into ridicule as they had already turned the lecturer?")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("In this he did injustice to one of the ladies, unconsciously. Miss Dunstable, with all her aptitude for mirth, and we may almost fairly say for frolic, was in no way inclined to ridicule religion or anything which she thought to appertain to it. It may be presumed that among such things she did not include Mrs. Proudie, as she was willing enough to laugh at that lady; but Mark, had he known her better, might have been sure that she would have sat out his sermon with perfect propriety.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("As it was, however, he did feel considerable uneasiness; and in the morning he got up early with the view of seeing what might be done in the way of emendation. He cut out those parts which referred most specially to the islands,—he rejected altogether those names over which they had all laughed together so heartily,—and he inserted a string of general remarks, very useful, no doubt, which he flattered himself would rob his sermon of all similarity to Harold Smith’s lecture. He had, perhaps, hoped, when writing it, to create some little sensation; but now he would be quite satisfied if it passed without remark.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("But his troubles for that Sunday were destined to be many. It had been arranged that the party at the hotel should breakfast at eight, and start at half-past eight punctually, so as to enable them to reach Chaldicotes in ample time to arrange their dresses before they went to church. The church stood in the grounds, close to that long formal avenue of lime-trees, but within the front gates. Their walk, therefore, after reaching Mr. Sowerby’s house, would not be long.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("Mrs. Proudie, who was herself an early body, would not hear of her guest—and he a clergyman—going out to the inn for his breakfast on a Sunday morning. As regarded that Sabbath-day journey to Chaldicotes, to that she had given her assent, no doubt with much uneasiness of mind; but let them have as little desecration as possible. It was, therefore, an understood thing that he was to return with his friends; but he should not go without the advantage of family prayers and family breakfast. And so Mrs. Proudie on retiring to rest gave the necessary orders, to the great annoyance of her household.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("To the great annoyance, at least, of her servants! The bishop himself did not make his appearance till a much later hour. He in all things now supported his wife’s rule; in all things, now, I say; for there had been a moment, when in the first flush and pride of his episcopacy other ideas had filled his mind. Now, however, he gave no opposition to that good woman with whom Providence had blessed him; and in return for such conduct that good woman administered in all things to his little personal comforts. With what surprise did the bishop now look back upon that unholy war which he had once been tempted to wage against the wife of his bosom! Nor did any of the Miss Proudies show themselves at that early hour. They, perhaps, were absent on a different ground. With them Mrs. Proudie had not been so successful as with the bishop. They had wills of their own which became stronger and stronger every day. Of the three with whom Mrs. Proudie was blessed one was already in a position to exercise that will in a legitimate way over a very excellent young clergyman in the diocese, the Rev. Optimus Grey; but the other two, having as yet no such opening for their powers of command, were perhaps a little too much inclined to keep themselves in practice at home. But at half-past seven punctually Mrs. Proudie was there, and so was the domestic chaplain; so was Mr. Robarts, and so were the household servants,—all excepting one lazy recreant. “Where is Thomas?” said she of the Argus eyes, standing up with her book of family prayers in her hand. ")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“So please you, ma’am, Tummas be bad with the tooth-ache.” ")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Tooth-ache!” exclaimed Mrs. Proudie; but her eyes said more terrible things than that. “Let Thomas come to me before church.” And then they proceeded to prayers. These were read by the chaplain, as it was proper and decent that they should be; but I cannot but think that Mrs. Proudie a little exceeded her office in taking upon herself to pronounce the blessing when the prayers were over. She did it, however, in a clear, sonorous voice, and perhaps with more personal dignity than was within the chaplain’s compass.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("Mrs. Proudie was rather stern at breakfast, and the vicar of Framley felt an unaccountable desire to get out of the house. In the first place she was not dressed with her usual punctilious attention to the proprieties of her high situation. It was evident that there was to be a further toilet before she sailed up the middle of the cathedral choir. She had on a large loose cap with no other strings than those which were wanted for tying it beneath her chin, a cap with which the household and the chaplain were well acquainted, but which seemed ungracious in the eyes of Mr. Robarts after all the well-dressed holiday doings of the last week. She wore also a large, loose, dark-coloured wrapper, which came well up round her neck, and which was not buoyed out, as were her dresses in general, with an under mechanism of petticoats. It clung to her closely, and added to the inflexibility of her general appearance. And then she had encased her feet in large carpet slippers, which no doubt were comfortable, but which struck her visitor as being strange and unsightly.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Do you find a difficulty in getting your people together for early morning prayers?” she said, as she commenced her operations with the teapot.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“I can’t say that I do,” said Mark. “But then we are seldom so early as this.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Parish clergymen should be early, I think,” said she. “It sets a good example in the village.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“I am thinking of having morning prayers in the church,” said Mr. Robarts.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“That’s nonsense,” said Mrs. Proudie, “and usually means worse than nonsense. I know what that comes to. If you have three services on Sunday and domestic prayers at home, you do very well.” And so saying she handed him his cup.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“But I have not three services on Sunday, Mrs. Proudie.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Then I think you should have. Where can the poor people be so well off on Sundays as in church? The bishop intends to express a very strong opinion on this subject in his next charge; and then I am sure you will attend to his wishes.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("To this Mark made no answer, but devoted himself to his egg.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“I suppose you have not a very large establishment at Framley?” asked Mrs. Proudie.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“What, at the parsonage?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Yes; you live at the parsonage, don’t you?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Certainly—well; not very large, Mrs. Proudie; just enough to do the work, make things comfortable, and look after the children.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“It is a very fine living,” said she; “very fine. I don’t remember that we have anything so good ourselves,—except it is Plumstead, the archdeacon’s place. He has managed to butter his bread pretty well.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“His father was Bishop of Barchester.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Oh, yes, I know all about him. Only for that he would barely have risen to be an archdeacon, I suspect. Let me see; yours is £800, is it not, Mr. Robarts? And you such a young man! I suppose you have insured your life highly.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Pretty well, Mrs. Proudie.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“And then, too, your wife had some little fortune, had she not? We cannot all fall on our feet like that; can we, Mr. White?” and Mrs. Proudie in her playful way appealed to the chaplain.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("Mrs. Proudie was an imperious woman; but then so also was Lady Lufton; and it may therefore be said that Mr. Robarts ought to have been accustomed to feminine domination; but as he sat there munching his toast he could not but make a comparison between the two. Lady Lufton in her little attempts sometimes angered him; but he certainly thought, comparing the lay lady and the clerical together, that the rule of the former was the lighter and the pleasanter. But then Lady Lufton had given him a living and a wife, and Mrs. Proudie had given him nothing.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("Immediately after breakfast Mr. Robarts escaped to the Dragon of Wantly, partly because he had had enough of the matutinal Mrs. Proudie, and partly also in order that he might hurry his friends there. He was already becoming fidgety about the time, as Harold Smith had been on the preceding evening, and he did not give Mrs. Smith credit for much punctuality. When he arrived at the inn he asked if they had done breakfast, and was immediately told that not one of them was yet down. It was already half-past eight, and they ought to be now under weigh on the road.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("He immediately went to Mr. Sowerby’s room, and found that gentleman shaving himself. “Don’t be a bit uneasy,” said Mr. Sowerby. “You and Smith shall have my phaeton, and those horses will take you there in an hour. Not, however, but what we shall all be in time. We’ll send round to the whole party and ferret them out.” And then Mr. Sowerby, having evoked manifold aid with various peals of the bell, sent messengers, male and female, flying to all the different rooms.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“I think I’ll hire a gig and go over at once,” said Mark. “It would not do for me to be late, you know.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“It won’t do for any of us to be late; and it’s all nonsense about hiring a gig. It would be just throwing a sovereign away, and we should pass you on the road. Go down and see that the tea is made, and all that; and make them have the bill ready; and, Robarts, you may pay it too, if you like it. But I believe we may as well leave that to Baron Borneo—eh?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("And then Mark did go down and make the tea, and he did order the bill; and then he walked about the room, looking at his watch, and nervously waiting for the footsteps of his friends. And as he was so employed, he bethought himself whether it was fit that he should be so doing on a Sunday morning; whether it was good that he should be waiting there, in painful anxiety, to gallop over a dozen miles in order that he might not be too late with his sermon; whether his own snug room at home, with Fanny opposite to him, and his bairns crawling on the floor, with his own preparations for his own quiet service, and the warm pressure of Lady Lufton’s hand when that service should be over, was not better than all this.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("He could not afford not to know Harold Smith, and Mr. Sowerby, and the Duke of Omnium, he had said to himself. He had to look to rise in the world, as other men did. But what pleasure had come to him as yet from these intimacies? How much had he hitherto done towards his rising? To speak the truth he was not over well pleased with himself, as he made Mrs. Harold Smith’s tea and ordered Mr. Sowerby’s mutton-chops on that Sunday morning.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("At a little after nine they all assembled; but even then he could not make the ladies understand that there was any cause for hurry; at least Mrs. Smith, who was the leader of the party, would not understand it. When Mark again talked of hiring a gig, Miss Dunstable indeed said that she would join him; and seemed to be so far earnest in the matter that Mr. Sowerby hurried through his second egg in order to prevent such a catastrophe. And then Mark absolutely did order the gig; whereupon Mrs. Smith remarked that in such case she need not hurry herself; but the waiter brought up word that all the horses of the hotel were out, excepting one pair, neither of which could go in single harness. Indeed, half of their stable establishment was already secured by Mr. Sowerby’s own party.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Then let me have the pair,” said Mark, almost frantic with delay.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Nonsense, Robarts; we are ready now. He won’t want them, James. Come, Supplehouse, have you done?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Then I am to hurry myself, am I?” said Mrs. Harold Smith. “What changeable creatures you men are! May I be allowed half a cup more tea, Mr. Robarts?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("Mark, who was now really angry, turned away to the window. There was no charity in these people, he said to himself. They knew the nature of his distress, and yet they only laughed at him. He did not, perhaps, reflect that he had assisted in the joke against Harold Smith on the previous evening.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“James,” said he, turning to the waiter, “let me have that pair of horses immediately, if you please.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Yes, sir; round in fifteen minutes, sir; only Ned, sir, the post-boy, sir; I fear he’s at his breakfast, sir; but we’ll have him here in less than no time, sir!”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("But before Ned and the pair were there, Mrs. Smith had absolutely got her bonnet on, and at ten they started. Mark did share the phaeton with Harold Smith, but the phaeton did not go any faster than the other carriages. They led the way, indeed, but that was all; and when the vicar’s watch told him that it was eleven, they were still a mile from Chaldicotes’ gate, although the horses were in a lather of steam; and they had only just entered the village when the church bells ceased to be heard.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Come, you are in time, after all,” said Harold Smith. “Better time than I was last night.” Robarts could not explain to him that the entry of a clergyman into church, of a clergyman who is going to assist in the service, should not be made at the last minute, that it should be staid and decorous, and not done in scrambling haste, with running feet and scant breath.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“I suppose we’ll stop here, sir,” said the postilion, as he pulled up his horses short at the church-door, in the midst of the people who were congregated together ready for the service. But Mark had not anticipated being so late, and said at first that it was necessary that he should go on to the house; then, when the horses had again begun to move, he remembered that he could send for his gown, and as he got out of the carriage he gave his orders accordingly. And now the other two carriages were there, and so there was a noise and confusion at the door—very unseemly, as Mark felt it; and the gentlemen spoke in loud voices, and Mrs. Harold Smith declared that she had no prayer-book, and was much too tired to go in at present;—she would go home and rest herself, she said. And two other ladies of the party did so also, leaving Miss Dunstable to go alone;—for which, however, she did not care one button. And then one of the party, who had a nasty habit of swearing, cursed at something as he walked in close to Mark’s elbow; and so they made their way up the church as the absolution was being read, and Mark Robarts felt thoroughly ashamed of himself. If his rising in the world brought him in contact with such things as these, would it not be better for him that he should do without rising?")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("His sermon went off without any special notice. Mrs. Harold Smith was not there, much to his satisfaction; and the others who were did not seem to pay any special attention to it. The subject had lost its novelty, except with the ordinary church congregation, the farmers and labourers of the parish; and the “quality” in the squire’s great pew were content to show their sympathy by a moderate subscription. Miss Dunstable, however, gave a ten-pound note, which swelled up the sum total to a respectable amount—for such a place as Chaldicotes.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“And now I hope I may never hear another word about New Guinea,” said Mr. Sowerby, as they all clustered round the drawing-room fire after church. “That subject may be regarded as having been killed and buried; eh, Harold?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Certainly murdered last night,” said Mrs. Harold, “by that awful woman, Mrs. Proudie.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“I wonder you did not make a dash at her and pull her out of the arm-chair,” said Miss Dunstable. “I was expecting it, and thought that I should come to grief in the scrimmage.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“I never knew a lady do such a brazen-faced thing before,” said Miss Kerrigy, a travelling friend of Miss Dunstable’s.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Nor I—never; in a public place, too,” said Dr. Easyman, a medical gentleman, who also often accompanied her.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“As for brass,” said Mr. Supplehouse, “she would never stop at anything for want of that. It is well that she has enough, for the poor bishop is but badly provided.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“I hardly heard what it was she did say,” said Harold Smith; “so I could not answer her, you know. Something about Sundays, I believe.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“She hoped you would not put the South Sea islanders up to Sabbath travelling,” said Mr. Sowerby.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“And specially begged that you would establish Lord’s-day schools,” said Mrs. Smith; and then they all went to work and picked Mrs. Proudie to pieces from the top ribbon of her cap down to the sole of her slipper.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“And then she expects the poor parsons to fall in love with her daughters. That’s the hardest thing of all,” said Miss Dunstable.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("But, on the whole, when our vicar went to bed he did not feel that he had spent a profitable Sunday.")])])])])
}]}

/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(95),
  /* template */
  __webpack_require__(96),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 96 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('p', {
    staticClass: "ORIM-Chapter-Title-Page-Break"
  }, [_vm._v("CHAPTER VIII")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Chapter-Subtitle"
  }, [_vm._v("Gatherum Castle")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Chapter-Opener-Paragraph"
  }, [_vm._v("On the Tuesday morning Mark did receive his wife’s letter and the ten-pound note, whereby a strong proof was given of the honesty of the post-office people in Barsetshire. That letter, written as it had been in a hurry, while Robin post-boy was drinking a single mug of beer,—well, what of it if it was half filled a second time?—was nevertheless eloquent of his wife’s love and of her great triumph."), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("I have only half a moment to send you the money [she said], for the postman is here waiting. When I see you I’ll explain why I am so hurried. Let me know that you get it safe. It is all right now, and Lady Lufton was here not a minute ago. She did not quite like it; about Gatherum Castle I mean; but you’ll hear "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("nothing about it")]), _vm._v(". Only remember that "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("you must dine")]), _vm._v(" at Framley Court on Wednesday week. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("I have promised for you")]), _c('span', {
    staticClass: "u"
  }, [_vm._v(".")]), _vm._v(" You will; won’t you, dearest? I shall come and fetch you away if you attempt to stay longer than you have said. But I’m sure you won’t. God bless you, my own one! Mr. Jones gave us the same sermon he preached the second Sunday after Easter. Twice in the same year is too often. God bless you! The children "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("are quite well")]), _vm._v(". Mark sends a big kiss.—Your own F.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("Robarts, as he read this letter and crumpled the note up into his pocket, felt that it was much more satisfactory than he deserved. He knew that there must have been a fight, and that his wife, fighting loyally on his behalf, had got the best of it; and he knew also that her victory had not been owing to the goodness of her cause. He frequently declared to himself that he would not be afraid of Lady Lufton; but nevertheless these tidings that no reproaches were to be made to him afforded him great relief.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("On the following Friday they all went to the duke’s, and found that the bishop and Mrs. Proudie were there before them; as were also sundry other people, mostly of some note, either in the estimation of the world at large or of that of West Barsetshire. Lord Boanerges was there, an old man who would have his own way in everything, and who was regarded by all men—apparently even by the duke himself—as an intellectual king, by no means of the constitutional kind,—as an intellectual emperor, rather, who took upon himself to rule all questions of mind without the assistance of any ministers whatever. And Baron Brawl was of the party, one of her Majesty’s puisne judges, as jovial a guest as ever entered a country house; but given to be rather sharp withal in his jovialities. And there was Mr. Green Walker, a young but rising man, the same who lectured not long since on a popular subject to his constituents at the Crewe Junction. Mr. Green Walker was a nephew of the Marchioness of Hartletop, and the Marchioness of Hartletop was a friend of the Duke of Omnium’s. Mr. Mark Robarts was certainly elated when he ascertained who composed the company of which he had been so earnestly pressed to make a portion. Would it have been wise in him to forego this on account of the prejudices of Lady Lufton?")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("As the guests were so many and so great, the huge front portals of Gatherum Castle were thrown open, and the vast hall, adorned with trophies—with marble busts from Italy and armour from Wardour Street,—was thronged with gentlemen and ladies, and gave forth unwonted echoes to many a footstep. His grace himself, when Mark arrived there with Sowerby and Miss Dunstable—for in this instance Miss Dunstable did travel in the phaeton while Mark occupied a seat in the dicky—his grace himself was at this moment in the drawing-room, and nothing could exceed his urbanity.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Oh, Miss Dunstable,” he said, taking that lady by the hand, and leading her up to the fire, “now I feel for the first time that Gatherum Castle has not been built for nothing.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Nobody ever supposed it was, your grace,” said Miss Dunstable. “I am sure the architect did not think so when his bill was paid.” And Miss Dunstable put her toes up on the fender to warm them with as much self-possession as though her father had been a duke also, instead of a quack doctor.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“We have given the strictest orders about the parrot,” said the duke—")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Ah! but I have not brought him after all,” said Miss Dunstable.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“—and I have had an aviary built on purpose,—just such as parrots are used to in their own country. Well, Miss Dunstable, I do call that unkind. Is it too late to send for him?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“He and Dr. Easyman are travelling together. The truth was, I could not rob the doctor of his companion.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Why? I have had another aviary built for him. I declare, Miss Dunstable, the honour you are doing me is shorn of half its glory. But the poodle—I still trust in the poodle.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“And your grace’s trust shall not in that respect be in vain. Where is he, I wonder?” And Miss Dunstable looked round as though she expected that somebody would certainly have brought her dog in after her. “I declare I must go and look for him,—only think if they were to put him among your grace’s dogs,—how his morals would be destroyed!”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Miss Dunstable, is that intended to be personal?” But the lady had turned away from the fire, and the duke was able to welcome his other guests.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("This he did with much courtesy. “Sowerby,” he said, “I am glad to find that you have survived the lecture. I can assure you I had fears for you.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“I was brought back to life after considerable delay by the administration of tonics at the Dragon of Wantly. Will your grace allow me to present to you Mr. Robarts, who on that occasion was not so fortunate. It was found necessary to carry him off to the palace, where he was obliged to undergo very vigorous treatment.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("And then the duke shook hands with Mr. Robarts, assuring him that he was most happy to make his acquaintance. He had often heard of him since he came into the county; and then he asked after Lord Lufton, regretting that he had been unable to induce his lordship to come to Gatherum Castle.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“But you had a diversion at the lecture, I am told,” continued the duke. “There was a second performer, was there not, who almost eclipsed poor Harold Smith?” And then Mr. Sowerby gave an amusing sketch of the little Proudie episode.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“It has, of course, ruined your brother-in-law for ever as a lecturer,” said the duke, laughing.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“If so, we shall feel ourselves under the deepest obligations to Mrs. Proudie,” said Mr. Sowerby. And then Harold Smith himself came up and received the duke’s sincere and hearty congratulations on the success of his enterprise at Barchester.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("Mark Robarts had now turned away, and his attention was suddenly arrested by the loud voice of Miss Dunstable, who had stumbled across some very dear friends in her passage through the rooms, and who by no means hid from the public her delight upon the occasion.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Well—well—well!” she exclaimed, and then she seized upon a very quiet-looking, well-dressed, attractive young woman who was walking towards her, in company with a gentleman. The gentleman and lady, as it turned out, were husband and wife. “Well—well—well! I hardly hoped for this.” And then she took hold of the lady and kissed her enthusiastically, and after that grasped both the gentleman’s hands, shaking them stoutly.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“And what a deal I shall have to say to you!” she went on. “You’ll upset all my other plans. But, Mary, my dear, how long are you going to stay here? I go—let me see—I forget when, but it’s all put down in a book upstairs. But the next stage is at Mrs. Proudie’s. I shan’t meet you there, I suppose. And now, Frank, how’s the governor?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("The gentleman called Frank declared that the governor was all right—“mad about the hounds, of course, you know.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Well, my dear, that’s better than the hounds being mad about him, like the poor gentleman they’ve put into a statue. But talking of hounds, Frank, how badly they manage their foxes at Chaldicotes! I was out hunting all one day—”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“You out hunting!” said the lady called Mary.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“And why shouldn’t I go out hunting? I’ll tell you what, Mrs. Proudie was out hunting, too. But they didn’t catch a single fox; and, if you must have the truth, it seemed to me to be rather slow.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“You were in the wrong division of the county,” said the gentleman called Frank.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Of course I was. When I really want to practise hunting I’ll go to Greshamsbury; not a doubt about that.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Or to Boxall Hill,” said the lady; “you’ll find quite as much zeal there as at Greshamsbury.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“And more discretion, you should add,” said the gentleman.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Ha! ha! ha!” laughed Miss Dunstable; “your discretion indeed! But you have not told me a word about Lady Arabella.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“My mother is quite well,” said the gentleman.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“And the doctor? By-the-by, my dear, I’ve had such a letter from the doctor; only two days ago. I’ll show it you upstairs to-morrow. But mind, it must be a positive secret. If he goes on in this way he’ll get himself into the Tower, or Coventry, or a blue-book, or some dreadful place.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Why; what has he said?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Never you mind, Master Frank: I don’t mean to show you the letter, you may be sure of that. But if your wife will swear three times on a poker and tongs that she won’t reveal, I’ll show it to her. And so you are quite settled at Boxall Hill, are you?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Frank’s horses are settled; and the dogs nearly so,” said Frank’s wife; “but I can’t boast much of anything else yet.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Well, there’s a good time coming. I must go and change my things now. But, Mary, mind you get near me this evening; I have such a deal to say to you.” And then Miss Dunstable marched out of the room.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("All this had been said in so loud a voice that it was, as a matter of course, overheard by Mark Robarts—that part of the conversation of course I mean which had come from Miss Dunstable. And then Mark learned that this was young Frank Gresham of Boxall Hill, son of old Mr. Gresham of Greshamsbury. Frank had lately married a great heiress; a greater heiress, men said, even than Miss Dunstable; and as the marriage was hardly as yet more than six months old the Barsetshire world was still full of it.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“The two heiresses seem to be very loving, don’t they?” said Mr. Supplehouse. “Birds of a feather flock together, you know. But they did say some little time ago that young Gresham was to have married Miss Dunstable himself.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Miss Dunstable! why she might almost be his mother,” said Mark.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“That makes but little difference. He was obliged to marry money, and I believe there is no doubt that he did at one time propose to Miss Dunstable.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“I have had a letter from Lufton,” Mr. Sowerby said to him the next morning. “He declares that the delay was all your fault. You were to have told Lady Lufton before he did anything, and he was waiting to write about it till he heard from you. It seems that you never said a word to her ladyship on the subject.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“I never did, certainly. My commission from Lufton was to break the matter to her when I found her in a proper humour for receiving it. If you knew Lady Lufton as well as I do, you would know that it is not every day that she would be in a humour for such tidings.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“And so I was to be kept waiting indefinitely because you two between you were afraid of an old woman! However I have not a word to say against her, and the matter is settled now.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Has the farm been sold?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Not a bit of it. The dowager could not bring her mind to suffer such profanation for the Lufton acres, and so she sold five thousand pounds out of the funds and sent the money to Lufton as a present;—sent it to him without saying a word, only hoping that it would suffice for his wants. I wish I had a mother, I know.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("Mark found it impossible at the moment to make any remark upon what had been told him, but he felt a sudden qualm of conscience and a wish that he was at Framley instead of at Gatherum Castle at the present moment. He knew a good deal respecting Lady Lufton’s income and the manner in which it was spent. It was very handsome for a single lady, but then she lived in a free and open-handed style; her charities were noble; there was no reason why she should save money, and her annual income was usually spent within the year. Mark knew this, and he knew also that nothing short of an impossibility to maintain them would induce her to lessen her charities. She had now given away a portion of her principal to save the property of her son—her son, who was so much more opulent than herself,—upon whose means, too, the world made fewer effectual claims.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("And Mark knew, too, something of the purpose for which this money had gone. There had been unsettled gambling claims between Sowerby and Lord Lufton, originating in affairs of the turf. It had now been going on for four years, almost from the period when Lord Lufton had become of age. He had before now spoken to Robarts on the matter with much bitter anger, alleging that Mr. Sowerby was treating him unfairly, nay, dishonestly—that he was claiming money that was not due to him; and then he declared more than once that he would bring the matter before the Jockey Club. But Mark, knowing that Lord Lufton was not clear-sighted in these matters, and believing it to be impossible that Mr. Sowerby should actually endeavour to defraud his friend, had smoothed down the young lord’s anger, and recommended him to get the case referred to some private arbiter. All this had afterwards been discussed between Robarts and Mr. Sowerby himself, and hence had originated their intimacy. The matter was so referred, Mr. Sowerby naming the referee; and Lord Lufton, when the matter was given against him, took it easily. His anger was over by that time. “I’ve been clean done among them,” he said to Mark, laughing; “but it does not signify; a man must pay for his experience. Of course, Sowerby thinks it all right; I am bound to suppose so.” And then there had been some further delay as to the amount, and part of the money had been paid to a third person, and a bill had been given, and heaven and the Jews only know how much money Lord Lufton had paid in all; and now it was ended by his handing over to some wretched villain of a money-dealer, on behalf of Mr. Sowerby, the enormous sum of five thousand pounds, which had been deducted from the means of his mother, Lady Lufton!")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("Mark, as he thought of all this, could not but feel a certain animosity against Mr. Sowerby—could not but suspect that he was a bad man. Nay, must he not have known that he was very bad? And yet he continued walking with him through the duke’s grounds, still talking about Lord Lufton’s affairs, and still listening with interest to what Sowerby told him of his own.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“No man was ever robbed as I have been,” said he. “But I shall win through yet, in spite of them all. But those Jews, Mark”—he had become very intimate with him in these latter days—“whatever you do, keep clear of them. Why, I could paper a room with their signatures; and yet I never had a claim upon one of them, though they always have claims on me!”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("I have said above that this affair of Lord Lufton’s was ended; but it now appeared to Mark that it was not "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("quite")]), _vm._v(" ended. “Tell Lufton, you know,” said Sowerby, “that every bit of paper with his name has been taken up, except what that ruffian Tozer has. Tozer may have one bill, I believe,—something that was not given up when it was renewed. But I’ll make my lawyer Gumption get that up. It may cost ten pounds or twenty pounds, not more. You’ll remember that when you see Lufton, will you?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“You’ll see Lufton in all probability before I shall.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Oh, did I not tell you? He’s going to Framley Court at once; you’ll find him there when you return.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Find him at Framley!”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Yes; this little "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("cadeau")]), _vm._v(" from his mother has touched his filial heart. He is rushing home to Framley to pay back the dowager’s hard moidores in soft caresses. I wish I had a mother; I know that.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("And Mark still felt that he feared Mr. Sowerby, but he could not make up his mind to break away from him.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("And there was much talk of politics just then at the castle. Not that the duke joined in it with any enthusiasm. He was a Whig—a huge mountain of a colossal Whig—all the world knew that. No opponent would have dreamed of tampering with his whiggery, nor would any brother Whig have dreamed of doubting it. But he was a Whig who gave very little practical support to any set of men, and very little practical opposition to any other set. He was above troubling himself with such sublunar matters. At election time he supported, and always carried, Whig candidates; and in return he had been appointed lord lieutenant of the county by one Whig minister, and had received the Garter from another. But these things were matters of course to a Duke of Omnium. He was born to be a lord lieutenant and a knight of the Garter.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("But not the less on account of his apathy, or rather quiescence, was it thought that Gatherum Castle was a fitting place in which politicians might express to each other their present hopes and future aims, and concoct together little plots in a half-serious and half-mocking way. Indeed it was hinted that Mr. Supplehouse and Harold Smith, with one or two others, were at Gatherum for this express purpose. Mr. Fothergill, too, was a noted politician, and was supposed to know the duke’s mind well; and Mr. Green Walker, the nephew of the marchioness, was a young man whom the duke desired to have brought forward. Mr. Sowerby also was the duke’s own member, and so the occasion suited well for the interchange of a few ideas.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("The then prime minister, angry as many men were with him, had not been altogether unsuccessful. He had brought the Russian war to a close, which, if not glorious, was at any rate much more so than Englishmen at one time had ventured to hope. And he had had wonderful luck in that Indian mutiny. It is true that many of those even who voted with him would declare that this was in no way attributable to him. Great men had risen in India and done all that. Even his minister there, the governor whom he had sent out, was not allowed in those days any credit for the success which was achieved under his orders. There was great reason to doubt the man at the helm. But nevertheless he had been lucky. There is no merit in a public man like success!")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("But now, when the evil days were well nigh over, came the question whether he had not been too successful. When a man has nailed fortune to his chariot-wheels he is apt to travel about in rather a proud fashion. There are servants who think that their masters cannot do without them; and the public also may occasionally have some such servant. What if this too successful minister were one of them!")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("And then a discreet, commonplace, zealous member of the Lower House does not like to be jeered at, when he does his duty by his constituents and asks a few questions. An all-successful minister who cannot keep his triumph to himself, but must needs drive about in a proud fashion, laughing at commonplace zealous members—laughing even occasionally at members who are by no means commonplace, which is outrageous!—may it not be as well to ostracize him for awhile?")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Had we not better throw in our shells against him?” says Mr. Harold Smith.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Let us throw in our shells, by all means,” says Mr. Supplehouse, mindful as Juno of his despised charms. And when Mr. Supplehouse declares himself an enemy, men know how much it means. They know that that much-belaboured head of affairs must succumb to the terrible blows which are now in store for him. “Yes, we will throw in our shells.” And Mr. Supplehouse rises from his chair with gleaming eyes. “Has not Greece as noble sons as him? ay, and much nobler, traitor that he is. We must judge a man by his friends,” says Mr. Supplehouse; and he points away to the East, where our dear allies the French are supposed to live, and where our head of affairs is supposed to have too close an intimacy.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("They all understand this, even Mr. Green Walker. “I don’t know that he is any good to any of us at all, now,” says the talented member for the Crewe Junction. “He’s a great deal too uppish to suit my book; and I know a great many people that think so too. There’s my uncle—”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“He’s the best fellow in the world,” said Mr. Fothergill, who felt, perhaps, that that coming revelation about Mr. Green Walker’s uncle might not be of use to them; “but the fact is one gets tired of the same man always. One does not like partridge every day. As for me, I have nothing to do with it myself; but I would certainly like to change the dish.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“If we’re merely to do as we are bid, and have no voice of our own, I don’t see what’s the good of going to the shop at all,” said Mr. Sowerby.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Not the least use,” said Mr. Supplehouse. “We are false to our constituents in submitting to such a dominion.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Let’s have a change, then,” said Mr. Sowerby. “The matter’s pretty much in our own hands.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Altogether,” said Mr. Green Walker. “That’s what my uncle always says.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“The Manchester men will only be too happy for the chance,” said Harold Smith.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“And as for the high and dry gentlemen,” said Mr. Sowerby, “it’s not very likely that they will object to pick up the fruit when we shake the tree.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“As to picking up the fruit, that’s as may be,” said Mr. Supplehouse. Was he not the man to save the nation; and if so, why should he not pick up the fruit himself? Had not the greatest power in the country pointed him out as such a saviour? What though the country at the present moment needed no more saving, might there not, nevertheless, be a good time coming? Were there not rumours of other wars still prevalent—if indeed the actual war then going on was being brought to a close without his assistance by some other species of salvation? He thought of that country to which he had pointed, and of that friend of his enemies, and remembered that there might be still work for a mighty saviour. The public mind was now awake, and understood what it was about. When a man gets into his head an idea that the public voice calls for him, it is astonishing how great becomes his trust in the wisdom of the public. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Vox populi vox Dei.")]), _vm._v(" “Has it not been so always?” he says to himself, as he gets up and as he goes to bed. And then Mr. Supplehouse felt that he was the master mind there at Gatherum Castle, and that those there were all puppets in his hand. It is such a pleasant thing to feel that one’s friends are puppets, and that the strings are in one’s own possession. But what if Mr. Supplehouse himself were a puppet?")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("Some months afterwards, when the much-belaboured head of affairs was in very truth made to retire, when unkind shells were thrown in against him in great numbers, when he exclaimed, “"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Et tu, Brute!")]), _vm._v("” till the words were stereotyped upon his lips, all men in all places talked much about the great Gatherum Castle confederation. The Duke of Omnium, the world said, had taken into his high consideration the state of affairs, and seeing with his eagle’s eye that the welfare of his countrymen at large required that some great step should be initiated, he had at once summoned to his mansion many members of the Lower House, and some also of the House of Lords,—mention was here especially made of the all-venerable and all-wise Lord Boanerges; and men went on to say that there, in deep conclave, he had made known to them his views. It was thus agreed that the head of affairs, Whig as he was, must fall. The country required it, and the duke did his duty. This was the beginning, the world said, of that celebrated confederation, by which the ministry was overturned, and—as the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Goody Twoshoes")]), _vm._v(" added,—the country saved. But the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Jupiter")]), _vm._v(" took all the credit to itself; and the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Jupiter")]), _vm._v(" was not far wrong. All the credit was due to the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Jupiter")]), _vm._v("—in that, as in everything else.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("In the meantime the Duke of Omnium entertained his guests in the quiet princely style, but did not condescend to have much conversation on politics either with Mr. Supplehouse or with Mr. Harold Smith. And as for Lord Boanerges, he spent the morning on which the above-described conversation took place in teaching Miss Dunstable to blow soap-bubbles on scientific principles.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Dear, dear!” said Miss Dunstable, as sparks of knowledge came flying in upon her mind. “I always thought that a soap-bubble was a soap-bubble, and I never asked the reason why. One doesn’t, you know, my lord.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Pardon me, Miss Dunstable,” said the old lord, “one does; but nine hundred and ninety-nine do not.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“And the nine hundred and ninety-nine have the best of it,” said Miss Dunstable. “What pleasure can one have in a ghost after one has seen the phosphorus rubbed on?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Quite true, my dear lady. ‘If ignorance be bliss, ’tis folly to be wise.’ It all lies in the ‘if.’”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("Then Miss Dunstable began to sing:—")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Blockquote-First"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("“‘What tho’ I trace each herb and flower")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Blockquote-Last"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("That sips the morning dew—’")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("—you know the rest, my lord.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("Lord Boanerges did know almost everything, but he did not know that; and so Miss Dunstable went on:—")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Blockquote-First"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("“‘Did I not own Jehovah’s power")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Blockquote-Last"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("How vain were all I knew.’”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Exactly, exactly, Miss Dunstable,” said his lordship; “but why not own the power and trace the flower as well? perhaps one might help the other.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("Upon the whole I am afraid that Lord Boanerges got the best of it. But then that is his line. He has been getting the best of it all his life.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("It was observed by all that the duke was especially attentive to young Mr. Frank Gresham, the gentleman on whom and on whose wife Miss Dunstable had seized so vehemently. This Mr. Gresham was the richest commoner in the county, and it was rumoured that at the next election he would be one of the members for the East Riding. Now the duke had little or nothing to do with the East Riding, and it was well known that young Gresham would be brought forward as a strong conservative. But, nevertheless, his acres were so extensive and his money so plentiful that he was worth a duke’s notice. Mr. Sowerby also was almost more than civil to him, as was natural, seeing that this very young man by a mere scratch of his pen could turn a scrap of paper into a bank-note of almost fabulous value.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“So you have the East Barsetshire hounds at Boxall Hill; have you not?” said the duke.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“The hounds are there,” said Frank. “But I am not the master.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Oh! I understood—”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“My father has them. But he finds Boxall Hill more centrical than Greshamsbury. The dogs and horses have to go shorter distances.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Boxall Hill is very centrical.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Oh, exactly!”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“And your young gorse coverts are doing well?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Pretty well—gorse won’t thrive everywhere, I find. I wish it would.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“That’s just what I say to Fothergill; and then where there’s much woodland you can’t get the vermin to leave it.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“But we haven’t a tree at Boxall Hill,” said Mrs. Gresham.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Ah, yes; you’re new there, certainly; you’ve enough of it at Greshamsbury in all conscience. There’s a larger extent of wood there than we have; isn’t there, Fothergill?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("Mr. Fothergill said that the Greshamsbury woods were very extensive, but that, perhaps, he thought—")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Oh, ah! I know,” said the duke. “The Black Forest in its old days was nothing to Gatherum woods, according to Fothergill. And then again, nothing in East Barsetshire could be equal to anything in West Barsetshire. Isn’t that it; eh, Fothergill?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("Mr. Fothergill professed that he had been brought up in that faith and intended to die in it.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Your exotics at Boxall Hill are very fine, magnificent!” said Mr. Sowerby.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“I’d sooner have one full-grown oak standing in its pride alone,” said young Gresham, rather grandiloquently, “than all the exotics in the world.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“They’ll come in due time,” said the duke.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“But the due time won’t be in my days. And so they’re going to cut down Chaldicotes forest, are they, Mr. Sowerby?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Well, I can’t tell you that. They are going to disforest it. I have been ranger since I was twenty-two, and I don’t yet know whether that means cutting down.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Not only cutting down, but rooting up,” said Mr. Fothergill.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“It’s a murderous shame,” said Frank Gresham; “and I will say one thing, I don’t think any but a Whig government would do it.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Ha, ha, ha!” laughed his grace. “At any rate I’m sure of this,” he said, “that if a conservative government did do so, the Whigs would be just as indignant as you are now.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“I’ll tell you what you ought to do, Mr. Gresham,” said Sowerby: “put in an offer for the whole of the West Barsetshire crown property; they will be very glad to sell it.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“And we should be delighted to welcome you on this side of the border,” said the duke.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("Young Gresham did feel rather flattered. There were not many men in the county to whom such an offer could be made without an absurdity. It might be doubted whether the duke himself could purchase the Chace of Chaldicotes with ready money; but that he, Gresham, could do so—he and his wife between them—no man did doubt. And then Mr. Gresham thought of a former day when he had once been at Gatherum Castle. He had been poor enough then, and the duke had not treated him in the most courteous manner in the world. How hard it is for a rich man not to lean upon his riches! harder, indeed, than for a camel to go through the eye of a needle.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("All Barsetshire knew—at any rate all West Barsetshire—that Miss Dunstable had been brought down in those parts in order that Mr. Sowerby might marry her. It was not surmised that Miss Dunstable herself had had any previous notice of this arrangement, but it was supposed that the thing would turn out as a matter of course. Mr. Sowerby had no money, but then he was witty, clever, good-looking, and a member of Parliament. He lived before the world, represented an old family, and had an old place. How could Miss Dunstable possibly do better? She was not so young now, and it was time that she should look about her.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("The suggestion as regarded Mr. Sowerby was certainly true, and was not the less so as regarded some of Mr. Sowerby’s friends. His sister, Mrs. Harold Smith, had devoted herself to the work, and with this view had run up a dear friendship with Miss Dunstable. The bishop had intimated, nodding his head knowingly, that it would be a very good thing. Mrs. Proudie had given in her adherence. Mr. Supplehouse had been made to understand that it must be a case of “Paws off” with him, as long as he remained in that part of the world; and even the duke himself had desired Fothergill to manage it.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“He owes me an enormous sum of money,” said the duke, who held all Mr. Sowerby’s title-deeds, “and I doubt whether the security will be sufficient.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Your grace will find the security quite sufficient,” said Mr. Fothergill; “but nevertheless it would be a good match.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Very good,” said the duke. And then it became Mr. Fothergill’s duty to see that Mr. Sowerby and Miss Dunstable became man and wife as speedily as possible.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("Some of the party, who were more wide awake than others, declared that he had made the offer; others, that he was just going to do so; and one very knowing lady went so far at one time as to say that he was making it at that moment. Bets also were laid as to the lady’s answer, as to the terms of the settlement, and as to the period of the marriage,—of all which poor Miss Dunstable of course knew nothing.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("Mr. Sowerby, in spite of the publicity of his proceedings, proceeded in the matter very well. He said little about it to those who joked with him, but carried on the fight with what best knowledge he had in such matters. But so much it is given to us to declare with certainty, that he had not proposed on the evening previous to the morning fixed for the departure of Mark Robarts.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("During the last two days Mr. Sowerby’s intimacy with Mark had grown warmer and warmer. He had talked to the vicar confidentially about the doings of these bigwigs now present at the castle, as though there were no other guest there with whom he could speak in so free a manner. He confided, it seemed, much more in Mark than in his brother-in-law, Harold Smith, or in any of his brother members of Parliament, and had altogether opened his heart to him in this affair of his anticipated marriage. Now Mr. Sowerby was a man of mark in the world, and all this flattered our young clergyman not a little.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("On that evening before Robarts went away Sowerby asked him to come up into his bedroom when the whole party was breaking up, and there got him into an easy-chair while he, Sowerby, walked up and down the room.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“You can hardly tell, my dear fellow,” said he, “the state of nervous anxiety in which this puts me.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Why don’t you ask her and have done with it? She seems to me to be fond of your society.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Ah, it is not that only; there are wheels within wheels;” and then he walked once or twice up and down the room, during which Mark thought that he might as well go to bed.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Not that I mind telling you everything,” said Sowerby. “I am infernally hard up for a little ready money just at the present moment. It may be, and indeed I think it will be, the case that I shall be ruined in this matter for the want of it.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Could not Harold Smith give it you?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Ha, ha, ha! you don’t know Harold Smith. Did you ever hear of his lending a man a shilling in his life?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Or Supplehouse?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Lord love you! You see me and Supplehouse together here, and he comes and stays at my house, and all that; but Supplehouse and I are no friends. Look you here, Mark—I would do more for your little finger than for his whole hand, including the pen which he holds in it. Fothergill indeed might—but then I know Fothergill is pressed himself at the present moment. It is deuced hard, isn’t it? I must give up the whole game if I can’t put my hand upon £400 within the next two days.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Ask her for it, herself.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“What, the woman I wish to marry! No, Mark, I’m not quite come to that. I would sooner lose her than that.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("Mark sat silent, gazing at the fire and wishing that he was in his own bedroom. He had an idea that Mr. Sowerby wished him to produce this £400; and he knew also that he had not £400 in the world, and that if he had he would be acting very foolishly to give it to Mr. Sowerby. But nevertheless he felt half fascinated by the man, and half afraid of him.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Lufton owes it to me to do more than this,” continued Mr. Sowerby; “but then Lufton is not here.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Why, he has just paid five thousand pounds for you.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Paid five thousand pounds for me! Indeed he has done no such thing. Not a sixpence of it came into my hands. Believe me, Mark, you don’t know the whole of that yet. Not that I mean to say a word against Lufton. He is the soul of honour; though so deucedly dilatory in money matters. He thought he was right all through that affair, but no man was ever so confoundedly wrong. Why, don’t you remember that that was the very view you took of it yourself?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“I remember saying that I thought he was mistaken.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Of course he was mistaken. And dearly the mistake cost me. I had to make good the money for two or three years. And my property is not like his—I wish it were.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Marry Miss Dunstable, and that will set it all right for you.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Ah! so I would if I had this money. At any rate I would bring it to the point. Now, I tell you what, Mark; if you’ll assist me at this strait I’ll never forget it. And the time will come round when I may be able to do something for you.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“I have not got a hundred, no, not fifty pounds by me in the world.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Of course you’ve not. Men don’t walk about the streets with £400 in their pockets. I don’t suppose there’s a single man here in the house with such a sum at his bankers’, unless it be the duke.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“What is it you want then?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Why, your name, to be sure. Believe me, my dear fellow, I would not ask you really to put your hand into your pocket to such a tune as that. Allow me to draw on you for that amount at three months. Long before that time I shall be flush enough.” And then, before Mark could answer, he had a bill stamp and pen and ink out on the table before him, and was filling in the bill as though his friend had already given his consent.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Upon my word, Sowerby, I had rather not do that.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Why? what are you afraid of?” Mr. Sowerby asked this very sharply. “Did you ever hear of my having neglected to take up a bill when it fell due?” Robarts thought that he had heard of such a thing; but in his confusion he was not exactly sure, and so he said nothing.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“No, my boy; I have not come to that. Look here; just you write, ‘Accepted, Mark Robarts,’ across that, and then you shall never hear of the transaction again;—and you will have obliged me for ever.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“As a clergyman it would be wrong of me,” said Robarts.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“As a clergyman! Come, Mark! If you don’t like to do as much as that for a friend, say so; but don’t let us have that sort of humbug. If there be one class of men whose names would be found more frequent on the backs of bills in the provincial banks than another, clergymen are that class. Come, old fellow, you won’t throw me over when I am so hard pushed.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("Mark Robarts took the pen and signed the bill. It was the first time in his life that he had ever done such an act. Sowerby then shook him cordially by the hand, and he walked off to his own bedroom a wretched man.")])])])])
}]}

/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(98),
  /* template */
  __webpack_require__(99),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 98 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 99 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('p', {
    staticClass: "ORIM-Chapter-Title-Page-Break"
  }, [_vm._v("CHAPTER IX")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Chapter-Subtitle"
  }, [_vm._v("The Vicar’s Return")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Chapter-Opener-Paragraph"
  }, [_vm._v("The next morning Mr. Robarts took leave of all his grand friends with a heavy heart. He had lain awake half the night thinking of what he had done and trying to reconcile himself to his position. He had not well left Mr. Sowerby’s room before he felt certain that at the end of three months he would again be troubled about that £400. As he went along the passage all the man’s known antecedents crowded upon him much quicker than he could remember them when seated in that arm-chair with the bill stamp before him, and the pen and ink ready to his hand. He remembered what Lord Lufton had told him—how he had complained of having been left in the lurch; he thought of all the stories current through the entire county as to the impossibility of getting money from Chaldicotes; he brought to mind the known character of the man, and then he knew that he must prepare himself to make good a portion at least of that heavy payment.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("Why had he come to this horrid place? Had he not everything at home at Framley which the heart of man could desire? No; the heart of man can desire deaneries—the heart, that is, of the man vicar; and the heart of the man dean can desire bishoprics; and before the eyes of the man bishop does there not loom the transcendental glory of Lambeth? He had owned to himself that he was ambitious; but he had to own to himself now also that he had hitherto taken but a sorry path towards the object of his ambition.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("On the next morning at breakfast-time, before his horse and gig arrived for him, no one was so bright as his friend Sowerby. “So you are off, are you?” said he.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Yes, I shall go this morning.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Say everything that’s kind from me to Lufton. I may possibly see him out hunting; otherwise we shan’t meet till the spring. As to my going to Framley, that’s out of the question. Her ladyship would look for my tail, and swear that she smelt brimstone. By-bye, old fellow!”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("The German student when he first made his bargain with the devil felt an indescribable attraction to his new friend; and such was the case now with Robarts. He shook Sowerby’s hand very warmly, said that he hoped he should meet him soon somewhere, and professed himself specially anxious to hear how that affair with the lady came off. As he had made his bargain—as he had undertaken to pay nearly half-a-year’s income for his dear friend—ought he not to have as much value as possible for his money? If the dear friendship of this flash member of Parliament did not represent that value, what else did do so? But then he felt, or fancied that he felt, that Mr. Sowerby did not care for him so much this morning as he had done on the previous evening. “By-bye,” said Mr. Sowerby, but he spoke no word as to such future meetings, nor did he even promise to write. Mr. Sowerby probably had many things on his mind; and it might be that it behoved him, having finished one piece of business, immediately to look to another.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("The sum for which Robarts had made himself responsible—which he so much feared that he would be called upon to pay—was very nearly half-a-year’s income; and as yet he had not put by one shilling since he had been married. When he found himself settled in his parsonage, he found also that all the world regarded him as a rich man. He had taken the dictum of all the world as true, and had set himself to work to live comfortably. He had no absolute need of a curate; but he could afford the £70—as Lady Lufton had said rather injudiciously; and by keeping Jones in the parish he would be acting charitably to a brother clergyman, and would also place himself in a more independent position. Lady Lufton had wished to see her pet clergyman well-to-do and comfortable; but now, as matters had turned out, she much regretted this affair of the curate. Mr. Jones, she said to herself, more than once, must be made to depart from Framley.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("He had given his wife a pony-carriage, and for himself he had a saddle-horse, and a second horse for his gig. A man in his position, well-to-do as he was, required as much as that. He had a footman also, and a gardener, and a groom. The two latter were absolutely necessary, but about the former there had been a question. His wife had been decidedly hostile to the footman; but, in all such matters as that, to doubt is to be lost. When the footman had been discussed for a week it became quite clear to the master that he also was a necessary.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("As he drove home that morning he pronounced to himself the doom of that footman, and the doom also of that saddle-horse. They at any rate should go. And then he would spend no more money in trips to Scotland; and above all, he would keep out of the bedrooms of impoverished members of Parliament at the witching hour of midnight. Such resolves did he make to himself as he drove home; and bethought himself wearily how that £400 might be made to be forthcoming. As to any assistance in the matter from Sowerby,—of that he gave himself no promise.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("But he almost felt himself happy again as his wife came out into the porch to meet him, with a silk shawl over her head, and pretending to shiver as she watched him descending from his gig.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“My dear old man,” she said, as she led him into the warm drawing-room with all his wrappings still about him, “you must be starved.” But Mark during the whole drive had been thinking too much of that transaction in Mr. Sowerby’s bedroom to remember that the air was cold. Now he had his arm round his own dear Fanny’s waist; but was he to tell her of that transaction? At any rate he would not do it now, while his two boys were in his arms, rubbing the moisture from his whiskers with their kisses. After all, what is there equal to that coming home?")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“And so Lufton is here. I say, Frank, gently, old boy,”—Frank was his eldest son—“you’ll have baby into the fender.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Let me take baby; it’s impossible to hold the two of them, they are so strong,” said the proud mother. “Oh, yes, he came home early yesterday.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Have you seen him?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“He was here yesterday, with her ladyship; and I lunched there to-day. The letter came, you know, in time to stop the Merediths. They don’t go till to-morrow, so you will meet them after all. Sir George is wild about it, but Lady Lufton would have her way. You never saw her in such a state as she is.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Good spirits, eh?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“I should think so. All Lord Lufton’s horses are coming, and he’s to be here till March.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Till March!”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“So her ladyship whispered to me. She could not conceal her triumph at his coming. He’s going to give up Leicestershire this year altogether. I wonder what has brought it all about?” Mark knew very well what had brought it about; he had been made acquainted, as the reader has also, with the price at which Lady Lufton had purchased her son’s visit. But no one had told Mrs. Robarts that the mother had made her son a present of five thousand pounds.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“She’s in a good humour about everything now,” continued Fanny; “so you need say nothing at all about Gatherum Castle.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“But she was very angry when she first heard it; was she not?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Well, Mark, to tell the truth, she was; and we had quite a scene there up in her own room up-stairs,—Justinia and I. She had heard something else that she did not like at the same time; and then—but you know her way. She blazed up quite hot.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“And said all manner of horrid things about me.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“About the duke she did. You know she never did like the duke; and for the matter of that, neither do I. I tell you that fairly, Master Mark!”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“The duke is not so bad as he’s painted.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Ah, that’s what you say about another great person. However, he won’t come here to trouble us, I suppose. And then I left her, not in the best temper in the world; for I blazed up too, you must know.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“I am sure you did,” said Mark, pressing his arm round her waist.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“And then we were going to have a dreadful war, I thought; and I came home and wrote such a doleful letter to you. But what should happen when I had just closed it, but in came her ladyship—all alone, and——! But I can’t tell you what she did or said, only she behaved beautifully; just like herself too; so full of love and truth and honesty. There’s nobody like her, Mark; and she’s better than all the dukes that ever wore—whatever dukes do wear.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Horns and hoofs; that’s their usual apparel, according to you and Lady Lufton,” said he, remembering what Mr. Sowerby had said of himself.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“You may say what you like about me, Mark, but you shan’t abuse Lady Lufton. And if horns and hoofs mean wickedness and dissipation, I believe it’s not far wrong. But get off your big coat and make yourself comfortable.” And that was all the scolding that Mark Robarts got from his wife on the occasion of his great iniquity.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“I will certainly tell her about this bill transaction,” he said to himself; “but not to-day; not till after I have seen Lufton.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("That evening they dined at Framley Court, and there they met the young lord; they found also Lady Lufton still in high good-humour. Lord Lufton himself was a fine, bright-looking young man; not so tall as Mark Robarts, and with perhaps less intelligence marked on his face; but his features were finer, and there was in his countenance a thorough appearance of good-humour and sweet temper. It was, indeed, a pleasant face to look upon, and dearly Lady Lufton loved to gaze at it.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Well, Mark, so you have been among the Philistines?” that was his lordship’s first remark. Robarts laughed as he took his friend’s hands, and bethought himself how truly that was the case; that he was, in very truth, already “himself in bonds under Philistian yoke.” Alas, alas, it is very hard to break asunder the bonds of the latter-day Philistines. When a Samson does now and then pull a temple down about their ears, is he not sure to be engulfed in the ruin with them? There is no horse-leech that sticks so fast as your latter-day Philistine.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“So you have caught Sir George, after all,” said Lady Lufton; and that was nearly all she did say in allusion to his absence. There was afterwards some conversation about the lecture, and from her ladyship’s remarks, it certainly was apparent that she did not like the people among whom the vicar had been lately staying; but she said no word that was personal to him himself, or that could be taken as a reproach. The little episode of Mrs. Proudie’s address in the lecture-room had already reached Framley, and it was only to be expected that Lady Lufton should enjoy the joke. She would affect to believe that the body of the lecture had been given by the bishop’s wife; and afterwards, when Mark described her costume at that Sunday morning breakfast-table, Lady Lufton would assume that such had been the dress in which she had exercised her faculties in public.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“I would have given a five-pound note to have heard it,” said Sir George.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“So would not I,” said Lady Lufton. “When one hears of such things described so graphically as Mr. Robarts now tells it, one can hardly help laughing. But it would give me great pain to see the wife of one of our bishops place herself in such a situation. For he is a bishop after all.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Well, upon my word, my lady, I agree with Meredith,” said Lord Lufton. “It must have been good fun. As it did happen, you know,—as the Church was doomed to the disgrace, I should like to have heard it.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“I know you would have been shocked, Ludovic.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“I should have got over that in time, mother. It would have been like a bull-fight I suppose—horrible to see no doubt, but extremely interesting. And Harold Smith, Mark; what did he do all the while?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“It didn’t take so very long, you know,” said Robarts.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“And the poor bishop,” said Lady Meredith; “how did he look? I really do pity him.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Well, he was asleep, I think.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“What, slept through it all?” said Sir George.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“It awakened him; and then he jumped up and said something.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“What, out loud too?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Only one word or so.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“What a disgraceful scene!” said Lady Lufton. “To those who remember the good old man who was in the diocese before him it is perfectly shocking. He confirmed you, Ludovic, and you ought to remember him. It was over at Barchester, and you went and lunched with him afterwards.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“I do remember; and especially this, that I never ate such tarts in my life, before or since. The old man particularly called my attention to them, and seemed remarkably pleased that I concurred in his sentiments. There are no such tarts as those going in the palace now, I’ll be bound.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Mrs. Proudie will be very happy to do her best for you if you will go and try,” said Sir George.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“I beg that he will do no such thing,” said Lady Lufton, and that was the only severe word she said about any of Mark’s visitings.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("As Sir George Meredith was there, Robarts could say nothing then to Lord Lufton about Mr. Sowerby and Mr. Sowerby’s money affairs; but he did make an appointment for a "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("tête-à-tête")]), _vm._v(" on the next morning.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“You must come down and see my nags, Mark; they came to-day. The Merediths will be off at twelve, and then we can have an hour together.” Mark said he would, and then went home with his wife under his arm.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Well, now, is not she kind?” said Fanny, as soon as they were out on the gravel together.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“She is kind; kinder than I can tell you just at present. But did you ever know anything so bitter as she is to the poor bishop? And really the bishop is not so bad.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Yes; I know something much more bitter; and that is what she thinks of the bishop’s wife. And you know, Mark, it was so unladylike, her getting up in that way. What must the people of Barchester think of her?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“As far as I could see the people of Barchester liked it.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Nonsense, Mark; they could not. But never mind that now. I want you to own that she is good.” And then Mrs. Robarts went on with another long eulogy on the dowager. Since that affair of the pardon-begging at the parsonage Mrs. Robarts hardly knew how to think well enough of her friend. And the evening had been so pleasant after the dreadful storm and threatenings of hurricanes; her husband had been so well received after his lapse of judgment; the wounds that had looked so sore had been so thoroughly healed, and everything was so pleasant. How all of this would have been changed had she known of that little bill!")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("At twelve the next morning the lord and the vicar were walking through the Framley stables together. Quite a commotion had been made there, for the larger portion of these buildings had of late years seldom been used. But now all was crowding and activity. Seven or eight very precious animals had followed Lord Lufton from Leicestershire, and all of them required dimensions that were thought to be rather excessive by the Framley old-fashioned groom. My lord, however, had a head man of his own who took the matter quite into his own hands.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("Mark, priest as he was, was quite worldly enough to be fond of a good horse; and for some little time allowed Lord Lufton to descant on the merit of this four-year-old filly, and that magnificent Rattlebones colt, out of a Mousetrap mare; but he had other things that lay heavy on his mind, and after bestowing half an hour on the stud, he contrived to get his friend away to the shrubbery walks.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“So you have settled with Sowerby,” Robarts began by saying.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Settled with him; yes, but do you know the price?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“I believe that you have paid five thousand pounds.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Yes, and about three before; and that in a matter in which I did not really owe one shilling. Whatever I do in future, I’ll keep out of Sowerby’s grip.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“But you don’t think he has been unfair to you.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Mark, to tell you the truth I have banished the affair from my mind, and don’t wish to take it up again. My mother has paid the money to save the property, and of course I must pay her back. But I think I may promise that I will not have any more money dealings with Sowerby. I will not say that he is dishonest, but at any rate he is sharp.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Well, Lufton; what will you say when I tell you that I have put my name to a bill for him, for four hundred pounds?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Say; why I should say—; but you’re joking; a man in your position would never do such a thing.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“But I have done it.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("Lord Lufton gave a long low whistle.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“He asked me the last night that I was there, making a great favour of it, and declaring that no bill of his had ever yet been dishonoured.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("Lord Lufton whistled again. “No bill of his dishonoured! Why the pocket-books of the Jews are stuffed full of his dishonoured papers! And you have really given him your name for four hundred pounds?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“I have certainly.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“At what date?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Three months.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“And have you thought where you are to get the money?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“I know very well that I can’t get it; not at least by that time. The bankers must renew it for me, and I must pay it by degrees. That is, if Sowerby really does not take it up.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“It is just as likely that he will take up the national debt.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("Robarts then told him about the projected marriage with Miss Dunstable, giving it as his opinion that the lady would probably accept the gentleman.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Not at all improbable,” said his lordship, “for Sowerby is an agreeable fellow; and if it be so, he will have all that he wants for life. But his creditors will gain nothing. The duke, who has his title-deeds, will doubtless get his money, and the estate will in fact belong to the wife. But the small fry, such as you, will not get a shilling.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("Poor Mark! He had had an inkling of this before; but it had hardly presented itself to him in such certain terms. It was, then, a positive fact, that in punishment for his weakness in having signed that bill he would have to pay, not only four hundred pounds, but four hundred pounds with interest, and expenses of renewal, and commission, and bill stamps. Yes; he had certainly got among the Philistines during that visit of his to the duke. It began to appear to him pretty clearly that it would have been better for him to have relinquished altogether the glories of Chaldicotes and Gatherum Castle.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("And now, how was he to tell his wife?")])])])])
}]}

/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(101),
  /* template */
  __webpack_require__(102),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 102 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('p', {
    staticClass: "ORIM-Chapter-Title-Page-Break"
  }, [_vm._v("CHAPTER X")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Chapter-Subtitle"
  }, [_vm._v("Lucy Robarts")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Chapter-Opener-Paragraph"
  }, [_vm._v("And now how was he to tell his wife? That was the consideration heavy on Mark Robarts’s mind when last we left him; and he turned the matter often in his thoughts before he could bring himself to a resolution. At last he did do so, and one may say that it was not altogether a bad one, if only he could carry it out.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("He would ascertain in what bank that bill of his had been discounted. He would ask Sowerby, and if he could not learn from him, he would go to the three banks in Barchester. That it had been taken to one of them he felt tolerably certain. He would explain to the manager his conviction that he would have to make good the amount, his inability to do so at the end of the three months, and the whole state of his income; and then the banker would explain to him how the matter might be arranged. He thought that he could pay £50 every three months with interest. As soon as this should have been concerted with the banker, he would let his wife know all about it. Were he to tell her at the present moment, while the matter was all unsettled, the intelligence would frighten her into illness.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("But on the next morning there came to him tidings by the hands of Robin postman, which for a long while upset all his plans. The letter was from Exeter. His father had been taken ill, and had very quickly been pronounced to be in danger. That evening—the evening on which his sister wrote—the old man was much worse, and it was desirable that Mark should go off to Exeter as quickly as possible. Of course he went to Exeter—again leaving the Framley souls at the mercy of the Welsh Low Churchman. Framley is only four miles from Silverbridge, and at Silverbridge he was on the direct road to the west. He was therefore at Exeter before nightfall on that day.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("But nevertheless he arrived there too late to see his father again alive. The old man’s illness had been sudden and rapid, and he expired without again seeing his eldest son. Mark arrived at the house of mourning just as they were learning to realize the full change in their position.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("The doctor’s career had been on the whole successful, but nevertheless he did not leave behind him as much money as the world had given him credit for possessing. Who ever does? Dr. Robarts had educated a large family, had always lived with every comfort, and had never possessed a shilling but what he had earned himself. A physician’s fees come in, no doubt, with comfortable rapidity as soon as rich old gentlemen and middle-aged ladies begin to put their faith in him; but fees run out almost with equal rapidity when a wife and seven children are treated to everything that the world considers most desirable. Mark, we have seen, had been educated at Harrow and Oxford, and it may be said, therefore, that he had received his patrimony early in life. For Gerald Robarts, the second brother, a commission had been bought in a crack regiment. He also had been lucky, having lived and become a captain in the Crimea; and the purchase-money was lodged for his majority. And John Robarts, the youngest, was a clerk in the Petty Bag Office, and was already assistant private secretary to the Lord Petty Bag himself—a place of considerable trust, if not hitherto of large emolument; and on his education money had been spent freely, for in these days a young man cannot get into the Petty Bag Office without knowing at least three modern languages; and he must be well up in trigonometry too, in bible theology, or in one dead language—at his option.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("And the doctor had four daughters. The two elder were married, including that Blanche with whom Lord Lufton was to have fallen in love at the vicar’s wedding. A Devonshire squire had done this in the lord’s place; but on marrying her it was necessary that he should have a few thousand pounds, two or three perhaps, and the old doctor had managed that they should be forthcoming. The elder also had not been sent away from the paternal mansion quite empty-handed. There were, therefore, at the time of the doctor’s death two children left at home, of whom one only, Lucy, the younger, will come much across us in the course of our story.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("Mark stayed for ten days at Exeter, he and the Devonshire squire having been named as executors in the will. In this document it was explained that the doctor trusted that provision had been made for most of his children. As for his dear son Mark, he said, he was aware that he need be under no uneasiness. On hearing this read Mark smiled sweetly, and looked very gracious; but, nevertheless, his heart did sink somewhat within him, for there had been a hope that a small windfall, coming now so opportunely, might enable him to rid himself at once of that dreadful Sowerby incubus. And then the will went on to declare that Mary, and Gerald, and Blanche, had also, by God’s providence, been placed beyond want. And here, looking into the squire’s face, one might have thought that his heart fell a little also; for he had not so full a command of his feelings as his brother-in-law, who had been so much more before the world. To John, the assistant private secretary, was left a legacy of a thousand pounds; and to Jane and Lucy certain sums in certain four per cents., which were quite sufficient to add an efficient value to the hands of those young ladies in the eyes of most prudent young would-be Benedicts. Over and beyond this there was nothing but the furniture, which he desired might be sold, and the proceeds divided among them all. It might come to sixty or seventy pounds a piece, and pay the expenses incidental on his death.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("And then all men and women there and thereabouts said that old Dr. Robarts had done well. His life had been good and prosperous, and his will was just. And Mark, among others, so declared,—and was so convinced in spite of his own little disappointment. And on the third morning after the reading of the will Squire Crowdy, of Creamclotted Hall, altogether got over his grief, and said that it was all right. And then it was decided that Jane should go home with him,—for there was a brother squire who, it was thought, might have an eye to Jane;—and Lucy, the younger, should be taken to Framley Parsonage. In a fortnight from the receipt of that letter Mark arrived at his own house with his sister Lucy under his wing.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("All this interfered greatly with Mark’s wise resolution as to the Sowerby-bill incubus. In the first place he could not get to Barchester as soon as he had intended, and then an idea came across him that possibly it might be well that he should borrow the money of his brother John, explaining the circumstances, of course, and paying him due interest. But he had not liked to broach the subject when they were there in Exeter, standing, as it were, over their father’s grave, and so the matter was postponed. There was still ample time for arrangement before the bill would come due, and he would not tell Fanny till he had made up his mind what that arrangement would be. It would kill her, he said to himself over and over again, were he to tell her of it without being able to tell her also that the means of liquidating the debt were to be forthcoming.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("And now I must say a word about Lucy Robarts. If one might only go on without those descriptions, how pleasant it would all be! But Lucy Robarts has to play a forward part in this little drama, and those who care for such matters must be made to understand something of her form and likeness. When last we mentioned her as appearing, though not in any prominent position, at her brother’s wedding, she was only sixteen; but now, at the time of her father’s death, somewhat over two years having since elapsed, she was nearly nineteen. Laying aside for the sake of clearness that indefinite term of girl—for girls are girls from the age of three up to forty-three, if not previously married—dropping that generic word, we may say that then, at that wedding of her brother, she was a child; and now, at the death of her father, she was a woman. Nothing, perhaps, adds so much to womanhood, turns the child so quickly into a woman, as such death-bed scenes as these. Hitherto but little had fallen to Lucy to do in the way of woman’s duties. Of money transactions she had known nothing, beyond a jocose attempt to make her annual allowance of twenty-five pounds cover all her personal wants—an attempt which was made jocose by the loving bounty of her father. Her sister, who was three years her elder—for John came in between them—had managed the house; that is, she had made the tea and talked to the housekeeper about the dinners. But Lucy had sat at her father’s elbow, had read to him on evenings when he went to sleep, had brought him his slippers and looked after the comforts of his easy-chair. All this she had done as a child; but when she stood at the coffin head, and knelt at the coffin side, then she was a woman.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("She was smaller in stature than either of her three sisters, to all of whom had been acceded the praise of being fine women—a eulogy which the people of Exeter, looking back at the elder sisters, and the general remembrance of them which pervaded the city, were not willing to extend to Lucy. “Dear—dear!” had been said of her; “poor Lucy is not like a Robarts at all; is she, now, Mrs. Pole?”—for as the daughters had become fine women, so had the sons grown into stalwart men. And then Mrs. Pole had answered: “Not a bit; is she, now? Only think what Blanche was at her age. But she has fine eyes, for all that; and they do say she is the cleverest of them all.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("And that, too, is so true a description of her, that I do not know that I can add much to it. She was not like Blanche; for Blanche had a bright complexion, and a fine neck, and a noble bust, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("et vera incessu patuit Dea")]), _vm._v("—a true goddess, that is, as far as the eye went. She had a grand idea, moreover, of an apple-pie, and had not reigned eighteen months at Creamclotted Hall before she knew all the mysteries of pigs and milk, and most of those appertaining to cider and green geese.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("Lucy had no neck at all worth speaking of,—no neck, I mean, that ever produced eloquence; she was brown, too, and had addicted herself in nowise, as she undoubtedly should have done, to larder utility. In regard to the neck and colour, poor girl, she could not help herself; but in that other respect she must be held as having wasted her opportunities.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("But then what eyes she had! Mrs. Pole was right there. They flashed upon you—not always softly; indeed not often softly, if you were a stranger to her; but whether softly or savagely, with a brilliancy that dazzled you as you looked at them. And who shall say of what colour they were? Green probably, for most eyes are green—green or grey, if green be thought uncomely for an eye-colour. But it was not their colour, but their fire, which struck one with such surprise.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("Lucy Robarts was thoroughly a brunette. Sometimes the dark tint of her cheek was exquisitely rich and lovely, and the fringes of her eyes were long and soft, and her small teeth, which one so seldom saw, were white as pearls, and her hair, though short, was beautifully soft—by no means black, but yet of so dark a shade of brown. Blanche, too, was noted for fine teeth. They were white and regular and lofty as a new row of houses in a French city. But then when she laughed she was all teeth; as she was all neck when she sat at the piano. But Lucy’s teeth!—it was only now and again, when in some sudden burst of wonder she would sit for a moment with her lips apart, that the fine finished lines and dainty pearl-white colour of that perfect set of ivory could be seen. Mrs. Pole would have said a word of her teeth also, but that to her they had never been made visible.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“But they do say that she is the cleverest of them all,” Mrs. Pole had added, very properly. The people of Exeter had expressed such an opinion, and had been quite just in doing so. I do not know how it happens, but it always does happen, that everybody in every small town knows which is the brightest-witted in every family. In this respect Mrs. Pole had only expressed public opinion, and public opinion was right. Lucy Robarts was blessed with an intelligence keener than that of her brothers or sisters.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“To tell the truth, Mark, I admire Lucy more than I do Blanche.” This had been said by Mrs. Robarts within a few hours of her having assumed that name. “She’s not a beauty, I know, but yet I do.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“My dearest Fanny!” Mark had answered in a tone of surprise.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“I do then; of course people won’t think so; but I never seem to care about regular beauties. Perhaps I envy them too much.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("What Mark said next need not be repeated, but everybody may be sure that it contained some gross flattery for his young bride. He remembered this, however, and had always called Lucy his wife’s pet. Neither of the sisters had since that been at Framley; and though Fanny had spent a week at Exeter on the occasion of Blanche’s marriage, it could hardly be said that she was very intimate with them. Nevertheless, when it became expedient that one of them should go to Framley, the remembrance of what his wife had said immediately induced Mark to make the offer to Lucy; and Jane, who was of a kindred soul with Blanche, was delighted to go to Creamclotted Hall. The acres of Heavybed House, down in that fat Totnes country, adjoined those of Creamclotted Hall, and Heavybed House still wanted a mistress.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("Fanny was delighted when the news reached her. It would of course be proper that one of his sisters should live with Mark under their present circumstances, and she was happy to think that that quiet little bright-eyed creature was to come and nestle with her under the same roof. The children should so love her—only not quite so much as they loved mamma; and the snug little room that looks out over the porch, in which the chimney never smokes, should be made ready for her; and she should be allowed her share of driving the pony—which was a great sacrifice of self on the part of Mrs. Robarts—and Lady Lufton’s best good-will should be bespoken. In fact, Lucy was not unfortunate in the destination that was laid out for her.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("Lady Lufton had of course heard of the doctor’s death, and had sent all manner of kind messages to Mark, advising him not to hurry home by any means until everything was settled at Exeter. And then she was told of the new-comer that was expected in the parish. When she heard that it was Lucy, the younger, she also was satisfied; for Blanche’s charms, though indisputable, had not been altogether to her taste. If a second Blanche were to arrive there what danger might there not be for young Lord Lufton!")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Quite right,” said her ladyship, “just what he ought to do. I think I remember the young lady; rather small, is she not, and very retiring?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Rather small and very retiring. What a description!” said Lord Lufton.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Never mind, Ludovic; some young ladies must be small, and some at least ought to be retiring. We shall be delighted to make her acquaintance.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“I remember your other sister-in-law very well,” said Lord Lufton. “She was a beautiful woman.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“I don’t think you will consider Lucy a beauty,” said Mrs. Robarts.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Small, retiring, and—” so far Lord Lufton had gone, when Mrs. Robarts finished by the word, “plain.” She had liked Lucy’s face, but she had thought that others probably did not do so.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Upon my word,” said Lady Lufton, “you don’t deserve to have a sister-in-law. I remember her very well, and can say that she is not plain. I was very much taken with her manner at your wedding, my dear; and thought more of her than I did of the beauty, I can tell you.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“I must confess I do not remember her at all,” said his lordship. And so the conversation ended.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("And then at the end of the fortnight Mark arrived with his sister. They did not reach Framley till long after dark—somewhere between six and seven—and by this time it was December. There was snow on the ground, and frost in the air, and no moon, and cautious men when they went on the roads had their horses’ shoes cocked. Such being the state of the weather Mark’s gig had been nearly filled with cloaks and shawls when it was sent over to Silverbridge. And a cart was sent for Lucy’s luggage, and all manner of preparations had been made. Three times had Fanny gone herself to see that the fire burned brightly in the little room over the porch, and at the moment that the sound of the wheels was heard she was engaged in opening her son’s mind as to the nature of an aunt. Hitherto papa and mamma and Lady Lufton were all that he had known, excepting, of course, the satellites of the nursery.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("And then in three minutes Lucy was standing by the fire. Those three minutes had been taken up in embraces between the husband and the wife. Let who would be brought as a visitor to the house, after a fortnight’s absence, she would kiss him before she welcomed any one else. But then she turned to Lucy, and began to assist her with her cloaks.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Oh, thank you,” said Lucy; “I’m not cold,—not very at least. Don’t trouble yourself; I can do it.” But here she had made a false boast, for her fingers had been so numbed that she could not do nor undo anything.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("They were all in black, of course; but the sombreness of Lucy’s clothes struck Fanny much more than her own. They seemed to have swallowed her up in their blackness, and to have made her almost an emblem of death. She did not look up, but kept her face turned towards the fire, and seemed almost afraid of her position.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“She may say what she likes, Fanny,” said Mark, “but she is very cold. And so am I,—cold enough. You had better go up with her to her room. We won’t do much in the dressing way to-night; eh, Lucy?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("In the bedroom Lucy thawed a little, and Fanny, as she kissed her, said to herself that she had been wrong as to that word “plain.” Lucy, at any rate, was not plain.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“You will be used to us soon,” said Fanny, “and then I hope we shall make you comfortable.” And she took her sister-in-law’s hand and pressed it.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("Lucy looked up at her, and her eyes then were tender enough. “I am sure I shall be happy here,” she said, “with you. But—but—dear papa!” And then they got into each other’s arms, and had a great bout of kissing and crying. “Plain,” said Fanny to herself, as at last she got her guest’s hair smoothed and the tears washed from her eyes—“plain! She has the loveliest countenance that I ever looked at in my life!”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Your sister is quite beautiful,” she said to Mark, as they talked her over alone before they went to sleep that night.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“No, she’s not beautiful; but she’s a very good girl, and clever enough too, in her sort of way.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“I think her perfectly lovely. I never saw such eyes in my life before.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“I’ll leave her in your hands then; you shall get her a husband.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“That mayn’t be so easy. I don’t think she’d marry anybody.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Well, I hope not. But she seems to me to be exactly cut out for an old maid;—to be aunt Lucy for ever and ever to your bairns.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“And so she shall, with all my heart. But I don’t think she will, very long. I have no doubt she will be hard to please; but if I were a man I should fall in love with her at once. Did you ever observe her teeth, Mark?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“I don’t think I ever did.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“You wouldn’t know whether any one had a tooth in their head, I believe.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“No one except you, my dear; and I know all yours by heart.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“You are a goose.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“And a very sleepy one; so, if you please, I’ll go to roost.” And thus there was nothing more said about Lucy’s beauty on that occasion.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("For the first two days Mrs. Robarts did not make much of her sister-in-law. Lucy, indeed, was not demonstrative; and she was, moreover, one of those few persons—for they are very few—who are contented to go on with their existence without making themselves the centre of any special outward circle. To the ordinary run of minds it is impossible not to do this. A man’s own dinner is to himself so important that he cannot bring himself to believe that it is a matter utterly indifferent to every one else. A lady’s collection of baby-clothes, in early years, and of house linen and curtain-fringes in later life, is so very interesting to her own eyes, that she cannot believe but what other people will rejoice to behold it. I would not, however, be held as regarding this tendency as evil. It leads to conversation of some sort among people, and perhaps to a kind of sympathy. Mrs. Jones will look at Mrs. White’s linen-chest, hoping that Mrs. White may be induced to look at hers. One can only pour out of a jug that which is in it. For the most of us, if we do not talk of ourselves, or at any rate of the individual circles of which we are the centres, we can talk of nothing. I cannot hold with those who wish to put down the insignificant chatter of the world. As for myself, I am always happy to look at Mrs. Jones’s linen, and never omit an opportunity of giving her the details of my own dinners.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("But Lucy Robarts had not this gift. She had come there as a stranger into her sister-in-law’s house, and at first seemed as though she would be contented in simply having her corner in the drawing-room and her place at the parlour-table. She did not seem to need the comforts of condolence and open-hearted talking. I do not mean to say that she was moody, that she did not answer when she was spoken to, or that she took no notice of the children; but she did not at once throw herself and all her hopes and sorrows into Fanny’s heart, as Fanny would have had her do.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("Mrs. Robarts herself was what we call demonstrative. When she was angry with Lady Lufton she showed it. And as since that time her love and admiration for Lady Lufton had increased, she showed that also. When she was in any way displeased with her husband, she could not hide it, even though she tried to do so, and fancied herself successful;—no more than she could hide her warm, constant, overflowing woman’s love. She could not walk through a room hanging on her husband’s arm without seeming to proclaim to every one there that she thought him the best man in it. She was demonstrative, and therefore she was the more disappointed in that Lucy did not rush at once with all her cares into her open heart.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“She is so quiet,” Fanny said to her husband.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“That’s her nature,” said Mark. “She always was quiet as a child. While we were smashing everything, she would never crack a teacup.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“I wish she would break something now,” said Fanny, “and then perhaps we should get to talk about it.” But she did not on this account give over loving her sister-in-law. She probably valued her the more, unconsciously, for not having those aptitudes with which she herself was endowed.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("And then after two days Lady Lufton called; of course it may be supposed that Fanny had said a good deal to her new inmate about Lady Lufton. A neighbour of that kind in the country exercises so large an influence upon the whole tenor of one’s life, that to abstain from such talk is out of the question. Mrs. Robarts had been brought up almost under the dowager’s wing, and of course she regarded her as being worthy of much talking. Do not let persons on this account suppose that Mrs. Robarts was a tuft-hunter, or a toad-eater. If they do not see the difference they have yet got to study the earliest principles of human nature.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("Lady Lufton called, and Lucy was struck dumb. Fanny was particularly anxious that her ladyship’s first impression should be favourable, and to effect this, she especially endeavoured to throw the two together during that visit. But in this she was unwise. Lady Lufton, however, had woman-craft enough not to be led into any egregious error by Lucy’s silence.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“And what day will you come and dine with us?” said Lady Lufton, turning expressly to her old friend Fanny.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Oh, do you name the day. We never have many engagements, you know.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Will Thursday do, Miss Robarts? You will meet nobody you know, only my son; so you need not regard it as going out. Fanny here will tell you that stepping over to Framley Court is no more going out, than when you go from one room to another in the parsonage. Is it, Fanny?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("Fanny laughed and said that that stepping over to Framley Court certainly was done so often that perhaps they did not think so much about it as they ought to do.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“We consider ourselves a sort of happy family here, Miss Robarts, and are delighted to have the opportunity of including you in the ménage.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("Lucy gave her ladyship one of her sweetest smiles, but what she said at that moment was inaudible. It was plain, however, that she could not bring herself even to go as far as Framley Court for her dinner just at present. “It was very kind of Lady Lufton,” she said to Fanny; “but it was so very soon, and—and—and if they would only go without her, she would be so happy.” But as the object was to go with her—expressly to take her there—the dinner was adjourned for a short time—"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("sine die")]), _vm._v(".")])])])])
}]}

/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(104),
  /* template */
  __webpack_require__(105),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 105 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('p', {
    staticClass: "ORIM-Chapter-Title-Page-Break"
  }, [_vm._v("CHAPTER XI")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Chapter-Subtitle"
  }, [_vm._v("Griselda Grantly")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Chapter-Opener-Paragraph"
  }, [_vm._v("It was nearly a month after this that Lucy was first introduced to Lord Lufton, and then it was brought about only by accident. During that time Lady Lufton had been often at the parsonage, and had in a certain degree learned to know Lucy; but the stranger in the parish had never yet plucked up courage to accept one of the numerous invitations that had reached her. Mr. Robarts and his wife had frequently been at Framley Court, but the dreaded day of Lucy’s initiation had not yet arrived.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("She had seen Lord Lufton in church, but hardly so as to know him, and beyond that she had not seen him at all. One day, however—or rather, one evening, for it was already dusk—he overtook her and Mrs. Robarts on the road walking towards the vicarage. He had his gun on his shoulder, three pointers were at his heels, and a gamekeeper followed a little in the rear.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“How are you, Mrs. Robarts?” he said, almost before he had overtaken them. “I have been chasing you along the road for the last half mile. I never knew ladies walk so fast.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“We should be frozen if we were to dawdle about as you gentlemen do,” and then she stopped and shook hands with him. She forgot at the moment that Lucy and he had not met, and therefore she did not introduce them.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Won’t you make me known to your sister-in-law?” said he, taking off his hat, and bowing to Lucy. “I have never yet had the pleasure of meeting her, though we have been neighbours for a month and more.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("Fanny made her excuses and introduced them, and then they went on till they came to Framley Gate, Lord Lufton talking to them both, and Fanny answering for the two, and there they stopped for a moment.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“I am surprised to see you alone,” Mrs. Robarts had just said; “I thought that Captain Culpepper was with you.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“The captain has left me for this one day. If you’ll whisper I’ll tell you where he has gone. I dare not speak it out loud, even to the woods.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“To what terrible place can he have taken himself? I’ll have no whisperings about such horrors.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“He has gone to—to—but you’ll promise not to tell my mother?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Not tell your mother! Well, now you have excited my curiosity! where can he be?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Do you promise, then?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Oh, yes! I will promise, because I am sure Lady Lufton won’t ask me as to Captain Culpepper’s whereabouts. We won’t tell; will we, Lucy?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“He has gone to Gatherum Castle for a day’s pheasant-shooting. Now, mind, you must not betray us. Her ladyship supposes that he is shut up in his room with a toothache. We did not dare to mention the name to her.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("And then it appeared that Mrs. Robarts had some engagement which made it necessary that she should go up and see Lady Lufton, whereas Lucy was intending to walk on to the parsonage alone.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“And I have promised to go to your husband,” said Lord Lufton; “or rather to your husband’s dog, Ponto. And I will do two other good things—I will carry a brace of pheasants with me, and protect Miss Robarts from the evil spirits of the Framley roads.” And so Mrs. Robarts turned in at the gate, and Lucy and his lordship walked off together.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("Lord Lufton, though he had never before spoken to Miss Robarts, had already found out that she was by no means plain. Though he had hardly seen her except at church, he had already made himself certain that the owner of that face must be worth knowing, and was not sorry to have the present opportunity of speaking to her. “So you have an unknown damsel shut up in your castle,” he had once said to Mrs. Robarts. “If she be kept a prisoner much longer, I shall find it my duty to come and release her by force of arms.” He had been there twice with the object of seeing her, but on both occasions Lucy had managed to escape. Now we may say she was fairly caught, and Lord Lufton, taking a pair of pheasants from the gamekeeper, and swinging them over his shoulder, walked off with his prey.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“You have been here a long time,” he said, “without our having had the pleasure of seeing you.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Yes, my lord,” said Lucy. Lords had not been frequent among her acquaintance hitherto.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“I tell Mrs. Robarts that she has been confining you illegally, and that we shall release you by force or stratagem.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“I—I—I have had a great sorrow lately.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Yes, Miss Robarts; I know you have; and I am only joking, you know. But I do hope that now you will be able to come amongst us. My mother is so anxious that you should do so.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“I am sure she is very kind, and you also—my lord.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“I never knew my own father,” said Lord Lufton, speaking gravely. “But I can well understand what a loss you have had.” And then, after pausing a moment, he continued, “I remember Dr. Robarts well.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Do you, indeed?” said Lucy, turning sharply towards him, and speaking now with some animation in her voice. Nobody had yet spoken to her about her father since she had been at Framley. It had been as though the subject were a forbidden one. And how frequently is this the case! When those we love are dead, our friends dread to mention them, though to us who are bereaved no subject would be so pleasant as their names. But we rarely understand how to treat our own sorrow or those of others.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("There was once a people in some land—and they may be still there for what I know—who thought it sacrilegious to stay the course of a raging fire. If a house were being burned, burn it must, even though there were facilities for saving it. For who would dare to interfere with the course of the god? Our idea of sorrow is much the same. We think it wicked, or at any rate heartless, to put it out. If a man’s wife be dead, he should go about lugubrious, with long face, for at least two years, or perhaps with full length for eighteen months, decreasing gradually during the other six. If he be a man who can quench his sorrow—put out his fire as it were—in less time than that, let him at any rate not show his power!")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Yes, I remember him,” continued Lord Lufton. “He came twice to Framley while I was a boy, consulting with my mother about Mark and myself,—whether the Eton floggings were not more efficacious than those at Harrow. He was very kind to me, foreboding all manner of good things on my behalf.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“He was very kind to every one,” said Lucy.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“I should think he would have been—a kind, good, genial man—just the man to be adored by his own family.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Exactly; and so he was. I do not remember that I ever heard an unkind word from him. There was not a harsh tone in his voice. And he was generous as the day.” Lucy, we have said, was not generally demonstrative, but now, on this subject, and with this absolute stranger, she became almost eloquent.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“I do not wonder that you should feel his loss, Miss Robarts.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Oh, I do feel it. Mark is the best of brothers, and, as for Fanny, she is too kind and too good to me. But I had always been specially my father’s friend. For the last year or two we had lived so much together!”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“He was an old man when he died, was he not?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Just seventy, my lord.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Ah, then he was old. My mother is only fifty, and we sometimes call her the old woman. Do you think she looks older than that? We all say that she makes herself out to be so much more ancient than she need do.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Lady Lufton does not dress young.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“That is it. She never has, in my memory. She always used to wear black when I first recollect her. She has given that up now; but she is still very sombre; is she not?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“I do not like ladies to dress very young, that is, ladies of—of—”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Ladies of fifty, we will say?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Very well; ladies of fifty, if you like it.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Then I am sure you will like my mother.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("They had now turned up through the parsonage wicket, a little gate that opened into the garden at a point on the road nearer than the chief entrance.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“I suppose I shall find Mark up at the house?” said he.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“I daresay you will, my lord.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Well, I’ll go round this way, for my business is partly in the stable. You see I am quite at home here, though you never have seen me before. But, Miss Robarts, now that the ice is broken, I hope that we may be friends.” He then put out his hand, and when she gave him hers he pressed it almost as an old friend might have done.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("And, indeed, Lucy had talked to him almost as though he were an old friend. For a minute or two she had forgotten that he was a lord and a stranger—had forgotten also to be stiff and guarded as was her wont. Lord Lufton had spoken to her as though he had really cared to know her; and she, unconsciously, had been taken by the compliment. Lord Lufton, indeed, had not thought much about it—excepting as thus, that he liked the glance of a pair of bright eyes, as most other young men do like it. But, on this occasion, the evening had been so dark, that he had hardly seen Lucy’s eyes at all.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Well, Lucy, I hope you liked your companion,” Mrs. Robarts said, as the three of them clustered round the drawing-room fire before dinner.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Oh, yes; pretty well,” said Lucy.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“That is not at all complimentary to his lordship.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“I did not mean to be complimentary, Fanny.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Lucy is a great deal too matter-of-fact for compliments,” said Mark.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“What I meant was, that I had no great opportunity for judging, seeing that I was only with Lord Lufton for about ten minutes.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Ah! but there are girls here who would give their eyes for ten minutes of Lord Lufton to themselves. You do not know how he’s valued. He has the character of being always able to make himself agreeable to ladies at half a minute’s warning.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Perhaps he had not the half-minute’s warning in this case,” said Lucy,—hypocrite that she was.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Poor Lucy,” said her brother; “he was coming up to see Ponto’s shoulder, and I am afraid he was thinking more about the dog than you.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Very likely,” said Lucy; and then they went in to dinner.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("Lucy had been a hypocrite, for she had confessed to herself, while dressing, that Lord Lufton had been very pleasant; but then it is allowed to young ladies to be hypocrites when the subject under discussion is the character of a young gentleman.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("Soon after that, Lucy did dine at Framley Court. Captain Culpepper, in spite of his enormity with reference to Gatherum Castle, was still staying there, as was also a clergyman from the neighbourhood of Barchester with his wife and daughter. This was Archdeacon Grantly, a gentleman whom we have mentioned before, and who was as well known in the diocese as the bishop himself,—and more thought about by many clergymen than even that illustrious prelate.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("Miss Grantly was a young lady not much older than Lucy Robarts, and she also was quiet, and not given to much talking in open company. She was decidedly a beauty, but somewhat statuesque in her loveliness. Her forehead was high and white, but perhaps too like marble to gratify the taste of those who are fond of flesh and blood. Her eyes were large and exquisitely formed, but they seldom showed much emotion. She, indeed, was impassive herself, and betrayed but little of her feelings. Her nose was nearly Grecian, not coming absolutely in a straight line from her forehead, but doing so nearly enough to entitle it to be considered as classical. Her mouth, too, was very fine—artists, at least, said so, and connoisseurs in beauty; but to me she always seemed as though she wanted fulness of lip. But the exquisite symmetry of her cheek and chin and lower face no man could deny. Her hair was light, and being always dressed with considerable care, did not detract from her appearance; but it lacked that richness which gives such luxuriance to feminine loveliness. She was tall and slight, and very graceful in her movements; but there were those who thought that she wanted the ease and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("abandon")]), _vm._v(" of youth. They said that she was too composed and stiff for her age, and that she gave but little to society beyond the beauty of her form and face.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("There can be no doubt, however, that she was considered by most men and women to be the beauty of Barsetshire, and that gentlemen from neighbouring counties would come many miles through dirty roads on the mere hope of being able to dance with her. Whatever attractions she may have lacked, she had at any rate created for herself a great reputation. She had spent two months of the last spring in London, and even there she had made a sensation; and people had said that Lord Dumbello, Lady Hartletop’s eldest son, had been peculiarly struck with her.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("It may be imagined that the archdeacon was proud of her, and so indeed was Mrs. Grantly—more proud, perhaps, of her daughter’s beauty, than so excellent a woman should have allowed herself to be of such an attribute. Griselda—that was her name—was now an only daughter. One sister she had had, but that sister had died. There were two brothers also left, one in the Church and the other in the army. That was the extent of the archdeacon’s family, and as the archdeacon was a very rich man—he was the only child of his father, who had been Bishop of Barchester for a great many years; and in those years it had been worth a man’s while to be Bishop of Barchester—it was supposed that Miss Grantly would have a large fortune. Mrs. Grantly, however, had been heard to say, that she was in no hurry to see her daughter established in the world;—ordinary young ladies are merely married, but those of real importance are established;—and this, if anything, added to the value of the prize. Mothers sometimes depreciate their wares by an undue solicitude to dispose of them. But to tell the truth openly and at once—a virtue for which a novelist does not receive very much commendation—Griselda Grantly was, to a certain extent, already given away. Not that she, Griselda, knew anything about it, or that the thrice happy gentleman had been made aware of his good fortune; nor even had the archdeacon been told. But Mrs. Grantly and Lady Lufton had been closeted together more than once, and terms had been signed and sealed between them. Not signed on parchment, and sealed with wax, as is the case with treaties made by kings and diplomats,—to be broken by the same; but signed with little words, and sealed with certain pressings of the hand,—a treaty which between two such contracting parties would be binding enough. And by the terms of this treaty Griselda Grantly was to become Lady Lufton. Lady Lufton had hitherto been fortunate in her matrimonial speculations. She had selected Sir George for her daughter, and Sir George, with the utmost good nature, had fallen in with her views. She had selected Fanny Monsell for Mr. Robarts, and Fanny Monsell had not rebelled against her for a moment. There was a prestige of success about her doings, and she felt almost confident that her dear son Ludovic must fall in love with Griselda. As to the lady herself, nothing, Lady Lufton thought, could be much better than such a match for her son. Lady Lufton, I have said, was a good churchwoman, and the archdeacon was the very type of that branch of the Church which she venerated. The Grantlys, too, were of a good family,—not noble, indeed; but in such matters Lady Lufton did not want everything. She was one of those persons who, in placing their hopes at a moderate pitch, may fairly trust to see them realized. She would fain that her son’s wife should be handsome; this she wished for his sake, that he might be proud of his wife, and because men love to look on beauty. But she was afraid of vivacious beauty, of those soft, sparkling feminine charms which are spread out as lures for all the world, soft dimples, laughing eyes, luscious lips, conscious smiles, and easy whispers. What if her son should bring her home a rattling, rapid-spoken, painted piece of Eve’s flesh such as this? Would not the glory and joy of her life be over, even though such child of their first mother should have come forth to the present day ennobled by the blood of two dozen successive British peers?")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("And then, too, Griselda’s money would not be useless. Lady Lufton, with all her high-flown ideas, was not an imprudent woman. She knew that her son had been extravagant, though she did not believe that he had been reckless; and she was well content to think that some balsam from the old bishop’s coffers should be made to cure the slight wounds which his early imprudence might have inflicted on the carcase of the family property. And thus, in this way, and for these reasons, Griselda Grantly had been chosen out from all the world to be the future Lady Lufton.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("Lord Lufton had met Griselda more than once already; had met her before these high contracting parties had come to any terms whatsoever, and had evidently admired her. Lord Dumbello had remained silent one whole evening in London with ineffable disgust, because Lord Lufton had been rather particular in his attentions; but then Lord Dumbello’s muteness was his most eloquent mode of expression. Both Lady Hartletop and Mrs. Grantly, when they saw him, knew very well what he meant. But that match would not exactly have suited Mrs. Grantly’s views. The Hartletop people were not in her line. They belonged altogether to another set, being connected, as we have heard before, with the Omnium interest—“those "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("horrid")]), _vm._v(" Gatherum people,” as Lady Lufton would say to her, raising her hands and eyebrows, and shaking her head. Lady Lufton probably thought that they ate babies in pies during their midnight orgies at Gatherum Castle; and that widows were kept in cells, and occasionally put on racks for the amusement of the duke’s guests.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("When the Robarts’s party entered the drawing-room the Grantlys were already there, and the archdeacon’s voice sounded loud and imposing in Lucy’s ears, as she heard him speaking while she was yet on the threshold of the door.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“My dear Lady Lufton, I would believe anything on earth about her—anything. There is nothing too outrageous for her. Had she insisted on going there with the bishop’s apron on, I should not have been surprised.” And then they all knew that the archdeacon was talking about Mrs. Proudie, for Mrs. Proudie was his bugbear.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("Lady Lufton after receiving her guests introduced Lucy to Griselda Grantly. Miss Grantly smiled graciously, bowed slightly, and then remarked in the lowest voice possible that it was exceedingly cold. A low voice, we know, is an excellent thing in a woman. Lucy, who thought that she was bound to speak, said that it was cold, but that she did not mind it when she was walking. And then Griselda smiled again, somewhat less graciously than before, and so the conversation ended. Miss Grantly was the elder of the two, and having seen most of the world, should have been the best able to talk, but perhaps she was not very anxious for a conversation with Miss Robarts.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“So, Robarts, I hear that you have been preaching at Chaldicotes,” said the archdeacon, still rather loudly. “I saw Sowerby the other day, and he told me that you gave them the fag end of Mrs. Proudie’s lecture.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“It was ill-natured of Sowerby to say the fag end,” said Robarts. “We divided the matter into thirds. Harold Smith took the first part, I the last—”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“And the lady the intervening portion. You have electrified the county between you; but I am told that she had the best of it.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“I was so sorry that Mr. Robarts went there,” said Lady Lufton, as she walked into the dining-room leaning on the archdeacon’s arm.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“I am inclined to think he could not very well have helped himself,” said the archdeacon, who was never willing to lean heavily on a brother parson, unless on one who had utterly and irrevocably gone away from his side of the Church.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Do you think not, archdeacon?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Why, no; Sowerby is a friend of Lufton’s—”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Not particularly,” said poor Lady Lufton, in a deprecating tone.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Well, they have been intimate; and Robarts, when he was asked to preach at Chaldicotes, could not well refuse.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“But then he went afterwards to Gatherum Castle. Not that I am vexed with him at all now, you understand. But it is such a dangerous house, you know.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“So it is.— But the very fact of the duke’s wishing to have a clergyman there, should always be taken as a sign of grace, Lady Lufton. The air was impure, no doubt; but it was less impure with Robarts there than it would have been without him. But, gracious heavens! what blasphemy have I been saying about impure air? Why, the bishop was there!”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Yes, the bishop was there,” said Lady Lufton, and they both understood each other thoroughly.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("Lord Lufton took out Mrs. Grantly to dinner, and matters were so managed that Miss Grantly sat on his other side. There was no management apparent in this to anybody; but there she was, while Lucy was placed between her brother and Captain Culpepper. Captain Culpepper was a man with an enormous moustache, and a great aptitude for slaughtering game; but as he had no other strong characteristics, it was not probable that he would make himself very agreeable to poor Lucy.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("She had seen Lord Lufton once, for two minutes, since the day of that walk, and then he had addressed her quite like an old friend. It had been in the parsonage drawing-room, and Fanny had been there. Fanny now was so well accustomed to his lordship, that she thought but little of this, but to Lucy it had been very pleasant. He was not forward or familiar, but kind, and gentle, and pleasant; and Lucy did feel that she liked him.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("Now, on this evening, he had hitherto hardly spoken to her; but then she knew that there were other people in the company to whom he was bound to speak. She was not exactly humble-minded in the usual sense of the word; but she did recognize the fact that her position was less important than that of other people there, and that therefore it was probable that to a certain extent she would be overlooked. But not the less would she have liked to occupy the seat to which Miss Grantly had found her way. She did not want to flirt with Lord Lufton; she was not such a fool as that; but she would have liked to have heard the sound of his voice close to her ear, instead of that of Captain Culpepper’s knife and fork.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("This was the first occasion on which she had endeavoured to dress herself with care since her father had died; and now, sombre though she was in her deep mourning, she did look very well.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“There is an expression about her forehead that is full of poetry,” Fanny had said to her husband.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Don’t you turn her head, Fanny, and make her believe that she is a beauty,” Mark had answered.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“I doubt it is not so easy to turn her head, Mark. There is more in Lucy than you imagine, and so you will find out before long.” It was thus that Mrs. Robarts prophesied about her sister-in-law. Had she been asked she might perhaps have said that Lucy’s presence would be dangerous to the Grantly interest at Framley Court.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("Lord Lufton’s voice was audible enough as he went on talking to Miss Grantly—his voice, but not his words. He talked in such a way that there was no appearance of whispering, and yet the person to whom he spoke, and she only, could hear what he said. Mrs. Grantly the while conversed constantly with Lucy’s brother, who sat at Lucy’s left hand. She never lacked for subjects on which to speak to a country clergyman of the right sort, and thus Griselda was left quite uninterrupted.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("But Lucy could not but observe that Griselda herself seemed to have very little to say,—or at any rate to say very little. Every now and then she did open her mouth, and some word or brace of words would fall from it. But for the most part she seemed to be content in the fact that Lord Lufton was paying her attention. She showed no animation, but sat there still and graceful, composed and classical, as she always was. Lucy, who could not keep her ears from listening or her eyes from looking, thought that had she been there she would have endeavoured to take a more prominent part in the conversation. But then Griselda Grantly probably knew much better than Lucy did how to comport herself in such a situation. Perhaps it might be that young men, such as Lord Lufton, liked to hear the sound of their own voices.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Immense deal of game about here,” Captain Culpepper said to her towards the end of the dinner. It was the second attempt he had made; on the former he had asked her whether she knew any of the fellows of the 9th.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Is there?” said Lucy. “Oh! I saw Lord Lufton the other day with a great armful of pheasants.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“An armful! Why we had seven cartloads the other day at Gatherum.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Seven carts full of pheasants!” said Lucy, amazed.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“That’s not so much. We had eight guns, you know. Eight guns will do a deal of work when the game has been well got together. They manage all that capitally at Gatherum. Been at the duke’s, eh?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("Lucy had heard the Framley report as to Gatherum Castle, and said with a sort of shudder that she had never been at that place. After this, Captain Culpepper troubled her no further.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("When the ladies had taken themselves to the drawing-room Lucy found herself hardly better off than she had been at the dinner-table. Lady Lufton and Mrs. Grantly got themselves on to a sofa together, and there chatted confidentially into each other’s ears. Her ladyship had introduced Lucy and Miss Grantly, and then she naturally thought that the young people might do very well together. Mrs. Robarts did attempt to bring about a joint conversation, which should include the three, and for ten minutes or so she worked hard at it. But it did not thrive. Miss Grantly was monosyllabic, smiling, however, at every monosyllable; and Lucy found that nothing would occur to her at that moment worthy of being spoken. There she sat, still and motionless, afraid to take up a book, and thinking in her heart how much happier she would have been at home at the parsonage. She was not made for society; she felt sure of that; and another time she would let Mark and Fanny come to Framley Court by themselves.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("And then the gentlemen came in, and there was another stir in the room. Lady Lufton got up and bustled about; she poked the fire and shifted the candles, spoke a few words to Dr. Grantly, whispered something to her son, patted Lucy on the cheek, told Fanny, who was a musician, that they would have a little music, and ended by putting her two hands on Griselda’s shoulders and telling her that the fit of her frock was perfect. For Lady Lufton, though she did dress old herself, as Lucy had said, delighted to see those around her neat and pretty, jaunty and graceful.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Dear Lady Lufton!” said Griselda, putting up her hand so as to press the end of her ladyship’s fingers. It was the first piece of animation she had shown, and Lucy Robarts watched it all.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("And then there was music. Lucy neither played nor sang; Fanny did both, and for an amateur did both well. Griselda did not sing, but she played; and did so in a manner that showed that neither her own labour nor her father’s money had been spared in her instruction. Lord Lufton sang also, a little, and Captain Culpepper a very little; so that they got up a concert among them. In the meantime the doctor and Mark stood talking together on the rug before the fire; the two mothers sat contented, watching the billings and the cooings of their offspring—and Lucy sat alone, turning over the leaves of a book of pictures. She made up her mind fully, then and there, that she was quite unfitted by disposition for such work as this. She cared for no one, and no one cared for her. Well, she must go through with it now; but another time she would know better. With her own book and a fireside she never felt herself to be miserable as she was now.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("She had turned her back to the music, for she was sick of seeing Lord Lufton watch the artistic motion of Miss Grantly’s fingers, and was sitting at a small table as far away from the piano as a long room would permit, when she was suddenly roused from a reverie of self-reproach by a voice close behind her: “Miss Robarts,” said the voice, “why have you cut us all?” and Lucy felt that though she heard the words plainly, nobody else did. Lord Lufton was now speaking to her as he had before spoken to Miss Grantly.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“I don’t play, my lord,” said Lucy, “nor yet sing.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“That would have made your company so much more valuable to us, for we are terribly badly off for listeners. Perhaps you don’t like music?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“I do like it,—sometimes very much.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“And when are the sometimes? But we shall find it all out in time. We shall have unravelled all your mysteries, and read all your riddles, by—when shall I say?—by the end of the winter. Shall we not?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“I do not know that I have got any mysteries.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Oh, but you have! It is very mysterious in you to come and sit here, with your back to us all—”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Oh, Lord Lufton; if I have done wrong—!” and poor Lucy almost started from her chair, and a deep flush came across her dark cheek.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“No—no; you have done no wrong. I was only joking. It is we who have done wrong in leaving you to yourself—you who are the greatest stranger among us.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“I have been very well, thank you. I don’t care about being left alone. I have always been used to it.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Ah! but we must break you of the habit. We won’t allow you to make a hermit of yourself. But the truth is, Miss Robarts, you don’t know us yet, and therefore you are not quite happy among us.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Oh! yes, I am; you are all very good to me.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“You must let us be good to you. At any rate, you must let me be so. You know, don’t you, that Mark and I have been dear friends since we were seven years old. His wife has been my sister’s dearest friend almost as long; and now that you are with them, you must be a dear friend too. You won’t refuse the offer; will you?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Oh, no,” she said, quite in a whisper; and, indeed, she could hardly raise her voice above a whisper, fearing that tears would fall from her tell-tale eyes.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Dr. and Mrs. Grantly will have gone in a couple of days, and then we must get you down here. Miss Grantly is to remain for Christmas, and you two must become bosom friends.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("Lucy smiled, and tried to look pleased, but she felt that she and Griselda Grantly could never be bosom friends—could never have anything in common between them. She felt sure that Griselda despised her, little, brown, plain, and unimportant as she was. She herself could not despise Griselda in turn; indeed she could not but admire Miss Grantly’s great beauty and dignity of demeanour; but she knew that she could never love her. It is hardly possible that the proud-hearted should love those who despise them; and Lucy Robarts was very proud-hearted.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Don’t you think she is very handsome?” said Lord Lufton.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Oh, very,” said Lucy. “Nobody can doubt that.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Ludovic,” said Lady Lufton—not quite approving of her son’s remaining so long at the back of Lucy’s chair—“won’t you give us another song? Mrs. Robarts and Miss Grantly are still at the piano.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“I have sung away all that I knew, mother. There’s Culpepper has not had a chance yet. He has got to give us his dream—how he ‘dreamt that he dwelt in marble halls!’”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“I sang that an hour ago,” said the captain, not over pleased.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“But you certainly have not told us how ‘your little lovers came!’”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("The captain, however, would not sing any more. And then the party was broken up, and the Robartses went home to their parsonage.")])])])])
}]}

/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(107),
  /* template */
  __webpack_require__(108),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 108 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('p', {
    staticClass: "ORIM-Chapter-Title-Page-Break"
  }, [_vm._v("CHAPTER XII")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Chapter-Subtitle"
  }, [_vm._v("The Little Bill")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Chapter-Opener-Paragraph"
  }, [_vm._v("Lucy, during those last fifteen minutes of her sojourn in the Framley Court drawing-room, somewhat modified the very strong opinion she had before formed as to her unfitness for such society. It was very pleasant sitting there in that easy-chair, while Lord Lufton stood at the back of it saying nice, soft, good-natured words to her. She was sure that in a little time she could feel a true friendship for him, and that she could do so without any risk of falling in love with him. But then she had a glimmering of an idea that such a friendship would be open to all manner of remarks, and would hardly be compatible with the world’s ordinary ways. At any rate it would be pleasant to be at Framley Court, if he would come and occasionally notice her. But she did not admit to herself that such a visit would be intolerable if his whole time were devoted to Griselda Grantly. She neither admitted it, nor thought it; but nevertheless, in a strange unconscious way, such a feeling did find entrance in her bosom.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("And then the Christmas holidays passed away. How much of this enjoyment fell to her share, and how much of this suffering she endured, we will not attempt accurately to describe. Miss Grantly remained at Framley Court up to Twelfth Night, and the Robartses also spent most of the season at the house. Lady Lufton, no doubt, had hoped that everything might have been arranged on this occasion in accordance with her wishes, but such had not been the case. Lord Lufton had evidently admired Miss Grantly very much; indeed, he had said so to his mother half-a-dozen times; but it may almost be questioned whether the pleasure Lady Lufton derived from this was not more than neutralized by an opinion he once put forward that Griselda Grantly wanted some of the fire of Lucy Robarts.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Surely, Ludovic, you would never compare the two girls,” said Lady Lufton.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Of course not. They are the very antipodes to each other. Miss Grantly would probably be more to my taste; but then I am wise enough to know that it is so because my taste is a bad taste.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“I know no man with a more accurate or refined taste in such matters,” said Lady Lufton. Beyond this she did not dare to go. She knew very well that her strategy would be vain should her son once learn that she had a strategy. To tell the truth, Lady Lufton was becoming somewhat indifferent to Lucy Robarts. She had been very kind to the little girl; but the little girl seemed hardly to appreciate the kindness as she should do—and then Lord Lufton would talk to Lucy, “which was so unnecessary, you know;” and Lucy had got into a way of talking quite freely with Lord Lufton, having completely dropped that short, spasmodic, ugly exclamation of “my lord.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("And so the Christmas festivities were at an end, and January wore itself away. During the greater part of this month Lord Lufton did not remain at Framley, but was nevertheless in the county, hunting with the hounds of both divisions, and staying at various houses. Two or three nights he spent at Chaldicotes; and one—let it only be told in an under voice—at Gatherum Castle! Of this he said nothing to Lady Lufton. “Why make her unhappy?” as he said to Mark. But Lady Lufton knew it, though she said not a word to him—knew it, and was unhappy. “If he would only marry Griselda, there would be an end of that danger,” she said to herself.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("But now we must go back for a while to the vicar and his little bill. It will be remembered, that his first idea with reference to that trouble, after the reading of his father’s will, was to borrow the money from his brother John. John was down at Exeter at the time, and was to stay one night at the parsonage on his way to London. Mark would broach the matter to him on the journey, painful though it would be to him to tell the story of his own folly to a brother so much younger than himself, and who had always looked up to him, clergyman and full-blown vicar as he was, with a deference greater than that which such difference in age required.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("The story was told, however; but was told all in vain, as Mark found out before he reached Framley. His brother John immediately declared that he would lend him the money, of course—eight hundred, if his brother wanted it. He, John, confessed that, as regarded the remaining two, he should like to feel the pleasure of immediate possession. As for interest, he would not take any—take interest from a brother! of course not. Well, if Mark made such a fuss about it, he supposed he must take it; but would rather not. Mark should have his own way, and do just what he liked.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("This was all very well, and Mark had fully made up his mind that his brother should not be kept long out of his money. But then arose the question, how was that money to be reached? He, Mark, was executor, or one of the executors under his father’s will, and, therefore, no doubt, could put his hand upon it; but his brother wanted five months of being of age, and could not therefore as yet be put legally in possession of the legacy.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“That’s a bore,” said the assistant private secretary to the Lord Petty Bag, thinking, perhaps, as much of his own immediate wish for ready cash as he did of his brother’s necessities. Mark felt that it was a bore, but there was nothing more to be done in that direction. He must now find out how far the bankers could assist him.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("Some week or two after his return to Framley he went over to Barchester, and called there on a certain Mr. Forrest, the manager of one of the banks, with whom he was acquainted; and with many injunctions as to secrecy told this manager the whole of his story. At first he concealed the name of his friend Sowerby, but it soon appeared that no such concealment was of any avail. “That’s Sowerby, of course,” said Mr. Forrest. “I know you are intimate with him; and all his friends go through that, sooner or later.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("It seemed to Mark as though Mr. Forrest made very light of the whole transaction.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“I cannot possibly pay the bill when it falls due,” said Mark.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Oh, no, of course not,” said Mr. Forrest. “It’s never very convenient to hand out four hundred pounds at a blow. Nobody will expect you to pay it!”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“But I suppose I shall have to do it sooner or later?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Well, that’s as may be. It will depend partly on how you manage with Sowerby, and partly on the hands it gets into. As the bill has your name on it, they’ll have patience as long as the interest is paid, and the commissions on renewal. But no doubt it will have to be met some day by somebody.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("Mr. Forrest said that he was sure that the bill was not in Barchester; Mr. Sowerby would not, he thought, have brought it to a Barchester bank. The bill was probably in London, but doubtless would be sent to Barchester for collection. “If it comes in my way,” said Mr. Forrest, “I will give you plenty of time, so that you may manage about the renewal with Sowerby. I suppose he’ll pay the expense of doing that.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("Mark’s heart was somewhat lighter as he left the bank. Mr. Forrest had made so little of the whole transaction that he felt himself justified in making little of it also. “It may be as well,” said he to himself, as he drove home, “not to tell Fanny anything about it till the three months have run round. I must make some arrangement then.” And in this way his mind was easier during the last of those three months than it had been during the two former. That feeling of over-due bills, of bills coming due, of accounts overdrawn, of tradesmen unpaid, of general money cares, is very dreadful at first; but it is astonishing how soon men get used to it. A load which would crush a man at first becomes, by habit, not only endurable, but easy and comfortable to the bearer. The habitual debtor goes along jaunty and with elastic step, almost enjoying the excitement of his embarrassments. There was Mr. Sowerby himself; who ever saw a cloud on his brow? It made one almost in love with ruin to be in his company. And even now, already, Mark Robarts was thinking to himself quite comfortably about this bill;—how very pleasantly those bankers managed these things. Pay it! No; no one will be so unreasonable as to expect you to do that! And then Mr. Sowerby certainly was a pleasant fellow, and gave a man something in return for his money. It was still a question with Mark whether Lord Lufton had not been too hard on Sowerby. Had that gentleman fallen across his clerical friend at the present moment, he might no doubt have gotten from him an acceptance for another four hundred pounds.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("One is almost inclined to believe that there is something pleasurable in the excitement of such embarrassments, as there is also in the excitement of drink. But then, at last, the time does come when the excitement is over, and when nothing but the misery is left. If there be an existence of wretchedness on earth it must be that of the elderly, worn-out "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("roué")]), _vm._v(", who has run this race of debt and bills of accommodation and acceptances,—of what, if we were not in these days somewhat afraid of good broad English, we might call lying and swindling, falsehood and fraud—and who, having ruined all whom he should have loved, having burnt up every one who would trust him much, and scorched all who would trust him a little, is at last left to finish his life with such bread and water as these men get, without one honest thought to strengthen his sinking heart, or one honest friend to hold his shivering hand! If a man could only think of that, as he puts his name to the first little bill, as to which he is so good-naturedly assured that it can easily be renewed!")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("When the three months had nearly run out, it so happened that Robarts met his friend Sowerby. Mark had once or twice ridden with Lord Lufton as far as the meet of the hounds, and may, perhaps, have gone a field or two farther on some occasions. The reader must not think that he had taken to hunting, as some parsons do; and it is singular enough that whenever they do so they always show a special aptitude for the pursuit, as though hunting were an employment peculiarly congenial with a cure of souls in the country. Such a thought would do our vicar injustice. But when Lord Lufton would ask him what on earth could be the harm of riding along the roads to look at the hounds, he hardly knew what sensible answer to give his lordship. It would be absurd to say that his time would be better employed at home in clerical matters, for it was notorious that he had not clerical pursuits for the employment of half his time. In this way, therefore, he had got into a habit of looking at the hounds, and keeping up his acquaintance in the county, meeting Lord Dumbello, Mr. Green Walker, Harold Smith, and other such like sinners; and on one such occasion, as the three months were nearly closing, he did meet Mr. Sowerby.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Look here, Sowerby; I want to speak to you for half a moment. What are you doing about that bill?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Bill—bill! what bill?—which bill? The whole bill, and nothing but the bill. That seems to be the conversation now-a-days of all men, morning, noon, and night.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Don’t you know the bill I signed for you for four hundred pounds?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Did you, though? Was not that rather green of you?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("This did seem strange to Mark. Could it really be the fact that Mr. Sowerby had so many bills flying about that he had absolutely forgotten that occurrence in the Gatherum Castle bedroom? And then to be called green by the very man whom he had obliged!")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Perhaps I was,” said Mark, in a tone that showed that he was somewhat piqued. “But all the same I should be glad to know how it will be taken up.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Oh, Mark, what a ruffian you are to spoil my day’s sport in this way. Any man but a parson would be too good a Christian for such intense cruelty. But let me see—four hundred pounds? Oh, yes—Tozer has it.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“And what will Tozer do with it?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Make money of it; whatever way he may go to work he will do that.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“But will Tozer bring it to me on the 20th?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Oh, Lord, no! Upon my word, Mark, you are deliciously green. A cat would as soon think of killing a mouse directly she got it into her claws. But, joking apart, you need not trouble yourself. Maybe you will hear no more about it; or, perhaps, which no doubt is more probable, I may have to send it to you to be renewed. But you need do nothing till you hear from me or somebody else.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Only do not let any one come down upon me for the money.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“There is not the slightest fear of that. Tally-ho, old fellow! He’s away. Tally-ho! right over by Gossetts’ barn. Come along, and never mind Tozer—‘Sufficient for the day is the evil thereof.’” And away they both went together, parson and member of Parliament.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("And then again on that occasion Mark went home with a sort of feeling that the bill did not matter. Tozer would manage it somehow; and it was quite clear that it would not do to tell his wife of it just at present.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("On the 21st of that month of February, however, he did receive a reminder that the bill and all concerning it had not merely been a farce. This was a letter from Mr. Sowerby, dated from Chaldicotes, though not bearing the Barchester post-mark, in which that gentleman suggested a renewal—not exactly of the old bill, but of a new one. It seemed to Mark that the letter had been posted in London. If I give it entire, I shall, perhaps, most quickly explain its purport:")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Ext-First"
  }, [_vm._v("Chaldicotes,—20th February, 185—.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Ext-First"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("MY DEAR MARK")]), _vm._v(",—“Lend not thy name to the money-dealers, for the same is a destruction and a snare.” If that be not in the Proverbs, it ought to be. Tozer has given me certain signs of his being alive and strong this cold weather. As we can neither of us take up that bill for £400 at the moment, we must renew it, and pay him his commission and interest, with all the rest of his perquisites, and pickings, and stealings—from all which, I can assure you, Tozer does not keep his hands as he should do.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Ext-Body"
  }, [_vm._v("To cover this and some other little outstanding trifles, I have filled in the new bill for £500, making it due 23rd of May next. Before that time, a certain accident will, I trust, have occurred to your impoverished friend. By-the-by, I never told you how she went off from Gatherum Castle, the morning after you left us, with the Greshams. Cart-ropes would not hold her, even though the duke held them; which he did, with all the strength of his ducal hands. She would go to meet some doctor of theirs, and so I was put off for that time; but I think that the matter stands in a good train.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Ext-Body"
  }, [_vm._v("Do not lose a post in sending back the bill accepted, as Tozer may annoy you—nay, undoubtedly will, if the matter be not in his hand, duly signed by both of us, the day after to-morrow. He is an ungrateful brute; he has lived on me for these eight years, and would not let me off a single squeeze now to save my life. But I am specially anxious to save you from the annoyance and cost of lawyers’ letters; and if delayed, it might get into the papers.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Ext-Body"
  }, [_vm._v("Put it under cover to me, at No. 7, Duke Street, St. James’s. I shall be in town by that time.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Ext-Body"
  }, [_vm._v("Good-bye, old fellow. That was a decent brush we had the other day from Cobbold’s Ashes. I wish I could get that brown horse from you. I would not mind going to a hundred and thirty.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Letclos"
  }, [_vm._v("Yours ever,")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Letclos-Last"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("N. SOWERBY")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("When Mark had read it through he looked down on his table to see whether the old bill had fallen from the letter; but no, there was no enclosure, and had been no enclosure but the new bill. And then he read the letter through again, and found that there was no word about the old bill,—not a syllable, at least, as to its whereabouts. Sowerby did not even say that it would remain in his own hands.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("Mark did not in truth know much about such things. It might be that the very fact of his signing this second document would render that first document null and void; and from Sowerby’s silence on the subject, it might be argued that this was so well known to be the case, that he had not thought of explaining it. But yet Mark could not see how this should be so.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("But what was he to do? That threat of cost and lawyers, and specially of the newspapers, did have its effect upon him—as no doubt it was intended to do. And then he was utterly dumfounded by Sowerby’s impudence in drawing on him for £500 instead of £400, “covering,” as Sowerby so good-humouredly said, “sundry little outstanding trifles.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("But at last he did sign the bill, and sent it off, as Sowerby had directed. What else was he to do?")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("Fool that he was. A man always can do right, even though he has done wrong before. But that previous wrong adds so much difficulty to the path—a difficulty which increases in tremendous ratio, till a man at last is choked in his struggling, and is drowned beneath the waters.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("And then he put away Sowerby’s letter carefully, locking it up from his wife’s sight. It was a letter that no parish clergyman should have received. So much he acknowledged to himself. But nevertheless it was necessary that he should keep it. And now again for a few hours this affair made him very miserable.")])])])])
}]}

/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(110),
  /* template */
  __webpack_require__(111),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 111 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('p', {
    staticClass: "ORIM-Chapter-Title-Page-Break"
  }, [_vm._v("CHAPTER XIII")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Chapter-Subtitle"
  }, [_vm._v("Delicate Hints")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Chapter-Opener-Paragraph"
  }, [_vm._v("Lady Lufton had been greatly rejoiced at that good deed which her son did in giving up his Leicestershire hunting, and coming to reside for the winter at Framley. It was proper, and becoming, and comfortable in the extreme. An English nobleman ought to hunt in the county where he himself owns the fields over which he rides; he ought to receive the respect and honour due to him from his own tenants; he ought to sleep under a roof of his own, and he ought also,—so Lady Lufton thought,—to fall in love with a young embryo bride of his own mother’s choosing. And then it was so pleasant to have him there in the house. Lady Lufton was not a woman who allowed her life to be what people in common parlance call dull. She had too many duties, and thought too much of them, to allow of her suffering from tedium and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("ennui")]), _vm._v(". But nevertheless the house was more joyous to her when he was there. There was a reason for some little gaiety, which would never have been attracted thither by herself, but which, nevertheless, she did enjoy when it was brought about by his presence. She was younger and brighter when he was there, thinking more of the future and less of the past. She could look at him, and that alone was happiness to her. And then he was pleasant-mannered with her; joking with her on her little old-world prejudices in a tone that was musical to her ear as coming from him; smiling on her, reminding her of those smiles which she had loved so dearly when as yet he was all her own, lying there in his little bed beside her chair. He was kind and gracious to her, behaving like a good son, at any rate while he was there in her presence. When we add to this her fears that he might not be so perfect in his conduct when absent, we may well imagine that Lady Lufton was pleased to have him there at Framley Court.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("She had hardly said a word to him as to that five thousand pounds. Many a night, as she lay thinking on her pillow, she said to herself that no money had ever been better expended, since it had brought him back to his own house. He had thanked her for it in his own open way, declaring that he would pay it back to her during the coming year, and comforting her heart by his rejoicing that the property had not been sold.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“I don’t like the idea of parting with an acre of it,” he had said.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Of course not, Ludovic. Never let the estate decrease in your hands. It is only by such resolutions as that that English noblemen and English gentlemen can preserve their country. I cannot bear to see property changing hands.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Well, I suppose it’s a good thing to have land in the market sometimes, so that the millionnaires may know what to do with their money.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“God forbid that yours should be there!” And the widow made a little mental prayer that her son’s acres might be protected from the millionnaires and other Philistines.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Why, yes; I don’t exactly want to see a Jew tailor investing his earnings at Lufton,” said the lord.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Heaven forbid!” said the widow. All this, as I have said, was very nice. It was manifest to her ladyship, from his lordship’s way of talking, that no vital injury had as yet been done; he had no cares on his mind, and spoke freely about the property; but nevertheless there were clouds even now, at this period of bliss, which somewhat obscured the brilliancy of Lady Lufton’s sky. Why was Ludovic so slow in that affair of Griselda Grantly? why so often in these latter winter days did he saunter over to the parsonage? And then that terrible visit to Gatherum Castle! What actually did happen at Gatherum Castle, she never knew. We, however, are more intrusive, less delicate in our inquiries, and we can say. He had a very bad day’s sport with the West Barsetshire. The county is altogether short of foxes, and some one who understands the matter must take that point up before they can do any good. And after that he had had rather a dull dinner with the duke. Sowerby had been there, and in the evening he and Sowerby had played billiards. Sowerby had won a pound or two, and that had been the extent of the damage done. But those saunterings over to the parsonage might be more dangerous. Not that it ever occurred to Lady Lufton as possible that her son should fall in love with Lucy Robarts. Lucy’s personal attractions were not of a nature to give ground for such a fear as that. But he might turn the girl’s head with his chatter; she might be fool enough to fancy any folly; and, moreover, people would talk. Why should he go to the parsonage now more frequently than he had ever done before Lucy came there?")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("And then her ladyship, in reference to the same trouble, hardly knew how to manage her invitations to the parsonage. These hitherto had been very frequent, and she had been in the habit of thinking that they could hardly be too much so; but now she was almost afraid to continue the custom. She could not ask the parson and his wife without Lucy; and when Lucy was there, her son would pass the greater part of the evening in talking to her, or playing chess with her. Now this did disturb Lady Lufton not a little. And then Lucy took it all so quietly. On her first arrival at Framley she had been so shy, so silent, and so much awestruck by the grandeur of Framley Court, that Lady Lufton had sympathized with her and encouraged her. She had endeavoured to moderate the blaze of her own splendour, in order that Lucy’s unaccustomed eyes might not be dazzled. But all this was changed now. Lucy could listen to the young lord’s voice by the hour together—without being dazzled in the least. Under these circumstances two things occurred to her. She would speak either to her son or to Fanny Robarts, and by a little diplomacy have this evil remedied. And then she had to determine on which step she would take. “Nothing could be more reasonable than Ludovic.” So at least she said to herself over and over again. But then Ludovic understood nothing about such matters; and he had, moreover, a habit, inherited from his father, of taking the bit between his teeth whenever he suspected interference. Drive him gently without pulling his mouth about, and you might take him anywhere, almost at any pace; but a smart touch, let it be ever so slight, would bring him on his haunches, and then it might be a question whether you could get him another mile that day. So that on the whole Lady Lufton thought that the other plan would be the best. I have no doubt that Lady Lufton was right.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("She got Fanny up into her own den one afternoon, and seated her discreetly in an easy arm-chair, making her guest take off her bonnet, and showing by various signs that the visit was regarded as one of great moment.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Fanny,” she said, “I want to speak to you about something that is important and necessary to mention, and yet it is a very delicate affair to speak of.” Fanny opened her eyes, and said that she hoped that nothing was wrong.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“No, my dear, I think nothing is wrong. I hope so, and I think I may say I’m sure of it; but then it’s always well to be on one’s guard.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Yes, it is,” said Fanny, who knew that something unpleasant was coming—something as to which she might probably be called upon to differ from her ladyship. Mrs. Robarts’s own fears, however, were running entirely in the direction of her husband;—and, indeed, Lady Lufton had a word or two to say on that subject also, only not exactly now. A hunting parson was not at all to her taste; but that matter might be allowed to remain in abeyance for a few days.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Now, Fanny, you know that we have all liked your sister-in-law, Lucy, very much.” And then Mrs. Robarts’s mind was immediately opened, and she knew the rest as well as though it had all been spoken. “I need hardly tell you that, for I am sure we have shown it.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“You have, indeed, as you always do.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“And you must not think that I am going to complain,” continued Lady Lufton.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“I hope there is nothing to complain of,” said Fanny, speaking by no means in a defiant tone, but humbly as it were, and deprecating her ladyship’s wrath. Fanny had gained one signal victory over Lady Lufton, and on that account, with a prudence equal to her generosity, felt that she could afford to be submissive. It might, perhaps, not be long before she would be equally anxious to conquer again.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Well, no; I don’t think there is,” said Lady Lufton. “Nothing to complain of; but a little chat between you and me may, perhaps, set matters right, which, otherwise, might become troublesome.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Is it about Lucy?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Yes, my dear—about Lucy. She is a very nice, good girl, and a credit to her father—”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“And a great comfort to us,” said Fanny.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“I am sure she is; she must be a very pleasant companion to you, and so useful about the children; but—” And then Lady Lufton paused for a moment; for she, eloquent and discreet as she always was, felt herself rather at a loss for words to express her exact meaning.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“I don’t know what I should do without her,” said Fanny, speaking with the object of assisting her ladyship in her embarrassment.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“But the truth is this: she and Lord Lufton are getting into the way of being too much together—of talking to each other too exclusively. I am sure you must have noticed it, Fanny. It is not that I suspect any evil. I don’t think that I am suspicious by nature.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Oh! no,” said Fanny.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“But they will each of them get wrong ideas about the other, and about themselves. Lucy will, perhaps, think that Ludovic means more than he does, and Ludovic will—” But it was not quite so easy to say what Ludovic might do or think; but Lady Lufton went on: “I am sure that you understand me, Fanny, with your excellent sense and tact. Lucy is clever, and amusing, and all that; and Ludovic, like all young men, is perhaps ignorant that his attentions may be taken to mean more than he intends—”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“You don’t think that Lucy is in love with him?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Oh dear, no—nothing of the kind. If I thought it had come to that, I should recommend that she should be sent away altogether. I am sure she is not so foolish as that.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“I don’t think there is anything in it at all, Lady Lufton.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“I don’t think there is, my dear, and therefore I would not for worlds make any suggestion about it to Lord Lufton. I would not let him suppose that I suspected Lucy of being so imprudent. But still, it may be well that you should just say a word to her. A little management now and then, in such matters, is so useful.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“But what shall I say to her?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Just explain to her that any young lady who talks so much to the same young gentleman will certainly be observed—that people will accuse her of setting her cap at Lord Lufton. Not that I suspect her—I give her credit for too much proper feeling. I know her education has been good, and her principles are upright. But people will talk of her. You must understand that, Fanny, as well as I do.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("Fanny could not help meditating whether proper feeling, education, and upright principles did forbid Lucy Robarts to fall in love with Lord Lufton; but her doubts on this subject, if she held any, were not communicated to her ladyship. It had never entered into her mind that a match was possible between Lord Lufton and Lucy Robarts, nor had she the slightest wish to encourage it now that the idea was suggested to her. On such a matter she could sympathize with Lady Lufton, though she did not completely agree with her as to the expediency of any interference. Nevertheless, she at once offered to speak to Lucy.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“I don’t think that Lucy has any idea in her head upon the subject,” said Mrs. Robarts.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“I daresay not;—I don’t suppose she has. But young ladies sometimes allow themselves to fall in love, and then to think themselves very ill-used, just because they have had no idea in their head.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“I will put her on her guard if you wish it, Lady Lufton.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Exactly, my dear; that is just it. Put her on her guard—that is all that is necessary. She is a dear, good, clever girl, and it would be very sad if anything were to interrupt our comfortable way of getting on with her.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("Mrs. Robarts knew to a nicety the exact meaning of this threat. If Lucy would persist in securing to herself so much of Lord Lufton’s time and attention, her visits to Framley Court must become less frequent. Lady Lufton would do much, very much, indeed, for her friends at the parsonage; but not even for them could she permit her son’s prospects in life to be endangered.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("There was nothing more said between them, and Mrs. Robarts got up to take her leave, having promised to speak to Lucy.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“You manage everything so perfectly,” said Lady Lufton, as she pressed Mrs. Robarts’s hand, “that I am quite at ease now that I find you will agree with me.” Mrs. Robarts did not exactly agree with her ladyship, but she hardly thought it worth her while to say so.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("Mrs. Robarts immediately started off on her walk to her own home, and when she had got out of the grounds into the road, where it makes a turn towards the parsonage, nearly opposite to Podgens’s shop, she saw Lord Lufton on horseback, and Lucy standing beside him. It was already nearly five o’clock, and it was getting dusk; but as she approached, or rather as she came suddenly within sight of them, she could see that they were in close conversation. Lord Lufton’s face was towards her, and his horse was standing still; he was leaning over towards his companion, and the whip, which he held in his right hand, hung almost over her arm and down her back, as though his hand had touched and perhaps rested on her shoulder. She was standing by his side, looking up into his face, with one gloved hand resting on the horse’s neck. Mrs. Robarts, as she saw them, could not but own that there might be cause for Lady Lufton’s fears.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("But then Lucy’s manner, as Mrs. Robarts approached, was calculated to dissipate any such fears, and to prove that there was no ground for them. She did not move from her position, or allow her hand to drop, or show that she was in any way either confused or conscious. She stood her ground, and when her sister-in-law came up was smiling and at her ease.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Lord Lufton wants me to learn to ride,” said she.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“To learn to ride!” said Fanny, not knowing what answer to make to such a proposition.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Yes,” said he. “This horse would carry her beautifully. He is as quiet as a lamb, and I made Gregory go out with him yesterday with a sheet hanging over him like a lady’s habit, and the man got up into a lady’s saddle.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“I think Gregory would make a better hand of it than Lucy.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“The horse cantered with him as though he had carried a lady all his life, and his mouth is like velvet; indeed, that is his fault—he is too soft-mouthed.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“I suppose that’s the same sort of thing as a man being soft-hearted,” said Lucy.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Exactly; you ought to ride them both with a very light hand. They are difficult cattle to manage, but very pleasant when you know how to do it.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“But you see I don’t know how to do it,” said Lucy.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“As regards the horse, you will learn in two days, and I do hope you will try. Don’t you think it will be an excellent thing for her, Mrs. Robarts?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Lucy has got no habit,” said Mrs. Robarts, making use of the excuse common on all such occasions.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“There is one of Justinia’s in the house, I know. She always leaves one here, in order that she may be able to ride when she comes.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“She would not think of taking such a liberty with Lady Meredith’s things,” said Fanny, almost frightened at the proposal.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Of course it is out of the question, Fanny,” said Lucy, now speaking rather seriously. “In the first place, I would not take Lord Lufton’s horse; in the second place, I would not take Lady Meredith’s habit; in the third place, I should be a great deal too much frightened; and, lastly, it is quite out of the question for a great many other very good reasons.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Nonsense,” said Lord Lufton.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“A great deal of nonsense,” said Lucy, laughing, “but all of it of Lord Lufton’s talking. But we are getting cold—are we not, Fanny?—so we will wish you good-night.” And then the two ladies shook hands with him, and walked on towards the parsonage.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("That which astonished Mrs. Robarts the most in all this was the perfectly collected manner in which Lucy spoke and conducted herself. This connected, as she could not but connect it, with the air of chagrin with which Lord Lufton received Lucy’s decision, made it manifest to Mrs. Robarts that Lord Lufton was annoyed because Lucy would not consent to learn to ride; whereas she, Lucy herself, had given her refusal in a firm and decided tone, as though resolved that nothing more should be said about it.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("They walked on in silence for a minute or two, till they reached the parsonage gate, and then Lucy said, laughing, “Can’t you fancy me sitting on that great big horse? I wonder what Lady Lufton would say if she saw me there, and his lordship giving me my first lesson?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“I don’t think she would like it,” said Fanny.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“I’m sure she would not. But I will not try her temper in that respect. Sometimes I fancy that she does not even like seeing Lord Lufton talking to me.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“She does not like it, Lucy, when she sees him flirting with you.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("This Mrs. Robarts said rather gravely, whereas Lucy had been speaking in a half-bantering tone. As soon as even the word flirting was out of Fanny’s mouth, she was conscious that she had been guilty of an injustice in using it. She had wished to say something which would convey to her sister-in-law an idea of what Lady Lufton would dislike; but in doing so, she had unintentionally brought against her an accusation.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Flirting, Fanny!” said Lucy, standing still in the path, and looking up into her companion’s face with all her eyes. “Do you mean to say that I have been flirting with Lord Lufton?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“I did not say that.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Or that I have allowed him to flirt with me?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“I did not mean to shock you, Lucy.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“What did you mean, Fanny?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Why, just this: that Lady Lufton would not be pleased if he paid you marked attentions, and if you received them;—just like that affair of the riding; it was better to decline it.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Of course I declined it; of course I never dreamt of accepting such an offer. Go riding about the country on his horses! What have I done, Fanny, that you should suppose such a thing?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“You have done nothing, dearest.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Then why did you speak as you did just now?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Because I wished to put you on your guard. You know, Lucy, that I do not intend to find fault with you; but you may be sure, as a rule, that intimate friendships between young gentlemen and young ladies are dangerous things.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("They then walked up to the hall-door in silence. When they had reached it, Lucy stood in the doorway instead of entering it, and said, “Fanny, let us take another turn together, if you are not tired.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“No, I’m not tired.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“It will be better that I should understand you at once,”—and then they again moved away from the house. “Tell me truly now, do you think that Lord Lufton and I have been flirting?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“I do think that he is a little inclined to flirt with you.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“And Lady Lufton has been asking you to lecture me about it?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("Poor Mrs. Robarts hardly knew what to say. She thought well of all the persons concerned, and was very anxious to behave well by all of them;—was particularly anxious to create no ill feeling, and wished that everybody should be comfortable, and on good terms with everybody else. But yet the truth was forced out of her when this question was asked so suddenly.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Not to lecture you, Lucy,” she said at last.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Well, to preach to me, or to talk to me, or to give me a lesson; to say something that shall drive me to put my back up against Lord Lufton?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“To caution you, dearest. Had you heard what she said, you would hardly have felt angry with Lady Lufton.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Well, to caution me. It is such a pleasant thing for a girl to be cautioned against falling in love with a gentleman, especially when the gentleman is very rich, and a lord, and all that sort of thing!”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Nobody for a moment attributes anything wrong to you, Lucy.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Anything wrong—no. I don’t know whether it would be anything wrong, even if I were to fall in love with him. I wonder whether they cautioned Griselda Grantly when she was here? I suppose when young lords go about, all the girls are cautioned as a matter of course. Why do they not label him ‘dangerous’?” And then again they were silent for a moment, as Mrs. Robarts did not feel that she had anything further to say on the matter.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“‘Poison’ should be the word with any one so fatal as Lord Lufton; and he ought to be made up of some particular colour, for fear he should be swallowed in mistake.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“You will be safe, you see,” said Fanny, laughing, “as you have been specially cautioned as to this individual bottle.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Ah! but what’s the use of that after I have had so many doses? It is no good telling me about it now, when the mischief is done,—after I have been taking it for I don’t know how long. Dear! dear! dear! and I regarded it as a mere commonplace powder, good for the complexion. I wonder whether it’s too late, or whether there’s any antidote?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("Mrs. Robarts did not always quite understand her sister-in-law, and now she was a little at a loss. “I don’t think there’s much harm done yet on either side,” she said, cheerily.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Ah! you don’t know, Fanny. But I do think that if I die—as I shall—I feel I shall;—and if so, I do think it ought to go very hard with Lady Lufton. Why didn’t she label him ‘dangerous’ in time?” And then they went into the house and up to their own rooms.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("It was difficult for any one to understand Lucy’s state of mind at present, and it can hardly be said that she understood it herself. She felt that she had received a severe blow in having been thus made the subject of remark with reference to Lord Lufton. She knew that her pleasant evenings at Framley Court were now over, and that she could not again talk to him in an unrestrained tone and without embarrassment. She had felt the air of the whole place to be very cold before her intimacy with him, and now it must be cold again. Two homes had been open to her, Framley Court and the parsonage; and now, as far as comfort was concerned, she must confine herself to the latter. She could not again be comfortable in Lady Lufton’s drawing-room.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("But then she could not help asking herself whether Lady Lufton was not right. She had had courage enough, and presence of mind, to joke about the matter when her sister-in-law spoke to her, and yet she was quite aware that it was no joking matter. Lord Lufton had not absolutely made love to her, but he had latterly spoken to her in a manner which she knew was not compatible with that ordinary comfortable masculine friendship with the idea of which she had once satisfied herself. Was not Fanny right when she said that intimate friendships of that nature were dangerous things?")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("Yes, Lucy, very dangerous. Lucy, before she went to bed that night, had owned to herself that they were so; and lying there with sleepless eyes and a moist pillow, she was driven to confess that the label would in truth be now too late, that the caution had come to her after the poison had been swallowed. Was there any antidote? That was all that was left for her to consider. But, nevertheless, on the following morning she could appear quite at her ease. And when Mark had left the house after breakfast, she could still joke with Fanny as to Lady Lufton’s poison cupboard.")])])])])
}]}

/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(113),
  /* template */
  __webpack_require__(114),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 114 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('p', {
    staticClass: "ORIM-Chapter-Title-Page-Break"
  }, [_vm._v("CHAPTER XIV")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Chapter-Subtitle"
  }, [_vm._v("Mr. Crawley of Hogglestock")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Chapter-Opener-Paragraph"
  }, [_vm._v("And then there was that other trouble in Lady Lufton’s mind, the sins, namely, of her selected parson. She had selected him, and she was by no means inclined to give him up, even though his sins against parsondom were grievous. Indeed she was a woman not prone to give up anything, and of all things not prone to give up a "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("protégé")]), _vm._v(". The very fact that she herself had selected him was the strongest argument in his favour.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("But his sins against parsondom were becoming very grievous in her eyes, and she was at a loss to know what steps to take. She hardly dared to take him to task, him himself. Were she to do so, and should he then tell her to mind her own business—as he probably might do, though not in those words—there would be a schism in the parish; and almost anything would be better than that. The whole work of her life would be upset, all the outlets of her energy would be impeded if not absolutely closed, if a state of things were to come to pass in which she and the parson of her parish should not be on good terms.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("But what was to be done? Early in the winter he had gone to Chaldicotes and to Gatherum Castle, consorting with gamblers, Whigs, atheists, men of loose pleasure, and Proudieites. That she had condoned; and now he was turning out a hunting parson on her hands. It was all very well for Fanny to say that he merely looked at the hounds as he rode about his parish. Fanny might be deceived. Being his wife, it might be her duty not to see her husband’s iniquities. But Lady Lufton could not be deceived. She knew very well in what part of the county Cobbold’s Ashes lay. It was not in Framley parish, nor in the next parish to it. It was half-way across to Chaldicotes—in the western division; and she had heard of that run in which two horses had been killed, and in which Parson Robarts had won such immortal glory among West Barsetshire sportsmen. It was not easy to keep Lady Lufton in the dark as to matters occurring in her own county.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("All these things she knew, but as yet had not noticed, grieving over them in her own heart the more on that account. Spoken grief relieves itself; and when one can give counsel, one always hopes at least that that counsel will be effective. To her son she had said, more than once, that it was a pity that Mr. Robarts should follow the hounds.—“The world has agreed that it is unbecoming in a clergyman,” she would urge, in her deprecatory tone. But her son would by no means give her any comfort. “He doesn’t hunt, you know—not as I do,” he would say. “And if he did, I really don’t see the harm of it. A man must have some amusement, even if he be an archbishop.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“He has amusement at home,” Lady Lufton would answer. “What does his wife do—and his sister?” This allusion to Lucy, however, was very soon dropped.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("Lord Lufton would in no wise help her. He would not even passively discourage the vicar, or refrain from offering to give him a seat in going to the meets. Mark and Lord Lufton had been boys together, and his lordship knew that Mark in his heart would enjoy a brush across the country quite as well as he himself; and then what was the harm of it?")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("Lady Lufton’s best aid had been in Mark’s own conscience. He had taken himself to task more than once, and had promised himself that he would not become a sporting parson. Indeed, where would be his hopes of ulterior promotion, if he allowed himself to degenerate so far as that? It had been his intention, in reviewing what he considered to be the necessary proprieties of clerical life, in laying out his own future mode of living, to assume no peculiar sacerdotal strictness; he would not be known as a denouncer of dancing or of card-tables, of theatres or of novel-reading; he would take the world around him as he found it, endeavouring by precept and practice to lend a hand to the gradual amelioration which Christianity is producing; but he would attempt no sudden or majestic reforms. Cake and ale would still be popular, and ginger be hot in the mouth, let him preach ever so—let him be never so solemn a hermit; but a bright face, a true trusting heart, a strong arm, and an humble mind, might do much in teaching those around him that men may be gay and yet not profligate, that women may be devout and yet not dead to the world.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("Such had been his ideas as to his own future life; and though many would think that as a clergyman he should have gone about his work with more serious devotion of thought, nevertheless there was some wisdom in them;—some folly also, undoubtedly, as appeared by the troubles into which they led him.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“I will not affect to think that to be bad,” said he to himself, “which in my heart of hearts does not seem to be bad.” And thus he resolved that he might live without contamination among hunting squires. And then, being a man only too prone by nature to do as others did around him, he found by degrees that that could hardly be wrong for him which he admitted to be right for others.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("But still his conscience upbraided him, and he declared to himself more than once that after this year he would hunt no more. And then his own Fanny would look at him on his return home on those days in a manner that cut him to the heart. She would say nothing to him. She never inquired in a sneering tone, and with angry eyes, whether he had enjoyed his day’s sport; but when he spoke of it, she could not answer him with enthusiasm; and in other matters which concerned him she was always enthusiastic.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("After a while, too, he made matters worse, for about the end of March he did another very foolish thing. He almost consented to buy an expensive horse from Sowerby—an animal which he by no means wanted, and which, if once possessed, would certainly lead him into further trouble. A gentleman, when he has a good horse in his stable, does not like to leave him there eating his head off. If he be a gig-horse, the owner of him will be keen to drive a gig; if a hunter, the happy possessor will wish to be with a pack of hounds.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Mark,” said Sowerby to him one day, when they were out together, “this brute of mine is so fresh, I can hardly ride him; you are young and strong; change with me for an hour or so.” And then they did change, and the horse on which Robarts found himself mounted went away with him beautifully.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“He’s a splendid animal,” said Mark, when they again met.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Yes, for a man of your weight. He’s thrown away upon me;—too much of a horse for my purposes. I don’t get along now quite as well as I used to do. He is a nice sort of hunter; just rising six, you know.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("How it came to pass that the price of the splendid animal was mentioned between them, I need not describe with exactness. But it did come to pass that Mr. Sowerby told the parson that the horse should be his for £130.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“And I really wish you’d take him,” said Sowerby. “It would be the means of partially relieving my mind of a great weight.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("Mark looked up into his friend’s face with an air of surprise, for he did not at the moment understand how this should be the case.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“I am afraid, you know, that you will have to put your hand into your pocket sooner or later about that accursed bill”—Mark shrank as the profane word struck his ears—“and I should be glad to think that you had got something in hand in the way of value.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Do you mean that I shall have to pay the whole sum of £500?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Oh! dear, no; nothing of the kind. But something I daresay you will have to pay: if you like to take Dandy for a hundred and thirty, you can be prepared for that amount when Tozer comes to you. The horse is dog cheap, and you will have a long day for your money.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("Mark at first declared, in a quiet, determined tone, that he did not want the horse; but it afterwards appeared to him that if it were so fated that he must pay a portion of Mr. Sowerby’s debts, he might as well repay himself to any extent within his power. It would be as well perhaps that he should take the horse and sell him. It did not occur to him that by so doing he would put it in Mr. Sowerby’s power to say that some valuable consideration had passed between them with reference to this bill, and that he would be aiding that gentleman in preparing an inextricable confusion of money-matters between them. Mr. Sowerby well knew the value of this. It would enable him to make a plausible story, as he had done in that other case of Lord Lufton.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Are you going to have Dandy?” Sowerby said to him again.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“I can’t say that I will just at present,” said the parson. “What should I want of him now the season’s over?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Exactly, my dear fellow; and what do I want of him now the season’s over? If it were the beginning of October instead of the end of March, Dandy would be up at two hundred and thirty instead of one. In six months’ time that horse will be worth anything you like to ask for him. Look at his bone.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("The vicar did look at his bones, examining the brute in a very knowing and unclerical manner. He lifted the animal’s four feet, one after another, handling the frogs, and measuring with his eye the proportion of the parts; he passed his hand up and down the legs, spanning the bones of the lower joint; he peered into his eyes, took into consideration the width of his chest, the dip of his back, the form of his ribs, the curve of his haunches, and his capabilities for breathing when pressed by work. And then he stood away a little, eyeing him from the side, and taking in a general idea of the form and make of the whole. “He seems to stand over a little, I think,” said the parson.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“It’s the lie of the ground. Move him about, Bob. There now, let him stand there.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“He’s not perfect,” said Mark. “I don’t quite like his heels; but no doubt he’s a nicish cut of a horse.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“I rather think he is. If he were perfect, as you say, he would not be going into your stables for a hundred and thirty. Do you ever remember to have seen a perfect horse?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Your mare Mrs. Gamp was as nearly perfect as possible.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Even Mrs. Gamp had her faults. In the first place she was a bad feeder. But one certainly doesn’t often come across anything much better than Mrs. Gamp.” And thus the matter was talked over between them with much stable conversation, all of which tended to make Sowerby more and more oblivious of his friend’s sacred profession, and perhaps to make the vicar himself too frequently oblivious of it also. But no; he was not oblivious of it. He was even mindful of it; but mindful of it in such a manner that his thoughts on the subject were nowadays always painful.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("There is a parish called Hogglestock lying away quite in the northern extremity of the eastern division of the county—lying also on the borders of the western division. I almost fear that it will become necessary, before this history be completed, to provide a map of Barsetshire for the due explanation of all these localities. Framley is also in the northern portion of the county, but just to the south of the grand trunk line of railway from which the branch to Barchester strikes off at a point some thirty miles nearer to London. The station for Framley Court is Silverbridge, which is, however, in the western division of the county. Hogglestock is to the north of the railway, the line of which, however, runs through a portion of the parish, and it adjoins Framley, though the churches are as much as seven miles apart. Barsetshire, taken altogether, is a pleasant green tree-becrowded county, with large bosky hedges, pretty damp deep lanes, and roads with broad grass margins running along them. Such is the general nature of the county; but just up in its northern extremity this nature alters. There it is bleak and ugly, with low artificial hedges and without wood; not uncultivated, as it is all portioned out into new-looking large fields, bearing turnips and wheat and mangel, all in due course of agricultural rotation; but it has none of the special beauties of English cultivation. There is not a gentleman’s house in the parish of Hogglestock besides that of the clergyman; and this, though it is certainly the house of a gentleman, can hardly be said to be fit to be so. It is ugly, and straight, and small. There is a garden attached to the house, half in front of it and half behind; but this garden, like the rest of the parish, is by no means ornamental, though sufficiently useful. It produces cabbages, but no trees; potatoes of, I believe, an excellent description, but hardly any flowers, and nothing worthy of the name of a shrub. Indeed the whole parish of Hogglestock should have been in the adjoining county, which is by no means so attractive as Barsetshire;—a fact well known to those few of my readers who are well acquainted with their own country.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("Mr. Crawley, whose name has been mentioned in these pages, was the incumbent of Hogglestock. On what principle the remuneration of our parish clergymen was settled when the original settlement was made, no deepest, keenest lover of middle-aged ecclesiastical black-letter learning can, I take it, now say. That the priests were to be paid from tithes of the parish produce, out of which tithes certain other good things were to be bought and paid for, such as church repairs and education, of so much the most of us have an inkling. That a rector, being a big sort of parson, owned the tithes of his parish in full,—or at any rate that part of them intended for the clergyman,—and that a vicar was somebody’s deputy, and therefore entitled only to little tithes, as being a little body: of so much we that are simple in such matters have a general idea. But one cannot conceive that even in this way any approximation could have been made, even in those old mediæval days, towards a fair proportioning of the pay to the work. At any rate, it is clear enough that there is no such approximation now.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("And what a screech would there not be among the clergy of the Church, even in these reforming days, if any over-bold reformer were to suggest that such an approximation should be attempted? Let those who know clergymen, and like them, and have lived with them, only fancy it! Clergymen to be paid, not according to the temporalities of any living which they may have acquired either by merit or favour, but in accordance with the work to be done! O Doddington! and O Stanhope, think of this, if an idea so sacrilegious can find entrance into your warm ecclesiastical bosoms! Ecclesiastical work to be bought and paid for according to its quantity and quality!")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("But, nevertheless, one may prophesy that we Englishmen must come to this, disagreeable as the idea undoubtedly is. Most pleasant-minded churchmen feel, I think, on this subject pretty much in the same way. Our present arrangement of parochial incomes is beloved as being time-honoured, gentlemanlike, English, and picturesque. We would fain adhere to it closely as long as we can, but we know that we do so by the force of our prejudices, and not by that of our judgment. A time-honoured, gentlemanlike, English, picturesque arrangement is so far very delightful. But are there not other attributes very desirable—nay, absolutely necessary—in respect to which this time-honoured, picturesque arrangement is so very deficient?")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("How pleasant it was, too, that one bishop should be getting fifteen thousand a year and another with an equal cure of parsons only four! That a certain prelate could get twenty thousand one year and his successor in the same diocese only five the next! There was something in it pleasant, and picturesque; it was an arrangement endowed with feudal charms, and the change which they have made was distasteful to many of us. A bishop with a regular salary, and no appanage of land and land-bailiffs, is only half a bishop. Let any man prove to me the contrary ever so thoroughly—let me prove it to my own self ever so often—my heart in this matter is not thereby a whit altered. One liked to know that there was a dean or two who got his three thousand a year, and that old Dr. Purple held four stalls, one of which was golden, and the other three silver-gilt! Such knowledge was always pleasant to me! A golden stall! How sweet is the sound thereof to church-loving ears!")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("But bishops have been shorn of their beauty, and deans are in their decadence. A utilitarian age requires the fatness of the ecclesiastical land, in order that it may be divided out into small portions of provender, on which necessary working clergymen may live,—into portions so infinitesimally small that working clergymen can hardly live. And the full-blown rectors and vicars, with full-blown tithes—with tithes when too full-blown for strict utilitarian principles—will necessarily follow. Stanhope and Doddington must bow their heads, with such compensation for temporal rights as may be extracted,—but probably without such compensation as may be desired. In other trades, professions, and lines of life, men are paid according to their work. Let it be so in the Church. Such will sooner or later be the edict of a utilitarian, reforming, matter-of-fact House of Parliament.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("I have a scheme of my own on the subject, which I will not introduce here, seeing that neither men nor women would read it. And with reference to this matter, I will only here further explain that all these words have been brought about by the fact, necessary to be here stated, that Mr. Crawley only received one hundred and thirty pounds a year for performing the whole parochial duty of the parish of Hogglestock. And Hogglestock is a large parish. It includes two populous villages, abounding in brickmakers, a race of men very troublesome to a zealous parson who won’t let men go rollicking to the devil without interference. Hogglestock has full work for two men; and yet all the funds therein applicable to parson’s work is this miserable stipend of one hundred and thirty pounds a year. It is a stipend neither picturesque, nor time-honoured, nor feudal, for Hogglestock takes rank only as a perpetual curacy.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("Mr. Crawley has been mentioned before as a clergyman of whom Mr. Robarts said, that he almost thought it wrong to take a walk out of his own parish. In so saying Mark Robarts of course burlesqued his brother parson; but there can be no doubt that Mr. Crawley was a strict man,—a strict, stern, unpleasant man, and one who feared God and his own conscience. We must say a word or two of Mr. Crawley and his concerns.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("He was now some forty years of age, but of these he had not been in possession even of his present benefice for more than four or five. The first ten years of his life as a clergyman had been passed in performing the duties and struggling through the life of a curate in a bleak, ugly, cold parish on the northern coast of Cornwall. It had been a weary life and a fearful struggle, made up of duties ill requited and not always satisfactorily performed, of love and poverty, of increasing cares, of sickness, debt, and death. For Mr. Crawley had married almost as soon as he was ordained, and children had been born to him in that chill, comfortless Cornish cottage. He had married a lady well educated and softly nurtured, but not dowered with worldly wealth. They two had gone forth determined to fight bravely together; to disregard the world and the world’s ways, looking only to God and to each other for their comfort. They would give up ideas of gentle living, of soft raiment, and delicate feeding. Others,—those that work with their hands, even the bettermost of such workers—could live in decency and health upon even such provision as he could earn as a clergyman. In such manner would they live, so poorly and so decently, working out their work, not with their hands but with their hearts.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("And so they had established themselves, beginning the world with one bare-footed little girl of fourteen to aid them in their small household matters; and for a while they had both kept heart, loving each other dearly, and prospering somewhat in their work. But a man who has once walked the world as a gentleman knows not what it is to change his position, and place himself lower down in the social rank. Much less can he know what it is so to put down the woman whom he loves. There are a thousand things, mean and trifling in themselves, which a man despises when he thinks of them in his philosophy, but to dispense with which puts his philosophy to so stern a proof. Let any plainest man who reads this think of his usual mode of getting himself into his matutinal garments, and confess how much such a struggle would cost him. And then children had come. The wife of the labouring man does rear her children, and often rears them in health, without even so many appliances of comfort as found their way into Mrs. Crawley’s cottage; but the task to her was almost more than she could accomplish. Not that she ever fainted or gave way. She was made of the sterner metal of the two, and could last on while he was prostrate.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("Sometimes he was prostrate;—prostrate in soul and spirit. Then would he complain with bitter voice, crying out that the world was too hard for him, that his back was broken with his burden, that his God had deserted him. For days and days, in such moods, he would stay within his cottage, never darkening the door or seeing other face than those of his own inmates. Those days were terrible both to him and her. He would sit there unwashed, with his unshorn face resting on his hand, with an old dressing-gown hanging loose about him, hardly tasting food, seldom speaking, striving to pray, but striving so frequently in vain. And then he would rise from his chair, and, with a burst of frenzy, call upon his Creator to remove him from this misery. In these moments she never deserted him. At one period they had had four children, and though the whole weight of this young brood rested on her arms, on her muscles, on her strength of mind and body, she never ceased in her efforts to comfort him. Then at length, falling utterly upon the ground, he would pour forth piteous prayers for mercy, and, after a night of sleep, would once more go forth to his work.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("But she never yielded to despair. The struggle was never beyond her powers of endurance. She had possessed her share of woman’s loveliness, but that was now all gone. Her colour quickly faded, and the fresh, soft tints soon deserted her face and forehead. She became thin, and rough, and almost haggard; thin, till her cheek-bones were nearly pressing through her skin, till her elbows were sharp, and her finger-bones as those of a skeleton. Her eye did not lose its lustre, but it became unnaturally bright, prominent, and too large for her wan face. The soft brown locks which she had once loved to brush back, scorning, as she would boast to herself, to care that they should be seen, were now sparse enough and all untidy and unclean. It was matter of little thought now whether they were seen or no. Whether he could be made fit to go into his pulpit—whether they might be fed—those four innocents—and their backs kept from the cold wind—that was now the matter of her thought.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("And then two of them died, and she went forth herself to see them laid under the frost-bound sod, lest he should faint in his work over their graves. For he would ask aid from no man—such at least was his boast through all.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("Two of them died, but their illness had been long; and then debts came upon them. Debt, indeed, had been creeping on them with slow but sure feet during the last five years. Who can see his children hungry, and not take bread if it be offered? Who can see his wife lying in sharpest want, and not seek a remedy if there be a remedy within reach? So debt had come upon them, and rude men pressed for small sums of money—for sums small to the world, but impossibly large to them. And he would hide himself within there, in that cranny of an inner chamber—hide himself with deep shame from the world, with shame, and a sinking heart, and a broken spirit.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("But had such a man no friend? it will be said. Such men, I take it, do not make many friends. But this man was not utterly friendless. Almost every year one visit was paid to him in his Cornish curacy by a brother clergyman, an old college friend, who, as far as might in him lie, did give aid to the curate and his wife. This gentleman would take up his abode for a week at a farmer’s in the neighbourhood, and though he found Mr. Crawley in despair, he would leave him with some drops of comfort in his soul. Nor were the benefits in this respect all on one side. Mr. Crawley, though at some periods weak enough for himself, could be strong for others; and, more than once, was strong to the great advantage of this man whom he loved. And then, too, pecuniary assistance was forthcoming—in those earlier years not in great amount, for this friend was not then among the rich ones of the earth—but in amount sufficient for that moderate hearth, if only its acceptance could have been managed. But in that matter there were difficulties without end. Of absolute money tenders Mr. Crawley would accept none. But a bill here and there was paid, the wife assisting; and shoes came for Kate—till Kate was placed beyond the need of shoes; and cloth for Harry and Frank found its way surreptitiously in beneath the cover of that wife’s solitary trunk—cloth with which those lean fingers worked garments for the two boys, to be worn—such was God’s will—only by the one.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("Such were Mr. and Mrs. Crawley in their Cornish curacy, and during their severest struggles. To one who thinks that a fair day’s work is worth a fair day’s wages, it seems hard enough that a man should work so hard and receive so little. There will be those who think that the fault was all his own in marrying so young. But still there remains that question, Is not a fair day’s work worth a fair day’s wages? This man did work hard—at a task perhaps the hardest of any that a man may do; and for ten years he earned some seventy pounds a year. Will any one say that he received fair wages for his fair work, let him be married or single? And yet there are so many who would fain pay their clergy, if they only knew how to apply their money! But that is a long subject, as Mr. Robarts had told Miss Dunstable. Such was Mr. Crawley in his Cornish curacy.")])])])])
}]}

/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(116),
  /* template */
  __webpack_require__(117),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 117 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('p', {
    staticClass: "ORIM-Chapter-Title-Page-Break"
  }, [_vm._v("CHAPTER XV")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Chapter-Subtitle"
  }, [_vm._v("Lady Lufton’s Ambassador")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Chapter-Opener-Paragraph"
  }, [_vm._v("And then, in the days which followed, that friend of Mr. Crawley’s, whose name, by-the-by, is yet to be mentioned, received quick and great promotion. Mr. Arabin by name he was then;—Dr. Arabin afterwards, when that quick and great promotion reached its climax. He had been simply a Fellow of Lazarus in those former years. Then he became Vicar of St. Ewold’s, in East Barsetshire, and had not yet got himself settled there when he married the Widow Bold, a widow with belongings in land and funded money, and with but one small baby as an encumbrance. Nor had he even yet married her,—had only engaged himself so to do, when they made him Dean of Barchester—all which may be read in the diocesan and county chronicles.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("And now that he was wealthy, the new dean did contrive to pay the debts of his poor friend, some lawyer of Camelford assisting him. It was but a paltry schedule after all, amounting in the total to something not much above a hundred pounds. And then, in the course of eighteen months, this poor piece of preferment fell in the dean’s way, this incumbency of Hogglestock with its stipend reaching one hundred and thirty pounds a year. Even that was worth double the Cornish curacy, and there was, moreover, a house attached to it. Poor Mrs. Crawley, when she heard of it, thought that their struggles of poverty were now well nigh over. What might not be done with a hundred and thirty pounds by people who had lived for ten years on seventy?")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("And so they moved away out of that cold, bleak country, carrying with them their humble household gods, and settled themselves in another country, cold and bleak also, but less terribly so than the former. They settled themselves, and again began their struggles against man’s hardness and the devil’s zeal. I have said that Mr. Crawley was a stern, unpleasant man; and it certainly was so. The man must be made of very sterling stuff, whom continued and undeserved misfortune does not make unpleasant. This man had so far succumbed to grief, that it had left upon him its marks, palpable and not to be effaced. He cared little for society, judging men to be doing evil who did care for it. He knew as a fact, and believed with all his heart, that these sorrows had come to him from the hand of God, and that they would work for his weal in the long run; but not the less did they make him morose, silent, and dogged. He had always at his heart a feeling that he and his had been ill-used, and too often solaced himself, at the devil’s bidding, with the conviction that eternity would make equal that which life in this world had made so unequal;—the last bait that with which the devil angles after those who are struggling to elude his rod and line.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("The Framley property did not run into the parish of Hogglestock; but nevertheless Lady Lufton did what she could in the way of kindness to these new-comers. Providence had not supplied Hogglestock with a Lady Lufton, or with any substitute in the shape of lord or lady, squire or squiress. The Hogglestock farmers, male and female, were a rude, rough set, not bordering in their social rank on the farmer gentle; and Lady Lufton, knowing this, and hearing something of these Crawleys from Mrs. Arabin, the dean’s wife, trimmed her lamps, so that they should shed a wider light, and pour forth some of their influence on that forlorn household.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("And as regards Mrs. Crawley, Lady Lufton by no means found that her work and good-will were thrown away. Mrs. Crawley accepted her kindness with thankfulness, and returned to some of the softnesses of life under her hand. As for dining at Framley Court, that was out of the question. Mr. Crawley, she knew, would not hear of it, even if other things were fitting and appliances were at command. Indeed Mrs. Crawley at once said that she felt herself unfit to go through such a ceremony with anything like comfort. The dean, she said, would talk of their going to stay at the deanery; but she thought it quite impossible that either of them should endure even that. But, all the same, Lady Lufton was a comfort to her; and the poor woman felt that it was well to have a lady near her in case of need.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("The task was much harder with Mr. Crawley, but even with him it was not altogether unsuccessful. Lady Lufton talked to him of his parish and of her own; made Mark Robarts go to him, and by degrees did something towards civilizing him. Between him and Robarts too there grew up an intimacy rather than a friendship. Robarts would submit to his opinion on matters of ecclesiastical and even theological law, would listen to him with patience, would agree with him where he could, and differ from him mildly when he could not. For Robarts was a man who made himself pleasant to all men. And thus, under Lady Lufton’s wing, there grew up a connection between Framley and Hogglestock, in which Mrs. Robarts also assisted.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("And now that Lady Lufton was looking about her, to see how she might best bring proper clerical influence to bear upon her own recreant fox-hunting parson, it occurred to her that she might use Mr. Crawley in the matter. Mr. Crawley would certainly be on her side as far as opinion went, and would have no fear as to expressing his opinion to his brother clergyman. So she sent for Mr. Crawley.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("In appearance he was the very opposite to Mark Robarts. He was a lean, slim, meagre man, with shoulders slightly curved, and pale, lank, long locks of ragged hair; his forehead was high, but his face was narrow; his small grey eyes were deeply sunken in his head, his nose was well-formed, his lips thin, and his mouth expressive. Nobody could look at him without seeing that there was a purpose and a meaning in his countenance. He always wore, in summer and winter, a long dusky grey coat, which buttoned close up to his neck and descended almost to his heels. He was full six feet high, but being so slight in build, he looked as though he were taller.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("He came at once at Lady Lufton’s bidding, putting himself into the gig beside the servant, to whom he spoke no single word during the journey. And the man, looking into his face, was struck with taciturnity. Now Mark Robarts would have talked with him the whole way from Hogglestock to Framley Court; discoursing partly as to horses and land, but partly also as to higher things.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("And then Lady Lufton opened her mind and told her griefs to Mr. Crawley, urging, however, through the whole length of her narrative, that Mr. Robarts was an excellent parish clergyman,—“just such a clergyman in his church as I would wish him to be,” she explained, with the view of saving herself from an expression of any of Mr. Crawley’s special ideas as to church teaching, and of confining him to the one subject-matter in hand; “but he got this living so young, Mr. Crawley, that he is hardly quite as steady as I could wish him to be. It has been as much my fault as his own in placing him in such a position so early in life.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“I think it has,” said Mr. Crawley, who might perhaps be a little sore on such a subject.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Quite so, quite so,” continued her ladyship, swallowing down with a gulp a certain sense of anger. “But that is done now, and is past cure. That Mr. Robarts will become a credit to his profession, I do not doubt, for his heart is in the right place and his sentiments are good; but I fear that at present he is succumbing to temptation.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“I am told that he hunts two or three times a week. Everybody round us is talking about it.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“No, Mr. Crawley; not two or three times a week; very seldom above once, I think. And then I do believe he does it more with the view of being with Lord Lufton than anything else.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“I cannot see that that would make the matter better,” said Mr. Crawley.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“It would show that he was not strongly imbued with a taste which I cannot but regard as vicious in a clergyman.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“It must be vicious in all men,” said Mr. Crawley. “It is in itself cruel, and leads to idleness and profligacy.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("Again Lady Lufton made a gulp. She had called Mr. Crawley thither to her aid, and felt that it would be inexpedient to quarrel with him. But she did not like to be told that her son’s amusement was idle and profligate. She had always regarded hunting as a proper pursuit for a country gentleman. It was, indeed, in her eyes one of the peculiar institutions of country life in England, and it may be almost said that she looked upon the Barsetshire hunt as something sacred. She could not endure to hear that a fox was trapped, and allowed her turkeys to be purloined without a groan. Such being the case, she did not like being told that it was vicious, and had by no means wished to consult Mr. Crawley on that matter. But nevertheless, she swallowed down her wrath.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“It is at any rate unbecoming in a clergyman,” she said; “and as I know that Mr. Robarts places a high value on your opinion, perhaps you will not object to advise him to discontinue it. He might possibly feel aggrieved were I to interfere personally on such a question.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“I have no doubt he would,” said Mr. Crawley. “It is not within a woman’s province to give counsel to a clergyman on such a subject, unless she be very near and very dear to him—his wife, or mother, or sister.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“As living in the same parish, you know, and being, perhaps—” the leading person in it, and the one who naturally rules the others. Those would have been the fitting words for the expression of her ladyship’s ideas; but she remembered herself, and did not use them. She had made up her mind that, great as her influence ought to be, she was not the proper person to speak to Mr. Robarts as to his pernicious, unclerical habits, and she would not now depart from her resolve by attempting to prove that she was the proper person.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Yes,” said Mr. Crawley, “just so. All that would entitle him to offer you his counsel if he thought that your mode of life was such as to require it, but could by no means justify you in addressing yourself to him.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("This was very hard upon Lady Lufton. She was endeavouring with all her woman’s strength to do her best, and endeavouring so to do it that the feelings of the sinner might be spared; and yet the ghostly comforter whom she had evoked to her aid, treated her as though she were arrogant and overbearing. She acknowledged the weakness of her own position with reference to her parish clergyman by calling in the aid of Mr. Crawley; and under such circumstances, he might, at any rate, have abstained from throwing that weakness in her teeth.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Well, sir; I hope my mode of life may not require it; but that is not exactly to the point. What I wish to know is, whether you will speak to Mr. Robarts?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Certainly I will,” said he.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Then I shall be much obliged to you. But, Mr. Crawley, pray—pray, remember this: I would not on any account wish that you should be harsh with him. He is an excellent young man, and—”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Lady Lufton, if I do this, I can only do it in my own way, as best I may, using such words as God may give me at the time. I hope that I am harsh to no man; but it is worse than useless, in all cases, to speak anything but the truth.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Of course—of course.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“If the ears be too delicate to hear the truth, the mind will be too perverse to profit by it.” And then Mr. Crawley got up to take his leave.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("But Lady Lufton insisted that he should go with her to luncheon. He hummed and ha’d and would fain have refused, but on this subject she was peremptory. It might be that she was unfit to advise a clergyman as to his duties, but in a matter of hospitality she did know what she was about. Mr. Crawley should not leave the house without refreshment. As to this, she carried her point; and Mr. Crawley—when the matter before him was cold roast-beef and hot potatoes, instead of the relative position of a parish priest and his parishioner—became humble, submissive, and almost timid. Lady Lufton recommended Madeira instead of sherry, and Mr. Crawley obeyed at once, and was, indeed, perfectly unconscious of the difference. Then there was a basket of seakale in the gig for Mrs. Crawley; that he would have left behind had he dared, but he did not dare. Not a word was said to him as to the marmalade for the children which was hidden under the seakale, Lady Lufton feeling well aware that that would find its way to its proper destination without any necessity for his co-operation. And then Mr. Crawley returned home in the Framley Court gig.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("Three or four days after this he walked over to Framley Parsonage. This he did on a Saturday, having learned that the hounds never hunted on that day; and he started early, so that he might be sure to catch Mr. Robarts before he went out on his parish business. He was quite early enough to attain this object, for when he reached the parsonage door at about half-past nine, the vicar, with his wife and sister, were just sitting down to breakfast.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Oh, Crawley,” said Robarts, before the other had well spoken, “you are a capital fellow;” and then he got him into a chair, and Mrs. Robarts had poured him out tea, and Lucy had surrendered to him a knife and plate, before he knew under what guise to excuse his coming among them.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“I hope you will excuse this intrusion,” at last he muttered; “but I have a few words of business to which I will request your attention presently.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Certainly,” said Robarts, conveying a broiled kidney on to the plate before Mr. Crawley; “but there is no preparation for business like a good breakfast. Lucy, hand Mr. Crawley the buttered toast. Eggs, Fanny; where are the eggs?” And then John, in livery, brought in the fresh eggs. “Now we shall do. I always eat my eggs while they’re hot, Crawley, and I advise you to do the same.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("To all this Mr. Crawley said very little, and he was not at all at home under the circumstances. Perhaps a thought did pass across his brain, as to the difference between the meal which he had left on his own table, and that which he now saw before him; and as to any cause which might exist for such difference. But, if so, it was a very fleeting thought, for he had far other matter now fully occupying his mind. And then the breakfast was over, and in a few minutes the two clergymen found themselves together in the parsonage study.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Mr. Robarts,” began the senior, when he had seated himself uncomfortably on one of the ordinary chairs at the farther side of the well-stored library table, while Mark was sitting at his ease in his own arm-chair by the fire, “I have called upon you on an unpleasant business.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("Mark’s mind immediately flew off to Mr. Sowerby’s bill, but he could not think it possible that Mr. Crawley could have had anything to do with that.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“But as a brother clergyman, and as one who esteems you much and wishes you well, I have thought myself bound to take this matter in hand.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“What matter is it, Crawley?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Mr. Robarts, men say that your present mode of life is one that is not befitting a soldier in Christ’s army.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Men say so! What men?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“The men around you, of your own neighbourhood; those who watch your life, and know all your doings; those who look to see you walking as a lamp to guide their feet, but find you consorting with horse-jockeys and hunters, galloping after hounds, and taking your place among the vainest of worldly pleasure-seekers. Those who have a right to expect an example of good living, and who think that they do not see it.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("Mr. Crawley had gone at once to the root of the matter, and in doing so had certainly made his own task so much the easier. There is nothing like going to the root of the matter at once when one has on hand an unpleasant piece of business.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“And have such men deputed you to come here?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“No one has or could depute me. I have come to speak my own mind, not that of any other. But I refer to what those around you think and say, because it is to them that your duties are due. You owe it to those around you to live a godly, cleanly life;—as you owe it also, in a much higher way, to your Father who is in heaven. I now make bold to ask you whether you are doing your best to lead such a life as that?” And then he remained silent, waiting for an answer.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("He was a singular man; so humble and meek, so unutterably inefficient and awkward in the ordinary intercourse of life, but so bold and enterprising, almost eloquent, on the one subject which was the work of his mind! As he sat there, he looked into his companion’s face from out his sunken grey eyes with a gaze which made his victim quail. And then repeated his words: “I now make bold to ask you, Mr. Robarts, whether you are doing your best to lead such a life as may become a parish clergyman among his parishioners?” And again he paused for an answer.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“There are but few of us,” said Mark in a low tone, “who could safely answer that question in the affirmative.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“But are there many, think you, among us who would find the question so unanswerable as yourself? And even were there many, would you, young, enterprising, and talented as you are, be content to be numbered among them? Are you satisfied to be a castaway after you have taken upon yourself Christ’s armour? If you will say so, I am mistaken in you, and will go my way.” There was again a pause, and then he went on. “Speak to me, my brother, and open your heart if it be possible.” And rising from his chair, he walked across the room, and laid his hand tenderly on Mark’s shoulder.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("Mark had been sitting lounging in his chair, and had at first, for a moment only, thought to brazen it out. But all idea of brazening had now left him. He had raised himself from his comfortable ease, and was leaning forward with his elbow on the table; but now, when he heard these words, he allowed his head to sink upon his arms, and he buried his face between his hands.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“It is a terrible falling off,” continued Crawley; “terrible in the fall, but doubly terrible through that difficulty of returning. But it cannot be that it should content you to place yourself as one among those thoughtless sinners, for the crushing of whose sin you have been placed here among them. You become a hunting parson, and ride with a happy mind among blasphemers and mocking devils—you, whose aspirations were so high, who have spoken so often and so well of the duties of a minister of Christ; you, who can argue in your pride as to the petty details of your Church, as though the broad teachings of its great and simple lessons were not enough for your energies! It cannot be that I have had a hypocrite beside me in all those eager controversies!”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Not a hypocrite—not a hypocrite,” said Mark, in a tone which was almost reduced to sobbing.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“But a castaway! Is it so that I must call you? No, Mr. Robarts, not a castaway; neither a hypocrite, nor a castaway; but one who in walking has stumbled in the dark and bruised his feet among the stones. Henceforth let him take a lantern in his hand, and look warily to his path, and walk cautiously among the thorns and rocks,—cautiously, but yet boldly, with manly courage, but Christian meekness, as all men should walk on their pilgrimage through this vale of tears.” And then without giving his companion time to stop him he hurried out of the room, and from the house, and without again seeing any others of the family, stalked back on his road to Hogglestock, thus tramping fourteen miles through the deep mud in performance of the mission on which he had been sent.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("It was some hours before Mr. Robarts left his room. As soon as he found that Crawley was really gone, and that he should see him no more, he turned the lock of his door, and sat himself down to think over his present life. At about eleven his wife knocked, not knowing whether that other strange clergyman were there or no, for none had seen his departure. But Mark, answering cheerily, desired that he might be left to his studies.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("Let us hope that his thoughts and mental resolves were then of service to him.")])])])])
}]}

/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(119),
  /* template */
  __webpack_require__(120),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 120 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('p', {
    staticClass: "ORIM-Chapter-Title-Page-Break"
  }, [_vm._v("CHAPTER XVI")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Chapter-Subtitle"
  }, [_vm._v("Mrs. Podgens’s Baby")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Chapter-Opener-Paragraph"
  }, [_vm._v("The hunting season had now nearly passed away, and the great ones of the Barsetshire world were thinking of the glories of London. Of these glories Lady Lufton always thought with much inquietude of mind. She would fain have remained throughout the whole year at Framley Court, did not certain grave considerations render such a course on her part improper in her own estimation. All the Lady Luftons of whom she had heard, dowager and ante-dowager, had always had their seasons in London, till old age had incapacitated them for such doings—sometimes for clearly long after the arrival of such period. And then she had an idea, perhaps not altogether erroneous, that she annually imported back with her into the country somewhat of the passing civilization of the times. May we not say an idea that certainly was not erroneous? for how otherwise is it that the forms of new caps and remodelled shapes for women’s waists find their way down into agricultural parts, and that the rural eye learns to appreciate grace and beauty? There are those who think that remodelled waists and new caps had better be kept to the towns; but such people, if they would follow out their own argument, would wish to see ploughboys painted with ruddle and milkmaids covered with skins.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("For these and other reasons Lady Lufton always went to London in April, and stayed there till the beginning of June. But for her this was usually a period of penance. In London she was no very great personage. She had never laid herself out for greatness of that sort, and did not shine as a lady-patroness or state secretary in the female cabinet of fashion. She was dull and listless, and without congenial pursuits in London, and spent her happiest moments in reading accounts of what was being done at Framley, and in writing orders for further local information of the same kind.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("But on this occasion there was a matter of vital import to give an interest of its own to her visit to town. She was to entertain Griselda Grantly, and as far as might be possible to induce her son to remain in Griselda’s society. The plan of the campaign was to be as follows:—Mrs. Grantly and the archdeacon were in the first place to go up to London for a month, taking Griselda with them; and then, when they returned to Plumstead, Griselda was to go to Lady Lufton. This arrangement was not at all points agreeable to Lady Lufton, for she knew that Mrs. Grantly did not turn her back on the Hartletop people quite as cordially as she should do, considering the terms of the Lufton-Grantly family treaty. But then Mrs. Grantly might have alleged in excuse the slow manner in which Lord Lufton proceeded in the making and declaring of his love, and the absolute necessity which there is for two strings to one’s bow, when one string may be in any way doubtful. Could it be possible that Mrs. Grantly had heard anything of that unfortunate Platonic friendship with Lucy Robarts?")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("There came a letter from Mrs. Grantly just about the end of March, which added much to Lady Lufton’s uneasiness, and made her more than ever anxious to be herself on the scene of action and to have Griselda in her own hands. After some communications of mere ordinary importance with reference to the London world in general and the Lufton-Grantly world in particular, Mrs. Grantly wrote confidentially about her daughter:")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“It would be useless to deny,” she said, with a mother’s pride and a mother’s humility, “that she is very much admired. She is asked out a great deal more than I can take her, and to houses to which I myself by no means wish to go. I could not refuse her as to Lady Hartletop’s first ball, for there will be nothing else this year like them; and of course when with you, dear Lady Lufton, that house will be out of the question. So indeed would it be with me, were I myself only concerned. The duke was there, of course, and I really wonder Lady Hartletop should not be more discreet in her own drawing-room when all the world is there. It is clear to me that Lord Dumbello admires Griselda much more than I could wish. She, dear girl, has such excellent sense that I do not think it likely that her head should be turned by it; but with how many girls would not the admiration of such a man be irresistible? The marquis, you know, is very feeble, and I am told that since this rage for building has come on, the Lancashire property is over two hundred thousand a year!! I do not think that Lord Dumbello has said much to her. Indeed it seems to me that he never does say much to any one. But he always stands up to dance with her, and I see that he is uneasy and fidgety when she stands up with any other partner whom he could care about. It was really embarrassing to see him the other night at Miss Dunstable’s, when Griselda was dancing with a certain friend of ours. But she did look very well that evening, and I have seldom seen her more animated!”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("All this, and a great deal more of the same sort in the same letter, tended to make Lady Lufton anxious to be in London. It was quite certain—there was no doubt of that, at any rate—that Griselda would see no more of Lady Hartletop’s meretricious grandeur when she had been transferred to Lady Lufton’s guardianship. And she, Lady Lufton, did wonder that Mrs. Grantly should have taken her daughter to such a house. All about Lady Hartletop was known to all the world. It was known that it was almost the only house in London at which the Duke of Omnium was constantly to be met. Lady Lufton herself would almost as soon think of taking a young girl to Gatherum Castle; and on these accounts she did feel rather angry with her friend Mrs. Grantly. But then perhaps she did not sufficiently calculate that Mrs. Grantly’s letter had been written purposely to produce such feelings—with the express view of awakening her ladyship to the necessity of action. Indeed in such a matter as this Mrs. Grantly was a more able woman than Lady Lufton—more able to see her way and to follow it out. The Lufton-Grantly alliance was in her mind the best, seeing that she did not regard money as everything. But failing that, the Hartletop-Grantly alliance was not bad. Regarding it as a second string to her bow, she thought that it was not at all bad.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("Lady Lufton’s reply was very affectionate. She declared how happy she was to know that Griselda was enjoying herself; she insinuated that Lord Dumbello was known to the world as a fool, and his mother as—being not a bit better than she ought to be; and then she added that circumstances would bring herself up to town four days sooner than she had expected, and that she hoped her dear Griselda would come to her at once. Lord Lufton, she said, though he would not sleep in Bruton Street—Lady Lufton lived in Bruton Street—had promised to pass there as much of his time as his parliamentary duties would permit.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("O Lady Lufton! Lady Lufton! did it not occur to you, when you wrote those last words, intending that they should have so strong an effect on the mind of your correspondent, that you were telling a—tarradiddle? Was it not the case that you had said to your son, in your own dear, kind, motherly way: “Ludovic, we shall see something of you in Bruton Street this year, shall we not? Griselda Grantly will be with me, and we must not let her be dull—must we?” And then had he not answered, “Oh, of course, mother,” and sauntered out of the room, not altogether graciously? Had he, or you, said a word about his parliamentary duties? Not a word! O Lady Lufton! have you not now written a tarradiddle to your friend?")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("In these days we are becoming very strict about truth with our children; terribly strict occasionally, when we consider the natural weakness of the moral courage at the ages of ten, twelve, and fourteen. But I do not know that we are at all increasing the measure of strictness with which we, grown-up people, regulate our own truth and falsehood. Heaven forbid that I should be thought to advocate falsehood in children; but an untruth is more pardonable in them than in their parents. Lady Lufton’s tarradiddle was of a nature that is usually considered excusable—at least with grown people; but, nevertheless, she would have been nearer to perfection could she have confined herself to the truth. Let us suppose that a boy were to write home from school, saying that another boy had promised to come and stay with him, that other having given no such promise—what a very naughty boy would that first boy be in the eyes of his pastors and masters!")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("That little conversation between Lord Lufton and his mother—in which nothing was said about his lordship’s parliamentary duties—took place on the evening before he started for London. On that occasion he certainly was not in his best humour, nor did he behave to his mother in his kindest manner. He had then left the room when she began to talk about Miss Grantly; and once again in the course of the evening, when his mother, not very judiciously, said a word or two about Griselda’s beauty, he had remarked that she was no conjuror, and would hardly set the Thames on fire.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“If she were a conjuror!” said Lady Lufton, rather piqued, “I should not now be going to take her out in London. I know many of those sort of girls whom you call conjurors; they can talk for ever, and always talk either loudly or in a whisper. I don’t like them, and I am sure that you do not in your heart.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Oh, as to liking them in my heart—that is being very particular.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Griselda Grantly is a lady, and as such I shall be happy to have her with me in town. She is just the girl that Justinia will like to have with her.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Exactly,” said Lord Lufton. “She will do exceedingly well for Justinia.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("Now this was not good-natured on the part of Lord Lufton; and his mother felt it the more strongly, inasmuch as it seemed to signify that he was setting his back up against the Lufton-Grantly alliance. She had been pretty sure that he would do so in the event of his suspecting that a plot was being laid to catch him; and now it almost appeared that he did suspect such a plot. Why else that sarcasm as to Griselda doing very well for his sister?")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("And now we must go back and describe a little scene at Framley which will account for his lordship’s ill-humour and suspicions, and explain how it came to pass that he so snubbed his mother. This scene took place about ten days after the evening on which Mrs. Robarts and Lucy were walking together in the parsonage garden, and during those ten days Lucy had not once allowed herself to be entrapped into any special conversation with the young peer. She had dined at Framley Court during that interval, and had spent a second evening there; Lord Lufton had also been up at the parsonage on three or four occasions, and had looked for her in her usual walks; but, nevertheless, they had never come together in their old familiar way, since the day on which Lady Lufton had hinted her fears to Mrs. Robarts.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("Lord Lufton had very much missed her. At first he had not attributed this change to a purposed scheme of action on the part of any one; nor, indeed, had he much thought about it, although he had felt himself to be annoyed. But as the period fixed for his departure grew near, it did occur to him as very odd that he should never hear Lucy’s voice unless when she said a few words to his mother, or to her sister-in-law. And then he made up his mind that he would speak to her before he went, and that the mystery should be explained to him.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("And he carried out his purpose, calling at the parsonage on one special afternoon; and it was on the evening of the same day that his mother sang the praises of Griselda Grantly so inopportunely. Robarts, he knew, was then absent from home, and Mrs. Robarts was with his mother down at the house, preparing lists of the poor people to be specially attended to in Lady Lufton’s approaching absence. Taking advantage of this, he walked boldly in through the parsonage garden; asked the gardener, with an indifferent voice, whether either of the ladies were at home, and then caught poor Lucy exactly on the doorstep of the house.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Were you going in or out, Miss Robarts?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Well, I was going out,” said Lucy; and she began to consider how best she might get quit of any prolonged encounter.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Oh, going out, were you? I don’t know whether I may offer to—”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Well, Lord Lufton, not exactly, seeing that I am about to pay a visit to our near neighbour, Mrs. Podgens. Perhaps you have no particular call towards Mrs. Podgens’s just at present, or to her new baby?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“And have you any very particular call that way?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Yes, and especially to Baby Podgens. Baby Podgens is a real little duck—only just two days old.” And Lucy, as she spoke, progressed a step or two, as though she were determined not to remain there talking on the doorstep.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("A slight cloud came across his brow as he saw this, and made him resolve that she should not gain her purpose. He was not going to be foiled in that way by such a girl as Lucy Robarts. He had come there to speak to her, and speak to her he would. There had been enough of intimacy between them to justify him in demanding, at any rate, as much as that.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Miss Robarts,” he said, “I am starting for London to-morrow, and if I do not say good-bye to you now, I shall not be able to do so at all.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Good-bye, Lord Lufton,” she said, giving him her hand, and smiling on him with her old genial, good-humoured, racy smile. “And mind you bring into Parliament that law which you promised me for defending my young chickens.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("He took her hand, but that was not all that he wanted. “Surely Mrs. Podgens and her baby can wait ten minutes. I shall not see you again for months to come, and yet you seem to begrudge me two words.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Not two hundred if they can be of any service to you,” said she, walking cheerily back into the drawing-room; “only I did not think it worth while to waste your time, as Fanny is not here.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("She was infinitely more collected, more master of herself than he was. Inwardly, she did tremble at the idea of what was coming, but outwardly she showed no agitation—none as yet; if only she could so possess herself as to refrain from doing so, when she heard what he might have to say to her.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("He hardly knew what it was for the saying of which he had so resolutely come thither. He had by no means made up his mind that he loved Lucy Robarts; nor had he made up his mind that, loving her, he would, or that, loving her, he would not, make her his wife. He had never used his mind in the matter in any way, either for good or evil. He had learned to like her and to think that she was very pretty. He had found out that it was very pleasant to talk to her; whereas, talking to Griselda Grantly, and, indeed, to some other young ladies of his acquaintance, was often hard work. The half-hours which he had spent with Lucy had always been satisfactory to him. He had found himself to be more bright with her than with other people, and more apt to discuss subjects worth discussing; and thus it had come about that he thoroughly liked Lucy Robarts. As to whether his affection was Platonic or anti-Platonic he had never asked himself; but he had spoken words to her, shortly before that sudden cessation of their intimacy, which might have been taken as anti-Platonic by any girl so disposed to regard them. He had not thrown himself at her feet, and declared himself to be devoured by a consuming passion; but he had touched her hand as lovers touch those of women whom they love; he had had his confidences with her, talking to her of his own mother, of his sister, and of his friends; and he had called her his own dear friend Lucy.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("All this had been very sweet to her, but very poisonous also. She had declared to herself very frequently that her liking for this young nobleman was as purely a feeling of mere friendship as was that of her brother; and she had professed to herself that she would give the lie to the world’s cold sarcasms on such subjects. But she had now acknowledged that the sarcasms of the world on that matter, cold though they may be, are not the less true; and having so acknowledged, she had resolved that all close alliance between herself and Lord Lufton must be at an end. She had come to a conclusion, but he had come to none; and in this frame of mind he was now there with the object of reopening that dangerous friendship which she had had the sense to close.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“And so you are going to-morrow?” she said, as soon as they were both within the drawing-room.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Yes; I’m off by the early train to-morrow morning, and Heaven knows when we may meet again.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Next winter, shall we not?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Yes, for a day or two, I suppose. I do not know whether I shall pass another winter here. Indeed, one can never say where one will be.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“No, one can’t; such as you, at least, cannot. I am not of a migratory tribe myself.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“I wish you were.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“I’m not a bit obliged to you. Your nomade life does not agree with young ladies.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“I think they are taking to it pretty freely, then. We have unprotected young women all about the world.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“And great bores you find them, I suppose?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“No; I like it. The more we can get out of old-fashioned grooves the better I am pleased. I should be a radical to-morrow—a regular man of the people,—only I should break my mother’s heart.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Whatever you do, Lord Lufton, do not do that.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“That is why I have liked you so much,” he continued, “because you get out of the grooves.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Do I?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Yes; and go along by yourself, guiding your own footsteps; not carried hither and thither, just as your grandmother’s old tramway may chance to take you.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Do you know I have a strong idea that my grandmother’s old tramway will be the safest and the best after all? I have not left it very far, and I certainly mean to go back to it.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“That’s impossible! An army of old women, with coils of ropes made out of time-honoured prejudices, could not drag you back.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“No, Lord Lufton, that is true. But one—” and then she stopped herself. She could not tell him that one loving mother, anxious for her only son, had sufficed to do it. She could not explain to him that this departure from the established tramway had already broken her own rest, and turned her peaceful happy life into a grievous battle.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“I know that you are trying to go back,” he said. “Do you think that I have eyes and cannot see? Come, Lucy, you and I have been friends, and we must not part in this way. My mother is a paragon among women. I say it in earnest;—a paragon among women; and her love for me is the perfection of motherly love.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“It is, it is; and I am so glad that you acknowledge it.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“I should be worse than a brute did I not do so; but, nevertheless, I cannot allow her to lead me in all things. Were I to do so, I should cease to be a man.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Where can you find any one who will counsel you so truly?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“But, nevertheless, I must rule myself. I do not know whether my suspicions may be perfectly just, but I fancy that she has created this estrangement between you and me. Has it not been so?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Certainly not by speaking to me,” said Lucy, blushing ruby-red through every vein of her deep-tinted face. But though she could not command her blood, her voice was still under her control—her voice and her manner.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“But has she not done so? You, I know, will tell me nothing but the truth.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“I will tell you nothing on this matter, Lord Lufton, whether true or false. It is a subject on which it does not concern me to speak.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Ah! I understand,” he said; and rising from his chair, he stood against the chimney-piece with his back to the fire. “She cannot leave me alone to choose for myself my own friends, and my own——” but he did not fill up the void.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“But why tell me this, Lord Lufton?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“No! I am not to choose my own friends, though they be among the best and purest of God’s creatures. Lucy, I cannot think that you have ceased to have a regard for me. That you had a regard for me, I am sure.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("She felt that it was almost unmanly of him thus to seek her out, and hunt her down, and then throw upon her the whole weight of the explanation that his coming thither made necessary. But, nevertheless, the truth must be told, and with God’s help she would find strength for the telling of it.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Yes, Lord Lufton, I had a regard for you—and have. By that word you mean something more than the customary feeling of acquaintance which may ordinarily prevail between a gentleman and lady of different families, who have known each other so short a time as we have done.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Yes, something much more,” said he, with energy.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Well, I will not define the much—something closer than that.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Yes, and warmer, and dearer, and more worthy of two human creatures who value each other’s minds and hearts.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Some such closer regard I have felt for you—very foolishly. Stop! You have made me speak, and do not interrupt me now. Does not your conscience tell you that in doing so I have unwisely deserted those wise old grandmother’s tramways of which you spoke just now? It has been pleasant to me to do so. I have liked the feeling of independence with which I have thought that I might indulge in an open friendship with such as you are. And your rank, so different from my own, has doubtless made this more attractive.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Nonsense!”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Ah! but it has. I know it now. But what will the world say of me as to such an alliance?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“The world!”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Yes, the world! I am not such a philosopher as to disregard it, though you may afford to do so. The world will say that I, the parson’s sister, set my cap at the young lord, and that the young lord had made a fool of me.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“The world shall say no such thing!” said Lord Lufton, very imperiously.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Ah! but it will. You can no more stop it, than King Canute could the waters. Your mother has interfered wisely to spare me from this; and the only favour that I can ask you is that you will spare me also.” And then she got up as though she intended at once to walk forth to her visit to Mrs. Podgens’s baby.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Stop, Lucy!” he said, putting himself between her and the door.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“It must not be Lucy any longer, Lord Lufton; I was madly foolish when I first allowed it.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“By heavens! but it shall be Lucy—Lucy before all the world. My Lucy, my own Lucy—my heart’s best friend, and chosen love. Lucy, there is my hand. How long you may have had my heart, it matters not to say now.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("The game was at her feet now, and no doubt she felt her triumph. Her ready wit and speaking lip, not her beauty, had brought him to her side; and now he was forced to acknowledge that her power over him had been supreme. Sooner than leave her he would risk all. She did feel her triumph; but there was nothing in her face to tell him that she did so.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("As to what she would now do she did not for a moment doubt. He had been precipitated into the declaration he had made, not by his love, but by his embarrassment. She had thrown in his teeth the injury which he had done her, and he had then been moved by his generosity to repair that injury by the noblest sacrifice which he could make. But Lucy Robarts was not the girl to accept a sacrifice.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("He had stepped forward as though he were going to clasp her round the waist, but she receded, and got beyond the reach of his hand. “Lord Lufton!” she said, “when you are more cool you will know that this is wrong. The best thing for both of us now is to part.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Not the best thing, but the very worst, till we perfectly understand each other.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Then perfectly understand me, that I cannot be your wife.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Lucy! do you mean that you cannot learn to love me?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“I mean that I shall not try. Do not persevere in this, or you will have to hate yourself for your own folly.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“But I will persevere till you accept my love, or say with your hand on your heart that you cannot and will not love me.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Then I must beg you to let me go,” and having so said, she paused while he walked once or twice hurriedly up and down the room. “And, Lord Lufton,” she continued, “if you will leave me now, the words that you have spoken shall be as though they had never been uttered.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“I care not who knows that they have been uttered. The sooner that they are known to all the world, the better I shall be pleased, unless indeed—”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Think of your mother, Lord Lufton.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“What can I do better than give her as a daughter the best and sweetest girl I have ever met? When my mother really knows you, she will love you as I do. Lucy, say one word to me of comfort.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“I will say no word to you that shall injure your future comfort. It is impossible that I should be your wife.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Do you mean that you cannot love me?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“You have no right to press me any further,” she said; and sat down upon the sofa, with an angry frown upon her forehead.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“By heavens,” he said, “I will take no such answer from you till you put your hand upon your heart, and say that you cannot love me.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Oh, why should you press me so, Lord Lufton?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Why! because my happiness depends upon it; because it behoves me to know the very truth. It has come to this, that I love you with my whole heart, and I must know how your heart stands towards me.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("She had now again risen from the sofa, and was looking steadily in his face.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Lord Lufton,” she said, “I cannot love you,” and as she spoke she did put her hand, as he had desired, upon her heart.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Then God help me! for I am very wretched. Good-bye, Lucy,” and he stretched out his hand to her.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Good-bye, my lord. Do not be angry with me.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“No, no, no!” and without further speech he left the room and the house, and hurried home. It was hardly surprising that he should that evening tell his mother that Griselda Grantly would be a companion sufficiently good for his sister. He wanted no such companion.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("And when he was well gone—absolutely out of sight from the window—Lucy walked steadily up to her room, locked the door, and then threw herself on the bed. Why—oh! why had she told such a falsehood? Could anything justify her in a lie? Was it not a lie—knowing as she did that she loved him with all her loving heart?")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("But, then, his mother! and the sneers of the world, which would have declared that she had set her trap, and caught the foolish young lord! Her pride would not have submitted to that. Strong as her love was, yet her pride was, perhaps, stronger—stronger at any rate during that interview.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("But how was she to forgive herself the falsehood she had told?")])])])])
}]}

/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(122),
  /* template */
  __webpack_require__(123),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 123 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('p', {
    staticClass: "ORIM-Chapter-Title-Page-Break"
  }, [_vm._v("CHAPTER XVII")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Chapter-Subtitle"
  }, [_vm._v("Mrs. Proudie’s Conversazione")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Chapter-Opener-Paragraph"
  }, [_vm._v("It was grievous to think of the mischief and danger into which Griselda Grantly was brought by the worldliness of her mother in those few weeks previous to Lady Lufton’s arrival in town—very grievous, at least, to her ladyship, as from time to time she heard of what was done in London. Lady Hartletop’s was not the only objectionable house at which Griselda was allowed to reap fresh fashionable laurels. It had been stated openly in the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Morning Post")]), _vm._v(" that that young lady had been the most admired among the beautiful at one of Miss Dunstable’s celebrated "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("soirées")]), _vm._v(", and then she was heard of as gracing the drawing-room at Mrs. Proudie’s conversazione.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("Of Miss Dunstable herself Lady Lufton was not able openly to allege any evil. She was acquainted, Lady Lufton knew, with very many people of the right sort, and was the dear friend of Lady Lufton’s highly conservative and not very distant neighbours, the Greshams. But then she was also acquainted with so many people of the bad sort. Indeed, she was intimate with everybody, from the Duke of Omnium to old Dowager Lady Goodygaffer, who had represented all the cardinal virtues for the last quarter of a century. She smiled with equal sweetness on treacle and on brimstone; was quite at home at Exeter Hall, having been consulted—so the world said, probably not with exact truth—as to the selection of more than one disagreeably Low Church bishop; and was not less frequent in her attendance at the ecclesiastical doings of a certain terrible prelate in the Midland counties, who was supposed to favour stoles and vespers, and to have no proper Protestant hatred for auricular confession and fish on Fridays. Lady Lufton, who was very staunch, did not like this, and would say of Miss Dunstable that it was impossible to serve both God and Mammon.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("But Mrs. Proudie was much more objectionable to her. Seeing how sharp was the feud between the Proudies and the Grantlys down in Barsetshire, how absolutely unable they had always been to carry a decent face towards each other in church matters, how they headed two parties in the diocese, which were, when brought together, as oil and vinegar, in which battles the whole Lufton influence had always been brought to bear on the Grantly side;—seeing all this, I say, Lady Lufton was surprised to hear that Griselda had been taken to Mrs. Proudie’s evening exhibition. “Had the archdeacon been consulted about it,” she said to herself, “this would never have happened.” But there she was wrong, for in matters concerning his daughter’s introduction to the world the archdeacon never interfered.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("On the whole, I am inclined to think that Mrs. Grantly understood the world better than did Lady Lufton. In her heart of hearts Mrs. Grantly hated Mrs. Proudie—that is, with that sort of hatred one Christian lady allows herself to feel towards another. Of course Mrs. Grantly forgave Mrs. Proudie all her offences, and wished her well, and was at peace with her, in the Christian sense of the word, as with all other women. But under this forbearance and meekness, and perhaps, we may say, wholly unconnected with it, there was certainly a current of antagonistic feeling which, in the ordinary unconsidered language of every day, men and women do call hatred. This raged and was strong throughout the whole year in Barsetshire, before the eyes of all mankind. But, nevertheless, Mrs. Grantly took Griselda to Mrs. Proudie’s evening parties in London.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("In these days Mrs. Proudie considered herself to be by no means the least among bishops’ wives. She had opened the season this year in a new house in Gloucester Place, at which the reception rooms, at any rate, were all that a lady bishop could desire. Here she had a front drawing-room of very noble dimensions, a second drawing-room rather noble also, though it had lost one of its back corners awkwardly enough, apparently in a jostle with the neighbouring house; and then there was a third—shall we say drawing-room, or closet?—in which Mrs. Proudie delighted to be seen sitting, in order that the world might know that there was a third room; altogether a noble suite, as Mrs. Proudie herself said in confidence to more than one clergyman’s wife from Barsetshire. “A noble suite, indeed, Mrs. Proudie!” the clergymen’s wives from Barsetshire would usually answer.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("For some time Mrs. Proudie was much at a loss to know by what sort of party or entertainment she would make herself famous. Balls and suppers were of course out of the question. She did not object to her daughters dancing all night at other houses—at least, of late she had not objected, for the fashionable world required it, and the young ladies had perhaps a will of their own—but dancing at her house—absolutely under the shade of the bishop’s apron—would be a sin and a scandal. And then as to suppers—of all modes in which one may extend one’s hospitality to a large acquaintance, they are the most costly.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“It is horrid to think that we should go out among our friends for the mere sake of eating and drinking,” Mrs. Proudie would say to the clergymen’s wives from Barsetshire. “It shows such a sensual propensity.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Indeed it does, Mrs. Proudie; and is so vulgar too!” those ladies would reply.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("But the elder among them would remember with regret the unsparing, open-handed hospitality of Barchester Palace in the good old days of Bishop Grantly—God rest his soul! One old vicar’s wife there was whose answer had not been so courteous—")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“When we are hungry, Mrs. Proudie,” she had said, “we do all have sensual propensities.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“It would be much better, Mrs. Athill, if the world would provide for all that at home,” Mrs. Proudie had rapidly replied; with which opinion I must here profess that I cannot by any means bring myself to coincide.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("But a conversazione would give play to no sensual propensity, nor occasion that intolerable expense which the gratification of sensual propensities too often produces. Mrs. Proudie felt that the word was not all that she could have desired. It was a little faded by old use and present oblivion, and seemed to address itself to that portion of the London world that is considered blue, rather than fashionable. But, nevertheless, there was a spirituality about it which suited her, and one may also say an economy. And then as regarded fashion, it might perhaps not be beyond the power of a Mrs. Proudie to regild the word with a newly burnished gilding. Some leading person must produce fashion at first hand, and why not Mrs. Proudie?")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("Her plan was to set the people by the ears talking, if talk they would, or to induce them to show themselves there inert if no more could be got from them. To accommodate with chairs and sofas as many as the furniture of her noble suite of rooms would allow, especially with the two chairs and padded bench against the wall in the back closet—the small inner drawing-room, as she would call it to the clergymen’s wives from Barsetshire—and to let the others stand about upright, or “group themselves,” as she described it. Then four times during the two hours’ period of her conversazione tea and cake were to be handed round on salvers. It is astonishing how far a very little cake will go in this way, particularly if administered tolerably early after dinner. The men can’t eat it, and the women, having no plates and no table, are obliged to abstain. Mrs. Jones knows that she cannot hold a piece of crumbly cake in her hand till it be consumed without doing serious injury to her best dress. When Mrs. Proudie, with her weekly books before her, looked into the financial upshot of her conversazione, her conscience told her that she had done the right thing.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("Going out to tea is not a bad thing, if one can contrive to dine early, and then be allowed to sit round a big table with a tea urn in the middle. I would, however, suggest that breakfast cups should always be provided for the gentlemen. And then with pleasant neighbours,—or more especially with a pleasant neighbour,—the affair is not, according to my taste, by any means the worst phase of society. But I do dislike that handing round, unless it be of a subsidiary thimbleful when the business of the social intercourse has been dinner.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("And indeed this handing round has become a vulgar and an intolerable nuisance among us second-class gentry with our eight hundred a year—there or thereabouts;—doubly intolerable as being destructive of our natural comforts, and a wretchedly vulgar aping of men with large incomes. The Duke of Omnium and Lady Hartletop are undoubtedly wise to have everything handed round. Friends of mine who occasionally dine at such houses tell me that they get their wine quite as quickly as they can drink it, that their mutton is brought to them without delay, and that the potato-bearer follows quick upon the heels of carnifer. Nothing can be more comfortable, and we may no doubt acknowledge that these first-class grandees do understand their material comforts. But we of the eight hundred can no more come up to them in this than we can in their opera-boxes and equipages. May I not say that the usual tether of this class, in the way of carnifers, cup-bearers, and the rest, does not reach beyond neat-handed Phyllis and the greengrocer? and that Phyllis, neat-handed as she probably is, and the greengrocer, though he be ever so active, cannot administer a dinner to twelve people who are prohibited by a Medo-Persian law from all self-administration whatever? And may I not further say that the lamentable consequence to us eight hundreders dining out among each other is this, that we too often get no dinner at all. Phyllis, with the potatoes, cannot reach us till our mutton is devoured, or in a lukewarm state past our power of managing; and Ganymede, the greengrocer, though we admire the skill of his necktie and the whiteness of his unexceptionable gloves, fails to keep us going in sherry.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("Seeing a lady the other day in this strait, left without a small modicum of stimulus which was no doubt necessary for her good digestion, I ventured to ask her to drink wine with me. But when I bowed my head at her, she looked at me with all her eyes, struck with amazement. Had I suggested that she should join me in a wild Indian war-dance, with nothing on but my paint, her face could not have shown greater astonishment. And yet I should have thought she might have remembered the days when Christian men and women used to drink wine with each other.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("God be with the good old days when I could hobnob with my friend over the table as often as I was inclined to lift my glass to my lips, and make a long arm for a hot potato whenever the exigencies of my plate required it.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("I think it may be laid down as a rule in affairs of hospitality, that whatever extra luxury or grandeur we introduce at our tables when guests are with us, should be introduced for the advantage of the guest and not for our own. If, for instance, our dinner be served in a manner different from that usual to us, it should be so served in order that our friends may with more satisfaction eat our repast than our everyday practice would produce on them. But the change should by no means be made to their material detriment in order that our fashion may be acknowledged. Again, if I decorate my sideboard and table, wishing that the eyes of my visitors may rest on that which is elegant and pleasant to the sight, I act in that matter with a becoming sense of hospitality; but if my object be to kill Mrs. Jones with envy at the sight of all my silver trinkets, I am a very mean-spirited fellow. This, in a broad way, will be acknowledged; but if we would bear in mind the same idea at all times,—on occasions when the way perhaps may not be so broad, when more thinking may be required to ascertain what is true hospitality,—I think we of the eight hundred would make a greater advance towards really entertaining our own friends than by any rearrangement of the actual meats and dishes which we set before them.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("Knowing as we do, that the terms of the Lufton-Grantly alliance had been so solemnly ratified between the two mothers, it is perhaps hardly open to us to suppose that Mrs. Grantly was induced to take her daughter to Mrs. Proudie’s by any knowledge which she may have acquired that Lord Dumbello had promised to grace the bishop’s assembly. It is certainly the fact that high contracting parties do sometimes allow themselves a latitude which would be considered dishonest by contractors of a lower sort; and it may be possible that the archdeacon’s wife did think of that second string with which her bow was furnished. Be that as it may, Lord Dumbello was at Mrs. Proudie’s, and it did so come to pass that Griselda was seated at the corner of a sofa close to which was a vacant space in which his lordship could—“group himself.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("They had not been long there before Lord Dumbello did group himself. “Fine day,” he said, coming up and occupying the vacant position by Miss Grantly’s elbow.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“We were driving to-day, and we thought it rather cold,” said Griselda.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Deuced cold,” said Lord Dumbello, and then he adjusted his white cravat and touched up his whiskers. Having got so far, he did not proceed to any other immediate conversational efforts; nor did Griselda. But he grouped himself again as became a marquis, and gave very intense satisfaction to Mrs. Proudie.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“This is so kind of you, Lord Dumbello,” said that lady, coming up to him and shaking his hand warmly; “so very kind of you to come to my poor little tea-party.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Uncommonly pleasant, I call it,” said his lordship. “I like this sort of thing—no trouble, you know.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“No; that is the charm of it, isn’t it? no trouble, or fuss, or parade. That’s what I always say. According to my ideas, society consists in giving people facility for an interchange of thoughts—what we call conversation.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Aw, yes, exactly.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Not in eating and drinking together—eh, Lord Dumbello? And yet the practice of our lives would seem to show that the indulgence of those animal propensities can alone suffice to bring people together. The world in this has surely made a great mistake.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“I like a good dinner all the same,” said Lord Dumbello.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Oh, yes, of course—of course. I am by no means one of those who would pretend to preach that our tastes have not been given to us for our enjoyment. Why should things be nice if we are not to like them?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“A man who can really give a good dinner has learned a great deal,” said Lord Dumbello, with unusual animation.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“An immense deal. It is quite an art in itself; and one which I, at any rate, by no means despise. But we cannot always be eating—can we?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“No,” said Lord Dumbello, “not always.” And he looked as though he lamented that his powers should be so circumscribed.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("And then Mrs. Proudie passed on to Mrs. Grantly. The two ladies were quite friendly in London; though down in their own neighbourhood they waged a war so internecine in its nature. But nevertheless Mrs. Proudie’s manner might have showed to a very close observer that she knew the difference between a bishop and an archdeacon. “I am so delighted to see you,” said she. “No, don’t mind moving; I won’t sit down just at present. But why didn’t the archdeacon come?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“It was quite impossible; it was indeed,” said Mrs. Grantly. “The archdeacon never has a moment in London that he can call his own.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“You don’t stay up very long, I believe.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“A good deal longer than we either of us like, I can assure you. London life is a perfect nuisance to me.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“But people in a certain position must go through with it, you know,” said Mrs. Proudie. “The bishop, for instance, must attend the House.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Must he?” asked Mrs. Grantly, as though she were not at all well informed with reference to this branch of a bishop’s business. “I am very glad that archdeacons are under no such liability.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Oh, no; there’s nothing of that sort,” said Mrs. Proudie, very seriously. “But how uncommonly well Miss Grantly is looking! I do hear that she has quite been admired.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("This phrase certainly was a little hard for the mother to bear. All the world had acknowledged, so Mrs. Grantly had taught herself to believe, that Griselda was undoubtedly the beauty of the season. Marquises and lords were already contending for her smiles, and paragraphs had been written in newspapers as to her profile. It was too hard to be told, after that, that her daughter had been “quite admired.” Such a phrase might suit a pretty little red-cheeked milkmaid of a girl.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“She cannot, of course, come near your girls in that respect,” said Mrs. Grantly, very quietly. Now the Miss Proudies had not elicited from the fashionable world any very loud encomiums on their beauty. Their mother felt the taunt in its fullest force, but she would not essay to do battle on the present arena. She jotted down the item in her mind, and kept it over for Barchester and the chapter. Such debts as those she usually paid on some day, if the means of doing so were at all within her power.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“But there is Miss Dunstable, I declare,” she said, seeing that that lady had entered the room; and away went Mrs. Proudie to welcome her distinguished guest.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“And so this is a conversazione, is it?” said that lady, speaking, as usual, not in a suppressed voice. “Well, I declare, it’s very nice. It means conversation, don’t it, Mrs. Proudie?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Ha, ha, ha! Miss Dunstable, there is nobody like you, I declare.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Well, but don’t it? and tea and cake? and then, when we’re tired of talking, we go away,—isn’t that it?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“But you must not be tired for these three hours yet.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Oh, I’m never tired of talking; all the world knows that. How do, bishop? A very nice sort of thing this conversazione, isn’t it now?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("The bishop rubbed his hands together and smiled, and said that he thought it was rather nice.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Mrs. Proudie is so fortunate in all her little arrangements,” said Miss Dunstable.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Yes, yes,” said the bishop. “I think she is happy in these matters. I do flatter myself that she is so. Of course, Miss Dunstable, you are accustomed to things on a much grander scale.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“I! Lord bless you, no! Nobody hates grandeur so much as I do. Of course I must do as I am told. I must live in a big house, and have three footmen six feet high. I must have a coachman with a top-heavy wig, and horses so big that they frighten me. If I did not, I should be made out a lunatic and declared unable to manage my own affairs. But as for grandeur, I hate it. I certainly think that I shall have some of these conversaziones. I wonder whether Mrs. Proudie will come and put me up to a wrinkle or two.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("The bishop again rubbed his hands, and said that he was sure she would. He never felt quite at his ease with Miss Dunstable, as he rarely could ascertain whether or no she was earnest in what she was saying. So he trotted off, muttering some excuse as he went, and Miss Dunstable chuckled with an inward chuckle at his too evident bewilderment. Miss Dunstable was by nature kind, generous, and open-hearted; but she was living now very much with people on whom kindness, generosity, and open-heartedness were thrown away. She was clever also, and could be sarcastic; and she found that those qualities told better in the world around her than generosity and an open heart. And so she went on from month to month, and year to year, not progressing in a good spirit as she might have done, but still carrying within her bosom a warm affection for those she could really love. And she knew that she was hardly living as she should live,—that the wealth which she affected to despise was eating into the soundness of her character, not by its splendour, but by the style of life which it had seemed to produce as a necessity. She knew that she was gradually becoming irreverent, scornful, and prone to ridicule; but yet, knowing this and hating it, she hardly knew how to break from it.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("She had seen so much of the blacker side of human nature that blackness no longer startled her as it should do. She had been the prize at which so many ruined spendthrifts had aimed; so many pirates had endeavoured to run her down while sailing in the open waters of life, that she had ceased to regard such attempts on her money-bags as unmanly or over-covetous. She was content to fight her own battle with her own weapons, feeling secure in her own strength of purpose and strength of wit.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("Some few friends she had whom she really loved,—among whom her inner self could come out and speak boldly what it had to say with its own true voice. And the woman who thus so spoke was very different from that Miss Dunstable whom Mrs. Proudie courted, and the Duke of Omnium fêted, and Mrs. Harold Smith claimed as her bosom friend. If only she could find among such one special companion on whom her heart might rest, who would help her to bear the heavy burdens of her world! But where was she to find such a friend?—she with her keen wit, her untold money, and loud laughing voice. Everything about her was calculated to attract those whom she could not value, and to scare from her the sort of friend to whom she would fain have linked her lot.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("And then she met Mrs. Harold Smith, who had taken Mrs. Proudie’s noble suite of rooms in her tour for the evening, and was devoting to them a period of twenty minutes. “And so I may congratulate you,” Miss Dunstable said eagerly to her friend.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“No, in mercy’s name do no such thing, or you may too probably have to uncongratulate me again; and that will be so unpleasant.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“But they told me that Lord Brock had sent for him yesterday.” Now at this period Lord Brock was Prime Minister.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“So he did, and Harold was with him backwards and forwards all the day. But he can’t shut his eyes and open his mouth, and see what God will send him, as a wise and prudent man should do. He is always for bargaining, and no Prime Minister likes that.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“I would not be in his shoes if, after all, he has to come home and say that the bargain is off.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Ha, ha, ha! Well, I should not take it very quietly. But what can we poor women do, you know? When it is settled, my dear, I’ll send you a line at once.” And then Mrs. Harold Smith finished her course round the rooms, and regained her carriage within the twenty minutes.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Beautiful profile, has she not?” said Miss Dunstable, somewhat later in the evening, to Mrs. Proudie. Of course, the profile spoken of belonged to Miss Grantly.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Yes, it is beautiful, certainly,” said Mrs. Proudie. “The pity is that it means nothing.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“The gentlemen seem to think that it means a good deal.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“I am not sure of that. She has no conversation, you see; not a word. She has been sitting there with Lord Dumbello at her elbow for the last hour, and yet she has hardly opened her mouth three times.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“But, my dear Mrs. Proudie, who on earth could talk to Lord Dumbello?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("Mrs. Proudie thought that her own daughter Olivia would undoubtedly be able to do so, if only she could get the opportunity. But, then, Olivia had so much conversation.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("And while the two ladies were yet looking at the youthful pair, Lord Dumbello did speak again. “I think I have had enough of this now,” said he, addressing himself to Griselda.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“I suppose you have other engagements,” said she.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Oh, yes; and I believe I shall go to Lady Clantelbrock’s.” And then he took his departure. No other word was spoken that evening between him and Miss Grantly beyond those given in this chronicle, and yet the world declared that he and that young lady had passed the evening in so close a flirtation as to make the matter more than ordinarily particular; and Mrs. Grantly, as she was driven home to her lodgings, began to have doubts in her mind whether it would be wise to discountenance so great an alliance as that which the head of the great Hartletop family now seemed so desirous to establish. The prudent mother had not yet spoken a word to her daughter on these subjects, but it might soon become necessary to do so. It was all very well for Lady Lufton to hurry up to town, but of what service would that be, if Lord Lufton were not to be found in Bruton Street?")])])])])
}]}

/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(125),
  /* template */
  __webpack_require__(126),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 126 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('p', {
    staticClass: "ORIM-Chapter-Title-Page-Break"
  }, [_vm._v("CHAPTER XVIII")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Chapter-Subtitle"
  }, [_vm._v("The New Minister’s Patronage")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Chapter-Opener-Paragraph"
  }, [_vm._v("At that time, just as Lady Lufton was about to leave Framley for London, Mark Robarts received a pressing letter, inviting him also to go up to the metropolis for a day or two—not for pleasure, but on business. The letter was from his indefatigable friend Sowerby.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Ext-First"
  }, [_vm._v("“My dear Robarts,” the letter ran:—")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Ext-First"
  }, [_vm._v("I have just heard that poor little Burslem, the Barsetshire prebendary, is dead. We must all die some day, you know,—as you have told your parishioners from the Framley pulpit more than once, no doubt. The stall must be filled up, and why should not you have it as well as another? It is six hundred a year and a house. Little Burslem had nine, but the good old times are gone. Whether the house is letable or not under the present ecclesiastical régime, I do not know. It used to be so, for I remember Mrs. Wiggins, the tallow-chandler’s widow, living in old Stanhope’s house.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Ext-Body"
  }, [_vm._v("Harold Smith has just joined the government as Lord Petty Bag, and could, I think, at the present moment get this for asking. He cannot well refuse me, and, if you will say the word, I will speak to him. You had better come up yourself; but say the word “Yes,” or “No,” by the wires.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Ext-Body"
  }, [_vm._v("If you say “Yes,” as of course you will, do not fail to come up. You will find me at the “Travellers,” or at the House. The stall will just suit you,—will give you no trouble, improve your position, and give some little assistance towards bed and board, and rack and manger.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Letclos"
  }, [_vm._v("Yours ever faithfully,")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Letclos-Last"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("N. SOWERBY")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Ext-Last"
  }, [_vm._v("Singularly enough, I hear that your brother is private secretary to the new Lord Petty Bag. I am told that his chief duty will consist in desiring the servants to call my sister’s carriage. I have only seen Harold once since he accepted office; but my Lady Petty Bag says that he has certainly grown an inch since that occurrence.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("This was certainly very good-natured on the part of Mr. Sowerby, and showed that he had a feeling within his bosom that he owed something to his friend the parson for the injury he had done him. And such was in truth the case. A more reckless being than the member for West Barsetshire could not exist. He was reckless for himself, and reckless for all others with whom he might be concerned. He could ruin his friends with as little remorse as he had ruined himself. All was fair game that came in the way of his net. But, nevertheless, he was good-natured, and willing to move heaven and earth to do a friend a good turn, if it came in his way to do so.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("He did really love Mark Robarts as much as it was given him to love any among his acquaintance. He knew that he had already done him an almost irreparable injury, and might very probably injure him still deeper before he had done with him. That he would undoubtedly do so, if it came in his way, was very certain. But then, if it also came in his way to repay his friend by any side blow, he would also undoubtedly do that. Such an occasion had now come, and he had desired his sister to give the new Lord Petty Bag no rest till he should have promised to use all his influence in getting the vacant prebend for Mark Robarts.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("This letter of Sowerby’s Mark immediately showed to his wife. How lucky, thought he to himself, that not a word was said in it about those accursed money transactions! Had he understood Sowerby better he would have known that that gentleman never said anything about money transactions until it became absolutely necessary. “I know you don’t like Mr. Sowerby,” he said; “but you must own that this is very good-natured.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“It is the character I hear of him that I don’t like,” said Mrs. Robarts.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“But what shall I do now, Fanny? As he says, why should not I have the stall as well as another?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“I suppose it would not interfere with your parish?” she asked.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Not in the least, at the distance at which we are. I did think of giving up old Jones; but if I take this, of course I must keep a curate.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("His wife could not find it in her heart to dissuade him from accepting promotion when it came in his way—what vicar’s wife would have so persuaded her husband? But yet she did not altogether like it. She feared that Greek from Chaldicotes, even when he came with the present of a prebendal stall in his hands. And then what would Lady Lufton say?")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“And do you think that you must go up to London, Mark?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Oh, certainly; that is, if I intend to accept Harold Smith’s kind offices in the matter.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“I suppose it will be better to accept them,” said Fanny, feeling perhaps that it would be useless in her to hope that they should not be accepted.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Prebendal stalls, Fanny, don’t generally go begging long among parish clergymen. How could I reconcile it to the duty I owe to my children to refuse such an increase to my income?” And so it was settled that he should at once drive to Silverbridge and send off a message by telegraph, and that he should himself proceed to London on the following day. “But you must see Lady Lufton first, of course,” said Fanny, as soon as all this was settled.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("Mark would have avoided this if he could have decently done so, but he felt that it would be impolitic, as well as indecent. And why should he be afraid to tell Lady Lufton that he hoped to receive this piece of promotion from the present government? There was nothing disgraceful in a clergyman becoming a prebendary of Barchester. Lady Lufton herself had always been very civil to the prebendaries, and especially to little Dr. Burslem, the meagre little man who had just now paid the debt of nature. She had always been very fond of the chapter, and her original dislike to Bishop Proudie had been chiefly founded on his interference with the cathedral clergy,—on his interference, or on that of his wife or chaplain. Considering these things Mark Robarts tried to make himself believe that Lady Lufton would be delighted at his good fortune. But yet he did not believe it. She at any rate would revolt from the gift of the Greek of Chaldicotes.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Oh, indeed,” she said, when the vicar had with some difficulty explained to her all the circumstances of the case. “Well, I congratulate you, Mr. Robarts, on your powerful new patron.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“You will probably feel with me, Lady Lufton, that the benefice is one which I can hold without any detriment to me in my position here at Framley,” said he, prudently resolving to let the slur upon his friends pass by unheeded.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Well, I hope so. Of course, you are a very young man, Mr. Robarts, and these things have generally been given to clergymen more advanced in life.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“But you do not mean to say that you think I ought to refuse it?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“What my advice to you might be if you really came to me for advice, I am hardly prepared to say at so very short a notice. You seem to have made up your mind, and therefore I need not consider it. As it is, I wish you joy, and hope that it may turn out to your advantage in every way.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“You understand, Lady Lufton, that I have by no means got it as yet.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Oh, I thought it had been offered to you. I thought you spoke of this new minister as having all that in his own hand.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Oh, dear, no. What may be the amount of his influence in that respect I do not at all know. But my correspondent assures me—”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Mr. Sowerby, you mean. Why don’t you call him by his name?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Mr. Sowerby assures me that Mr. Smith will ask for it; and thinks it most probable that his request will be successful.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Oh, of course. Mr. Sowerby and Mr. Harold Smith together would no doubt be successful in anything. They are the sort of men who are successful nowadays. Well, Mr. Robarts, I wish you joy.” And she gave him her hand in token of her sincerity.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("Mark took her hand, resolving to say nothing further on that occasion. That Lady Lufton was not now cordial with him, as she used to be, he was well aware; and sooner or later he was determined to have the matter out with her. He would ask her why she now so constantly met him with a taunt, and so seldom greeted him with that kind old affectionate smile which he knew and appreciated so well. That she was honest and true, he was quite sure. If he asked her the question plainly, she would answer him openly. And if he could induce her to say that she would return to her old ways, return to them she would in a hearty manner. But he could not do this just at present. It was but a day or two since Mr. Crawley had been with him; and was it not probable that Mr. Crawley had been sent thither by Lady Lufton? His own hands were not clean enough for a remonstrance at the present moment. He would cleanse them, and then he would remonstrate.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Would you like to live part of the year in Barchester?” he said to his wife and sister that evening.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“I think that two houses are only a trouble,” said his wife. “And we have been very happy here.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“I have always liked a cathedral town,” said Lucy; “and I am particularly fond of the close.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“And Barchester-close is the closest of all closes,” said Mark. “There is not a single house within the gateways that does not belong to the chapter.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“But if we are to keep up two houses, the additional income will soon be wasted,” said Fanny prudently.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“The thing would be, to let the house furnished every summer,” said Lucy.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“But I must take my residence as the terms come,” said the vicar; “and I certainly should not like to be away from Framley all the winter; I should never see anything of Lufton.” And perhaps he thought of his hunting, and then thought again of that cleansing of his hands.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“I should not a bit mind being away during the winter,” said Lucy, thinking of what the last winter had done for her.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“But where on earth should we find money to furnish one of those large, old-fashioned houses? Pray, Mark, do not do anything rash.” And the wife laid her hand affectionately on her husband’s arm. In this manner the question of the prebend was discussed between them on the evening before he started for London.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("Success had at last crowned the earnest effort with which Harold Smith had carried on the political battle of his life for the last ten years. The late Lord Petty Bag had resigned in disgust, having been unable to digest the Prime Minister’s ideas on Indian Reform, and Mr. Harold Smith, after sundry hitches in the business, was installed in his place. It was said that Harold Smith was not exactly the man whom the Premier would himself have chosen for that high office; but the Premier’s hands were a good deal tied by circumstances. The last great appointment he had made had been terribly unpopular,—so much so as to subject him, popular as he undoubtedly was himself, to a screech from the whole nation. The "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Jupiter")]), _vm._v(", with withering scorn, had asked whether vice of every kind was to be considered, in these days of Queen Victoria, as a passport to the cabinet. Adverse members of both Houses had arrayed themselves in a pure panoply of morality, and thundered forth their sarcasms with the indignant virtue and keen discontent of political Juvenals; and even his own friends had held up their hands in dismay. Under these circumstances he had thought himself obliged in the present instance to select a man who would not be especially objectionable to any party. Now Harold Smith lived with his wife, and his circumstances were not more than ordinarily embarrassed. He kept no race-horses; and, as Lord Brock now heard for the first time, gave lectures in provincial towns on popular subjects. He had a seat which was tolerably secure, and could talk to the House by the yard if required to do so. Moreover, Lord Brock had a great idea that the whole machinery of his own ministry would break to pieces very speedily. His own reputation was not bad, but it was insufficient for himself and that lately selected friend of his. Under all these circumstances combined, he chose Harold Smith to fill the vacant office of Lord Petty Bag.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("And very proud the Lord Petty Bag was. For the last three or four months, he and Mr. Supplehouse had been agreeing to consign the ministry to speedy perdition. “This sort of dictatorship will never do,” Harold Smith had himself said, justifying that future vote of his as to want of confidence in the Queen’s government. And Mr. Supplehouse in this matter had fully agreed with him. He was a Juno whose form that wicked old Paris had utterly despised, and he, too, had quite made up his mind as to the lobby in which he would be found when that day of vengeance should arrive. But now things were much altered in Harold Smith’s views. The Premier had shown his wisdom in seeking for new strength where strength ought to be sought, and introducing new blood into the body of his ministry. The people would now feel fresh confidence, and probably the House also. As to Mr. Supplehouse—he would use all his influence on Supplehouse. But, after all, Mr. Supplehouse was not everything.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("On the morning after our vicar’s arrival in London he attended at the Petty Bag office. It was situated in the close neighbourhood of Downing Street and the higher governmental gods; and though the building itself was not much, seeing that it was shored up on one side, that it bulged out in the front, was foul with smoke, dingy with dirt, and was devoid of any single architectural grace or modern scientific improvement, nevertheless its position gave it a status in the world which made the clerks in the Lord Petty Bag’s office quite respectable in their walk in life. Mark had seen his friend Sowerby on the previous evening, and had then made an appointment with him for the following morning at the new minister’s office. And now he was there a little before his time, in order that he might have a few moments’ chat with his brother.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("When Mark found himself in the private secretary’s room he was quite astonished to see the change in his brother’s appearance which the change in his official rank had produced. Jack Robarts had been a well-built, straight-legged, lissome young fellow, pleasant to the eye because of his natural advantages, but rather given to a harum-skarum style of gait, and occasionally careless, not to say slovenly, in his dress. But now he was the very pink of perfection. His jaunty frock-coat fitted him to perfection; not a hair of his head was out of place; his waistcoat and trousers were glossy and new, and his umbrella, which stood in the umbrella-stand in the corner, was tight, and neat, and small, and natty.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Well, John, you’ve become quite a great man,” said his brother.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“I don’t know much about that,” said John; “but I find that I have an enormous deal of fagging to go through.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Do you mean work? I thought you had about the easiest berth in the whole Civil Service.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Ah! that’s just the mistake that people make. Because we don’t cover whole reams of foolscap paper at the rate of fifteen lines to a page, and five words to a line, people think that we private secretaries have got nothing to do. Look here,” and he tossed over scornfully a dozen or so of little notes. “I tell you what, Mark; it is no easy matter to manage the patronage of a cabinet minister. Now I am bound to write to every one of these fellows a letter that will please him; and yet I shall refuse to every one of them the request which he asks.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“That must be difficult.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Difficult is no word for it. But, after all, it consists chiefly in the knack of the thing. One must have the wit ‘from such a sharp and waspish word as No to pluck the sting.’ I do it every day, and I really think that the people like it.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Perhaps your refusals are better than other people’s acquiescences.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“I don’t mean that at all. We private secretaries have all to do the same thing. Now, would you believe it? I have used up three lifts of note-paper already in telling people that there is no vacancy for a lobby messenger in the Petty Bag office. Seven peeresses have asked for it for their favourite footmen. But there—there’s the Lord Petty Bag!”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("A bell rang and the private secretary, jumping up from his note-paper, tripped away quickly to the great man’s room.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“He’ll see you at once,” said he, returning. “Buggins, show the Reverend Mr. Robarts to the Lord Petty Bag.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("Buggins was the messenger for whose not vacant place all the peeresses were striving with so much animation. And then Mark, following Buggins for two steps, was ushered into the next room.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("If a man be altered by becoming a private secretary, he is much more altered by being made a cabinet minister. Robarts, as he entered the room, could hardly believe that this was the same Harold Smith whom Mrs. Proudie bothered so cruelly in the lecture-room at Barchester. Then he was cross, and touchy, and uneasy, and insignificant. Now, as he stood smiling on the hearthrug of his official fireplace, it was quite pleasant to see the kind, patronizing smile which lighted up his features. He delighted to stand there, with his hands in his trousers’ pocket, the great man of the place, conscious of his lordship, and feeling himself every inch a minister. Sowerby had come with him, and was standing a little in the background, from which position he winked occasionally at the parson over the minister’s shoulder.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Ah, Robarts, delighted to see you. How odd, by-the-by, that your brother should be my private secretary!” Mark said that it was a singular coincidence.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“A very smart young fellow, and, if he minds himself, he’ll do well.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“I’m quite sure he’ll do well,” said Mark.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Ah! well, yes; I think he will. And now, what can I do for you, Robarts?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("Hereupon Mr. Sowerby struck in, making it apparent by his explanation that Mr. Robarts himself by no means intended to ask for anything; but that, as his friends had thought that this stall at Barchester might be put into his hands with more fitness than in those of any other clergyman of the day, he was willing to accept the piece of preferment from a man whom he respected so much as he did the new Lord Petty Bag.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("The minister did not quite like this, as it restricted him from much of his condescension, and robbed him of the incense of a petition which he had expected Mark Robarts would make to him. But, nevertheless, he was very gracious.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“He could not take upon himself to declare,” he said, “what might be Lord Brock’s pleasure with reference to the preferment at Barchester which was vacant. He had certainly already spoken to his lordship on the subject, and had perhaps some reason to believe that his own wishes would be consulted. No distinct promise had been made, but he might perhaps go so far as to say that he expected such result. If so, it would give him the greatest pleasure in the world to congratulate Mr. Robarts on the possession of the stall—a stall which he was sure Mr. Robarts would fill with dignity, piety, and brotherly love.” And then, when he had finished, Mr. Sowerby gave a final wink, and said that he regarded the matter as settled.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“No, not settled, Nathaniel,” said the cautious minister.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“It’s the same thing,” rejoined Sowerby. “We all know what all that flummery means. Men in office, Mark, never do make a distinct promise,—not even to themselves of the leg of mutton which is roasting before their kitchen fires. It is so necessary in these days to be safe; is it not, Harold?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Most expedient,” said Harold Smith, shaking his head wisely. “Well, Robarts, who is it now?” This he said to his private secretary, who came to notice the arrival of some bigwig. “Well, yes. I will say good morning, with your leave, for I am a little hurried. And remember, Mr. Robarts, I will do what I can for you; but you must distinctly understand that there is no promise.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("“Oh, no promise at all,” said Sowerby—“of course not.” And then, as he sauntered up Whitehall towards Charing Cross, with Robarts on his arm, he again pressed upon him the sale of that invaluable hunter, who was eating his head off his shoulders in the stable at Chaldicotes.")])])])])
}]}

/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(128),
  /* template */
  __webpack_require__(129),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 129 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(131),
  /* template */
  __webpack_require__(132),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 132 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(134),
  /* template */
  __webpack_require__(135),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 134 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 135 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(137),
  /* template */
  __webpack_require__(138),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 137 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 138 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(140),
  /* template */
  __webpack_require__(141),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 140 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 141 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(143),
  /* template */
  __webpack_require__(144),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 143 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 144 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(146),
  /* template */
  __webpack_require__(147),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 146 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 147 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(149),
  /* template */
  __webpack_require__(150),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 149 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 150 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(152),
  /* template */
  __webpack_require__(153),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 152 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 153 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(155),
  /* template */
  __webpack_require__(156),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 155 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 156 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(158),
  /* template */
  __webpack_require__(159),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 158 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 159 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(161),
  /* template */
  __webpack_require__(162),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 161 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 162 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(164),
  /* template */
  __webpack_require__(165),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 164 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 165 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(167),
  /* template */
  __webpack_require__(168),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 167 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 168 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(170),
  /* template */
  __webpack_require__(171),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 170 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 171 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(173),
  /* template */
  __webpack_require__(174),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 173 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 174 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(176),
  /* template */
  __webpack_require__(177),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 176 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 177 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(179),
  /* template */
  __webpack_require__(180),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 179 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 180 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(182),
  /* template */
  __webpack_require__(183),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 182 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 183 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(185),
  /* template */
  __webpack_require__(186),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 185 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 186 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(188),
  /* template */
  __webpack_require__(189),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 188 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 189 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(191),
  /* template */
  __webpack_require__(192),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 191 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 192 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(194),
  /* template */
  __webpack_require__(195),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 194 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 195 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(197),
  /* template */
  __webpack_require__(198),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 197 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 198 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(200),
  /* template */
  __webpack_require__(201),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 200 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 201 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(203),
  /* template */
  __webpack_require__(204),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 203 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 204 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(206),
  /* template */
  __webpack_require__(207),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 206 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 207 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(209),
  /* template */
  __webpack_require__(210),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 209 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 210 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(212),
  /* template */
  __webpack_require__(213),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 212 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 213 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(215),
  /* template */
  __webpack_require__(216),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 215 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 216 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(218),
  /* template */
  __webpack_require__(219),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 218 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 219 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(221),
  /* template */
  __webpack_require__(222),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 221 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 222 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(224),
  /* template */
  __webpack_require__(225),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 224 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 225 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(227),
  /* template */
  __webpack_require__(228),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 227 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 228 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(230),
  /* template */
  __webpack_require__(231),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 230 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 231 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(233),
  /* template */
  __webpack_require__(234),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 233 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 234 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(236),
  /* template */
  __webpack_require__(237),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 236 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 237 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(239),
  /* template */
  __webpack_require__(240),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 239 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 240 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(242),
  /* template */
  __webpack_require__(243),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 242 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 243 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(245),
  /* template */
  __webpack_require__(246),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 245 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 246 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(248),
  /* template */
  __webpack_require__(249),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 248 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 249 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(251),
  /* template */
  __webpack_require__(252),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 251 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 252 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(254),
  /* template */
  __webpack_require__(255),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 254 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 255 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(257),
  /* template */
  __webpack_require__(258),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 257 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 258 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(260),
  /* template */
  __webpack_require__(261),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 260 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 261 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(263),
  /* template */
  __webpack_require__(264),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 263 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 264 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(266),
  /* template */
  __webpack_require__(267),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 266 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 267 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(269),
  /* template */
  __webpack_require__(270),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 269 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 270 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(272),
  /* template */
  __webpack_require__(273),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 272 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 273 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(275),
  /* template */
  __webpack_require__(276),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 275 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 276 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(278),
  /* template */
  __webpack_require__(279),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 278 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 279 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(281),
  /* template */
  __webpack_require__(282),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 281 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 282 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(284),
  /* template */
  __webpack_require__(285),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 284 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 285 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(287),
  /* template */
  __webpack_require__(288),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 287 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 288 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(290),
  /* template */
  __webpack_require__(291),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 290 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 291 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(293),
  /* template */
  __webpack_require__(294),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 293 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 294 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(296),
  /* template */
  __webpack_require__(297),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 296 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 297 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(299),
  /* template */
  __webpack_require__(300),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 299 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 300 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(302),
  /* template */
  __webpack_require__(303),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 302 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 303 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(305),
  /* template */
  __webpack_require__(306),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 305 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 306 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(308),
  /* template */
  __webpack_require__(309),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 308 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 309 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(311),
  /* template */
  __webpack_require__(312),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 311 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 312 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(314),
  /* template */
  __webpack_require__(315),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 314 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 315 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(317),
  /* template */
  __webpack_require__(318),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 317 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 318 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(320),
  /* template */
  __webpack_require__(321),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 320 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 321 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(323),
  /* template */
  __webpack_require__(324),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 323 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 324 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(326),
  /* template */
  __webpack_require__(327),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 326 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 327 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(329),
  /* template */
  __webpack_require__(330),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 329 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 330 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(332),
  /* template */
  __webpack_require__(333),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 332 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 333 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(335),
  /* template */
  __webpack_require__(336),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 335 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 336 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(338),
  /* template */
  __webpack_require__(339),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 338 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 339 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(341),
  /* template */
  __webpack_require__(342),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 341 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 342 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(344),
  /* template */
  __webpack_require__(345),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 344 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 345 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(347),
  /* template */
  __webpack_require__(348),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 347 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 348 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(350),
  /* template */
  __webpack_require__(351),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 350 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 351 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(353),
  /* template */
  __webpack_require__(354),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 353 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 354 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(356),
  /* template */
  __webpack_require__(357),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 356 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 357 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(359),
  /* template */
  __webpack_require__(360),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 359 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 360 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(362),
  /* template */
  __webpack_require__(363),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 362 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 363 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(365),
  /* template */
  __webpack_require__(366),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 365 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 366 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(368),
  /* template */
  __webpack_require__(369),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 368 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 369 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(371),
  /* template */
  __webpack_require__(372),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 371 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 372 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(374),
  /* template */
  __webpack_require__(375),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 374 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 375 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(377),
  /* template */
  __webpack_require__(378),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 377 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 378 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(380),
  /* template */
  __webpack_require__(381),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 380 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 381 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(383),
  /* template */
  __webpack_require__(384),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 383 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 384 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(386),
  /* template */
  __webpack_require__(387),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 386 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 387 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(389),
  /* template */
  __webpack_require__(390),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 389 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 390 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(392),
  /* template */
  __webpack_require__(393),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 392 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 393 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(395),
  /* template */
  __webpack_require__(396),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 395 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 396 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(398),
  /* template */
  __webpack_require__(399),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 398 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 399 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(401),
  /* template */
  __webpack_require__(402),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 401 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 402 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(404),
  /* template */
  __webpack_require__(405),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 404 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 405 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(407),
  /* template */
  __webpack_require__(408),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 407 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 408 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(410),
  /* template */
  __webpack_require__(411),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 410 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 411 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(413),
  /* template */
  __webpack_require__(414),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 413 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 414 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(416),
  /* template */
  __webpack_require__(417),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 416 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 417 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(419),
  /* template */
  __webpack_require__(420),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 419 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 420 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(422),
  /* template */
  __webpack_require__(423),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 422 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 423 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(425),
  /* template */
  __webpack_require__(426),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 425 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 426 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(428),
  /* template */
  __webpack_require__(429),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 428 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 429 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(431),
  /* template */
  __webpack_require__(432),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 431 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 432 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(434),
  /* template */
  __webpack_require__(435),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 434 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 435 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(437),
  /* template */
  __webpack_require__(438),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 437 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 438 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(440),
  /* template */
  __webpack_require__(441),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 440 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 441 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 442 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(443),
  /* template */
  __webpack_require__(444),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 443 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 444 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 445 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(446),
  /* template */
  __webpack_require__(447),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 446 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 447 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(449),
  /* template */
  __webpack_require__(450),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 449 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 450 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(452),
  /* template */
  __webpack_require__(453),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 452 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 453 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(455),
  /* template */
  __webpack_require__(456),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 455 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 456 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 457 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(458),
  /* template */
  __webpack_require__(459),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 458 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 459 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(461),
  /* template */
  __webpack_require__(462),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 461 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 462 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 463 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(464),
  /* template */
  __webpack_require__(465),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 464 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 465 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 466 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(467),
  /* template */
  __webpack_require__(468),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 467 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 468 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 469 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(470),
  /* template */
  __webpack_require__(471),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 470 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 471 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 472 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(473),
  /* template */
  __webpack_require__(474),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 473 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 474 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 475 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(476),
  /* template */
  __webpack_require__(477),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 476 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 477 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 478 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(479),
  /* template */
  __webpack_require__(480),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 479 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 480 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 481 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(482),
  /* template */
  __webpack_require__(483),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 482 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 483 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 484 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(485),
  /* template */
  __webpack_require__(486),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 485 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 486 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 487 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(488),
  /* template */
  __webpack_require__(489),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 488 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 489 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 490 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(491),
  /* template */
  __webpack_require__(492),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 491 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 492 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 493 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(494),
  /* template */
  __webpack_require__(495),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 494 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 495 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 496 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(497),
  /* template */
  __webpack_require__(498),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 497 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 498 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 499 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(500),
  /* template */
  __webpack_require__(501),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 500 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 501 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 502 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(503),
  /* template */
  __webpack_require__(504),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 503 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 504 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 505 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(506),
  /* template */
  __webpack_require__(507),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 506 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 507 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 508 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(509),
  /* template */
  __webpack_require__(510),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 509 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 510 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 511 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(512),
  /* template */
  __webpack_require__(513),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 512 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 513 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 514 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(515),
  /* template */
  __webpack_require__(516),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 515 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 516 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 517 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(518),
  /* template */
  __webpack_require__(519),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 518 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 519 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 520 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(521),
  /* template */
  __webpack_require__(522),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 521 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 522 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 523 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(524),
  /* template */
  __webpack_require__(525),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 524 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 525 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 526 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(527),
  /* template */
  __webpack_require__(528),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 527 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 528 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 529 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(530),
  /* template */
  __webpack_require__(531),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 530 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 531 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 532 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(533),
  /* template */
  __webpack_require__(534),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 533 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 534 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 535 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(536),
  /* template */
  __webpack_require__(537),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 536 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 537 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 538 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(539),
  /* template */
  __webpack_require__(540),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 539 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 540 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 541 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(542),
  /* template */
  __webpack_require__(543),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 542 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 543 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 544 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(545),
  /* template */
  __webpack_require__(546),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 545 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 546 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 547 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(548),
  /* template */
  __webpack_require__(549),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 548 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 549 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 550 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(551),
  /* template */
  __webpack_require__(552),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 551 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 552 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 553 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(554),
  /* template */
  __webpack_require__(555),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 554 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 555 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 556 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(557),
  /* template */
  __webpack_require__(558),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 557 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 558 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 559 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(560),
  /* template */
  __webpack_require__(561),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 560 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 561 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 562 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(563),
  /* template */
  __webpack_require__(564),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 563 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 564 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 565 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(566),
  /* template */
  __webpack_require__(567),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 566 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 567 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 568 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(569),
  /* template */
  __webpack_require__(570),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 569 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 570 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 571 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(572),
  /* template */
  __webpack_require__(573),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 572 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 573 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 574 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(575),
  /* template */
  __webpack_require__(576),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 575 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 576 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 577 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(578),
  /* template */
  __webpack_require__(579),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 578 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 579 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 580 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(581),
  /* template */
  __webpack_require__(582),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 581 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 582 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 583 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(584),
  /* template */
  __webpack_require__(585),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 584 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 585 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 586 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(587),
  /* template */
  __webpack_require__(588),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 587 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 588 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 589 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(590),
  /* template */
  __webpack_require__(591),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 590 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 591 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 592 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(593),
  /* template */
  __webpack_require__(594),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 593 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 594 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 595 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(596),
  /* template */
  __webpack_require__(597),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 596 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 597 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 598 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(599),
  /* template */
  __webpack_require__(600),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 599 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 600 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 601 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(602),
  /* template */
  __webpack_require__(603),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 602 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 603 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 604 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(605),
  /* template */
  __webpack_require__(606),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 605 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 606 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 607 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(608),
  /* template */
  __webpack_require__(609),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 608 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 609 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 610 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(611),
  /* template */
  __webpack_require__(612),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 611 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 612 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 613 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(614),
  /* template */
  __webpack_require__(615),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 614 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 615 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 616 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(617),
  /* template */
  __webpack_require__(618),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 617 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 618 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 619 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(620),
  /* template */
  __webpack_require__(621),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 620 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 621 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 622 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(623),
  /* template */
  __webpack_require__(624),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 623 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 624 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 625 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(626),
  /* template */
  __webpack_require__(627),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 626 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 627 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 628 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(629),
  /* template */
  __webpack_require__(630),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 629 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 630 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 631 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(632),
  /* template */
  __webpack_require__(633),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 632 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 633 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 634 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(635),
  /* template */
  __webpack_require__(636),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 635 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 636 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 637 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(638),
  /* template */
  __webpack_require__(639),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 638 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 639 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 640 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(641),
  /* template */
  __webpack_require__(642),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 641 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 642 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 643 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(644),
  /* template */
  __webpack_require__(645),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 644 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 645 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 646 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(647),
  /* template */
  __webpack_require__(648),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 647 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 648 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 649 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(650),
  /* template */
  __webpack_require__(651),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 650 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 651 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 652 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(653),
  /* template */
  __webpack_require__(654),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 653 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 654 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 655 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(656),
  /* template */
  __webpack_require__(657),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 656 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 657 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 658 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(659),
  /* template */
  __webpack_require__(660),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 659 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 660 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 661 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(662),
  /* template */
  __webpack_require__(663),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 662 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 663 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 664 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(665),
  /* template */
  __webpack_require__(666),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 665 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 666 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 667 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(668),
  /* template */
  __webpack_require__(669),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 668 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 669 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 670 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(671),
  /* template */
  __webpack_require__(672),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 671 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 672 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 673 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(674),
  /* template */
  __webpack_require__(675),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 674 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 675 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('p', [_vm._v("Thank you for reading this sample. Here are other books you might like.")]), _c('div', [_c('div', {
    attrs: {
      "id": "textcafe-gallery-widget-container"
    }
  }), _vm._v(" "), _c('script', {
    attrs: {
      "type": "application/javascript"
    }
  }, [_vm._v("\n      TextCafeWidget.config({\n          'type':'related',\n          'id':'9781504065214',\n          'coverImageWidth': '30',\n          'hideDescriptions': true\n      });\n      var textCafeGalleryWidget = TextCafeWidget.widgets.galleryWidget.new({selector:'#textcafe-gallery-widget-container'});\n      textCafeGalleryWidget.render();\n    ")])])])
}]}

/***/ }),
/* 676 */
/***/ (function(module, exports, __webpack_require__) {

(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["Vuetify"] = factory();
	else
		root["Vuetify"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/dist/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 29);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["d"] = createSimpleFunctional;
/* harmony export (immutable) */ __webpack_exports__["e"] = createSimpleTransition;
/* harmony export (immutable) */ __webpack_exports__["b"] = createJavaScriptTransition;
/* harmony export (immutable) */ __webpack_exports__["f"] = directiveConfig;
/* harmony export (immutable) */ __webpack_exports__["a"] = addOnceEventListener;
/* harmony export (immutable) */ __webpack_exports__["g"] = getObjectValueByPath;
/* harmony export (immutable) */ __webpack_exports__["c"] = createRange;
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function createSimpleFunctional(c) {
  var el = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'div';

  return {
    functional: true,

    render: function render(h, _ref) {
      var data = _ref.data,
          children = _ref.children;

      data.staticClass = (c + ' ' + (data.staticClass || '')).trim();

      return h(el, data, children);
    }
  };
}

function createSimpleTransition(name) {
  var origin = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'top center 0';
  var mode = arguments[2];

  return {
    functional: true,

    props: {
      origin: {
        type: String,
        default: origin
      }
    },

    render: function render(h, context) {
      context.data = context.data || {};
      context.data.props = { name: name };
      context.data.on = context.data.on || {};

      if (mode) context.data.props.mode = mode;

      context.data.on.beforeEnter = function (el) {
        el.style.transformOrigin = origin;
        el.style.webkitTransformOrigin = origin;
      };

      return h('transition', context.data, context.children);
    }
  };
}

function createJavaScriptTransition(name, functions) {
  var css = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  var mode = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'in-out';

  return {
    functional: true,

    props: {
      css: {
        type: Boolean,
        default: css
      },
      mode: {
        type: String,
        default: mode
      }
    },

    render: function render(h, context) {
      var data = {
        props: _extends({}, context.props, {
          name: name
        }),
        on: functions
      };

      return h('transition', data, context.children);
    }
  };
}

function directiveConfig(binding) {
  var defaults = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return Object.assign({}, defaults, binding.modifiers, { value: binding.arg }, binding.value || {});
}

function addOnceEventListener(el, event, cb) {
  var once = function once() {
    cb();
    el.removeEventListener(event, once, false);
  };

  el.addEventListener(event, once, false);
}

function getObjectValueByPath(obj, path) {
  // credit: http://stackoverflow.com/questions/6491463/accessing-nested-javascript-objects-with-string-key#comment55278413_6491621
  if (!path || path.constructor !== String) return;
  path = path.replace(/\[(\w+)\]/g, '.$1'); // convert indexes to properties
  path = path.replace(/^\./, ''); // strip a leading dot
  var a = path.split('.');
  for (var i = 0, n = a.length; i < n; ++i) {
    var k = a[i];
    if (obj instanceof Object && k in obj) {
      obj = obj[k];
    } else {
      return;
    }
  }
  return obj;
}

function createRange(length) {
  return [].concat(_toConsumableArray(Array.from({ length: length }, function (v, k) {
    return k;
  })));
}

/***/ }),
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    dark: Boolean,
    light: Boolean
  }
});

/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      isActive: !!this.value
    };
  },


  props: {
    value: {
      required: false
    }
  },

  watch: {
    value: function value(val) {
      this.isActive = !!val;
    },
    isActive: function isActive(val) {
      !!val !== this.value && this.$emit('input', val);
    }
  }
});

/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_contextualable__ = __webpack_require__(8);



/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_contextualable__["a" /* default */]],

  props: {
    disabled: Boolean,
    fa: Boolean,
    mdi: Boolean,
    large: Boolean,
    left: Boolean,
    medium: Boolean,
    right: Boolean,
    xLarge: Boolean
  },

  render: function render(h, _ref) {
    var props = _ref.props,
        data = _ref.data,
        _ref$children = _ref.children,
        children = _ref$children === undefined ? [] : _ref$children;

    if (props.fa || props.mdi) console.warn('The v-icon prop \'fa\' and \'mdi\' will be deprecated in the next release. Use \'fa\' or \'mdi\' prefix in icon name instead.');
    var iconName = '';
    var iconType = 'material-icons';

    if (children.length) {
      iconName = children.pop().text;
    } else if (data.domProps && data.domProps.textContent) {
      iconName = data.domProps.textContent;
      delete data.domProps.textContent;
    } else if (data.domProps && data.domProps.innerHTML) {
      iconName = data.domProps.innerHTML;
      delete data.domProps.innerHTML;
    }

    var thirdPartyIcon = iconName.indexOf('-') > -1;
    if (thirdPartyIcon) iconType = iconName.slice(0, iconName.indexOf('-'));

    // To keep things backwards compatible for now
    iconType = props.fa ? 'fa' : props.mdi ? 'mdi' : iconType;

    data.staticClass = (iconType + ' icon ' + (data.staticClass || '')).trim();
    data.attrs = data.attrs || {};

    var classes = {
      'icon--large': props.large,
      'icon--left': props.left,
      'icon--medium': props.medium,
      'icon--right': props.right,
      'icon--x-large': props.xLarge,
      'primary--text': props.primary,
      'secondary--text': props.secondary,
      'success--text': props.success,
      'info--text': props.info,
      'warning--text': props.warning,
      'error--text': props.error,
      'theme--dark': props.dark,
      'theme--light': props.light
    };

    var iconClasses = Object.keys(classes).filter(function (k) {
      return classes[k];
    }).join(' ');
    iconClasses && (data.staticClass += ' ' + iconClasses);

    // To keep things backwards compatible for now
    if (props.fa || props.mdi) {
      var comparison = props.fa ? 'fa' : 'mdi';

      if (iconName.indexOf(' ') > -1) data.staticClass += ' ' + comparison + '-' + iconName;else data.staticClass += ' ' + comparison + '-' + iconName.split(' ').join('-');
    }

    if (thirdPartyIcon) data.staticClass += ' ' + iconName;
    if (props.disabled) data.attrs.disabled = props.disabled;
    !(thirdPartyIcon || props.fa || props.mdi) && children.push(iconName);

    return h('i', data, children);
  }
});

/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__badge__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__click_outside__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__resize__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ripple__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__scroll__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__tooltip__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__touch__ = __webpack_require__(81);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Badge", function() { return __WEBPACK_IMPORTED_MODULE_0__badge__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ClickOutside", function() { return __WEBPACK_IMPORTED_MODULE_1__click_outside__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Ripple", function() { return __WEBPACK_IMPORTED_MODULE_3__ripple__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Resize", function() { return __WEBPACK_IMPORTED_MODULE_2__resize__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Scroll", function() { return __WEBPACK_IMPORTED_MODULE_4__scroll__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Tooltip", function() { return __WEBPACK_IMPORTED_MODULE_5__tooltip__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Touch", function() { return __WEBPACK_IMPORTED_MODULE_6__touch__["a"]; });










/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_positionable__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_route_link__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_themeable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_toggleable__ = __webpack_require__(2);






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-btn',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_route_link__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_positionable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_themeable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_toggleable__["a" /* default */]],

  props: {
    activeClass: {
      type: String,
      default: 'btn--active'
    },
    block: Boolean,
    fab: Boolean,
    flat: Boolean,
    icon: Boolean,
    large: Boolean,
    loading: Boolean,
    outline: Boolean,
    ripple: {
      type: [Boolean, Object],
      default: true
    },
    round: Boolean,
    small: Boolean,
    tag: {
      type: String,
      default: 'button'
    },
    type: {
      type: String,
      default: 'button'
    }
  },

  computed: {
    classes: function classes() {
      return {
        'btn': true,
        'btn--absolute': this.absolute,
        'btn--active': this.isActive,
        'btn--block': this.block,
        'btn--bottom': this.bottom,
        'btn--disabled': this.disabled,
        'btn--flat': this.flat,
        'btn--floating': this.fab,
        'btn--fixed': this.fixed,
        'btn--hover': this.hover,
        'btn--icon': this.icon,
        'btn--large': this.large,
        'btn--left': this.left,
        'btn--loader': this.loading,
        'btn--outline': this.outline,
        'btn--raised': !this.flat,
        'btn--right': this.right,
        'btn--round': this.round,
        'btn--small': this.small,
        'btn--top': this.top,
        'theme--dark': this.dark,
        'theme--light': this.light,
        'primary': this.primary && !this.outline,
        'secondary': this.secondary && !this.outline,
        'success': this.success && !this.outline,
        'info': this.info && !this.outline,
        'warning': this.warning && !this.outline,
        'error': this.error && !this.outline,
        'primary--text': this.primary && (this.outline || this.flat),
        'secondary--text': this.secondary && (this.outline || this.flat),
        'success--text': this.success && (this.outline || this.flat),
        'info--text': this.info && (this.outline || this.flat),
        'warning--text': this.warning && (this.outline || this.flat),
        'error--text': this.error && (this.outline || this.flat)
      };
    }
  },

  methods: {
    // Prevent focus to match md spec
    click: function click(e) {
      !this.fab && e.detail && this.$el.blur();

      this.$emit('click', e);
    },
    genContent: function genContent() {
      return this.$createElement('div', { 'class': 'btn__content' }, [this.$slots.default]);
    },
    genLoader: function genLoader() {
      var children = [];

      if (!this.$slots.loader) {
        children.push(this.$createElement('v-progress-circular', {
          props: {
            indeterminate: true,
            size: 26
          }
        }));
      } else {
        children.push(this.$slots.loader);
      }

      return this.$createElement('span', { 'class': 'btn__loading' }, children);
    }
  },

  render: function render(h) {
    var _generateRouteLink = this.generateRouteLink(),
        tag = _generateRouteLink.tag,
        data = _generateRouteLink.data;

    var children = [this.genContent()];

    tag === 'button' && (data.attrs.type = this.type);
    this.loading && children.push(this.genLoader());

    return h(tag, data, children);
  }
});

/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export VCarouselTransition */
/* unused harmony export VCarouselReverseTransition */
/* unused harmony export VTabTransition */
/* unused harmony export VTabReverseTransition */
/* unused harmony export VMenuTransition */
/* unused harmony export VFabTransition */
/* unused harmony export VDialogTransition */
/* unused harmony export VDialogBottomTransition */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return VFadeTransition; });
/* unused harmony export VScaleTransition */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return VSlideXTransition; });
/* unused harmony export VSlideXReverseTransition */
/* unused harmony export VSlideYTransition */
/* unused harmony export VSlideYReverseTransition */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return VExpandTransition; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__expand_transition__ = __webpack_require__(71);




// Component specific transitions
var VCarouselTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('carousel-transition');
var VCarouselReverseTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('carousel-reverse-transition');
var VTabTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('tab-transition');
var VTabReverseTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('tab-reverse-transition');
var VMenuTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('menu-transition');
var VFabTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('fab-transition', 'center center', 'out-in');

// Generic transitions
var VDialogTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('dialog-transition');
var VDialogBottomTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('dialog-bottom-transition');
var VFadeTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('fade-transition');
var VScaleTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('scale-transition');
var VSlideXTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('slide-x-transition');
var VSlideXReverseTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('slide-x-reverse-transition');
var VSlideYTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('slide-y-transition');
var VSlideYReverseTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('slide-y-reverse-transition');

// JavaScript transitions
var VExpandTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["b" /* createJavaScriptTransition */])('expand-transition', __WEBPACK_IMPORTED_MODULE_1__expand_transition__["a" /* default */]);

/* harmony default export */ __webpack_exports__["d"] = ({
  VCarouselTransition: VCarouselTransition,
  VCarouselReverseTransition: VCarouselReverseTransition,
  VDialogTransition: VDialogTransition,
  VDialogBottomTransition: VDialogBottomTransition,
  VFabTransition: VFabTransition,
  VFadeTransition: VFadeTransition,
  VMenuTransition: VMenuTransition,
  VScaleTransition: VScaleTransition,
  VSlideXTransition: VSlideXTransition,
  VSlideXReverseTransition: VSlideXReverseTransition,
  VSlideYTransition: VSlideYTransition,
  VSlideYReverseTransition: VSlideYReverseTransition,
  VTabReverseTransition: VTabReverseTransition,
  VTabTransition: VTabTransition,
  VExpandTransition: VExpandTransition
});

/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__themeable__ = __webpack_require__(1);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0__themeable__["a" /* default */]],

  data: function data() {
    return {
      errorBucket: [],
      focused: false,
      tabFocused: false,
      lazyValue: this.value
    };
  },


  props: {
    appendIcon: String,
    appendIconCb: Function,
    disabled: Boolean,
    error: Boolean,
    errorMessages: {
      type: [String, Array],
      default: function _default() {
        return [];
      }
    },
    hint: String,
    hideDetails: Boolean,
    label: String,
    persistentHint: Boolean,
    placeholder: String,
    prependIcon: String,
    prependIconCb: Function,
    required: Boolean,
    rules: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    tabindex: {
      default: 0
    },
    value: {
      required: false
    }
  },

  computed: {
    hasError: function hasError() {
      return this.validations.length || this.error;
    },
    inputGroupClasses: function inputGroupClasses() {
      return Object.assign({
        'input-group': true,
        'input-group--focused': this.focused,
        'input-group--dirty': this.isDirty,
        'input-group--tab-focused': this.tabFocused,
        'input-group--disabled': this.disabled,
        'input-group--error': this.hasError,
        'input-group--append-icon': this.appendIcon,
        'input-group--prepend-icon': this.prependIcon,
        'input-group--required': this.required,
        'input-group--hide-details': this.hideDetails,
        'input-group--placeholder': !!this.placeholder,
        'theme--dark': this.dark,
        'theme--light': this.light
      }, this.classes);
    },
    isDirty: function isDirty() {
      return this.inputValue;
    },
    modifiers: function modifiers() {
      var modifiers = {
        lazy: false,
        number: false,
        trim: false
      };

      if (!this.$vnode.data.directives) {
        return modifiers;
      }

      var model = this.$vnode.data.directives.find(function (i) {
        return i.name === 'model';
      });

      if (!model) {
        return modifiers;
      }

      return Object.assign(modifiers, model.modifiers);
    },
    validations: function validations() {
      return (!Array.isArray(this.errorMessages) ? [this.errorMessages] : this.errorMessages).concat(this.errorBucket);
    }
  },

  watch: {
    rules: function rules() {
      this.validate();
    }
  },

  mounted: function mounted() {
    this.validate();
  },


  methods: {
    genLabel: function genLabel() {
      return this.$createElement('label', {
        attrs: {
          for: this.$attrs.id
        }
      }, this.$slots.label || this.label);
    },
    genMessages: function genMessages() {
      var _this = this;

      var messages = [];

      if ((this.hint && this.focused || this.hint && this.persistentHint) && this.validations.length === 0) {
        messages = [this.genHint()];
      } else if (this.validations.length) {
        messages = this.validations.map(function (i) {
          return _this.genError(i);
        });
      }

      return this.$createElement('transition-group', {
        'class': 'input-group__messages',
        props: {
          tag: 'div',
          name: 'slide-y-transition'
        }
      }, messages);
    },
    genHint: function genHint() {
      return this.$createElement('div', {
        'class': 'input-group__hint',
        key: this.hint,
        domProps: { innerHTML: this.hint }
      });
    },
    genError: function genError(error) {
      return this.$createElement('div', {
        'class': 'input-group__error',
        key: error
      }, error);
    },
    genIcon: function genIcon(type) {
      var _class;

      var icon = this[type + 'Icon'];
      var cb = this[type + 'IconCb'];
      var hasCallback = typeof cb === 'function';

      return this.$createElement('v-icon', {
        'class': (_class = {}, _defineProperty(_class, 'input-group__' + type + '-icon', true), _defineProperty(_class, 'input-group__icon-cb', hasCallback), _class),
        on: {
          click: function click(e) {
            hasCallback && cb(e);
          }
        }
      }, icon);
    },
    genInputGroup: function genInputGroup(input) {
      var _this2 = this;

      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var children = [];
      var wrapperChildren = [];
      var detailsChildren = [];

      data = Object.assign({}, {
        'class': this.inputGroupClasses,
        attrs: {
          tabindex: this.tabindex
        },
        on: {
          blur: function blur() {
            return _this2.tabFocused = false;
          },
          click: function click() {
            return _this2.tabFocused = false;
          },
          keyup: function keyup(e) {
            if ([9, 16].includes(e.keyCode)) {
              _this2.tabFocused = true;
            }
          },
          keydown: function keydown(e) {
            if (!_this2.toggle) return;

            if ([13, 32].includes(e.keyCode)) {
              e.preventDefault();
              _this2.toggle();
            }
          }
        }
      }, data);

      if (this.$slots.label || this.label) {
        children.push(this.genLabel());
      }

      wrapperChildren.push(input);

      if (this.prependIcon) {
        wrapperChildren.unshift(this.genIcon('prepend'));
      }

      if (this.appendIcon) {
        wrapperChildren.push(this.genIcon('append'));
      }

      children.push(this.$createElement('div', {
        'class': 'input-group__input'
      }, wrapperChildren));

      detailsChildren.push(this.genMessages());
      this.counter && detailsChildren.push(this.genCounter());

      children.push(this.$createElement('div', {
        'class': 'input-group__details'
      }, detailsChildren));

      return this.$createElement('div', data, children);
    },
    validate: function validate() {
      var _this3 = this;

      this.errorBucket = [];

      this.rules.forEach(function (rule) {
        var valid = typeof rule === 'function' ? rule(_this3.value) : rule;

        if (valid !== true) {
          _this3.errorBucket.push(valid);
        }
      });
    }
  }
});

/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    primary: Boolean,
    secondary: Boolean,
    success: Boolean,
    info: Boolean,
    warning: Boolean,
    error: Boolean
  }
});

/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    append: Boolean,
    disabled: Boolean,
    exact: Boolean,
    href: [String, Object],
    to: [String, Object],
    nuxt: Boolean,
    replace: Boolean,
    router: Boolean,
    ripple: {
      type: Boolean,
      default: true
    },
    tag: String
  },

  methods: {
    click: function click() {},
    generateRouteLink: function generateRouteLink() {
      var exact = this.exact;
      var tag = void 0;

      var data = {
        attrs: { disabled: this.disabled },
        class: this.classes,
        props: {},
        directives: [{
          name: 'ripple',
          value: this.ripple || false
        }],
        on: Object.assign({
          click: this.click
        }, this.$listeners || {})
      };

      if (typeof this.exact === 'undefined') {
        exact = this.to === '/' || this.to === Object(this.to) && this.to.path === '/';
      }

      if (this.to) {
        tag = this.nuxt ? 'nuxt-link' : 'router-link';
        data.props.to = this.to;
        data.props.exact = exact;
        data.props.activeClass = this.activeClass;
        data.props.append = this.append;
        data.props.replace = this.replace;
      } else {
        tag = this.href && 'a' || this.tag || 'a';

        if (tag === 'a') {
          data.attrs.href = this.href || 'javascript:;';
        }
      }

      return { tag: tag, data: data };
    }
  }
});

/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      isBooted: false
    };
  },


  watch: {
    isActive: function isActive() {
      this.isBooted = true;
    }
  },

  methods: {
    showLazyContent: function showLazyContent(content) {
      return this.lazy && this.isBooted || !this.lazy ? content : null;
    }
  }
});

/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export VListTileActionText */
/* unused harmony export VListTileAvatar */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return VListTileContent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return VListTileTitle; });
/* unused harmony export VListTileSubTitle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VList__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VListGroup__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VListTile__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__VListTileAction__ = __webpack_require__(21);







var VListTileActionText = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('list__tile__action-text', 'span');
var VListTileAvatar = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('list__tile__avatar', 'v-avatar');
var VListTileContent = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('list__tile__content', 'div');
var VListTileTitle = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('list__tile__title', 'div');
var VListTileSubTitle = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('list__tile__sub-title', 'div');

/* harmony default export */ __webpack_exports__["c"] = ({
  VList: __WEBPACK_IMPORTED_MODULE_1__VList__["a" /* default */],
  VListTile: __WEBPACK_IMPORTED_MODULE_3__VListTile__["a" /* default */],
  VListGroup: __WEBPACK_IMPORTED_MODULE_2__VListGroup__["a" /* default */],
  VListTileAction: __WEBPACK_IMPORTED_MODULE_4__VListTileAction__["a" /* default */],
  VListTileActionText: VListTileActionText,
  VListTileAvatar: VListTileAvatar,
  VListTileContent: VListTileContent,
  VListTileTitle: VListTileTitle,
  VListTileSubTitle: VListTileSubTitle
});

/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    absolute: Boolean,
    bottom: Boolean,
    fixed: Boolean,
    left: Boolean,
    right: Boolean,
    top: Boolean
  }
});

/***/ }),
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  props: {
    flat: Boolean,
    height: {
      type: String,
      default: 'auto'
    },
    hover: Boolean,
    img: String,
    raised: Boolean,
    tile: Boolean
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        props = _ref.props,
        children = _ref.children;

    data.staticClass = ('card ' + (data.staticClass || '')).trim();
    data.style = data.style || {};
    data.style.height = props.height;

    if (props.dark) data.staticClass += ' theme--dark';
    if (props.flat) data.staticClass += ' card--flat';
    if (props.horizontal) data.staticClass += ' card--horizontal';
    if (props.hover) data.staticClass += ' card--hover';
    if (props.light) data.staticClass += ' theme--light';
    if (props.raised) data.staticClass += ' card--raised';
    if (props.tile) data.staticClass += ' card--tile';

    if (props.img) {
      data.style.background = 'url(' + props.img + ') center center / cover no-repeat';
    }

    return h('div', data, children);
  }
});

/***/ }),
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      isSaving: false
    };
  },


  props: {
    actions: Boolean,
    autosave: Boolean,
    landscape: Boolean,
    noTitle: Boolean,
    scrollable: Boolean,
    value: {
      required: true
    },
    light: {
      type: Boolean,
      default: true
    },
    dark: Boolean
  },

  methods: {
    save: function save() {},
    cancel: function cancel() {},
    genSlot: function genSlot() {
      return this.$scopedSlots.default({
        save: this.save,
        cancel: this.cancel
      });
    }
  }
});

/***/ }),
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    contentClass: {
      default: ''
    }
  },

  mounted: function mounted() {
    var _this = this;

    this.$vuetify.load(function () {
      if (_this._isDestroyed) return;

      var app = document.querySelector('[data-app]');

      if (!app) {
        return console.warn('Application is missing <v-app> component.');
      }

      app.insertBefore(_this.$refs.content, app.firstChild);
    });
  },
  beforeDestroy: function beforeDestroy() {
    if (!this.$refs.content) return;

    // IE11 Fix
    try {
      this.$refs.content.parentNode.removeChild(this.$refs.content);
    } catch (e) {}
  }
});

/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      overlay: null,
      overlayOffset: 0,
      overlayTransitionDuration: 500
    };
  },


  props: {
    hideOverlay: Boolean
  },

  beforeDestroy: function beforeDestroy() {
    this.removeOverlay();
  },


  methods: {
    genOverlay: function genOverlay() {
      var _this = this;

      if (!this.isActive || this.hideOverlay || this.isActive && this.overlay) return;

      this.overlay = document.createElement('div');
      this.overlay.className = 'overlay';
      this.overlay.onclick = function () {
        if (_this.permanent) return;else if (!_this.persistent) _this.isActive = false;else if (_this.isMobile) _this.isActive = false;
      };

      if (this.absolute) this.overlay.className += ' overlay--absolute';

      this.hideScroll();

      if (this.absolute) {
        // Required for IE11
        var parent = this.$el.parentNode;
        parent.insertBefore(this.overlay, parent.firstChild);
      } else {
        document.querySelector('[data-app]').appendChild(this.overlay);
      }

      this.overlay.clientHeight; // Force repaint
      requestAnimationFrame(function () {
        _this.overlay.className += ' overlay--active';
      });

      return true;
    },
    removeOverlay: function removeOverlay() {
      var _this2 = this;

      if (!this.overlay) {
        return this.showScroll();
      }

      this.overlay.classList.remove('overlay--active');

      setTimeout(function () {
        // IE11 Fix
        try {
          _this2.overlay.parentNode.removeChild(_this2.overlay);
          _this2.overlay = null;
          _this2.showScroll();
        } catch (e) {}
      }, this.overlayTransitionDuration);
    },
    hideScroll: function hideScroll() {
      // Check documentElement first for IE11
      // this.overlayOffset = document.documentElement &&
      //   document.documentElement.scrollTop ||
      //   document.body.scrollTop

      // document.body.style.top = `-${this.overlayOffset}px`
      // document.body.style.position = 'fixed'
      document.documentElement.style.overflow = 'hidden';
    },
    showScroll: function showScroll() {
      document.documentElement.removeAttribute('style');

      // if (!this.overlayOffset) return
      // document.body.scrollTop = this.overlayOffset
      // document.documentElement.scrollTop = this.overlayOffset
    }
  }
});

/***/ }),
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-list',

  provide: function provide() {
    return {
      listClick: this.listClick,
      listClose: this.listClose
    };
  },


  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  data: function data() {
    return {
      uid: null,
      groups: []
    };
  },


  props: {
    dense: Boolean,
    subheader: Boolean,
    threeLine: Boolean,
    twoLine: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'list': true,
        'list--two-line': this.twoLine,
        'list--dense': this.dense,
        'list--three-line': this.threeLine,
        'list--subheader': this.subheader,
        'theme--dark dark--bg': this.dark,
        'theme--light light--bg': this.light
      };
    }
  },

  watch: {
    uid: function uid() {
      var _this = this;

      this.$children.filter(function (i) {
        return i.$options._componentTag === 'v-list-group';
      }).forEach(function (i) {
        return i.toggle(_this.uid);
      });
    }
  },

  methods: {
    listClick: function listClick(uid, force) {
      if (force) {
        this.uid = uid;
      } else {
        this.uid = this.uid === uid ? null : uid;
      }
    },
    listClose: function listClose(uid) {
      if (this.uid === uid) {
        this.uid = null;
      }
    }
  },

  render: function render(h) {
    var data = {
      'class': this.classes,
      attrs: { 'data-uid': this._uid }
    };

    return h('ul', data, [this.$slots.default]);
  }
});

/***/ }),
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_route_link__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__directives__ = __webpack_require__(4);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-list-tile',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_route_link__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__["a" /* default */]],

  directives: {
    Ripple: __WEBPACK_IMPORTED_MODULE_2__directives__["Ripple"]
  },

  inheritAttrs: false,

  props: {
    activeClass: {
      type: String,
      default: 'list__tile--active'
    },
    avatar: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'list__tile': true,
        'list__tile--avatar': this.avatar,
        'list__tile--disabled': this.disabled
      };
    }
  },

  render: function render(h) {
    var _generateRouteLink = this.generateRouteLink(),
        tag = _generateRouteLink.tag,
        data = _generateRouteLink.data;

    data.attrs = Object.assign({}, data.attrs, this.$attrs);

    return h('li', {
      attrs: {
        disabled: this.disabled
      }
    }, [h(tag, data, [this.$slots.default])]);
  }
});

/***/ }),
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function directive(e, el, binding, v) {
  var cb = function cb() {
    return true;
  };

  if (binding.value) cb = binding.value;

  if (v.context.isActive && e && e.target && e.target !== el && !el.contains(e.target) && cb(e)) {
    v.context.isActive = false;
  }
}

/* harmony default export */ __webpack_exports__["a"] = ({
  bind: function bind(el, binding, v) {
    v.context.$vuetify.load(function () {
      var outside = document.querySelector('[data-app]');
      var click = function click(e) {
        return directive(e, el, binding, v);
      };
      outside.addEventListener('click', click, false);
      el._clickOutside = click;
    });
  },
  unbind: function unbind(el) {
    var outside = document.querySelector('[data-app]');
    outside && outside.removeEventListener('click', el._clickOutside, false);
  }
});

/***/ }),
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function style(el, value) {
  ['transform', 'webkitTransform'].forEach(function (i) {
    el.style[i] = value;
  });
}

var ripple = {
  show: function show(e, el, _ref) {
    var _ref$value = _ref.value,
        value = _ref$value === undefined ? {} : _ref$value;

    var container = document.createElement('span');
    var animation = document.createElement('span');

    container.appendChild(animation);
    container.className = 'ripple__container';

    if (value.class) {
      container.className += ' ' + value.class;
    }

    var size = el.clientWidth > el.clientHeight ? el.clientWidth : el.clientHeight;
    animation.className = 'ripple__animation';
    animation.style.width = size * (value.center ? 1 : 2) + 'px';
    animation.style.height = animation.style.width;

    el.appendChild(container);
    var computed = window.getComputedStyle(el);
    if (computed.position !== 'absolute' && computed.position !== 'fixed') el.style.position = 'relative';

    var offset = el.getBoundingClientRect();
    var x = value.center ? '50%' : e.clientX - offset.left + 'px';
    var y = value.center ? '50%' : e.clientY - offset.top + 'px';

    animation.classList.add('ripple__animation--enter');
    animation.classList.add('ripple__animation--visible');
    style(animation, 'translate(-50%, -50%) translate(' + x + ', ' + y + ') scale3d(0.01,0.01,0.01)');
    animation.dataset.activated = Date.now();

    setTimeout(function () {
      animation.classList.remove('ripple__animation--enter');
      style(animation, 'translate(-50%, -50%) translate(' + x + ', ' + y + ')  scale3d(0.99,0.99,0.99)');
    }, 0);
  },

  hide: function hide(el) {
    var ripples = el.getElementsByClassName('ripple__animation');

    if (ripples.length === 0) return;
    var animation = ripples[ripples.length - 1];
    var diff = Date.now() - Number(animation.dataset.activated);
    var delay = 400 - diff;

    delay = delay < 0 ? 0 : delay;

    setTimeout(function () {
      animation.classList.remove('ripple__animation--visible');

      setTimeout(function () {
        // Need to figure out a new way to do this
        try {
          if (ripples.length < 1) el.style.position = null;
          animation.parentNode && el.removeChild(animation.parentNode);
        } catch (e) {}
      }, 300);
    }, delay);
  }
};

function directive(el, binding, v) {
  if (binding.value === false) return;

  if ('ontouchstart' in window) {
    el.addEventListener('touchend', function () {
      return ripple.hide(el);
    }, false);
    el.addEventListener('touchcancel', function () {
      return ripple.hide(el);
    }, false);
  }

  el.addEventListener('mousedown', function (e) {
    return ripple.show(e, el, binding);
  }, false);
  el.addEventListener('mouseup', function () {
    return ripple.hide(el);
  }, false);
  el.addEventListener('mouseleave', function () {
    return ripple.hide(el);
  }, false);
}

function unbind(el, binding) {
  el.removeEventListener('touchstart', function (e) {
    return ripple.show(e, el, binding);
  }, false);
  el.removeEventListener('mousedown', function (e) {
    return ripple.show(e, el, binding);
  }, false);
  el.removeEventListener('touchend', function () {
    return ripple.hide(el);
  }, false);
  el.removeEventListener('touchcancel', function () {
    return ripple.hide(el);
  }, false);
  el.removeEventListener('mouseup', function () {
    return ripple.hide(el);
  }, false);
  el.removeEventListener('mouseleave', function () {
    return ripple.hide(el);
  }, false);
}

/* harmony default export */ __webpack_exports__["a"] = ({
  bind: directive,
  unbind: unbind
});

/***/ }),
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  name: 'list-tile-action',

  render: function render(h, _ref) {
    var data = _ref.data,
        children = _ref.children;

    data.staticClass = data.staticClass ? 'list__tile__action ' + (data.staticClass || '') : 'list__tile__action';
    if ((children || []).length > 1) data.staticClass += ' list__tile__action--stack';

    return h('div', data, children);
  }
});

/***/ }),
/* 22 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_activator__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_detachable__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_generators__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_position__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_utils__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_toggleable__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_keyable__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__directives__ = __webpack_require__(4);










/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-menu',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_activator__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_detachable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_generators__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__mixins_keyable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_position__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_utils__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__mixins_toggleable__["a" /* default */]],

  directives: {
    ClickOutside: __WEBPACK_IMPORTED_MODULE_7__directives__["ClickOutside"]
  },

  data: function data() {
    return {
      autoIndex: null,
      dimensions: {
        activator: {
          top: 0, left: 0,
          bottom: 0, right: 0,
          width: 0, height: 0,
          offsetTop: 0, scrollHeight: 0
        },
        content: {
          top: 0, left: 0,
          bottom: 0, right: 0,
          width: 0, height: 0,
          offsetTop: 0, scrollHeight: 0
        },
        list: null,
        selected: null
      },
      direction: { vert: 'bottom', horiz: 'right' },
      isContentActive: false,
      isBooted: false,
      maxHeightAutoDefault: '200px',
      resizeTimeout: {},
      startIndex: 3,
      stopIndex: 0,
      tileLength: 0,
      window: {},
      absoluteX: 0,
      absoluteY: 0,
      hasJustFocused: false,
      focusedTimeout: {}
    };
  },


  props: {
    top: Boolean,
    left: Boolean,
    bottom: Boolean,
    right: Boolean,
    fullWidth: Boolean,
    auto: Boolean,
    offsetX: Boolean,
    offsetY: Boolean,
    disabled: Boolean,
    maxHeight: {
      default: 'auto'
    },
    nudgeTop: {
      type: Number,
      default: 0
    },
    nudgeBottom: {
      type: Number,
      default: 0
    },
    nudgeLeft: {
      type: Number,
      default: 0
    },
    nudgeRight: {
      type: Number,
      default: 0
    },
    nudgeWidth: {
      type: Number,
      default: 0
    },
    openOnClick: {
      type: Boolean,
      default: true
    },
    openOnHover: {
      type: Boolean,
      default: false
    },
    lazy: Boolean,
    closeOnClick: {
      type: Boolean,
      default: true
    },
    closeOnContentClick: {
      type: Boolean,
      default: true
    },
    activator: {
      default: null
    },
    origin: {
      type: String,
      default: 'top left'
    },
    transition: {
      type: String,
      default: 'menu-transition'
    },
    positionX: {
      type: Number,
      default: null
    },
    positionY: {
      type: Number,
      default: null
    },
    positionAbsolutely: {
      type: Boolean,
      default: false
    },
    maxWidth: [Number, String],
    minWidth: [Number, String]
  },

  computed: {
    calculatedMinWidth: function calculatedMinWidth() {
      var minWidth = parseInt(this.minWidth) || this.dimensions.activator.width + this.nudgeWidth + (this.auto ? 16 : 0);

      if (!this.maxWidth) return minWidth;

      var maxWidth = parseInt(this.maxWidth);

      return maxWidth < minWidth ? maxWidth : minWidth;
    },
    styles: function styles() {
      return {
        maxHeight: this.auto ? '200px' : isNaN(this.maxHeight) ? this.maxHeight : this.maxHeight + 'px',
        minWidth: this.calculatedMinWidth + 'px',
        maxWidth: parseInt(this.maxWidth) + 'px',
        top: this.calcTop() + 'px',
        left: this.calcLeft() + 'px'
      };
    },
    hasActivator: function hasActivator() {
      return !!this.$slots.activator || this.activator;
    }
  },

  watch: {
    activator: function activator(newActivator, oldActivator) {
      this.removeActivatorEvents(oldActivator);
      this.addActivatorEvents(newActivator);
    },
    disabled: function disabled(val) {
      val && this.deactivate();
    },
    hasJustFocused: function hasJustFocused(val) {
      var _this = this;

      if (!val) return;

      clearTimeout(this.focusedTimeout);
      this.focusedTimeout = setTimeout(function () {
        return _this.hasJustFocused = false;
      }, 550);
    },
    isActive: function isActive(val) {
      if (this.disabled) return;

      val && this.activate() || this.deactivate();
    },
    windowResizeHandler: function windowResizeHandler() {
      this.isBooted = false;
    }
  },

  mounted: function mounted() {
    window.addEventListener('resize', this.onResize, { passive: true });
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.onResize, { passive: true });
    window.removeEventListener('resize', this.windowResizeHandler);
  },


  methods: {
    activate: function activate() {
      if (typeof window === 'undefined') return;
      this.isBooted = true;
      this.getTiles();
      this.updateDimensions();
      requestAnimationFrame(this.startTransition);
      this.$emit('activate');
    },
    deactivate: function deactivate() {
      this.isContentActive = false;
      this.$emit('deactivate');
    },
    onResize: function onResize() {
      clearTimeout(this.resizeTimeout);
      if (!this.isActive) return;
      this.resizeTimeout = setTimeout(this.updateDimensions, 200);
    },
    startTransition: function startTransition() {
      var _this2 = this;

      requestAnimationFrame(function () {
        return _this2.isContentActive = true;
      });
      requestAnimationFrame(this.calculateScroll);
    }
  },

  render: function render(h) {
    var _this3 = this;

    var data = {
      'class': 'menu',
      style: {
        display: this.fullWidth ? 'block' : 'inline-block'
      },
      directives: [{
        name: 'click-outside',
        value: function value() {
          return _this3.closeOnClick;
        }
      }],
      on: {
        keydown: function keydown(e) {
          if (e.keyCode === 27) _this3.isActive = false;else _this3.changeListIndex(e);
        }
      }
    };

    return h('div', data, [this.genActivator(), this.genTransition()]);
  }
});

/***/ }),
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_transitions__ = __webpack_require__(6);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-progress-linear',

  components: {
    VFadeTransition: __WEBPACK_IMPORTED_MODULE_0__components_transitions__["b" /* VFadeTransition */],
    VSlideXTransition: __WEBPACK_IMPORTED_MODULE_0__components_transitions__["c" /* VSlideXTransition */]
  },

  props: {
    active: {
      type: Boolean,
      default: true
    },
    buffer: Boolean,
    bufferValue: Number,
    error: Boolean,
    height: {
      type: [Number, String],
      default: 7
    },
    indeterminate: Boolean,
    info: Boolean,
    secondary: Boolean,
    success: Boolean,
    query: Boolean,
    warning: Boolean,
    value: {
      type: [Number, String],
      default: 0
    },
    colorFront: {
      type: String,
      default: null
    },
    colorBack: {
      type: String,
      default: null
    }
  },

  computed: {
    classes: function classes() {
      return {
        'progress-linear--query': this.query,
        'progress-linear--secondary': this.secondary,
        'progress-linear--success': this.success,
        'progress-linear--info': this.info,
        'progress-linear--warning': this.warning,
        'progress-linear--error': this.error
      };
    },
    styles: function styles() {
      var styles = {};

      if (!this.active) {
        styles.height = 0;
      }

      if (this.buffer) {
        styles.width = this.bufferValue + '%';
      }

      return styles;
    },
    bufferStyles: function bufferStyles() {
      var styles = {};

      if (!this.active) {
        styles.height = 0;
      }

      return styles;
    }
  },

  methods: {
    genDeterminate: function genDeterminate(h) {
      return h('div', {
        ref: 'front',
        class: ['progress-linear__bar__determinate', this.colorFront],
        style: { width: this.value + '%' }
      });
    },
    genBar: function genBar(h, name) {
      return h('div', {
        class: ['progress-linear__bar__indeterminate', name, this.colorFront]
      });
    },
    genIndeterminate: function genIndeterminate(h) {
      return h('div', {
        ref: 'front',
        class: {
          'progress-linear__bar__indeterminate': true,
          'progress-linear__bar__indeterminate--active': this.active
        }
      }, [this.genBar(h, 'long'), this.genBar(h, 'short')]);
    }
  },

  render: function render(h) {
    var fade = h('v-fade-transition', [this.indeterminate && this.genIndeterminate(h)]);
    var slide = h('v-slide-x-transition', [!this.indeterminate && this.genDeterminate(h)]);

    var bar = h('div', { class: ['progress-linear__bar', this.colorBack], style: this.styles }, [fade, slide]);

    return h('div', {
      class: ['progress-linear', this.classes],
      style: { height: this.height + 'px' },
      on: this.$listeners
    }, [bar]);
  }
});

/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_autocomplete__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_filterable__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_generators__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_input__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_cards_VCard__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_selection_controls_VCheckbox__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_icons_VIcon__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_lists_VList__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_lists_VListTile__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_lists_VListTileAction__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_lists__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_menus_VMenu__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__directives_click_outside__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__util_helpers__ = __webpack_require__(0);



















/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-select',

  components: {
    VCard: __WEBPACK_IMPORTED_MODULE_4__components_cards_VCard__["a" /* default */],
    VCheckbox: __WEBPACK_IMPORTED_MODULE_5__components_selection_controls_VCheckbox__["a" /* default */],
    VIcon: __WEBPACK_IMPORTED_MODULE_6__components_icons_VIcon__["a" /* default */],
    VList: __WEBPACK_IMPORTED_MODULE_7__components_lists_VList__["a" /* default */],
    VListTile: __WEBPACK_IMPORTED_MODULE_8__components_lists_VListTile__["a" /* default */],
    VListTileAction: __WEBPACK_IMPORTED_MODULE_9__components_lists_VListTileAction__["a" /* default */],
    VListTileContent: __WEBPACK_IMPORTED_MODULE_10__components_lists__["a" /* VListTileContent */],
    VListTileTitle: __WEBPACK_IMPORTED_MODULE_10__components_lists__["b" /* VListTileTitle */],
    VMenu: __WEBPACK_IMPORTED_MODULE_11__components_menus_VMenu__["a" /* default */]
  },

  directives: {
    clickOutside: __WEBPACK_IMPORTED_MODULE_12__directives_click_outside__["a" /* default */]
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_autocomplete__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_input__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_filterable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_generators__["a" /* default */]],

  data: function data() {
    return {
      content: {},
      hasFocused: false,
      inputValue: this.multiple && !this.value ? [] : this.value,
      isBooted: false,
      lastItem: 20,
      isActive: false,
      searchInputValue: this.searchInput
    };
  },


  props: {
    appendIcon: {
      type: String,
      default: 'arrow_drop_down'
    },
    auto: Boolean,
    autocomplete: Boolean,
    bottom: Boolean,
    chips: Boolean,
    close: Boolean,
    debounce: {
      type: Number,
      default: 200
    },
    items: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    filter: Function,
    itemText: {
      type: String,
      default: 'text'
    },
    itemValue: {
      type: String,
      default: 'value'
    },
    itemDisabled: {
      type: String,
      default: 'disabled'
    },
    maxHeight: {
      type: [Number, String],
      default: 300
    },
    minWidth: {
      type: [Boolean, Number, String],
      default: false
    },
    multiple: Boolean,
    multiLine: Boolean,
    offset: Boolean,
    searchInput: null,
    singleLine: Boolean,
    top: Boolean,
    returnObject: Boolean,
    overflow: Boolean,
    segmented: Boolean,
    editable: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'input-group--text-field input-group--select': true,
        'input-group--auto': this.auto,
        'input-group--overflow': this.overflow,
        'input-group--segmented': this.segmented,
        'input-group--editable': this.editable,
        'input-group--autocomplete': this.autocomplete,
        'input-group--single-line': this.singleLine || this.isDropdown,
        'input-group--multi-line': this.multiLine,
        'input-group--chips': this.chips,
        'input-group--multiple': this.multiple
      };
    },
    computedContentClass: function computedContentClass() {
      var children = [this.auto ? 'menu__content--auto' : '', this.isDropdown ? 'menu__content--dropdown' : ''];

      return children.join(' ');
    },
    filteredItems: function filteredItems() {
      var items = this.autocomplete && this.searchValue ? this.filterSearch() : this.items;

      return !this.auto ? items.slice(0, this.lastItem) : items;
    },
    hasError: function hasError() {
      return this.validations.length || this.error || this.hasFocused && !this.focused && !this.isDirty && this.required;
    },
    isDirty: function isDirty() {
      return this.selectedItems.length;
    },
    isDropdown: function isDropdown() {
      return this.segmented || this.overflow || this.editable;
    },

    searchValue: {
      get: function get() {
        return this.searchInput || this.searchInputValue;
      },
      set: function set(val) {
        this.searchInputValue = val;
        this.$emit('update:searchInput', val);
      }
    },
    selectedItems: function selectedItems() {
      var _this = this;

      if (this.inputValue === null || typeof this.inputValue === 'undefined') return [];

      return this.items.filter(function (i) {
        if (!_this.multiple) {
          return _this.getValue(i) === _this.getValue(_this.inputValue);
        } else {
          // Always return Boolean
          return _this.inputValue.find(function (j) {
            return _this.getValue(j) === _this.getValue(i);
          }) !== undefined;
        }
      });
    }
  },

  watch: {
    inputValue: function inputValue(val) {
      this.$emit('input', val);
    },
    value: function value(val) {
      this.inputValue = val;
      this.validate();
      if (this.autocomplete || this.editable) {
        this.$nextTick(this.$refs.menu.updateDimensions);
      }
    },
    isActive: function isActive(val) {
      this.isBooted = true;
      this.lastItem += !val ? 20 : 0;

      if (!val) this.blur();else this.focus();
    },
    isBooted: function isBooted() {
      var _this2 = this;

      this.$nextTick(function () {
        if (_this2.content) {
          _this2.content.addEventListener('scroll', _this2.onScroll, false);
        }
      });
    },
    searchValue: function searchValue() {
      this.$refs.menu.listIndex = -1;
    }
  },

  mounted: function mounted() {
    var _this3 = this;

    this.$vuetify.load(function () {
      if (_this3._isDestroyed) return;

      _this3.content = _this3.$refs.menu.$refs.content;
    });
  },
  beforeDestroy: function beforeDestroy() {
    if (this.isBooted) {
      if (this.content) {
        this.content.removeEventListener('scroll', this.onScroll, false);
      }
    }
  },


  methods: {
    blur: function blur() {
      var _this4 = this;

      this.$nextTick(function () {
        _this4.focused = false;
        _this4.hasFocused = true;
        _this4.searchValue = null;
        _this4.$el.blur();
      });
    },
    focus: function focus() {
      var _this5 = this;

      this.focused = true;
      this.$refs.input && (this.autocomplete || this.editable) && this.$refs.input.focus();

      if (this.editable && this.inputValue !== null && typeof this.inputValue !== 'undefined') {
        this.$nextTick(function () {
          _this5.$refs.input.value = _this5.getValue(_this5.inputValue);
        });
      }
    },
    genLabel: function genLabel() {
      if (this.searchValue && !this.focused && this.isDirty) return null;

      var data = {};

      if (this.id) data.attrs = { for: this.id };

      return this.$createElement('label', data, this.label);
    },
    getPropertyFromItem: function getPropertyFromItem(item, field) {
      if (item !== Object(item)) return item;

      var value = Object(__WEBPACK_IMPORTED_MODULE_13__util_helpers__["g" /* getObjectValueByPath */])(item, field);

      return typeof value === 'undefined' ? item : value;
    },
    getText: function getText(item) {
      return this.getPropertyFromItem(item, this.itemText);
    },
    getValue: function getValue(item) {
      return this.getPropertyFromItem(item, this.itemValue);
    },
    onScroll: function onScroll() {
      var _this6 = this;

      if (!this.isActive) {
        requestAnimationFrame(function () {
          return _this6.content.scrollTop = 0;
        });
      } else {
        var showMoreItems = this.content.scrollHeight - (this.content.scrollTop + this.content.clientHeight) < 200;

        if (showMoreItems) {
          this.lastItem += 20;
        }
      }
    },
    selectItem: function selectItem(item) {
      var _this7 = this;

      if (!this.multiple) {
        this.inputValue = this.returnObject ? item : this.getValue(item);
      } else {
        var inputValue = this.inputValue.slice();
        var i = this.inputValue.findIndex(function (i) {
          return _this7.getValue(i) === _this7.getValue(item);
        });

        i !== -1 && inputValue.splice(i, 1) || inputValue.push(item);
        this.inputValue = inputValue.map(function (i) {
          return _this7.returnObject ? i : _this7.getValue(i);
        });
      }

      if (this.autocomplete || this.editable) {
        this.$nextTick(function () {
          _this7.searchValue = null;
          _this7.$refs.input && _this7.$refs.input.focus();
        });
      }

      this.$emit('change', this.inputValue);
    }
  },

  render: function render(h) {
    var _this8 = this;

    return this.genInputGroup([this.genSelectionsAndSearch(), this.genMenu()], {
      ref: 'activator',
      directives: [{
        name: 'click-outside',
        value: function value() {
          return _this8.isActive = false;
        }
      }],
      on: {
        keydown: this.onKeyDown // Located in mixins/autocomplete.js
      }
    });
  }
});

/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    noDataText: {
      type: String,
      default: 'No data available'
    }
  }
});

/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_selectable__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__directives_ripple__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_transitions__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_icons_VIcon__ = __webpack_require__(3);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-checkbox',

  components: {
    VFadeTransition: __WEBPACK_IMPORTED_MODULE_2__components_transitions__["b" /* VFadeTransition */],
    VIcon: __WEBPACK_IMPORTED_MODULE_3__components_icons_VIcon__["a" /* default */]
  },

  directives: {
    Ripple: __WEBPACK_IMPORTED_MODULE_1__directives_ripple__["a" /* default */]
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_selectable__["a" /* default */]],

  data: function data() {
    return {
      inputIndeterminate: this.indeterminate
    };
  },


  props: {
    indeterminate: Boolean
  },

  computed: {
    classes: function classes() {
      return this.addColorClassChecks({
        'checkbox': true,
        'input-group--selection-controls': true,
        'input-group--active': this.isActive
      });
    },
    icon: function icon() {
      if (this.inputIndeterminate) {
        return 'indeterminate_check_box';
      } else if (this.isActive) {
        return 'check_box';
      } else {
        return 'check_box_outline_blank';
      }
    }
  },

  render: function render(h) {
    var transition = h('v-fade-transition', [h('v-icon', {
      'class': {
        'icon--checkbox': this.icon === 'check_box'
      },
      key: this.icon
    }, this.icon)]);

    var ripple = h('div', {
      'class': 'input-group--selection-controls__ripple',
      on: Object.assign({}, {
        click: this.toggle
      }, this.$listeners),
      directives: [{
        name: 'ripple',
        value: { center: true }
      }]
    });

    var data = {
      attrs: {
        role: 'checkbox',
        'aria-checked': this.inputIndeterminate && 'mixed' || this.isActive && 'true' || 'false',
        'aria-label': this.label
      }
    };

    return this.genInputGroup([transition, ripple], data);
  }
});

/***/ }),
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colorable__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__input__ = __webpack_require__(7);



/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_1__input__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0__colorable__["a" /* default */]],

  model: {
    prop: 'inputValue',
    event: 'change'
  },

  props: {
    inputValue: null,
    falseValue: null,
    trueValue: null
  },

  computed: {
    isActive: function isActive() {
      if (Array.isArray(this.inputValue)) {
        return this.inputValue.indexOf(this.value) !== -1;
      }

      if (!this.trueValue || !this.falseValue) {
        return this.value ? this.value === this.inputValue : Boolean(this.inputValue);
      }

      return this.inputValue === this.trueValue;
    }
  },

  watch: {
    indeterminate: function indeterminate(val) {
      this.inputIndeterminate = val;
    }
  },

  methods: {
    genLabel: function genLabel() {
      return this.$createElement('label', {
        on: { click: this.toggle },
        attrs: {
          for: this.$attrs.id
        }
      }, this.$slots.label || this.label);
    },
    toggle: function toggle() {
      if (this.disabled) {
        return;
      }

      var input = this.inputValue;
      if (Array.isArray(input)) {
        input = input.slice();
        var i = input.indexOf(this.value);

        if (i === -1) {
          input.push(this.value);
        } else {
          input.splice(i, 1);
        }
      } else if (this.trueValue || this.falseValue) {
        input = input === this.trueValue ? this.falseValue : this.trueValue;
      } else if (this.value) {
        input = this.value === this.inputValue ? null : this.value;
      } else {
        input = !input;
      }

      this.$emit('change', input);
    }
  }
});

/***/ }),
/* 28 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    color: String
  },
  methods: {
    addColorClassChecks: function addColorClassChecks(classes) {
      var parts = this.color ? this.color.trim().split(' ') : [''];
      var color = parts[0] + '--text';
      if (parts.length > 1) color += ' text--' + parts[1];
      classes[color] = !!this.color;
      return classes;
    }
  }
});

/***/ }),
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__package_json__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__package_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__package_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__directives__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_load__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_semver__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_semver___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_semver__);
__webpack_require__(30);







function plugin(Vue) {
  Object.keys(__WEBPACK_IMPORTED_MODULE_1__components__["a" /* default */]).forEach(function (key) {
    Vue.component(key, __WEBPACK_IMPORTED_MODULE_1__components__["a" /* default */][key]);
  });

  Object.keys(__WEBPACK_IMPORTED_MODULE_2__directives__).forEach(function (key) {
    Vue.directive(key, __WEBPACK_IMPORTED_MODULE_2__directives__[key]);
  });

  Vue.prototype.$vuetify = {
    load: __WEBPACK_IMPORTED_MODULE_3__util_load__["a" /* default */]
  };
}

function checkVueVersion() {
  var vueDep = __WEBPACK_IMPORTED_MODULE_0__package_json__["devDependencies"].vue;
  if (!__WEBPACK_IMPORTED_MODULE_4_semver___default.a.satisfies(window.Vue.version, vueDep)) {
    console.warn('Vuetify requires Vue version ' + vueDep);
  }
}

if (typeof window !== 'undefined' && window.Vue) {
  if (window.Vue.version) {
    checkVueVersion();
  }
  window.Vue.use(plugin);
}

/* harmony default export */ __webpack_exports__["default"] = (plugin);

/***/ }),
/* 30 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 31 */
/***/ (function(module, exports) {

module.exports = {
	"name": "vuetify",
	"version": "0.14.10",
	"author": {
		"name": "John Leider",
		"email": "john.j.leider@gmail.com"
	},
	"license": "MIT",
	"homepage": "http://vuetifyjs.com",
	"main": "dist/vuetify.js",
	"types": "index.d.ts",
	"scripts": {
		"watch": "cross-env TARGET=dev webpack --config build/config.js --progress --hide-modules --watch",
		"dev": "cross-env NODE_ENV=development webpack-dev-server --config build/webpack.dev.config.js --open --hot",
		"build": "rimraf dist && cross-env NODE_ENV=production node build/build.js --progress --hide-modules",
		"debug-build": "node --inspect --debug-brk build/build.js",
		"test": "cross-env NODE_ENV=test jest --no-cache --verbose",
		"test-coverage": "cross-env NODE_ENV=test jest --no-cache --coverage --verbose",
		"lint": "eslint --ext .js,.vue src"
	},
	"description": "Vue.js 2 Semantic Component Framework",
	"devDependencies": {
		"autoprefixer": "^6.6.0",
		"avoriaz": "^3.2.0",
		"babel-cli": "^6.24.1",
		"babel-core": "^6.24.1",
		"babel-eslint": "^7.1.1",
		"babel-jest": "^20.0.3",
		"babel-loader": "^7.1.1",
		"babel-plugin-add-filehash": "^6.9.4",
		"babel-plugin-module-resolver": "^2.7.1",
		"babel-plugin-transform-async-to-generator": "^6.24.1",
		"babel-plugin-transform-runtime": "^6.23.0",
		"babel-preset-env": "^1.5.1",
		"babel-preset-es2015": "^6.24.1",
		"babel-preset-stage-2": "^6.24.1",
		"chalk": "^1.1.3",
		"chromedriver": "^2.21.2",
		"cross-env": "^3.1.3",
		"cross-spawn": "^4.0.2",
		"css-loader": "^0.23.1",
		"css-mqpacker": "^6.0.1",
		"cssnano": "^3.10.0",
		"eslint": "^3.7.1",
		"eslint-config-standard": "^6.1.0",
		"eslint-config-vue": "^2.0.2",
		"eslint-friendly-formatter": "^2.0.5",
		"eslint-loader": "^1.6.1",
		"eslint-plugin-html": "^1.3.0",
		"eslint-plugin-promise": "^3.4.0",
		"eslint-plugin-pug": "^1.0.0",
		"eslint-plugin-standard": "^3.0.1",
		"eslint-plugin-vue": "^2.1.0",
		"eventsource-polyfill": "^0.9.6",
		"extract-text-webpack-plugin": "^3.0.0",
		"friendly-errors-webpack-plugin": "^1.6.1",
		"function-bind": "^1.0.2",
		"jest": "^20.0.4",
		"jest-cli": "^20.0.4",
		"jest-css-modules": "^1.1.0",
		"jest-serializer-html": "^4.0.0",
		"jest-vue-preprocessor": "^0.2.0",
		"lolex": "^1.4.0",
		"nightwatch": "^0.9.8",
		"opn": "^4.0.2",
		"optimize-css-assets-webpack-plugin": "^2.0.0",
		"optimize-js-plugin": "^0.0.4",
		"ora": "^0.3.0",
		"phantomjs-prebuilt": "^2.1.3",
		"postcss-loader": "^1.2.1",
		"precss": "^1.4.0",
		"pug": "^2.0.0-beta3",
		"pug-loader": "^2.3.0",
		"ress": "^1.1.1",
		"rimraf": "^2.5.4",
		"selenium-server": "2.53.1",
		"semver": "^5.3.0",
		"serialize-javascript": "^1.3.0",
		"shelljs": "^0.7.4",
		"style-loader": "^0.13.1",
		"stylus": "^0.54.5",
		"stylus-loader": "^2.1.1",
		"uglifyjs-webpack-plugin": "^0.4.6",
		"vue": "^2.4.1",
		"vue-loader": "^10.1.0",
		"vue-router": "^2.7.0",
		"vue-server-renderer": "^2.4.1",
		"vue-template-compiler": "^2.4.1",
		"webpack": "^3.2.0",
		"webpack-bundle-size-analyzer": "^2.7.0",
		"webpack-dev-server": "^2.6.1",
		"webpack-merge": "^4.1.0"
	},
	"dependencies": {},
	"engines": {
		"node": ">= 4.0.0",
		"npm": ">= 3.0.0"
	},
	"jest": {
		"verbose": false,
		"roots": [
			"<rootDir>/src"
		],
		"moduleFileExtensions": [
			"js",
			"vue"
		],
		"moduleDirectories": [
			"node_modules"
		],
		"moduleNameMapper": {
			"src/(.*)": "<rootDir>/src/$1"
		},
		"transform": {
			".*\\.(vue)$": "<rootDir>/node_modules/jest-vue-preprocessor",
			"\\.(styl)$": "<rootDir>/node_modules/jest-css-modules",
			".*\\.(vue|js)$": "<rootDir>/node_modules/babel-jest"
		},
		"transformIgnorePatterns": [
			"node_modules/(?!vue-router)"
		],
		"snapshotSerializers": [
			"jest-serializer-html"
		]
	}
};

/***/ }),
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__alerts__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__app__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__avatars__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__bottom_nav__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__breadcrumbs__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__buttons__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__cards__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__carousel__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__chips__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__pickers__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__dialogs__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__dividers__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__expansion_panel__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__footer__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__grid__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__icons__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__lists__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__menus__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__navigation_drawer__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__toolbar__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__pagination__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__parallax__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__progress__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__selects__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__selection_controls__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__sliders__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__subheaders__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__steppers__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__tables__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__tabs__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__text_fields__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__transitions__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__snackbars__ = __webpack_require__(129);


































/* harmony default export */ __webpack_exports__["a"] = (Object.assign({}, __WEBPACK_IMPORTED_MODULE_0__alerts__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__app__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__avatars__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__bottom_nav__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__breadcrumbs__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__buttons__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__cards__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__carousel__["a" /* default */], __WEBPACK_IMPORTED_MODULE_8__chips__["a" /* default */], __WEBPACK_IMPORTED_MODULE_9__pickers__["a" /* default */], __WEBPACK_IMPORTED_MODULE_10__dialogs__["a" /* default */], __WEBPACK_IMPORTED_MODULE_11__dividers__["a" /* default */], __WEBPACK_IMPORTED_MODULE_12__expansion_panel__["a" /* default */], __WEBPACK_IMPORTED_MODULE_13__footer__["a" /* default */], __WEBPACK_IMPORTED_MODULE_14__grid__["a" /* default */], __WEBPACK_IMPORTED_MODULE_15__icons__["a" /* default */], __WEBPACK_IMPORTED_MODULE_16__lists__["c" /* default */], __WEBPACK_IMPORTED_MODULE_17__menus__["a" /* default */], __WEBPACK_IMPORTED_MODULE_18__navigation_drawer__["a" /* default */], __WEBPACK_IMPORTED_MODULE_19__toolbar__["a" /* default */], __WEBPACK_IMPORTED_MODULE_20__pagination__["a" /* default */], __WEBPACK_IMPORTED_MODULE_21__parallax__["a" /* default */], __WEBPACK_IMPORTED_MODULE_22__progress__["a" /* default */], __WEBPACK_IMPORTED_MODULE_23__selects__["a" /* default */], __WEBPACK_IMPORTED_MODULE_24__selection_controls__["a" /* default */], __WEBPACK_IMPORTED_MODULE_25__sliders__["a" /* default */], __WEBPACK_IMPORTED_MODULE_26__subheaders__["a" /* default */], __WEBPACK_IMPORTED_MODULE_27__steppers__["a" /* default */], __WEBPACK_IMPORTED_MODULE_28__tables__["a" /* default */], __WEBPACK_IMPORTED_MODULE_29__tabs__["a" /* default */], __WEBPACK_IMPORTED_MODULE_30__text_fields__["a" /* default */], __WEBPACK_IMPORTED_MODULE_31__transitions__["d" /* default */], __WEBPACK_IMPORTED_MODULE_32__snackbars__["a" /* default */]));

/***/ }),
/* 33 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VAlert__ = __webpack_require__(34);


/* harmony default export */ __webpack_exports__["a"] = ({
  VAlert: __WEBPACK_IMPORTED_MODULE_0__VAlert__["a" /* default */]
});

/***/ }),
/* 34 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_transitionable__ = __webpack_require__(35);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-alert',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_transitionable__["a" /* default */]],

  props: {
    dismissible: Boolean,
    hideIcon: Boolean,
    icon: String
  },

  computed: {
    classes: function classes() {
      return {
        'alert': true,
        'alert--dismissible': this.dismissible,
        'error': this.error,
        'info': this.info,
        'primary': this.primary,
        'secondary': this.secondary,
        'success': this.success,
        'warning': this.warning
      };
    },
    mdIcon: function mdIcon() {
      switch (true) {
        case !!this.icon:
          return this.icon;
        case this.error:
          return 'warning';
        case this.info:
          return 'info';
        case this.success:
          return 'check_circle';
        case this.warning:
          return 'priority_high';
      }
    }
  },

  render: function render(h) {
    var _this = this;

    var children = [h('div', this.$slots.default)];

    if (!this.hideIcon && this.mdIcon) {
      children.unshift(h('v-icon', {
        'class': 'alert__icon'
      }, this.mdIcon));
    }

    if (this.dismissible) {
      var close = h('a', {
        'class': 'alert__dismissible',
        domProps: { href: 'javascript:;' },
        on: { click: function click() {
            return _this.$emit('input', false);
          } }
      }, [h('v-icon', {
        props: { right: true }
      }, 'cancel')]);

      children.push(close);
    }

    var alert = h('div', {
      'class': this.classes,
      directives: [{
        name: 'show',
        value: this.isActive
      }],
      on: this.$listeners
    }, children);

    if (!this.transition) return alert;

    return h('transition', {
      props: {
        name: this.transition,
        origin: this.origin,
        mode: this.mode
      }
    }, [alert]);
  }
});

/***/ }),
/* 35 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    mode: String,
    origin: String,
    transition: String
  }
});

/***/ }),
/* 36 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VApp__ = __webpack_require__(37);


/* harmony default export */ __webpack_exports__["a"] = ({
  VApp: __WEBPACK_IMPORTED_MODULE_0__VApp__["a" /* default */]
});

/***/ }),
/* 37 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  props: {
    fixedFooter: Boolean,
    footer: Boolean,
    id: {
      type: String,
      default: 'app'
    },
    toolbar: Boolean
  },

  render: function render(h, _ref) {
    var props = _ref.props,
        data = _ref.data,
        children = _ref.children;

    data.staticClass = ('application ' + (data.staticClass || '')).trim();
    data.staticClass += ' application--' + (props.dark ? 'dark' : 'light');

    props.footer && (data.staticClass += ' application--footer');
    props.fixedFooter && (data.staticClass += ' application--footer-fixed');
    props.toolbar && (data.staticClass += ' application--toolbar');

    data.attrs = { 'data-app': true };
    data.domProps = { id: props.id };

    return h('div', data, children);
  }
});

/***/ }),
/* 38 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export VAvatar */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


var VAvatar = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('avatar');

/* harmony default export */ __webpack_exports__["a"] = ({
  VAvatar: VAvatar
});

/***/ }),
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VBottomNav__ = __webpack_require__(40);


/* harmony default export */ __webpack_exports__["a"] = ({
  VBottomNav: __WEBPACK_IMPORTED_MODULE_0__VBottomNav__["a" /* default */]
});

/***/ }),
/* 40 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  props: {
    absolute: Boolean,
    shift: Boolean,
    value: { required: false }
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        props = _ref.props,
        children = _ref.children;

    data.staticClass = ('bottom-nav ' + (data.staticClass || '')).trim();

    if (props.absolute) data.staticClass += ' bottom-nav--absolute';
    if (props.shift) data.staticClass += ' bottom-nav--shift';
    if (props.value) data.staticClass += ' bottom-nav--active';

    return h('div', data, children);
  }
});

/***/ }),
/* 41 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VBreadcrumbs__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VBreadcrumbsItem__ = __webpack_require__(43);



/* harmony default export */ __webpack_exports__["a"] = ({
  VBreadcrumbs: __WEBPACK_IMPORTED_MODULE_0__VBreadcrumbs__["a" /* default */],
  VBreadcrumbsItem: __WEBPACK_IMPORTED_MODULE_1__VBreadcrumbsItem__["a" /* default */]
});

/***/ }),
/* 42 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-breadcrumbs',

  provide: function provide() {
    return {
      divider: this.divider
    };
  },


  props: {
    divider: {
      type: String,
      default: '/'
    },
    icons: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'breadcrumbs': true,
        'breadcrumbs--with-icons': this.icons
      };
    }
  },

  render: function render(h) {
    return h('ul', {
      'class': this.classes,
      props: { items: this.items }
    }, this.$slots.default);
  }
});

/***/ }),
/* 43 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_route_link__ = __webpack_require__(9);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-breadcrumbs-item',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_route_link__["a" /* default */]],

  inject: ['divider'],

  props: {
    activeClass: {
      type: String,
      default: 'breadcrumbs__item--active'
    }
  },

  computed: {
    classes: function classes() {
      var classes = _defineProperty({
        'breadcrumbs__item': true
      }, this.activeClass, !this.disabled);

      return classes;
    }
  },

  render: function render(h) {
    var _generateRouteLink = this.generateRouteLink(),
        tag = _generateRouteLink.tag,
        data = _generateRouteLink.data;

    return h('li', {
      attrs: { 'data-divider': this.divider }
    }, [h(tag, data, this.$slots.default)]);
  }
});

/***/ }),
/* 44 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VBtn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VBtnToggle__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VSpeedDial__ = __webpack_require__(46);




/* harmony default export */ __webpack_exports__["a"] = ({
  VBtn: __WEBPACK_IMPORTED_MODULE_0__VBtn__["a" /* default */],
  VBtnToggle: __WEBPACK_IMPORTED_MODULE_1__VBtnToggle__["a" /* default */],
  VSpeedDial: __WEBPACK_IMPORTED_MODULE_2__VSpeedDial__["a" /* default */]
});

/***/ }),
/* 45 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_buttons_VBtn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_icons_VIcon__ = __webpack_require__(3);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-btn-toggle',

  model: {
    prop: 'inputValue',
    event: 'change'
  },

  props: {
    inputValue: {
      required: false
    },
    items: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    mandatory: Boolean,
    multiple: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'btn-toggle': true,
        'btn-toggle--selected': this.inputValue && (!this.multiple || this.inputValue.length)
      };
    }
  },

  methods: {
    isSelected: function isSelected(item) {
      if (!this.multiple) {
        return this.inputValue === item.value;
      }

      return this.inputValue.includes(item.value);
    },
    updateValue: function updateValue(item) {
      if (!this.multiple) {
        if (this.mandatory && this.inputValue === item.value) return;
        return this.$emit('change', this.inputValue === item.value ? null : item.value);
      }

      var items = this.inputValue.slice();

      var i = items.indexOf(item.value);
      if (i > -1) {
        items.length >= 1 && !this.mandatory && items.splice(i, 1);
      } else {
        items.push(item.value);
      }

      this.$emit('change', items);
    }
  },

  render: function render(h) {
    var _this = this;

    var buttons = this.items.map(function (item, index) {
      var children = [];

      item.text && children.push(h('span', item.text));
      item.icon && children.push(h(__WEBPACK_IMPORTED_MODULE_1__components_icons_VIcon__["a" /* default */], item.icon));

      return h(__WEBPACK_IMPORTED_MODULE_0__components_buttons_VBtn__["a" /* default */], {
        key: index,
        props: {
          flat: true
        },
        on: {
          click: function click(e) {
            e.stopPropagation();
            _this.updateValue(item);
          }
        },
        attrs: {
          'data-selected': _this.isSelected(item),
          'data-index': index,
          'data-only-child': _this.isSelected(item) && (!_this.multiple || _this.inputValue.length === 1)
        }
      }, children);
    });

    return h('div', { class: this.classes }, buttons);
  }
});

/***/ }),
/* 46 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_toggleable__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_positionable__ = __webpack_require__(12);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-speed-dial',

  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_positionable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0__mixins_toggleable__["a" /* default */]],

  props: {
    direction: {
      type: String,
      default: 'top',
      validator: function validator(val) {
        return ['top', 'right', 'bottom', 'left'].includes(val);
      }
    },
    hover: Boolean,
    transition: {
      type: String,
      default: 'scale-transition'
    }
  },

  computed: {
    classes: function classes() {
      return _defineProperty({
        'speed-dial': true,
        'speed-dial--top': this.top,
        'speed-dial--right': this.right,
        'speed-dial--bottom': this.bottom,
        'speed-dial--left': this.left,
        'speed-dial--absolute': this.absolute,
        'speed-dial--fixed': this.fixed
      }, 'speed-dial--direction-' + this.direction, true);
    }
  },

  render: function render(h) {
    var _this = this;

    var children = [];
    var data = {
      'class': this.classes,
      directives: [{
        name: 'click-outside'
      }],
      on: {
        click: function click() {
          return _this.isActive = !_this.isActive;
        }
      }
    };

    if (this.hover) {
      data.on.mouseenter = function () {
        return _this.isActive = true;
      };
      data.on.mouseleave = function () {
        return _this.isActive = false;
      };
    }

    if (this.isActive) {
      children = (this.$slots.default || []).map(function (b, i) {
        b.key = i;

        return b;
      });
    }

    var list = h('transition-group', {
      'class': 'speed-dial__list',
      props: {
        name: this.transition,
        tag: 'div'
      }
    }, children);

    return h('div', data, [this.$slots.activator, list]);
  }
});

/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VCard__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VCardMedia__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VCardTitle__ = __webpack_require__(49);





var VCardActions = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('card__actions');
var VCardText = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('card__text');

/* harmony default export */ __webpack_exports__["a"] = ({
  VCard: __WEBPACK_IMPORTED_MODULE_1__VCard__["a" /* default */],
  VCardActions: VCardActions,
  VCardMedia: __WEBPACK_IMPORTED_MODULE_2__VCardMedia__["a" /* default */],
  VCardText: VCardText,
  VCardTitle: __WEBPACK_IMPORTED_MODULE_3__VCardTitle__["a" /* default */]
});

/***/ }),
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-card-media',

  props: {
    contain: Boolean,
    height: {
      type: [Number, String],
      default: 'auto'
    },
    src: {
      type: String
    }
  },

  render: function render(h) {
    var data = {
      'class': 'card__media',
      style: {
        height: !isNaN(this.height) ? this.height + 'px' : this.height
      },
      on: this.$listeners
    };

    var children = [];

    if (this.src) {
      children.push(h('div', {
        'class': 'card__media__background',
        style: {
          background: 'url(' + this.src + ') center center / ' + (this.contain ? 'contain' : 'cover') + ' no-repeat'
        }
      }));
    }

    children.push(h('div', {
      'class': 'card__media__content'
    }, this.$slots.default));

    return h('div', data, children);
  }
});

/***/ }),
/* 49 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  props: {
    primaryTitle: Boolean
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        props = _ref.props,
        children = _ref.children;

    data.staticClass = ('card__title ' + (data.staticClass || '')).trim();

    if (props.primaryTitle) data.staticClass += ' card__title--primary';

    return h('div', data, children);
  }
});

/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VCarousel__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VCarouselItem__ = __webpack_require__(52);



/* harmony default export */ __webpack_exports__["a"] = ({
  VCarousel: __WEBPACK_IMPORTED_MODULE_0__VCarousel__["a" /* default */],
  VCarouselItem: __WEBPACK_IMPORTED_MODULE_1__VCarouselItem__["a" /* default */]
});

/***/ }),
/* 51 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_bootable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_buttons_VBtn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_icons_VIcon__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_themeable__ = __webpack_require__(1);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-carousel',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_bootable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_themeable__["a" /* default */]],

  data: function data() {
    return {
      current: null,
      items: [],
      slideInterval: {},
      reverse: false
    };
  },


  props: {
    cycle: {
      type: Boolean,
      default: true
    },
    icon: {
      type: String,
      default: 'fiber_manual_record'
    },
    interval: {
      type: Number,
      default: 6000
    },
    leftControlIcon: {
      type: [Boolean, String],
      default: 'chevron_left'
    },
    rightControlIcon: {
      type: [Boolean, String],
      default: 'chevron_right'
    }
  },

  computed: {
    defaultState: function defaultState() {
      return {
        current: null,
        reverse: false
      };
    }
  },

  watch: {
    current: function current() {
      var _this = this;

      // Evaluate items when current changes to account for
      // dynamic changing of children
      this.items = this.$children.filter(function (i) {
        return i.$el.classList && i.$el.classList.contains('carousel__item');
      });

      this.items.forEach(function (i) {
        return i.open(_this.items[_this.current]._uid, _this.reverse);
      });

      !this.isBooted && this.cycle && this.restartInterval();
      this.isBooted = true;
    },
    cycle: function cycle(val) {
      val && this.restartInterval() || clearInterval(this.slideInterval);
    }
  },

  mounted: function mounted() {
    this.init();
  },


  methods: {
    genControls: function genControls() {
      return this.$createElement('div', {
        staticClass: 'carousel__controls'
      }, this.genItems());
    },
    genIcon: function genIcon(direction, icon, fn) {
      if (!icon) return null;

      return this.$createElement('div', {
        staticClass: 'carousel__' + direction
      }, [this.$createElement(__WEBPACK_IMPORTED_MODULE_1__components_buttons_VBtn__["a" /* default */], {
        props: {
          icon: true,
          dark: this.dark || !this.light,
          light: this.light
        },
        on: { click: fn }
      }, [this.$createElement(__WEBPACK_IMPORTED_MODULE_2__components_icons_VIcon__["a" /* default */], icon)])]);
    },
    genItems: function genItems() {
      var _this2 = this;

      return this.items.map(function (item, index) {
        return _this2.$createElement(__WEBPACK_IMPORTED_MODULE_1__components_buttons_VBtn__["a" /* default */], {
          class: {
            'carousel__controls__item': true,
            'carousel__controls__item--active': index === _this2.current
          },
          props: {
            icon: true,
            dark: _this2.dark || !_this2.light,
            light: _this2.light
          },
          key: index,
          on: { click: _this2.select.bind(_this2, index) }
        }, [_this2.$createElement(__WEBPACK_IMPORTED_MODULE_2__components_icons_VIcon__["a" /* default */], _this2.icon)]);
      });
    },
    restartInterval: function restartInterval() {
      clearInterval(this.slideInterval);
      this.$nextTick(this.startInterval);
    },
    init: function init() {
      this.current = 0;
    },
    next: function next() {
      this.reverse = false;

      if (this.current + 1 === this.items.length) {
        return this.current = 0;
      }

      this.current++;
    },
    prev: function prev() {
      this.reverse = true;

      if (this.current - 1 < 0) {
        return this.current = this.items.length - 1;
      }

      this.current--;
    },
    select: function select(index) {
      this.reverse = index < this.current;
      this.current = index;
    },
    startInterval: function startInterval() {
      this.slideInterval = setInterval(this.next, this.interval);
    }
  },

  render: function render(h) {
    return h('div', {
      staticClass: 'carousel',
      directives: [{
        name: 'touch',
        value: {
          left: this.next,
          right: this.prev
        }
      }]
    }, [this.genIcon('left', this.leftControlIcon, this.prev), this.genIcon('right', this.rightControlIcon, this.next), this.genControls(), this.$slots.default]);
  }
});

/***/ }),
/* 52 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-carousel-item',

  data: function data() {
    return {
      active: false,
      reverse: false
    };
  },


  props: {
    src: {
      type: String,
      required: true
    },

    transition: {
      type: String,
      default: 'tab-transition'
    },

    reverseTransition: {
      type: String,
      default: 'tab-reverse-transition'
    }
  },

  computed: {
    computedTransition: function computedTransition() {
      return this.reverse ? this.reverseTransition : this.transition;
    },
    styles: function styles() {
      return {
        backgroundImage: 'url(' + this.src + ')'
      };
    }
  },

  methods: {
    open: function open(id, reverse) {
      this.active = this._uid === id;
      this.reverse = reverse;
    }
  },

  render: function render(h) {
    var item = h('div', {
      class: {
        'carousel__item': true,
        'reverse': this.reverse
      },
      style: this.styles,
      on: this.$listeners,
      directives: [{
        name: 'show',
        value: this.active
      }]
    }, [this.$slots.default]);

    return h('transition', { props: { name: this.computedTransition } }, [item]);
  }
});

/***/ }),
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VChip__ = __webpack_require__(54);


/* harmony default export */ __webpack_exports__["a"] = ({
  VChip: __WEBPACK_IMPORTED_MODULE_0__VChip__["a" /* default */]
});

/***/ }),
/* 54 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_toggleable__ = __webpack_require__(2);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-chip',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_toggleable__["a" /* default */]],

  props: {
    close: Boolean,
    label: Boolean,
    outline: Boolean,
    small: Boolean,
    value: {
      type: Boolean,
      default: true
    }
  },

  computed: {
    classes: function classes() {
      return {
        'chip': true,
        'chip--label': this.label,
        'chip--outline': this.outline,
        'chip--small': this.small,
        'chip--removable': this.close
      };
    }
  },

  render: function render(h) {
    var _this = this;

    var children = [this.$slots.default];
    var data = {
      'class': this.classes,
      attrs: { tabindex: -1 },
      directives: [{
        name: 'show',
        value: this.isActive
      }],
      on: this.$listeners
    };

    if (this.close) {
      children.push(h('a', {
        'class': 'chip__close',
        domProps: { href: 'javascript:;' },
        on: {
          click: function click(e) {
            e.stopPropagation();

            _this.$emit('input', false);
          }
        }
      }, [h('v-icon', { props: { right: true } }, 'cancel')]));
    }

    return h('span', data, children);
  }
});

/***/ }),
/* 55 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VDatePicker__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VTimePicker__ = __webpack_require__(61);



/* harmony default export */ __webpack_exports__["a"] = ({
  VDatePicker: __WEBPACK_IMPORTED_MODULE_0__VDatePicker__["a" /* default */],
  VTimePicker: __WEBPACK_IMPORTED_MODULE_1__VTimePicker__["a" /* default */]
});

/***/ }),
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_date_title__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_date_header__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_date_table__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_date_years__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_picker__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_helpers__ = __webpack_require__(0);







var defaultDateFormat = function defaultDateFormat(val) {
  return new Date(val).toISOString().substr(0, 10);
};

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-date-picker',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_date_title__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_date_header__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_date_table__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_date_years__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_picker__["a" /* default */]],

  data: function data() {
    return {
      tableDate: new Date(),
      originalDate: this.value,
      currentDay: null,
      currentMonth: null,
      currentYear: null,
      isSelected: false,
      isReversing: false,
      narrowDays: []
    };
  },


  props: {
    locale: {
      type: String,
      default: 'en-us'
    },
    dateFormat: {
      type: Function,
      default: defaultDateFormat
    },
    titleDateFormat: {
      type: Object,
      default: function _default() {
        return { weekday: 'short', month: 'short', day: 'numeric' };
      }
    },
    headerDateFormat: {
      type: Object,
      default: function _default() {
        return { month: 'long', year: 'numeric' };
      }
    },
    formattedValue: {
      required: false
    },
    allowedDates: {
      type: [Array, Object, Function],
      default: function _default() {
        return null;
      }
    },
    firstDayOfWeek: {
      type: [String, Number],
      default: 0
    },
    yearIcon: String
  },

  computed: {
    firstAllowedDate: function firstAllowedDate() {
      var date = new Date();
      date.setHours(12, 0, 0, 0);

      if (this.allowedDates) {
        var millisecondOffset = 1 * 24 * 60 * 60 * 1000;
        var valid = new Date(date);
        for (var i = 0; i < 31; i++) {
          if (this.isAllowed(valid)) return valid;

          valid.setTime(valid.getTime() + millisecondOffset);
        }
      }

      return date;
    },

    inputDate: {
      get: function get() {
        if (!this.value) return this.firstAllowedDate;
        if (this.value instanceof Date) return this.value;
        if (!isNaN(this.value) || typeof this.value === 'string' && this.value.indexOf(':') !== -1) return new Date(this.value);

        return new Date(this.value + 'T12:00:00');
      },
      set: function set(val) {
        this.$emit('input', val ? defaultDateFormat(val) : this.originalDate);
        this.$emit('update:formattedValue', val ? this.dateFormat(val) : this.dateFormat(this.originalDate));
      }
    },
    day: function day() {
      return this.inputDate.getDate();
    },
    month: function month() {
      return this.inputDate.getMonth();
    },
    year: function year() {
      return this.inputDate.getFullYear();
    },
    tableMonth: function tableMonth() {
      return this.tableDate.getMonth();
    },
    tableYear: function tableYear() {
      return this.tableDate.getFullYear();
    },
    computedTransition: function computedTransition() {
      return this.isReversing ? 'v-tab-reverse-transition' : 'v-tab-transition';
    }
  },

  watch: {
    isSelected: function isSelected(val) {
      var _this = this;

      val && this.$nextTick(function () {
        _this.$refs.years.scrollTop = _this.$refs.years.scrollHeight / 2 - 125;
      });
    },
    tableDate: function tableDate(val, prev) {
      this.isReversing = val < prev;
    },
    value: function value(val) {
      if (val) this.tableDate = this.inputDate;
    }
  },

  methods: {
    save: function save() {
      if (this.originalDate) {
        this.originalDate = this.value;
      } else {
        this.originalDate = this.inputDate;
      }

      if (this.$parent && this.$parent.isActive) this.$parent.isActive = false;
    },
    cancel: function cancel() {
      this.inputDate = this.originalDate;
      if (this.$parent && this.$parent.isActive) this.$parent.isActive = false;
    },
    isAllowed: function isAllowed(date) {
      if (!this.allowedDates) return true;

      if (Array.isArray(this.allowedDates)) {
        return !!this.allowedDates.find(function (allowedDate) {
          var d = new Date(allowedDate);
          d.setHours(12, 0, 0, 0);

          return d - date === 0;
        });
      } else if (this.allowedDates instanceof Function) {
        return this.allowedDates(date);
      } else if (this.allowedDates instanceof Object) {
        var min = new Date(this.allowedDates.min);
        min.setHours(12, 0, 0, 0);
        var max = new Date(this.allowedDates.max);
        max.setHours(12, 0, 0, 0);

        return date >= min && date <= max;
      }

      return true;
    }
  },

  created: function created() {
    var _this2 = this;

    var date = new Date();
    date.setDate(date.getDate() - date.getDay() + parseInt(this.firstDayOfWeek));

    Object(__WEBPACK_IMPORTED_MODULE_5__util_helpers__["c" /* createRange */])(7).forEach(function () {
      var narrow = date.toLocaleString(_this2.locale, { weekday: 'narrow' });
      _this2.narrowDays.push(narrow);

      date.setDate(date.getDate() + 1);
    });
  },
  mounted: function mounted() {
    this.currentDay = this.tableDate.getDate();
    this.currentMonth = this.tableDate.getMonth();
    this.currentYear = this.tableDate.getFullYear();
    this.tableDate = this.inputDate;
  },
  render: function render(h) {
    var children = [];

    !this.noTitle && children.push(this.genTitle());

    if (!this.isSelected) {
      var bodyChildren = [];

      bodyChildren.push(this.genHeader());
      bodyChildren.push(this.genTable());

      children.push(h('div', {
        'class': 'picker__body'
      }, bodyChildren));
    } else {
      children.push(this.genYears());
    }

    this.$scopedSlots.default && children.push(this.genSlot());

    return h('v-card', {
      'class': {
        'picker picker--date': true,
        'picker--landscape': this.landscape,
        'picker--dark': this.dark,
        'picker--light': this.light && !this.dark
      }
    }, children);
  }
});

/***/ }),
/* 57 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genYearIcon: function genYearIcon() {
      return this.yearIcon ? this.$createElement('v-icon', {
        props: {
          dark: true
        }
      }, this.yearIcon) : null;
    },
    genTitle: function genTitle() {
      var _this = this;

      var date = new Date(this.year, this.month, this.day);
      date = date.toLocaleString(this.locale, this.titleDateFormat);

      if (this.landscape) {
        if (date.indexOf(',') > -1) date = date.replace(',', ',<br>');else if (date.indexOf(' ') > -1) date = date.replace(' ', '<br>');
      }

      var text = this.$createElement('transition', {
        props: {
          name: 'slide-x-transition',
          mode: 'out-in'
        }
      }, [this.$createElement('div', {
        domProps: { innerHTML: date },
        key: date
      })]);

      return this.$createElement('div', {
        'class': 'picker__title'
      }, [this.$createElement('div', {
        'class': {
          'picker--date__title-year': true,
          'active': this.isSelected
        },
        on: {
          click: function click(e) {
            e.stopPropagation();
            _this.isSelected = true;
          }
        }
      }, [this.year, this.genYearIcon()]), this.$createElement('div', {
        'class': {
          'picker--date__title-date': true,
          'active': !this.isSelected
        },
        on: {
          click: function click(e) {
            e.stopPropagation();
            _this.isSelected = false;
          }
        }
      }, [text])]);
    }
  }
});

/***/ }),
/* 58 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genHeader: function genHeader() {
      return this.$createElement('div', {
        'class': 'picker--date__header'
      }, [this.genSelector()]);
    },
    genBtn: function genBtn(change, children) {
      var _this = this;

      return this.$createElement('v-btn', {
        props: {
          dark: this.dark,
          icon: true
        },
        nativeOn: {
          click: function click(e) {
            e.stopPropagation();
            _this.tableDate = new Date(_this.tableYear, change);
          }
        }
      }, children);
    },
    genSelector: function genSelector() {
      var date = new Date(this.tableYear, this.tableMonth);
      var header = this.$createElement('div', {
        'class': 'picker--date__header-selector-date'
      }, [this.$createElement(this.computedTransition, [this.$createElement('strong', {
        key: this.tableMonth
      }, date.toLocaleString(this.locale, this.headerDateFormat))])]);

      return this.$createElement('div', {
        'class': 'picker--date__header-selector'
      }, [this.genBtn(this.tableMonth - 1, [this.$createElement('v-icon', 'chevron_left')]), header, this.genBtn(this.tableMonth + 1, [this.$createElement('v-icon', 'chevron_right')])]);
    }
  }
});

/***/ }),
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    wheelScroll: function wheelScroll(e) {
      e.preventDefault();

      var month = this.tableMonth;

      if (e.deltaY < 0) month++;else month--;

      this.tableDate = new Date(this.tableYear, month);
    },
    touch: function touch(value) {
      this.tableDate = new Date(this.tableYear, this.tableMonth + value);
    },
    genTable: function genTable() {
      var _this = this;

      var children = [];
      var data = {
        'class': 'picker--date__table',
        directives: [{
          name: 'touch',
          value: {
            left: function left(e) {
              return e.offsetX < -15 && _this.touch(1);
            },
            right: function right(e) {
              return e.offsetX > 15 && _this.touch(-1);
            }
          }
        }]
      };

      if (this.scrollable) {
        data.on = { wheel: this.wheelScroll };
      }

      children.push(this.$createElement('table', {
        key: this.tableMonth
      }, [this.genTHead(), this.genTBody()]));

      return this.$createElement('div', data, [this.$createElement(this.computedTransition, children)]);
    },
    genTHead: function genTHead() {
      var _this2 = this;

      var days = this.narrowDays.map(function (day) {
        return _this2.$createElement('th', day);
      });
      return this.$createElement('thead', this.genTR(days));
    },
    genTBody: function genTBody() {
      var _this3 = this;

      var children = [];
      var rows = [];
      var length = new Date(this.tableYear, this.tableMonth + 1, 0).getDate();

      var day = new Date(this.tableYear, this.tableMonth).getDay() - parseInt(this.firstDayOfWeek);

      for (var i = 0; i < day; i++) {
        rows.push(this.$createElement('td'));
      }

      var _loop = function _loop(_i) {
        var date = new Date(_this3.tableYear, _this3.tableMonth, _i, 12, 0, 0, 0);
        rows.push(_this3.$createElement('td', [_this3.$createElement('button', {
          'class': {
            'btn btn--floating btn--small btn--flat': true,
            'btn--active': _this3.isActive(_i),
            'btn--current': _this3.isCurrent(_i),
            'btn--light': _this3.dark,
            'btn--disabled': !_this3.isAllowed(date)
          },
          attrs: {
            type: 'button'
          },
          domProps: {
            innerHTML: '<span class="btn__content">' + _i + '</span>'
          },
          on: {
            click: function click() {
              var day = _i < 10 ? '0' + _i : _i;
              var tableYear = _this3.tableYear;
              var tableMonth = _this3.tableMonth + 1;
              tableMonth = tableMonth < 10 ? '0' + tableMonth : tableMonth;

              _this3.inputDate = tableYear + '-' + tableMonth + '-' + day + 'T12:00:00';
              _this3.$nextTick(function () {
                return _this3.autosave && _this3.save();
              });
            }
          }
        })]));

        if (rows.length % 7 === 0) {
          children.push(_this3.genTR(rows));
          rows = [];
        }
      };

      for (var _i = 1; _i <= length; _i++) {
        _loop(_i);
      }

      if (rows.length) {
        children.push(this.genTR(rows));
      }

      children.length < 6 && children.push(this.genTR([this.$createElement('td', { domProps: { innerHTML: '&nbsp;' } })]));

      return this.$createElement('tbody', children);
    },
    genTR: function genTR() {
      var children = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      return [this.$createElement('tr', data, children)];
    },
    isActive: function isActive(i) {
      return this.tableYear === this.year && this.tableMonth === this.month && this.day === i;
    },
    isCurrent: function isCurrent(i) {
      return this.currentYear === this.tableYear && this.currentMonth === this.tableMonth && this.currentDay === i;
    }
  }
});

/***/ }),
/* 60 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genYears: function genYears() {
      return this.$createElement('ul', {
        'class': 'picker--date__years',
        ref: 'years'
      }, this.genYearItems());
    },
    genYearItems: function genYearItems() {
      var _this = this;

      var children = [];

      var _loop = function _loop(i, length) {
        children.push(_this.$createElement('li', {
          'class': {
            active: _this.year === i
          },
          on: {
            click: function click(e) {
              e.stopPropagation();

              var tableMonth = _this.tableMonth + 1;
              var day = _this.day;
              tableMonth = tableMonth < 10 ? '0' + tableMonth : tableMonth;
              day = day < 10 ? '0' + day : day;

              _this.inputDate = i + '-' + tableMonth + '-' + day;
              _this.isSelected = false;
            }
          }
        }, i));
      };

      for (var i = this.year + 100, length = this.year - 100; i > length; i--) {
        _loop(i, length);
      }
      return children;
    }
  }
});

/***/ }),
/* 61 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_picker__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_time_title__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_time_body__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_helpers__ = __webpack_require__(0);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-time-picker',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_picker__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_time_body__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_time_title__["a" /* default */]],

  data: function data() {
    return {
      isDragging: false,
      rotate: 0,
      originalTime: this.value,
      period: 'am',
      selectingHour: true,
      ranges: {
        hours: Object(__WEBPACK_IMPORTED_MODULE_3__util_helpers__["c" /* createRange */])(24),
        minutes: Object(__WEBPACK_IMPORTED_MODULE_3__util_helpers__["c" /* createRange */])(60)
      }
    };
  },


  props: {
    format: {
      type: String,
      default: 'ampm',
      validator: function validator(val) {
        return ['ampm', '24hr'].includes(val);
      }
    },
    allowedHours: {
      type: [Array, Object, Function],
      default: function _default() {
        return null;
      }
    },
    allowedMinutes: {
      type: [Array, Object, Function],
      default: function _default() {
        return null;
      }
    }
  },

  computed: {
    is24hr: function is24hr() {
      return this.format !== 'ampm';
    },
    is24hrAfter12: function is24hrAfter12() {
      return this.selectingHour && this.is24hr && this.hour >= 12;
    },
    divider: function divider() {
      return this.selectingHour ? 12 : 60;
    },
    degrees: function degrees() {
      return this.degreesPerUnit * Math.PI / 180;
    },
    degreesPerUnit: function degreesPerUnit() {
      return 360 / this.divider;
    },

    inputTime: {
      get: function get() {
        if (this.value && !(this.value instanceof Date)) {
          if (!this.is24hr) {
            this.period = this.value.match(/pm/) ? 'pm' : 'am';
          }

          return this.value;
        }
        var value = new Date();

        if (this.value instanceof Date) {
          value = this.value;
        }

        var hour = value.getHours();
        var minute = value.getMinutes();
        var period = '';

        if (!this.is24hr) {
          hour = hour > 12 ? hour - 12 : hour;
          period = hour > 12 ? 'pm' : 'am';
        }

        period && (this.period = period);

        hour = this.firstAllowed('hour', hour);
        minute = this.firstAllowed('minute', minute);

        return hour + ':' + minute + period;
      },
      set: function set(val) {
        return this.$emit('input', val);
      }
    },
    timeArray: function timeArray() {
      return this.inputTime.replace(/(am|pm)/, '').split(':');
    },

    hour: {
      get: function get() {
        return parseInt(this.timeArray[0]);
      },
      set: function set(val) {
        if (!this.is24hr) {
          val = val > 12 ? val - 12 : val < 1 ? 12 : val;
        } else {
          val = val < 10 ? '0' + val : val > 23 ? '00' : val;
        }

        this.inputTime = val + ':' + this.minute + (!this.is24hr ? this.period : '');
      }
    },
    minute: {
      get: function get() {
        var minute = parseInt(this.timeArray[1]);

        return minute < 10 ? '0' + minute : minute > 59 ? '00' : minute;
      },
      set: function set(val) {
        val = val < 10 ? '0' + parseInt(val) : val > 59 ? '00' : val;
        var hour = this.hour;

        if (this.is24hr && hour < 10) {
          hour = '0' + hour;
        }

        this.inputTime = hour + ':' + val + (!this.is24hr ? this.period : '');
      }
    },
    clockHand: function clockHand() {
      if (this.selectingHour) return this.degreesPerUnit * this.hour;
      return this.degreesPerUnit * this.minute;
    },
    radius: function radius() {
      return this.clockSize / 2;
    },

    clockSize: {
      get: function get() {
        return this.size;
      },
      set: function set(val) {
        this.size = val;
      }
    },
    size: function size() {
      return this.landscape ? 250 : 280;
    }
  },

  watch: {
    period: function period(val) {
      var hour = !!this.allowedHours && this.selectingHour ? this.firstAllowed('hour', this.hour - 1) : this.hour;
      this.inputTime = hour + ':' + this.minute + val;
    },
    value: function value(val) {
      if (this.isSaving) {
        this.originalTime = this.inputTime;
        this.isSaving = false;
      }
    }
  },

  methods: {
    save: function save() {
      if (this.originalTime) {
        this.originalTime = this.value;
      } else {
        this.inputTime = this.inputTime;
        this.originalTime = this.inputTime;
      }

      if (this.$parent && this.$parent.isActive) this.$parent.isActive = false;
    },
    cancel: function cancel() {
      this.inputTime = this.originalTime;
      if (this.$parent && this.$parent.isActive) this.$parent.isActive = false;
    },
    isAllowed: function isAllowed(type, value) {
      var allowed = this['allowed' + (type.charAt(0).toUpperCase() + type.slice(1)) + 's'];

      if (!allowed) return true;

      if (Array.isArray(allowed)) {
        return !!allowed.find(function (v) {
          return v === value;
        });
      } else if (allowed instanceof Function) {
        return allowed(value);
      } else if (allowed === Object(allowed)) {
        var range = type === 'minute' ? this.ranges.minutes : this.ranges.hours;
        var mod = type === 'minute' ? 60 : 24;

        if (allowed.min === String(allowed.min)) {
          allowed.min = this.convert12to24hr(allowed.min);
        }

        if (allowed.max === String(allowed.max)) {
          allowed.max = this.convert12to24hr(allowed.max);
        }

        var steps = allowed.max - allowed.min;
        value = type === 'hour' && !this.is24hr && this.period === 'pm' ? value + 12 : value;

        for (var i = 0; i <= steps; i++) {
          var index = (allowed.min + i) % mod;
          if (range[index] === value) return true;
        }

        return false;
      }

      return true;
    },
    convert12to24hr: function convert12to24hr(input) {
      input = input.toLowerCase();
      var pm = input.indexOf('pm') !== -1;
      var hour = parseInt(input.slice(0, input.indexOf(pm ? 'pm' : 'am')));

      return pm ? hour + 12 : hour;
    },
    generateRange: function generateRange(type, start) {
      var range = type === 'hour' ? this.ranges.hours : this.ranges.minutes;
      var offset = 1;

      if (type === 'hour' && !this.is24hr) {
        range = range.slice(1, 13);
        offset = 0;
      }

      return range.slice(start + offset, range.length).concat(range.slice(0, start + offset));
    },
    firstAllowed: function firstAllowed(type, value) {
      var _this = this;

      var allowed = this['allowed' + (type.charAt(0).toUpperCase() + type.slice(1)) + 's'];

      if (!allowed) return value;

      var range = this.generateRange(type, value);

      var first = range.find(function (v) {
        return _this.isAllowed(type, v);
      });

      return first || value;
    }
  },

  render: function render(h) {
    var children = [this.genBody()];

    !this.noTitle && children.unshift(this.genTitle());
    this.$scopedSlots.default && children.push(this.genSlot());

    return h('v-card', {
      'class': {
        'picker picker--time': true,
        'picker--landscape': this.landscape,
        'picker--dark': this.dark,
        'picker--light': this.light && !this.dark,
        'picker--time--hours': this.selectingHour
      }
    }, children);
  }
});

/***/ }),
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genTitle: function genTitle() {
      var children = [this.genTime()];

      if (this.format === 'ampm') {
        children.push(this.genAMPM());
      }

      return this.$createElement('div', {
        'class': 'picker__title'
      }, children);
    },
    genTime: function genTime() {
      var _this = this;

      var hour = this.hour;

      if (this.is24hr && hour < 10) {
        hour = '0' + hour;
      }

      return this.$createElement('div', {
        'class': 'picker--time__title'
      }, [this.$createElement('span', {
        'class': { active: this.selectingHour },
        on: {
          click: function click() {
            return _this.selectingHour = true;
          }
        }
      }, hour), this.$createElement('span', {
        'class': { active: !this.selectingHour },
        on: {
          click: function click() {
            return _this.selectingHour = false;
          }
        }
      }, ':' + this.minute)]);
    },
    genAMPM: function genAMPM() {
      return this.$createElement('div', [this.genPeriod('am'), this.genPeriod('pm')]);
    },
    genPeriod: function genPeriod(period) {
      var _this2 = this;

      return this.$createElement('span', {
        'class': { active: this.period === period },
        on: { click: function click() {
            return _this2.period = period;
          } }
      }, period.toUpperCase());
    }
  }
});

/***/ }),
/* 63 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      hasChanged: false
    };
  },

  methods: {
    genBody: function genBody() {
      var _this = this;

      var children = [this.genHand(this.selectingHour ? 'hour' : 'minute')];
      var data = {
        'class': 'picker--time__clock',
        on: {
          mousedown: this.onMouseDown,
          mouseup: this.onMouseUp,
          mouseleave: function mouseleave() {
            _this.isDragging && _this.onMouseUp();
          },
          touchstart: this.onMouseDown,
          touchend: this.onMouseUp,
          mousemove: this.onDragMove,
          touchmove: this.onDragMove
        },
        key: this.selectingHour ? 'hour' : 'minute',
        ref: 'clock'
      };

      this.selectingHour && children.push(this.genHours()) || children.push(this.genMinutes());

      if (this.scrollable) {
        data.on.wheel = function (e) {
          e.preventDefault();

          var diff = e.wheelDelta > 0 ? 1 : -1;
          var changing = _this.selectingHour ? 'changeHour' : 'changeMinute';

          _this[changing](diff);
        };
      }

      return this.$createElement('div', {
        'class': 'picker__body'
      }, [this.$createElement('v-fade-transition', {
        props: { mode: 'out-in' }
      }, [this.$createElement('div', data, children)])]);
    },
    genHand: function genHand(type) {
      var scale = this.is24hrAfter12 ? 'scaleY(0.6)' : '';
      return [this.$createElement('div', {
        'class': 'picker--time__clock-hand ' + type,
        style: {
          transform: 'rotate(' + this.clockHand + 'deg) ' + scale
        }
      })];
    },
    genHours: function genHours() {
      var hours = this.is24hr ? 24 : 12;
      var children = [];
      var start = 0;

      if (hours === 12) {
        hours++;
        start = 1;
      }

      for (var i = start; i < hours; i++) {
        children.push(this.$createElement('span', {
          'class': {
            'active': i === this.hour,
            'disabled': !this.isAllowed('hour', i)
          },
          style: this.getTransform(i),
          domProps: { innerHTML: '<span>' + i + '</span>' }
        }));
      }

      return children;
    },
    genMinutes: function genMinutes() {
      var children = [];

      for (var i = 0; i < 60; i = i + 5) {
        var num = i;

        if (num < 10) num = '0' + num;
        if (num === 60) num = '00';

        children.push(this.$createElement('span', {
          'class': {
            'active': num.toString() === this.minute.toString(),
            'disabled': !this.isAllowed('minute', i)
          },
          style: this.getTransform(i),
          domProps: { innerHTML: '<span>' + num + '</span>' }
        }));
      }

      return children;
    },
    getTransform: function getTransform(i) {
      var _getPosition = this.getPosition(i),
          x = _getPosition.x,
          y = _getPosition.y;

      return { transform: 'translate(' + x + 'px, ' + y + 'px)' };
    },
    getPosition: function getPosition(i) {
      var radiusPercentage = this.selectingHour && this.is24hr && i >= 12 ? 0.5 : 0.8;
      var r = this.radius * radiusPercentage;
      i = this.selectingHour && this.is24hr ? i % 12 : i;
      return {
        x: Math.round(Math.sin(i * this.degrees) * r),
        y: Math.round(-Math.cos(i * this.degrees) * r)
      };
    },
    changeHour: function changeHour(time) {
      var _this2 = this;

      var range = this.generateRange('hour', this.hour);

      time < 0 && (range = range.reverse().slice(1));
      this.hour = range.find(function (h) {
        return _this2.allowedHours ? _this2.isAllowed('hour', h) : true;
      });

      return true;
    },
    changeMinute: function changeMinute(time) {
      var _this3 = this;

      var current = Number(this.minute);
      var range = this.generateRange('minute', current);

      time < 0 && (range = range.reverse().slice(1));
      var minute = range.find(function (m) {
        return _this3.allowedMinutes ? _this3.isAllowed('minute', m) : true;
      });

      this.minute = minute < 10 ? '0' + minute : minute;

      return true;
    },
    onMouseDown: function onMouseDown(e) {
      e.preventDefault();

      this.isDragging = true;
      this.onDragMove(e);
    },
    onMouseUp: function onMouseUp() {
      this.isDragging = false;
      !this.selectingHour && this.autosave && this.save();
      if (this.hasChanged) {
        this.selectingHour = false;
        this.hasChanged = false;
      }
    },
    onDragMove: function onDragMove(e) {
      e.preventDefault();
      if (!this.isDragging && e.type !== 'click') return;

      var rect = this.$refs.clock.getBoundingClientRect();
      var center = { x: rect.width / 2, y: 0 - rect.width / 2 };
      var clientY = 'touches' in e ? e.touches[0].clientY : e.clientY;
      var clientX = 'touches' in e ? e.touches[0].clientX : e.clientX;
      var coords = {
        y: rect.top - clientY,
        x: clientX - rect.left
      };

      var selecting = this.selectingHour ? 'hour' : 'minute';
      var value = Math.round(this.angle(center, coords) / this.degreesPerUnit);

      if (this.selectingHour && this.is24hr) {
        var insideClick = this.euclidean(center, coords) / this.radius < 0.65;
        value = insideClick ? value + 12 : value;

        // Necessary to fix edge case when selecting left part of 0 and 12
        value = this.angle(center, coords) >= 345 ? (value + 12) % 24 : value;
      }

      if (this.isAllowed(selecting, value)) {
        this[selecting] = value;
        this.hasChanged = true;
      }
    },
    euclidean: function euclidean(p0, p1) {
      var dx = Math.abs(p1.x - p0.x);
      var dy = Math.abs(p1.y - p0.y);

      return Math.sqrt(dx * dx + dy * dy);
    },
    angle: function angle(center, p1) {
      var p0 = {
        x: center.x,
        y: center.y + Math.sqrt(Math.abs(p1.x - center.x) * Math.abs(p1.x - center.x) + Math.abs(p1.y - center.y) * Math.abs(p1.y - center.y))
      };

      var value = 2 * Math.atan2(p1.y - p0.y, p1.x - p0.x);
      return Math.abs(value * 180 / Math.PI);
    }
  }
});

/***/ }),
/* 64 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VDialog__ = __webpack_require__(65);


/* harmony default export */ __webpack_exports__["a"] = ({
  VDialog: __WEBPACK_IMPORTED_MODULE_0__VDialog__["a" /* default */]
});

/***/ }),
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_bootable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_detachable__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_overlayable__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_toggleable__ = __webpack_require__(2);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-dialog',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_bootable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_detachable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_overlayable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_toggleable__["a" /* default */]],

  props: {
    disabled: Boolean,
    persistent: Boolean,
    fullscreen: Boolean,
    fullWidth: Boolean,
    lazy: Boolean,
    origin: {
      type: String,
      default: 'center center'
    },
    width: {
      type: [String, Number],
      default: 290
    },
    scrollable: Boolean,
    transition: {
      type: [String, Boolean],
      default: 'dialog-transition'
    }
  },

  computed: {
    classes: function classes() {
      return {
        'dialog': true,
        'dialog--active': this.isActive,
        'dialog--persistent': this.persistent,
        'dialog--fullscreen': this.fullscreen,
        'dialog--stacked-actions': this.stackedActions && !this.fullscreen,
        'dialog--scrollable': this.scrollable
      };
    }
  },

  watch: {
    isActive: function isActive(val) {
      if (val) {
        !this.fullscreen && !this.hideOverlay && this.genOverlay();
        this.fullscreen && this.hideScroll();
      } else {
        if (!this.fullscreen) this.removeOverlay();else this.showScroll();
      }
    }
  },

  mounted: function mounted() {
    var _this = this;

    this.isBooted = this.isActive;
    this.$vuetify.load(function () {
      return _this.isActive && _this.genOverlay();
    });
  },


  methods: {
    closeConditional: function closeConditional(e) {
      // close dialog if !persistent and clicked outside
      return !this.persistent;
    }
  },

  render: function render(h) {
    var _this2 = this;

    var children = [];
    var data = {
      'class': this.classes,
      ref: 'dialog',
      directives: [{ name: 'click-outside', value: this.closeConditional }, { name: 'show', value: this.isActive }]
    };

    if (!this.fullscreen) {
      data.style = {
        width: isNaN(this.width) ? this.width : this.width + 'px'
      };
    }

    if (this.$slots.activator) {
      children.push(h('div', {
        'class': 'dialog__activator',
        on: {
          click: function click(e) {
            e.stopPropagation();
            if (!_this2.disabled) _this2.isActive = !_this2.isActive;
          }
        }
      }, [this.$slots.activator]));
    }

    var dialog = h('transition', {
      props: {
        name: this.transition || '', // If false, show nothing
        origin: this.origin
      }
    }, [h('div', data, this.showLazyContent(this.$slots.default))]);

    children.push(h('div', {
      'class': ('dialog__content ' + this.contentClass).trim(),
      ref: 'content'
    }, [dialog]));

    return h('div', {
      'class': 'dialog__container',
      style: {
        display: !this.$slots.activator && 'none' || this.fullWidth ? 'block' : 'inline-block'
      }
    }, children);
  }
});

/***/ }),
/* 66 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VDivider__ = __webpack_require__(67);


/* harmony default export */ __webpack_exports__["a"] = ({
  VDivider: __WEBPACK_IMPORTED_MODULE_0__VDivider__["a" /* default */]
});

/***/ }),
/* 67 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  props: {
    inset: Boolean
  },

  render: function render(h, _ref) {
    var props = _ref.props,
        data = _ref.data,
        children = _ref.children;

    data.staticClass = ('divider ' + (data.staticClass || '')).trim();

    if (props.dark) data.staticClass += ' theme--dark';
    if (props.inset) data.staticClass += ' divider--inset';
    if (props.light) data.staticClass += ' theme--light';

    return h('hr', data);
  }
});

/***/ }),
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VExpansionPanel__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VExpansionPanelContent__ = __webpack_require__(70);



/* harmony default export */ __webpack_exports__["a"] = ({
  VExpansionPanel: __WEBPACK_IMPORTED_MODULE_0__VExpansionPanel__["a" /* default */],
  VExpansionPanelContent: __WEBPACK_IMPORTED_MODULE_1__VExpansionPanelContent__["a" /* default */]
});

/***/ }),
/* 69 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-expansion-panel',

  props: {
    expand: Boolean
  },

  computed: {
    params: function params() {
      return {
        expand: this.expand
      };
    }
  },

  render: function render(h) {
    return h('ul', {
      'class': 'expansion-panel'
    }, this.$slots.default);
  }
});

/***/ }),
/* 70 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_transitions__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__ = __webpack_require__(2);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-expansion-panel-content',

  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__["a" /* default */]],

  data: function data() {
    return {
      height: 'auto'
    };
  },


  props: {
    ripple: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'expansion-panel__header': true,
        'expansion-panel__header--active': this.isActive
      };
    }
  },

  methods: {
    closeConditional: function closeConditional(e) {
      return this.$parent.$el.contains(e.target) && !this.$parent.expand && !this.$el.contains(e.target);
    },
    toggle: function toggle() {
      this.isActive = !this.isActive;
    },
    genHeader: function genHeader(h) {
      var _this = this;

      return h('div', {
        class: this.classes,
        directives: [{
          name: 'click-outside',
          value: this.closeConditional
        }, {
          name: 'ripple',
          value: this.ripple
        }],
        on: {
          click: function click() {
            _this.isActive = !_this.isActive;
          }
        }
      }, [this.$slots.header]);
    },
    genBody: function genBody(h) {
      return h('div', {
        ref: 'body',
        class: 'expansion-panel__body',
        directives: [{
          name: 'show',
          value: this.isActive
        }]
      }, [this.$slots.default]);
    }
  },

  render: function render(h) {
    var children = [];

    this.$slots.header && children.push(this.genHeader(h));
    children.push(h(__WEBPACK_IMPORTED_MODULE_0__components_transitions__["a" /* VExpandTransition */], [this.genBody(h)]));

    return h('li', children);
  }
});

/***/ }),
/* 71 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


/* harmony default export */ __webpack_exports__["a"] = ({
  enter: function enter(el, done) {
    // Remove initial transition
    el.style.transition = 'none';
    Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["a" /* addOnceEventListener */])(el, 'transitionend', done);

    // Get height that is to be scrolled
    el.style.overflow = 'hidden';
    el.style.height = null;
    el.style.display = 'block';
    var height = el.clientHeight + 'px';
    el.style.height = 0;
    el.style.transition = null;

    setTimeout(function () {
      return el.style.height = height;
    }, 50);
  },
  afterEnter: function afterEnter(el) {
    el.style.height = 'auto';
    el.style.overflow = null;
  },
  leave: function leave(el, done) {
    // Remove initial transition
    el.style.transition = 'none';
    Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["a" /* addOnceEventListener */])(el, 'transitionend', done);

    // Set height before we transition to 0
    el.style.overflow = 'hidden';
    el.style.height = el.clientHeight + 'px';
    el.style.transition = null;

    setTimeout(function () {
      return el.style.height = 0;
    }, 50);
  }
});

/***/ }),
/* 72 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VFooter__ = __webpack_require__(73);


/* harmony default export */ __webpack_exports__["a"] = ({
  VFooter: __WEBPACK_IMPORTED_MODULE_0__VFooter__["a" /* default */]
});

/***/ }),
/* 73 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  props: {
    absolute: Boolean,
    fixed: Boolean
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        props = _ref.props,
        children = _ref.children;

    data.staticClass = ('footer ' + (data.staticClass || '')).trim();

    if (props.absolute) data.staticClass += ' footer--absolute';
    if (props.fixed) data.staticClass += ' footer--fixed';

    return h('footer', data, children);
  }
});

/***/ }),
/* 74 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


var Grid = function Grid(name) {
  return {
    functional: true,

    props: {
      id: String
    },

    render: function render(h, _ref) {
      var props = _ref.props,
          data = _ref.data,
          children = _ref.children;

      data.staticClass = (name + ' ' + (data.staticClass || '')).trim();

      if (data.attrs) {
        data.staticClass += ' ' + Object.keys(data.attrs).join(' ');
        delete data.attrs;
      }

      if (props.id) {
        data.domProps = data.domProps || {};
        data.domProps.id = props.id;
      }

      return h('div', data, children);
    }
  };
};

var VContainer = Grid('container');
var VFlex = Grid('flex');
var VLayout = Grid('layout');
var VSpacer = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('spacer');

/* harmony default export */ __webpack_exports__["a"] = ({
  VContainer: VContainer,
  VFlex: VFlex,
  VLayout: VLayout,
  VSpacer: VSpacer
});

/***/ }),
/* 75 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VIcon__ = __webpack_require__(3);


/* harmony default export */ __webpack_exports__["a"] = ({
  VIcon: __WEBPACK_IMPORTED_MODULE_0__VIcon__["a" /* default */]
});

/***/ }),
/* 76 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_transitions__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__ = __webpack_require__(2);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-list-group',

  inject: ['listClick', 'listClose'],

  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__["a" /* default */]],

  data: function data() {
    return {
      isBooted: this.value
    };
  },


  props: {
    group: String,
    lazy: Boolean,
    noAction: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'list--group__header': true,
        'list--group__header--active': this.isActive,
        'list--group__header--no-action': this.noAction
      };
    }
  },

  watch: {
    isActive: function isActive() {
      this.isBooted = true;

      if (!this.isActive) {
        this.listClose(this._uid);
      }
    },
    $route: function $route(to) {
      var isActive = this.matchRoute(to.path);

      if (this.group) {
        if (isActive && this.isActive !== isActive) {
          this.listClick(this._uid);
        }
        this.isActive = isActive;
      }
    }
  },

  mounted: function mounted() {
    if (this.group) {
      this.isActive = this.matchRoute(this.$route.path);
    }

    if (this.isActive) {
      this.listClick(this._uid);
    }
  },


  methods: {
    click: function click() {
      var _this = this;

      if (!this.$refs.item.querySelector('.list__tile--disabled')) {
        requestAnimationFrame(function () {
          return _this.listClick(_this._uid);
        });
      }
    },
    toggle: function toggle(uid) {
      this.isActive = this._uid === uid;
    },
    matchRoute: function matchRoute(to) {
      if (!this.group) return false;
      return to.match(this.group) !== null;
    }
  },

  render: function render(h) {
    var group = h('ul', {
      'class': 'list list--group',
      directives: [{
        name: 'show',
        value: this.isActive
      }],
      ref: 'group'
    }, [this.lazy && !this.isBooted ? null : this.$slots.default]);

    var item = h('div', {
      'class': this.classes,
      on: Object.assign({}, { click: this.click }, this.$listeners),
      ref: 'item'
    }, [this.$slots.item]);

    var transition = h(__WEBPACK_IMPORTED_MODULE_0__components_transitions__["a" /* VExpandTransition */], [group]);

    return h('div', { 'class': 'list--group__container' }, [item, transition]);
  }
});

/***/ }),
/* 77 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


function directive(el, binding) {
  var config = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["f" /* directiveConfig */])(binding, {
    icon: false,
    left: false,
    bottom: false,
    overlap: false,
    visible: true
  });

  if (!config.visible || binding.expression && !binding.value) {
    return unbind(el);
  }

  if (config.overlap) el.classList.add('badge--overlap');
  if (config.icon) el.classList.add('badge--icon');
  if (config.left) el.classList.add('badge--left');
  if (config.bottom) el.classList.add('badge--bottom');

  el.dataset.badge = config.value;
  el.classList.add('badge');
}

function unbind(el) {
  el.removeAttribute('data-badge');
  el.classList.remove('badge');
}

/* harmony default export */ __webpack_exports__["a"] = ({
  bind: directive,
  updated: directive,
  componentUpdated: directive,
  unbind: unbind
});

/***/ }),
/* 78 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function inserted(el, binding) {
  var debounce = function debounce(cb) {
    return setTimeout(cb, 50);
  };
  var onResize = function onResize() {
    clearTimeout(debounce);
    debounce(binding.value);
  };

  window.addEventListener('resize', onResize, { passive: true });
  el._onResize = onResize;
}

function unbind(el, binding) {
  window.removeEventListener('resize', el._onResize);
}

/* harmony default export */ __webpack_exports__["a"] = ({
  inserted: inserted,
  unbind: unbind
});

/***/ }),
/* 79 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function inserted(el, binding) {
  var callback = typeof binding.value === 'function' ? binding.value : binding.value.callback;
  var options = binding.value.options || { passive: true };
  var target = binding.value.target || window;
  if (target === 'undefined') return;

  if (target !== window) {
    target = document.querySelector(target);
  }

  target.addEventListener('scroll', callback, options);

  el._onScroll = {
    target: target,
    options: options
  };
}

function unbind(el, binding) {
  var _el$_onScroll = el._onScroll,
      target = _el$_onScroll.target,
      options = _el$_onScroll.options;


  target.removeEventListener('scroll', binding.callback, options);
}

/* harmony default export */ __webpack_exports__["a"] = ({
  inserted: inserted,
  unbind: unbind
});

/***/ }),
/* 80 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


function directive(el, binding) {
  var config = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["f" /* directiveConfig */])(binding, {
    top: true,
    visible: true
  });

  if (!config.visible || binding.expression && !binding.value) {
    return unbind(el);
  }

  unbind(el, binding, config);

  el.dataset.tooltip = config.html;
  el.dataset['tooltipLocation'] = config.value;
}

function unbind(el) {
  el.removeAttribute('data-tooltip');
  el.removeAttribute('data-tooltip-location');
}

/* harmony default export */ __webpack_exports__["a"] = ({
  bind: directive,
  updated: directive,
  componentUpdated: directive,
  unbind: unbind
});

/***/ }),
/* 81 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var touchstart = function touchstart(event, wrapper) {
  var touch = event.changedTouches[0];
  wrapper.touchstartX = touch.clientX;
  wrapper.touchstartY = touch.clientY;

  wrapper.start && wrapper.start(Object.assign(event, wrapper));
};

var touchend = function touchend(event, wrapper) {
  var touch = event.changedTouches[0];
  wrapper.touchendX = touch.clientX;
  wrapper.touchendY = touch.clientY;

  wrapper.end && wrapper.end(Object.assign(event, wrapper));

  handleGesture(wrapper);
};

var touchmove = function touchmove(event, wrapper) {
  var touch = event.changedTouches[0];
  wrapper.touchmoveX = touch.clientX;
  wrapper.touchmoveY = touch.clientY;

  wrapper.move && wrapper.move(Object.assign(event, wrapper));
};

var handleGesture = function handleGesture(wrapper) {
  var touchstartX = wrapper.touchstartX,
      touchendX = wrapper.touchendX,
      touchstartY = wrapper.touchstartY,
      touchendY = wrapper.touchendY;

  wrapper.offsetX = touchendX - touchstartX;
  wrapper.offsetY = touchendY - touchstartY;

  if (touchendX < touchstartX) {
    wrapper.left && wrapper.left(wrapper);
  }
  if (touchendX > touchstartX) {
    wrapper.right && wrapper.right(wrapper);
  }
  if (touchendY < touchstartY) {
    wrapper.up && wrapper.up(wrapper);
  }
  if (touchendY > touchstartY) {
    wrapper.down && wrapper.down(wrapper);
  }
};

function inserted(el, _ref) {
  var value = _ref.value;

  var wrapper = {
    touchstartX: 0,
    touchstartY: 0,
    touchendX: 0,
    touchendY: 0,
    touchmoveX: 0,
    touchmoveY: 0,
    offsetX: 0,
    offsetY: 0,
    left: value.left,
    right: value.right,
    up: value.up,
    down: value.down,
    start: value.start,
    move: value.move,
    end: value.end
  };

  var target = value.parent ? el.parentNode : el;
  var options = value.options || {};

  target.addEventListener('touchstart', function (e) {
    return touchstart(e, wrapper);
  }, options);
  target.addEventListener('touchend', function (e) {
    return touchend(e, wrapper);
  }, options);
  target.addEventListener('touchmove', function (e) {
    return touchmove(e, wrapper);
  }, options);
}

function unbind(el, _ref2) {
  var value = _ref2.value;

  var target = value.parent ? el.parentNode : el;

  if (!target) return;

  target.removeEventListener('touchstart', touchstart);
  target.removeEventListener('touchend', touchend);
  target.removeEventListener('touchmove', touchmove);
}

/* harmony default export */ __webpack_exports__["a"] = ({
  inserted: inserted,
  unbind: unbind
});

/***/ }),
/* 82 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VMenu_js__ = __webpack_require__(22);


/* harmony default export */ __webpack_exports__["a"] = ({
  VMenu: __WEBPACK_IMPORTED_MODULE_0__VMenu_js__["a" /* default */]
});

/***/ }),
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    getActivator: function getActivator() {
      if (this.activator) return this.activator;
      return this.$refs.activator.children ? this.$refs.activator.children[0] : this.$refs.activator;
    },
    activatorClickHandler: function activatorClickHandler(e) {
      if (this.disabled) return;else if (this.openOnClick && !this.isActive) {
        this.isActive = true;
        this.absoluteX = e.clientX;
        this.absoluteY = e.clientY;
      } else if (this.closeOnClick && this.isActive) this.isActive = false;
    },
    mouseEnterHandler: function mouseEnterHandler(e) {
      if (this.disabled || this.hasJustFocused) return;
      this.hasJustFocused = true;
      this.isActive = true;
    },
    mouseLeaveHandler: function mouseLeaveHandler(e) {
      if (this.isContentActive) return;
      this.isActive = false;
    },
    addActivatorEvents: function addActivatorEvents() {
      var activator = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      if (!activator) return;
      activator.addEventListener('click', this.activatorClickHandler);
    },
    removeActivatorEvents: function removeActivatorEvents() {
      var activator = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      if (!activator) return;
      activator.removeEventListener('click', this.activatorClickHandler);
    }
  }
});

/***/ }),
/* 84 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genActivator: function genActivator() {
      if (!this.$slots.activator) return null;

      var options = {
        'class': {
          'menu__activator--active': this.hasJustFocused || this.isActive
        },
        staticClass: 'menu__activator',
        ref: 'activator',
        slot: 'activator',
        on: {}
      };

      if (this.openOnHover) {
        options.on['mouseenter'] = this.mouseEnterHandler;
        options.on['mouseleave'] = this.mouseLeaveHandler;
      } else if (this.openOnClick) {
        options.on['click'] = this.activatorClickHandler;
      }

      return this.$createElement('div', options, this.$slots.activator);
    },
    genTransition: function genTransition() {
      return this.$createElement('transition', {
        props: {
          name: this.transition,
          origin: this.origin
        }
      }, [this.genContent()]);
    },
    genContent: function genContent() {
      var _this = this;

      var booted = this.lazy && this.isBooted || !this.lazy;
      return this.$createElement('div', {
        'class': ('menu__content ' + this.contentClass).trim(),
        ref: 'content',
        style: this.styles,
        directives: [{
          name: 'show',
          value: this.isContentActive
        }],
        on: {
          click: function click(e) {
            e.stopPropagation();
            if (e.target.getAttribute('disabled')) return;
            if (_this.closeOnContentClick) _this.isActive = false;
          },
          mouseleave: function mouseleave(e) {
            _this.openOnHover && (_this.isActive = false);
          }
        }
      }, [booted ? this.$slots.default : null]);
    }
  }
});

/***/ }),
/* 85 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    // Revisit this
    calculateScroll: function calculateScroll() {
      if (this.selectedIndex === null) return;

      var scrollTop = 0;

      if (this.selectedIndex >= this.stopIndex) {
        scrollTop = this.$refs.content.scrollHeight;
      } else if (this.selectedIndex > this.startIndex) {
        scrollTop = this.selectedIndex * 48 - 56;
      }

      this.$refs.content.scrollTop = scrollTop;
    },
    calcLeftAuto: function calcLeftAuto() {
      var a = this.dimensions.activator;

      return parseInt(a.left - 16);
    },
    calcTopAuto: function calcTopAuto() {
      if (!this.hasActivator) return this.calcTop(true);

      var selectedIndex = Array.from(this.tiles).findIndex(function (n) {
        return n.classList.contains('list__tile--active');
      });

      if (selectedIndex === -1) {
        this.selectedIndex = null;

        return this.calcTop(true);
      }

      this.selectedIndex = selectedIndex;
      var actingIndex = selectedIndex;

      var offsetPadding = 1;
      // #708 Stop index should vary by tile length
      this.stopIndex = this.tiles.length > 4 ? this.tiles.length - 4 : this.tiles.length;

      if (selectedIndex > this.startIndex && selectedIndex < this.stopIndex) {
        actingIndex = 2;
        offsetPadding = 41;
      } else if (selectedIndex >= this.stopIndex) {
        offsetPadding = 9;
        actingIndex = selectedIndex - this.stopIndex;
      }

      return this.calcTop(true) + offsetPadding - actingIndex * 48;
    },
    calcLeft: function calcLeft() {
      if (this.auto) return this.calcLeftAuto();

      var a = this.dimensions.activator;
      var c = this.dimensions.content;
      var left = this.left ? a.right - c.width : a.left;

      if (this.offsetX) left += this.left ? -a.width : a.width;
      if (this.nudgeLeft) left += this.nudgeLeft;
      if (this.nudgeRight) left -= this.nudgeRight;

      return this.calcXOverflow(left);
    },
    calcTop: function calcTop(force) {
      if (this.auto && !force) return this.calcTopAuto();

      var a = this.dimensions.activator;
      var c = this.dimensions.content;
      var top = this.top ? a.bottom - c.height : a.top;

      if (this.offsetY) top += this.top ? -a.height : a.height;
      if (this.nudgeTop) top -= this.nudgeTop;
      if (this.nudgeBottom) top += this.nudgeBottom;

      var defined = typeof window !== 'undefined';
      var pageYOffset = defined ? window.pageYOffset : 0;

      return this.calcYOverflow(top) + pageYOffset;
    },
    calcXOverflow: function calcXOverflow(left) {
      var hasWindow = typeof window !== 'undefined';
      var innerWidth = hasWindow ? window.innerWidth : 0;
      var maxWidth = Math.max(this.dimensions.content.width, this.calculatedMinWidth, parseInt(this.maxWidth) || 0);
      var totalWidth = left + maxWidth;
      var availableWidth = totalWidth - innerWidth;

      if ((!this.left || this.right) && availableWidth > 0) {
        left = innerWidth - maxWidth - (innerWidth > 1024 ? 30 : 12) // Account for scrollbar
        ;
      } else if (this.left && left < 0) left = 12;

      return left;
    },
    calcYOverflow: function calcYOverflow(top) {
      var totalHeight = top + this.dimensions.content.height;
      var defined = typeof window !== 'undefined';
      var innerHeight = defined ? window.innerHeight : 0;

      if (this.top && top < 0) top = 12;else if ((!this.top || this.bottom) && innerHeight < totalHeight) {
        top = innerHeight - this.dimensions.content.height;
      }

      return top < 12 ? 12 : top;
    },
    sneakPeek: function sneakPeek(cb) {
      var _this = this;

      requestAnimationFrame(function () {
        var el = _this.$refs.content;
        var currentDisplay = el.style.display;

        el.style.display = 'inline-block';
        cb();
        el.style.display = currentDisplay;
      });
    },
    absolutePosition: function absolutePosition() {
      return {
        offsetTop: 0,
        scrollHeight: 0,
        top: this.positionY || this.absoluteY,
        bottom: this.positionY || this.absoluteY,
        left: this.positionX || this.absoluteX,
        right: this.positionX || this.absoluteX,
        height: 0,
        width: 0
      };
    },
    updateDimensions: function updateDimensions() {
      var _this2 = this;

      this.sneakPeek(function () {
        _this2.dimensions = {
          activator: !_this2.hasActivator || _this2.positionAbsolutely ? _this2.absolutePosition() : _this2.measure(_this2.getActivator()),
          content: _this2.measure(_this2.$refs.content)
        };
      });
    }
  }
});

/***/ }),
/* 86 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    measure: function measure(el, selector) {
      var getParent = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

      el = selector ? el.querySelector(selector) : el;

      if (!el) return null;

      var _el$getBoundingClient = el.getBoundingClientRect(),
          top = _el$getBoundingClient.top,
          bottom = _el$getBoundingClient.bottom,
          left = _el$getBoundingClient.left,
          right = _el$getBoundingClient.right,
          height = _el$getBoundingClient.height,
          width = _el$getBoundingClient.width;

      return {
        offsetTop: el.offsetTop,
        scrollHeight: el.scrollHeight,
        top: top, bottom: bottom, left: left, right: right, height: height, width: width
      };
    }
  }
});

/***/ }),
/* 87 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      listIndex: -1,
      isUsingKeys: false,
      tiles: []
    };
  },

  watch: {
    isActive: function isActive(val) {
      if (!val) this.listIndex = -1;
    },
    listIndex: function listIndex(next, prev) {
      // For infinite scroll and autocomplete, re-evaluate children
      this.getTiles();

      if (next in this.tiles) {
        this.tiles[next].classList.add('list__tile--highlighted');
        this.$refs.content.scrollTop = next * 48;
      }

      prev in this.tiles && this.tiles[prev].classList.remove('list__tile--highlighted');
    }
  },

  methods: {
    changeListIndex: function changeListIndex(e) {
      [40, 38, 13].includes(e.keyCode) && e.preventDefault();
      e.keyCode === 32 && !this.isActive && e.preventDefault();

      if (this.listIndex === -1) this.setActiveListIndex();
      if ([27, 9].includes(e.keyCode)) return this.isActive = false;else if (!this.isActive && [13, 32].includes(e.keyCode)) {
        return this.isActive = true;
      }

      if (e.keyCode === 40 && this.listIndex < this.tiles.length - 1) {
        this.listIndex++;
      } else if (e.keyCode === 38 && this.listIndex > 0) {
        this.listIndex--;
      } else if (e.keyCode === 13 && this.listIndex !== -1) {
        this.tiles[this.listIndex].click();
      }
    },
    getTiles: function getTiles() {
      this.tiles = this.$refs.content.querySelectorAll('.list__tile');
    },
    setActiveListIndex: function setActiveListIndex() {
      var _this = this;

      this.tiles.forEach(function (t, i) {
        if (t.classList.contains('list__tile--active')) {
          _this.listIndex = i;
          return;
        }
      });
    }
  }
});

/***/ }),
/* 88 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VNavigationDrawer__ = __webpack_require__(89);


/* harmony default export */ __webpack_exports__["a"] = ({
  VNavigationDrawer: __WEBPACK_IMPORTED_MODULE_0__VNavigationDrawer__["a" /* default */]
});

/***/ }),
/* 89 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_overlayable__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_themeable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__directives__ = __webpack_require__(4);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-navigation-drawer',

  directives: {
    Resize: __WEBPACK_IMPORTED_MODULE_2__directives__["Resize"]
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_overlayable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_themeable__["a" /* default */]],

  data: function data() {
    return {
      isActive: this.value,
      isBooted: false,
      isMobile: false,
      touchArea: {
        left: 0,
        right: 0
      }
    };
  },


  props: {
    absolute: Boolean,
    clipped: Boolean,
    disableRouteWatcher: Boolean,
    enableResizeWatcher: Boolean,
    height: String,
    floating: Boolean,
    miniVariant: Boolean,
    mobileBreakPoint: {
      type: Number,
      default: 1024
    },
    permanent: Boolean,
    persistent: Boolean,
    right: Boolean,
    temporary: Boolean,
    touchless: Boolean,
    value: { required: false }
  },

  computed: {
    calculatedHeight: function calculatedHeight() {
      return this.height || '100%';
    },
    classes: function classes() {
      return {
        'navigation-drawer': true,
        'navigation-drawer--absolute': this.absolute,
        'navigation-drawer--clipped': this.clipped,
        'navigation-drawer--close': !this.isActive,
        'navigation-drawer--floating': this.floating,
        'navigation-drawer--is-booted': this.isBooted,
        'navigation-drawer--is-mobile': this.isMobile,
        'navigation-drawer--mini-variant': this.miniVariant,
        'navigation-drawer--open': this.isActive,
        'navigation-drawer--permanent': this.permanent,
        'navigation-drawer--persistent': this.persistent,
        'navigation-drawer--right': this.right,
        'navigation-drawer--temporary': this.temporary,
        'theme--dark': this.dark,
        'theme--light': this.light
      };
    },
    showOverlay: function showOverlay() {
      return !this.permanent && this.isActive && (this.temporary || this.isMobile);
    }
  },

  watch: {
    $route: function $route() {
      if (!this.disableRouteWatcher) {
        this.isActive = !this.closeConditional();
      }
    },
    isActive: function isActive(val) {
      this.$emit('input', val);
      this.showOverlay && val && this.genOverlay() || this.removeOverlay();
      this.$el.scrollTop = 0;
    },
    isMobile: function isMobile(val) {
      !val && this.removeOverlay();
    },
    permanent: function permanent(val) {
      this.$emit('input', val);
    },
    value: function value(val) {
      if (this.permanent) return;
      if (val !== this.isActive) this.isActive = val;
    }
  },

  mounted: function mounted() {
    this.$vuetify.load(this.init);
  },


  methods: {
    init: function init() {
      var _this = this;

      this.checkIfMobile();
      setTimeout(function () {
        return _this.isBooted = true;
      }, 0);

      if (this.permanent) this.isActive = true;else if (this.isMobile) this.isActive = false;else if (!this.value && (this.persistent || this.temporary)) this.isActive = false;
    },
    checkIfMobile: function checkIfMobile() {
      this.isMobile = window.innerWidth < parseInt(this.mobileBreakPoint);
    },
    closeConditional: function closeConditional() {
      return !this.permanent && (this.temporary || this.isMobile);
    },
    onResize: function onResize() {
      var _this2 = this;

      clearTimeout(this.resizeTimeout);

      if (!this.enableResizeWatcher || this.permanent || this.temporary) return;

      this.resizeTimeout = setTimeout(function () {
        _this2.checkIfMobile();
        _this2.isActive = !_this2.isMobile;
      }, 200);
    },
    swipeRight: function swipeRight(e) {
      if (this.isActive && !this.right) return;
      this.calculateTouchArea();

      if (Math.abs(e.touchendX - e.touchstartX) < 100) return;else if (!this.right && e.touchstartX <= this.touchArea.left) this.isActive = true;else if (this.right && this.isActive) this.isActive = false;
    },
    swipeLeft: function swipeLeft(e) {
      if (this.isActive && this.right) return;
      this.calculateTouchArea();

      if (Math.abs(e.touchendX - e.touchstartX) < 100) return;else if (this.right && e.touchstartX >= this.touchArea.right) this.isActive = true;else if (!this.right && this.isActive) this.isActive = false;
    },
    calculateTouchArea: function calculateTouchArea() {
      if (!this.$el.parentNode) return;
      var parentRect = this.$el.parentNode.getBoundingClientRect();

      this.touchArea = {
        left: parentRect.left + 50,
        right: parentRect.right - 50
      };
    },
    genDirectives: function genDirectives() {
      var directives = [{
        name: 'click-outside',
        value: this.closeConditional
      }, {
        name: 'resize',
        value: this.onResize
      }];

      !this.touchless && directives.push({
        name: 'touch',
        value: {
          parent: true,
          left: this.swipeLeft,
          right: this.swipeRight
        }
      });

      return directives;
    }
  },

  render: function render(h) {
    var _this3 = this;

    var data = {
      'class': this.classes,
      style: { height: this.calculatedHeight },
      directives: this.genDirectives(),
      on: Object.assign({}, {
        click: function click() {
          return _this3.$emit('update:miniVariant', false);
        }
      }, this.$listeners)
    };

    return h('aside', data, [this.$slots.default, h('div', { 'class': 'navigation-drawer__border' })]);
  }
});

/***/ }),
/* 90 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VSystemBar__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VToolbar__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VToolbarSideIcon__ = __webpack_require__(93);






var VToolbarTitle = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('toolbar__title');
var VToolbarItems = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('toolbar__items');

/* harmony default export */ __webpack_exports__["a"] = ({
  VSystemBar: __WEBPACK_IMPORTED_MODULE_1__VSystemBar__["a" /* default */],
  VToolbar: __WEBPACK_IMPORTED_MODULE_2__VToolbar__["a" /* default */],
  VToolbarItems: VToolbarItems,
  VToolbarTitle: VToolbarTitle,
  VToolbarSideIcon: __WEBPACK_IMPORTED_MODULE_3__VToolbarSideIcon__["a" /* default */]
});

/***/ }),
/* 91 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  props: {
    lightsOut: Boolean,
    status: Boolean,
    window: Boolean
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        props = _ref.props,
        children = _ref.children;

    data.staticClass = ('system-bar ' + (data.staticClass || '')).trim();

    if (props.dark) data.staticClass += ' theme--dark';
    if (props.light) data.staticClass += ' theme--light';
    if (props.status) data.staticClass += ' system-bar--status';
    if (props.window) data.staticClass += ' system-bar--window';
    if (props.lightsOut) data.staticClass += ' system-bar--lights-out';

    return h('div', data, children);
  }
});

/***/ }),
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-toolbar',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  data: function data() {
    return {
      isExtended: false,
      isScrolling: false,
      marginTop: 0,
      previousScroll: null,
      target: null
    };
  },

  props: {
    absolute: Boolean,
    card: Boolean,
    dense: Boolean,
    extended: Boolean,
    fixed: Boolean,
    flat: Boolean,
    floating: Boolean,
    prominent: Boolean,
    scrollOffScreen: Boolean,
    scrollTarget: String,
    scrollThreshHold: {
      type: Number,
      default: 100
    }
  },

  computed: {
    classes: function classes() {
      return {
        'toolbar': true,
        'elevation-0': this.flat,
        'toolbar--absolute': this.absolute,
        'toolbar--card': this.card,
        'toolbar--dense': this.dense,
        'toolbar--fixed': this.fixed,
        'toolbar--floating': this.floating,
        'toolbar--prominent': this.prominent,
        'toolbar--extended': this.isExtended,
        'theme--dark': this.dark,
        'theme--light': this.light
      };
    },
    styles: function styles() {
      return {
        marginTop: this.marginTop
      };
    }
  },

  watch: {
    isScrolling: function isScrolling(val) {
      if (!val) this.marginTop = 0;else this.marginTop = -this.$refs.content.clientHeight - 6 + 'px';
    }
  },

  methods: {
    onScroll: function onScroll() {
      if (typeof window === 'undefined') return;

      if (!this.target) {
        this.target = this.scrollTarget ? document.querySelector(this.scrollTarget) : window;
      }

      var currentScroll = this.scrollTarget ? this.target.scrollTop : this.target.pageYOffset || document.documentElement.scrollTop;

      if (currentScroll < this.scrollThreshHold) return;

      if (this.previousScroll === null) {
        this.previousScroll = currentScroll;
      }

      this.isScrolling = this.previousScroll < currentScroll;

      this.previousScroll = currentScroll;
    }
  },

  render: function render(h) {
    this.isExtended = this.extended || !!this.$slots.extension;
    var children = [];
    var data = {
      'class': this.classes,
      style: this.styles,
      on: this.$listeners
    };

    if (this.scrollOffScreen) {
      data.directives = [{
        name: 'scroll',
        value: {
          callback: this.onScroll,
          target: this.scrollTarget
        }
      }];
    }

    children.push(h('div', {
      'class': 'toolbar__content',
      ref: 'content'
    }, this.$slots.default));

    if (this.isExtended) {
      children.push(h('div', {
        'class': 'toolbar__extension'
      }, this.$slots.extension));
    }

    return h('nav', data, children);
  }
});

/***/ }),
/* 93 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_buttons_VBtn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_icons_VIcon__ = __webpack_require__(3);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-toolbar-side-icon',

  functional: true,

  render: function render(h, _ref) {
    var slots = _ref.slots,
        listeners = _ref.listeners,
        props = _ref.props;

    var data = {
      staticClass: 'toolbar__side-icon',
      props: Object.assign(props, {
        icon: true
      }),
      on: listeners
    };

    var defaultSlot = slots().default;

    return h(__WEBPACK_IMPORTED_MODULE_0__components_buttons_VBtn__["a" /* default */], data, defaultSlot || [h(__WEBPACK_IMPORTED_MODULE_1__components_icons_VIcon__["a" /* default */], 'menu')]);
  }
});

/***/ }),
/* 94 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VPagination__ = __webpack_require__(95);


/* harmony default export */ __webpack_exports__["a"] = ({
  VPagination: __WEBPACK_IMPORTED_MODULE_0__VPagination__["a" /* default */]
});

/***/ }),
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_icons_VIcon__ = __webpack_require__(3);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-pagination',

  props: {
    circle: Boolean,
    disabled: Boolean,
    length: {
      type: Number,
      default: 0,
      validator: function validator(val) {
        return val % 1 === 0;
      }
    },
    value: {
      type: Number,
      default: 0
    },
    prevIcon: {
      type: String,
      default: 'chevron_left'
    },
    nextIcon: {
      type: String,
      default: 'chevron_right'
    }
  },

  watch: {
    value: function value() {
      this.init();
    }
  },

  computed: {
    classes: function classes() {
      return {
        'pagination': true,
        'pagination--circle': this.circle,
        'pagination--disabled': this.disabled
      };
    },
    items: function items() {
      if (this.length <= 5) {
        return this.range(1, this.length);
      }

      var min = this.value - 3;
      min = min > 0 ? min : 1;

      var max = min + 6;
      max = max <= this.length ? max : this.length;

      if (max === this.length) {
        min = this.length - 6;
      }

      var range = this.range(min, max);

      if (this.value >= 4 && this.length > 6) {
        range.splice(0, 2, 1, '...');
      }

      if (this.value + 3 < this.length && this.length > 6) {
        range.splice(range.length - 2, 2, '...', this.length);
      }

      return range;
    }
  },

  mounted: function mounted() {
    this.$vuetify.load.call(this, this.init);
  },


  methods: {
    init: function init() {
      var _this = this;

      this.selected = null;

      // Change this
      setTimeout(function () {
        return _this.selected = _this.value;
      }, 100);
    },
    next: function next(e) {
      e.preventDefault();
      this.$emit('input', this.value + 1);
      this.$emit('next');
    },
    previous: function previous(e) {
      e.preventDefault();
      this.$emit('input', this.value - 1);
      this.$emit('previous');
    },
    range: function range(from, to) {
      var range = [];

      from = from > 0 ? from : 1;

      for (var i = from; i <= to; i++) {
        range.push(i);
      }

      return range;
    },
    genIcon: function genIcon(h, icon, disabled, fn) {
      return h('li', [h('a', {
        class: {
          'pagination__navigation': true,
          'pagination__navigation--disabled': disabled
        },
        attrs: { href: '#!' },
        on: { click: fn }
      }, [h(__WEBPACK_IMPORTED_MODULE_0__components_icons_VIcon__["a" /* default */], [icon])])]);
    },
    genItem: function genItem(h, i) {
      var _this2 = this;

      return h('a', {
        class: {
          'pagination__item': true,
          'pagination__item--active': i === this.value
        },
        attrs: { href: '#!' },
        on: {
          click: function click(e) {
            e.preventDefault();
            _this2.$emit('input', i);
          }
        }
      }, [i]);
    },
    genItems: function genItems(h) {
      var _this3 = this;

      return this.items.map(function (i) {
        return h('li', [isNaN(i) && h('span', { class: 'pagination__more' }, [i]) || _this3.genItem(h, i)]);
      });
    }
  },

  render: function render(h) {
    var children = [this.genIcon(h, this.prevIcon, this.value === 1, this.previous), this.genItems(h), this.genIcon(h, this.nextIcon, this.value === this.length, this.next)];

    return h('ul', { class: this.classes }, children);
  }
});

/***/ }),
/* 96 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VParallax__ = __webpack_require__(97);


/* harmony default export */ __webpack_exports__["a"] = ({
  VParallax: __WEBPACK_IMPORTED_MODULE_0__VParallax__["a" /* default */]
});

/***/ }),
/* 97 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_translatable__ = __webpack_require__(98);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-parallax',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_translatable__["a" /* default */]],

  props: {
    height: {
      type: [String, Number],
      default: 500
    },
    src: String
  },

  computed: {
    styles: function styles() {
      return {
        display: 'block',
        transform: 'translate3d(-50%, ' + this.parallax + 'px, 0)'
      };
    }
  },

  methods: {
    init: function init() {
      var _this = this;

      if (!this.$refs.img) return;

      if (this.$refs.img.complete) {
        this.translate();
        this.listeners();
      } else {
        this.$refs.img.addEventListener('load', function () {
          _this.translate();
          _this.listeners();
        }, false);
      }
    },
    objHeight: function objHeight() {
      return this.$refs.img.naturalHeight;
    },
    elOffsetTop: function elOffsetTop() {
      return this.$el.offsetTop;
    }
  },

  render: function render(h) {
    var container = h('div', {
      staticClass: 'parallax__image-container'
    }, [h('img', {
      staticClass: 'parallax__image',
      style: this.styles,
      attrs: {
        src: this.src
      },
      ref: 'img'
    })]);

    var content = h('div', {
      staticClass: 'parallax__content'
    }, this.$slots.default);

    return h('div', {
      staticClass: 'parallax',
      style: {
        height: parseInt(this.normalizedHeight) + 'px'
      },
      on: this.$listeners
    }, [container, content]);
  }
});

/***/ }),
/* 98 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      parallax: null,
      parallaxDist: null,
      percentScrolled: null,
      scrollTop: null,
      windowHeight: null,
      windowBottom: null
    };
  },


  computed: {
    normalizedHeight: function normalizedHeight() {
      return Number(this.height.toString().replace(/(^[0-9]*$)/, '$1'));
    },
    imgHeight: function imgHeight() {
      return this.objHeight();
    }
  },

  mounted: function mounted() {
    this.$vuetify.load(this.init);
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('scroll', this.translate, false);
    window.removeEventListener('resize', this.translate, false);
  },


  methods: {
    listeners: function listeners() {
      window.addEventListener('scroll', this.translate, false);
      window.addEventListener('resize', this.translate, false);
    },
    translate: function translate() {
      this.calcDimensions();

      this.percentScrolled = (this.windowBottom - this.elOffsetTop) / (this.normalizedHeight + this.windowHeight);

      this.parallax = Math.round(this.parallaxDist * this.percentScrolled);

      if (this.translated) {
        this.translated();
      }
    },
    calcDimensions: function calcDimensions() {
      var offset = this.$el.getBoundingClientRect();

      this.scrollTop = window.pageYOffset;
      this.parallaxDist = this.imgHeight - this.normalizedHeight;
      this.elOffsetTop = offset.top + this.scrollTop;
      this.windowHeight = window.innerHeight;
      this.windowBottom = this.scrollTop + this.windowHeight;
    }
  }
});

/***/ }),
/* 99 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VProgressLinear__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VProgressCircular__ = __webpack_require__(100);



/* harmony default export */ __webpack_exports__["a"] = ({
  VProgressLinear: __WEBPACK_IMPORTED_MODULE_0__VProgressLinear__["a" /* default */],
  VProgressCircular: __WEBPACK_IMPORTED_MODULE_1__VProgressCircular__["a" /* default */]
});

/***/ }),
/* 100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _this = this;

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-progress-circular',

  props: {
    button: Boolean,

    fill: {
      type: String,
      default: function _default() {
        return _this.indeterminate ? 'none' : 'transparent';
      }
    },

    indeterminate: Boolean,

    rotate: {
      type: Number,
      default: 0
    },

    size: {
      type: [Number, String],
      default: 32
    },

    width: {
      type: Number,
      default: 4
    },

    value: {
      type: Number,
      default: 0
    }
  },

  computed: {
    calculatedSize: function calculatedSize() {
      var size = Number(this.size);

      if (this.button) {
        size += 8;
      }

      return size;
    },
    circumference: function circumference() {
      return 2 * Math.PI * this.radius;
    },
    classes: function classes() {
      return {
        'progress-circular': true,
        'progress-circular--indeterminate': this.indeterminate,
        'progress-circular--button': this.button
      };
    },
    cxy: function cxy() {
      return this.indeterminate && !this.button ? 50 : this.calculatedSize / 2;
    },
    normalizedValue: function normalizedValue() {
      if (this.value < 0) {
        return 0;
      }

      if (this.value > 100) {
        return 100;
      }

      return this.value;
    },
    radius: function radius() {
      return this.indeterminate && !this.button ? 20 : (this.calculatedSize - this.width) / 2;
    },
    strokeDashArray: function strokeDashArray() {
      return Math.round(this.circumference * 1000) / 1000;
    },
    strokeDashOffset: function strokeDashOffset() {
      return (100 - this.normalizedValue) / 100 * this.circumference + 'px';
    },
    styles: function styles() {
      return {
        height: this.calculatedSize + 'px',
        width: this.calculatedSize + 'px'
      };
    },
    svgSize: function svgSize() {
      return this.indeterminate ? false : this.calculatedSize;
    },
    svgStyles: function svgStyles() {
      return {
        transform: 'rotate(' + this.rotate + 'deg)'
      };
    },
    viewBox: function viewBox() {
      return this.indeterminate ? '25 25 50 50' : false;
    }
  },

  methods: {
    genCircle: function genCircle(h, name, offset) {
      return h('circle', {
        class: 'progress-circular__' + name,
        attrs: {
          fill: 'transparent',
          cx: this.cxy,
          cy: this.cxy,
          r: this.radius,
          'stroke-width': this.width,
          'stroke-dasharray': this.strokeDashArray,
          'stroke-dashoffset': offset
        }
      });
    },
    genSvg: function genSvg(h) {
      var children = [!this.indeterminate && this.genCircle(h, 'underlay', 0), this.genCircle(h, 'overlay', this.strokeDashOffset)];

      return h('svg', {
        style: this.svgStyles,
        attrs: {
          xmlns: 'http://www.w3.org/2000/svg',
          height: this.svgSize,
          width: this.svgSize,
          viewBox: this.viewBox
        }
      }, children);
    }
  },

  render: function render(h) {
    var info = h('div', { class: 'progress-circular__info' }, [this.$slots.default]);
    var svg = this.genSvg(h);

    return h('div', {
      class: this.classes,
      style: this.styles,
      on: this.$listeners
    }, [svg, info]);
  }
});

/*
<template lang="pug">
  div(
    class="progress-circular"
    v-bind:class="classes"
    v-bind:style="styles"
    v-on="$listeners"
  )
    svg(
      xmlns="http://www.w3.org/2000/svg"
      v-bind:height="svgSize"
      v-bind:width="svgSize"
      v-bind:viewBox="viewBox"
      v-bind:style="svgStyles"
    )
      circle(
        class="progress-circular__underlay"
        fill="transparent"
        v-bind:cx="cxy"
        v-bind:cy="cxy"
        v-bind:r="radius"
        v-bind:stroke-width="width"
        v-bind:stroke-dasharray="strokeDashArray"
        v-bind:stroke-dashoffset="0"
        v-if="!indeterminate"
      )
      circle(
        class="progress-circular__overlay"
        v-bind:fill="fill"
        v-bind:cx="cxy"
        v-bind:cy="cxy"
        v-bind:r="radius"
        v-bind:stroke-width="width"
        v-bind:stroke-dasharray="strokeDashArray"
        v-bind:stroke-dashoffset="strokeDashOffset"
      )
    div(class="progress-circular__info")
      slot
</template>
*/

/***/ }),
/* 101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VSelect__ = __webpack_require__(24);


/* harmony default export */ __webpack_exports__["a"] = ({
  VSelect: __WEBPACK_IMPORTED_MODULE_0__VSelect__["a" /* default */]
});

/***/ }),
/* 102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    filterSearch: function filterSearch() {
      var _this = this;

      return this.items.filter(function (i) {
        var text = _this.getText(i);
        if (typeof text !== 'string') return false;

        return text.toLowerCase().indexOf(_this.searchValue.toLowerCase()) !== -1;
      });
    },
    onKeyDown: function onKeyDown(e) {
      this.$refs.menu.changeListIndex(e);
    }
  }
});

/***/ }),
/* 103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genMenu: function genMenu() {
      var _this = this;

      var offsetY = this.autocomplete || this.offset || this.isDropdown;
      var data = {
        ref: 'menu',
        props: {
          activator: this.$refs.activator,
          auto: this.auto,
          closeOnClick: false,
          closeOnContentClick: !this.multiple,
          contentClass: this.computedContentClass,
          disabled: this.disabled,
          maxHeight: this.maxHeight,
          nudgeTop: this.isDropdown ? 22 : offsetY ? 38 : 0,
          offsetY: offsetY,
          value: this.isActive
        },
        on: { input: function input(val) {
            return _this.isActive = val;
          } }
      };

      this.minWidth && (data.props.minWidth = this.minWidth);

      return this.$createElement('v-menu', data, [this.genList()]);
    },
    genSelectionsAndSearch: function genSelectionsAndSearch() {
      var _this2 = this;

      var input = void 0;

      if (this.autocomplete || this.editable) {
        input = this.$createElement('input', {
          'class': 'input-group--select__autocomplete',
          domProps: { value: this.searchValue },
          on: { input: function input(e) {
              return _this2.searchValue = e.target.value;
            } },
          attrs: { tabindex: -1 },
          ref: 'input',
          key: 'input'
        });
      }

      var selections = this.isDirty && (!this.editable || this.editable && !this.focused) ? this.genSelections() : [];
      input && selections.push(input);
      var group = this.$createElement('div', selections);

      return this.$createElement('div', {
        'class': 'input-group__selections',
        style: { 'overflow': 'hidden' },
        ref: 'activator'
      }, [group]);
    },
    genSelections: function genSelections() {
      var _this3 = this;

      var children = [];
      var chips = this.chips;
      var slots = this.$scopedSlots.selection;
      var length = this.selectedItems.length;

      this.selectedItems.forEach(function (item, i) {
        if (slots) {
          children.push(_this3.genSlotSelection(item));
        } else if (chips) {
          children.push(_this3.genChipSelection(item));
        } else {
          children.push(_this3.genCommaSelection(item, i < length - 1));
        }
      });

      return children;
    },
    genSlotSelection: function genSlotSelection(item) {
      return this.$scopedSlots.selection({ parent: this, item: item });
    },
    genChipSelection: function genChipSelection(item) {
      var _this4 = this;

      return this.$createElement('v-chip', {
        'class': 'chip--select-multi',
        props: { close: true },
        on: {
          input: function input() {
            return _this4.selectItem(item);
          },
          click: function click(e) {
            return e.stopPropagation();
          }
        },
        key: this.getValue(item)
      }, this.getText(item));
    },
    genCommaSelection: function genCommaSelection(item, comma) {
      return this.$createElement('div', {
        'class': 'input-group__selections__comma',
        key: JSON.stringify(this.getValue(item)) // Item may be an object
      }, '' + this.getText(item) + (comma ? ', ' : ''));
    },
    genList: function genList() {
      var _this5 = this;

      var children = this.filteredItems.map(function (o) {
        if (o.header) return _this5.genHeader(o);
        if (o.divider) return _this5.genDivider(o);else return _this5.genTile(o);
      });

      if (!children.length) {
        children.push(this.genTile(this.noDataText, true));
      }

      return this.$createElement('v-card', [this.$createElement('v-list', {
        ref: 'list'
      }, children)]);
    },
    genHeader: function genHeader(item) {
      return this.$createElement('v-subheader', {
        props: item
      }, item.header);
    },
    genDivider: function genDivider(item) {
      return this.$createElement('v-divider', {
        props: item
      });
    },
    genTile: function genTile(item, disabled) {
      var _this6 = this;

      var active = this.selectedItems.indexOf(item) !== -1;

      if (typeof disabled === 'undefined') {
        disabled = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["g" /* getObjectValueByPath */])(item, this.itemDisabled);
      }

      var data = {
        on: { click: function click(e) {
            return _this6.selectItem(item);
          } },
        props: {
          avatar: item === Object(item) && 'avatar' in item,
          ripple: true,
          value: active
        }
      };

      if (disabled) {
        data.props.disabled = disabled;
      }

      if (this.$scopedSlots.item) {
        return this.$createElement('v-list-tile', data, [this.$scopedSlots.item({ parent: this, item: item })]);
      }

      return this.$createElement('v-list-tile', data, [this.genAction(item, active), this.genContent(item)]);
    },
    genAction: function genAction(item, active) {
      var _this7 = this;

      if (!this.multiple) return null;

      var data = {
        'class': {
          'list__tile__action--select-multi': this.multiple
        },
        on: {
          click: function click(e) {
            e.stopPropagation();
            _this7.selectItem(item);
          }
        }
      };

      return this.$createElement('v-list-tile-action', data, [this.$createElement('v-checkbox', { props: { inputValue: active } })]);
    },
    genContent: function genContent(item) {
      return this.$createElement('v-list-tile-content', [this.$createElement('v-list-tile-title', this.getText(item))]);
    }
  }
});

/***/ }),
/* 104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VCheckbox__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VRadio__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VSwitch__ = __webpack_require__(106);




/* harmony default export */ __webpack_exports__["a"] = ({
  VCheckbox: __WEBPACK_IMPORTED_MODULE_0__VCheckbox__["a" /* default */],
  VRadio: __WEBPACK_IMPORTED_MODULE_1__VRadio__["a" /* default */],
  VSwitch: __WEBPACK_IMPORTED_MODULE_2__VSwitch__["a" /* default */]
});

/***/ }),
/* 105 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_input__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_colorable__ = __webpack_require__(28);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'radio',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_input__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_colorable__["a" /* default */]],

  model: {
    prop: 'inputValue',
    event: 'change'
  },

  props: {
    inputValue: [String, Number]
  },

  computed: {
    isActive: function isActive() {
      return this.inputValue === this.value;
    },
    classes: function classes() {
      return this.addColorClassChecks({
        'radio': true,
        'input-group--selection-controls': true,
        'input-group--active': this.isActive
      });
    },
    icon: function icon() {
      return this.isActive ? 'radio_button_checked' : 'radio_button_unchecked';
    }
  },

  methods: {
    genLabel: function genLabel() {
      return this.$createElement('label', {
        on: { click: this.toggle }
      }, this.label);
    },
    toggle: function toggle() {
      if (!this.disabled) {
        this.$emit('change', this.value);
      }
    }
  },

  render: function render(h) {
    var transition = h('v-fade-transition', {}, [h('v-icon', {
      'class': {
        'icon--radio': this.isActive
      },
      key: this.icon
    }, this.icon)]);

    var ripple = h('div', {
      'class': 'input-group--selection-controls__ripple',
      on: Object.assign({}, {
        click: this.toggle
      }, this.$listeners),
      directives: [{
        name: 'ripple',
        value: { center: true }
      }]
    });

    return this.genInputGroup([transition, ripple]);
  }
});

/***/ }),
/* 106 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_selectable__ = __webpack_require__(27);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'switch',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_selectable__["a" /* default */]],

  computed: {
    classes: function classes() {
      return {
        'input-group--selection-controls switch': true
      };
    },
    rippleClasses: function rippleClasses() {
      return {
        'input-group--selection-controls__ripple': true,
        'input-group--selection-controls__ripple--active': this.isActive
      };
    },
    containerClasses: function containerClasses() {
      return this.addColorClassChecks({
        'input-group--selection-controls__container': true,
        'input-group--selection-controls__container--light': this.light,
        'input-group--selection-controls__container--disabled': this.disabled
      });
    },
    toggleClasses: function toggleClasses() {
      return {
        'input-group--selection-controls__toggle': true,
        'input-group--selection-controls__toggle--active': this.isActive
      };
    }
  },

  render: function render(h) {
    var ripple = h('div', {
      'class': this.rippleClasses,
      on: Object.assign({}, {
        click: this.toggle
      }, this.$listeners),
      directives: [{
        name: 'ripple',
        value: { center: true }
      }]
    });

    var container = h('div', {
      'class': this.containerClasses
    }, [h('div', { 'class': this.toggleClasses }), ripple]);

    return this.genInputGroup([container]);
  }
});

/***/ }),
/* 107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VSlider__ = __webpack_require__(108);


/* harmony default export */ __webpack_exports__["a"] = ({
  VSlider: __WEBPACK_IMPORTED_MODULE_0__VSlider__["a" /* default */]
});

/***/ }),
/* 108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_input__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_helpers__ = __webpack_require__(0);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-slider',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_input__["a" /* default */]],

  data: function data() {
    return {
      app: {},
      isActive: false,
      inputWidth: 0
    };
  },


  props: {
    inverted: Boolean,
    min: {
      type: [Number, String],
      default: 0
    },
    max: {
      type: [Number, String],
      default: 100
    },
    step: {
      type: [Number, String],
      default: null
    },
    thumbLabel: Boolean,
    value: [Number, String],
    vertical: Boolean,
    snap: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'input-group input-group--slider': true,
        'input-group--active': this.isActive,
        'input-group--dirty': this.inputWidth > 0,
        'input-group--disabled': this.disabled,
        'input-group--ticks': !this.disabled && this.step
      };
    },

    inputValue: {
      get: function get() {
        return this.value;
      },
      set: function set(val) {
        var min = this.min,
            max = this.max,
            step = this.step,
            snap = this.snap;

        val = val < min ? min : val > max ? max : val;
        if (Math.ceil(val) !== Math.ceil(this.lazyValue)) {
          this.inputWidth = this.calculateWidth(val);
        }

        var value = snap ? Math.round(val / step) * step : parseInt(val);
        this.lazyValue = value;

        if (value !== this.value) {
          this.$emit('input', value);
        }
      }
    },
    interval: function interval() {
      return 100 / (this.max - this.min) * this.step;
    },
    thumbContainerClasses: function thumbContainerClasses() {
      return {
        'slider__thumb-container': true,
        'slider__thumb-container--label': this.thumbLabel
      };
    },
    thumbStyles: function thumbStyles() {
      return {
        left: this.inputWidth + '%'
      };
    },
    tickContainerStyles: function tickContainerStyles() {
      return {
        transform: 'translate3d(0, -50%, 0)'
      };
    },
    trackStyles: function trackStyles() {
      var scaleX = this.calculateScale(1 - this.inputWidth / 100);
      var translateX = this.inputWidth < 1 && !this.isActive ? 8 + 'px' : 0;
      return {
        transform: 'scaleX(' + scaleX + ') translateX(' + translateX + ')'
      };
    },
    trackFillStyles: function trackFillStyles() {
      var inputWidth = this.inputWidth;
      var scaleX = this.calculateScale(inputWidth / 100);
      var translateX = inputWidth > 99 && !this.thumbLabel ? -8 + 'px' : 0;
      return {
        transform: 'scaleX(' + scaleX + ') translateX(' + translateX + ')'
      };
    },
    numTicks: function numTicks() {
      return parseInt((this.max - this.min) / this.step);
    }
  },

  watch: {
    value: function value() {
      this.inputValue = this.value;
    }
  },

  mounted: function mounted() {
    var _this = this;

    this.inputValue = this.value;
    this.$nextTick(function () {
      _this.inputWidth = _this.calculateWidth(_this.inputValue);
    });

    // Without a v-app, iOS does not work with body selectors
    this.app = document.querySelector('[data-app]') || console.warn('The v-slider component requires the present of v-app or a non-body wrapping element with the [data-app] attribute.');
  },


  methods: {
    calculateWidth: function calculateWidth(val) {
      if (this.snap) {
        val = Math.round(val / this.step) * this.step;
      }

      val = (val - this.min) / (this.max - this.min) * 100;

      return val < 0.15 ? 0 : val;
    },
    calculateScale: function calculateScale(scale) {
      if (scale < 0.02 && !this.thumbLabel) {
        return 0;
      }

      return this.disabled ? scale - 0.015 : scale;
    },
    onMouseDown: function onMouseDown(e) {
      var options = { passive: true };
      this.isActive = true;

      if ('touches' in e) {
        this.app.addEventListener('touchmove', this.onMouseMove, options);
        Object(__WEBPACK_IMPORTED_MODULE_1__util_helpers__["a" /* addOnceEventListener */])(this.app, 'touchend', this.onMouseUp);
      } else {
        this.app.addEventListener('mousemove', this.onMouseMove, options);
        Object(__WEBPACK_IMPORTED_MODULE_1__util_helpers__["a" /* addOnceEventListener */])(this.app, 'mouseup', this.onMouseUp);
      }
    },
    onMouseUp: function onMouseUp() {
      var options = { passive: true };
      this.isActive = false;
      this.app.removeEventListener('touchmove', this.onMouseMove, options);
      this.app.removeEventListener('mousemove', this.onMouseMove, options);
    },
    onMouseMove: function onMouseMove(e) {
      var _$refs$track$getBound = this.$refs.track.getBoundingClientRect(),
          offsetLeft = _$refs$track$getBound.left,
          trackWidth = _$refs$track$getBound.width;

      var clientX = 'touches' in e ? e.touches[0].clientX : e.clientX;
      var left = (clientX - offsetLeft) / trackWidth * 100;

      left = left < 0 ? 0 : left > 100 ? 100 : left;

      this.inputValue = this.min + left / 100 * (this.max - this.min);
    },
    onKeyDown: function onKeyDown(e) {
      if (!e.keyCode === 37 && !e.keyCode === 39) return;

      var direction = e.keyCode === 37 && -1 || e.keyCode === 39 && 1 || 0;
      var multiplier = e.shiftKey && 3 || e.ctrlKey && 2 || 1;
      var amount = this.snap && this.step || 1;

      this.inputValue = this.inputValue + direction * amount * multiplier;
    },
    sliderMove: function sliderMove(e) {
      if (!this.isActive) {
        this.onMouseMove(e);
      }
    },
    genThumbLabel: function genThumbLabel(h) {
      return h('v-scale-transition', {
        props: { origin: 'bottom center' }
      }, [h('div', {
        'class': 'slider__thumb--label__container',
        directives: [{
          name: 'show',
          value: this.isActive
        }]
      }, [h('div', { 'class': 'slider__thumb--label' }, [h('span', {}, parseInt(this.inputValue))])])]);
    },
    genThumbContainer: function genThumbContainer(h) {
      var children = [];
      children.push(h('div', { 'class': 'slider__thumb' }));

      this.thumbLabel && children.push(this.genThumbLabel(h));

      return h('div', {
        'class': this.thumbContainerClasses,
        style: this.thumbStyles,
        on: {
          touchstart: this.onMouseDown,
          mousedown: this.onMouseDown
        },
        ref: 'thumb'
      }, children);
    },
    genSteps: function genSteps(h) {
      var _this2 = this;

      var ticks = Object(__WEBPACK_IMPORTED_MODULE_1__util_helpers__["c" /* createRange */])(this.numTicks + 1).map(function (i) {
        var span = h('span', {
          class: 'slider__tick',
          style: {
            left: i * (100 / _this2.numTicks) + '%'
          }
        });

        return span;
      });

      return h('div', {
        'class': 'slider__ticks-container',
        style: this.tickContainerStyles
      }, ticks);
    },
    genTrackContainer: function genTrackContainer(h) {
      var children = [h('div', {
        'class': 'slider__track',
        style: this.trackStyles
      }), h('div', {
        'class': 'slider__track-fill',
        style: this.trackFillStyles
      })];

      return h('div', {
        'class': 'slider__track__container',
        ref: 'track'
      }, children);
    }
  },

  render: function render(h) {
    var children = [];

    children.push(this.genTrackContainer(h));
    this.step && children.push(this.genSteps(h));
    children.push(this.genThumbContainer(h));

    var slider = h('div', { 'class': 'slider' }, children);

    return this.genInputGroup([slider], {
      attrs: {
        role: 'slider',
        tabindex: this.tabindex
      },
      on: Object.assign({}, {
        mouseup: this.sliderMove,
        keydown: this.onKeyDown
      }, this.$listeners),
      directives: [{
        name: 'click-outside'
      }]
    });
  }
});

/***/ }),
/* 109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VSubheader__ = __webpack_require__(110);


/* harmony default export */ __webpack_exports__["a"] = ({
  VSubheader: __WEBPACK_IMPORTED_MODULE_0__VSubheader__["a" /* default */]
});

/***/ }),
/* 110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  props: {
    inset: Boolean
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        children = _ref.children,
        props = _ref.props;

    data.staticClass = ('subheader ' + (data.staticClass || '')).trim();

    if (props.inset) data.staticClass += ' subheader--inset';
    if (props.light) data.staticClass += ' theme--light';
    if (props.dark) data.staticClass += ' theme--dark';

    return h('li', data, children);
  }
});

/***/ }),
/* 111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VStepper__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VStepperStep__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VStepperContent__ = __webpack_require__(114);





var VStepperHeader = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('stepper__header');

/* harmony default export */ __webpack_exports__["a"] = ({
  VStepper: __WEBPACK_IMPORTED_MODULE_1__VStepper__["a" /* default */],
  VStepperContent: __WEBPACK_IMPORTED_MODULE_3__VStepperContent__["a" /* default */],
  VStepperHeader: VStepperHeader,
  VStepperStep: __WEBPACK_IMPORTED_MODULE_2__VStepperStep__["a" /* default */]
});

/***/ }),
/* 112 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-stepper',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  provide: function provide() {
    return {
      stepClick: this.stepClick
    };
  },
  data: function data() {
    return {
      inputValue: null,
      isBooted: false,
      steps: [],
      content: [],
      isReverse: false
    };
  },


  props: {
    nonLinear: Boolean,
    altLabels: Boolean,
    vertical: Boolean,
    value: [Number, String]
  },

  computed: {
    classes: function classes() {
      return {
        'stepper': true,
        'stepper--is-booted': this.isBooted,
        'stepper--vertical': this.vertical,
        'stepper--alt-labels': this.altLabels,
        'stepper--non-linear': this.nonLinear,
        'theme--dark': this.dark,
        'theme--light': this.light
      };
    }
  },

  watch: {
    inputValue: function inputValue(val, prev) {
      var _this = this;

      this.isReverse = Number(val) < Number(prev);
      this.steps.forEach(function (i) {
        return i.toggle(_this.inputValue);
      });
      this.content.forEach(function (i) {
        return i.toggle(_this.inputValue, _this.isReverse);
      });

      this.$emit('input', this.inputValue);
      prev && (this.isBooted = true);
    },
    value: function value() {
      this.inputValue = this.value;
    }
  },

  mounted: function mounted() {
    this.$vuetify.load(this.init);
  },


  methods: {
    init: function init() {
      var _this2 = this;

      this.$children.forEach(function (i) {
        if (i.$options._componentTag === 'v-stepper-step') {
          _this2.steps.push(i);
        } else if (i.$options._componentTag === 'v-stepper-content') {
          i.isVertical = _this2.vertical;
          _this2.content.push(i);
        }
      });

      this.inputValue = this.value || this.steps[0].step || 1;
    },
    stepClick: function stepClick(step) {
      this.inputValue = step;
    }
  },

  render: function render(h) {
    return h('div', {
      'class': this.classes
    }, this.$slots.default);
  }
});

/***/ }),
/* 113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-stepper-step',

  inject: ['stepClick'],

  data: function data() {
    return {
      isActive: false,
      isInactive: true
    };
  },


  props: {
    complete: Boolean,
    completeIcon: {
      type: String,
      default: 'check'
    },
    editIcon: {
      type: String,
      default: 'edit'
    },
    errorIcon: {
      type: String,
      default: 'warning'
    },
    editable: Boolean,
    rules: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    step: [Number, String]
  },

  computed: {
    classes: function classes() {
      return {
        'stepper__step': true,
        'stepper__step--active': this.isActive,
        'stepper__step--editable': this.editable,
        'stepper__step--inactive': this.isInactive,
        'stepper__step--error': this.hasError,
        'stepper__step--complete': this.complete
      };
    },
    hasError: function hasError() {
      return this.rules.some(function (i) {
        return i() !== true;
      });
    }
  },

  methods: {
    click: function click(e) {
      e.stopPropagation();

      if (this.editable) {
        this.stepClick(this.step);
      }
    },
    toggle: function toggle(step) {
      this.isActive = step.toString() === this.step.toString();
      this.isInactive = Number(step) < Number(this.step);
    }
  },

  render: function render(h) {
    var data = {
      'class': this.classes,
      directives: [{
        name: 'ripple',
        value: this.editable
      }],
      on: { click: this.click }
    };
    var stepContent = void 0;

    if (this.hasError) {
      stepContent = [h('v-icon', {}, this.errorIcon)];
    } else if (this.complete) {
      if (this.editable) {
        stepContent = [h('v-icon', {}, this.editIcon)];
      } else {
        stepContent = [h('v-icon', {}, this.completeIcon)];
      }
    } else {
      stepContent = this.step;
    }

    var step = h('span', { 'class': 'stepper__step__step' }, stepContent);
    var label = h('div', { 'class': 'stepper__label' }, this.$slots.default);

    return h('div', data, [step, label]);
  }
});

/***/ }),
/* 114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-stepper-content',

  data: function data() {
    return {
      height: 0,
      isActive: false,
      isReverse: false,
      isVertical: false
    };
  },


  props: {
    step: {
      type: [Number, String],
      required: true
    }
  },

  computed: {
    classes: function classes() {
      return {
        'stepper__content': true
      };
    },
    computedTransition: function computedTransition() {
      return this.isReverse ? 'v-tab-reverse-transition' : 'v-tab-transition';
    },
    styles: function styles() {
      if (!this.isVertical) return {};

      return {
        height: !isNaN(this.height) ? this.height + 'px' : this.height
      };
    },
    wrapperClasses: function wrapperClasses() {
      return {
        'stepper__wrapper': true
      };
    }
  },

  watch: {
    isActive: function isActive() {
      if (!this.isVertical) {
        return;
      }

      if (this.isActive) {
        this.enter();
      } else {
        this.leave();
      }
    }
  },

  mounted: function mounted() {
    this.$refs.wrapper.addEventListener('transitionend', this.onTransition, false);
  },
  beforeDestroy: function beforeDestroy() {
    this.$refs.wrapper.removeEventListener('transitionend', this.onTransition, false);
  },


  methods: {
    onTransition: function onTransition() {
      if (!this.isActive) return;

      this.height = 'auto';
    },
    enter: function enter() {
      var _this = this;

      var scrollHeight = 0;

      // Render bug with height
      setTimeout(function () {
        scrollHeight = _this.$refs.wrapper.scrollHeight;
      }, 0);

      this.height = 0;

      // Give the collapsing element time to collapse
      setTimeout(function () {
        return _this.height = scrollHeight || 'auto';
      }, 450);
    },
    leave: function leave() {
      var _this2 = this;

      this.height = this.$refs.wrapper.clientHeight;
      setTimeout(function () {
        return _this2.height = 0;
      }, 0);
    },
    toggle: function toggle(step, reverse) {
      this.isActive = step.toString() === this.step.toString();
      this.isReverse = reverse;
    }
  },

  render: function render(h) {
    var contentData = {
      'class': this.classes
    };
    var wrapperData = {
      'class': this.wrapperClasses,
      style: this.styles,
      ref: 'wrapper'
    };

    if (!this.isVertical) {
      contentData.directives = [{
        name: 'show',
        value: this.isActive
      }];
    }

    var wrapper = h('div', wrapperData, [this.$slots.default]);
    var content = h('div', contentData, [wrapper]);

    return h(this.computedTransition, {
      on: this.$listeners
    }, [content]);
  }
});

/***/ }),
/* 115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export VTableOverflow */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VDataTable__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VEditDialog__ = __webpack_require__(121);




var VTableOverflow = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('table__overflow');

/* harmony default export */ __webpack_exports__["a"] = ({
  VDataTable: __WEBPACK_IMPORTED_MODULE_1__VDataTable__["a" /* default */],
  VEditDialog: __WEBPACK_IMPORTED_MODULE_2__VEditDialog__["a" /* default */],
  VTableOverflow: VTableOverflow
});

/***/ }),
/* 116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_head__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_body__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_foot__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_progress__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_filterable__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_themeable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_buttons_VBtn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_icons_VIcon__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_progress_VProgressLinear__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_selects_VSelect__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__util_helpers__ = __webpack_require__(0);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };















/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-datatable',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_head__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_body__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_filterable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_foot__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_progress__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__mixins_themeable__["a" /* default */]],

  components: {
    VBtn: __WEBPACK_IMPORTED_MODULE_6__components_buttons_VBtn__["a" /* default */],
    VIcon: __WEBPACK_IMPORTED_MODULE_7__components_icons_VIcon__["a" /* default */],
    VProgressLinear: __WEBPACK_IMPORTED_MODULE_8__components_progress_VProgressLinear__["a" /* default */],
    VSelect: __WEBPACK_IMPORTED_MODULE_9__components_selects_VSelect__["a" /* default */],
    // Importing does not work properly
    'v-table-overflow': Object(__WEBPACK_IMPORTED_MODULE_10__util_helpers__["d" /* createSimpleFunctional */])('table__overflow')
  },

  data: function data() {
    return {
      all: false,
      searchLength: 0,
      defaultPagination: {
        page: 1,
        rowsPerPage: 5,
        descending: false,
        totalItems: 0
      }
    };
  },


  props: {
    headers: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    headerText: {
      type: String,
      default: 'text'
    },
    hideActions: Boolean,
    noResultsText: {
      type: String,
      default: 'No matching records found'
    },
    rowsPerPageItems: {
      type: Array,
      default: function _default() {
        return [5, 10, 25, { text: 'All', value: -1 }];
      }
    },
    rowsPerPageText: {
      type: String,
      default: 'Rows per page:'
    },
    selectAll: [Boolean, String],
    search: {
      required: false
    },
    filter: {
      type: Function,
      default: function _default(val, search) {
        return val !== null && ['undefined', 'boolean'].indexOf(typeof val === 'undefined' ? 'undefined' : _typeof(val)) === -1 && val.toString().toLowerCase().indexOf(search) !== -1;
      }
    },
    customFilter: {
      type: Function,
      default: function _default(items, search, filter) {
        search = search.toString().toLowerCase();
        return items.filter(function (i) {
          return Object.keys(i).some(function (j) {
            return filter(i[j], search);
          });
        });
      }
    },
    customSort: {
      type: Function,
      default: function _default(items, index, isDescending) {
        if (index === null) return items;

        return items.sort(function (a, b) {
          var sortA = Object(__WEBPACK_IMPORTED_MODULE_10__util_helpers__["g" /* getObjectValueByPath */])(a, index);
          var sortB = Object(__WEBPACK_IMPORTED_MODULE_10__util_helpers__["g" /* getObjectValueByPath */])(b, index);

          if (isDescending) {
            var _ref = [sortB, sortA];
            sortA = _ref[0];
            sortB = _ref[1];
          }

          // Check if both are numbers
          if (!isNaN(sortA) && !isNaN(sortB)) {
            return sortA - sortB;
          }

          // Check if both cannot be evaluated
          if (sortA === null && sortB === null) {
            return 0;
          }

          var _map = [sortA, sortB].map(function (s) {
            return (s || '').toString().toLocaleLowerCase();
          });

          var _map2 = _slicedToArray(_map, 2);

          sortA = _map2[0];
          sortB = _map2[1];


          if (sortA > sortB) return 1;
          if (sortA < sortB) return -1;

          return 0;
        });
      }
    },
    value: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    items: {
      type: Array,
      required: true,
      default: function _default() {
        return [];
      }
    },
    totalItems: {
      type: Number,
      default: null
    },
    loading: {
      type: [Boolean, String],
      default: false
    },
    selectedKey: {
      type: String,
      default: 'id'
    },
    pagination: {
      type: Object,
      default: null
    }
  },

  computed: {
    classes: function classes() {
      return {
        'datatable table': true,
        'datatable--select-all': this.selectAll !== false,
        'theme--dark': this.dark,
        'theme--light': this.light
      };
    },
    computedPagination: function computedPagination() {
      return this.pagination || this.defaultPagination;
    },
    hasSelectAll: function hasSelectAll() {
      return this.selectAll !== undefined && this.selectAll !== false;
    },
    itemsLength: function itemsLength() {
      if (this.search) return this.searchLength;
      return this.totalItems || this.items.length;
    },
    indeterminate: function indeterminate() {
      return this.hasSelectAll && this.someItems && !this.everyItem;
    },
    everyItem: function everyItem() {
      var _this = this;

      return this.filteredItems.length && this.filteredItems.every(function (i) {
        return _this.isSelected(i);
      });
    },
    someItems: function someItems() {
      var _this2 = this;

      return this.filteredItems.some(function (i) {
        return _this2.isSelected(i);
      });
    },
    getPage: function getPage() {
      var rowsPerPage = this.computedPagination.rowsPerPage;


      return rowsPerPage === Object(rowsPerPage) ? rowsPerPage.value : rowsPerPage;
    },
    pageStart: function pageStart() {
      return this.getPage === -1 ? 0 : (this.computedPagination.page - 1) * this.getPage;
    },
    pageStop: function pageStop() {
      return this.getPage === -1 ? this.itemsLength : this.computedPagination.page * this.getPage;
    },
    filteredItems: function filteredItems() {
      if (this.totalItems) return this.items;

      var items = this.items.slice();
      var hasSearch = typeof this.search !== 'undefined' && this.search !== null;

      if (hasSearch) {
        items = this.customFilter(items, this.search, this.filter);
        this.searchLength = items.length;
      }

      items = this.customSort(items, this.computedPagination.sortBy, this.computedPagination.descending);

      return this.hideActions && !this.pagination ? items : items.slice(this.pageStart, this.pageStop);
    },
    selected: function selected() {
      var _this3 = this;

      var selected = {};
      this.value.forEach(function (i) {
        return selected[i[_this3.selectedKey]] = true;
      });
      return selected;
    }
  },

  watch: {
    indeterminate: function indeterminate(val) {
      if (val) this.all = true;
    },
    someItems: function someItems(val) {
      if (!val) this.all = false;
    },
    search: function search() {
      this.updatePagination({ page: 1 });
    },
    everyItem: function everyItem(val) {
      if (val) this.all = true;
    }
  },

  methods: {
    updatePagination: function updatePagination(val) {
      var pagination = this.pagination || this.defaultPagination;
      var updatedPagination = Object.assign({}, pagination, val);

      if (this.pagination) {
        this.$emit('update:pagination', updatedPagination);
      } else {
        this.defaultPagination = updatedPagination;
      }
    },
    isSelected: function isSelected(item) {
      return this.selected[item[this.selectedKey]];
    },
    sort: function sort(index) {
      var _computedPagination = this.computedPagination,
          sortBy = _computedPagination.sortBy,
          descending = _computedPagination.descending;

      if (sortBy === null) {
        this.updatePagination({ sortBy: index, descending: false });
      } else if (sortBy === index && !descending) {
        this.updatePagination({ descending: true });
      } else if (sortBy !== index) {
        this.updatePagination({ sortBy: index, descending: false });
      } else {
        this.updatePagination({ sortBy: null, descending: null });
      }
    },
    needsTR: function needsTR(row) {
      return row.length && row.find(function (c) {
        return c.tag === 'td';
      });
    },
    genTR: function genTR(children) {
      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      return this.$createElement('tr', data, children);
    },
    toggle: function toggle(value) {
      var _this4 = this;

      var selected = Object.assign({}, this.selected);
      this.filteredItems.forEach(function (i) {
        return selected[i[_this4.selectedKey]] = value;
      });

      this.$emit('input', this.items.filter(function (i) {
        return selected[i[_this4.selectedKey]];
      }));
    }
  },

  created: function created() {
    var firstSortable = this.headers.find(function (h) {
      return !('sortable' in h) || h.sortable;
    });

    this.defaultPagination.sortBy = firstSortable ? firstSortable.value : null;

    if (!this.rowsPerPageItems.length) {
      console.warn('The prop \'rows-per-page-items\' in v-data-table can not be empty.');
    } else {
      this.defaultPagination.rowsPerPage = this.rowsPerPageItems[0];
    }

    this.updatePagination(Object.assign({}, this.defaultPagination, this.pagination));
  },
  render: function render(h) {
    return h('v-table-overflow', {}, [h('table', {
      'class': this.classes
    }, [this.genTHead(), this.genTProgress(), this.genTBody(), this.genTFoot()])]);
  }
});

/***/ }),
/* 117 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genTHead: function genTHead() {
      var _this = this;

      var children = [];

      if (this.$scopedSlots.headers) {
        var row = this.$scopedSlots.headers({
          headers: this.headers,
          indeterminate: this.indeterminate,
          all: this.all
        });

        children = this.needsTR(row) ? this.genTR(row) : row;
      } else {
        var _row = this.headers.map(function (o) {
          return _this.genHeader(o);
        });
        var checkbox = this.$createElement('v-checkbox', {
          props: {
            dark: this.dark,
            light: this.light,
            color: this.selectAll === true && '' || this.selectAll,
            hideDetails: true,
            inputValue: this.all,
            indeterminate: this.indeterminate
          },
          on: { change: this.toggle }
        });

        this.hasSelectAll && _row.unshift(this.$createElement('th', [checkbox]));

        children = this.genTR(_row);
      }

      return this.$createElement('thead', [children]);
    },
    genHeader: function genHeader(header) {
      var array = [this.$scopedSlots.headerCell ? this.$scopedSlots.headerCell({ header: header }) : header[this.headerText]];

      return this.$createElement.apply(this, ['th'].concat(_toConsumableArray(this.genHeaderData(header, array))));
    },
    genHeaderData: function genHeaderData(header, children) {
      var _this2 = this;

      var classes = ['column'];
      var data = {};
      var pagination = this.computedPagination;

      if ('sortable' in header && header.sortable || !('sortable' in header)) {
        data.on = { click: function click() {
            return _this2.sort(header.value);
          } };
        if (!('value' in header)) {
          console.warn('Data table headers must have a value property that corresponds to a value in the v-model array');
        }

        classes.push('sortable');
        var icon = this.$createElement('v-icon', 'arrow_upward');
        if (header.align && header.align === 'left') {
          children.push(icon);
        } else {
          children.unshift(icon);
        }

        var beingSorted = pagination.sortBy === header.value;
        if (beingSorted) {
          classes.push('active');
          classes.push(pagination.descending ? 'desc' : 'asc');
        }
      }

      classes.push('text-xs-' + (header.align || 'right'));
      data.class = classes;

      return [data, children];
    }
  }
});

/***/ }),
/* 118 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genTBody: function genTBody() {
      var children = [];

      if (!this.itemsLength) {
        children.push(this.genEmptyBody(this.noDataText));
      } else if (!this.filteredItems.length) {
        children.push(this.genEmptyBody(this.noResultsText));
      } else {
        children.push(this.genFilteredItems());
      }

      return this.$createElement('tbody', children);
    },
    genFilteredItems: function genFilteredItems() {
      var _this = this;

      return this.filteredItems.map(function (item, index) {
        var props = { item: item, index: index };
        var key = _this.selectedKey;

        Object.defineProperty(props, 'selected', {
          get: function get() {
            return _this.selected[item[_this.selectedKey]];
          },
          set: function set(value) {
            var selected = _this.value.slice();
            if (value) selected.push(item);else selected = selected.filter(function (i) {
              return i[key] !== item[key];
            });

            _this.$emit('input', selected);
          }
        });

        var row = _this.$scopedSlots.items(props);

        return _this.needsTR(row) ? _this.genTR(row, {
          attrs: { active: _this.isSelected(item) }
        }) : row;
      });
    },
    genEmptyBody: function genEmptyBody(text) {
      return this.genTR([this.$createElement('td', {
        'class': 'text-xs-center',
        attrs: { colspan: '100%' }
      }, text)]);
    }
  }
});

/***/ }),
/* 119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genPrevIcon: function genPrevIcon() {
      var _this = this;

      return this.$createElement('v-btn', {
        props: {
          disabled: this.computedPagination.page === 1,
          icon: true,
          flat: true,
          dark: this.dark,
          light: this.light
        },
        on: {
          click: function click() {
            var page = _this.computedPagination.page;
            _this.updatePagination({ page: page - 1 });
          }
        }
      }, [this.$createElement('v-icon', 'chevron_left')]);
    },
    genNextIcon: function genNextIcon() {
      var _this2 = this;

      var pagination = this.computedPagination;
      var disabled = pagination.rowsPerPage < 0 || pagination.page * pagination.rowsPerPage >= this.itemsLength || this.pageStop < 0;

      return this.$createElement('v-btn', {
        props: {
          disabled: disabled,
          icon: true,
          flat: true,
          dark: this.dark,
          light: this.light
        },
        on: {
          click: function click() {
            var page = _this2.computedPagination.page;
            _this2.updatePagination({ page: page + 1 });
          }
        }
      }, [this.$createElement('v-icon', 'chevron_right')]);
    },
    genSelect: function genSelect() {
      var _this3 = this;

      return this.$createElement('div', {
        'class': 'datatable__actions__select'
      }, [this.rowsPerPageText, this.$createElement('v-select', {
        props: {
          items: this.rowsPerPageItems,
          value: this.computedPagination.rowsPerPage,
          hideDetails: true,
          auto: true,
          minWidth: '75px'
        },
        on: {
          input: function input(val) {
            _this3.updatePagination({
              page: 1,
              rowsPerPage: val
            });
          }
        }
      })]);
    },
    genPagination: function genPagination() {
      var pagination = '–';

      if (this.itemsLength) {
        var stop = this.itemsLength < this.pageStop || this.pageStop < 0 ? this.itemsLength : this.pageStop;

        pagination = this.$scopedSlots.pageText ? this.$scopedSlots.pageText({
          pageStart: this.pageStart + 1,
          pageStop: stop,
          itemsLength: this.itemsLength
        }) : this.pageStart + 1 + '-' + stop + ' of ' + this.itemsLength;
      }

      return this.$createElement('div', {
        'class': 'datatable__actions__pagination'
      }, [pagination]);
    },
    genActions: function genActions() {
      return [this.$createElement('div', {
        'class': 'datatable__actions'
      }, [this.genSelect(), this.genPagination(), this.genPrevIcon(), this.genNextIcon()])];
    },
    genTFoot: function genTFoot() {
      var children = [];

      if (this.$slots.footer) {
        var footer = this.$slots.footer;
        var row = this.needsTR(footer) ? this.genTR(footer) : footer;

        children.push(row);
      }

      if (!this.hideActions) {
        children.push(this.genTR([this.$createElement('td', {
          attrs: { colspan: '100%' }
        }, this.genActions())]));
      }

      if (!children.length) return null;
      return this.$createElement('tfoot', children);
    }
  }
});

/***/ }),
/* 120 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      color: ''
    };
  },


  watch: {
    loading: function loading(val) {
      if (val) this.color = val;
    }
  },

  methods: {
    genTProgress: function genTProgress() {
      var loader = this.$createElement('v-progress-linear', {
        props: {
          primary: this.color === 'primary',
          secondary: this.color === 'secondary',
          success: this.color === 'success',
          info: this.color === 'info',
          warning: this.color === 'warning',
          error: this.color === 'error',
          indeterminate: true,
          height: 3,
          active: !!this.loading
        }
      });

      var col = this.$createElement('th', {
        class: 'column',
        attrs: {
          colspan: '100%'
        }
      }, [loader]);

      return this.$createElement('thead', {
        class: 'datatable__progress'
      }, [this.genTR([col])]);
    }
  }
});

/***/ }),
/* 121 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-edit-dialog',

  data: function data() {
    return {
      isActive: false,
      isSaving: false
    };
  },


  props: {
    cancelText: {
      default: 'Cancel'
    },
    large: Boolean,
    lazy: Boolean,
    saveText: {
      default: 'Save'
    },
    transition: {
      type: String,
      default: 'slide-x-reverse-transition'
    }
  },

  watch: {
    isActive: function isActive(val) {
      val && this.$emit('open') && setTimeout(this.focus, 50); // Give DOM time to paint

      if (!val) {
        !this.isSaving && this.$emit('cancel');
        this.isSaving && this.$emit('close');
        this.isSaving = false;
      }
    }
  },

  methods: {
    cancel: function cancel() {
      this.isActive = false;
    },
    focus: function focus() {
      var input = this.$refs.content.querySelector('input');
      input && input.focus();
    },
    save: function save() {
      this.isSaving = true;
      this.isActive = false;
      this.$emit('save');
    },
    genButton: function genButton(fn, text) {
      return this.$createElement('v-btn', {
        props: {
          flat: true,
          primary: true,
          light: true
        },
        on: { click: fn }
      }, text);
    },
    genActions: function genActions() {
      return this.$createElement('div', {
        'class': 'small-dialog__actions',
        directives: [{
          name: 'show',
          value: this.large
        }]
      }, [this.genButton(this.cancel, this.cancelText), this.genButton(this.save, this.saveText)]);
    },
    genContent: function genContent() {
      var _this = this;

      return this.$createElement('div', {
        'class': 'small-dialog__content',
        on: {
          keydown: function keydown(e) {
            e.keyCode === 27 && _this.cancel();
            e.keyCode === 13 && _this.save();
          }
        },
        ref: 'content'
      }, [this.$slots.input]);
    }
  },

  render: function render(h) {
    var _this2 = this;

    return h('v-menu', {
      'class': 'small-dialog',
      props: {
        transition: this.transition,
        origin: 'top right',
        right: true,
        value: this.isActive,
        closeOnContentClick: false,
        lazy: this.lazy
      },
      on: {
        input: function input(val) {
          return _this2.isActive = val;
        }
      }
    }, [h('a', {
      domProps: { href: 'javascript:;' },
      slot: 'activator'
    }, this.$slots.default), this.genContent(), this.genActions()]);
  }
});

/***/ }),
/* 122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VTabs__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VTabsItem__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VTabsContent__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__VTabsBar__ = __webpack_require__(126);






var VTabsSlider = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('tabs__slider', 'li');

var VTabsItems = {
  name: 'v-tabs-items',

  render: function render(h) {
    return h('div', { 'class': { 'tabs__items': true } }, [this.$slots.default]);
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  VTabsItem: __WEBPACK_IMPORTED_MODULE_2__VTabsItem__["a" /* default */],
  VTabsItems: VTabsItems,
  VTabs: __WEBPACK_IMPORTED_MODULE_1__VTabs__["a" /* default */],
  VTabsContent: __WEBPACK_IMPORTED_MODULE_3__VTabsContent__["a" /* default */],
  VTabsBar: __WEBPACK_IMPORTED_MODULE_4__VTabsBar__["a" /* default */],
  VTabsSlider: VTabsSlider
});

/***/ }),
/* 123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__directives__ = __webpack_require__(4);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-tabs',

  directives: {
    Resize: __WEBPACK_IMPORTED_MODULE_1__directives__["Resize"]
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  provide: function provide() {
    var _this = this;

    return {
      slider: this.slider,
      tabClick: this.tabClick,
      isScrollable: function isScrollable() {
        return _this.scrollable;
      },
      isMobile: function isMobile() {
        return _this.isMobile;
      }
    };
  },
  data: function data() {
    return {
      activators: [],
      activeIndex: null,
      isMobile: false,
      reverse: false,
      target: null,
      tabsSlider: null,
      targetEl: null,
      tabsContainer: null
    };
  },


  props: {
    centered: Boolean,
    fixed: Boolean,
    grow: Boolean,
    icons: Boolean,
    mobileBreakPoint: {
      type: [Number, String],
      default: 1024
    },
    value: String,
    scrollable: {
      type: Boolean,
      default: true
    }
  },

  computed: {
    classes: function classes() {
      return {
        'tabs': true,
        'tabs--centered': this.centered,
        'tabs--fixed': this.fixed,
        'tabs--grow': this.grow,
        'tabs--icons': this.icons,
        'tabs--mobile': this.isMobile,
        'tabs--scroll-bars': this.scrollable,
        'theme--dark': this.dark,
        'theme--light': this.light
      };
    }
  },

  watch: {
    value: function value() {
      this.tabClick(this.value);
    },
    activeIndex: function activeIndex() {
      this.updateTabs();
      this.$emit('input', this.target);
      this.isBooted = true;
    }
  },

  mounted: function mounted() {
    var _this2 = this;

    this.$vuetify.load(function () {
      var activators = _this2.$slots.activators;

      if (!activators || !activators.length || !activators[0].componentInstance) return;

      var bar = activators[0].componentInstance.$children;
      // // This is a workaround to detect if link is active
      // // when being used as a router or nuxt link
      var i = bar.findIndex(function (t) {
        return t.$el.firstChild.classList.contains('tabs__item--active');
      });

      var tab = _this2.value || (bar[i !== -1 ? i : 0] || {}).action;

      tab && _this2.tabClick(tab) && _this2.onResize();
    });
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.resize, { passive: true });
  },


  methods: {
    onResize: function onResize() {
      this.isMobile = window.innerWidth < this.mobileBreakPoint;
      this.slider();
    },
    slider: function slider(el) {
      var _this3 = this;

      this.tabsSlider = this.tabsSlider || this.$el.querySelector('.tabs__slider');

      this.tabsContainer = this.tabsContainer || this.$el.querySelector('.tabs__container');

      if (!this.tabsSlider || !this.tabsContainer) return;

      this.targetEl = el || this.targetEl;

      if (!this.targetEl || !this.tabsContainer) return;

      // Gives DOM time to paint when
      // processing slider for
      // dynamic tabs
      this.$nextTick(function () {
        // #684 Calculate width as %
        var width = _this3.targetEl.scrollWidth / _this3.tabsContainer.clientWidth * 100;

        _this3.tabsSlider.style.width = width + '%';
        _this3.tabsSlider.style.left = _this3.targetEl.offsetLeft + 'px';
      });
    },
    tabClick: function tabClick(target) {
      var _this4 = this;

      var setActiveIndex = function setActiveIndex(index) {
        if (_this4.activeIndex === index) {
          // #762 update tabs display
          // In case tabs count got changed but activeIndex didn't
          _this4.updateTabs();
        } else {
          _this4.activeIndex = index;
        }
      };

      this.target = target;

      var content = this.$refs.content;
      if (!content) {
        setActiveIndex(target);
        return;
      }

      this.$nextTick(function () {
        var nextIndex = content.$children.findIndex(function (i) {
          return i.id === target;
        });
        _this4.reverse = nextIndex < _this4.activeIndex;
        setActiveIndex(nextIndex);
      });
    },
    updateTabs: function updateTabs() {
      var _this5 = this;

      var activators = this.$slots.activators;
      var content = this.$refs.content;

      if (!activators || !activators.length || activators.length && !activators[0].componentInstance) return;

      activators[0].componentInstance.$children.filter(function (i) {
        return i.$options._componentTag === 'v-tabs-item';
      }).forEach(function (i) {
        return i.toggle(_this5.target);
      });

      content && content.$children.forEach(function (i) {
        return i.toggle(_this5.target, _this5.reverse, _this5.isBooted);
      });
    }
  },

  render: function render(h) {
    var content = [];
    var slot = [];
    var iter = this.$slots.default || [];

    iter.forEach(function (c) {
      if (!c.componentOptions) slot.push(c);else if (c.componentOptions.tag === 'v-tabs-content') content.push(c);else slot.push(c);
    });

    var tabs = content.length ? h('v-tabs-items', {
      ref: 'content'
    }, content) : null;

    return h('div', {
      'class': this.classes,
      directives: [{
        name: 'resize',
        value: this.onResize
      }]
    }, [slot, this.$slots.activators, tabs]);
  }
});

/***/ }),
/* 124 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_route_link__ = __webpack_require__(9);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-tabs-item',

  inject: ['slider', 'tabClick'],

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_route_link__["a" /* default */]],

  data: function data() {
    return {
      isActive: false
    };
  },


  props: {
    activeClass: {
      type: String,
      default: 'tabs__item--active'
    }
  },

  computed: {
    classes: function classes() {
      var classes = {
        'tabs__item': true,
        'tabs__item--disabled': this.disabled
      };

      classes[this.activeClass] = !this.to && this.isActive;

      return classes;
    },
    action: function action() {
      var to = this.to || this.href;

      if (!to || to === Object(to)) return this._uid;

      return to.replace('#', '');
    }
  },

  watch: {
    $route: function $route() {
      this.to && this.callSlider();
    }
  },

  mounted: function mounted() {
    this.callSlider();
  },


  methods: {
    callSlider: function callSlider() {
      var _this = this;

      setTimeout(function () {
        _this.$el.firstChild.classList.contains('tabs__item--active') && _this.slider(_this.$el);
      }, 0);
    },
    click: function click(e) {
      e.preventDefault();

      if (!this.to && !this.href) return;

      if (!this.to) {
        this.tabClick(this.action);
      }

      this.callSlider();
    },
    toggle: function toggle(action) {
      var _this2 = this;

      this.isActive = this.action === action;

      this.$nextTick(function () {
        _this2.isActive && _this2.slider(_this2.$el);
      });
    }
  },

  render: function render(h) {
    var _generateRouteLink = this.generateRouteLink(),
        tag = _generateRouteLink.tag,
        data = _generateRouteLink.data;

    return h('li', {
      'class': 'tabs__li'
    }, [h(tag, data, this.$slots.default)]);
  }
});

/***/ }),
/* 125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_bootable__ = __webpack_require__(10);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-tabs-content',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_bootable__["a" /* default */]],

  data: function data() {
    return {
      isActive: false,
      reverse: false
    };
  },


  props: {
    id: {
      type: String,
      required: true
    },
    lazy: Boolean,
    transition: {
      type: String,
      default: 'v-tab-transition'
    },
    reverseTransition: {
      type: String,
      default: 'v-tab-reverse-transition'
    }
  },

  computed: {
    computedTransition: function computedTransition() {
      return this.reverse ? this.reverseTransition : this.transition;
    }
  },

  methods: {
    toggle: function toggle(target, reverse, showTransition) {
      this.$el.style.transition = !showTransition ? 'none' : null;
      this.reverse = reverse;
      this.isActive = this.id === target;
    }
  },

  render: function render(h) {
    return h(this.computedTransition, {}, [h('div', {
      'class': 'tabs__content',
      domProps: { id: this.id },
      directives: [{
        name: 'show',
        value: this.isActive
      }],
      on: this.$listeners
    }, this.lazy && this.isBooted || !this.lazy ? this.$slots.default : null)]);
  }
});

/***/ }),
/* 126 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_icons_VIcon__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__directives__ = __webpack_require__(4);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-tabs-bar',

  directives: {
    Resize: __WEBPACK_IMPORTED_MODULE_1__directives__["Resize"]
  },

  inject: ['isScrollable', 'isMobile'],

  data: function data() {
    return {
      isOverflowing: false,
      scrollOffset: 0,
      itemOffset: 0,
      startX: 0
    };
  },


  computed: {
    classes: function classes() {
      return {
        'tabs__bar': true
      };
    },
    containerClasses: function containerClasses() {
      return {
        'tabs__container': true
      };
    },
    wrapperClasses: function wrapperClasses() {
      return {
        'tabs__wrapper': true,
        'tabs__wrapper--scrollable': this.isScrollable(),
        'tabs__wrapper--overflow': this.isOverflowing
      };
    },
    containerStyles: function containerStyles() {
      return {
        'transform': 'translateX(' + -this.scrollOffset + 'px)'
      };
    },
    leftIconVisible: function leftIconVisible() {
      return !this.isMobile() && this.isScrollable() && this.isOverflowing && this.scrollOffset > 0;
    },
    rightIconVisible: function rightIconVisible() {
      if (this.isMobile() || !this.isScrollable() || !this.isOverflowing) return;

      // Check one scroll ahead to know the width of right-most item
      var container = this.$refs.container;
      var item = this.newOffsetRight(this.scrollOffset, this.itemOffset);
      var itemWidth = item && container.children[item.index].clientWidth || 0;
      var scrollOffset = this.scrollOffset + container.clientWidth;

      return container.scrollWidth - scrollOffset > itemWidth * 0.30;
    }
  },

  methods: {
    genContainer: function genContainer() {
      return this.$createElement('ul', {
        'class': this.containerClasses,
        'style': this.containerStyles,
        ref: 'container'
      }, this.$slots.default);
    },
    genIcon: function genIcon(direction) {
      var capitalize = direction.charAt(0).toUpperCase() + direction.slice(1);
      return this.$createElement(__WEBPACK_IMPORTED_MODULE_0__components_icons_VIcon__["a" /* default */], {
        props: _defineProperty({}, '' + direction, true),
        style: { display: 'inline-flex' },
        on: {
          click: this['scroll' + capitalize]
        }
      }, 'chevron_' + direction);
    },
    genWrapper: function genWrapper() {
      return this.$createElement('div', {
        class: this.wrapperClasses,
        directives: [{
          name: 'touch',
          value: {
            start: this.start,
            move: this.move,
            end: this.end
          }
        }]
      }, [this.genContainer()]);
    },
    start: function start(e) {
      this.startX = this.scrollOffset + e.touchstartX;
      this.$refs.container.style.transition = 'none';
    },
    move: function move(e) {
      var offset = this.startX - e.touchmoveX;
      this.scrollOffset = offset;
    },
    end: function end(e) {
      this.onResize();
      var container = this.$refs.container;
      var scrollWidth = container.scrollWidth - this.$el.clientWidth / 2;
      container.style.transition = null;

      if (this.scrollOffset < 0 || !this.isOverflowing) {
        this.scrollOffset = 0;
      } else if (this.scrollOffset >= scrollWidth) {
        var lastItem = container.children[container.children.length - 1];
        this.scrollOffset = scrollWidth - lastItem.clientWidth;
      }
    },
    scrollLeft: function scrollLeft() {
      var _newOffset = this.newOffset('Left'),
          offset = _newOffset.offset,
          index = _newOffset.index;

      this.scrollOffset = offset;
      this.itemOffset = index;
    },
    scrollRight: function scrollRight() {
      var _newOffset2 = this.newOffset('Right'),
          offset = _newOffset2.offset,
          index = _newOffset2.index;

      this.scrollOffset = offset;
      this.itemOffset = index;
    },
    onResize: function onResize() {
      if (this._isDestroyed) return;

      var container = this.$refs.container;
      this.isOverflowing = container.clientWidth < container.scrollWidth;
    },
    newOffset: function newOffset(direction) {
      return this['newOffset' + direction](this.scrollOffset, this.itemOffset);
    },
    newOffsetLeft: function newOffsetLeft(currentOffset, currentIndex) {
      var container = this.$refs.container;
      var items = container.children;
      var offset = 0;

      for (var index = currentIndex - 1; index >= 0; index--) {
        if (!items[index].classList.contains('tabs__slider')) {
          var newOffset = offset + items[index].clientWidth;
          if (newOffset >= container.clientWidth) {
            return { offset: currentOffset - offset, index: index + 1 };
          }
          offset = newOffset;
        }
      }

      return { offset: 0, index: 0 };
    },
    newOffsetRight: function newOffsetRight(currentOffset, currentIndex) {
      var container = this.$refs.container;
      var items = container.children;
      var offset = currentOffset;

      for (var index = currentIndex; index < items.length; index++) {
        if (!items[index].classList.contains('tabs__slider')) {
          var newOffset = offset + items[index].clientWidth;
          if (newOffset > currentOffset + container.clientWidth) {
            return { offset: offset, index: index };
          }
          offset = newOffset;
        }
      }

      return null;
    }
  },

  render: function render(h) {
    return h('div', {
      'class': this.classes,
      directives: [{
        name: 'resize',
        value: this.onResize
      }]
    }, [this.genWrapper(), this.leftIconVisible ? this.genIcon('left') : null, this.rightIconVisible ? this.genIcon('right') : null]);
  }
});

/***/ }),
/* 127 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VTextField__ = __webpack_require__(128);


/* harmony default export */ __webpack_exports__["a"] = ({
  VTextField: __WEBPACK_IMPORTED_MODULE_0__VTextField__["a" /* default */]
});

/***/ }),
/* 128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_input__ = __webpack_require__(7);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-text-field',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_input__["a" /* default */]],

  inheritAttrs: false,

  data: function data() {
    return {
      hasFocused: false,
      inputHeight: null
    };
  },


  props: {
    autofocus: Boolean,
    autoGrow: Boolean,
    counter: Boolean,
    fullWidth: Boolean,
    max: [Number, String],
    min: [Number, String],
    multiLine: Boolean,
    placeholder: String,
    prefix: String,
    rows: {
      default: 5
    },
    singleLine: Boolean,
    solo: Boolean,
    suffix: String,
    textarea: Boolean,
    type: {
      type: String,
      default: 'text'
    }
  },

  computed: {
    classes: function classes() {
      return {
        'input-group--text-field': true,
        'input-group--single-line': this.singleLine,
        'input-group--solo': this.solo,
        'input-group--multi-line': this.multiLine,
        'input-group--full-width': this.fullWidth,
        'input-group--prefix': this.prefix,
        'input-group--suffix': this.suffix,
        'input-group--textarea': this.textarea
      };
    },
    hasError: function hasError() {
      return this.validations.length || this.errorMessages.length > 0 || !this.counterIsValid() || !this.validateIsValid() || this.error;
    },
    count: function count() {
      var inputLength = void 0;
      if (this.inputValue) inputLength = this.inputValue.toString().length;else inputLength = 0;
      var min = inputLength;

      if (this.counterMin !== 0 && inputLength < this.counterMin) {
        min = this.counterMin;
      }

      return min + ' / ' + this.counterMax;
    },
    counterMin: function counterMin() {
      var parsedMin = parseInt(this.min, 10);
      return isNaN(parsedMin) ? 0 : parsedMin;
    },
    counterMax: function counterMax() {
      var parsedMax = parseInt(this.max, 10);
      return isNaN(parsedMax) ? 25 : parsedMax;
    },

    inputValue: {
      get: function get() {
        return this.value;
      },
      set: function set(val) {
        if (this.modifiers.trim) {
          val = val.trim();
        }

        if (this.modifiers.number) {
          val = Number(val);
        }

        if (!this.modifiers.lazy) {
          this.$emit('input', val);
        }

        this.lazyValue = val;
      }
    },
    isDirty: function isDirty() {
      return this.lazyValue !== null && typeof this.lazyValue !== 'undefined' && this.lazyValue.toString().length > 0 || this.placeholder;
    }
  },

  watch: {
    focused: function focused(val) {
      this.hasFocused = true;
    },
    value: function value() {
      this.lazyValue = this.value;
      this.validate();
      this.multiLine && this.autoGrow && this.calculateInputHeight();
    }
  },

  mounted: function mounted() {
    var _this = this;

    this.$vuetify.load(function () {
      _this.multiLine && _this.autoGrow && _this.calculateInputHeight();
      _this.autofocus && _this.focus();
    });
  },


  methods: {
    calculateInputHeight: function calculateInputHeight() {
      var _this2 = this;

      this.inputHeight = null;

      this.$nextTick(function () {
        var height = _this2.$refs.input.scrollHeight;
        var minHeight = _this2.rows * 24;
        var inputHeight = height < minHeight ? minHeight : height;
        _this2.inputHeight = inputHeight;
      });
    },
    onChange: function onChange(e) {
      this.lazyValue = e.target.value;
      this.$emit('change', this.lazyValue || null);
    },
    onInput: function onInput(e) {
      this.inputValue = e.target.value;
      this.multiLine && this.autoGrow && this.calculateInputHeight();
    },
    blur: function blur(e) {
      var _this3 = this;

      this.validate();
      this.$nextTick(function () {
        return _this3.focused = false;
      });
      this.$emit('blur', e);
    },
    focus: function focus(e) {
      this.focused = true;
      this.$refs.input.focus();
      this.$emit('focus', e);
    },
    genCounter: function genCounter() {
      return this.$createElement('div', {
        'class': {
          'input-group__counter': true,
          'input-group__counter--error': !this.counterIsValid()
        }
      }, this.count);
    },
    genInput: function genInput() {
      var tag = this.multiLine || this.textarea ? 'textarea' : 'input';

      var data = {
        style: {
          'height': this.inputHeight && this.inputHeight + 'px'
        },
        domProps: {
          autofocus: this.autofocus,
          disabled: this.disabled,
          required: this.required,
          value: this.lazyValue
        },
        attrs: _extends({}, this.$attrs, {
          tabindex: this.tabindex,
          'aria-label': !this.$attrs.id && this.label // Label `for` will be set if we have an id
        }),
        on: _extends({}, this.$listeners, {
          blur: this.blur,
          input: this.onInput,
          focus: this.focus
        }),
        ref: 'input'
      };

      if (this.placeholder) data.domProps.placeholder = this.placeholder;

      if (!this.counter) {
        if (![undefined, null].includes(this.max)) data.attrs.max = this.max;
        if (![undefined, null].includes(this.min)) data.attrs.min = this.min;
      }

      if (!this.textarea && !this.multiLine) {
        data.domProps.type = this.type;
      } else {
        data.domProps.rows = this.rows;
      }

      var children = [this.$createElement(tag, data)];

      this.prefix && children.unshift(this.genFix('prefix'));
      this.suffix && children.push(this.genFix('suffix'));

      return children;
    },
    genFix: function genFix(type) {
      return this.$createElement('span', {
        'class': 'input-group--text-field__' + type
      }, this[type]);
    },

    counterIsValid: function counterIsValid() {
      var val = this.inputValue && this.inputValue.toString() || '';

      return !this.counter || val.length >= this.counterMin && val.length <= this.counterMax;
    },
    validateIsValid: function validateIsValid() {
      return !this.required || this.required && this.isDirty || !this.hasFocused || this.hasFocused && this.focused;
    }
  },

  render: function render() {
    return this.genInputGroup(this.genInput(), { attrs: { tabindex: false } });
  }
});

/***/ }),
/* 129 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VSnackbar__ = __webpack_require__(130);


/* harmony default export */ __webpack_exports__["a"] = ({
  VSnackbar: __WEBPACK_IMPORTED_MODULE_0__VSnackbar__["a" /* default */]
});

/***/ }),
/* 130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__ = __webpack_require__(2);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-snackbar',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__["a" /* default */]],

  data: function data() {
    return {
      activeTimeout: {}
    };
  },


  props: {
    absolute: Boolean,
    bottom: Boolean,
    left: Boolean,
    multiLine: Boolean,
    right: Boolean,
    top: Boolean,
    timeout: {
      type: Number,
      default: 6000
    },
    vertical: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'snack': true,
        'snack--active': this.isActive,
        'snack--absolute': this.absolute,
        'snack--bottom': this.bottom || !this.top,
        'snack--left': this.left,
        'snack--multi-line': this.multiLine && !this.vertical,
        'snack--right': this.right,
        'snack--top': this.top,
        'snack--vertical': this.vertical,
        'primary': this.primary,
        'secondary': this.secondary,
        'success': this.success,
        'info': this.info,
        'warning': this.warning,
        'error': this.error
      };
    },
    computedTransition: function computedTransition() {
      return this.top ? 'v-slide-y-transition' : 'v-slide-y-reverse-transition';
    }
  },

  watch: {
    isActive: function isActive() {
      var _this = this;

      clearTimeout(this.activeTimeout);

      if (this.isActive && this.timeout) {
        this.activeTimeout = setTimeout(function () {
          _this.isActive = false;
        }, this.timeout);
      }
    }
  },

  render: function render(h) {
    var children = [];

    if (this.isActive) {
      children.push(h('div', {
        'class': 'snack__content'
      }, this.$slots.default));
    }

    return h('div', {
      'class': this.classes,
      on: this.$listeners
    }, [h(this.computedTransition, children)]);
  }
});

/***/ }),
/* 131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function load(cb) {
  var i = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

  if (document.readyState === 'complete') {
    return setTimeout(cb, 0);
  }

  if (document.readyState === 'interactive' && i <= 10) {
    return setTimeout(function () {
      return load(cb, i + 1);
    }, 200);
  }

  window.addEventListener('load', cb);
}

/* harmony default export */ __webpack_exports__["a"] = (load);

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {exports = module.exports = SemVer;

// The debug function is excluded entirely from the minified version.
/* nomin */ var debug;
/* nomin */ if (typeof process === 'object' &&
    /* nomin */ process.env &&
    /* nomin */ process.env.NODE_DEBUG &&
    /* nomin */ /\bsemver\b/i.test(process.env.NODE_DEBUG))
  /* nomin */ debug = function() {
    /* nomin */ var args = Array.prototype.slice.call(arguments, 0);
    /* nomin */ args.unshift('SEMVER');
    /* nomin */ console.log.apply(console, args);
    /* nomin */ };
/* nomin */ else
  /* nomin */ debug = function() {};

// Note: this is the semver.org version of the spec that it implements
// Not necessarily the package version of this code.
exports.SEMVER_SPEC_VERSION = '2.0.0';

var MAX_LENGTH = 256;
var MAX_SAFE_INTEGER = Number.MAX_SAFE_INTEGER || 9007199254740991;

// The actual regexps go on exports.re
var re = exports.re = [];
var src = exports.src = [];
var R = 0;

// The following Regular Expressions can be used for tokenizing,
// validating, and parsing SemVer version strings.

// ## Numeric Identifier
// A single `0`, or a non-zero digit followed by zero or more digits.

var NUMERICIDENTIFIER = R++;
src[NUMERICIDENTIFIER] = '0|[1-9]\\d*';
var NUMERICIDENTIFIERLOOSE = R++;
src[NUMERICIDENTIFIERLOOSE] = '[0-9]+';


// ## Non-numeric Identifier
// Zero or more digits, followed by a letter or hyphen, and then zero or
// more letters, digits, or hyphens.

var NONNUMERICIDENTIFIER = R++;
src[NONNUMERICIDENTIFIER] = '\\d*[a-zA-Z-][a-zA-Z0-9-]*';


// ## Main Version
// Three dot-separated numeric identifiers.

var MAINVERSION = R++;
src[MAINVERSION] = '(' + src[NUMERICIDENTIFIER] + ')\\.' +
                   '(' + src[NUMERICIDENTIFIER] + ')\\.' +
                   '(' + src[NUMERICIDENTIFIER] + ')';

var MAINVERSIONLOOSE = R++;
src[MAINVERSIONLOOSE] = '(' + src[NUMERICIDENTIFIERLOOSE] + ')\\.' +
                        '(' + src[NUMERICIDENTIFIERLOOSE] + ')\\.' +
                        '(' + src[NUMERICIDENTIFIERLOOSE] + ')';

// ## Pre-release Version Identifier
// A numeric identifier, or a non-numeric identifier.

var PRERELEASEIDENTIFIER = R++;
src[PRERELEASEIDENTIFIER] = '(?:' + src[NUMERICIDENTIFIER] +
                            '|' + src[NONNUMERICIDENTIFIER] + ')';

var PRERELEASEIDENTIFIERLOOSE = R++;
src[PRERELEASEIDENTIFIERLOOSE] = '(?:' + src[NUMERICIDENTIFIERLOOSE] +
                                 '|' + src[NONNUMERICIDENTIFIER] + ')';


// ## Pre-release Version
// Hyphen, followed by one or more dot-separated pre-release version
// identifiers.

var PRERELEASE = R++;
src[PRERELEASE] = '(?:-(' + src[PRERELEASEIDENTIFIER] +
                  '(?:\\.' + src[PRERELEASEIDENTIFIER] + ')*))';

var PRERELEASELOOSE = R++;
src[PRERELEASELOOSE] = '(?:-?(' + src[PRERELEASEIDENTIFIERLOOSE] +
                       '(?:\\.' + src[PRERELEASEIDENTIFIERLOOSE] + ')*))';

// ## Build Metadata Identifier
// Any combination of digits, letters, or hyphens.

var BUILDIDENTIFIER = R++;
src[BUILDIDENTIFIER] = '[0-9A-Za-z-]+';

// ## Build Metadata
// Plus sign, followed by one or more period-separated build metadata
// identifiers.

var BUILD = R++;
src[BUILD] = '(?:\\+(' + src[BUILDIDENTIFIER] +
             '(?:\\.' + src[BUILDIDENTIFIER] + ')*))';


// ## Full Version String
// A main version, followed optionally by a pre-release version and
// build metadata.

// Note that the only major, minor, patch, and pre-release sections of
// the version string are capturing groups.  The build metadata is not a
// capturing group, because it should not ever be used in version
// comparison.

var FULL = R++;
var FULLPLAIN = 'v?' + src[MAINVERSION] +
                src[PRERELEASE] + '?' +
                src[BUILD] + '?';

src[FULL] = '^' + FULLPLAIN + '$';

// like full, but allows v1.2.3 and =1.2.3, which people do sometimes.
// also, 1.0.0alpha1 (prerelease without the hyphen) which is pretty
// common in the npm registry.
var LOOSEPLAIN = '[v=\\s]*' + src[MAINVERSIONLOOSE] +
                 src[PRERELEASELOOSE] + '?' +
                 src[BUILD] + '?';

var LOOSE = R++;
src[LOOSE] = '^' + LOOSEPLAIN + '$';

var GTLT = R++;
src[GTLT] = '((?:<|>)?=?)';

// Something like "2.*" or "1.2.x".
// Note that "x.x" is a valid xRange identifer, meaning "any version"
// Only the first item is strictly required.
var XRANGEIDENTIFIERLOOSE = R++;
src[XRANGEIDENTIFIERLOOSE] = src[NUMERICIDENTIFIERLOOSE] + '|x|X|\\*';
var XRANGEIDENTIFIER = R++;
src[XRANGEIDENTIFIER] = src[NUMERICIDENTIFIER] + '|x|X|\\*';

var XRANGEPLAIN = R++;
src[XRANGEPLAIN] = '[v=\\s]*(' + src[XRANGEIDENTIFIER] + ')' +
                   '(?:\\.(' + src[XRANGEIDENTIFIER] + ')' +
                   '(?:\\.(' + src[XRANGEIDENTIFIER] + ')' +
                   '(?:' + src[PRERELEASE] + ')?' +
                   src[BUILD] + '?' +
                   ')?)?';

var XRANGEPLAINLOOSE = R++;
src[XRANGEPLAINLOOSE] = '[v=\\s]*(' + src[XRANGEIDENTIFIERLOOSE] + ')' +
                        '(?:\\.(' + src[XRANGEIDENTIFIERLOOSE] + ')' +
                        '(?:\\.(' + src[XRANGEIDENTIFIERLOOSE] + ')' +
                        '(?:' + src[PRERELEASELOOSE] + ')?' +
                        src[BUILD] + '?' +
                        ')?)?';

var XRANGE = R++;
src[XRANGE] = '^' + src[GTLT] + '\\s*' + src[XRANGEPLAIN] + '$';
var XRANGELOOSE = R++;
src[XRANGELOOSE] = '^' + src[GTLT] + '\\s*' + src[XRANGEPLAINLOOSE] + '$';

// Tilde ranges.
// Meaning is "reasonably at or greater than"
var LONETILDE = R++;
src[LONETILDE] = '(?:~>?)';

var TILDETRIM = R++;
src[TILDETRIM] = '(\\s*)' + src[LONETILDE] + '\\s+';
re[TILDETRIM] = new RegExp(src[TILDETRIM], 'g');
var tildeTrimReplace = '$1~';

var TILDE = R++;
src[TILDE] = '^' + src[LONETILDE] + src[XRANGEPLAIN] + '$';
var TILDELOOSE = R++;
src[TILDELOOSE] = '^' + src[LONETILDE] + src[XRANGEPLAINLOOSE] + '$';

// Caret ranges.
// Meaning is "at least and backwards compatible with"
var LONECARET = R++;
src[LONECARET] = '(?:\\^)';

var CARETTRIM = R++;
src[CARETTRIM] = '(\\s*)' + src[LONECARET] + '\\s+';
re[CARETTRIM] = new RegExp(src[CARETTRIM], 'g');
var caretTrimReplace = '$1^';

var CARET = R++;
src[CARET] = '^' + src[LONECARET] + src[XRANGEPLAIN] + '$';
var CARETLOOSE = R++;
src[CARETLOOSE] = '^' + src[LONECARET] + src[XRANGEPLAINLOOSE] + '$';

// A simple gt/lt/eq thing, or just "" to indicate "any version"
var COMPARATORLOOSE = R++;
src[COMPARATORLOOSE] = '^' + src[GTLT] + '\\s*(' + LOOSEPLAIN + ')$|^$';
var COMPARATOR = R++;
src[COMPARATOR] = '^' + src[GTLT] + '\\s*(' + FULLPLAIN + ')$|^$';


// An expression to strip any whitespace between the gtlt and the thing
// it modifies, so that `> 1.2.3` ==> `>1.2.3`
var COMPARATORTRIM = R++;
src[COMPARATORTRIM] = '(\\s*)' + src[GTLT] +
                      '\\s*(' + LOOSEPLAIN + '|' + src[XRANGEPLAIN] + ')';

// this one has to use the /g flag
re[COMPARATORTRIM] = new RegExp(src[COMPARATORTRIM], 'g');
var comparatorTrimReplace = '$1$2$3';


// Something like `1.2.3 - 1.2.4`
// Note that these all use the loose form, because they'll be
// checked against either the strict or loose comparator form
// later.
var HYPHENRANGE = R++;
src[HYPHENRANGE] = '^\\s*(' + src[XRANGEPLAIN] + ')' +
                   '\\s+-\\s+' +
                   '(' + src[XRANGEPLAIN] + ')' +
                   '\\s*$';

var HYPHENRANGELOOSE = R++;
src[HYPHENRANGELOOSE] = '^\\s*(' + src[XRANGEPLAINLOOSE] + ')' +
                        '\\s+-\\s+' +
                        '(' + src[XRANGEPLAINLOOSE] + ')' +
                        '\\s*$';

// Star ranges basically just allow anything at all.
var STAR = R++;
src[STAR] = '(<|>)?=?\\s*\\*';

// Compile to actual regexp objects.
// All are flag-free, unless they were created above with a flag.
for (var i = 0; i < R; i++) {
  debug(i, src[i]);
  if (!re[i])
    re[i] = new RegExp(src[i]);
}

exports.parse = parse;
function parse(version, loose) {
  if (version instanceof SemVer)
    return version;

  if (typeof version !== 'string')
    return null;

  if (version.length > MAX_LENGTH)
    return null;

  var r = loose ? re[LOOSE] : re[FULL];
  if (!r.test(version))
    return null;

  try {
    return new SemVer(version, loose);
  } catch (er) {
    return null;
  }
}

exports.valid = valid;
function valid(version, loose) {
  var v = parse(version, loose);
  return v ? v.version : null;
}


exports.clean = clean;
function clean(version, loose) {
  var s = parse(version.trim().replace(/^[=v]+/, ''), loose);
  return s ? s.version : null;
}

exports.SemVer = SemVer;

function SemVer(version, loose) {
  if (version instanceof SemVer) {
    if (version.loose === loose)
      return version;
    else
      version = version.version;
  } else if (typeof version !== 'string') {
    throw new TypeError('Invalid Version: ' + version);
  }

  if (version.length > MAX_LENGTH)
    throw new TypeError('version is longer than ' + MAX_LENGTH + ' characters')

  if (!(this instanceof SemVer))
    return new SemVer(version, loose);

  debug('SemVer', version, loose);
  this.loose = loose;
  var m = version.trim().match(loose ? re[LOOSE] : re[FULL]);

  if (!m)
    throw new TypeError('Invalid Version: ' + version);

  this.raw = version;

  // these are actually numbers
  this.major = +m[1];
  this.minor = +m[2];
  this.patch = +m[3];

  if (this.major > MAX_SAFE_INTEGER || this.major < 0)
    throw new TypeError('Invalid major version')

  if (this.minor > MAX_SAFE_INTEGER || this.minor < 0)
    throw new TypeError('Invalid minor version')

  if (this.patch > MAX_SAFE_INTEGER || this.patch < 0)
    throw new TypeError('Invalid patch version')

  // numberify any prerelease numeric ids
  if (!m[4])
    this.prerelease = [];
  else
    this.prerelease = m[4].split('.').map(function(id) {
      if (/^[0-9]+$/.test(id)) {
        var num = +id;
        if (num >= 0 && num < MAX_SAFE_INTEGER)
          return num;
      }
      return id;
    });

  this.build = m[5] ? m[5].split('.') : [];
  this.format();
}

SemVer.prototype.format = function() {
  this.version = this.major + '.' + this.minor + '.' + this.patch;
  if (this.prerelease.length)
    this.version += '-' + this.prerelease.join('.');
  return this.version;
};

SemVer.prototype.toString = function() {
  return this.version;
};

SemVer.prototype.compare = function(other) {
  debug('SemVer.compare', this.version, this.loose, other);
  if (!(other instanceof SemVer))
    other = new SemVer(other, this.loose);

  return this.compareMain(other) || this.comparePre(other);
};

SemVer.prototype.compareMain = function(other) {
  if (!(other instanceof SemVer))
    other = new SemVer(other, this.loose);

  return compareIdentifiers(this.major, other.major) ||
         compareIdentifiers(this.minor, other.minor) ||
         compareIdentifiers(this.patch, other.patch);
};

SemVer.prototype.comparePre = function(other) {
  if (!(other instanceof SemVer))
    other = new SemVer(other, this.loose);

  // NOT having a prerelease is > having one
  if (this.prerelease.length && !other.prerelease.length)
    return -1;
  else if (!this.prerelease.length && other.prerelease.length)
    return 1;
  else if (!this.prerelease.length && !other.prerelease.length)
    return 0;

  var i = 0;
  do {
    var a = this.prerelease[i];
    var b = other.prerelease[i];
    debug('prerelease compare', i, a, b);
    if (a === undefined && b === undefined)
      return 0;
    else if (b === undefined)
      return 1;
    else if (a === undefined)
      return -1;
    else if (a === b)
      continue;
    else
      return compareIdentifiers(a, b);
  } while (++i);
};

// preminor will bump the version up to the next minor release, and immediately
// down to pre-release. premajor and prepatch work the same way.
SemVer.prototype.inc = function(release, identifier) {
  switch (release) {
    case 'premajor':
      this.prerelease.length = 0;
      this.patch = 0;
      this.minor = 0;
      this.major++;
      this.inc('pre', identifier);
      break;
    case 'preminor':
      this.prerelease.length = 0;
      this.patch = 0;
      this.minor++;
      this.inc('pre', identifier);
      break;
    case 'prepatch':
      // If this is already a prerelease, it will bump to the next version
      // drop any prereleases that might already exist, since they are not
      // relevant at this point.
      this.prerelease.length = 0;
      this.inc('patch', identifier);
      this.inc('pre', identifier);
      break;
    // If the input is a non-prerelease version, this acts the same as
    // prepatch.
    case 'prerelease':
      if (this.prerelease.length === 0)
        this.inc('patch', identifier);
      this.inc('pre', identifier);
      break;

    case 'major':
      // If this is a pre-major version, bump up to the same major version.
      // Otherwise increment major.
      // 1.0.0-5 bumps to 1.0.0
      // 1.1.0 bumps to 2.0.0
      if (this.minor !== 0 || this.patch !== 0 || this.prerelease.length === 0)
        this.major++;
      this.minor = 0;
      this.patch = 0;
      this.prerelease = [];
      break;
    case 'minor':
      // If this is a pre-minor version, bump up to the same minor version.
      // Otherwise increment minor.
      // 1.2.0-5 bumps to 1.2.0
      // 1.2.1 bumps to 1.3.0
      if (this.patch !== 0 || this.prerelease.length === 0)
        this.minor++;
      this.patch = 0;
      this.prerelease = [];
      break;
    case 'patch':
      // If this is not a pre-release version, it will increment the patch.
      // If it is a pre-release it will bump up to the same patch version.
      // 1.2.0-5 patches to 1.2.0
      // 1.2.0 patches to 1.2.1
      if (this.prerelease.length === 0)
        this.patch++;
      this.prerelease = [];
      break;
    // This probably shouldn't be used publicly.
    // 1.0.0 "pre" would become 1.0.0-0 which is the wrong direction.
    case 'pre':
      if (this.prerelease.length === 0)
        this.prerelease = [0];
      else {
        var i = this.prerelease.length;
        while (--i >= 0) {
          if (typeof this.prerelease[i] === 'number') {
            this.prerelease[i]++;
            i = -2;
          }
        }
        if (i === -1) // didn't increment anything
          this.prerelease.push(0);
      }
      if (identifier) {
        // 1.2.0-beta.1 bumps to 1.2.0-beta.2,
        // 1.2.0-beta.fooblz or 1.2.0-beta bumps to 1.2.0-beta.0
        if (this.prerelease[0] === identifier) {
          if (isNaN(this.prerelease[1]))
            this.prerelease = [identifier, 0];
        } else
          this.prerelease = [identifier, 0];
      }
      break;

    default:
      throw new Error('invalid increment argument: ' + release);
  }
  this.format();
  this.raw = this.version;
  return this;
};

exports.inc = inc;
function inc(version, release, loose, identifier) {
  if (typeof(loose) === 'string') {
    identifier = loose;
    loose = undefined;
  }

  try {
    return new SemVer(version, loose).inc(release, identifier).version;
  } catch (er) {
    return null;
  }
}

exports.diff = diff;
function diff(version1, version2) {
  if (eq(version1, version2)) {
    return null;
  } else {
    var v1 = parse(version1);
    var v2 = parse(version2);
    if (v1.prerelease.length || v2.prerelease.length) {
      for (var key in v1) {
        if (key === 'major' || key === 'minor' || key === 'patch') {
          if (v1[key] !== v2[key]) {
            return 'pre'+key;
          }
        }
      }
      return 'prerelease';
    }
    for (var key in v1) {
      if (key === 'major' || key === 'minor' || key === 'patch') {
        if (v1[key] !== v2[key]) {
          return key;
        }
      }
    }
  }
}

exports.compareIdentifiers = compareIdentifiers;

var numeric = /^[0-9]+$/;
function compareIdentifiers(a, b) {
  var anum = numeric.test(a);
  var bnum = numeric.test(b);

  if (anum && bnum) {
    a = +a;
    b = +b;
  }

  return (anum && !bnum) ? -1 :
         (bnum && !anum) ? 1 :
         a < b ? -1 :
         a > b ? 1 :
         0;
}

exports.rcompareIdentifiers = rcompareIdentifiers;
function rcompareIdentifiers(a, b) {
  return compareIdentifiers(b, a);
}

exports.major = major;
function major(a, loose) {
  return new SemVer(a, loose).major;
}

exports.minor = minor;
function minor(a, loose) {
  return new SemVer(a, loose).minor;
}

exports.patch = patch;
function patch(a, loose) {
  return new SemVer(a, loose).patch;
}

exports.compare = compare;
function compare(a, b, loose) {
  return new SemVer(a, loose).compare(b);
}

exports.compareLoose = compareLoose;
function compareLoose(a, b) {
  return compare(a, b, true);
}

exports.rcompare = rcompare;
function rcompare(a, b, loose) {
  return compare(b, a, loose);
}

exports.sort = sort;
function sort(list, loose) {
  return list.sort(function(a, b) {
    return exports.compare(a, b, loose);
  });
}

exports.rsort = rsort;
function rsort(list, loose) {
  return list.sort(function(a, b) {
    return exports.rcompare(a, b, loose);
  });
}

exports.gt = gt;
function gt(a, b, loose) {
  return compare(a, b, loose) > 0;
}

exports.lt = lt;
function lt(a, b, loose) {
  return compare(a, b, loose) < 0;
}

exports.eq = eq;
function eq(a, b, loose) {
  return compare(a, b, loose) === 0;
}

exports.neq = neq;
function neq(a, b, loose) {
  return compare(a, b, loose) !== 0;
}

exports.gte = gte;
function gte(a, b, loose) {
  return compare(a, b, loose) >= 0;
}

exports.lte = lte;
function lte(a, b, loose) {
  return compare(a, b, loose) <= 0;
}

exports.cmp = cmp;
function cmp(a, op, b, loose) {
  var ret;
  switch (op) {
    case '===':
      if (typeof a === 'object') a = a.version;
      if (typeof b === 'object') b = b.version;
      ret = a === b;
      break;
    case '!==':
      if (typeof a === 'object') a = a.version;
      if (typeof b === 'object') b = b.version;
      ret = a !== b;
      break;
    case '': case '=': case '==': ret = eq(a, b, loose); break;
    case '!=': ret = neq(a, b, loose); break;
    case '>': ret = gt(a, b, loose); break;
    case '>=': ret = gte(a, b, loose); break;
    case '<': ret = lt(a, b, loose); break;
    case '<=': ret = lte(a, b, loose); break;
    default: throw new TypeError('Invalid operator: ' + op);
  }
  return ret;
}

exports.Comparator = Comparator;
function Comparator(comp, loose) {
  if (comp instanceof Comparator) {
    if (comp.loose === loose)
      return comp;
    else
      comp = comp.value;
  }

  if (!(this instanceof Comparator))
    return new Comparator(comp, loose);

  debug('comparator', comp, loose);
  this.loose = loose;
  this.parse(comp);

  if (this.semver === ANY)
    this.value = '';
  else
    this.value = this.operator + this.semver.version;

  debug('comp', this);
}

var ANY = {};
Comparator.prototype.parse = function(comp) {
  var r = this.loose ? re[COMPARATORLOOSE] : re[COMPARATOR];
  var m = comp.match(r);

  if (!m)
    throw new TypeError('Invalid comparator: ' + comp);

  this.operator = m[1];
  if (this.operator === '=')
    this.operator = '';

  // if it literally is just '>' or '' then allow anything.
  if (!m[2])
    this.semver = ANY;
  else
    this.semver = new SemVer(m[2], this.loose);
};

Comparator.prototype.toString = function() {
  return this.value;
};

Comparator.prototype.test = function(version) {
  debug('Comparator.test', version, this.loose);

  if (this.semver === ANY)
    return true;

  if (typeof version === 'string')
    version = new SemVer(version, this.loose);

  return cmp(version, this.operator, this.semver, this.loose);
};


exports.Range = Range;
function Range(range, loose) {
  if ((range instanceof Range) && range.loose === loose)
    return range;

  if (!(this instanceof Range))
    return new Range(range, loose);

  this.loose = loose;

  // First, split based on boolean or ||
  this.raw = range;
  this.set = range.split(/\s*\|\|\s*/).map(function(range) {
    return this.parseRange(range.trim());
  }, this).filter(function(c) {
    // throw out any that are not relevant for whatever reason
    return c.length;
  });

  if (!this.set.length) {
    throw new TypeError('Invalid SemVer Range: ' + range);
  }

  this.format();
}

Range.prototype.format = function() {
  this.range = this.set.map(function(comps) {
    return comps.join(' ').trim();
  }).join('||').trim();
  return this.range;
};

Range.prototype.toString = function() {
  return this.range;
};

Range.prototype.parseRange = function(range) {
  var loose = this.loose;
  range = range.trim();
  debug('range', range, loose);
  // `1.2.3 - 1.2.4` => `>=1.2.3 <=1.2.4`
  var hr = loose ? re[HYPHENRANGELOOSE] : re[HYPHENRANGE];
  range = range.replace(hr, hyphenReplace);
  debug('hyphen replace', range);
  // `> 1.2.3 < 1.2.5` => `>1.2.3 <1.2.5`
  range = range.replace(re[COMPARATORTRIM], comparatorTrimReplace);
  debug('comparator trim', range, re[COMPARATORTRIM]);

  // `~ 1.2.3` => `~1.2.3`
  range = range.replace(re[TILDETRIM], tildeTrimReplace);

  // `^ 1.2.3` => `^1.2.3`
  range = range.replace(re[CARETTRIM], caretTrimReplace);

  // normalize spaces
  range = range.split(/\s+/).join(' ');

  // At this point, the range is completely trimmed and
  // ready to be split into comparators.

  var compRe = loose ? re[COMPARATORLOOSE] : re[COMPARATOR];
  var set = range.split(' ').map(function(comp) {
    return parseComparator(comp, loose);
  }).join(' ').split(/\s+/);
  if (this.loose) {
    // in loose mode, throw out any that are not valid comparators
    set = set.filter(function(comp) {
      return !!comp.match(compRe);
    });
  }
  set = set.map(function(comp) {
    return new Comparator(comp, loose);
  });

  return set;
};

// Mostly just for testing and legacy API reasons
exports.toComparators = toComparators;
function toComparators(range, loose) {
  return new Range(range, loose).set.map(function(comp) {
    return comp.map(function(c) {
      return c.value;
    }).join(' ').trim().split(' ');
  });
}

// comprised of xranges, tildes, stars, and gtlt's at this point.
// already replaced the hyphen ranges
// turn into a set of JUST comparators.
function parseComparator(comp, loose) {
  debug('comp', comp);
  comp = replaceCarets(comp, loose);
  debug('caret', comp);
  comp = replaceTildes(comp, loose);
  debug('tildes', comp);
  comp = replaceXRanges(comp, loose);
  debug('xrange', comp);
  comp = replaceStars(comp, loose);
  debug('stars', comp);
  return comp;
}

function isX(id) {
  return !id || id.toLowerCase() === 'x' || id === '*';
}

// ~, ~> --> * (any, kinda silly)
// ~2, ~2.x, ~2.x.x, ~>2, ~>2.x ~>2.x.x --> >=2.0.0 <3.0.0
// ~2.0, ~2.0.x, ~>2.0, ~>2.0.x --> >=2.0.0 <2.1.0
// ~1.2, ~1.2.x, ~>1.2, ~>1.2.x --> >=1.2.0 <1.3.0
// ~1.2.3, ~>1.2.3 --> >=1.2.3 <1.3.0
// ~1.2.0, ~>1.2.0 --> >=1.2.0 <1.3.0
function replaceTildes(comp, loose) {
  return comp.trim().split(/\s+/).map(function(comp) {
    return replaceTilde(comp, loose);
  }).join(' ');
}

function replaceTilde(comp, loose) {
  var r = loose ? re[TILDELOOSE] : re[TILDE];
  return comp.replace(r, function(_, M, m, p, pr) {
    debug('tilde', comp, _, M, m, p, pr);
    var ret;

    if (isX(M))
      ret = '';
    else if (isX(m))
      ret = '>=' + M + '.0.0 <' + (+M + 1) + '.0.0';
    else if (isX(p))
      // ~1.2 == >=1.2.0 <1.3.0
      ret = '>=' + M + '.' + m + '.0 <' + M + '.' + (+m + 1) + '.0';
    else if (pr) {
      debug('replaceTilde pr', pr);
      if (pr.charAt(0) !== '-')
        pr = '-' + pr;
      ret = '>=' + M + '.' + m + '.' + p + pr +
            ' <' + M + '.' + (+m + 1) + '.0';
    } else
      // ~1.2.3 == >=1.2.3 <1.3.0
      ret = '>=' + M + '.' + m + '.' + p +
            ' <' + M + '.' + (+m + 1) + '.0';

    debug('tilde return', ret);
    return ret;
  });
}

// ^ --> * (any, kinda silly)
// ^2, ^2.x, ^2.x.x --> >=2.0.0 <3.0.0
// ^2.0, ^2.0.x --> >=2.0.0 <3.0.0
// ^1.2, ^1.2.x --> >=1.2.0 <2.0.0
// ^1.2.3 --> >=1.2.3 <2.0.0
// ^1.2.0 --> >=1.2.0 <2.0.0
function replaceCarets(comp, loose) {
  return comp.trim().split(/\s+/).map(function(comp) {
    return replaceCaret(comp, loose);
  }).join(' ');
}

function replaceCaret(comp, loose) {
  debug('caret', comp, loose);
  var r = loose ? re[CARETLOOSE] : re[CARET];
  return comp.replace(r, function(_, M, m, p, pr) {
    debug('caret', comp, _, M, m, p, pr);
    var ret;

    if (isX(M))
      ret = '';
    else if (isX(m))
      ret = '>=' + M + '.0.0 <' + (+M + 1) + '.0.0';
    else if (isX(p)) {
      if (M === '0')
        ret = '>=' + M + '.' + m + '.0 <' + M + '.' + (+m + 1) + '.0';
      else
        ret = '>=' + M + '.' + m + '.0 <' + (+M + 1) + '.0.0';
    } else if (pr) {
      debug('replaceCaret pr', pr);
      if (pr.charAt(0) !== '-')
        pr = '-' + pr;
      if (M === '0') {
        if (m === '0')
          ret = '>=' + M + '.' + m + '.' + p + pr +
                ' <' + M + '.' + m + '.' + (+p + 1);
        else
          ret = '>=' + M + '.' + m + '.' + p + pr +
                ' <' + M + '.' + (+m + 1) + '.0';
      } else
        ret = '>=' + M + '.' + m + '.' + p + pr +
              ' <' + (+M + 1) + '.0.0';
    } else {
      debug('no pr');
      if (M === '0') {
        if (m === '0')
          ret = '>=' + M + '.' + m + '.' + p +
                ' <' + M + '.' + m + '.' + (+p + 1);
        else
          ret = '>=' + M + '.' + m + '.' + p +
                ' <' + M + '.' + (+m + 1) + '.0';
      } else
        ret = '>=' + M + '.' + m + '.' + p +
              ' <' + (+M + 1) + '.0.0';
    }

    debug('caret return', ret);
    return ret;
  });
}

function replaceXRanges(comp, loose) {
  debug('replaceXRanges', comp, loose);
  return comp.split(/\s+/).map(function(comp) {
    return replaceXRange(comp, loose);
  }).join(' ');
}

function replaceXRange(comp, loose) {
  comp = comp.trim();
  var r = loose ? re[XRANGELOOSE] : re[XRANGE];
  return comp.replace(r, function(ret, gtlt, M, m, p, pr) {
    debug('xRange', comp, ret, gtlt, M, m, p, pr);
    var xM = isX(M);
    var xm = xM || isX(m);
    var xp = xm || isX(p);
    var anyX = xp;

    if (gtlt === '=' && anyX)
      gtlt = '';

    if (xM) {
      if (gtlt === '>' || gtlt === '<') {
        // nothing is allowed
        ret = '<0.0.0';
      } else {
        // nothing is forbidden
        ret = '*';
      }
    } else if (gtlt && anyX) {
      // replace X with 0
      if (xm)
        m = 0;
      if (xp)
        p = 0;

      if (gtlt === '>') {
        // >1 => >=2.0.0
        // >1.2 => >=1.3.0
        // >1.2.3 => >= 1.2.4
        gtlt = '>=';
        if (xm) {
          M = +M + 1;
          m = 0;
          p = 0;
        } else if (xp) {
          m = +m + 1;
          p = 0;
        }
      } else if (gtlt === '<=') {
        // <=0.7.x is actually <0.8.0, since any 0.7.x should
        // pass.  Similarly, <=7.x is actually <8.0.0, etc.
        gtlt = '<';
        if (xm)
          M = +M + 1;
        else
          m = +m + 1;
      }

      ret = gtlt + M + '.' + m + '.' + p;
    } else if (xm) {
      ret = '>=' + M + '.0.0 <' + (+M + 1) + '.0.0';
    } else if (xp) {
      ret = '>=' + M + '.' + m + '.0 <' + M + '.' + (+m + 1) + '.0';
    }

    debug('xRange return', ret);

    return ret;
  });
}

// Because * is AND-ed with everything else in the comparator,
// and '' means "any version", just remove the *s entirely.
function replaceStars(comp, loose) {
  debug('replaceStars', comp, loose);
  // Looseness is ignored here.  star is always as loose as it gets!
  return comp.trim().replace(re[STAR], '');
}

// This function is passed to string.replace(re[HYPHENRANGE])
// M, m, patch, prerelease, build
// 1.2 - 3.4.5 => >=1.2.0 <=3.4.5
// 1.2.3 - 3.4 => >=1.2.0 <3.5.0 Any 3.4.x will do
// 1.2 - 3.4 => >=1.2.0 <3.5.0
function hyphenReplace($0,
                       from, fM, fm, fp, fpr, fb,
                       to, tM, tm, tp, tpr, tb) {

  if (isX(fM))
    from = '';
  else if (isX(fm))
    from = '>=' + fM + '.0.0';
  else if (isX(fp))
    from = '>=' + fM + '.' + fm + '.0';
  else
    from = '>=' + from;

  if (isX(tM))
    to = '';
  else if (isX(tm))
    to = '<' + (+tM + 1) + '.0.0';
  else if (isX(tp))
    to = '<' + tM + '.' + (+tm + 1) + '.0';
  else if (tpr)
    to = '<=' + tM + '.' + tm + '.' + tp + '-' + tpr;
  else
    to = '<=' + to;

  return (from + ' ' + to).trim();
}


// if ANY of the sets match ALL of its comparators, then pass
Range.prototype.test = function(version) {
  if (!version)
    return false;

  if (typeof version === 'string')
    version = new SemVer(version, this.loose);

  for (var i = 0; i < this.set.length; i++) {
    if (testSet(this.set[i], version))
      return true;
  }
  return false;
};

function testSet(set, version) {
  for (var i = 0; i < set.length; i++) {
    if (!set[i].test(version))
      return false;
  }

  if (version.prerelease.length) {
    // Find the set of versions that are allowed to have prereleases
    // For example, ^1.2.3-pr.1 desugars to >=1.2.3-pr.1 <2.0.0
    // That should allow `1.2.3-pr.2` to pass.
    // However, `1.2.4-alpha.notready` should NOT be allowed,
    // even though it's within the range set by the comparators.
    for (var i = 0; i < set.length; i++) {
      debug(set[i].semver);
      if (set[i].semver === ANY)
        continue;

      if (set[i].semver.prerelease.length > 0) {
        var allowed = set[i].semver;
        if (allowed.major === version.major &&
            allowed.minor === version.minor &&
            allowed.patch === version.patch)
          return true;
      }
    }

    // Version has a -pre, but it's not one of the ones we like.
    return false;
  }

  return true;
}

exports.satisfies = satisfies;
function satisfies(version, range, loose) {
  try {
    range = new Range(range, loose);
  } catch (er) {
    return false;
  }
  return range.test(version);
}

exports.maxSatisfying = maxSatisfying;
function maxSatisfying(versions, range, loose) {
  return versions.filter(function(version) {
    return satisfies(version, range, loose);
  }).sort(function(a, b) {
    return rcompare(a, b, loose);
  })[0] || null;
}

exports.minSatisfying = minSatisfying;
function minSatisfying(versions, range, loose) {
  return versions.filter(function(version) {
    return satisfies(version, range, loose);
  }).sort(function(a, b) {
    return compare(a, b, loose);
  })[0] || null;
}

exports.validRange = validRange;
function validRange(range, loose) {
  try {
    // Return '*' instead of '' so that truthiness works.
    // This will throw if it's invalid anyway
    return new Range(range, loose).range || '*';
  } catch (er) {
    return null;
  }
}

// Determine if version is less than all the versions possible in the range
exports.ltr = ltr;
function ltr(version, range, loose) {
  return outside(version, range, '<', loose);
}

// Determine if version is greater than all the versions possible in the range.
exports.gtr = gtr;
function gtr(version, range, loose) {
  return outside(version, range, '>', loose);
}

exports.outside = outside;
function outside(version, range, hilo, loose) {
  version = new SemVer(version, loose);
  range = new Range(range, loose);

  var gtfn, ltefn, ltfn, comp, ecomp;
  switch (hilo) {
    case '>':
      gtfn = gt;
      ltefn = lte;
      ltfn = lt;
      comp = '>';
      ecomp = '>=';
      break;
    case '<':
      gtfn = lt;
      ltefn = gte;
      ltfn = gt;
      comp = '<';
      ecomp = '<=';
      break;
    default:
      throw new TypeError('Must provide a hilo val of "<" or ">"');
  }

  // If it satisifes the range it is not outside
  if (satisfies(version, range, loose)) {
    return false;
  }

  // From now on, variable terms are as if we're in "gtr" mode.
  // but note that everything is flipped for the "ltr" function.

  for (var i = 0; i < range.set.length; ++i) {
    var comparators = range.set[i];

    var high = null;
    var low = null;

    comparators.forEach(function(comparator) {
      if (comparator.semver === ANY) {
        comparator = new Comparator('>=0.0.0')
      }
      high = high || comparator;
      low = low || comparator;
      if (gtfn(comparator.semver, high.semver, loose)) {
        high = comparator;
      } else if (ltfn(comparator.semver, low.semver, loose)) {
        low = comparator;
      }
    });

    // If the edge version comparator has a operator then our version
    // isn't outside it
    if (high.operator === comp || high.operator === ecomp) {
      return false;
    }

    // If the lowest version comparator has an operator and our version
    // is less than it then it isn't higher than the range
    if ((!low.operator || low.operator === comp) &&
        ltefn(version, low.semver)) {
      return false;
    } else if (low.operator === ecomp && ltfn(version, low.semver)) {
      return false;
    }
  }
  return true;
}

exports.prerelease = prerelease;
function prerelease(version, loose) {
  var parsed = parse(version, loose);
  return (parsed && parsed.prerelease.length) ? parsed.prerelease : null;
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(133)))

/***/ }),
/* 133 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ })
/******/ ]);
});
//# sourceMappingURL=vuetify.js.map

/***/ }),
/* 677 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,t){ true?module.exports=t():"function"==typeof define&&define.amd?define("VueShortkey",[],t):"object"==typeof exports?exports.VueShortkey=t():e.VueShortkey=t()}("undefined"!=typeof self?self:this,function(){return function(e){function t(r){if(n[r])return n[r].exports;var o=n[r]={i:r,l:!1,exports:{}};return e[r].call(o.exports,o,o.exports,t),o.l=!0,o.exports}var n={};return t.m=e,t.c=n,t.d=function(e,n,r){t.o(e,n)||Object.defineProperty(e,n,{configurable:!1,enumerable:!0,get:r})},t.n=function(e){var n=e&&e.__esModule?function(){return e.default}:function(){return e};return t.d(n,"a",n),n},t.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},t.p="../dist/",t(t.s=0)}([function(e,t,n){"use strict";(function(r){function o(e){if(Array.isArray(e)){for(var t=0,n=Array(e.length);t<e.length;t++)n[t]=e[t];return n}return Array.from(e)}var c;n(2),n(3);var u={},i={},a=[],l=[],s=!1,f=function(e){return e="string"==typeof e?JSON.parse(e.replace(/\'/gi,'"')):e,e instanceof Array?{"":e}:e},p=function(e,t,n,r){var o=!0===n.modifiers.push,c=!0===n.modifiers.avoid,u=!0==!n.modifiers.focus,i=!0===n.modifiers.once;c?(a=a.filter(function(e){return!e===t}),a.push(t)):v({b:e,push:o,once:i,focus:u,el:r.elm})},y=function(e,t){for(var n in e){var r=u.encodeKey(e[n]),o=i[r].el.indexOf(t);i[r].el.length>1&&o>-1?i[r].el.splice(o,1):delete i[r]}};u.install=function(e,t){l=[].concat(o(t&&t.prevent?t.prevent:[])),e.directive("shortkey",{bind:function(e,t,n){var r=f(t.value);p(r,e,t,n)},update:function(e,t,n){var r=f(t.oldValue);y(r,e);var o=f(t.value);p(o,e,t,n)},unbind:function(e,t){var n=f(t.value);y(n,e)}})},u.decodeKey=function(e){return d(e)},u.encodeKey=function(e){var t={};t.shiftKey=e.includes("shift"),t.ctrlKey=e.includes("ctrl"),t.metaKey=e.includes("meta"),t.altKey=e.includes("alt");var n=d(t);return n+=e.filter(function(e){return!["shift","ctrl","meta","alt"].includes(e)}).join("")};var d=function(e){var t="";return("Shift"===e.key||e.shiftKey)&&(t+="shift"),("Control"===e.key||e.ctrlKey)&&(t+="ctrl"),("Meta"===e.key||e.metaKey)&&(t+="meta"),("Alt"===e.key||e.altKey)&&(t+="alt"),"ArrowUp"===e.key&&(t+="arrowup"),"ArrowLeft"===e.key&&(t+="arrowleft"),"ArrowRight"===e.key&&(t+="arrowright"),"ArrowDown"===e.key&&(t+="arrowdown"),"AltGraph"===e.key&&(t+="altgraph"),"Escape"===e.key&&(t+="esc"),"Enter"===e.key&&(t+="enter"),"Tab"===e.key&&(t+="tab")," "===e.key&&(t+="space"),"PageUp"===e.key&&(t+="pageup"),"PageDown"===e.key&&(t+="pagedown"),"Home"===e.key&&(t+="home"),"End"===e.key&&(t+="end"),"Delete"===e.key&&(t+="del"),"Backspace"===e.key&&(t+="backspace"),"Insert"===e.key&&(t+="insert"),"NumLock"===e.key&&(t+="numlock"),"CapsLock"===e.key&&(t+="capslock"),"Pause"===e.key&&(t+="pause"),"ContextMenu"===e.key&&(t+="contextmenu"),"ScrollLock"===e.key&&(t+="scrolllock"),"BrowserHome"===e.key&&(t+="browserhome"),"MediaSelect"===e.key&&(t+="mediaselect"),(e.key&&" "!==e.key&&1===e.key.length||/F\d{1,2}|\//g.test(e.key))&&(t+=e.key.toLowerCase()),t},h=function(e){var t=new CustomEvent("shortkey",{bubbles:!1});i[e].key&&(t.srcKey=i[e].key);var n=i[e].el;n[n.length-1].dispatchEvent(t)};u.keyDown=function(e){(!i[e].once&&!i[e].push||i[e].push&&!s)&&h(e)},r&&Object({NODE_ENV:"production"})&&function(){document.addEventListener("keydown",function(e){var t=u.decodeKey(e);if(m(t))if(e.preventDefault(),e.stopPropagation(),i[t].focus)u.keyDown(t),s=!0;else if(!s){var n=i[t].el;n[n.length-1].focus(),s=!0}},!0),document.addEventListener("keyup",function(e){var t=u.decodeKey(e);m(t)&&(e.preventDefault(),e.stopPropagation(),(i[t].once||i[t].push)&&h(t)),s=!1},!0)}();var v=function(e){var t=e.b,n=e.push,r=e.once,o=e.focus,c=e.el;for(var a in t){var l=u.encodeKey(t[a]),s=i[l]&&i[l].el?i[l].el:[];s.push(c),i[l]={push:n,once:r,focus:o,key:a,el:s}}},m=function(e){var t=!!a.find(function(e){return e===document.activeElement}),n=!!l.find(function(e){return document.activeElement&&document.activeElement.matches(e)});return!!i[e]&&!(t||n)};void 0!==e&&e.exports?e.exports=u:void 0!==(c=function(){return u}.call(t,n,t,e))&&(e.exports=c)}).call(t,n(1))},function(e,t){function n(){throw new Error("setTimeout has not been defined")}function r(){throw new Error("clearTimeout has not been defined")}function o(e){if(s===setTimeout)return setTimeout(e,0);if((s===n||!s)&&setTimeout)return s=setTimeout,setTimeout(e,0);try{return s(e,0)}catch(t){try{return s.call(null,e,0)}catch(t){return s.call(this,e,0)}}}function c(e){if(f===clearTimeout)return clearTimeout(e);if((f===r||!f)&&clearTimeout)return f=clearTimeout,clearTimeout(e);try{return f(e)}catch(t){try{return f.call(null,e)}catch(t){return f.call(this,e)}}}function u(){h&&y&&(h=!1,y.length?d=y.concat(d):v=-1,d.length&&i())}function i(){if(!h){var e=o(u);h=!0;for(var t=d.length;t;){for(y=d,d=[];++v<t;)y&&y[v].run();v=-1,t=d.length}y=null,h=!1,c(e)}}function a(e,t){this.fun=e,this.array=t}function l(){}var s,f,p=e.exports={};!function(){try{s="function"==typeof setTimeout?setTimeout:n}catch(e){s=n}try{f="function"==typeof clearTimeout?clearTimeout:r}catch(e){f=r}}();var y,d=[],h=!1,v=-1;p.nextTick=function(e){var t=new Array(arguments.length-1);if(arguments.length>1)for(var n=1;n<arguments.length;n++)t[n-1]=arguments[n];d.push(new a(e,t)),1!==d.length||h||o(i)},a.prototype.run=function(){this.fun.apply(null,this.array)},p.title="browser",p.browser=!0,p.env={},p.argv=[],p.version="",p.versions={},p.on=l,p.addListener=l,p.once=l,p.off=l,p.removeListener=l,p.removeAllListeners=l,p.emit=l,p.prependListener=l,p.prependOnceListener=l,p.listeners=function(e){return[]},p.binding=function(e){throw new Error("process.binding is not supported")},p.cwd=function(){return"/"},p.chdir=function(e){throw new Error("process.chdir is not supported")},p.umask=function(){return 0}},function(e,t){Element.prototype.matches||(Element.prototype.matches=Element.prototype.matchesSelector||Element.prototype.msMatchesSelector||Element.prototype.webkitMatchesSelector)},function(e,t){!function(){if("undefined"!=typeof window)try{var e=new window.CustomEvent("test",{cancelable:!0});if(e.preventDefault(),!0!==e.defaultPrevented)throw new Error("Could not prevent default")}catch(e){var t=function(e,t){var n,r;return t=t||{},t.bubbles=!!t.bubbles,t.cancelable=!!t.cancelable,n=document.createEvent("CustomEvent"),n.initCustomEvent(e,t.bubbles,t.cancelable,t.detail),r=n.preventDefault,n.preventDefault=function(){r.call(this);try{Object.defineProperty(this,"defaultPrevented",{get:function(){return!0}})}catch(e){this.defaultPrevented=!0}},n};t.prototype=window.Event.prototype,window.CustomEvent=t}}()}])});
//# sourceMappingURL=index.js.map

/***/ }),
/* 678 */
/***/ (function(module, exports, __webpack_require__) {

(function (global, factory) {
   true ? factory(__webpack_require__(679)) :
  typeof define === 'function' && define.amd ? define(['hammerjs'], factory) :
  (factory(global.Hammer));
}(this, (function (Hammer) { 'use strict';

Hammer = 'default' in Hammer ? Hammer['default'] : Hammer;

function assign(target) {
  var sources = [], len = arguments.length - 1;
  while ( len-- > 0 ) sources[ len ] = arguments[ len + 1 ];
  for (var i = 0; i < sources.length; i++) {
    var source = sources[i];
    var keys = Object.keys(source);
    for (var i$1 = 0; i$1 < keys.length; i$1++) {
      var key = keys[i$1];
      target[key] = source[key];
    }
  }
  return target
}
function createProp() {
  return {
    type: Object,
    default: function() { return {} }
  }
}
function capitalize (str) {
  return str.charAt(0).toUpperCase() + str.slice(1)
}
var directions = ['up', 'down', 'left', 'right', 'horizontal', 'vertical', 'all'];
function guardDirections (options) {
  var dir = options.direction;
  if (typeof dir === 'string') {
    var hammerDirection = 'DIRECTION_' + dir.toUpperCase();
    if (directions.indexOf(dir) > -1 && Hammer.hasOwnProperty(hammerDirection)) {
      options.direction = Hammer[hammerDirection];
    } else {
      console.warn('[vue-touch] invalid direction: ' + dir);
    }
  }
  return options
}
var config = {
};
var customEvents = {
};
var gestures = [
  'pan','panstart','panmove','panend','pancancel','panleft','panright','panup','pandown',
  'pinch','pinchstart','pinchmove','pinchend','pinchcancel','pinchin','pinchout',
  'press','pressup',
  'rotate','rotatestart','rotatemove','rotateend','rotatecancel',
  'swipe','swipeleft','swiperight','swipeup','swipedown',
  'tap'
];
var gestureMap = {
  pan: 'pan',
  panstart: 'pan',
  panmove: 'pan',
  panend: 'pan',
  pancancel: 'pan',
  panleft: 'pan',
  panright: 'pan',
  panup: 'pan',
  pandown: 'pan',
  pinch: 'pinch',
  pinchstart: 'pinch',
  pinchmove: 'pinch',
  pinchend: 'pinch',
  pinchcancel: 'pinch',
  pinchin: 'pinch',
  pinchout: 'pinch',
  press: 'press',
  pressup: 'press',
  rotate: 'rotate',
  rotatestart: 'rotate',
  rotatemove: 'rotate',
  rotateend: 'rotate',
  rotatecancel: 'rotate',
  swipe: 'swipe',
  swipeleft: 'swipe',
  swiperight: 'swipe',
  swipeup: 'swipe',
  swipedown: 'swipe',
  tap: 'tap'
};

var Component = {
  props: {
    options: createProp(),
    tapOptions: createProp(),
    panOptions: createProp(),
    pinchOptions: createProp(),
    pressOptions: createProp(),
    rotateOptions: createProp(),
    swipeOptions: createProp(),
    tag: { type: String, default: 'div' },
    enabled: {
      default: true,
      type: [Boolean, Object],
    }
  },
  mounted: function mounted() {
    if (!this.$isServer) {
      this.hammer = new Hammer.Manager(this.$el, this.options);
      this.recognizers = {};
      this.setupBuiltinRecognizers();
      this.setupCustomRecognizers();
      this.updateEnabled(this.enabled);
    }
  },
  destroyed: function destroyed() {
    if (!this.$isServer) {
      this.hammer.destroy();
    }
  },
  watch: {
    enabled: {
      deep: true,
      handler: function handler() {
        var args = [], len = arguments.length;
        while ( len-- ) args[ len ] = arguments[ len ];
        (ref = this).updateEnabled.apply(ref, args);
        var ref;
      }
    }
  },
  methods: {
    setupBuiltinRecognizers: function setupBuiltinRecognizers()  {
      var this$1 = this;
      for (var i = 0; i < gestures.length; i++) {
        var gesture = gestures[i];
        if (this$1._events[gesture]) {
          var mainGesture = gestureMap[gesture];
          var options = assign({}, (config[mainGesture] || {}), this$1[(mainGesture + "Options")]);
          this$1.addRecognizer(mainGesture, options);
          this$1.addEvent(gesture);
        }
      }
    },
    setupCustomRecognizers: function setupCustomRecognizers() {
      var this$1 = this;
      var gestures$$1 = Object.keys(customEvents);
      for (var i = 0; i < gestures$$1.length; i++) {
        var gesture = gestures$$1[i];
        if (this$1._events[gesture]) {
          var opts = customEvents[gesture];
          var localCustomOpts = this$1[(gesture + "Options")] || {};
          var options = assign({}, opts, localCustomOpts);
          this$1.addRecognizer(gesture, options, {mainGesture: options.type});
          this$1.addEvent(gesture);
        }
      }
    },
    addRecognizer: function addRecognizer(gesture, options, ref) {
      if ( ref === void 0 ) ref = {};
      var mainGesture = ref.mainGesture;
      if (!this.recognizers[gesture]) {
        var recognizer = new Hammer[capitalize(mainGesture || gesture)](guardDirections(options));
        this.recognizers[gesture] = recognizer;
        this.hammer.add(recognizer);
        recognizer.recognizeWith(this.hammer.recognizers);
      }
    },
    addEvent: function addEvent(gesture) {
      var this$1 = this;
      this.hammer.on(gesture, function (e) { return this$1.$emit(gesture, e); });
    },
    updateEnabled: function updateEnabled(newVal, oldVal) {
      var this$1 = this;
      if (newVal === true) {
        this.enableAll();
      } else if (newVal === false) {
        this.disableAll();
      } else if (typeof newVal === 'object') {
        var keys = Object.keys(newVal);
        for (var i = 0; i < keys.length; i++) {
          var event = keys[i];
          if (this$1.recognizers[event]) {
            newVal[event]
              ? this$1.enable(event)
              : this$1.disable(event);
          }
        }
      }
    },
    enable: function enable(r) {
      var recognizer = this.recognizers[r];
      if (!recognizer.options.enable) {
        recognizer.set({ enable: true });
      }
    },
    disable: function disable(r) {
      var recognizer = this.recognizers[r];
      if (recognizer.options.enable) {
        recognizer.set({ enable: false });
      }
    },
    toggle: function toggle(r) {
      var recognizer = this.recognizers[r];
      if (recognizer) {
        recognizer.options.enable
          ? this.disable(r)
          : this.enable(r);
      }
    },
    enableAll: function enableAll(r) {
      this.toggleAll({ enable: true });
    },
    disableAll: function disableAll(r) {
      this.toggleAll({ enable: false });
    },
    toggleAll: function toggleAll(ref) {
      var this$1 = this;
      var enable = ref.enable;
      var keys = Object.keys(this.recognizers);
      for (var i = 0; i < keys.length; i++) {
        var r = this$1.recognizers[keys[i]];
        if (r.options.enable !== enable) {
          r.set({ enable: enable });
        }
      }
    },
    isEnabled: function isEnabled(r) {
      return this.recognizers[r] && this.recognizers[r].options.enable
    }
  },
  render: function render(h) {
    return h(this.tag, {}, this.$slots.default)
  }
};

var installed = false;
var vueTouch = { config: config, customEvents: customEvents };
vueTouch.install = function install(Vue, opts) {
  if ( opts === void 0 ) opts = {};
  var name = opts.name || 'v-touch';
  Vue.component(name, assign(Component, { name: name }));
  installed = true;
}.bind(vueTouch);
vueTouch.registerCustomEvent = function registerCustomEvent(event, options) {
  if ( options === void 0 ) options = {};
  if (installed) {
    console.warn(("\n      [vue-touch]: Custom Event '" + event + "' couldn't be added to vue-touch.\n      Custom Events have to be registered before installing the plugin.\n      "));
    return
  }
  options.event = event;
  customEvents[event] = options;
  Component.props[(event + "Options")] = {
    type: Object,
    default: function default$1() { return {} }
  };
}.bind(vueTouch);
vueTouch.component = Component;
if (true) {
  module.exports = vueTouch;
} else if (typeof define == "function" && define.amd) {
  define([], function(){ return vueTouch });
} else if (typeof window !== 'undefined' && window.Vue) {
  window.VueTouch = vueTouch;
  Vue.use(vueTouch);
}

})));
//# sourceMappingURL=vue-touch.js.map


/***/ }),
/* 679 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/*! Hammer.JS - v2.0.7 - 2016-04-22
 * http://hammerjs.github.io/
 *
 * Copyright (c) 2016 Jorik Tangelder;
 * Licensed under the MIT license */
(function(window, document, exportName, undefined) {
  'use strict';

var VENDOR_PREFIXES = ['', 'webkit', 'Moz', 'MS', 'ms', 'o'];
var TEST_ELEMENT = document.createElement('div');

var TYPE_FUNCTION = 'function';

var round = Math.round;
var abs = Math.abs;
var now = Date.now;

/**
 * set a timeout with a given scope
 * @param {Function} fn
 * @param {Number} timeout
 * @param {Object} context
 * @returns {number}
 */
function setTimeoutContext(fn, timeout, context) {
    return setTimeout(bindFn(fn, context), timeout);
}

/**
 * if the argument is an array, we want to execute the fn on each entry
 * if it aint an array we don't want to do a thing.
 * this is used by all the methods that accept a single and array argument.
 * @param {*|Array} arg
 * @param {String} fn
 * @param {Object} [context]
 * @returns {Boolean}
 */
function invokeArrayArg(arg, fn, context) {
    if (Array.isArray(arg)) {
        each(arg, context[fn], context);
        return true;
    }
    return false;
}

/**
 * walk objects and arrays
 * @param {Object} obj
 * @param {Function} iterator
 * @param {Object} context
 */
function each(obj, iterator, context) {
    var i;

    if (!obj) {
        return;
    }

    if (obj.forEach) {
        obj.forEach(iterator, context);
    } else if (obj.length !== undefined) {
        i = 0;
        while (i < obj.length) {
            iterator.call(context, obj[i], i, obj);
            i++;
        }
    } else {
        for (i in obj) {
            obj.hasOwnProperty(i) && iterator.call(context, obj[i], i, obj);
        }
    }
}

/**
 * wrap a method with a deprecation warning and stack trace
 * @param {Function} method
 * @param {String} name
 * @param {String} message
 * @returns {Function} A new function wrapping the supplied method.
 */
function deprecate(method, name, message) {
    var deprecationMessage = 'DEPRECATED METHOD: ' + name + '\n' + message + ' AT \n';
    return function() {
        var e = new Error('get-stack-trace');
        var stack = e && e.stack ? e.stack.replace(/^[^\(]+?[\n$]/gm, '')
            .replace(/^\s+at\s+/gm, '')
            .replace(/^Object.<anonymous>\s*\(/gm, '{anonymous}()@') : 'Unknown Stack Trace';

        var log = window.console && (window.console.warn || window.console.log);
        if (log) {
            log.call(window.console, deprecationMessage, stack);
        }
        return method.apply(this, arguments);
    };
}

/**
 * extend object.
 * means that properties in dest will be overwritten by the ones in src.
 * @param {Object} target
 * @param {...Object} objects_to_assign
 * @returns {Object} target
 */
var assign;
if (typeof Object.assign !== 'function') {
    assign = function assign(target) {
        if (target === undefined || target === null) {
            throw new TypeError('Cannot convert undefined or null to object');
        }

        var output = Object(target);
        for (var index = 1; index < arguments.length; index++) {
            var source = arguments[index];
            if (source !== undefined && source !== null) {
                for (var nextKey in source) {
                    if (source.hasOwnProperty(nextKey)) {
                        output[nextKey] = source[nextKey];
                    }
                }
            }
        }
        return output;
    };
} else {
    assign = Object.assign;
}

/**
 * extend object.
 * means that properties in dest will be overwritten by the ones in src.
 * @param {Object} dest
 * @param {Object} src
 * @param {Boolean} [merge=false]
 * @returns {Object} dest
 */
var extend = deprecate(function extend(dest, src, merge) {
    var keys = Object.keys(src);
    var i = 0;
    while (i < keys.length) {
        if (!merge || (merge && dest[keys[i]] === undefined)) {
            dest[keys[i]] = src[keys[i]];
        }
        i++;
    }
    return dest;
}, 'extend', 'Use `assign`.');

/**
 * merge the values from src in the dest.
 * means that properties that exist in dest will not be overwritten by src
 * @param {Object} dest
 * @param {Object} src
 * @returns {Object} dest
 */
var merge = deprecate(function merge(dest, src) {
    return extend(dest, src, true);
}, 'merge', 'Use `assign`.');

/**
 * simple class inheritance
 * @param {Function} child
 * @param {Function} base
 * @param {Object} [properties]
 */
function inherit(child, base, properties) {
    var baseP = base.prototype,
        childP;

    childP = child.prototype = Object.create(baseP);
    childP.constructor = child;
    childP._super = baseP;

    if (properties) {
        assign(childP, properties);
    }
}

/**
 * simple function bind
 * @param {Function} fn
 * @param {Object} context
 * @returns {Function}
 */
function bindFn(fn, context) {
    return function boundFn() {
        return fn.apply(context, arguments);
    };
}

/**
 * let a boolean value also be a function that must return a boolean
 * this first item in args will be used as the context
 * @param {Boolean|Function} val
 * @param {Array} [args]
 * @returns {Boolean}
 */
function boolOrFn(val, args) {
    if (typeof val == TYPE_FUNCTION) {
        return val.apply(args ? args[0] || undefined : undefined, args);
    }
    return val;
}

/**
 * use the val2 when val1 is undefined
 * @param {*} val1
 * @param {*} val2
 * @returns {*}
 */
function ifUndefined(val1, val2) {
    return (val1 === undefined) ? val2 : val1;
}

/**
 * addEventListener with multiple events at once
 * @param {EventTarget} target
 * @param {String} types
 * @param {Function} handler
 */
function addEventListeners(target, types, handler) {
    each(splitStr(types), function(type) {
        target.addEventListener(type, handler, false);
    });
}

/**
 * removeEventListener with multiple events at once
 * @param {EventTarget} target
 * @param {String} types
 * @param {Function} handler
 */
function removeEventListeners(target, types, handler) {
    each(splitStr(types), function(type) {
        target.removeEventListener(type, handler, false);
    });
}

/**
 * find if a node is in the given parent
 * @method hasParent
 * @param {HTMLElement} node
 * @param {HTMLElement} parent
 * @return {Boolean} found
 */
function hasParent(node, parent) {
    while (node) {
        if (node == parent) {
            return true;
        }
        node = node.parentNode;
    }
    return false;
}

/**
 * small indexOf wrapper
 * @param {String} str
 * @param {String} find
 * @returns {Boolean} found
 */
function inStr(str, find) {
    return str.indexOf(find) > -1;
}

/**
 * split string on whitespace
 * @param {String} str
 * @returns {Array} words
 */
function splitStr(str) {
    return str.trim().split(/\s+/g);
}

/**
 * find if a array contains the object using indexOf or a simple polyFill
 * @param {Array} src
 * @param {String} find
 * @param {String} [findByKey]
 * @return {Boolean|Number} false when not found, or the index
 */
function inArray(src, find, findByKey) {
    if (src.indexOf && !findByKey) {
        return src.indexOf(find);
    } else {
        var i = 0;
        while (i < src.length) {
            if ((findByKey && src[i][findByKey] == find) || (!findByKey && src[i] === find)) {
                return i;
            }
            i++;
        }
        return -1;
    }
}

/**
 * convert array-like objects to real arrays
 * @param {Object} obj
 * @returns {Array}
 */
function toArray(obj) {
    return Array.prototype.slice.call(obj, 0);
}

/**
 * unique array with objects based on a key (like 'id') or just by the array's value
 * @param {Array} src [{id:1},{id:2},{id:1}]
 * @param {String} [key]
 * @param {Boolean} [sort=False]
 * @returns {Array} [{id:1},{id:2}]
 */
function uniqueArray(src, key, sort) {
    var results = [];
    var values = [];
    var i = 0;

    while (i < src.length) {
        var val = key ? src[i][key] : src[i];
        if (inArray(values, val) < 0) {
            results.push(src[i]);
        }
        values[i] = val;
        i++;
    }

    if (sort) {
        if (!key) {
            results = results.sort();
        } else {
            results = results.sort(function sortUniqueArray(a, b) {
                return a[key] > b[key];
            });
        }
    }

    return results;
}

/**
 * get the prefixed property
 * @param {Object} obj
 * @param {String} property
 * @returns {String|Undefined} prefixed
 */
function prefixed(obj, property) {
    var prefix, prop;
    var camelProp = property[0].toUpperCase() + property.slice(1);

    var i = 0;
    while (i < VENDOR_PREFIXES.length) {
        prefix = VENDOR_PREFIXES[i];
        prop = (prefix) ? prefix + camelProp : property;

        if (prop in obj) {
            return prop;
        }
        i++;
    }
    return undefined;
}

/**
 * get a unique id
 * @returns {number} uniqueId
 */
var _uniqueId = 1;
function uniqueId() {
    return _uniqueId++;
}

/**
 * get the window object of an element
 * @param {HTMLElement} element
 * @returns {DocumentView|Window}
 */
function getWindowForElement(element) {
    var doc = element.ownerDocument || element;
    return (doc.defaultView || doc.parentWindow || window);
}

var MOBILE_REGEX = /mobile|tablet|ip(ad|hone|od)|android/i;

var SUPPORT_TOUCH = ('ontouchstart' in window);
var SUPPORT_POINTER_EVENTS = prefixed(window, 'PointerEvent') !== undefined;
var SUPPORT_ONLY_TOUCH = SUPPORT_TOUCH && MOBILE_REGEX.test(navigator.userAgent);

var INPUT_TYPE_TOUCH = 'touch';
var INPUT_TYPE_PEN = 'pen';
var INPUT_TYPE_MOUSE = 'mouse';
var INPUT_TYPE_KINECT = 'kinect';

var COMPUTE_INTERVAL = 25;

var INPUT_START = 1;
var INPUT_MOVE = 2;
var INPUT_END = 4;
var INPUT_CANCEL = 8;

var DIRECTION_NONE = 1;
var DIRECTION_LEFT = 2;
var DIRECTION_RIGHT = 4;
var DIRECTION_UP = 8;
var DIRECTION_DOWN = 16;

var DIRECTION_HORIZONTAL = DIRECTION_LEFT | DIRECTION_RIGHT;
var DIRECTION_VERTICAL = DIRECTION_UP | DIRECTION_DOWN;
var DIRECTION_ALL = DIRECTION_HORIZONTAL | DIRECTION_VERTICAL;

var PROPS_XY = ['x', 'y'];
var PROPS_CLIENT_XY = ['clientX', 'clientY'];

/**
 * create new input type manager
 * @param {Manager} manager
 * @param {Function} callback
 * @returns {Input}
 * @constructor
 */
function Input(manager, callback) {
    var self = this;
    this.manager = manager;
    this.callback = callback;
    this.element = manager.element;
    this.target = manager.options.inputTarget;

    // smaller wrapper around the handler, for the scope and the enabled state of the manager,
    // so when disabled the input events are completely bypassed.
    this.domHandler = function(ev) {
        if (boolOrFn(manager.options.enable, [manager])) {
            self.handler(ev);
        }
    };

    this.init();

}

Input.prototype = {
    /**
     * should handle the inputEvent data and trigger the callback
     * @virtual
     */
    handler: function() { },

    /**
     * bind the events
     */
    init: function() {
        this.evEl && addEventListeners(this.element, this.evEl, this.domHandler);
        this.evTarget && addEventListeners(this.target, this.evTarget, this.domHandler);
        this.evWin && addEventListeners(getWindowForElement(this.element), this.evWin, this.domHandler);
    },

    /**
     * unbind the events
     */
    destroy: function() {
        this.evEl && removeEventListeners(this.element, this.evEl, this.domHandler);
        this.evTarget && removeEventListeners(this.target, this.evTarget, this.domHandler);
        this.evWin && removeEventListeners(getWindowForElement(this.element), this.evWin, this.domHandler);
    }
};

/**
 * create new input type manager
 * called by the Manager constructor
 * @param {Hammer} manager
 * @returns {Input}
 */
function createInputInstance(manager) {
    var Type;
    var inputClass = manager.options.inputClass;

    if (inputClass) {
        Type = inputClass;
    } else if (SUPPORT_POINTER_EVENTS) {
        Type = PointerEventInput;
    } else if (SUPPORT_ONLY_TOUCH) {
        Type = TouchInput;
    } else if (!SUPPORT_TOUCH) {
        Type = MouseInput;
    } else {
        Type = TouchMouseInput;
    }
    return new (Type)(manager, inputHandler);
}

/**
 * handle input events
 * @param {Manager} manager
 * @param {String} eventType
 * @param {Object} input
 */
function inputHandler(manager, eventType, input) {
    var pointersLen = input.pointers.length;
    var changedPointersLen = input.changedPointers.length;
    var isFirst = (eventType & INPUT_START && (pointersLen - changedPointersLen === 0));
    var isFinal = (eventType & (INPUT_END | INPUT_CANCEL) && (pointersLen - changedPointersLen === 0));

    input.isFirst = !!isFirst;
    input.isFinal = !!isFinal;

    if (isFirst) {
        manager.session = {};
    }

    // source event is the normalized value of the domEvents
    // like 'touchstart, mouseup, pointerdown'
    input.eventType = eventType;

    // compute scale, rotation etc
    computeInputData(manager, input);

    // emit secret event
    manager.emit('hammer.input', input);

    manager.recognize(input);
    manager.session.prevInput = input;
}

/**
 * extend the data with some usable properties like scale, rotate, velocity etc
 * @param {Object} manager
 * @param {Object} input
 */
function computeInputData(manager, input) {
    var session = manager.session;
    var pointers = input.pointers;
    var pointersLength = pointers.length;

    // store the first input to calculate the distance and direction
    if (!session.firstInput) {
        session.firstInput = simpleCloneInputData(input);
    }

    // to compute scale and rotation we need to store the multiple touches
    if (pointersLength > 1 && !session.firstMultiple) {
        session.firstMultiple = simpleCloneInputData(input);
    } else if (pointersLength === 1) {
        session.firstMultiple = false;
    }

    var firstInput = session.firstInput;
    var firstMultiple = session.firstMultiple;
    var offsetCenter = firstMultiple ? firstMultiple.center : firstInput.center;

    var center = input.center = getCenter(pointers);
    input.timeStamp = now();
    input.deltaTime = input.timeStamp - firstInput.timeStamp;

    input.angle = getAngle(offsetCenter, center);
    input.distance = getDistance(offsetCenter, center);

    computeDeltaXY(session, input);
    input.offsetDirection = getDirection(input.deltaX, input.deltaY);

    var overallVelocity = getVelocity(input.deltaTime, input.deltaX, input.deltaY);
    input.overallVelocityX = overallVelocity.x;
    input.overallVelocityY = overallVelocity.y;
    input.overallVelocity = (abs(overallVelocity.x) > abs(overallVelocity.y)) ? overallVelocity.x : overallVelocity.y;

    input.scale = firstMultiple ? getScale(firstMultiple.pointers, pointers) : 1;
    input.rotation = firstMultiple ? getRotation(firstMultiple.pointers, pointers) : 0;

    input.maxPointers = !session.prevInput ? input.pointers.length : ((input.pointers.length >
        session.prevInput.maxPointers) ? input.pointers.length : session.prevInput.maxPointers);

    computeIntervalInputData(session, input);

    // find the correct target
    var target = manager.element;
    if (hasParent(input.srcEvent.target, target)) {
        target = input.srcEvent.target;
    }
    input.target = target;
}

function computeDeltaXY(session, input) {
    var center = input.center;
    var offset = session.offsetDelta || {};
    var prevDelta = session.prevDelta || {};
    var prevInput = session.prevInput || {};

    if (input.eventType === INPUT_START || prevInput.eventType === INPUT_END) {
        prevDelta = session.prevDelta = {
            x: prevInput.deltaX || 0,
            y: prevInput.deltaY || 0
        };

        offset = session.offsetDelta = {
            x: center.x,
            y: center.y
        };
    }

    input.deltaX = prevDelta.x + (center.x - offset.x);
    input.deltaY = prevDelta.y + (center.y - offset.y);
}

/**
 * velocity is calculated every x ms
 * @param {Object} session
 * @param {Object} input
 */
function computeIntervalInputData(session, input) {
    var last = session.lastInterval || input,
        deltaTime = input.timeStamp - last.timeStamp,
        velocity, velocityX, velocityY, direction;

    if (input.eventType != INPUT_CANCEL && (deltaTime > COMPUTE_INTERVAL || last.velocity === undefined)) {
        var deltaX = input.deltaX - last.deltaX;
        var deltaY = input.deltaY - last.deltaY;

        var v = getVelocity(deltaTime, deltaX, deltaY);
        velocityX = v.x;
        velocityY = v.y;
        velocity = (abs(v.x) > abs(v.y)) ? v.x : v.y;
        direction = getDirection(deltaX, deltaY);

        session.lastInterval = input;
    } else {
        // use latest velocity info if it doesn't overtake a minimum period
        velocity = last.velocity;
        velocityX = last.velocityX;
        velocityY = last.velocityY;
        direction = last.direction;
    }

    input.velocity = velocity;
    input.velocityX = velocityX;
    input.velocityY = velocityY;
    input.direction = direction;
}

/**
 * create a simple clone from the input used for storage of firstInput and firstMultiple
 * @param {Object} input
 * @returns {Object} clonedInputData
 */
function simpleCloneInputData(input) {
    // make a simple copy of the pointers because we will get a reference if we don't
    // we only need clientXY for the calculations
    var pointers = [];
    var i = 0;
    while (i < input.pointers.length) {
        pointers[i] = {
            clientX: round(input.pointers[i].clientX),
            clientY: round(input.pointers[i].clientY)
        };
        i++;
    }

    return {
        timeStamp: now(),
        pointers: pointers,
        center: getCenter(pointers),
        deltaX: input.deltaX,
        deltaY: input.deltaY
    };
}

/**
 * get the center of all the pointers
 * @param {Array} pointers
 * @return {Object} center contains `x` and `y` properties
 */
function getCenter(pointers) {
    var pointersLength = pointers.length;

    // no need to loop when only one touch
    if (pointersLength === 1) {
        return {
            x: round(pointers[0].clientX),
            y: round(pointers[0].clientY)
        };
    }

    var x = 0, y = 0, i = 0;
    while (i < pointersLength) {
        x += pointers[i].clientX;
        y += pointers[i].clientY;
        i++;
    }

    return {
        x: round(x / pointersLength),
        y: round(y / pointersLength)
    };
}

/**
 * calculate the velocity between two points. unit is in px per ms.
 * @param {Number} deltaTime
 * @param {Number} x
 * @param {Number} y
 * @return {Object} velocity `x` and `y`
 */
function getVelocity(deltaTime, x, y) {
    return {
        x: x / deltaTime || 0,
        y: y / deltaTime || 0
    };
}

/**
 * get the direction between two points
 * @param {Number} x
 * @param {Number} y
 * @return {Number} direction
 */
function getDirection(x, y) {
    if (x === y) {
        return DIRECTION_NONE;
    }

    if (abs(x) >= abs(y)) {
        return x < 0 ? DIRECTION_LEFT : DIRECTION_RIGHT;
    }
    return y < 0 ? DIRECTION_UP : DIRECTION_DOWN;
}

/**
 * calculate the absolute distance between two points
 * @param {Object} p1 {x, y}
 * @param {Object} p2 {x, y}
 * @param {Array} [props] containing x and y keys
 * @return {Number} distance
 */
function getDistance(p1, p2, props) {
    if (!props) {
        props = PROPS_XY;
    }
    var x = p2[props[0]] - p1[props[0]],
        y = p2[props[1]] - p1[props[1]];

    return Math.sqrt((x * x) + (y * y));
}

/**
 * calculate the angle between two coordinates
 * @param {Object} p1
 * @param {Object} p2
 * @param {Array} [props] containing x and y keys
 * @return {Number} angle
 */
function getAngle(p1, p2, props) {
    if (!props) {
        props = PROPS_XY;
    }
    var x = p2[props[0]] - p1[props[0]],
        y = p2[props[1]] - p1[props[1]];
    return Math.atan2(y, x) * 180 / Math.PI;
}

/**
 * calculate the rotation degrees between two pointersets
 * @param {Array} start array of pointers
 * @param {Array} end array of pointers
 * @return {Number} rotation
 */
function getRotation(start, end) {
    return getAngle(end[1], end[0], PROPS_CLIENT_XY) + getAngle(start[1], start[0], PROPS_CLIENT_XY);
}

/**
 * calculate the scale factor between two pointersets
 * no scale is 1, and goes down to 0 when pinched together, and bigger when pinched out
 * @param {Array} start array of pointers
 * @param {Array} end array of pointers
 * @return {Number} scale
 */
function getScale(start, end) {
    return getDistance(end[0], end[1], PROPS_CLIENT_XY) / getDistance(start[0], start[1], PROPS_CLIENT_XY);
}

var MOUSE_INPUT_MAP = {
    mousedown: INPUT_START,
    mousemove: INPUT_MOVE,
    mouseup: INPUT_END
};

var MOUSE_ELEMENT_EVENTS = 'mousedown';
var MOUSE_WINDOW_EVENTS = 'mousemove mouseup';

/**
 * Mouse events input
 * @constructor
 * @extends Input
 */
function MouseInput() {
    this.evEl = MOUSE_ELEMENT_EVENTS;
    this.evWin = MOUSE_WINDOW_EVENTS;

    this.pressed = false; // mousedown state

    Input.apply(this, arguments);
}

inherit(MouseInput, Input, {
    /**
     * handle mouse events
     * @param {Object} ev
     */
    handler: function MEhandler(ev) {
        var eventType = MOUSE_INPUT_MAP[ev.type];

        // on start we want to have the left mouse button down
        if (eventType & INPUT_START && ev.button === 0) {
            this.pressed = true;
        }

        if (eventType & INPUT_MOVE && ev.which !== 1) {
            eventType = INPUT_END;
        }

        // mouse must be down
        if (!this.pressed) {
            return;
        }

        if (eventType & INPUT_END) {
            this.pressed = false;
        }

        this.callback(this.manager, eventType, {
            pointers: [ev],
            changedPointers: [ev],
            pointerType: INPUT_TYPE_MOUSE,
            srcEvent: ev
        });
    }
});

var POINTER_INPUT_MAP = {
    pointerdown: INPUT_START,
    pointermove: INPUT_MOVE,
    pointerup: INPUT_END,
    pointercancel: INPUT_CANCEL,
    pointerout: INPUT_CANCEL
};

// in IE10 the pointer types is defined as an enum
var IE10_POINTER_TYPE_ENUM = {
    2: INPUT_TYPE_TOUCH,
    3: INPUT_TYPE_PEN,
    4: INPUT_TYPE_MOUSE,
    5: INPUT_TYPE_KINECT // see https://twitter.com/jacobrossi/status/480596438489890816
};

var POINTER_ELEMENT_EVENTS = 'pointerdown';
var POINTER_WINDOW_EVENTS = 'pointermove pointerup pointercancel';

// IE10 has prefixed support, and case-sensitive
if (window.MSPointerEvent && !window.PointerEvent) {
    POINTER_ELEMENT_EVENTS = 'MSPointerDown';
    POINTER_WINDOW_EVENTS = 'MSPointerMove MSPointerUp MSPointerCancel';
}

/**
 * Pointer events input
 * @constructor
 * @extends Input
 */
function PointerEventInput() {
    this.evEl = POINTER_ELEMENT_EVENTS;
    this.evWin = POINTER_WINDOW_EVENTS;

    Input.apply(this, arguments);

    this.store = (this.manager.session.pointerEvents = []);
}

inherit(PointerEventInput, Input, {
    /**
     * handle mouse events
     * @param {Object} ev
     */
    handler: function PEhandler(ev) {
        var store = this.store;
        var removePointer = false;

        var eventTypeNormalized = ev.type.toLowerCase().replace('ms', '');
        var eventType = POINTER_INPUT_MAP[eventTypeNormalized];
        var pointerType = IE10_POINTER_TYPE_ENUM[ev.pointerType] || ev.pointerType;

        var isTouch = (pointerType == INPUT_TYPE_TOUCH);

        // get index of the event in the store
        var storeIndex = inArray(store, ev.pointerId, 'pointerId');

        // start and mouse must be down
        if (eventType & INPUT_START && (ev.button === 0 || isTouch)) {
            if (storeIndex < 0) {
                store.push(ev);
                storeIndex = store.length - 1;
            }
        } else if (eventType & (INPUT_END | INPUT_CANCEL)) {
            removePointer = true;
        }

        // it not found, so the pointer hasn't been down (so it's probably a hover)
        if (storeIndex < 0) {
            return;
        }

        // update the event in the store
        store[storeIndex] = ev;

        this.callback(this.manager, eventType, {
            pointers: store,
            changedPointers: [ev],
            pointerType: pointerType,
            srcEvent: ev
        });

        if (removePointer) {
            // remove from the store
            store.splice(storeIndex, 1);
        }
    }
});

var SINGLE_TOUCH_INPUT_MAP = {
    touchstart: INPUT_START,
    touchmove: INPUT_MOVE,
    touchend: INPUT_END,
    touchcancel: INPUT_CANCEL
};

var SINGLE_TOUCH_TARGET_EVENTS = 'touchstart';
var SINGLE_TOUCH_WINDOW_EVENTS = 'touchstart touchmove touchend touchcancel';

/**
 * Touch events input
 * @constructor
 * @extends Input
 */
function SingleTouchInput() {
    this.evTarget = SINGLE_TOUCH_TARGET_EVENTS;
    this.evWin = SINGLE_TOUCH_WINDOW_EVENTS;
    this.started = false;

    Input.apply(this, arguments);
}

inherit(SingleTouchInput, Input, {
    handler: function TEhandler(ev) {
        var type = SINGLE_TOUCH_INPUT_MAP[ev.type];

        // should we handle the touch events?
        if (type === INPUT_START) {
            this.started = true;
        }

        if (!this.started) {
            return;
        }

        var touches = normalizeSingleTouches.call(this, ev, type);

        // when done, reset the started state
        if (type & (INPUT_END | INPUT_CANCEL) && touches[0].length - touches[1].length === 0) {
            this.started = false;
        }

        this.callback(this.manager, type, {
            pointers: touches[0],
            changedPointers: touches[1],
            pointerType: INPUT_TYPE_TOUCH,
            srcEvent: ev
        });
    }
});

/**
 * @this {TouchInput}
 * @param {Object} ev
 * @param {Number} type flag
 * @returns {undefined|Array} [all, changed]
 */
function normalizeSingleTouches(ev, type) {
    var all = toArray(ev.touches);
    var changed = toArray(ev.changedTouches);

    if (type & (INPUT_END | INPUT_CANCEL)) {
        all = uniqueArray(all.concat(changed), 'identifier', true);
    }

    return [all, changed];
}

var TOUCH_INPUT_MAP = {
    touchstart: INPUT_START,
    touchmove: INPUT_MOVE,
    touchend: INPUT_END,
    touchcancel: INPUT_CANCEL
};

var TOUCH_TARGET_EVENTS = 'touchstart touchmove touchend touchcancel';

/**
 * Multi-user touch events input
 * @constructor
 * @extends Input
 */
function TouchInput() {
    this.evTarget = TOUCH_TARGET_EVENTS;
    this.targetIds = {};

    Input.apply(this, arguments);
}

inherit(TouchInput, Input, {
    handler: function MTEhandler(ev) {
        var type = TOUCH_INPUT_MAP[ev.type];
        var touches = getTouches.call(this, ev, type);
        if (!touches) {
            return;
        }

        this.callback(this.manager, type, {
            pointers: touches[0],
            changedPointers: touches[1],
            pointerType: INPUT_TYPE_TOUCH,
            srcEvent: ev
        });
    }
});

/**
 * @this {TouchInput}
 * @param {Object} ev
 * @param {Number} type flag
 * @returns {undefined|Array} [all, changed]
 */
function getTouches(ev, type) {
    var allTouches = toArray(ev.touches);
    var targetIds = this.targetIds;

    // when there is only one touch, the process can be simplified
    if (type & (INPUT_START | INPUT_MOVE) && allTouches.length === 1) {
        targetIds[allTouches[0].identifier] = true;
        return [allTouches, allTouches];
    }

    var i,
        targetTouches,
        changedTouches = toArray(ev.changedTouches),
        changedTargetTouches = [],
        target = this.target;

    // get target touches from touches
    targetTouches = allTouches.filter(function(touch) {
        return hasParent(touch.target, target);
    });

    // collect touches
    if (type === INPUT_START) {
        i = 0;
        while (i < targetTouches.length) {
            targetIds[targetTouches[i].identifier] = true;
            i++;
        }
    }

    // filter changed touches to only contain touches that exist in the collected target ids
    i = 0;
    while (i < changedTouches.length) {
        if (targetIds[changedTouches[i].identifier]) {
            changedTargetTouches.push(changedTouches[i]);
        }

        // cleanup removed touches
        if (type & (INPUT_END | INPUT_CANCEL)) {
            delete targetIds[changedTouches[i].identifier];
        }
        i++;
    }

    if (!changedTargetTouches.length) {
        return;
    }

    return [
        // merge targetTouches with changedTargetTouches so it contains ALL touches, including 'end' and 'cancel'
        uniqueArray(targetTouches.concat(changedTargetTouches), 'identifier', true),
        changedTargetTouches
    ];
}

/**
 * Combined touch and mouse input
 *
 * Touch has a higher priority then mouse, and while touching no mouse events are allowed.
 * This because touch devices also emit mouse events while doing a touch.
 *
 * @constructor
 * @extends Input
 */

var DEDUP_TIMEOUT = 2500;
var DEDUP_DISTANCE = 25;

function TouchMouseInput() {
    Input.apply(this, arguments);

    var handler = bindFn(this.handler, this);
    this.touch = new TouchInput(this.manager, handler);
    this.mouse = new MouseInput(this.manager, handler);

    this.primaryTouch = null;
    this.lastTouches = [];
}

inherit(TouchMouseInput, Input, {
    /**
     * handle mouse and touch events
     * @param {Hammer} manager
     * @param {String} inputEvent
     * @param {Object} inputData
     */
    handler: function TMEhandler(manager, inputEvent, inputData) {
        var isTouch = (inputData.pointerType == INPUT_TYPE_TOUCH),
            isMouse = (inputData.pointerType == INPUT_TYPE_MOUSE);

        if (isMouse && inputData.sourceCapabilities && inputData.sourceCapabilities.firesTouchEvents) {
            return;
        }

        // when we're in a touch event, record touches to  de-dupe synthetic mouse event
        if (isTouch) {
            recordTouches.call(this, inputEvent, inputData);
        } else if (isMouse && isSyntheticEvent.call(this, inputData)) {
            return;
        }

        this.callback(manager, inputEvent, inputData);
    },

    /**
     * remove the event listeners
     */
    destroy: function destroy() {
        this.touch.destroy();
        this.mouse.destroy();
    }
});

function recordTouches(eventType, eventData) {
    if (eventType & INPUT_START) {
        this.primaryTouch = eventData.changedPointers[0].identifier;
        setLastTouch.call(this, eventData);
    } else if (eventType & (INPUT_END | INPUT_CANCEL)) {
        setLastTouch.call(this, eventData);
    }
}

function setLastTouch(eventData) {
    var touch = eventData.changedPointers[0];

    if (touch.identifier === this.primaryTouch) {
        var lastTouch = {x: touch.clientX, y: touch.clientY};
        this.lastTouches.push(lastTouch);
        var lts = this.lastTouches;
        var removeLastTouch = function() {
            var i = lts.indexOf(lastTouch);
            if (i > -1) {
                lts.splice(i, 1);
            }
        };
        setTimeout(removeLastTouch, DEDUP_TIMEOUT);
    }
}

function isSyntheticEvent(eventData) {
    var x = eventData.srcEvent.clientX, y = eventData.srcEvent.clientY;
    for (var i = 0; i < this.lastTouches.length; i++) {
        var t = this.lastTouches[i];
        var dx = Math.abs(x - t.x), dy = Math.abs(y - t.y);
        if (dx <= DEDUP_DISTANCE && dy <= DEDUP_DISTANCE) {
            return true;
        }
    }
    return false;
}

var PREFIXED_TOUCH_ACTION = prefixed(TEST_ELEMENT.style, 'touchAction');
var NATIVE_TOUCH_ACTION = PREFIXED_TOUCH_ACTION !== undefined;

// magical touchAction value
var TOUCH_ACTION_COMPUTE = 'compute';
var TOUCH_ACTION_AUTO = 'auto';
var TOUCH_ACTION_MANIPULATION = 'manipulation'; // not implemented
var TOUCH_ACTION_NONE = 'none';
var TOUCH_ACTION_PAN_X = 'pan-x';
var TOUCH_ACTION_PAN_Y = 'pan-y';
var TOUCH_ACTION_MAP = getTouchActionProps();

/**
 * Touch Action
 * sets the touchAction property or uses the js alternative
 * @param {Manager} manager
 * @param {String} value
 * @constructor
 */
function TouchAction(manager, value) {
    this.manager = manager;
    this.set(value);
}

TouchAction.prototype = {
    /**
     * set the touchAction value on the element or enable the polyfill
     * @param {String} value
     */
    set: function(value) {
        // find out the touch-action by the event handlers
        if (value == TOUCH_ACTION_COMPUTE) {
            value = this.compute();
        }

        if (NATIVE_TOUCH_ACTION && this.manager.element.style && TOUCH_ACTION_MAP[value]) {
            this.manager.element.style[PREFIXED_TOUCH_ACTION] = value;
        }
        this.actions = value.toLowerCase().trim();
    },

    /**
     * just re-set the touchAction value
     */
    update: function() {
        this.set(this.manager.options.touchAction);
    },

    /**
     * compute the value for the touchAction property based on the recognizer's settings
     * @returns {String} value
     */
    compute: function() {
        var actions = [];
        each(this.manager.recognizers, function(recognizer) {
            if (boolOrFn(recognizer.options.enable, [recognizer])) {
                actions = actions.concat(recognizer.getTouchAction());
            }
        });
        return cleanTouchActions(actions.join(' '));
    },

    /**
     * this method is called on each input cycle and provides the preventing of the browser behavior
     * @param {Object} input
     */
    preventDefaults: function(input) {
        var srcEvent = input.srcEvent;
        var direction = input.offsetDirection;

        // if the touch action did prevented once this session
        if (this.manager.session.prevented) {
            srcEvent.preventDefault();
            return;
        }

        var actions = this.actions;
        var hasNone = inStr(actions, TOUCH_ACTION_NONE) && !TOUCH_ACTION_MAP[TOUCH_ACTION_NONE];
        var hasPanY = inStr(actions, TOUCH_ACTION_PAN_Y) && !TOUCH_ACTION_MAP[TOUCH_ACTION_PAN_Y];
        var hasPanX = inStr(actions, TOUCH_ACTION_PAN_X) && !TOUCH_ACTION_MAP[TOUCH_ACTION_PAN_X];

        if (hasNone) {
            //do not prevent defaults if this is a tap gesture

            var isTapPointer = input.pointers.length === 1;
            var isTapMovement = input.distance < 2;
            var isTapTouchTime = input.deltaTime < 250;

            if (isTapPointer && isTapMovement && isTapTouchTime) {
                return;
            }
        }

        if (hasPanX && hasPanY) {
            // `pan-x pan-y` means browser handles all scrolling/panning, do not prevent
            return;
        }

        if (hasNone ||
            (hasPanY && direction & DIRECTION_HORIZONTAL) ||
            (hasPanX && direction & DIRECTION_VERTICAL)) {
            return this.preventSrc(srcEvent);
        }
    },

    /**
     * call preventDefault to prevent the browser's default behavior (scrolling in most cases)
     * @param {Object} srcEvent
     */
    preventSrc: function(srcEvent) {
        this.manager.session.prevented = true;
        srcEvent.preventDefault();
    }
};

/**
 * when the touchActions are collected they are not a valid value, so we need to clean things up. *
 * @param {String} actions
 * @returns {*}
 */
function cleanTouchActions(actions) {
    // none
    if (inStr(actions, TOUCH_ACTION_NONE)) {
        return TOUCH_ACTION_NONE;
    }

    var hasPanX = inStr(actions, TOUCH_ACTION_PAN_X);
    var hasPanY = inStr(actions, TOUCH_ACTION_PAN_Y);

    // if both pan-x and pan-y are set (different recognizers
    // for different directions, e.g. horizontal pan but vertical swipe?)
    // we need none (as otherwise with pan-x pan-y combined none of these
    // recognizers will work, since the browser would handle all panning
    if (hasPanX && hasPanY) {
        return TOUCH_ACTION_NONE;
    }

    // pan-x OR pan-y
    if (hasPanX || hasPanY) {
        return hasPanX ? TOUCH_ACTION_PAN_X : TOUCH_ACTION_PAN_Y;
    }

    // manipulation
    if (inStr(actions, TOUCH_ACTION_MANIPULATION)) {
        return TOUCH_ACTION_MANIPULATION;
    }

    return TOUCH_ACTION_AUTO;
}

function getTouchActionProps() {
    if (!NATIVE_TOUCH_ACTION) {
        return false;
    }
    var touchMap = {};
    var cssSupports = window.CSS && window.CSS.supports;
    ['auto', 'manipulation', 'pan-y', 'pan-x', 'pan-x pan-y', 'none'].forEach(function(val) {

        // If css.supports is not supported but there is native touch-action assume it supports
        // all values. This is the case for IE 10 and 11.
        touchMap[val] = cssSupports ? window.CSS.supports('touch-action', val) : true;
    });
    return touchMap;
}

/**
 * Recognizer flow explained; *
 * All recognizers have the initial state of POSSIBLE when a input session starts.
 * The definition of a input session is from the first input until the last input, with all it's movement in it. *
 * Example session for mouse-input: mousedown -> mousemove -> mouseup
 *
 * On each recognizing cycle (see Manager.recognize) the .recognize() method is executed
 * which determines with state it should be.
 *
 * If the recognizer has the state FAILED, CANCELLED or RECOGNIZED (equals ENDED), it is reset to
 * POSSIBLE to give it another change on the next cycle.
 *
 *               Possible
 *                  |
 *            +-----+---------------+
 *            |                     |
 *      +-----+-----+               |
 *      |           |               |
 *   Failed      Cancelled          |
 *                          +-------+------+
 *                          |              |
 *                      Recognized       Began
 *                                         |
 *                                      Changed
 *                                         |
 *                                  Ended/Recognized
 */
var STATE_POSSIBLE = 1;
var STATE_BEGAN = 2;
var STATE_CHANGED = 4;
var STATE_ENDED = 8;
var STATE_RECOGNIZED = STATE_ENDED;
var STATE_CANCELLED = 16;
var STATE_FAILED = 32;

/**
 * Recognizer
 * Every recognizer needs to extend from this class.
 * @constructor
 * @param {Object} options
 */
function Recognizer(options) {
    this.options = assign({}, this.defaults, options || {});

    this.id = uniqueId();

    this.manager = null;

    // default is enable true
    this.options.enable = ifUndefined(this.options.enable, true);

    this.state = STATE_POSSIBLE;

    this.simultaneous = {};
    this.requireFail = [];
}

Recognizer.prototype = {
    /**
     * @virtual
     * @type {Object}
     */
    defaults: {},

    /**
     * set options
     * @param {Object} options
     * @return {Recognizer}
     */
    set: function(options) {
        assign(this.options, options);

        // also update the touchAction, in case something changed about the directions/enabled state
        this.manager && this.manager.touchAction.update();
        return this;
    },

    /**
     * recognize simultaneous with an other recognizer.
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    recognizeWith: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'recognizeWith', this)) {
            return this;
        }

        var simultaneous = this.simultaneous;
        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        if (!simultaneous[otherRecognizer.id]) {
            simultaneous[otherRecognizer.id] = otherRecognizer;
            otherRecognizer.recognizeWith(this);
        }
        return this;
    },

    /**
     * drop the simultaneous link. it doesnt remove the link on the other recognizer.
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    dropRecognizeWith: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'dropRecognizeWith', this)) {
            return this;
        }

        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        delete this.simultaneous[otherRecognizer.id];
        return this;
    },

    /**
     * recognizer can only run when an other is failing
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    requireFailure: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'requireFailure', this)) {
            return this;
        }

        var requireFail = this.requireFail;
        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        if (inArray(requireFail, otherRecognizer) === -1) {
            requireFail.push(otherRecognizer);
            otherRecognizer.requireFailure(this);
        }
        return this;
    },

    /**
     * drop the requireFailure link. it does not remove the link on the other recognizer.
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    dropRequireFailure: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'dropRequireFailure', this)) {
            return this;
        }

        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        var index = inArray(this.requireFail, otherRecognizer);
        if (index > -1) {
            this.requireFail.splice(index, 1);
        }
        return this;
    },

    /**
     * has require failures boolean
     * @returns {boolean}
     */
    hasRequireFailures: function() {
        return this.requireFail.length > 0;
    },

    /**
     * if the recognizer can recognize simultaneous with an other recognizer
     * @param {Recognizer} otherRecognizer
     * @returns {Boolean}
     */
    canRecognizeWith: function(otherRecognizer) {
        return !!this.simultaneous[otherRecognizer.id];
    },

    /**
     * You should use `tryEmit` instead of `emit` directly to check
     * that all the needed recognizers has failed before emitting.
     * @param {Object} input
     */
    emit: function(input) {
        var self = this;
        var state = this.state;

        function emit(event) {
            self.manager.emit(event, input);
        }

        // 'panstart' and 'panmove'
        if (state < STATE_ENDED) {
            emit(self.options.event + stateStr(state));
        }

        emit(self.options.event); // simple 'eventName' events

        if (input.additionalEvent) { // additional event(panleft, panright, pinchin, pinchout...)
            emit(input.additionalEvent);
        }

        // panend and pancancel
        if (state >= STATE_ENDED) {
            emit(self.options.event + stateStr(state));
        }
    },

    /**
     * Check that all the require failure recognizers has failed,
     * if true, it emits a gesture event,
     * otherwise, setup the state to FAILED.
     * @param {Object} input
     */
    tryEmit: function(input) {
        if (this.canEmit()) {
            return this.emit(input);
        }
        // it's failing anyway
        this.state = STATE_FAILED;
    },

    /**
     * can we emit?
     * @returns {boolean}
     */
    canEmit: function() {
        var i = 0;
        while (i < this.requireFail.length) {
            if (!(this.requireFail[i].state & (STATE_FAILED | STATE_POSSIBLE))) {
                return false;
            }
            i++;
        }
        return true;
    },

    /**
     * update the recognizer
     * @param {Object} inputData
     */
    recognize: function(inputData) {
        // make a new copy of the inputData
        // so we can change the inputData without messing up the other recognizers
        var inputDataClone = assign({}, inputData);

        // is is enabled and allow recognizing?
        if (!boolOrFn(this.options.enable, [this, inputDataClone])) {
            this.reset();
            this.state = STATE_FAILED;
            return;
        }

        // reset when we've reached the end
        if (this.state & (STATE_RECOGNIZED | STATE_CANCELLED | STATE_FAILED)) {
            this.state = STATE_POSSIBLE;
        }

        this.state = this.process(inputDataClone);

        // the recognizer has recognized a gesture
        // so trigger an event
        if (this.state & (STATE_BEGAN | STATE_CHANGED | STATE_ENDED | STATE_CANCELLED)) {
            this.tryEmit(inputDataClone);
        }
    },

    /**
     * return the state of the recognizer
     * the actual recognizing happens in this method
     * @virtual
     * @param {Object} inputData
     * @returns {Const} STATE
     */
    process: function(inputData) { }, // jshint ignore:line

    /**
     * return the preferred touch-action
     * @virtual
     * @returns {Array}
     */
    getTouchAction: function() { },

    /**
     * called when the gesture isn't allowed to recognize
     * like when another is being recognized or it is disabled
     * @virtual
     */
    reset: function() { }
};

/**
 * get a usable string, used as event postfix
 * @param {Const} state
 * @returns {String} state
 */
function stateStr(state) {
    if (state & STATE_CANCELLED) {
        return 'cancel';
    } else if (state & STATE_ENDED) {
        return 'end';
    } else if (state & STATE_CHANGED) {
        return 'move';
    } else if (state & STATE_BEGAN) {
        return 'start';
    }
    return '';
}

/**
 * direction cons to string
 * @param {Const} direction
 * @returns {String}
 */
function directionStr(direction) {
    if (direction == DIRECTION_DOWN) {
        return 'down';
    } else if (direction == DIRECTION_UP) {
        return 'up';
    } else if (direction == DIRECTION_LEFT) {
        return 'left';
    } else if (direction == DIRECTION_RIGHT) {
        return 'right';
    }
    return '';
}

/**
 * get a recognizer by name if it is bound to a manager
 * @param {Recognizer|String} otherRecognizer
 * @param {Recognizer} recognizer
 * @returns {Recognizer}
 */
function getRecognizerByNameIfManager(otherRecognizer, recognizer) {
    var manager = recognizer.manager;
    if (manager) {
        return manager.get(otherRecognizer);
    }
    return otherRecognizer;
}

/**
 * This recognizer is just used as a base for the simple attribute recognizers.
 * @constructor
 * @extends Recognizer
 */
function AttrRecognizer() {
    Recognizer.apply(this, arguments);
}

inherit(AttrRecognizer, Recognizer, {
    /**
     * @namespace
     * @memberof AttrRecognizer
     */
    defaults: {
        /**
         * @type {Number}
         * @default 1
         */
        pointers: 1
    },

    /**
     * Used to check if it the recognizer receives valid input, like input.distance > 10.
     * @memberof AttrRecognizer
     * @param {Object} input
     * @returns {Boolean} recognized
     */
    attrTest: function(input) {
        var optionPointers = this.options.pointers;
        return optionPointers === 0 || input.pointers.length === optionPointers;
    },

    /**
     * Process the input and return the state for the recognizer
     * @memberof AttrRecognizer
     * @param {Object} input
     * @returns {*} State
     */
    process: function(input) {
        var state = this.state;
        var eventType = input.eventType;

        var isRecognized = state & (STATE_BEGAN | STATE_CHANGED);
        var isValid = this.attrTest(input);

        // on cancel input and we've recognized before, return STATE_CANCELLED
        if (isRecognized && (eventType & INPUT_CANCEL || !isValid)) {
            return state | STATE_CANCELLED;
        } else if (isRecognized || isValid) {
            if (eventType & INPUT_END) {
                return state | STATE_ENDED;
            } else if (!(state & STATE_BEGAN)) {
                return STATE_BEGAN;
            }
            return state | STATE_CHANGED;
        }
        return STATE_FAILED;
    }
});

/**
 * Pan
 * Recognized when the pointer is down and moved in the allowed direction.
 * @constructor
 * @extends AttrRecognizer
 */
function PanRecognizer() {
    AttrRecognizer.apply(this, arguments);

    this.pX = null;
    this.pY = null;
}

inherit(PanRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof PanRecognizer
     */
    defaults: {
        event: 'pan',
        threshold: 10,
        pointers: 1,
        direction: DIRECTION_ALL
    },

    getTouchAction: function() {
        var direction = this.options.direction;
        var actions = [];
        if (direction & DIRECTION_HORIZONTAL) {
            actions.push(TOUCH_ACTION_PAN_Y);
        }
        if (direction & DIRECTION_VERTICAL) {
            actions.push(TOUCH_ACTION_PAN_X);
        }
        return actions;
    },

    directionTest: function(input) {
        var options = this.options;
        var hasMoved = true;
        var distance = input.distance;
        var direction = input.direction;
        var x = input.deltaX;
        var y = input.deltaY;

        // lock to axis?
        if (!(direction & options.direction)) {
            if (options.direction & DIRECTION_HORIZONTAL) {
                direction = (x === 0) ? DIRECTION_NONE : (x < 0) ? DIRECTION_LEFT : DIRECTION_RIGHT;
                hasMoved = x != this.pX;
                distance = Math.abs(input.deltaX);
            } else {
                direction = (y === 0) ? DIRECTION_NONE : (y < 0) ? DIRECTION_UP : DIRECTION_DOWN;
                hasMoved = y != this.pY;
                distance = Math.abs(input.deltaY);
            }
        }
        input.direction = direction;
        return hasMoved && distance > options.threshold && direction & options.direction;
    },

    attrTest: function(input) {
        return AttrRecognizer.prototype.attrTest.call(this, input) &&
            (this.state & STATE_BEGAN || (!(this.state & STATE_BEGAN) && this.directionTest(input)));
    },

    emit: function(input) {

        this.pX = input.deltaX;
        this.pY = input.deltaY;

        var direction = directionStr(input.direction);

        if (direction) {
            input.additionalEvent = this.options.event + direction;
        }
        this._super.emit.call(this, input);
    }
});

/**
 * Pinch
 * Recognized when two or more pointers are moving toward (zoom-in) or away from each other (zoom-out).
 * @constructor
 * @extends AttrRecognizer
 */
function PinchRecognizer() {
    AttrRecognizer.apply(this, arguments);
}

inherit(PinchRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof PinchRecognizer
     */
    defaults: {
        event: 'pinch',
        threshold: 0,
        pointers: 2
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_NONE];
    },

    attrTest: function(input) {
        return this._super.attrTest.call(this, input) &&
            (Math.abs(input.scale - 1) > this.options.threshold || this.state & STATE_BEGAN);
    },

    emit: function(input) {
        if (input.scale !== 1) {
            var inOut = input.scale < 1 ? 'in' : 'out';
            input.additionalEvent = this.options.event + inOut;
        }
        this._super.emit.call(this, input);
    }
});

/**
 * Press
 * Recognized when the pointer is down for x ms without any movement.
 * @constructor
 * @extends Recognizer
 */
function PressRecognizer() {
    Recognizer.apply(this, arguments);

    this._timer = null;
    this._input = null;
}

inherit(PressRecognizer, Recognizer, {
    /**
     * @namespace
     * @memberof PressRecognizer
     */
    defaults: {
        event: 'press',
        pointers: 1,
        time: 251, // minimal time of the pointer to be pressed
        threshold: 9 // a minimal movement is ok, but keep it low
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_AUTO];
    },

    process: function(input) {
        var options = this.options;
        var validPointers = input.pointers.length === options.pointers;
        var validMovement = input.distance < options.threshold;
        var validTime = input.deltaTime > options.time;

        this._input = input;

        // we only allow little movement
        // and we've reached an end event, so a tap is possible
        if (!validMovement || !validPointers || (input.eventType & (INPUT_END | INPUT_CANCEL) && !validTime)) {
            this.reset();
        } else if (input.eventType & INPUT_START) {
            this.reset();
            this._timer = setTimeoutContext(function() {
                this.state = STATE_RECOGNIZED;
                this.tryEmit();
            }, options.time, this);
        } else if (input.eventType & INPUT_END) {
            return STATE_RECOGNIZED;
        }
        return STATE_FAILED;
    },

    reset: function() {
        clearTimeout(this._timer);
    },

    emit: function(input) {
        if (this.state !== STATE_RECOGNIZED) {
            return;
        }

        if (input && (input.eventType & INPUT_END)) {
            this.manager.emit(this.options.event + 'up', input);
        } else {
            this._input.timeStamp = now();
            this.manager.emit(this.options.event, this._input);
        }
    }
});

/**
 * Rotate
 * Recognized when two or more pointer are moving in a circular motion.
 * @constructor
 * @extends AttrRecognizer
 */
function RotateRecognizer() {
    AttrRecognizer.apply(this, arguments);
}

inherit(RotateRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof RotateRecognizer
     */
    defaults: {
        event: 'rotate',
        threshold: 0,
        pointers: 2
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_NONE];
    },

    attrTest: function(input) {
        return this._super.attrTest.call(this, input) &&
            (Math.abs(input.rotation) > this.options.threshold || this.state & STATE_BEGAN);
    }
});

/**
 * Swipe
 * Recognized when the pointer is moving fast (velocity), with enough distance in the allowed direction.
 * @constructor
 * @extends AttrRecognizer
 */
function SwipeRecognizer() {
    AttrRecognizer.apply(this, arguments);
}

inherit(SwipeRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof SwipeRecognizer
     */
    defaults: {
        event: 'swipe',
        threshold: 10,
        velocity: 0.3,
        direction: DIRECTION_HORIZONTAL | DIRECTION_VERTICAL,
        pointers: 1
    },

    getTouchAction: function() {
        return PanRecognizer.prototype.getTouchAction.call(this);
    },

    attrTest: function(input) {
        var direction = this.options.direction;
        var velocity;

        if (direction & (DIRECTION_HORIZONTAL | DIRECTION_VERTICAL)) {
            velocity = input.overallVelocity;
        } else if (direction & DIRECTION_HORIZONTAL) {
            velocity = input.overallVelocityX;
        } else if (direction & DIRECTION_VERTICAL) {
            velocity = input.overallVelocityY;
        }

        return this._super.attrTest.call(this, input) &&
            direction & input.offsetDirection &&
            input.distance > this.options.threshold &&
            input.maxPointers == this.options.pointers &&
            abs(velocity) > this.options.velocity && input.eventType & INPUT_END;
    },

    emit: function(input) {
        var direction = directionStr(input.offsetDirection);
        if (direction) {
            this.manager.emit(this.options.event + direction, input);
        }

        this.manager.emit(this.options.event, input);
    }
});

/**
 * A tap is ecognized when the pointer is doing a small tap/click. Multiple taps are recognized if they occur
 * between the given interval and position. The delay option can be used to recognize multi-taps without firing
 * a single tap.
 *
 * The eventData from the emitted event contains the property `tapCount`, which contains the amount of
 * multi-taps being recognized.
 * @constructor
 * @extends Recognizer
 */
function TapRecognizer() {
    Recognizer.apply(this, arguments);

    // previous time and center,
    // used for tap counting
    this.pTime = false;
    this.pCenter = false;

    this._timer = null;
    this._input = null;
    this.count = 0;
}

inherit(TapRecognizer, Recognizer, {
    /**
     * @namespace
     * @memberof PinchRecognizer
     */
    defaults: {
        event: 'tap',
        pointers: 1,
        taps: 1,
        interval: 300, // max time between the multi-tap taps
        time: 250, // max time of the pointer to be down (like finger on the screen)
        threshold: 9, // a minimal movement is ok, but keep it low
        posThreshold: 10 // a multi-tap can be a bit off the initial position
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_MANIPULATION];
    },

    process: function(input) {
        var options = this.options;

        var validPointers = input.pointers.length === options.pointers;
        var validMovement = input.distance < options.threshold;
        var validTouchTime = input.deltaTime < options.time;

        this.reset();

        if ((input.eventType & INPUT_START) && (this.count === 0)) {
            return this.failTimeout();
        }

        // we only allow little movement
        // and we've reached an end event, so a tap is possible
        if (validMovement && validTouchTime && validPointers) {
            if (input.eventType != INPUT_END) {
                return this.failTimeout();
            }

            var validInterval = this.pTime ? (input.timeStamp - this.pTime < options.interval) : true;
            var validMultiTap = !this.pCenter || getDistance(this.pCenter, input.center) < options.posThreshold;

            this.pTime = input.timeStamp;
            this.pCenter = input.center;

            if (!validMultiTap || !validInterval) {
                this.count = 1;
            } else {
                this.count += 1;
            }

            this._input = input;

            // if tap count matches we have recognized it,
            // else it has began recognizing...
            var tapCount = this.count % options.taps;
            if (tapCount === 0) {
                // no failing requirements, immediately trigger the tap event
                // or wait as long as the multitap interval to trigger
                if (!this.hasRequireFailures()) {
                    return STATE_RECOGNIZED;
                } else {
                    this._timer = setTimeoutContext(function() {
                        this.state = STATE_RECOGNIZED;
                        this.tryEmit();
                    }, options.interval, this);
                    return STATE_BEGAN;
                }
            }
        }
        return STATE_FAILED;
    },

    failTimeout: function() {
        this._timer = setTimeoutContext(function() {
            this.state = STATE_FAILED;
        }, this.options.interval, this);
        return STATE_FAILED;
    },

    reset: function() {
        clearTimeout(this._timer);
    },

    emit: function() {
        if (this.state == STATE_RECOGNIZED) {
            this._input.tapCount = this.count;
            this.manager.emit(this.options.event, this._input);
        }
    }
});

/**
 * Simple way to create a manager with a default set of recognizers.
 * @param {HTMLElement} element
 * @param {Object} [options]
 * @constructor
 */
function Hammer(element, options) {
    options = options || {};
    options.recognizers = ifUndefined(options.recognizers, Hammer.defaults.preset);
    return new Manager(element, options);
}

/**
 * @const {string}
 */
Hammer.VERSION = '2.0.7';

/**
 * default settings
 * @namespace
 */
Hammer.defaults = {
    /**
     * set if DOM events are being triggered.
     * But this is slower and unused by simple implementations, so disabled by default.
     * @type {Boolean}
     * @default false
     */
    domEvents: false,

    /**
     * The value for the touchAction property/fallback.
     * When set to `compute` it will magically set the correct value based on the added recognizers.
     * @type {String}
     * @default compute
     */
    touchAction: TOUCH_ACTION_COMPUTE,

    /**
     * @type {Boolean}
     * @default true
     */
    enable: true,

    /**
     * EXPERIMENTAL FEATURE -- can be removed/changed
     * Change the parent input target element.
     * If Null, then it is being set the to main element.
     * @type {Null|EventTarget}
     * @default null
     */
    inputTarget: null,

    /**
     * force an input class
     * @type {Null|Function}
     * @default null
     */
    inputClass: null,

    /**
     * Default recognizer setup when calling `Hammer()`
     * When creating a new Manager these will be skipped.
     * @type {Array}
     */
    preset: [
        // RecognizerClass, options, [recognizeWith, ...], [requireFailure, ...]
        [RotateRecognizer, {enable: false}],
        [PinchRecognizer, {enable: false}, ['rotate']],
        [SwipeRecognizer, {direction: DIRECTION_HORIZONTAL}],
        [PanRecognizer, {direction: DIRECTION_HORIZONTAL}, ['swipe']],
        [TapRecognizer],
        [TapRecognizer, {event: 'doubletap', taps: 2}, ['tap']],
        [PressRecognizer]
    ],

    /**
     * Some CSS properties can be used to improve the working of Hammer.
     * Add them to this method and they will be set when creating a new Manager.
     * @namespace
     */
    cssProps: {
        /**
         * Disables text selection to improve the dragging gesture. Mainly for desktop browsers.
         * @type {String}
         * @default 'none'
         */
        userSelect: 'none',

        /**
         * Disable the Windows Phone grippers when pressing an element.
         * @type {String}
         * @default 'none'
         */
        touchSelect: 'none',

        /**
         * Disables the default callout shown when you touch and hold a touch target.
         * On iOS, when you touch and hold a touch target such as a link, Safari displays
         * a callout containing information about the link. This property allows you to disable that callout.
         * @type {String}
         * @default 'none'
         */
        touchCallout: 'none',

        /**
         * Specifies whether zooming is enabled. Used by IE10>
         * @type {String}
         * @default 'none'
         */
        contentZooming: 'none',

        /**
         * Specifies that an entire element should be draggable instead of its contents. Mainly for desktop browsers.
         * @type {String}
         * @default 'none'
         */
        userDrag: 'none',

        /**
         * Overrides the highlight color shown when the user taps a link or a JavaScript
         * clickable element in iOS. This property obeys the alpha value, if specified.
         * @type {String}
         * @default 'rgba(0,0,0,0)'
         */
        tapHighlightColor: 'rgba(0,0,0,0)'
    }
};

var STOP = 1;
var FORCED_STOP = 2;

/**
 * Manager
 * @param {HTMLElement} element
 * @param {Object} [options]
 * @constructor
 */
function Manager(element, options) {
    this.options = assign({}, Hammer.defaults, options || {});

    this.options.inputTarget = this.options.inputTarget || element;

    this.handlers = {};
    this.session = {};
    this.recognizers = [];
    this.oldCssProps = {};

    this.element = element;
    this.input = createInputInstance(this);
    this.touchAction = new TouchAction(this, this.options.touchAction);

    toggleCssProps(this, true);

    each(this.options.recognizers, function(item) {
        var recognizer = this.add(new (item[0])(item[1]));
        item[2] && recognizer.recognizeWith(item[2]);
        item[3] && recognizer.requireFailure(item[3]);
    }, this);
}

Manager.prototype = {
    /**
     * set options
     * @param {Object} options
     * @returns {Manager}
     */
    set: function(options) {
        assign(this.options, options);

        // Options that need a little more setup
        if (options.touchAction) {
            this.touchAction.update();
        }
        if (options.inputTarget) {
            // Clean up existing event listeners and reinitialize
            this.input.destroy();
            this.input.target = options.inputTarget;
            this.input.init();
        }
        return this;
    },

    /**
     * stop recognizing for this session.
     * This session will be discarded, when a new [input]start event is fired.
     * When forced, the recognizer cycle is stopped immediately.
     * @param {Boolean} [force]
     */
    stop: function(force) {
        this.session.stopped = force ? FORCED_STOP : STOP;
    },

    /**
     * run the recognizers!
     * called by the inputHandler function on every movement of the pointers (touches)
     * it walks through all the recognizers and tries to detect the gesture that is being made
     * @param {Object} inputData
     */
    recognize: function(inputData) {
        var session = this.session;
        if (session.stopped) {
            return;
        }

        // run the touch-action polyfill
        this.touchAction.preventDefaults(inputData);

        var recognizer;
        var recognizers = this.recognizers;

        // this holds the recognizer that is being recognized.
        // so the recognizer's state needs to be BEGAN, CHANGED, ENDED or RECOGNIZED
        // if no recognizer is detecting a thing, it is set to `null`
        var curRecognizer = session.curRecognizer;

        // reset when the last recognizer is recognized
        // or when we're in a new session
        if (!curRecognizer || (curRecognizer && curRecognizer.state & STATE_RECOGNIZED)) {
            curRecognizer = session.curRecognizer = null;
        }

        var i = 0;
        while (i < recognizers.length) {
            recognizer = recognizers[i];

            // find out if we are allowed try to recognize the input for this one.
            // 1.   allow if the session is NOT forced stopped (see the .stop() method)
            // 2.   allow if we still haven't recognized a gesture in this session, or the this recognizer is the one
            //      that is being recognized.
            // 3.   allow if the recognizer is allowed to run simultaneous with the current recognized recognizer.
            //      this can be setup with the `recognizeWith()` method on the recognizer.
            if (session.stopped !== FORCED_STOP && ( // 1
                    !curRecognizer || recognizer == curRecognizer || // 2
                    recognizer.canRecognizeWith(curRecognizer))) { // 3
                recognizer.recognize(inputData);
            } else {
                recognizer.reset();
            }

            // if the recognizer has been recognizing the input as a valid gesture, we want to store this one as the
            // current active recognizer. but only if we don't already have an active recognizer
            if (!curRecognizer && recognizer.state & (STATE_BEGAN | STATE_CHANGED | STATE_ENDED)) {
                curRecognizer = session.curRecognizer = recognizer;
            }
            i++;
        }
    },

    /**
     * get a recognizer by its event name.
     * @param {Recognizer|String} recognizer
     * @returns {Recognizer|Null}
     */
    get: function(recognizer) {
        if (recognizer instanceof Recognizer) {
            return recognizer;
        }

        var recognizers = this.recognizers;
        for (var i = 0; i < recognizers.length; i++) {
            if (recognizers[i].options.event == recognizer) {
                return recognizers[i];
            }
        }
        return null;
    },

    /**
     * add a recognizer to the manager
     * existing recognizers with the same event name will be removed
     * @param {Recognizer} recognizer
     * @returns {Recognizer|Manager}
     */
    add: function(recognizer) {
        if (invokeArrayArg(recognizer, 'add', this)) {
            return this;
        }

        // remove existing
        var existing = this.get(recognizer.options.event);
        if (existing) {
            this.remove(existing);
        }

        this.recognizers.push(recognizer);
        recognizer.manager = this;

        this.touchAction.update();
        return recognizer;
    },

    /**
     * remove a recognizer by name or instance
     * @param {Recognizer|String} recognizer
     * @returns {Manager}
     */
    remove: function(recognizer) {
        if (invokeArrayArg(recognizer, 'remove', this)) {
            return this;
        }

        recognizer = this.get(recognizer);

        // let's make sure this recognizer exists
        if (recognizer) {
            var recognizers = this.recognizers;
            var index = inArray(recognizers, recognizer);

            if (index !== -1) {
                recognizers.splice(index, 1);
                this.touchAction.update();
            }
        }

        return this;
    },

    /**
     * bind event
     * @param {String} events
     * @param {Function} handler
     * @returns {EventEmitter} this
     */
    on: function(events, handler) {
        if (events === undefined) {
            return;
        }
        if (handler === undefined) {
            return;
        }

        var handlers = this.handlers;
        each(splitStr(events), function(event) {
            handlers[event] = handlers[event] || [];
            handlers[event].push(handler);
        });
        return this;
    },

    /**
     * unbind event, leave emit blank to remove all handlers
     * @param {String} events
     * @param {Function} [handler]
     * @returns {EventEmitter} this
     */
    off: function(events, handler) {
        if (events === undefined) {
            return;
        }

        var handlers = this.handlers;
        each(splitStr(events), function(event) {
            if (!handler) {
                delete handlers[event];
            } else {
                handlers[event] && handlers[event].splice(inArray(handlers[event], handler), 1);
            }
        });
        return this;
    },

    /**
     * emit event to the listeners
     * @param {String} event
     * @param {Object} data
     */
    emit: function(event, data) {
        // we also want to trigger dom events
        if (this.options.domEvents) {
            triggerDomEvent(event, data);
        }

        // no handlers, so skip it all
        var handlers = this.handlers[event] && this.handlers[event].slice();
        if (!handlers || !handlers.length) {
            return;
        }

        data.type = event;
        data.preventDefault = function() {
            data.srcEvent.preventDefault();
        };

        var i = 0;
        while (i < handlers.length) {
            handlers[i](data);
            i++;
        }
    },

    /**
     * destroy the manager and unbinds all events
     * it doesn't unbind dom events, that is the user own responsibility
     */
    destroy: function() {
        this.element && toggleCssProps(this, false);

        this.handlers = {};
        this.session = {};
        this.input.destroy();
        this.element = null;
    }
};

/**
 * add/remove the css properties as defined in manager.options.cssProps
 * @param {Manager} manager
 * @param {Boolean} add
 */
function toggleCssProps(manager, add) {
    var element = manager.element;
    if (!element.style) {
        return;
    }
    var prop;
    each(manager.options.cssProps, function(value, name) {
        prop = prefixed(element.style, name);
        if (add) {
            manager.oldCssProps[prop] = element.style[prop];
            element.style[prop] = value;
        } else {
            element.style[prop] = manager.oldCssProps[prop] || '';
        }
    });
    if (!add) {
        manager.oldCssProps = {};
    }
}

/**
 * trigger dom event
 * @param {String} event
 * @param {Object} data
 */
function triggerDomEvent(event, data) {
    var gestureEvent = document.createEvent('Event');
    gestureEvent.initEvent(event, true, true);
    gestureEvent.gesture = data;
    data.target.dispatchEvent(gestureEvent);
}

assign(Hammer, {
    INPUT_START: INPUT_START,
    INPUT_MOVE: INPUT_MOVE,
    INPUT_END: INPUT_END,
    INPUT_CANCEL: INPUT_CANCEL,

    STATE_POSSIBLE: STATE_POSSIBLE,
    STATE_BEGAN: STATE_BEGAN,
    STATE_CHANGED: STATE_CHANGED,
    STATE_ENDED: STATE_ENDED,
    STATE_RECOGNIZED: STATE_RECOGNIZED,
    STATE_CANCELLED: STATE_CANCELLED,
    STATE_FAILED: STATE_FAILED,

    DIRECTION_NONE: DIRECTION_NONE,
    DIRECTION_LEFT: DIRECTION_LEFT,
    DIRECTION_RIGHT: DIRECTION_RIGHT,
    DIRECTION_UP: DIRECTION_UP,
    DIRECTION_DOWN: DIRECTION_DOWN,
    DIRECTION_HORIZONTAL: DIRECTION_HORIZONTAL,
    DIRECTION_VERTICAL: DIRECTION_VERTICAL,
    DIRECTION_ALL: DIRECTION_ALL,

    Manager: Manager,
    Input: Input,
    TouchAction: TouchAction,

    TouchInput: TouchInput,
    MouseInput: MouseInput,
    PointerEventInput: PointerEventInput,
    TouchMouseInput: TouchMouseInput,
    SingleTouchInput: SingleTouchInput,

    Recognizer: Recognizer,
    AttrRecognizer: AttrRecognizer,
    Tap: TapRecognizer,
    Pan: PanRecognizer,
    Swipe: SwipeRecognizer,
    Pinch: PinchRecognizer,
    Rotate: RotateRecognizer,
    Press: PressRecognizer,

    on: addEventListeners,
    off: removeEventListeners,
    each: each,
    merge: merge,
    extend: extend,
    assign: assign,
    inherit: inherit,
    bindFn: bindFn,
    prefixed: prefixed
});

// this prevents errors when Hammer is loaded in the presence of an AMD
//  style loader but by script tag, not by the loader.
var freeGlobal = (typeof window !== 'undefined' ? window : (typeof self !== 'undefined' ? self : {})); // jshint ignore:line
freeGlobal.Hammer = Hammer;

if (true) {
    !(__WEBPACK_AMD_DEFINE_RESULT__ = (function() {
        return Hammer;
    }).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
} else if (typeof module != 'undefined' && module.exports) {
    module.exports = Hammer;
} else {
    window[exportName] = Hammer;
}

})(window, document, 'Hammer');


/***/ }),
/* 680 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Url */
/* unused harmony export Http */
/* unused harmony export Resource */
/*!
 * vue-resource v1.5.1
 * https://github.com/pagekit/vue-resource
 * Released under the MIT License.
 */

/**
 * Promises/A+ polyfill v1.1.4 (https://github.com/bramstein/promis)
 */

var RESOLVED = 0;
var REJECTED = 1;
var PENDING = 2;

function Promise$1(executor) {

    this.state = PENDING;
    this.value = undefined;
    this.deferred = [];

    var promise = this;

    try {
        executor(function (x) {
            promise.resolve(x);
        }, function (r) {
            promise.reject(r);
        });
    } catch (e) {
        promise.reject(e);
    }
}

Promise$1.reject = function (r) {
    return new Promise$1(function (resolve, reject) {
        reject(r);
    });
};

Promise$1.resolve = function (x) {
    return new Promise$1(function (resolve, reject) {
        resolve(x);
    });
};

Promise$1.all = function all(iterable) {
    return new Promise$1(function (resolve, reject) {
        var count = 0, result = [];

        if (iterable.length === 0) {
            resolve(result);
        }

        function resolver(i) {
            return function (x) {
                result[i] = x;
                count += 1;

                if (count === iterable.length) {
                    resolve(result);
                }
            };
        }

        for (var i = 0; i < iterable.length; i += 1) {
            Promise$1.resolve(iterable[i]).then(resolver(i), reject);
        }
    });
};

Promise$1.race = function race(iterable) {
    return new Promise$1(function (resolve, reject) {
        for (var i = 0; i < iterable.length; i += 1) {
            Promise$1.resolve(iterable[i]).then(resolve, reject);
        }
    });
};

var p = Promise$1.prototype;

p.resolve = function resolve(x) {
    var promise = this;

    if (promise.state === PENDING) {
        if (x === promise) {
            throw new TypeError('Promise settled with itself.');
        }

        var called = false;

        try {
            var then = x && x['then'];

            if (x !== null && typeof x === 'object' && typeof then === 'function') {
                then.call(x, function (x) {
                    if (!called) {
                        promise.resolve(x);
                    }
                    called = true;

                }, function (r) {
                    if (!called) {
                        promise.reject(r);
                    }
                    called = true;
                });
                return;
            }
        } catch (e) {
            if (!called) {
                promise.reject(e);
            }
            return;
        }

        promise.state = RESOLVED;
        promise.value = x;
        promise.notify();
    }
};

p.reject = function reject(reason) {
    var promise = this;

    if (promise.state === PENDING) {
        if (reason === promise) {
            throw new TypeError('Promise settled with itself.');
        }

        promise.state = REJECTED;
        promise.value = reason;
        promise.notify();
    }
};

p.notify = function notify() {
    var promise = this;

    nextTick(function () {
        if (promise.state !== PENDING) {
            while (promise.deferred.length) {
                var deferred = promise.deferred.shift(),
                    onResolved = deferred[0],
                    onRejected = deferred[1],
                    resolve = deferred[2],
                    reject = deferred[3];

                try {
                    if (promise.state === RESOLVED) {
                        if (typeof onResolved === 'function') {
                            resolve(onResolved.call(undefined, promise.value));
                        } else {
                            resolve(promise.value);
                        }
                    } else if (promise.state === REJECTED) {
                        if (typeof onRejected === 'function') {
                            resolve(onRejected.call(undefined, promise.value));
                        } else {
                            reject(promise.value);
                        }
                    }
                } catch (e) {
                    reject(e);
                }
            }
        }
    });
};

p.then = function then(onResolved, onRejected) {
    var promise = this;

    return new Promise$1(function (resolve, reject) {
        promise.deferred.push([onResolved, onRejected, resolve, reject]);
        promise.notify();
    });
};

p.catch = function (onRejected) {
    return this.then(undefined, onRejected);
};

/**
 * Promise adapter.
 */

if (typeof Promise === 'undefined') {
    window.Promise = Promise$1;
}

function PromiseObj(executor, context) {

    if (executor instanceof Promise) {
        this.promise = executor;
    } else {
        this.promise = new Promise(executor.bind(context));
    }

    this.context = context;
}

PromiseObj.all = function (iterable, context) {
    return new PromiseObj(Promise.all(iterable), context);
};

PromiseObj.resolve = function (value, context) {
    return new PromiseObj(Promise.resolve(value), context);
};

PromiseObj.reject = function (reason, context) {
    return new PromiseObj(Promise.reject(reason), context);
};

PromiseObj.race = function (iterable, context) {
    return new PromiseObj(Promise.race(iterable), context);
};

var p$1 = PromiseObj.prototype;

p$1.bind = function (context) {
    this.context = context;
    return this;
};

p$1.then = function (fulfilled, rejected) {

    if (fulfilled && fulfilled.bind && this.context) {
        fulfilled = fulfilled.bind(this.context);
    }

    if (rejected && rejected.bind && this.context) {
        rejected = rejected.bind(this.context);
    }

    return new PromiseObj(this.promise.then(fulfilled, rejected), this.context);
};

p$1.catch = function (rejected) {

    if (rejected && rejected.bind && this.context) {
        rejected = rejected.bind(this.context);
    }

    return new PromiseObj(this.promise.catch(rejected), this.context);
};

p$1.finally = function (callback) {

    return this.then(function (value) {
        callback.call(this);
        return value;
    }, function (reason) {
        callback.call(this);
        return Promise.reject(reason);
    }
    );
};

/**
 * Utility functions.
 */

var ref = {};
var hasOwnProperty = ref.hasOwnProperty;
var ref$1 = [];
var slice = ref$1.slice;
var debug = false, ntick;

var inBrowser = typeof window !== 'undefined';

function Util (ref) {
    var config = ref.config;
    var nextTick = ref.nextTick;

    ntick = nextTick;
    debug = config.debug || !config.silent;
}

function warn(msg) {
    if (typeof console !== 'undefined' && debug) {
        console.warn('[VueResource warn]: ' + msg);
    }
}

function error(msg) {
    if (typeof console !== 'undefined') {
        console.error(msg);
    }
}

function nextTick(cb, ctx) {
    return ntick(cb, ctx);
}

function trim(str) {
    return str ? str.replace(/^\s*|\s*$/g, '') : '';
}

function trimEnd(str, chars) {

    if (str && chars === undefined) {
        return str.replace(/\s+$/, '');
    }

    if (!str || !chars) {
        return str;
    }

    return str.replace(new RegExp(("[" + chars + "]+$")), '');
}

function toLower(str) {
    return str ? str.toLowerCase() : '';
}

function toUpper(str) {
    return str ? str.toUpperCase() : '';
}

var isArray = Array.isArray;

function isString(val) {
    return typeof val === 'string';
}

function isFunction(val) {
    return typeof val === 'function';
}

function isObject(obj) {
    return obj !== null && typeof obj === 'object';
}

function isPlainObject(obj) {
    return isObject(obj) && Object.getPrototypeOf(obj) == Object.prototype;
}

function isBlob(obj) {
    return typeof Blob !== 'undefined' && obj instanceof Blob;
}

function isFormData(obj) {
    return typeof FormData !== 'undefined' && obj instanceof FormData;
}

function when(value, fulfilled, rejected) {

    var promise = PromiseObj.resolve(value);

    if (arguments.length < 2) {
        return promise;
    }

    return promise.then(fulfilled, rejected);
}

function options(fn, obj, opts) {

    opts = opts || {};

    if (isFunction(opts)) {
        opts = opts.call(obj);
    }

    return merge(fn.bind({$vm: obj, $options: opts}), fn, {$options: opts});
}

function each(obj, iterator) {

    var i, key;

    if (isArray(obj)) {
        for (i = 0; i < obj.length; i++) {
            iterator.call(obj[i], obj[i], i);
        }
    } else if (isObject(obj)) {
        for (key in obj) {
            if (hasOwnProperty.call(obj, key)) {
                iterator.call(obj[key], obj[key], key);
            }
        }
    }

    return obj;
}

var assign = Object.assign || _assign;

function merge(target) {

    var args = slice.call(arguments, 1);

    args.forEach(function (source) {
        _merge(target, source, true);
    });

    return target;
}

function defaults(target) {

    var args = slice.call(arguments, 1);

    args.forEach(function (source) {

        for (var key in source) {
            if (target[key] === undefined) {
                target[key] = source[key];
            }
        }

    });

    return target;
}

function _assign(target) {

    var args = slice.call(arguments, 1);

    args.forEach(function (source) {
        _merge(target, source);
    });

    return target;
}

function _merge(target, source, deep) {
    for (var key in source) {
        if (deep && (isPlainObject(source[key]) || isArray(source[key]))) {
            if (isPlainObject(source[key]) && !isPlainObject(target[key])) {
                target[key] = {};
            }
            if (isArray(source[key]) && !isArray(target[key])) {
                target[key] = [];
            }
            _merge(target[key], source[key], deep);
        } else if (source[key] !== undefined) {
            target[key] = source[key];
        }
    }
}

/**
 * Root Prefix Transform.
 */

function root (options$$1, next) {

    var url = next(options$$1);

    if (isString(options$$1.root) && !/^(https?:)?\//.test(url)) {
        url = trimEnd(options$$1.root, '/') + '/' + url;
    }

    return url;
}

/**
 * Query Parameter Transform.
 */

function query (options$$1, next) {

    var urlParams = Object.keys(Url.options.params), query = {}, url = next(options$$1);

    each(options$$1.params, function (value, key) {
        if (urlParams.indexOf(key) === -1) {
            query[key] = value;
        }
    });

    query = Url.params(query);

    if (query) {
        url += (url.indexOf('?') == -1 ? '?' : '&') + query;
    }

    return url;
}

/**
 * URL Template v2.0.6 (https://github.com/bramstein/url-template)
 */

function expand(url, params, variables) {

    var tmpl = parse(url), expanded = tmpl.expand(params);

    if (variables) {
        variables.push.apply(variables, tmpl.vars);
    }

    return expanded;
}

function parse(template) {

    var operators = ['+', '#', '.', '/', ';', '?', '&'], variables = [];

    return {
        vars: variables,
        expand: function expand(context) {
            return template.replace(/\{([^{}]+)\}|([^{}]+)/g, function (_, expression, literal) {
                if (expression) {

                    var operator = null, values = [];

                    if (operators.indexOf(expression.charAt(0)) !== -1) {
                        operator = expression.charAt(0);
                        expression = expression.substr(1);
                    }

                    expression.split(/,/g).forEach(function (variable) {
                        var tmp = /([^:*]*)(?::(\d+)|(\*))?/.exec(variable);
                        values.push.apply(values, getValues(context, operator, tmp[1], tmp[2] || tmp[3]));
                        variables.push(tmp[1]);
                    });

                    if (operator && operator !== '+') {

                        var separator = ',';

                        if (operator === '?') {
                            separator = '&';
                        } else if (operator !== '#') {
                            separator = operator;
                        }

                        return (values.length !== 0 ? operator : '') + values.join(separator);
                    } else {
                        return values.join(',');
                    }

                } else {
                    return encodeReserved(literal);
                }
            });
        }
    };
}

function getValues(context, operator, key, modifier) {

    var value = context[key], result = [];

    if (isDefined(value) && value !== '') {
        if (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean') {
            value = value.toString();

            if (modifier && modifier !== '*') {
                value = value.substring(0, parseInt(modifier, 10));
            }

            result.push(encodeValue(operator, value, isKeyOperator(operator) ? key : null));
        } else {
            if (modifier === '*') {
                if (Array.isArray(value)) {
                    value.filter(isDefined).forEach(function (value) {
                        result.push(encodeValue(operator, value, isKeyOperator(operator) ? key : null));
                    });
                } else {
                    Object.keys(value).forEach(function (k) {
                        if (isDefined(value[k])) {
                            result.push(encodeValue(operator, value[k], k));
                        }
                    });
                }
            } else {
                var tmp = [];

                if (Array.isArray(value)) {
                    value.filter(isDefined).forEach(function (value) {
                        tmp.push(encodeValue(operator, value));
                    });
                } else {
                    Object.keys(value).forEach(function (k) {
                        if (isDefined(value[k])) {
                            tmp.push(encodeURIComponent(k));
                            tmp.push(encodeValue(operator, value[k].toString()));
                        }
                    });
                }

                if (isKeyOperator(operator)) {
                    result.push(encodeURIComponent(key) + '=' + tmp.join(','));
                } else if (tmp.length !== 0) {
                    result.push(tmp.join(','));
                }
            }
        }
    } else {
        if (operator === ';') {
            result.push(encodeURIComponent(key));
        } else if (value === '' && (operator === '&' || operator === '?')) {
            result.push(encodeURIComponent(key) + '=');
        } else if (value === '') {
            result.push('');
        }
    }

    return result;
}

function isDefined(value) {
    return value !== undefined && value !== null;
}

function isKeyOperator(operator) {
    return operator === ';' || operator === '&' || operator === '?';
}

function encodeValue(operator, value, key) {

    value = (operator === '+' || operator === '#') ? encodeReserved(value) : encodeURIComponent(value);

    if (key) {
        return encodeURIComponent(key) + '=' + value;
    } else {
        return value;
    }
}

function encodeReserved(str) {
    return str.split(/(%[0-9A-Fa-f]{2})/g).map(function (part) {
        if (!/%[0-9A-Fa-f]/.test(part)) {
            part = encodeURI(part);
        }
        return part;
    }).join('');
}

/**
 * URL Template (RFC 6570) Transform.
 */

function template (options) {

    var variables = [], url = expand(options.url, options.params, variables);

    variables.forEach(function (key) {
        delete options.params[key];
    });

    return url;
}

/**
 * Service for URL templating.
 */

function Url(url, params) {

    var self = this || {}, options$$1 = url, transform;

    if (isString(url)) {
        options$$1 = {url: url, params: params};
    }

    options$$1 = merge({}, Url.options, self.$options, options$$1);

    Url.transforms.forEach(function (handler) {

        if (isString(handler)) {
            handler = Url.transform[handler];
        }

        if (isFunction(handler)) {
            transform = factory(handler, transform, self.$vm);
        }

    });

    return transform(options$$1);
}

/**
 * Url options.
 */

Url.options = {
    url: '',
    root: null,
    params: {}
};

/**
 * Url transforms.
 */

Url.transform = {template: template, query: query, root: root};
Url.transforms = ['template', 'query', 'root'];

/**
 * Encodes a Url parameter string.
 *
 * @param {Object} obj
 */

Url.params = function (obj) {

    var params = [], escape = encodeURIComponent;

    params.add = function (key, value) {

        if (isFunction(value)) {
            value = value();
        }

        if (value === null) {
            value = '';
        }

        this.push(escape(key) + '=' + escape(value));
    };

    serialize(params, obj);

    return params.join('&').replace(/%20/g, '+');
};

/**
 * Parse a URL and return its components.
 *
 * @param {String} url
 */

Url.parse = function (url) {

    var el = document.createElement('a');

    if (document.documentMode) {
        el.href = url;
        url = el.href;
    }

    el.href = url;

    return {
        href: el.href,
        protocol: el.protocol ? el.protocol.replace(/:$/, '') : '',
        port: el.port,
        host: el.host,
        hostname: el.hostname,
        pathname: el.pathname.charAt(0) === '/' ? el.pathname : '/' + el.pathname,
        search: el.search ? el.search.replace(/^\?/, '') : '',
        hash: el.hash ? el.hash.replace(/^#/, '') : ''
    };
};

function factory(handler, next, vm) {
    return function (options$$1) {
        return handler.call(vm, options$$1, next);
    };
}

function serialize(params, obj, scope) {

    var array = isArray(obj), plain = isPlainObject(obj), hash;

    each(obj, function (value, key) {

        hash = isObject(value) || isArray(value);

        if (scope) {
            key = scope + '[' + (plain || hash ? key : '') + ']';
        }

        if (!scope && array) {
            params.add(value.name, value.value);
        } else if (hash) {
            serialize(params, value, key);
        } else {
            params.add(key, value);
        }
    });
}

/**
 * XDomain client (Internet Explorer).
 */

function xdrClient (request) {
    return new PromiseObj(function (resolve) {

        var xdr = new XDomainRequest(), handler = function (ref) {
                var type = ref.type;


                var status = 0;

                if (type === 'load') {
                    status = 200;
                } else if (type === 'error') {
                    status = 500;
                }

                resolve(request.respondWith(xdr.responseText, {status: status}));
            };

        request.abort = function () { return xdr.abort(); };

        xdr.open(request.method, request.getUrl());

        if (request.timeout) {
            xdr.timeout = request.timeout;
        }

        xdr.onload = handler;
        xdr.onabort = handler;
        xdr.onerror = handler;
        xdr.ontimeout = handler;
        xdr.onprogress = function () {};
        xdr.send(request.getBody());
    });
}

/**
 * CORS Interceptor.
 */

var SUPPORTS_CORS = inBrowser && 'withCredentials' in new XMLHttpRequest();

function cors (request) {

    if (inBrowser) {

        var orgUrl = Url.parse(location.href);
        var reqUrl = Url.parse(request.getUrl());

        if (reqUrl.protocol !== orgUrl.protocol || reqUrl.host !== orgUrl.host) {

            request.crossOrigin = true;
            request.emulateHTTP = false;

            if (!SUPPORTS_CORS) {
                request.client = xdrClient;
            }
        }
    }

}

/**
 * Form data Interceptor.
 */

function form (request) {

    if (isFormData(request.body)) {
        request.headers.delete('Content-Type');
    } else if (isObject(request.body) && request.emulateJSON) {
        request.body = Url.params(request.body);
        request.headers.set('Content-Type', 'application/x-www-form-urlencoded');
    }

}

/**
 * JSON Interceptor.
 */

function json (request) {

    var type = request.headers.get('Content-Type') || '';

    if (isObject(request.body) && type.indexOf('application/json') === 0) {
        request.body = JSON.stringify(request.body);
    }

    return function (response) {

        return response.bodyText ? when(response.text(), function (text) {

            var type = response.headers.get('Content-Type') || '';

            if (type.indexOf('application/json') === 0 || isJson(text)) {

                try {
                    response.body = JSON.parse(text);
                } catch (e) {
                    response.body = null;
                }

            } else {
                response.body = text;
            }

            return response;

        }) : response;

    };
}

function isJson(str) {

    var start = str.match(/^\s*(\[|\{)/);
    var end = {'[': /]\s*$/, '{': /}\s*$/};

    return start && end[start[1]].test(str);
}

/**
 * JSONP client (Browser).
 */

function jsonpClient (request) {
    return new PromiseObj(function (resolve) {

        var name = request.jsonp || 'callback', callback = request.jsonpCallback || '_jsonp' + Math.random().toString(36).substr(2), body = null, handler, script;

        handler = function (ref) {
            var type = ref.type;


            var status = 0;

            if (type === 'load' && body !== null) {
                status = 200;
            } else if (type === 'error') {
                status = 500;
            }

            if (status && window[callback]) {
                delete window[callback];
                document.body.removeChild(script);
            }

            resolve(request.respondWith(body, {status: status}));
        };

        window[callback] = function (result) {
            body = JSON.stringify(result);
        };

        request.abort = function () {
            handler({type: 'abort'});
        };

        request.params[name] = callback;

        if (request.timeout) {
            setTimeout(request.abort, request.timeout);
        }

        script = document.createElement('script');
        script.src = request.getUrl();
        script.type = 'text/javascript';
        script.async = true;
        script.onload = handler;
        script.onerror = handler;

        document.body.appendChild(script);
    });
}

/**
 * JSONP Interceptor.
 */

function jsonp (request) {

    if (request.method == 'JSONP') {
        request.client = jsonpClient;
    }

}

/**
 * Before Interceptor.
 */

function before (request) {

    if (isFunction(request.before)) {
        request.before.call(this, request);
    }

}

/**
 * HTTP method override Interceptor.
 */

function method (request) {

    if (request.emulateHTTP && /^(PUT|PATCH|DELETE)$/i.test(request.method)) {
        request.headers.set('X-HTTP-Method-Override', request.method);
        request.method = 'POST';
    }

}

/**
 * Header Interceptor.
 */

function header (request) {

    var headers = assign({}, Http.headers.common,
        !request.crossOrigin ? Http.headers.custom : {},
        Http.headers[toLower(request.method)]
    );

    each(headers, function (value, name) {
        if (!request.headers.has(name)) {
            request.headers.set(name, value);
        }
    });

}

/**
 * XMLHttp client (Browser).
 */

function xhrClient (request) {
    return new PromiseObj(function (resolve) {

        var xhr = new XMLHttpRequest(), handler = function (event) {

                var response = request.respondWith(
                'response' in xhr ? xhr.response : xhr.responseText, {
                    status: xhr.status === 1223 ? 204 : xhr.status, // IE9 status bug
                    statusText: xhr.status === 1223 ? 'No Content' : trim(xhr.statusText)
                });

                each(trim(xhr.getAllResponseHeaders()).split('\n'), function (row) {
                    response.headers.append(row.slice(0, row.indexOf(':')), row.slice(row.indexOf(':') + 1));
                });

                resolve(response);
            };

        request.abort = function () { return xhr.abort(); };

        xhr.open(request.method, request.getUrl(), true);

        if (request.timeout) {
            xhr.timeout = request.timeout;
        }

        if (request.responseType && 'responseType' in xhr) {
            xhr.responseType = request.responseType;
        }

        if (request.withCredentials || request.credentials) {
            xhr.withCredentials = true;
        }

        if (!request.crossOrigin) {
            request.headers.set('X-Requested-With', 'XMLHttpRequest');
        }

        // deprecated use downloadProgress
        if (isFunction(request.progress) && request.method === 'GET') {
            xhr.addEventListener('progress', request.progress);
        }

        if (isFunction(request.downloadProgress)) {
            xhr.addEventListener('progress', request.downloadProgress);
        }

        // deprecated use uploadProgress
        if (isFunction(request.progress) && /^(POST|PUT)$/i.test(request.method)) {
            xhr.upload.addEventListener('progress', request.progress);
        }

        if (isFunction(request.uploadProgress) && xhr.upload) {
            xhr.upload.addEventListener('progress', request.uploadProgress);
        }

        request.headers.forEach(function (value, name) {
            xhr.setRequestHeader(name, value);
        });

        xhr.onload = handler;
        xhr.onabort = handler;
        xhr.onerror = handler;
        xhr.ontimeout = handler;
        xhr.send(request.getBody());
    });
}

/**
 * Http client (Node).
 */

function nodeClient (request) {

    var client = __webpack_require__(681);

    return new PromiseObj(function (resolve) {

        var url = request.getUrl();
        var body = request.getBody();
        var method = request.method;
        var headers = {}, handler;

        request.headers.forEach(function (value, name) {
            headers[name] = value;
        });

        client(url, {body: body, method: method, headers: headers}).then(handler = function (resp) {

            var response = request.respondWith(resp.body, {
                status: resp.statusCode,
                statusText: trim(resp.statusMessage)
            });

            each(resp.headers, function (value, name) {
                response.headers.set(name, value);
            });

            resolve(response);

        }, function (error$$1) { return handler(error$$1.response); });
    });
}

/**
 * Base client.
 */

function Client (context) {

    var reqHandlers = [sendRequest], resHandlers = [];

    if (!isObject(context)) {
        context = null;
    }

    function Client(request) {
        while (reqHandlers.length) {

            var handler = reqHandlers.pop();

            if (isFunction(handler)) {

                var response = (void 0), next = (void 0);

                response = handler.call(context, request, function (val) { return next = val; }) || next;

                if (isObject(response)) {
                    return new PromiseObj(function (resolve, reject) {

                        resHandlers.forEach(function (handler) {
                            response = when(response, function (response) {
                                return handler.call(context, response) || response;
                            }, reject);
                        });

                        when(response, resolve, reject);

                    }, context);
                }

                if (isFunction(response)) {
                    resHandlers.unshift(response);
                }

            } else {
                warn(("Invalid interceptor of type " + (typeof handler) + ", must be a function"));
            }
        }
    }

    Client.use = function (handler) {
        reqHandlers.push(handler);
    };

    return Client;
}

function sendRequest(request) {

    var client = request.client || (inBrowser ? xhrClient : nodeClient);

    return client(request);
}

/**
 * HTTP Headers.
 */

var Headers = function Headers(headers) {
    var this$1 = this;


    this.map = {};

    each(headers, function (value, name) { return this$1.append(name, value); });
};

Headers.prototype.has = function has (name) {
    return getName(this.map, name) !== null;
};

Headers.prototype.get = function get (name) {

    var list = this.map[getName(this.map, name)];

    return list ? list.join() : null;
};

Headers.prototype.getAll = function getAll (name) {
    return this.map[getName(this.map, name)] || [];
};

Headers.prototype.set = function set (name, value) {
    this.map[normalizeName(getName(this.map, name) || name)] = [trim(value)];
};

Headers.prototype.append = function append (name, value) {

    var list = this.map[getName(this.map, name)];

    if (list) {
        list.push(trim(value));
    } else {
        this.set(name, value);
    }
};

Headers.prototype.delete = function delete$1 (name) {
    delete this.map[getName(this.map, name)];
};

Headers.prototype.deleteAll = function deleteAll () {
    this.map = {};
};

Headers.prototype.forEach = function forEach (callback, thisArg) {
        var this$1 = this;

    each(this.map, function (list, name) {
        each(list, function (value) { return callback.call(thisArg, value, name, this$1); });
    });
};

function getName(map, name) {
    return Object.keys(map).reduce(function (prev, curr) {
        return toLower(name) === toLower(curr) ? curr : prev;
    }, null);
}

function normalizeName(name) {

    if (/[^a-z0-9\-#$%&'*+.^_`|~]/i.test(name)) {
        throw new TypeError('Invalid character in header field name');
    }

    return trim(name);
}

/**
 * HTTP Response.
 */

var Response = function Response(body, ref) {
    var url = ref.url;
    var headers = ref.headers;
    var status = ref.status;
    var statusText = ref.statusText;


    this.url = url;
    this.ok = status >= 200 && status < 300;
    this.status = status || 0;
    this.statusText = statusText || '';
    this.headers = new Headers(headers);
    this.body = body;

    if (isString(body)) {

        this.bodyText = body;

    } else if (isBlob(body)) {

        this.bodyBlob = body;

        if (isBlobText(body)) {
            this.bodyText = blobText(body);
        }
    }
};

Response.prototype.blob = function blob () {
    return when(this.bodyBlob);
};

Response.prototype.text = function text () {
    return when(this.bodyText);
};

Response.prototype.json = function json () {
    return when(this.text(), function (text) { return JSON.parse(text); });
};

Object.defineProperty(Response.prototype, 'data', {

    get: function get() {
        return this.body;
    },

    set: function set(body) {
        this.body = body;
    }

});

function blobText(body) {
    return new PromiseObj(function (resolve) {

        var reader = new FileReader();

        reader.readAsText(body);
        reader.onload = function () {
            resolve(reader.result);
        };

    });
}

function isBlobText(body) {
    return body.type.indexOf('text') === 0 || body.type.indexOf('json') !== -1;
}

/**
 * HTTP Request.
 */

var Request = function Request(options$$1) {

    this.body = null;
    this.params = {};

    assign(this, options$$1, {
        method: toUpper(options$$1.method || 'GET')
    });

    if (!(this.headers instanceof Headers)) {
        this.headers = new Headers(this.headers);
    }
};

Request.prototype.getUrl = function getUrl () {
    return Url(this);
};

Request.prototype.getBody = function getBody () {
    return this.body;
};

Request.prototype.respondWith = function respondWith (body, options$$1) {
    return new Response(body, assign(options$$1 || {}, {url: this.getUrl()}));
};

/**
 * Service for sending network requests.
 */

var COMMON_HEADERS = {'Accept': 'application/json, text/plain, */*'};
var JSON_CONTENT_TYPE = {'Content-Type': 'application/json;charset=utf-8'};

function Http(options$$1) {

    var self = this || {}, client = Client(self.$vm);

    defaults(options$$1 || {}, self.$options, Http.options);

    Http.interceptors.forEach(function (handler) {

        if (isString(handler)) {
            handler = Http.interceptor[handler];
        }

        if (isFunction(handler)) {
            client.use(handler);
        }

    });

    return client(new Request(options$$1)).then(function (response) {

        return response.ok ? response : PromiseObj.reject(response);

    }, function (response) {

        if (response instanceof Error) {
            error(response);
        }

        return PromiseObj.reject(response);
    });
}

Http.options = {};

Http.headers = {
    put: JSON_CONTENT_TYPE,
    post: JSON_CONTENT_TYPE,
    patch: JSON_CONTENT_TYPE,
    delete: JSON_CONTENT_TYPE,
    common: COMMON_HEADERS,
    custom: {}
};

Http.interceptor = {before: before, method: method, jsonp: jsonp, json: json, form: form, header: header, cors: cors};
Http.interceptors = ['before', 'method', 'jsonp', 'json', 'form', 'header', 'cors'];

['get', 'delete', 'head', 'jsonp'].forEach(function (method$$1) {

    Http[method$$1] = function (url, options$$1) {
        return this(assign(options$$1 || {}, {url: url, method: method$$1}));
    };

});

['post', 'put', 'patch'].forEach(function (method$$1) {

    Http[method$$1] = function (url, body, options$$1) {
        return this(assign(options$$1 || {}, {url: url, method: method$$1, body: body}));
    };

});

/**
 * Service for interacting with RESTful services.
 */

function Resource(url, params, actions, options$$1) {

    var self = this || {}, resource = {};

    actions = assign({},
        Resource.actions,
        actions
    );

    each(actions, function (action, name) {

        action = merge({url: url, params: assign({}, params)}, options$$1, action);

        resource[name] = function () {
            return (self.$http || Http)(opts(action, arguments));
        };
    });

    return resource;
}

function opts(action, args) {

    var options$$1 = assign({}, action), params = {}, body;

    switch (args.length) {

        case 2:

            params = args[0];
            body = args[1];

            break;

        case 1:

            if (/^(POST|PUT|PATCH)$/i.test(options$$1.method)) {
                body = args[0];
            } else {
                params = args[0];
            }

            break;

        case 0:

            break;

        default:

            throw 'Expected up to 2 arguments [params, body], got ' + args.length + ' arguments';
    }

    options$$1.body = body;
    options$$1.params = assign({}, options$$1.params, params);

    return options$$1;
}

Resource.actions = {

    get: {method: 'GET'},
    save: {method: 'POST'},
    query: {method: 'GET'},
    update: {method: 'PUT'},
    remove: {method: 'DELETE'},
    delete: {method: 'DELETE'}

};

/**
 * Install plugin.
 */

function plugin(Vue) {

    if (plugin.installed) {
        return;
    }

    Util(Vue);

    Vue.url = Url;
    Vue.http = Http;
    Vue.resource = Resource;
    Vue.Promise = PromiseObj;

    Object.defineProperties(Vue.prototype, {

        $url: {
            get: function get() {
                return options(Vue.url, this, this.$options.url);
            }
        },

        $http: {
            get: function get() {
                return options(Vue.http, this, this.$options.http);
            }
        },

        $resource: {
            get: function get() {
                return Vue.resource.bind(this);
            }
        },

        $promise: {
            get: function get() {
                var this$1 = this;

                return function (executor) { return new Vue.Promise(executor, this$1); };
            }
        }

    });
}

if (typeof window !== 'undefined' && window.Vue) {
    window.Vue.use(plugin);
}

/* harmony default export */ __webpack_exports__["a"] = (plugin);



/***/ }),
/* 681 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 682 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,n){if(true)module.exports=n();else if("function"==typeof define&&define.amd)define([],n);else{var t=n();for(var r in t)("object"==typeof exports?exports:e)[r]=t[r]}}("undefined"!=typeof self?self:this,(function(){return function(e){var n={};function t(r){if(n[r])return n[r].exports;var o=n[r]={i:r,l:!1,exports:{}};return e[r].call(o.exports,o,o.exports,t),o.l=!0,o.exports}return t.m=e,t.c=n,t.d=function(e,n,r){t.o(e,n)||Object.defineProperty(e,n,{enumerable:!0,get:r})},t.r=function(e){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0})},t.t=function(e,n){if(1&n&&(e=t(e)),8&n)return e;if(4&n&&"object"==typeof e&&e&&e.__esModule)return e;var r=Object.create(null);if(t.r(r),Object.defineProperty(r,"default",{enumerable:!0,value:e}),2&n&&"string"!=typeof e)for(var o in e)t.d(r,o,function(n){return e[n]}.bind(null,o));return r},t.n=function(e){var n=e&&e.__esModule?function(){return e.default}:function(){return e};return t.d(n,"a",n),n},t.o=function(e,n){return Object.prototype.hasOwnProperty.call(e,n)},t.p="",t(t.s=0)}([function(e,n,t){"use strict";function r(e,n){var t=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);n&&(r=r.filter((function(n){return Object.getOwnPropertyDescriptor(e,n).enumerable}))),t.push.apply(t,r)}return t}function o(e){for(var n=1;n<arguments.length;n++){var t=null!=arguments[n]?arguments[n]:{};n%2?r(t,!0).forEach((function(n){i(e,n,t[n])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(t)):r(t).forEach((function(n){Object.defineProperty(e,n,Object.getOwnPropertyDescriptor(t,n))}))}return e}function i(e,n,t){return n in e?Object.defineProperty(e,n,{value:t,enumerable:!0,configurable:!0,writable:!0}):e[n]=t,e}t.r(n);var c={$vue:null,id:null,router:null,fields:{},customIdFields:{},ignoreRoutes:[],linkers:[],commands:{},disabled:!1,customResourceURL:null,set:[],require:[],ecommerce:{enabled:!1,options:null,enhanced:!1},autoTracking:{screenview:!1,shouldRouterUpdate:null,skipSamePath:!1,exception:!1,exceptionLogs:!0,page:!0,transformQueryString:!0,pageviewOnLoad:!0,pageviewTemplate:null,untracked:!0,prependBase:!0},debug:{enabled:!1,trace:!1,sendHitTask:!0},batch:{enabled:!1,delay:500,amount:2},checkDuplicatedScript:!1,disableScriptLoader:!1,beforeFirstHit:s,ready:s,untracked:[]},a=o({},c);function u(e){!function e(n,t){return Object.keys(t).forEach((function(r){var o=n[r]&&Object.prototype.toString.call(n[r]);"[object Object]"!==o&&"[object Array]"!==o?n[r]=t[r]:e(n[r],t[r])})),n}(a,e)}function f(){return a.id?[].concat(a.id):[]}var l=a;function s(){}var p=function(e){console.warn("[vue-analytics] ".concat(e))};function d(e,n){return new Promise((function(t,r){var o=document.head||document.getElementsByTagName("head")[0],i=document.createElement("script");if(i.async=!0,i.src=e,i.charset="utf-8",n){var c=document.createElement("link");c.href=n,c.rel="preconnect",o.appendChild(c)}o.appendChild(i),i.onload=t,i.onerror=r}))}function y(e){return e.name||e.replace(/-/gi,"")}function b(e,n){if(f().length>1){var t=y(n);return"".concat(t,".").concat(e)}return e}var m,v=function(e){if(e.then)return e;if("function"==typeof e){var n=e();return n.then?n:Promise.resolve(n)}return Promise.resolve(e)};function g(e){return function(e){if(Array.isArray(e)){for(var n=0,t=new Array(e.length);n<e.length;n++)t[n]=e[n];return t}}(e)||function(e){if(Symbol.iterator in Object(e)||"[object Arguments]"===Object.prototype.toString.call(e))return Array.from(e)}(e)||function(){throw new TypeError("Invalid attempt to spread non-iterable instance")}()}var h=[];function w(e){for(var n=arguments.length,t=new Array(n>1?n-1:0),r=1;r<n;r++)t[r-1]=arguments[r];"undefined"!=typeof window&&f().forEach((function(n){var r,o={m:b(e,n),a:t};window.ga?l.batch.enabled?(h.push(o),m||(m=setInterval((function(){h.length?h.splice(0,l.batch.amount).forEach((function(e){var n;(n=window).ga.apply(n,[e.m].concat(g(e.a)))})):(clearInterval(m),m=null)}),l.batch.delay))):(r=window).ga.apply(r,[b(e,n)].concat(t)):l.untracked.push(o)}))}function O(e){return(O="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function j(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];"object"!==O(n[0])||n[0].constructor!==Object?w("set",n[0],n[1]):w("set",n[0])}function P(e,n){var t=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);n&&(r=r.filter((function(n){return Object.getOwnPropertyDescriptor(e,n).enumerable}))),t.push.apply(t,r)}return t}function S(e,n,t){return n in e?Object.defineProperty(e,n,{value:t,enumerable:!0,configurable:!0,writable:!0}):e[n]=t,e}function k(){if(window.ga||!l.debug.enabled){if(window.ga){var e=f();l.debug.enabled&&(window.ga_debug={trace:l.debug.trace}),e.forEach((function(n){var t=y(n),r=l.customIdFields[n]||{},o=e.length>1?function(e){for(var n=1;n<arguments.length;n++){var t=null!=arguments[n]?arguments[n]:{};n%2?P(t,!0).forEach((function(n){S(e,n,t[n])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(t)):P(t).forEach((function(n){Object.defineProperty(e,n,Object.getOwnPropertyDescriptor(t,n))}))}return e}({},l.fields,{},r,{name:t}):l.fields;window.ga("create",n.id||n,"auto",o)})),l.beforeFirstHit();var n=l.ecommerce;if(n.enabled){var t=n.enhanced?"ec":"ecommerce";n.options?w("require",t,n.options):w("require",t)}l.linkers.length>0&&(w("require","linker"),w("linker:autoLink",l.linkers)),l.debug.sendHitTask||j("sendHitTask",null)}}else p("Google Analytics has probably been blocked.")}var E=function(){2!=arguments.length?w("require",arguments.length<=0?void 0:arguments[0]):w("require",arguments.length<=0?void 0:arguments[0],arguments.length<=1?void 0:arguments[1])};function A(e){return(A="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}var x=function(){var e;l.set.forEach((function(e){var n=e.field,t=e.value;if(void 0===n||void 0===t)throw new Error('[vue-analytics] Wrong configuration in the plugin options.\nThe "set" array requires each item to have a "field" and a "value" property.');j(n,t)})),e=["ec","ecommerce"],l.require.forEach((function(n){if(-1!==e.indexOf(n)||-1!==e.indexOf(n.name))throw new Error("[vue-analytics] The ecommerce features are built-in in the plugin. \nFollow the ecommerce instructions available in the documentation.");if("string"!=typeof n&&"object"!==A(n))throw new Error('[vue-analytics] Wrong configuration in the plugin options. \nThe "require" array requires each item to be a string or to have a "name" and an "options" property.');var t=n.name||n;n.options?E(t,n.options):E(t)}))};function T(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];var r=n[0];if(1===n.length&&"string"==typeof r)return w("send","screenview",{screenName:r});w.apply(void 0,["send","screenview"].concat(n))}function D(e){return(D="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function q(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];var r;n.length&&!n[0]||(n.length&&n[0].currentRoute&&(r=n[0].currentRoute),n.length&&function(e){return e.query&&e.params}(n[0])&&(r=n[0]),r?R(r):(j("page","object"===D(n[0])?n[0].page:n[0]),w.apply(void 0,["send","pageview"].concat(n))))}function R(e){if(![(n=e).name,n.path].filter(Boolean).find((function(e){return-1!==l.ignoreRoutes.indexOf(e)}))){var n,t=l.autoTracking,r=e.meta.analytics,o=(void 0===r?{}:r).pageviewTemplate||t.pageviewTemplate;if(t.screenview&&!e.name)throw new Error("[vue-analytics] Route name is mandatory when using screenview.");if(t.screenview)T(e.name);else if(o)q(o(e));else{var i=l.router,c=l.autoTracking,a=c.transformQueryString,u=c.prependBase,f=function(e){var n=Object.keys(e).reduce((function(n,t,r,o){var i=r===o.length-1,c=e[t];return null==c?n:n+="".concat(t,"=").concat(c).concat(i?"":"&")}),"");return""!==n?"?".concat(n):""}(e.query),s=i&&i.options.base,p=u&&s,d=e.path+(a?f:"");q(d=p?function(e,n){var t=n.split("/"),r=e.split("/");return""===t[0]&&"/"===e[e.length-1]&&t.shift(),r.join("/")+t.join("/")}(s,d):d)}}}function I(e){return function(e){if(Array.isArray(e)){for(var n=0,t=new Array(e.length);n<e.length;n++)t[n]=e[n];return t}}(e)||function(e){if(Symbol.iterator in Object(e)||"[object Arguments]"===Object.prototype.toString.call(e))return Array.from(e)}(e)||function(){throw new TypeError("Invalid attempt to spread non-iterable instance")}()}var L=function(){var e=!(arguments.length>0&&void 0!==arguments[0])||arguments[0];"undefined"!=typeof window&&f().forEach((function(n){window["ga-disable-".concat(n)]=e}))},_=function(){if("undefined"!=typeof document&&"undefined"!=typeof window){if(l.id){var e,n,t=[v(l.id),v(l.disabled)];if(e=l.checkDuplicatedScript,n=l.disableScriptLoader,[Boolean(window&&window.ga),e&&!(Array.prototype.slice.call(document.getElementsByTagName("script")).filter((function(e){return-1!==e.src.indexOf("analytics")||-1!==e.src.indexOf("gtag")})).length>0),!n].some(Boolean)){var r="https://www.google-analytics.com",o=l.debug.enabled?"analytics_debug":"analytics",i=l.customResourceURL?d(l.customResourceURL):d("".concat(r,"/").concat(o,".js"),r);t.push(i.catch((function(){p("An error occured! Please check your connection or disable your AD blocker")})))}return Promise.all(t).then((function(e){var n,t,r;u({id:e[0],disabled:e[1]}),L(l.disabled),k(),x(),l.untracked.forEach((function(e){w.apply(void 0,[e.m].concat(I(e.a)))})),n=l.router,t=l.autoTracking,r=l.$vue,t.page&&n&&n.onReady((function(){t.pageviewOnLoad&&n.history.ready&&R(n.currentRoute),n.afterEach((function(e,o){var i=t.skipSamePath,c=t.shouldRouterUpdate;i&&e.path===o.path||("function"!=typeof c||c(e,o))&&r.nextTick().then((function(){R(n.currentRoute)}))}))})),l.ready()})).catch((function(e){l.debug.enabled&&p(e.message)}))}p('Missing the "id" parameter. Add at least one tracking domain ID')}};var B=function(e){var n=arguments.length>1&&void 0!==arguments[1]&&arguments[1];w("send","exception",{exDescription:e,exFatal:n})},H=function(e){if(l.autoTracking.exception){window.addEventListener("error",(function(e){B(e.message)}));var n=e.config.errorHandler;e.config.errorHandler=function(e,t,r){B(e.message),l.autoTracking.exceptionLogs&&console.error(e),"function"==typeof n&&n.call(void 0,e,t,r)}}},F=B;function M(e,n){var t=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);n&&(r=r.filter((function(n){return Object.getOwnPropertyDescriptor(e,n).enumerable}))),t.push.apply(t,r)}return t}function U(e,n,t){return n in e?Object.defineProperty(e,n,{value:t,enumerable:!0,configurable:!0,writable:!0}):e[n]=t,e}var $=function(e){return"".concat(l.ecommerce.enhanced?"ec":"ecommerce",":").concat(e)},C=["addItem","addTransaction","addProduct","addImpression","setAction","addPromo","send"].reduce((function(e,n){return function(e){for(var n=1;n<arguments.length;n++){var t=null!=arguments[n]?arguments[n]:{};n%2?M(t,!0).forEach((function(n){U(e,n,t[n])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(t)):M(t).forEach((function(n){Object.defineProperty(e,n,Object.getOwnPropertyDescriptor(t,n))}))}return e}({},e,U({},n,(function(){for(var e=arguments.length,t=new Array(e),r=0;r<e;r++)t[r]=arguments[r];w.apply(void 0,[$(n)].concat(t))})))}),{}),N={event:function(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];w.apply(void 0,["send","event"].concat(n))},exception:F,page:q,query:w,require:E,set:j,social:function(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];w.apply(void 0,["send","social"].concat(n))},time:function(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];w.apply(void 0,["send","timing"].concat(n))},screenview:T,ecommerce:C,disable:function(){return L(!0)},enable:function(){return L(!1)},commands:l.commands},Q={inserted:function(e,n,t){var r=Object.keys(n.modifiers);0===r.length&&r.push("click"),r.forEach((function(r){e.addEventListener(r,(function(){var e="string"==typeof n.value?l.commands[n.value]:n.value;if(!e)throw new Error("[vue-analytics] The value passed to v-ga is not defined in the commands list.");e.apply(t.context)}))}))}};function W(e){return function(e){if(Array.isArray(e)){for(var n=0,t=new Array(e.length);n<e.length;n++)t[n]=e[n];return t}}(e)||function(e){if(Symbol.iterator in Object(e)||"[object Arguments]"===Object.prototype.toString.call(e))return Array.from(e)}(e)||function(){throw new TypeError("Invalid attempt to spread non-iterable instance")}()}function G(e,n){return function(e){if(Array.isArray(e))return e}(e)||function(e,n){if(!(Symbol.iterator in Object(e)||"[object Arguments]"===Object.prototype.toString.call(e)))return;var t=[],r=!0,o=!1,i=void 0;try{for(var c,a=e[Symbol.iterator]();!(r=(c=a.next()).done)&&(t.push(c.value),!n||t.length!==n);r=!0);}catch(e){o=!0,i=e}finally{try{r||null==a.return||a.return()}finally{if(o)throw i}}return t}(e,n)||function(){throw new TypeError("Invalid attempt to destructure non-iterable instance")}()}function z(e,n){var t=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);n&&(r=r.filter((function(n){return Object.getOwnPropertyDescriptor(e,n).enumerable}))),t.push.apply(t,r)}return t}function J(e,n,t){return n in e?Object.defineProperty(e,n,{value:t,enumerable:!0,configurable:!0,writable:!0}):e[n]=t,e}function K(e){u(function(e){for(var n=1;n<arguments.length;n++){var t=null!=arguments[n]?arguments[n]:{};n%2?z(t,!0).forEach((function(n){J(e,n,t[n])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(t)):z(t).forEach((function(n){Object.defineProperty(e,n,Object.getOwnPropertyDescriptor(t,n))}))}return e}({},arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},{$vue:e})),e.directive("ga",Q),e.prototype.$ga=e.$ga=N,H(e),_()}t.d(n,"default",(function(){return K})),t.d(n,"analyticsMiddleware",(function(){return V})),t.d(n,"onAnalyticsReady",(function(){return X})),t.d(n,"event",(function(){return Y})),t.d(n,"ecommerce",(function(){return Z})),t.d(n,"set",(function(){return ee})),t.d(n,"page",(function(){return ne})),t.d(n,"query",(function(){return te})),t.d(n,"screenview",(function(){return re})),t.d(n,"time",(function(){return oe})),t.d(n,"require",(function(){return ie})),t.d(n,"exception",(function(){return ce})),t.d(n,"social",(function(){return ae}));var V=function(e){e.subscribe((function(e){var n=e.payload;if(n&&n.meta&&n.meta.analytics){var t=n.meta.analytics;if(!Array.isArray(t))throw new Error('The "analytics" property needs to be an array');t.forEach((function(e){var n,t,r=e.shift(),o=e;if(r.includes(":")){var i=G(r.split(":"),2);r=i[0],n=i[1]}if(!(r in N))throw new Error('[vue-analytics:vuex] The type "'.concat(r,"\" doesn't exist."));if(n&&!(n in N[r]))throw new Error('[vue-analytics:vuex] The type "'.concat(r,'" has not method "').concat(n,'".'));if("ecommerce"===r&&!n)throw new Error('[vue-analytics:vuex] The type "'.concat(r,'" needs to call a method. Check documentation.'));n?(t=N[r])[n].apply(t,W(o)):N[r].apply(N,W(o))}))}}))},X=function(){return new Promise((function(e,n){var t=setInterval((function(){"undefined"!=typeof window&&window.ga&&(e(),clearInterval(t))}),10)}))},Y=N.event,Z=N.ecommerce,ee=N.set,ne=N.page,te=N.query,re=N.screenview,oe=N.time,ie=N.require,ce=N.exception,ae=N.social}])}));

/***/ })
],[16]);


// WEBPACK FOOTER //
// js/app.fc4f2107086bad1719f0.js